import { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Hex: { input: any; output: any; }
  Json: { input: any; output: any; }
  Long: { input: any; output: any; }
  RGBAHue: { input: any; output: any; }
  RGBATransparency: { input: any; output: any; }
  RichTextAST: { input: any; output: any; }
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  altText?: Maybe<Scalars['String']['output']>;
  attribution?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** For video assets, enables the web player controls to allow users to fullscreen, unmute, etc.. */
  enableVideoControls?: Maybe<Scalars['Boolean']['output']>;
  /** This image will be used as a fallback if the main resource in this asset is a video */
  fallbackImage?: Maybe<Asset>;
  fallbackImageAsset: Array<Asset>;
  /** The file name */
  fileName: Scalars['String']['output'];
  /** The file handle */
  handle: Scalars['String']['output'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  /** List of Asset versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** For the Override Embed URL, disables the overlay with the Play button and just shows the iframe immediately */
  overrideEmbedDisableOverlay?: Maybe<Scalars['Boolean']['output']>;
  /** If specified will attempt to use an embed instead of the asset.  This URL would be the page to embed in an iframe. Certain URLs, such as those containing bilibili or twitch.tv, will open in a new tab rather than be embedded on the page. */
  overrideEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetFallbackImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Asset system model */
export type AssetFallbackImageAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  assetCosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateManyInlineInput>;
  assetCosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateManyInlineInput>;
  assetCosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardCreateManyInlineInput>;
  assetCosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardCreateManyInlineInput>;
  assetCosmosElementDolphinusCard?: InputMaybe<CosmosElementDelphinusCardCreateManyInlineInput>;
  assetCosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateManyInlineInput>;
  assetCosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateManyInlineInput>;
  assetCosmosElementNewsMediaCard?: InputMaybe<CosmosElementNewsMediaCardCreateManyInlineInput>;
  assetCosmosElementSpeakerCard?: InputMaybe<CosmosElementSpeakerCardCreateManyInlineInput>;
  assetCosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemCreateManyInlineInput>;
  assetCosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateManyInlineInput>;
  assetCosmosSectionAsset?: InputMaybe<CosmosSectionAssetCreateManyInlineInput>;
  assetCosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateManyInlineInput>;
  assetCosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateManyInlineInput>;
  assetsCosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateManyInlineInput>;
  assetsCosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateManyInlineInput>;
  assetsCosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateManyInlineInput>;
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  backgroundAssetCosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateManyInlineInput>;
  backgroundAssetCosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateManyInlineInput>;
  backgroundAssetCosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateManyInlineInput>;
  backgroundImageCosmosConfigSection?: InputMaybe<CosmosConfigSectionCreateManyInlineInput>;
  blurredBackgroundImageCosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchCreateManyInlineInput>;
  blurredImageCosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemCreateManyInlineInput>;
  blurredImageCosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateManyInlineInput>;
  blurredImageCosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateManyInlineInput>;
  blurredImageCosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableCreateManyInlineInput>;
  blurredImageCosmosSectionHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateManyInlineInput>;
  cardImageCosmosElementUTCard?: InputMaybe<CosmosElementUtCardCreateManyInlineInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  cmfnz3bar0f4h07oj9wqx65iw?: InputMaybe<CosmosElementResearchCardCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  developersTsvCosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListCreateManyInlineInput>;
  enableVideoControls?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackImage?: InputMaybe<AssetCreateOneInlineInput>;
  fallbackImageAsset?: InputMaybe<AssetCreateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  heroAssetCosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateManyInlineInput>;
  heroAssetCosmosHeroBravo?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateManyInlineInput>;
  imageAssetCosmosElementAvatar?: InputMaybe<CosmosElementAvatarCreateManyInlineInput>;
  imageCosmosElementFeatureCard?: InputMaybe<CosmosElementFeatureCardCreateManyInlineInput>;
  imageCosmosElementImageTag?: InputMaybe<CosmosElementImageTagCreateManyInlineInput>;
  imageCosmosElementLogo?: InputMaybe<CosmosElementLogoCreateManyInlineInput>;
  imageCosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardCreateManyInlineInput>;
  imgCosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardCreateManyInlineInput>;
  leftImageCosmosElementCompare?: InputMaybe<CosmosElementCompareCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  logoImageCosmosElementUTCard?: InputMaybe<CosmosElementUtCardCreateManyInlineInput>;
  logoImageCosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateManyInlineInput>;
  logoImageCosmosSectionHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateManyInlineInput>;
  logoImageCosmosSectionUniversalCard?: InputMaybe<CosmosSectionGeminiCardCreateManyInlineInput>;
  mediaCosmosElementAsset?: InputMaybe<CosmosElementAssetCreateManyInlineInput>;
  openGraphImageSeo?: InputMaybe<CosmosSeoCreateManyInlineInput>;
  overlayImageCosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedCreateManyInlineInput>;
  overrideEmbedDisableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  overrideEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  rightImageCosmosElementCompare?: InputMaybe<CosmosElementCompareCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  enableVideoControls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableVideoControls_not?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackImage?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_every?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_none?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_some?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  overrideEmbedDisableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  overrideEmbedDisableOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  overrideEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  overrideEmbedUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  overrideEmbedUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  overrideEmbedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  overrideEmbedUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  overrideEmbedUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  overrideEmbedUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  overrideEmbedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  overrideEmbedUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  overrideEmbedUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EnableVideoControlsAsc = 'enableVideoControls_ASC',
  EnableVideoControlsDesc = 'enableVideoControls_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  OverrideEmbedDisableOverlayAsc = 'overrideEmbedDisableOverlay_ASC',
  OverrideEmbedDisableOverlayDesc = 'overrideEmbedDisableOverlay_DESC',
  OverrideEmbedUrlAsc = 'overrideEmbedUrl_ASC',
  OverrideEmbedUrlDesc = 'overrideEmbedUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  assetCosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateManyInlineInput>;
  assetCosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateManyInlineInput>;
  assetCosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpdateManyInlineInput>;
  assetCosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpdateManyInlineInput>;
  assetCosmosElementDolphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateManyInlineInput>;
  assetCosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyInlineInput>;
  assetCosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateManyInlineInput>;
  assetCosmosElementNewsMediaCard?: InputMaybe<CosmosElementNewsMediaCardUpdateManyInlineInput>;
  assetCosmosElementSpeakerCard?: InputMaybe<CosmosElementSpeakerCardUpdateManyInlineInput>;
  assetCosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpdateManyInlineInput>;
  assetCosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyInlineInput>;
  assetCosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateManyInlineInput>;
  assetCosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyInlineInput>;
  assetCosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateManyInlineInput>;
  assetsCosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateManyInlineInput>;
  assetsCosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateManyInlineInput>;
  assetsCosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateManyInlineInput>;
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  backgroundAssetCosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateManyInlineInput>;
  backgroundAssetCosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyInlineInput>;
  backgroundAssetCosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyInlineInput>;
  backgroundImageCosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateManyInlineInput>;
  blurredBackgroundImageCosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateManyInlineInput>;
  blurredImageCosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpdateManyInlineInput>;
  blurredImageCosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyInlineInput>;
  blurredImageCosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyInlineInput>;
  blurredImageCosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateManyInlineInput>;
  blurredImageCosmosSectionHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyInlineInput>;
  cardImageCosmosElementUTCard?: InputMaybe<CosmosElementUtCardUpdateManyInlineInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  cmfnz3bar0f4h07oj9wqx65iw?: InputMaybe<CosmosElementResearchCardUpdateManyInlineInput>;
  developersTsvCosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateManyInlineInput>;
  enableVideoControls?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackImage?: InputMaybe<AssetUpdateOneInlineInput>;
  fallbackImageAsset?: InputMaybe<AssetUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  heroAssetCosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyInlineInput>;
  heroAssetCosmosHeroBravo?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateManyInlineInput>;
  imageAssetCosmosElementAvatar?: InputMaybe<CosmosElementAvatarUpdateManyInlineInput>;
  imageCosmosElementFeatureCard?: InputMaybe<CosmosElementFeatureCardUpdateManyInlineInput>;
  imageCosmosElementImageTag?: InputMaybe<CosmosElementImageTagUpdateManyInlineInput>;
  imageCosmosElementLogo?: InputMaybe<CosmosElementLogoUpdateManyInlineInput>;
  imageCosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateManyInlineInput>;
  imgCosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateManyInlineInput>;
  leftImageCosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  logoImageCosmosElementUTCard?: InputMaybe<CosmosElementUtCardUpdateManyInlineInput>;
  logoImageCosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateManyInlineInput>;
  logoImageCosmosSectionHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyInlineInput>;
  logoImageCosmosSectionUniversalCard?: InputMaybe<CosmosSectionGeminiCardUpdateManyInlineInput>;
  mediaCosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateManyInlineInput>;
  openGraphImageSeo?: InputMaybe<CosmosSeoUpdateManyInlineInput>;
  overlayImageCosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateManyInlineInput>;
  overrideEmbedDisableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  overrideEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  rightImageCosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateManyInlineInput>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  enableVideoControls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>;
  overrideEmbedDisableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  overrideEmbedUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  altText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  altText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  altText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  altText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  altText_starts_with?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  attribution_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  attribution_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  attribution_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  attribution_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  attribution_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  attribution_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  attribution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  attribution_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  attribution_starts_with?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  enableVideoControls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableVideoControls_not?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackImage?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_every?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_none?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_some?: InputMaybe<AssetWhereInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  overrideEmbedDisableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  overrideEmbedDisableOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  overrideEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  overrideEmbedUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  overrideEmbedUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  overrideEmbedUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  overrideEmbedUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  overrideEmbedUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  overrideEmbedUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  overrideEmbedUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  overrideEmbedUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  overrideEmbedUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

export type CommunityCard = Entity & {
  __typename?: 'CommunityCard';
  /** Card description */
  description?: Maybe<Scalars['String']['output']>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  iconType?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Card link */
  link?: Maybe<CosmosElementLink>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CommunityCard>;
  /** System stage field */
  stage: Stage;
  /** Card title */
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CommunityCardLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommunityCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CommunityCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CommunityCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommunityCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommunityCardConnection = {
  __typename?: 'CommunityCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommunityCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommunityCardCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  iconType?: InputMaybe<EdsIconsEnum>;
  link?: InputMaybe<CosmosElementLinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CommunityCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommunityCardCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommunityCardCreateLocalizationInput = {
  /** Localization input */
  data: CommunityCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CommunityCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CommunityCardCreateLocalizationInput>>;
};

export type CommunityCardCreateManyInlineInput = {
  /** Create and connect multiple existing CommunityCard documents */
  create?: InputMaybe<Array<CommunityCardCreateInput>>;
};

export type CommunityCardCreateOneInlineInput = {
  /** Create and connect one CommunityCard document */
  create?: InputMaybe<CommunityCardCreateInput>;
};

export type CommunityCardCreateWithPositionInput = {
  /** Document to create */
  data: CommunityCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CommunityCardEdge = {
  __typename?: 'CommunityCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommunityCard;
};

/** Identifies documents */
export type CommunityCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommunityCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommunityCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommunityCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  iconType?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  iconType_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconType_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  iconType_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<CosmosElementLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CommunityCardOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconTypeAsc = 'iconType_ASC',
  IconTypeDesc = 'iconType_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CommunityCardParent = CommunityResource;

export type CommunityCardParentConnectInput = {
  CommunityResource?: InputMaybe<CommunityResourceConnectInput>;
};

export type CommunityCardParentCreateInput = {
  CommunityResource?: InputMaybe<CommunityResourceCreateInput>;
};

export type CommunityCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CommunityCardParent documents */
  create?: InputMaybe<Array<CommunityCardParentCreateInput>>;
};

export type CommunityCardParentCreateOneInlineInput = {
  /** Create and connect one CommunityCardParent document */
  create?: InputMaybe<CommunityCardParentCreateInput>;
};

export type CommunityCardParentCreateWithPositionInput = {
  CommunityResource?: InputMaybe<CommunityResourceCreateWithPositionInput>;
};

export type CommunityCardParentUpdateInput = {
  CommunityResource?: InputMaybe<CommunityResourceUpdateInput>;
};

export type CommunityCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CommunityCardParent component instances */
  create?: InputMaybe<Array<CommunityCardParentCreateWithPositionInput>>;
  /** Delete multiple CommunityCardParent documents */
  delete?: InputMaybe<Array<CommunityCardParentWhereUniqueInput>>;
  /** Update multiple CommunityCardParent component instances */
  update?: InputMaybe<Array<CommunityCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CommunityCardParent component instances */
  upsert?: InputMaybe<Array<CommunityCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CommunityCardParentUpdateManyWithNestedWhereInput = {
  CommunityResource?: InputMaybe<CommunityResourceUpdateManyWithNestedWhereInput>;
};

export type CommunityCardParentUpdateOneInlineInput = {
  /** Create and connect one CommunityCardParent document */
  create?: InputMaybe<CommunityCardParentCreateInput>;
  /** Delete currently connected CommunityCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommunityCardParent document */
  update?: InputMaybe<CommunityCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommunityCardParent document */
  upsert?: InputMaybe<CommunityCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CommunityCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CommunityResource?: InputMaybe<CommunityResourceUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CommunityCardParentUpdateWithNestedWhereUniqueInput = {
  CommunityResource?: InputMaybe<CommunityResourceUpdateWithNestedWhereUniqueInput>;
};

export type CommunityCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CommunityResource?: InputMaybe<CommunityResourceUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CommunityCardParentUpsertWithNestedWhereUniqueInput = {
  CommunityResource?: InputMaybe<CommunityResourceUpsertWithNestedWhereUniqueInput>;
};

export type CommunityCardParentWhereInput = {
  CommunityResource?: InputMaybe<CommunityResourceWhereInput>;
};

export type CommunityCardParentWhereUniqueInput = {
  CommunityResource?: InputMaybe<CommunityResourceWhereUniqueInput>;
};

export type CommunityCardUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  iconType?: InputMaybe<EdsIconsEnum>;
  link?: InputMaybe<CosmosElementLinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CommunityCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityCardUpdateLocalizationInput = {
  data: CommunityCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CommunityCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CommunityCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CommunityCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CommunityCardUpsertLocalizationInput>>;
};

export type CommunityCardUpdateManyInlineInput = {
  /** Create and connect multiple CommunityCard component instances */
  create?: InputMaybe<Array<CommunityCardCreateWithPositionInput>>;
  /** Delete multiple CommunityCard documents */
  delete?: InputMaybe<Array<CommunityCardWhereUniqueInput>>;
  /** Update multiple CommunityCard component instances */
  update?: InputMaybe<Array<CommunityCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CommunityCard component instances */
  upsert?: InputMaybe<Array<CommunityCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CommunityCardUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  iconType?: InputMaybe<EdsIconsEnum>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CommunityCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityCardUpdateManyLocalizationInput = {
  data: CommunityCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CommunityCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CommunityCardUpdateManyLocalizationInput>>;
};

export type CommunityCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommunityCardUpdateManyInput;
  /** Document search */
  where: CommunityCardWhereInput;
};

export type CommunityCardUpdateOneInlineInput = {
  /** Create and connect one CommunityCard document */
  create?: InputMaybe<CommunityCardCreateInput>;
  /** Delete currently connected CommunityCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommunityCard document */
  update?: InputMaybe<CommunityCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommunityCard document */
  upsert?: InputMaybe<CommunityCardUpsertWithNestedWhereUniqueInput>;
};

export type CommunityCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CommunityCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CommunityCardWhereUniqueInput;
};

export type CommunityCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommunityCardUpdateInput;
  /** Unique document search */
  where: CommunityCardWhereUniqueInput;
};

export type CommunityCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CommunityCardCreateInput;
  /** Update document if it exists */
  update: CommunityCardUpdateInput;
};

export type CommunityCardUpsertLocalizationInput = {
  create: CommunityCardCreateLocalizationDataInput;
  locale: Locale;
  update: CommunityCardUpdateLocalizationDataInput;
};

export type CommunityCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CommunityCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CommunityCardWhereUniqueInput;
};

export type CommunityCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommunityCardUpsertInput;
  /** Unique document search */
  where: CommunityCardWhereUniqueInput;
};

/** Identifies documents */
export type CommunityCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommunityCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommunityCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommunityCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  iconType?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  iconType_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconType_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  iconType_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<CosmosElementLinkWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CommunityCard record uniquely */
export type CommunityCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CommunityResource = Entity & {
  __typename?: 'CommunityResource';
  cards: Array<CommunityCard>;
  /** Hide localization */
  hideStr?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CommunityResource>;
  /** Show more localization */
  showMoreStr?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CommunityResourceCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CommunityCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunityCardWhereInput>;
};


export type CommunityResourceLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CommunityResourceUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CommunityResourceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommunityResourceWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommunityResourceConnection = {
  __typename?: 'CommunityResourceConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommunityResourceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommunityResourceCreateInput = {
  cards?: InputMaybe<CommunityCardCreateManyInlineInput>;
  /** hideStr input for default locale (en) */
  hideStr?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CommunityResourceCreateLocalizationsInput>;
  /** showMoreStr input for default locale (en) */
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommunityResourceCreateLocalizationDataInput = {
  hideStr?: InputMaybe<Scalars['String']['input']>;
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommunityResourceCreateLocalizationInput = {
  /** Localization input */
  data: CommunityResourceCreateLocalizationDataInput;
  locale: Locale;
};

export type CommunityResourceCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CommunityResourceCreateLocalizationInput>>;
};

export type CommunityResourceCreateManyInlineInput = {
  /** Create and connect multiple existing CommunityResource documents */
  create?: InputMaybe<Array<CommunityResourceCreateInput>>;
};

export type CommunityResourceCreateOneInlineInput = {
  /** Create and connect one CommunityResource document */
  create?: InputMaybe<CommunityResourceCreateInput>;
};

export type CommunityResourceCreateWithPositionInput = {
  /** Document to create */
  data: CommunityResourceCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CommunityResourceEdge = {
  __typename?: 'CommunityResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommunityResource;
};

/** Identifies documents */
export type CommunityResourceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommunityResourceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommunityResourceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommunityResourceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CommunityCardWhereInput>;
  cards_none?: InputMaybe<CommunityCardWhereInput>;
  cards_some?: InputMaybe<CommunityCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CommunityResourceOrderByInput {
  HideStrAsc = 'hideStr_ASC',
  HideStrDesc = 'hideStr_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ShowMoreStrAsc = 'showMoreStr_ASC',
  ShowMoreStrDesc = 'showMoreStr_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CommunityResourceParent = CosmosSectionCommunity;

export type CommunityResourceParentConnectInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityConnectInput>;
};

export type CommunityResourceParentCreateInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateInput>;
};

export type CommunityResourceParentCreateManyInlineInput = {
  /** Create and connect multiple existing CommunityResourceParent documents */
  create?: InputMaybe<Array<CommunityResourceParentCreateInput>>;
};

export type CommunityResourceParentCreateOneInlineInput = {
  /** Create and connect one CommunityResourceParent document */
  create?: InputMaybe<CommunityResourceParentCreateInput>;
};

export type CommunityResourceParentCreateWithPositionInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateWithPositionInput>;
};

export type CommunityResourceParentUpdateInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateInput>;
};

export type CommunityResourceParentUpdateManyInlineInput = {
  /** Create and connect multiple CommunityResourceParent component instances */
  create?: InputMaybe<Array<CommunityResourceParentCreateWithPositionInput>>;
  /** Delete multiple CommunityResourceParent documents */
  delete?: InputMaybe<Array<CommunityResourceParentWhereUniqueInput>>;
  /** Update multiple CommunityResourceParent component instances */
  update?: InputMaybe<Array<CommunityResourceParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CommunityResourceParent component instances */
  upsert?: InputMaybe<Array<CommunityResourceParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CommunityResourceParentUpdateManyWithNestedWhereInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateManyWithNestedWhereInput>;
};

export type CommunityResourceParentUpdateOneInlineInput = {
  /** Create and connect one CommunityResourceParent document */
  create?: InputMaybe<CommunityResourceParentCreateInput>;
  /** Delete currently connected CommunityResourceParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommunityResourceParent document */
  update?: InputMaybe<CommunityResourceParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommunityResourceParent document */
  upsert?: InputMaybe<CommunityResourceParentUpsertWithNestedWhereUniqueInput>;
};

export type CommunityResourceParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CommunityResourceParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueInput>;
};

export type CommunityResourceParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CommunityResourceParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueInput>;
};

export type CommunityResourceParentWhereInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereInput>;
};

export type CommunityResourceParentWhereUniqueInput = {
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereUniqueInput>;
};

export type CommunityResourceUpdateInput = {
  cards?: InputMaybe<CommunityCardUpdateManyInlineInput>;
  /** hideStr input for default locale (en) */
  hideStr?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CommunityResourceUpdateLocalizationsInput>;
  /** showMoreStr input for default locale (en) */
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityResourceUpdateLocalizationDataInput = {
  hideStr?: InputMaybe<Scalars['String']['input']>;
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityResourceUpdateLocalizationInput = {
  data: CommunityResourceUpdateLocalizationDataInput;
  locale: Locale;
};

export type CommunityResourceUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CommunityResourceCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CommunityResourceUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CommunityResourceUpsertLocalizationInput>>;
};

export type CommunityResourceUpdateManyInlineInput = {
  /** Create and connect multiple CommunityResource component instances */
  create?: InputMaybe<Array<CommunityResourceCreateWithPositionInput>>;
  /** Delete multiple CommunityResource documents */
  delete?: InputMaybe<Array<CommunityResourceWhereUniqueInput>>;
  /** Update multiple CommunityResource component instances */
  update?: InputMaybe<Array<CommunityResourceUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CommunityResource component instances */
  upsert?: InputMaybe<Array<CommunityResourceUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CommunityResourceUpdateManyInput = {
  /** hideStr input for default locale (en) */
  hideStr?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CommunityResourceUpdateManyLocalizationsInput>;
  /** showMoreStr input for default locale (en) */
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityResourceUpdateManyLocalizationDataInput = {
  hideStr?: InputMaybe<Scalars['String']['input']>;
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityResourceUpdateManyLocalizationInput = {
  data: CommunityResourceUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CommunityResourceUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CommunityResourceUpdateManyLocalizationInput>>;
};

export type CommunityResourceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommunityResourceUpdateManyInput;
  /** Document search */
  where: CommunityResourceWhereInput;
};

export type CommunityResourceUpdateOneInlineInput = {
  /** Create and connect one CommunityResource document */
  create?: InputMaybe<CommunityResourceCreateInput>;
  /** Delete currently connected CommunityResource document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommunityResource document */
  update?: InputMaybe<CommunityResourceUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommunityResource document */
  upsert?: InputMaybe<CommunityResourceUpsertWithNestedWhereUniqueInput>;
};

export type CommunityResourceUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CommunityResourceUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CommunityResourceWhereUniqueInput;
};

export type CommunityResourceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommunityResourceUpdateInput;
  /** Unique document search */
  where: CommunityResourceWhereUniqueInput;
};

export type CommunityResourceUpsertInput = {
  /** Create document if it didn't exist */
  create: CommunityResourceCreateInput;
  /** Update document if it exists */
  update: CommunityResourceUpdateInput;
};

export type CommunityResourceUpsertLocalizationInput = {
  create: CommunityResourceCreateLocalizationDataInput;
  locale: Locale;
  update: CommunityResourceUpdateLocalizationDataInput;
};

export type CommunityResourceUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CommunityResourceUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CommunityResourceWhereUniqueInput;
};

export type CommunityResourceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommunityResourceUpsertInput;
  /** Unique document search */
  where: CommunityResourceWhereUniqueInput;
};

/** Identifies documents */
export type CommunityResourceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommunityResourceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommunityResourceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommunityResourceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CommunityCardWhereInput>;
  cards_none?: InputMaybe<CommunityCardWhereInput>;
  cards_some?: InputMaybe<CommunityCardWhereInput>;
  hideStr?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  hideStr_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  hideStr_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  hideStr_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  hideStr_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  hideStr_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  hideStr_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  hideStr_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  hideStr_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  hideStr_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  showMoreStr?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  showMoreStr_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  showMoreStr_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  showMoreStr_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  showMoreStr_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  showMoreStr_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  showMoreStr_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  showMoreStr_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  showMoreStr_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  showMoreStr_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CommunityResource record uniquely */
export type CommunityResourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosConfigBlog = Entity & {
  __typename?: 'CosmosConfigBlog';
  authorTag?: Maybe<CosmosElementImageTag>;
  /** The card to display a link to this blog in the blog feed */
  blogLandingCard?: Maybe<CosmosElementBlogCard>;
  categories: Array<WfRefBlogCategory>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosConfigBlog>;
  publicationDate?: Maybe<Scalars['Date']['output']>;
  /** System stage field */
  stage: Stage;
  /** Pins this blog at the top of the blog feed */
  sticky?: Maybe<Scalars['Boolean']['output']>;
  /** The list of tags which describe this Blog Detail page */
  tags: Array<WfRefBlogTag>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosConfigBlogAuthorTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosConfigBlogBlogLandingCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosConfigBlogCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<WfRefBlogCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogCategoryWhereInput>;
};


export type CosmosConfigBlogLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosConfigBlogTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<WfRefBlogTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogTagWhereInput>;
};


export type CosmosConfigBlogUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosConfigBlogConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosConfigBlogWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosConfigBlogConnection = {
  __typename?: 'CosmosConfigBlogConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosConfigBlogEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosConfigBlogCreateInput = {
  authorTag?: InputMaybe<CosmosElementImageTagCreateOneInlineInput>;
  blogLandingCard?: InputMaybe<CosmosElementBlogCardCreateOneInlineInput>;
  categories?: InputMaybe<WfRefBlogCategoryCreateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosConfigBlogCreateLocalizationsInput>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<WfRefBlogTagCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosConfigBlogCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosConfigBlogCreateLocalizationInput = {
  /** Localization input */
  data: CosmosConfigBlogCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosConfigBlogCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosConfigBlogCreateLocalizationInput>>;
};

export type CosmosConfigBlogCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosConfigBlog documents */
  create?: InputMaybe<Array<CosmosConfigBlogCreateInput>>;
};

export type CosmosConfigBlogCreateOneInlineInput = {
  /** Create and connect one CosmosConfigBlog document */
  create?: InputMaybe<CosmosConfigBlogCreateInput>;
};

export type CosmosConfigBlogCreateWithPositionInput = {
  /** Document to create */
  data: CosmosConfigBlogCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosConfigBlogEdge = {
  __typename?: 'CosmosConfigBlogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosConfigBlog;
};

/** Identifies documents */
export type CosmosConfigBlogManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosConfigBlogWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosConfigBlogWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosConfigBlogWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorTag?: InputMaybe<CosmosElementImageTagWhereInput>;
  blogLandingCard?: InputMaybe<CosmosElementBlogCardWhereInput>;
  categories_every?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_none?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_some?: InputMaybe<WfRefBlogCategoryWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  publicationDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  publicationDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  publicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  publicationDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  publicationDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publicationDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  publicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sticky_not?: InputMaybe<Scalars['Boolean']['input']>;
  tags_every?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_none?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_some?: InputMaybe<WfRefBlogTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosConfigBlogOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  StickyAsc = 'sticky_ASC',
  StickyDesc = 'sticky_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosConfigBlogParent = CosmosFeedBlogCard | CosmosPageBlogDetail;

export type CosmosConfigBlogParentConnectInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
};

export type CosmosConfigBlogParentCreateInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
};

export type CosmosConfigBlogParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosConfigBlogParent documents */
  connect?: InputMaybe<Array<CosmosConfigBlogParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosConfigBlogParent documents */
  create?: InputMaybe<Array<CosmosConfigBlogParentCreateInput>>;
};

export type CosmosConfigBlogParentCreateOneInlineInput = {
  /** Connect one existing CosmosConfigBlogParent document */
  connect?: InputMaybe<CosmosConfigBlogParentWhereUniqueInput>;
  /** Create and connect one CosmosConfigBlogParent document */
  create?: InputMaybe<CosmosConfigBlogParentCreateInput>;
};

export type CosmosConfigBlogParentUpdateInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
};

export type CosmosConfigBlogParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosConfigBlogParent documents */
  connect?: InputMaybe<Array<CosmosConfigBlogParentConnectInput>>;
  /** Create and connect multiple CosmosConfigBlogParent documents */
  create?: InputMaybe<Array<CosmosConfigBlogParentCreateInput>>;
  /** Delete multiple CosmosConfigBlogParent documents */
  delete?: InputMaybe<Array<CosmosConfigBlogParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosConfigBlogParent documents */
  disconnect?: InputMaybe<Array<CosmosConfigBlogParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosConfigBlogParent documents */
  set?: InputMaybe<Array<CosmosConfigBlogParentWhereUniqueInput>>;
  /** Update multiple CosmosConfigBlogParent documents */
  update?: InputMaybe<Array<CosmosConfigBlogParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosConfigBlogParent documents */
  upsert?: InputMaybe<Array<CosmosConfigBlogParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosConfigBlogParentUpdateManyWithNestedWhereInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosConfigBlogParentUpdateOneInlineInput = {
  /** Connect existing CosmosConfigBlogParent document */
  connect?: InputMaybe<CosmosConfigBlogParentWhereUniqueInput>;
  /** Create and connect one CosmosConfigBlogParent document */
  create?: InputMaybe<CosmosConfigBlogParentCreateInput>;
  /** Delete currently connected CosmosConfigBlogParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosConfigBlogParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosConfigBlogParent document */
  update?: InputMaybe<CosmosConfigBlogParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosConfigBlogParent document */
  upsert?: InputMaybe<CosmosConfigBlogParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigBlogParentUpdateWithNestedWhereUniqueInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosConfigBlogParentUpsertWithNestedWhereUniqueInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigBlogParentWhereInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
};

export type CosmosConfigBlogParentWhereUniqueInput = {
  CosmosFeedBlogCard?: InputMaybe<CosmosFeedBlogCardWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
};

export type CosmosConfigBlogUpdateInput = {
  authorTag?: InputMaybe<CosmosElementImageTagUpdateOneInlineInput>;
  blogLandingCard?: InputMaybe<CosmosElementBlogCardUpdateOneInlineInput>;
  categories?: InputMaybe<WfRefBlogCategoryUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosConfigBlogUpdateLocalizationsInput>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<WfRefBlogTagUpdateManyInlineInput>;
};

export type CosmosConfigBlogUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosConfigBlogUpdateLocalizationInput = {
  data: CosmosConfigBlogUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosConfigBlogUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosConfigBlogCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosConfigBlogUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosConfigBlogUpsertLocalizationInput>>;
};

export type CosmosConfigBlogUpdateManyInlineInput = {
  /** Create and connect multiple CosmosConfigBlog component instances */
  create?: InputMaybe<Array<CosmosConfigBlogCreateWithPositionInput>>;
  /** Delete multiple CosmosConfigBlog documents */
  delete?: InputMaybe<Array<CosmosConfigBlogWhereUniqueInput>>;
  /** Update multiple CosmosConfigBlog component instances */
  update?: InputMaybe<Array<CosmosConfigBlogUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosConfigBlog component instances */
  upsert?: InputMaybe<Array<CosmosConfigBlogUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosConfigBlogUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosConfigBlogUpdateManyLocalizationsInput>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosConfigBlogUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosConfigBlogUpdateManyLocalizationInput = {
  data: CosmosConfigBlogUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosConfigBlogUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosConfigBlogUpdateManyLocalizationInput>>;
};

export type CosmosConfigBlogUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosConfigBlogUpdateManyInput;
  /** Document search */
  where: CosmosConfigBlogWhereInput;
};

export type CosmosConfigBlogUpdateOneInlineInput = {
  /** Create and connect one CosmosConfigBlog document */
  create?: InputMaybe<CosmosConfigBlogCreateInput>;
  /** Delete currently connected CosmosConfigBlog document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosConfigBlog document */
  update?: InputMaybe<CosmosConfigBlogUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosConfigBlog document */
  upsert?: InputMaybe<CosmosConfigBlogUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigBlogUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosConfigBlogUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosConfigBlogWhereUniqueInput;
};

export type CosmosConfigBlogUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosConfigBlogUpdateInput;
  /** Unique document search */
  where: CosmosConfigBlogWhereUniqueInput;
};

export type CosmosConfigBlogUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosConfigBlogCreateInput;
  /** Update document if it exists */
  update: CosmosConfigBlogUpdateInput;
};

export type CosmosConfigBlogUpsertLocalizationInput = {
  create: CosmosConfigBlogCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosConfigBlogUpdateLocalizationDataInput;
};

export type CosmosConfigBlogUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosConfigBlogUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosConfigBlogWhereUniqueInput;
};

export type CosmosConfigBlogUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosConfigBlogUpsertInput;
  /** Unique document search */
  where: CosmosConfigBlogWhereUniqueInput;
};

/** Identifies documents */
export type CosmosConfigBlogWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosConfigBlogWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosConfigBlogWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosConfigBlogWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorTag?: InputMaybe<CosmosElementImageTagWhereInput>;
  blogLandingCard?: InputMaybe<CosmosElementBlogCardWhereInput>;
  categories_every?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_none?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_some?: InputMaybe<WfRefBlogCategoryWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  publicationDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  publicationDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  publicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  publicationDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  publicationDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publicationDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  publicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sticky_not?: InputMaybe<Scalars['Boolean']['input']>;
  tags_every?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_none?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_some?: InputMaybe<WfRefBlogTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosConfigBlog record uniquely */
export type CosmosConfigBlogWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosConfigSection = Entity & {
  __typename?: 'CosmosConfigSection';
  /** An anchor ID that anchor links can skip to this section with */
  anchorId?: Maybe<Scalars['String']['output']>;
  /** Background animation for blurred RefSections */
  backgroundAnimation?: Maybe<CosmosEnumLottieAnimation>;
  /** This is used for smaller sections, where you want background to use full section height with centering */
  backgroundFullHeight?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage?: Maybe<Asset>;
  /** Defaults the section to a collapsed state.  (Only implemented on certain sections) */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  disablePaddingBottom?: Maybe<Scalars['Boolean']['output']>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  edsBackgroundColor?: Maybe<CosmosEnumEdsBackgroundColors>;
  heading?: Maybe<CosmosConfigSectionheadingUnion>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosConfigSection>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosConfigSectionBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosConfigSectionHeadingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosConfigSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosConfigSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosConfigSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosConfigSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosConfigSectionConnection = {
  __typename?: 'CosmosConfigSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosConfigSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosConfigSectionCreateInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  backgroundAnimation?: InputMaybe<CosmosEnumLottieAnimation>;
  backgroundFullHeight?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  heading?: InputMaybe<CosmosConfigSectionheadingUnionCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosConfigSectionCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosConfigSectionCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosConfigSectionCreateLocalizationInput = {
  /** Localization input */
  data: CosmosConfigSectionCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosConfigSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosConfigSectionCreateLocalizationInput>>;
};

export type CosmosConfigSectionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosConfigSection documents */
  create?: InputMaybe<Array<CosmosConfigSectionCreateInput>>;
};

export type CosmosConfigSectionCreateOneInlineInput = {
  /** Create and connect one CosmosConfigSection document */
  create?: InputMaybe<CosmosConfigSectionCreateInput>;
};

export type CosmosConfigSectionCreateWithPositionInput = {
  /** Document to create */
  data: CosmosConfigSectionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosConfigSectionEdge = {
  __typename?: 'CosmosConfigSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosConfigSection;
};

/** Identifies documents */
export type CosmosConfigSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosConfigSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosConfigSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosConfigSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorId_starts_with?: InputMaybe<Scalars['String']['input']>;
  backgroundAnimation?: InputMaybe<CosmosEnumLottieAnimation>;
  /** All values that are contained in given list. */
  backgroundAnimation_in?: InputMaybe<Array<InputMaybe<CosmosEnumLottieAnimation>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundAnimation_not?: InputMaybe<CosmosEnumLottieAnimation>;
  /** All values that are not contained in given list. */
  backgroundAnimation_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLottieAnimation>>>;
  backgroundFullHeight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundFullHeight_not?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disablePaddingBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are contained in given list. */
  edsBackgroundColor_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  edsBackgroundColor_not?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are not contained in given list. */
  edsBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  /** All values in which the modular component is connected to the given models */
  heading?: InputMaybe<CosmosConfigSectionheadingUnionWhereInput>;
  /** All values in which the union is empty. */
  heading_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosConfigSectionOrderByInput {
  AnchorIdAsc = 'anchorId_ASC',
  AnchorIdDesc = 'anchorId_DESC',
  BackgroundAnimationAsc = 'backgroundAnimation_ASC',
  BackgroundAnimationDesc = 'backgroundAnimation_DESC',
  BackgroundFullHeightAsc = 'backgroundFullHeight_ASC',
  BackgroundFullHeightDesc = 'backgroundFullHeight_DESC',
  CollapsedAsc = 'collapsed_ASC',
  CollapsedDesc = 'collapsed_DESC',
  DisablePaddingBottomAsc = 'disablePaddingBottom_ASC',
  DisablePaddingBottomDesc = 'disablePaddingBottom_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  EdsBackgroundColorAsc = 'edsBackgroundColor_ASC',
  EdsBackgroundColorDesc = 'edsBackgroundColor_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosConfigSectionParent = CosmosPageResearch | CosmosSectionAccordionFeatureCard | CosmosSectionAccordionTierCards | CosmosSectionAriesCards | CosmosSectionAsset | CosmosSectionAssetCarousel | CosmosSectionAssetGallery | CosmosSectionBlobTable | CosmosSectionBlogCard | CosmosSectionCkRichText | CosmosSectionCommunity | CosmosSectionComplexCtaCard | CosmosSectionContentLargeImage | CosmosSectionContentSliderAsset | CosmosSectionCrux | CosmosSectionDelphinusCardsGrid | CosmosSectionDevelopersList | CosmosSectionDownloadCard | CosmosSectionDownloadable | CosmosSectionEmbed | CosmosSectionEventsTable | CosmosSectionFaq | CosmosSectionFaqSearch | CosmosSectionFeatureCard | CosmosSectionGameDevFeatureCard | CosmosSectionGeminiCard | CosmosSectionHydrusColumnList | CosmosSectionLatestNews | CosmosSectionLearn | CosmosSectionLicensesCollapsed | CosmosSectionLogoList | CosmosSectionLogoMultiCard | CosmosSectionNewsCard | CosmosSectionNewsMediaCard | CosmosSectionNumberCallout | CosmosSectionPluginListTable | CosmosSectionQuote | CosmosSectionResellersSearch | CosmosSectionRichText | CosmosSectionSlimContactCard | CosmosSectionSpeakerCard | CosmosSectionTabbedContentImage | CosmosSectionUtCard;

export type CosmosConfigSectionParentConnectInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardConnectInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsConnectInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsConnectInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetConnectInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselConnectInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryConnectInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableConnectInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardConnectInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextConnectInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityConnectInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardConnectInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageConnectInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetConnectInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxConnectInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridConnectInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListConnectInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardConnectInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableConnectInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedConnectInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableConnectInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqConnectInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchConnectInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardConnectInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardConnectInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardConnectInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListConnectInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsConnectInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnConnectInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedConnectInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardConnectInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardConnectInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutConnectInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableConnectInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteConnectInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchConnectInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextConnectInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardConnectInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardConnectInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageConnectInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardConnectInput>;
};

export type CosmosConfigSectionParentCreateInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardCreateInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsCreateInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsCreateInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetCreateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableCreateInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardCreateInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextCreateInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardCreateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridCreateInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListCreateInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableCreateInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedCreateInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableCreateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardCreateInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListCreateInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsCreateInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardCreateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableCreateInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteCreateInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchCreateInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextCreateInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardCreateInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardCreateInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageCreateInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardCreateInput>;
};

export type CosmosConfigSectionParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosConfigSectionParent documents */
  connect?: InputMaybe<Array<CosmosConfigSectionParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosConfigSectionParent documents */
  create?: InputMaybe<Array<CosmosConfigSectionParentCreateInput>>;
};

export type CosmosConfigSectionParentCreateOneInlineInput = {
  /** Connect one existing CosmosConfigSectionParent document */
  connect?: InputMaybe<CosmosConfigSectionParentWhereUniqueInput>;
  /** Create and connect one CosmosConfigSectionParent document */
  create?: InputMaybe<CosmosConfigSectionParentCreateInput>;
};

export type CosmosConfigSectionParentUpdateInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateInput>;
};

export type CosmosConfigSectionParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosConfigSectionParent documents */
  connect?: InputMaybe<Array<CosmosConfigSectionParentConnectInput>>;
  /** Create and connect multiple CosmosConfigSectionParent documents */
  create?: InputMaybe<Array<CosmosConfigSectionParentCreateInput>>;
  /** Delete multiple CosmosConfigSectionParent documents */
  delete?: InputMaybe<Array<CosmosConfigSectionParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosConfigSectionParent documents */
  disconnect?: InputMaybe<Array<CosmosConfigSectionParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosConfigSectionParent documents */
  set?: InputMaybe<Array<CosmosConfigSectionParentWhereUniqueInput>>;
  /** Update multiple CosmosConfigSectionParent documents */
  update?: InputMaybe<Array<CosmosConfigSectionParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosConfigSectionParent documents */
  upsert?: InputMaybe<Array<CosmosConfigSectionParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosConfigSectionParentUpdateManyWithNestedWhereInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateManyWithNestedWhereInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateManyWithNestedWhereInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateManyWithNestedWhereInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateManyWithNestedWhereInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateManyWithNestedWhereInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateManyWithNestedWhereInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateManyWithNestedWhereInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateManyWithNestedWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateManyWithNestedWhereInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateManyWithNestedWhereInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateManyWithNestedWhereInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateManyWithNestedWhereInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateManyWithNestedWhereInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateManyWithNestedWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateManyWithNestedWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateManyWithNestedWhereInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateManyWithNestedWhereInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateManyWithNestedWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateManyWithNestedWhereInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateManyWithNestedWhereInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateManyWithNestedWhereInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateManyWithNestedWhereInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateManyWithNestedWhereInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateManyWithNestedWhereInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateManyWithNestedWhereInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateManyWithNestedWhereInput>;
};

export type CosmosConfigSectionParentUpdateOneInlineInput = {
  /** Connect existing CosmosConfigSectionParent document */
  connect?: InputMaybe<CosmosConfigSectionParentWhereUniqueInput>;
  /** Create and connect one CosmosConfigSectionParent document */
  create?: InputMaybe<CosmosConfigSectionParentCreateInput>;
  /** Delete currently connected CosmosConfigSectionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosConfigSectionParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosConfigSectionParent document */
  update?: InputMaybe<CosmosConfigSectionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosConfigSectionParent document */
  upsert?: InputMaybe<CosmosConfigSectionParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateWithNestedWhereUniqueInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpsertWithNestedWhereUniqueInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionParentWhereInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardWhereInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsWhereInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsWhereInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableWhereInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardWhereInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextWhereInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridWhereInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListWhereInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableWhereInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedWhereInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardWhereInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListWhereInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsWhereInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableWhereInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteWhereInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchWhereInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextWhereInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardWhereInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardWhereInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageWhereInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardWhereInput>;
};

export type CosmosConfigSectionParentWhereUniqueInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardWhereUniqueInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsWhereUniqueInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsWhereUniqueInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereUniqueInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereUniqueInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereUniqueInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridWhereUniqueInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedWhereUniqueInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardWhereUniqueInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListWhereUniqueInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsWhereUniqueInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereUniqueInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteWhereUniqueInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardWhereUniqueInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardWhereUniqueInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageWhereUniqueInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardWhereUniqueInput>;
};

export type CosmosConfigSectionUpdateInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  backgroundAnimation?: InputMaybe<CosmosEnumLottieAnimation>;
  backgroundFullHeight?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  heading?: InputMaybe<CosmosConfigSectionheadingUnionUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosConfigSectionUpdateLocalizationsInput>;
};

export type CosmosConfigSectionUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosConfigSectionUpdateLocalizationInput = {
  data: CosmosConfigSectionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosConfigSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosConfigSectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosConfigSectionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosConfigSectionUpsertLocalizationInput>>;
};

export type CosmosConfigSectionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosConfigSection component instances */
  create?: InputMaybe<Array<CosmosConfigSectionCreateWithPositionInput>>;
  /** Delete multiple CosmosConfigSection documents */
  delete?: InputMaybe<Array<CosmosConfigSectionWhereUniqueInput>>;
  /** Update multiple CosmosConfigSection component instances */
  update?: InputMaybe<Array<CosmosConfigSectionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosConfigSection component instances */
  upsert?: InputMaybe<Array<CosmosConfigSectionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosConfigSectionUpdateManyInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  backgroundAnimation?: InputMaybe<CosmosEnumLottieAnimation>;
  backgroundFullHeight?: InputMaybe<Scalars['Boolean']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosConfigSectionUpdateManyLocalizationsInput>;
};

export type CosmosConfigSectionUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosConfigSectionUpdateManyLocalizationInput = {
  data: CosmosConfigSectionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosConfigSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosConfigSectionUpdateManyLocalizationInput>>;
};

export type CosmosConfigSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosConfigSectionUpdateManyInput;
  /** Document search */
  where: CosmosConfigSectionWhereInput;
};

export type CosmosConfigSectionUpdateOneInlineInput = {
  /** Create and connect one CosmosConfigSection document */
  create?: InputMaybe<CosmosConfigSectionCreateInput>;
  /** Delete currently connected CosmosConfigSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosConfigSection document */
  update?: InputMaybe<CosmosConfigSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosConfigSection document */
  upsert?: InputMaybe<CosmosConfigSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosConfigSectionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosConfigSectionWhereUniqueInput;
};

export type CosmosConfigSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosConfigSectionUpdateInput;
  /** Unique document search */
  where: CosmosConfigSectionWhereUniqueInput;
};

export type CosmosConfigSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosConfigSectionCreateInput;
  /** Update document if it exists */
  update: CosmosConfigSectionUpdateInput;
};

export type CosmosConfigSectionUpsertLocalizationInput = {
  create: CosmosConfigSectionCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosConfigSectionUpdateLocalizationDataInput;
};

export type CosmosConfigSectionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosConfigSectionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosConfigSectionWhereUniqueInput;
};

export type CosmosConfigSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosConfigSectionUpsertInput;
  /** Unique document search */
  where: CosmosConfigSectionWhereUniqueInput;
};

/** Identifies documents */
export type CosmosConfigSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosConfigSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosConfigSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosConfigSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorId_starts_with?: InputMaybe<Scalars['String']['input']>;
  backgroundAnimation?: InputMaybe<CosmosEnumLottieAnimation>;
  /** All values that are contained in given list. */
  backgroundAnimation_in?: InputMaybe<Array<InputMaybe<CosmosEnumLottieAnimation>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundAnimation_not?: InputMaybe<CosmosEnumLottieAnimation>;
  /** All values that are not contained in given list. */
  backgroundAnimation_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLottieAnimation>>>;
  backgroundFullHeight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundFullHeight_not?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disablePaddingBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are contained in given list. */
  edsBackgroundColor_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  edsBackgroundColor_not?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are not contained in given list. */
  edsBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  /** All values in which the modular component is connected to the given models */
  heading?: InputMaybe<CosmosConfigSectionheadingUnionWhereInput>;
  /** All values in which the union is empty. */
  heading_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosConfigSection record uniquely */
export type CosmosConfigSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosConfigSectionheadingUnion = CosmosElementIconSectionHeading | CosmosElementSectionHeading;

export type CosmosConfigSectionheadingUnionConnectInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingConnectInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingConnectInput>;
};

export type CosmosConfigSectionheadingUnionCreateInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingCreateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
};

export type CosmosConfigSectionheadingUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosConfigSectionheadingUnion documents */
  create?: InputMaybe<Array<CosmosConfigSectionheadingUnionCreateInput>>;
};

export type CosmosConfigSectionheadingUnionCreateOneInlineInput = {
  /** Create and connect one CosmosConfigSectionheadingUnion document */
  create?: InputMaybe<CosmosConfigSectionheadingUnionCreateInput>;
};

export type CosmosConfigSectionheadingUnionCreateWithPositionInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingCreateWithPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateWithPositionInput>;
};

export type CosmosConfigSectionheadingUnionUpdateInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateInput>;
};

export type CosmosConfigSectionheadingUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosConfigSectionheadingUnion component instances */
  create?: InputMaybe<Array<CosmosConfigSectionheadingUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosConfigSectionheadingUnion documents */
  delete?: InputMaybe<Array<CosmosConfigSectionheadingUnionWhereUniqueInput>>;
  /** Update multiple CosmosConfigSectionheadingUnion component instances */
  update?: InputMaybe<Array<CosmosConfigSectionheadingUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosConfigSectionheadingUnion component instances */
  upsert?: InputMaybe<Array<CosmosConfigSectionheadingUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosConfigSectionheadingUnionUpdateManyWithNestedWhereInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateManyWithNestedWhereInput>;
};

export type CosmosConfigSectionheadingUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosConfigSectionheadingUnion document */
  create?: InputMaybe<CosmosConfigSectionheadingUnionCreateInput>;
  /** Delete currently connected CosmosConfigSectionheadingUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosConfigSectionheadingUnion document */
  update?: InputMaybe<CosmosConfigSectionheadingUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosConfigSectionheadingUnion document */
  upsert?: InputMaybe<CosmosConfigSectionheadingUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionheadingUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosConfigSectionheadingUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionheadingUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosConfigSectionheadingUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput>;
};

export type CosmosConfigSectionheadingUnionWhereInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereInput>;
};

export type CosmosConfigSectionheadingUnionWhereUniqueInput = {
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereUniqueInput>;
};

export type CosmosElementAccordionFeatureCard = Entity & {
  __typename?: 'CosmosElementAccordionFeatureCard';
  /** This is the id (you might enter "game-dev") that can be linked to (like "/uses/#game-dev") from another page to scroll to this expanded AccordionFeatureCard. */
  anchorLinkId?: Maybe<Scalars['String']['output']>;
  cards: Array<CosmosElementGameDevFeatureCard>;
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAccordionFeatureCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAccordionFeatureCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementGameDevFeatureCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
};


export type CosmosElementAccordionFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAccordionFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAccordionFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAccordionFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAccordionFeatureCardConnection = {
  __typename?: 'CosmosElementAccordionFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAccordionFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAccordionFeatureCardCreateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  cards?: InputMaybe<CosmosElementGameDevFeatureCardCreateManyInlineInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAccordionFeatureCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionFeatureCardCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAccordionFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAccordionFeatureCardCreateLocalizationInput>>;
};

export type CosmosElementAccordionFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionFeatureCard documents */
  create?: InputMaybe<Array<CosmosElementAccordionFeatureCardCreateInput>>;
};

export type CosmosElementAccordionFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionFeatureCard document */
  create?: InputMaybe<CosmosElementAccordionFeatureCardCreateInput>;
};

export type CosmosElementAccordionFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAccordionFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAccordionFeatureCardEdge = {
  __typename?: 'CosmosElementAccordionFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAccordionFeatureCard;
};

/** Identifies documents */
export type CosmosElementAccordionFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAccordionFeatureCardOrderByInput {
  AnchorLinkIdAsc = 'anchorLinkId_ASC',
  AnchorLinkIdDesc = 'anchorLinkId_DESC',
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAccordionFeatureCardParent = CosmosSectionAccordionFeatureCard;

export type CosmosElementAccordionFeatureCardParentConnectInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardConnectInput>;
};

export type CosmosElementAccordionFeatureCardParentCreateInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardCreateInput>;
};

export type CosmosElementAccordionFeatureCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosElementAccordionFeatureCardParentCreateInput>>;
};

export type CosmosElementAccordionFeatureCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionFeatureCardParent document */
  create?: InputMaybe<CosmosElementAccordionFeatureCardParentCreateInput>;
};

export type CosmosElementAccordionFeatureCardParentCreateWithPositionInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardCreateWithPositionInput>;
};

export type CosmosElementAccordionFeatureCardParentUpdateInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateInput>;
};

export type CosmosElementAccordionFeatureCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionFeatureCardParent component instances */
  create?: InputMaybe<Array<CosmosElementAccordionFeatureCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosElementAccordionFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionFeatureCardParent component instances */
  update?: InputMaybe<Array<CosmosElementAccordionFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionFeatureCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionFeatureCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionFeatureCardParent document */
  create?: InputMaybe<CosmosElementAccordionFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosElementAccordionFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionFeatureCardParent document */
  update?: InputMaybe<CosmosElementAccordionFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionFeatureCardParent document */
  upsert?: InputMaybe<CosmosElementAccordionFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionFeatureCardParentWhereInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardWhereInput>;
};

export type CosmosElementAccordionFeatureCardParentWhereUniqueInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardWhereUniqueInput>;
};

export type CosmosElementAccordionFeatureCardUpdateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  cards?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyInlineInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAccordionFeatureCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionFeatureCardUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionFeatureCardUpdateLocalizationInput = {
  data: CosmosElementAccordionFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAccordionFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAccordionFeatureCardUpsertLocalizationInput>>;
};

export type CosmosElementAccordionFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionFeatureCard component instances */
  create?: InputMaybe<Array<CosmosElementAccordionFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionFeatureCard documents */
  delete?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionFeatureCard component instances */
  update?: InputMaybe<Array<CosmosElementAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionFeatureCardUpdateManyInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAccordionFeatureCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionFeatureCardUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionFeatureCardUpdateManyLocalizationInput = {
  data: CosmosElementAccordionFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosElementAccordionFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAccordionFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosElementAccordionFeatureCardWhereInput;
};

export type CosmosElementAccordionFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionFeatureCard document */
  create?: InputMaybe<CosmosElementAccordionFeatureCardCreateInput>;
  /** Delete currently connected CosmosElementAccordionFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionFeatureCard document */
  update?: InputMaybe<CosmosElementAccordionFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionFeatureCard document */
  upsert?: InputMaybe<CosmosElementAccordionFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAccordionFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionFeatureCardWhereUniqueInput;
};

export type CosmosElementAccordionFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAccordionFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosElementAccordionFeatureCardWhereUniqueInput;
};

export type CosmosElementAccordionFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAccordionFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementAccordionFeatureCardUpdateInput;
};

export type CosmosElementAccordionFeatureCardUpsertLocalizationInput = {
  create: CosmosElementAccordionFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAccordionFeatureCardUpdateLocalizationDataInput;
};

export type CosmosElementAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAccordionFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionFeatureCardWhereUniqueInput;
};

export type CosmosElementAccordionFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAccordionFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosElementAccordionFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAccordionFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAccordionFeatureCard record uniquely */
export type CosmosElementAccordionFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAccordionTierCard = Entity & {
  __typename?: 'CosmosElementAccordionTierCard';
  /** Used to auto expand and scroll to the section */
  anchorLinkId?: Maybe<Scalars['String']['output']>;
  /** Whether the tier is expanded on initial render */
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  items: Array<CosmosElementAccordionTierCarditemsUnion>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAccordionTierCard>;
  /** System stage field */
  stage: Stage;
  /** Pill next to the title on the accordion heading */
  tag?: Maybe<Scalars['String']['output']>;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAccordionTierCardItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementAccordionTierCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAccordionTierCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAccordionTierCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAccordionTierCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAccordionTierCardConnection = {
  __typename?: 'CosmosElementAccordionTierCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAccordionTierCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAccordionTierCardCreateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  items?: InputMaybe<CosmosElementAccordionTierCarditemsUnionCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAccordionTierCardCreateLocalizationsInput>;
  /** tag input for default locale (en) */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionTierCardCreateLocalizationDataInput = {
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionTierCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAccordionTierCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAccordionTierCardCreateLocalizationInput>>;
};

export type CosmosElementAccordionTierCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierCard documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierCardCreateInput>>;
};

export type CosmosElementAccordionTierCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCard document */
  create?: InputMaybe<CosmosElementAccordionTierCardCreateInput>;
};

export type CosmosElementAccordionTierCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAccordionTierCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAccordionTierCardEdge = {
  __typename?: 'CosmosElementAccordionTierCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAccordionTierCard;
};

/** Identifies documents */
export type CosmosElementAccordionTierCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionTierCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionTierCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionTierCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  items_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  items_some?: InputMaybe<CosmosElementAccordionTierCarditemsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAccordionTierCardOrderByInput {
  AnchorLinkIdAsc = 'anchorLinkId_ASC',
  AnchorLinkIdDesc = 'anchorLinkId_DESC',
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TagAsc = 'tag_ASC',
  TagDesc = 'tag_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAccordionTierCardParent = CosmosSectionAccordionTierCards;

export type CosmosElementAccordionTierCardParentConnectInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsConnectInput>;
};

export type CosmosElementAccordionTierCardParentCreateInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsCreateInput>;
};

export type CosmosElementAccordionTierCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierCardParent documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierCardParentCreateInput>>;
};

export type CosmosElementAccordionTierCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCardParent document */
  create?: InputMaybe<CosmosElementAccordionTierCardParentCreateInput>;
};

export type CosmosElementAccordionTierCardParentCreateWithPositionInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsCreateWithPositionInput>;
};

export type CosmosElementAccordionTierCardParentUpdateInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateInput>;
};

export type CosmosElementAccordionTierCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierCardParent component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierCardParent documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierCardParent component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionTierCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCardParent document */
  create?: InputMaybe<CosmosElementAccordionTierCardParentCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierCardParent document */
  update?: InputMaybe<CosmosElementAccordionTierCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierCardParent document */
  upsert?: InputMaybe<CosmosElementAccordionTierCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCardParentWhereInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsWhereInput>;
};

export type CosmosElementAccordionTierCardParentWhereUniqueInput = {
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsWhereUniqueInput>;
};

export type CosmosElementAccordionTierCardUpdateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  items?: InputMaybe<CosmosElementAccordionTierCarditemsUnionUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAccordionTierCardUpdateLocalizationsInput>;
  /** tag input for default locale (en) */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCardUpdateLocalizationDataInput = {
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCardUpdateLocalizationInput = {
  data: CosmosElementAccordionTierCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAccordionTierCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionTierCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCardUpsertLocalizationInput>>;
};

export type CosmosElementAccordionTierCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierCard component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierCard documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierCardWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierCard component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierCard component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierCardUpdateManyInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAccordionTierCardUpdateManyLocalizationsInput>;
  /** tag input for default locale (en) */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCardUpdateManyLocalizationDataInput = {
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCardUpdateManyLocalizationInput = {
  data: CosmosElementAccordionTierCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionTierCardUpdateManyLocalizationInput>>;
};

export type CosmosElementAccordionTierCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAccordionTierCardUpdateManyInput;
  /** Document search */
  where: CosmosElementAccordionTierCardWhereInput;
};

export type CosmosElementAccordionTierCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCard document */
  create?: InputMaybe<CosmosElementAccordionTierCardCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierCard document */
  update?: InputMaybe<CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierCard document */
  upsert?: InputMaybe<CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAccordionTierCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionTierCardWhereUniqueInput;
};

export type CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAccordionTierCardUpdateInput;
  /** Unique document search */
  where: CosmosElementAccordionTierCardWhereUniqueInput;
};

export type CosmosElementAccordionTierCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAccordionTierCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementAccordionTierCardUpdateInput;
};

export type CosmosElementAccordionTierCardUpsertLocalizationInput = {
  create: CosmosElementAccordionTierCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAccordionTierCardUpdateLocalizationDataInput;
};

export type CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAccordionTierCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionTierCardWhereUniqueInput;
};

export type CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAccordionTierCardUpsertInput;
  /** Unique document search */
  where: CosmosElementAccordionTierCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAccordionTierCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionTierCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionTierCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionTierCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  items_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  items_some?: InputMaybe<CosmosElementAccordionTierCarditemsUnionWhereInput>;
  tag?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tag_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tag_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tag_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tag_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tag_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tag_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tag_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAccordionTierCard record uniquely */
export type CosmosElementAccordionTierCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAccordionTierCarditemsUnion = CosmosElementAccordionTierCtaCard | CosmosElementAccordionTierFeatureCard;

export type CosmosElementAccordionTierCarditemsUnionConnectInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardConnectInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardConnectInput>;
};

export type CosmosElementAccordionTierCarditemsUnionCreateInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateInput>;
};

export type CosmosElementAccordionTierCarditemsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierCarditemsUnion documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierCarditemsUnionCreateInput>>;
};

export type CosmosElementAccordionTierCarditemsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCarditemsUnion document */
  create?: InputMaybe<CosmosElementAccordionTierCarditemsUnionCreateInput>;
};

export type CosmosElementAccordionTierCarditemsUnionCreateWithPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateWithPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateWithPositionInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpdateInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierCarditemsUnion component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierCarditemsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierCarditemsUnion documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierCarditemsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierCarditemsUnion component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierCarditemsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierCarditemsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCarditemsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierCarditemsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateManyWithNestedWhereInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCarditemsUnion document */
  create?: InputMaybe<CosmosElementAccordionTierCarditemsUnionCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierCarditemsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierCarditemsUnion document */
  update?: InputMaybe<CosmosElementAccordionTierCarditemsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierCarditemsUnion document */
  upsert?: InputMaybe<CosmosElementAccordionTierCarditemsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCarditemsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCarditemsUnionWhereInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardWhereInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardWhereInput>;
};

export type CosmosElementAccordionTierCarditemsUnionWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCard = Entity & {
  __typename?: 'CosmosElementAccordionTierCtaCard';
  asset?: Maybe<Asset>;
  buttons: Array<CosmosElementAccordionTierCtaCardbuttonsUnion>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Override for the CTA gradient */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAccordionTierCtaCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAccordionTierCtaCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementAccordionTierCtaCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementAccordionTierCtaCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAccordionTierCtaCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAccordionTierCtaCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAccordionTierCtaCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAccordionTierCtaCardConnection = {
  __typename?: 'CosmosElementAccordionTierCtaCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAccordionTierCtaCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAccordionTierCtaCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAccordionTierCtaCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionTierCtaCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionTierCtaCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAccordionTierCtaCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierCtaCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardCreateLocalizationInput>>;
};

export type CosmosElementAccordionTierCtaCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierCtaCard documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardCreateInput>>;
};

export type CosmosElementAccordionTierCtaCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCtaCard document */
  create?: InputMaybe<CosmosElementAccordionTierCtaCardCreateInput>;
};

export type CosmosElementAccordionTierCtaCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAccordionTierCtaCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAccordionTierCtaCardEdge = {
  __typename?: 'CosmosElementAccordionTierCtaCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAccordionTierCtaCard;
};

/** Identifies documents */
export type CosmosElementAccordionTierCtaCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  /** All values in which the union is empty. */
  buttons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  buttons_some?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAccordionTierCtaCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAccordionTierCtaCardParent = CosmosElementAccordionTierCard;

export type CosmosElementAccordionTierCtaCardParentConnectInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardConnectInput>;
};

export type CosmosElementAccordionTierCtaCardParentCreateInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardCreateInput>;
};

export type CosmosElementAccordionTierCtaCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierCtaCardParent documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardParentCreateInput>>;
};

export type CosmosElementAccordionTierCtaCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCtaCardParent document */
  create?: InputMaybe<CosmosElementAccordionTierCtaCardParentCreateInput>;
};

export type CosmosElementAccordionTierCtaCardParentCreateWithPositionInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardCreateWithPositionInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpdateInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierCtaCardParent component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierCtaCardParent documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierCtaCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierCtaCardParent component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierCtaCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierCtaCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCtaCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierCtaCardParentUpdateManyWithNestedWhereInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCtaCardParent document */
  create?: InputMaybe<CosmosElementAccordionTierCtaCardParentCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierCtaCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierCtaCardParent document */
  update?: InputMaybe<CosmosElementAccordionTierCtaCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierCtaCardParent document */
  upsert?: InputMaybe<CosmosElementAccordionTierCtaCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCtaCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardParentWhereInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
};

export type CosmosElementAccordionTierCtaCardParentWhereUniqueInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCtaCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCtaCardUpdateLocalizationInput = {
  data: CosmosElementAccordionTierCtaCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierCtaCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionTierCtaCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCtaCardUpsertLocalizationInput>>;
};

export type CosmosElementAccordionTierCtaCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierCtaCard component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierCtaCard documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierCtaCard component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierCtaCard component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierCtaCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCtaCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierCtaCardUpdateManyLocalizationInput = {
  data: CosmosElementAccordionTierCtaCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierCtaCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionTierCtaCardUpdateManyLocalizationInput>>;
};

export type CosmosElementAccordionTierCtaCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAccordionTierCtaCardUpdateManyInput;
  /** Document search */
  where: CosmosElementAccordionTierCtaCardWhereInput;
};

export type CosmosElementAccordionTierCtaCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCtaCard document */
  create?: InputMaybe<CosmosElementAccordionTierCtaCardCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierCtaCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierCtaCard document */
  update?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierCtaCard document */
  upsert?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionTierCtaCardWhereUniqueInput;
};

export type CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAccordionTierCtaCardUpdateInput;
  /** Unique document search */
  where: CosmosElementAccordionTierCtaCardWhereUniqueInput;
};

export type CosmosElementAccordionTierCtaCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAccordionTierCtaCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementAccordionTierCtaCardUpdateInput;
};

export type CosmosElementAccordionTierCtaCardUpsertLocalizationInput = {
  create: CosmosElementAccordionTierCtaCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAccordionTierCtaCardUpdateLocalizationDataInput;
};

export type CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionTierCtaCardWhereUniqueInput;
};

export type CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAccordionTierCtaCardUpsertInput;
  /** Unique document search */
  where: CosmosElementAccordionTierCtaCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAccordionTierCtaCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionTierCtaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  /** All values in which the union is empty. */
  buttons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  buttons_some?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAccordionTierCtaCard record uniquely */
export type CosmosElementAccordionTierCtaCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosElementAccordionTierCtaCardbuttonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierCtaCardbuttonsUnion documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardbuttonsUnionCreateInput>>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCtaCardbuttonsUnion document */
  create?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionCreateInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierCtaCardbuttonsUnion component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierCtaCardbuttonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierCtaCardbuttonsUnion documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierCtaCardbuttonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierCtaCardbuttonsUnion component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierCtaCardbuttonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierCtaCardbuttonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierCtaCardbuttonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierCtaCardbuttonsUnion document */
  create?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierCtaCardbuttonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierCtaCardbuttonsUnion document */
  update?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierCtaCardbuttonsUnion document */
  upsert?: InputMaybe<CosmosElementAccordionTierCtaCardbuttonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosElementAccordionTierCtaCardbuttonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCard = Entity & {
  __typename?: 'CosmosElementAccordionTierFeatureCard';
  asset?: Maybe<Asset>;
  buttons: Array<CosmosElementAccordionTierFeatureCardbuttonsUnion>;
  desc?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAccordionTierFeatureCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAccordionTierFeatureCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementAccordionTierFeatureCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementAccordionTierFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAccordionTierFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAccordionTierFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAccordionTierFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAccordionTierFeatureCardConnection = {
  __typename?: 'CosmosElementAccordionTierFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAccordionTierFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAccordionTierFeatureCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionTierFeatureCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAccordionTierFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAccordionTierFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardCreateLocalizationInput>>;
};

export type CosmosElementAccordionTierFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierFeatureCard documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardCreateInput>>;
};

export type CosmosElementAccordionTierFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierFeatureCard document */
  create?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateInput>;
};

export type CosmosElementAccordionTierFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAccordionTierFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAccordionTierFeatureCardEdge = {
  __typename?: 'CosmosElementAccordionTierFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAccordionTierFeatureCard;
};

/** Identifies documents */
export type CosmosElementAccordionTierFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  /** All values in which the union is empty. */
  buttons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  buttons_some?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAccordionTierFeatureCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAccordionTierFeatureCardParent = CosmosElementAccordionTierCard;

export type CosmosElementAccordionTierFeatureCardParentConnectInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardConnectInput>;
};

export type CosmosElementAccordionTierFeatureCardParentCreateInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardCreateInput>;
};

export type CosmosElementAccordionTierFeatureCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardParentCreateInput>>;
};

export type CosmosElementAccordionTierFeatureCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierFeatureCardParent document */
  create?: InputMaybe<CosmosElementAccordionTierFeatureCardParentCreateInput>;
};

export type CosmosElementAccordionTierFeatureCardParentCreateWithPositionInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardCreateWithPositionInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpdateInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierFeatureCardParent component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierFeatureCardParent component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierFeatureCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierFeatureCardParent document */
  create?: InputMaybe<CosmosElementAccordionTierFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierFeatureCardParent document */
  update?: InputMaybe<CosmosElementAccordionTierFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierFeatureCardParent document */
  upsert?: InputMaybe<CosmosElementAccordionTierFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardParentWhereInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
};

export type CosmosElementAccordionTierFeatureCardParentWhereUniqueInput = {
  CosmosElementAccordionTierCard?: InputMaybe<CosmosElementAccordionTierCardWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierFeatureCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierFeatureCardUpdateLocalizationInput = {
  data: CosmosElementAccordionTierFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardUpsertLocalizationInput>>;
};

export type CosmosElementAccordionTierFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierFeatureCard component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierFeatureCard documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierFeatureCard component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierFeatureCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierFeatureCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAccordionTierFeatureCardUpdateManyLocalizationInput = {
  data: CosmosElementAccordionTierFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAccordionTierFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosElementAccordionTierFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAccordionTierFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosElementAccordionTierFeatureCardWhereInput;
};

export type CosmosElementAccordionTierFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierFeatureCard document */
  create?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierFeatureCard document */
  update?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierFeatureCard document */
  upsert?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionTierFeatureCardWhereUniqueInput;
};

export type CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAccordionTierFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosElementAccordionTierFeatureCardWhereUniqueInput;
};

export type CosmosElementAccordionTierFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAccordionTierFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementAccordionTierFeatureCardUpdateInput;
};

export type CosmosElementAccordionTierFeatureCardUpsertLocalizationInput = {
  create: CosmosElementAccordionTierFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAccordionTierFeatureCardUpdateLocalizationDataInput;
};

export type CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAccordionTierFeatureCardWhereUniqueInput;
};

export type CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAccordionTierFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosElementAccordionTierFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAccordionTierFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  /** All values in which the union is empty. */
  buttons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  buttons_some?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAccordionTierFeatureCard record uniquely */
export type CosmosElementAccordionTierFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosElementAccordionTierFeatureCardbuttonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAccordionTierFeatureCardbuttonsUnion documents */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardbuttonsUnionCreateInput>>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierFeatureCardbuttonsUnion document */
  create?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionCreateInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAccordionTierFeatureCardbuttonsUnion component instances */
  create?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardbuttonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAccordionTierFeatureCardbuttonsUnion documents */
  delete?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardbuttonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementAccordionTierFeatureCardbuttonsUnion component instances */
  update?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAccordionTierFeatureCardbuttonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementAccordionTierFeatureCardbuttonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAccordionTierFeatureCardbuttonsUnion document */
  create?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionCreateInput>;
  /** Delete currently connected CosmosElementAccordionTierFeatureCardbuttonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAccordionTierFeatureCardbuttonsUnion document */
  update?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAccordionTierFeatureCardbuttonsUnion document */
  upsert?: InputMaybe<CosmosElementAccordionTierFeatureCardbuttonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosElementAccordionTierFeatureCardbuttonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosElementAgreementDetail = Entity & {
  __typename?: 'CosmosElementAgreementDetail';
  acceptButtonLabel?: Maybe<Scalars['String']['output']>;
  acceptOptionLabel?: Maybe<Scalars['String']['output']>;
  /** Message to show in footer after Agreement was accepted */
  acceptedContent?: Maybe<Scalars['String']['output']>;
  /** Where we want to redirect after we accepted EULA. */
  acceptedRedirect?: Maybe<Scalars['String']['output']>;
  /** How much time to wait before redirect */
  acceptedTimeout?: Maybe<Scalars['Int']['output']>;
  /** Key value from https://adminportal-website-gamedev.ol.epicgames.net/services/eula/ */
  agreementKeyEula: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAgreementDetail>;
  mustAcceptWarning?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAgreementDetailLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAgreementDetailUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAgreementDetailConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAgreementDetailWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAgreementDetailConnection = {
  __typename?: 'CosmosElementAgreementDetailConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAgreementDetailEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAgreementDetailCreateInput = {
  /** acceptButtonLabel input for default locale (en) */
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** acceptOptionLabel input for default locale (en) */
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  /** acceptedContent input for default locale (en) */
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  /** acceptedRedirect input for default locale (en) */
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  acceptedTimeout?: InputMaybe<Scalars['Int']['input']>;
  agreementKeyEula: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAgreementDetailCreateLocalizationsInput>;
  /** mustAcceptWarning input for default locale (en) */
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAgreementDetailCreateLocalizationDataInput = {
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAgreementDetailCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAgreementDetailCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAgreementDetailCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAgreementDetailCreateLocalizationInput>>;
};

export type CosmosElementAgreementDetailCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAgreementDetail documents */
  create?: InputMaybe<Array<CosmosElementAgreementDetailCreateInput>>;
};

export type CosmosElementAgreementDetailCreateOneInlineInput = {
  /** Create and connect one CosmosElementAgreementDetail document */
  create?: InputMaybe<CosmosElementAgreementDetailCreateInput>;
};

export type CosmosElementAgreementDetailCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAgreementDetailCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAgreementDetailEdge = {
  __typename?: 'CosmosElementAgreementDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAgreementDetail;
};

/** Identifies documents */
export type CosmosElementAgreementDetailManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAgreementDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAgreementDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAgreementDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  acceptedTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  acceptedTimeout_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  acceptedTimeout_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  acceptedTimeout_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  acceptedTimeout_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  acceptedTimeout_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  acceptedTimeout_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  acceptedTimeout_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  agreementKeyEula?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  agreementKeyEula_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  agreementKeyEula_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  agreementKeyEula_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  agreementKeyEula_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  agreementKeyEula_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  agreementKeyEula_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  agreementKeyEula_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  agreementKeyEula_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  agreementKeyEula_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAgreementDetailOrderByInput {
  AcceptButtonLabelAsc = 'acceptButtonLabel_ASC',
  AcceptButtonLabelDesc = 'acceptButtonLabel_DESC',
  AcceptOptionLabelAsc = 'acceptOptionLabel_ASC',
  AcceptOptionLabelDesc = 'acceptOptionLabel_DESC',
  AcceptedContentAsc = 'acceptedContent_ASC',
  AcceptedContentDesc = 'acceptedContent_DESC',
  AcceptedRedirectAsc = 'acceptedRedirect_ASC',
  AcceptedRedirectDesc = 'acceptedRedirect_DESC',
  AcceptedTimeoutAsc = 'acceptedTimeout_ASC',
  AcceptedTimeoutDesc = 'acceptedTimeout_DESC',
  AgreementKeyEulaAsc = 'agreementKeyEula_ASC',
  AgreementKeyEulaDesc = 'agreementKeyEula_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MustAcceptWarningAsc = 'mustAcceptWarning_ASC',
  MustAcceptWarningDesc = 'mustAcceptWarning_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAgreementDetailParent = CosmosPageAgreement;

export type CosmosElementAgreementDetailParentConnectInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementConnectInput>;
};

export type CosmosElementAgreementDetailParentCreateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementCreateInput>;
};

export type CosmosElementAgreementDetailParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementAgreementDetailParent documents */
  connect?: InputMaybe<Array<CosmosElementAgreementDetailParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementAgreementDetailParent documents */
  create?: InputMaybe<Array<CosmosElementAgreementDetailParentCreateInput>>;
};

export type CosmosElementAgreementDetailParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementAgreementDetailParent document */
  connect?: InputMaybe<CosmosElementAgreementDetailParentWhereUniqueInput>;
  /** Create and connect one CosmosElementAgreementDetailParent document */
  create?: InputMaybe<CosmosElementAgreementDetailParentCreateInput>;
};

export type CosmosElementAgreementDetailParentUpdateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateInput>;
};

export type CosmosElementAgreementDetailParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementAgreementDetailParent documents */
  connect?: InputMaybe<Array<CosmosElementAgreementDetailParentConnectInput>>;
  /** Create and connect multiple CosmosElementAgreementDetailParent documents */
  create?: InputMaybe<Array<CosmosElementAgreementDetailParentCreateInput>>;
  /** Delete multiple CosmosElementAgreementDetailParent documents */
  delete?: InputMaybe<Array<CosmosElementAgreementDetailParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementAgreementDetailParent documents */
  disconnect?: InputMaybe<Array<CosmosElementAgreementDetailParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementAgreementDetailParent documents */
  set?: InputMaybe<Array<CosmosElementAgreementDetailParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAgreementDetailParent documents */
  update?: InputMaybe<Array<CosmosElementAgreementDetailParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementAgreementDetailParent documents */
  upsert?: InputMaybe<Array<CosmosElementAgreementDetailParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementAgreementDetailParentUpdateManyWithNestedWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAgreementDetailParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementAgreementDetailParent document */
  connect?: InputMaybe<CosmosElementAgreementDetailParentWhereUniqueInput>;
  /** Create and connect one CosmosElementAgreementDetailParent document */
  create?: InputMaybe<CosmosElementAgreementDetailParentCreateInput>;
  /** Delete currently connected CosmosElementAgreementDetailParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementAgreementDetailParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAgreementDetailParent document */
  update?: InputMaybe<CosmosElementAgreementDetailParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAgreementDetailParent document */
  upsert?: InputMaybe<CosmosElementAgreementDetailParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAgreementDetailParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAgreementDetailParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAgreementDetailParentWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereInput>;
};

export type CosmosElementAgreementDetailParentWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
};

export type CosmosElementAgreementDetailUpdateInput = {
  /** acceptButtonLabel input for default locale (en) */
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** acceptOptionLabel input for default locale (en) */
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  /** acceptedContent input for default locale (en) */
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  /** acceptedRedirect input for default locale (en) */
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  acceptedTimeout?: InputMaybe<Scalars['Int']['input']>;
  agreementKeyEula?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAgreementDetailUpdateLocalizationsInput>;
  /** mustAcceptWarning input for default locale (en) */
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAgreementDetailUpdateLocalizationDataInput = {
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAgreementDetailUpdateLocalizationInput = {
  data: CosmosElementAgreementDetailUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAgreementDetailUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAgreementDetailCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAgreementDetailUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAgreementDetailUpsertLocalizationInput>>;
};

export type CosmosElementAgreementDetailUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAgreementDetail component instances */
  create?: InputMaybe<Array<CosmosElementAgreementDetailCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAgreementDetail documents */
  delete?: InputMaybe<Array<CosmosElementAgreementDetailWhereUniqueInput>>;
  /** Update multiple CosmosElementAgreementDetail component instances */
  update?: InputMaybe<Array<CosmosElementAgreementDetailUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAgreementDetail component instances */
  upsert?: InputMaybe<Array<CosmosElementAgreementDetailUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAgreementDetailUpdateManyInput = {
  /** acceptButtonLabel input for default locale (en) */
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** acceptOptionLabel input for default locale (en) */
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  /** acceptedContent input for default locale (en) */
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  /** acceptedRedirect input for default locale (en) */
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  acceptedTimeout?: InputMaybe<Scalars['Int']['input']>;
  agreementKeyEula?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAgreementDetailUpdateManyLocalizationsInput>;
  /** mustAcceptWarning input for default locale (en) */
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAgreementDetailUpdateManyLocalizationDataInput = {
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAgreementDetailUpdateManyLocalizationInput = {
  data: CosmosElementAgreementDetailUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAgreementDetailUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAgreementDetailUpdateManyLocalizationInput>>;
};

export type CosmosElementAgreementDetailUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAgreementDetailUpdateManyInput;
  /** Document search */
  where: CosmosElementAgreementDetailWhereInput;
};

export type CosmosElementAgreementDetailUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAgreementDetail document */
  create?: InputMaybe<CosmosElementAgreementDetailCreateInput>;
  /** Delete currently connected CosmosElementAgreementDetail document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAgreementDetail document */
  update?: InputMaybe<CosmosElementAgreementDetailUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAgreementDetail document */
  upsert?: InputMaybe<CosmosElementAgreementDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAgreementDetailUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAgreementDetailUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAgreementDetailWhereUniqueInput;
};

export type CosmosElementAgreementDetailUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAgreementDetailUpdateInput;
  /** Unique document search */
  where: CosmosElementAgreementDetailWhereUniqueInput;
};

export type CosmosElementAgreementDetailUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAgreementDetailCreateInput;
  /** Update document if it exists */
  update: CosmosElementAgreementDetailUpdateInput;
};

export type CosmosElementAgreementDetailUpsertLocalizationInput = {
  create: CosmosElementAgreementDetailCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAgreementDetailUpdateLocalizationDataInput;
};

export type CosmosElementAgreementDetailUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAgreementDetailUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAgreementDetailWhereUniqueInput;
};

export type CosmosElementAgreementDetailUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAgreementDetailUpsertInput;
  /** Unique document search */
  where: CosmosElementAgreementDetailWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAgreementDetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAgreementDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAgreementDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAgreementDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  acceptButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  acceptButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  acceptButtonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  acceptButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  acceptButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  acceptButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  acceptButtonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  acceptButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  acceptButtonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  acceptButtonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  acceptOptionLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  acceptOptionLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  acceptOptionLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  acceptOptionLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  acceptOptionLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  acceptOptionLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  acceptOptionLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  acceptOptionLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  acceptOptionLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  acceptOptionLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  acceptedContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  acceptedContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  acceptedContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  acceptedContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  acceptedContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  acceptedContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  acceptedContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  acceptedContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  acceptedContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  acceptedContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  acceptedRedirect?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  acceptedRedirect_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  acceptedRedirect_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  acceptedRedirect_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  acceptedRedirect_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  acceptedRedirect_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  acceptedRedirect_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  acceptedRedirect_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  acceptedRedirect_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  acceptedRedirect_starts_with?: InputMaybe<Scalars['String']['input']>;
  acceptedTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  acceptedTimeout_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  acceptedTimeout_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  acceptedTimeout_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  acceptedTimeout_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  acceptedTimeout_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  acceptedTimeout_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  acceptedTimeout_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  agreementKeyEula?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  agreementKeyEula_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  agreementKeyEula_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  agreementKeyEula_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  agreementKeyEula_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  agreementKeyEula_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  agreementKeyEula_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  agreementKeyEula_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  agreementKeyEula_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  agreementKeyEula_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mustAcceptWarning?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mustAcceptWarning_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mustAcceptWarning_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mustAcceptWarning_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mustAcceptWarning_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mustAcceptWarning_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mustAcceptWarning_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mustAcceptWarning_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mustAcceptWarning_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mustAcceptWarning_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAgreementDetail record uniquely */
export type CosmosElementAgreementDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAriesCard = Entity & {
  __typename?: 'CosmosElementAriesCard';
  asset?: Maybe<Asset>;
  buttons: Array<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAriesCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAriesCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementAriesCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementAriesCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAriesCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAriesCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAriesCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAriesCardConnection = {
  __typename?: 'CosmosElementAriesCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAriesCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAriesCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAriesCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAriesCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAriesCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAriesCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAriesCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAriesCardCreateLocalizationInput>>;
};

export type CosmosElementAriesCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAriesCard documents */
  create?: InputMaybe<Array<CosmosElementAriesCardCreateInput>>;
};

export type CosmosElementAriesCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementAriesCard document */
  create?: InputMaybe<CosmosElementAriesCardCreateInput>;
};

export type CosmosElementAriesCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAriesCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAriesCardEdge = {
  __typename?: 'CosmosElementAriesCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAriesCard;
};

/** Identifies documents */
export type CosmosElementAriesCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAriesCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAriesCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAriesCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAriesCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  FullWidthAsc = 'fullWidth_ASC',
  FullWidthDesc = 'fullWidth_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAriesCardParent = CosmosSectionAriesCards;

export type CosmosElementAriesCardParentConnectInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsConnectInput>;
};

export type CosmosElementAriesCardParentCreateInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsCreateInput>;
};

export type CosmosElementAriesCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAriesCardParent documents */
  create?: InputMaybe<Array<CosmosElementAriesCardParentCreateInput>>;
};

export type CosmosElementAriesCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementAriesCardParent document */
  create?: InputMaybe<CosmosElementAriesCardParentCreateInput>;
};

export type CosmosElementAriesCardParentCreateWithPositionInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsCreateWithPositionInput>;
};

export type CosmosElementAriesCardParentUpdateInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateInput>;
};

export type CosmosElementAriesCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAriesCardParent component instances */
  create?: InputMaybe<Array<CosmosElementAriesCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAriesCardParent documents */
  delete?: InputMaybe<Array<CosmosElementAriesCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAriesCardParent component instances */
  update?: InputMaybe<Array<CosmosElementAriesCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAriesCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementAriesCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAriesCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAriesCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAriesCardParent document */
  create?: InputMaybe<CosmosElementAriesCardParentCreateInput>;
  /** Delete currently connected CosmosElementAriesCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAriesCardParent document */
  update?: InputMaybe<CosmosElementAriesCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAriesCardParent document */
  upsert?: InputMaybe<CosmosElementAriesCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAriesCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAriesCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAriesCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAriesCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAriesCardParentWhereInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsWhereInput>;
};

export type CosmosElementAriesCardParentWhereUniqueInput = {
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsWhereUniqueInput>;
};

export type CosmosElementAriesCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAriesCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAriesCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAriesCardUpdateLocalizationInput = {
  data: CosmosElementAriesCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAriesCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAriesCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAriesCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAriesCardUpsertLocalizationInput>>;
};

export type CosmosElementAriesCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAriesCard component instances */
  create?: InputMaybe<Array<CosmosElementAriesCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAriesCard documents */
  delete?: InputMaybe<Array<CosmosElementAriesCardWhereUniqueInput>>;
  /** Update multiple CosmosElementAriesCard component instances */
  update?: InputMaybe<Array<CosmosElementAriesCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAriesCard component instances */
  upsert?: InputMaybe<Array<CosmosElementAriesCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAriesCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAriesCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAriesCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementAriesCardUpdateManyLocalizationInput = {
  data: CosmosElementAriesCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAriesCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAriesCardUpdateManyLocalizationInput>>;
};

export type CosmosElementAriesCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAriesCardUpdateManyInput;
  /** Document search */
  where: CosmosElementAriesCardWhereInput;
};

export type CosmosElementAriesCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAriesCard document */
  create?: InputMaybe<CosmosElementAriesCardCreateInput>;
  /** Delete currently connected CosmosElementAriesCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAriesCard document */
  update?: InputMaybe<CosmosElementAriesCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAriesCard document */
  upsert?: InputMaybe<CosmosElementAriesCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAriesCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAriesCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAriesCardWhereUniqueInput;
};

export type CosmosElementAriesCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAriesCardUpdateInput;
  /** Unique document search */
  where: CosmosElementAriesCardWhereUniqueInput;
};

export type CosmosElementAriesCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAriesCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementAriesCardUpdateInput;
};

export type CosmosElementAriesCardUpsertLocalizationInput = {
  create: CosmosElementAriesCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAriesCardUpdateLocalizationDataInput;
};

export type CosmosElementAriesCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAriesCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAriesCardWhereUniqueInput;
};

export type CosmosElementAriesCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAriesCardUpsertInput;
  /** Unique document search */
  where: CosmosElementAriesCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAriesCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAriesCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAriesCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAriesCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAriesCard record uniquely */
export type CosmosElementAriesCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAsset = Entity & {
  __typename?: 'CosmosElementAsset';
  asset: Asset;
  caption?: Maybe<Scalars['String']['output']>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementAsset>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAssetAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementAssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementAssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementAssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAssetConnection = {
  __typename?: 'CosmosElementAssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAssetCreateInput = {
  asset: AssetCreateOneInlineInput;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementAssetCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAssetCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAssetCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementAssetCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementAssetCreateLocalizationInput>>;
};

export type CosmosElementAssetCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAsset documents */
  create?: InputMaybe<Array<CosmosElementAssetCreateInput>>;
};

export type CosmosElementAssetCreateOneInlineInput = {
  /** Create and connect one CosmosElementAsset document */
  create?: InputMaybe<CosmosElementAssetCreateInput>;
};

export type CosmosElementAssetCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAssetCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAssetEdge = {
  __typename?: 'CosmosElementAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAsset;
};

/** Identifies documents */
export type CosmosElementAssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAssetOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAssetParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementAssetParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementAssetParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementAssetParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementAssetParent documents */
  connect?: InputMaybe<Array<CosmosElementAssetParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementAssetParent documents */
  create?: InputMaybe<Array<CosmosElementAssetParentCreateInput>>;
};

export type CosmosElementAssetParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementAssetParent document */
  connect?: InputMaybe<CosmosElementAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosElementAssetParent document */
  create?: InputMaybe<CosmosElementAssetParentCreateInput>;
};

export type CosmosElementAssetParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementAssetParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementAssetParent documents */
  connect?: InputMaybe<Array<CosmosElementAssetParentConnectInput>>;
  /** Create and connect multiple CosmosElementAssetParent documents */
  create?: InputMaybe<Array<CosmosElementAssetParentCreateInput>>;
  /** Delete multiple CosmosElementAssetParent documents */
  delete?: InputMaybe<Array<CosmosElementAssetParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementAssetParent documents */
  disconnect?: InputMaybe<Array<CosmosElementAssetParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementAssetParent documents */
  set?: InputMaybe<Array<CosmosElementAssetParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAssetParent documents */
  update?: InputMaybe<Array<CosmosElementAssetParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementAssetParent documents */
  upsert?: InputMaybe<Array<CosmosElementAssetParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementAssetParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAssetParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementAssetParent document */
  connect?: InputMaybe<CosmosElementAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosElementAssetParent document */
  create?: InputMaybe<CosmosElementAssetParentCreateInput>;
  /** Delete currently connected CosmosElementAssetParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementAssetParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAssetParent document */
  update?: InputMaybe<CosmosElementAssetParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAssetParent document */
  upsert?: InputMaybe<CosmosElementAssetParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAssetParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAssetParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAssetParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementAssetParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementAssetUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementAssetUpdateLocalizationsInput>;
};

export type CosmosElementAssetUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAssetUpdateLocalizationInput = {
  data: CosmosElementAssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementAssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementAssetUpsertLocalizationInput>>;
};

export type CosmosElementAssetUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAsset component instances */
  create?: InputMaybe<Array<CosmosElementAssetCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAsset documents */
  delete?: InputMaybe<Array<CosmosElementAssetWhereUniqueInput>>;
  /** Update multiple CosmosElementAsset component instances */
  update?: InputMaybe<Array<CosmosElementAssetUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAsset component instances */
  upsert?: InputMaybe<Array<CosmosElementAssetUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAssetUpdateManyInput = {
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementAssetUpdateManyLocalizationsInput>;
};

export type CosmosElementAssetUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAssetUpdateManyLocalizationInput = {
  data: CosmosElementAssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementAssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementAssetUpdateManyLocalizationInput>>;
};

export type CosmosElementAssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAssetUpdateManyInput;
  /** Document search */
  where: CosmosElementAssetWhereInput;
};

export type CosmosElementAssetUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAsset document */
  create?: InputMaybe<CosmosElementAssetCreateInput>;
  /** Delete currently connected CosmosElementAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAsset document */
  update?: InputMaybe<CosmosElementAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAsset document */
  upsert?: InputMaybe<CosmosElementAssetUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAssetUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAssetUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAssetWhereUniqueInput;
};

export type CosmosElementAssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAssetUpdateInput;
  /** Unique document search */
  where: CosmosElementAssetWhereUniqueInput;
};

export type CosmosElementAssetUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAssetCreateInput;
  /** Update document if it exists */
  update: CosmosElementAssetUpdateInput;
};

export type CosmosElementAssetUpsertLocalizationInput = {
  create: CosmosElementAssetCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementAssetUpdateLocalizationDataInput;
};

export type CosmosElementAssetUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAssetUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAssetWhereUniqueInput;
};

export type CosmosElementAssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAssetUpsertInput;
  /** Unique document search */
  where: CosmosElementAssetWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAsset record uniquely */
export type CosmosElementAssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementAvatar = Entity & {
  __typename?: 'CosmosElementAvatar';
  color?: Maybe<CosmosEnumAvatarColors>;
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageAsset?: Maybe<Asset>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementAvatarImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type CosmosElementAvatarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementAvatarWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementAvatarConnection = {
  __typename?: 'CosmosElementAvatarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementAvatarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementAvatarCreateInput = {
  color?: InputMaybe<CosmosEnumAvatarColors>;
  href?: InputMaybe<Scalars['String']['input']>;
  imageAsset?: InputMaybe<AssetCreateOneInlineInput>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementAvatarCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAvatar documents */
  create?: InputMaybe<Array<CosmosElementAvatarCreateInput>>;
};

export type CosmosElementAvatarCreateOneInlineInput = {
  /** Create and connect one CosmosElementAvatar document */
  create?: InputMaybe<CosmosElementAvatarCreateInput>;
};

export type CosmosElementAvatarCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementAvatarCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementAvatarEdge = {
  __typename?: 'CosmosElementAvatarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementAvatar;
};

/** Identifies documents */
export type CosmosElementAvatarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAvatarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAvatarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAvatarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CosmosEnumAvatarColors>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CosmosEnumAvatarColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CosmosEnumAvatarColors>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumAvatarColors>>>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAsset?: InputMaybe<AssetWhereInput>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageSrc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageSrc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageSrc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageSrc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageSrc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageSrc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageSrc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageSrc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageSrc_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementAvatarOrderByInput {
  ColorAsc = 'color_ASC',
  ColorDesc = 'color_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageSrcAsc = 'imageSrc_ASC',
  ImageSrcDesc = 'imageSrc_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementAvatarParent = CosmosElementDelphinusCard | CosmosElementUserProfile;

export type CosmosElementAvatarParentConnectInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardConnectInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileConnectInput>;
};

export type CosmosElementAvatarParentCreateInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardCreateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateInput>;
};

export type CosmosElementAvatarParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementAvatarParent documents */
  create?: InputMaybe<Array<CosmosElementAvatarParentCreateInput>>;
};

export type CosmosElementAvatarParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementAvatarParent document */
  create?: InputMaybe<CosmosElementAvatarParentCreateInput>;
};

export type CosmosElementAvatarParentCreateWithPositionInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardCreateWithPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateWithPositionInput>;
};

export type CosmosElementAvatarParentUpdateInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateInput>;
};

export type CosmosElementAvatarParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAvatarParent component instances */
  create?: InputMaybe<Array<CosmosElementAvatarParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAvatarParent documents */
  delete?: InputMaybe<Array<CosmosElementAvatarParentWhereUniqueInput>>;
  /** Update multiple CosmosElementAvatarParent component instances */
  update?: InputMaybe<Array<CosmosElementAvatarParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAvatarParent component instances */
  upsert?: InputMaybe<Array<CosmosElementAvatarParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAvatarParentUpdateManyWithNestedWhereInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateManyWithNestedWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateManyWithNestedWhereInput>;
};

export type CosmosElementAvatarParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAvatarParent document */
  create?: InputMaybe<CosmosElementAvatarParentCreateInput>;
  /** Delete currently connected CosmosElementAvatarParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAvatarParent document */
  update?: InputMaybe<CosmosElementAvatarParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAvatarParent document */
  upsert?: InputMaybe<CosmosElementAvatarParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAvatarParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAvatarParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementAvatarParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementAvatarParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAvatarParentWhereInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereInput>;
};

export type CosmosElementAvatarParentWhereUniqueInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereUniqueInput>;
};

export type CosmosElementAvatarUpdateInput = {
  color?: InputMaybe<CosmosEnumAvatarColors>;
  href?: InputMaybe<Scalars['String']['input']>;
  imageAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAvatarUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementAvatar component instances */
  create?: InputMaybe<Array<CosmosElementAvatarCreateWithPositionInput>>;
  /** Delete multiple CosmosElementAvatar documents */
  delete?: InputMaybe<Array<CosmosElementAvatarWhereUniqueInput>>;
  /** Update multiple CosmosElementAvatar component instances */
  update?: InputMaybe<Array<CosmosElementAvatarUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementAvatar component instances */
  upsert?: InputMaybe<Array<CosmosElementAvatarUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementAvatarUpdateManyInput = {
  color?: InputMaybe<CosmosEnumAvatarColors>;
  href?: InputMaybe<Scalars['String']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementAvatarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementAvatarUpdateManyInput;
  /** Document search */
  where: CosmosElementAvatarWhereInput;
};

export type CosmosElementAvatarUpdateOneInlineInput = {
  /** Create and connect one CosmosElementAvatar document */
  create?: InputMaybe<CosmosElementAvatarCreateInput>;
  /** Delete currently connected CosmosElementAvatar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementAvatar document */
  update?: InputMaybe<CosmosElementAvatarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementAvatar document */
  upsert?: InputMaybe<CosmosElementAvatarUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementAvatarUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementAvatarUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAvatarWhereUniqueInput;
};

export type CosmosElementAvatarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementAvatarUpdateInput;
  /** Unique document search */
  where: CosmosElementAvatarWhereUniqueInput;
};

export type CosmosElementAvatarUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementAvatarCreateInput;
  /** Update document if it exists */
  update: CosmosElementAvatarUpdateInput;
};

export type CosmosElementAvatarUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementAvatarUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementAvatarWhereUniqueInput;
};

export type CosmosElementAvatarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementAvatarUpsertInput;
  /** Unique document search */
  where: CosmosElementAvatarWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementAvatarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementAvatarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementAvatarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementAvatarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CosmosEnumAvatarColors>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CosmosEnumAvatarColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CosmosEnumAvatarColors>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumAvatarColors>>>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAsset?: InputMaybe<AssetWhereInput>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageSrc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageSrc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageSrc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageSrc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageSrc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageSrc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageSrc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageSrc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageSrc_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementAvatar record uniquely */
export type CosmosElementAvatarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementBlogCard = Entity & {
  __typename?: 'CosmosElementBlogCard';
  asset?: Maybe<Asset>;
  buttons: Array<CosmosElementIconButton>;
  category?: Maybe<WfRefBlogCategory>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Optional eyebrow above the title */
  eyebrow?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementBlogCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementBlogCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementBlogCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosElementBlogCardCategoryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementBlogCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementBlogCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementBlogCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementBlogCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementBlogCardConnection = {
  __typename?: 'CosmosElementBlogCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementBlogCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementBlogCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  category?: InputMaybe<WfRefBlogCategoryCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementBlogCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementBlogCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementBlogCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementBlogCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementBlogCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementBlogCardCreateLocalizationInput>>;
};

export type CosmosElementBlogCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementBlogCard documents */
  create?: InputMaybe<Array<CosmosElementBlogCardCreateInput>>;
};

export type CosmosElementBlogCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementBlogCard document */
  create?: InputMaybe<CosmosElementBlogCardCreateInput>;
};

export type CosmosElementBlogCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementBlogCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementBlogCardEdge = {
  __typename?: 'CosmosElementBlogCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementBlogCard;
};

/** Identifies documents */
export type CosmosElementBlogCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  category?: InputMaybe<WfRefBlogCategoryWhereInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementBlogCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementBlogCardParent = CosmosConfigBlog | CosmosElementTabbedBlogCardsItem | CosmosSectionBlogCard;

export type CosmosElementBlogCardParentConnectInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogConnectInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemConnectInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardConnectInput>;
};

export type CosmosElementBlogCardParentCreateInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogCreateInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardCreateInput>;
};

export type CosmosElementBlogCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementBlogCardParent documents */
  create?: InputMaybe<Array<CosmosElementBlogCardParentCreateInput>>;
};

export type CosmosElementBlogCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementBlogCardParent document */
  create?: InputMaybe<CosmosElementBlogCardParentCreateInput>;
};

export type CosmosElementBlogCardParentCreateWithPositionInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogCreateWithPositionInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateWithPositionInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardCreateWithPositionInput>;
};

export type CosmosElementBlogCardParentUpdateInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateInput>;
};

export type CosmosElementBlogCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementBlogCardParent component instances */
  create?: InputMaybe<Array<CosmosElementBlogCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementBlogCardParent documents */
  delete?: InputMaybe<Array<CosmosElementBlogCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementBlogCardParent component instances */
  update?: InputMaybe<Array<CosmosElementBlogCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementBlogCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementBlogCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementBlogCardParentUpdateManyWithNestedWhereInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateManyWithNestedWhereInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateManyWithNestedWhereInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementBlogCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementBlogCardParent document */
  create?: InputMaybe<CosmosElementBlogCardParentCreateInput>;
  /** Delete currently connected CosmosElementBlogCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementBlogCardParent document */
  update?: InputMaybe<CosmosElementBlogCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementBlogCardParent document */
  upsert?: InputMaybe<CosmosElementBlogCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementBlogCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementBlogCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateWithNestedWhereUniqueInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementBlogCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementBlogCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpsertWithNestedWhereUniqueInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementBlogCardParentWhereInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogWhereInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardWhereInput>;
};

export type CosmosElementBlogCardParentWhereUniqueInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogWhereUniqueInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardWhereUniqueInput>;
};

export type CosmosElementBlogCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  category?: InputMaybe<WfRefBlogCategoryUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementBlogCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementBlogCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementBlogCardUpdateLocalizationInput = {
  data: CosmosElementBlogCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementBlogCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementBlogCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementBlogCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementBlogCardUpsertLocalizationInput>>;
};

export type CosmosElementBlogCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementBlogCard component instances */
  create?: InputMaybe<Array<CosmosElementBlogCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementBlogCard documents */
  delete?: InputMaybe<Array<CosmosElementBlogCardWhereUniqueInput>>;
  /** Update multiple CosmosElementBlogCard component instances */
  update?: InputMaybe<Array<CosmosElementBlogCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementBlogCard component instances */
  upsert?: InputMaybe<Array<CosmosElementBlogCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementBlogCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementBlogCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementBlogCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementBlogCardUpdateManyLocalizationInput = {
  data: CosmosElementBlogCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementBlogCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementBlogCardUpdateManyLocalizationInput>>;
};

export type CosmosElementBlogCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementBlogCardUpdateManyInput;
  /** Document search */
  where: CosmosElementBlogCardWhereInput;
};

export type CosmosElementBlogCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementBlogCard document */
  create?: InputMaybe<CosmosElementBlogCardCreateInput>;
  /** Delete currently connected CosmosElementBlogCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementBlogCard document */
  update?: InputMaybe<CosmosElementBlogCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementBlogCard document */
  upsert?: InputMaybe<CosmosElementBlogCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementBlogCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementBlogCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementBlogCardWhereUniqueInput;
};

export type CosmosElementBlogCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementBlogCardUpdateInput;
  /** Unique document search */
  where: CosmosElementBlogCardWhereUniqueInput;
};

export type CosmosElementBlogCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementBlogCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementBlogCardUpdateInput;
};

export type CosmosElementBlogCardUpsertLocalizationInput = {
  create: CosmosElementBlogCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementBlogCardUpdateLocalizationDataInput;
};

export type CosmosElementBlogCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementBlogCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementBlogCardWhereUniqueInput;
};

export type CosmosElementBlogCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementBlogCardUpsertInput;
  /** Unique document search */
  where: CosmosElementBlogCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementBlogCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  category?: InputMaybe<WfRefBlogCategoryWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementBlogCard record uniquely */
export type CosmosElementBlogCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementButton = Entity & {
  __typename?: 'CosmosElementButton';
  /** Either an absolute URL or a relative path */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementButton>;
  /** Descriptive name for analytics */
  name?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant?: Maybe<CosmosEnumButtonVariants>;
};


export type CosmosElementButtonLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementButtonUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementButtonConnection = {
  __typename?: 'CosmosElementButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementButtonCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementButtonCreateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
};

export type CosmosElementButtonCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementButtonCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementButtonCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementButtonCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementButtonCreateLocalizationInput>>;
};

export type CosmosElementButtonCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementButton documents */
  create?: InputMaybe<Array<CosmosElementButtonCreateInput>>;
};

export type CosmosElementButtonCreateOneInlineInput = {
  /** Create and connect one CosmosElementButton document */
  create?: InputMaybe<CosmosElementButtonCreateInput>;
};

export type CosmosElementButtonCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementButtonCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementButtonEdge = {
  __typename?: 'CosmosElementButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementButton;
};

export type CosmosElementButtonList = Entity & {
  __typename?: 'CosmosElementButtonList';
  buttons: Array<CosmosElementButton>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementButtonList>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementButtonListButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementButtonListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementButtonListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementButtonListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementButtonListWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementButtonListConnection = {
  __typename?: 'CosmosElementButtonListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementButtonListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementButtonListCreateInput = {
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementButtonListCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementButtonListCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementButtonListCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementButtonListCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementButtonListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementButtonListCreateLocalizationInput>>;
};

export type CosmosElementButtonListCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementButtonList documents */
  create?: InputMaybe<Array<CosmosElementButtonListCreateInput>>;
};

export type CosmosElementButtonListCreateOneInlineInput = {
  /** Create and connect one CosmosElementButtonList document */
  create?: InputMaybe<CosmosElementButtonListCreateInput>;
};

export type CosmosElementButtonListCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementButtonListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementButtonListEdge = {
  __typename?: 'CosmosElementButtonListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementButtonList;
};

/** Identifies documents */
export type CosmosElementButtonListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementButtonListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementButtonListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementButtonListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementButtonListOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementButtonListParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementButtonListParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementButtonListParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementButtonListParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementButtonListParent documents */
  connect?: InputMaybe<Array<CosmosElementButtonListParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementButtonListParent documents */
  create?: InputMaybe<Array<CosmosElementButtonListParentCreateInput>>;
};

export type CosmosElementButtonListParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementButtonListParent document */
  connect?: InputMaybe<CosmosElementButtonListParentWhereUniqueInput>;
  /** Create and connect one CosmosElementButtonListParent document */
  create?: InputMaybe<CosmosElementButtonListParentCreateInput>;
};

export type CosmosElementButtonListParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementButtonListParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementButtonListParent documents */
  connect?: InputMaybe<Array<CosmosElementButtonListParentConnectInput>>;
  /** Create and connect multiple CosmosElementButtonListParent documents */
  create?: InputMaybe<Array<CosmosElementButtonListParentCreateInput>>;
  /** Delete multiple CosmosElementButtonListParent documents */
  delete?: InputMaybe<Array<CosmosElementButtonListParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementButtonListParent documents */
  disconnect?: InputMaybe<Array<CosmosElementButtonListParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementButtonListParent documents */
  set?: InputMaybe<Array<CosmosElementButtonListParentWhereUniqueInput>>;
  /** Update multiple CosmosElementButtonListParent documents */
  update?: InputMaybe<Array<CosmosElementButtonListParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementButtonListParent documents */
  upsert?: InputMaybe<Array<CosmosElementButtonListParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementButtonListParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementButtonListParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementButtonListParent document */
  connect?: InputMaybe<CosmosElementButtonListParentWhereUniqueInput>;
  /** Create and connect one CosmosElementButtonListParent document */
  create?: InputMaybe<CosmosElementButtonListParentCreateInput>;
  /** Delete currently connected CosmosElementButtonListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementButtonListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementButtonListParent document */
  update?: InputMaybe<CosmosElementButtonListParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementButtonListParent document */
  upsert?: InputMaybe<CosmosElementButtonListParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonListParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonListParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonListParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementButtonListParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementButtonListUpdateInput = {
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementButtonListUpdateLocalizationsInput>;
};

export type CosmosElementButtonListUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementButtonListUpdateLocalizationInput = {
  data: CosmosElementButtonListUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementButtonListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementButtonListCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementButtonListUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementButtonListUpsertLocalizationInput>>;
};

export type CosmosElementButtonListUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementButtonList component instances */
  create?: InputMaybe<Array<CosmosElementButtonListCreateWithPositionInput>>;
  /** Delete multiple CosmosElementButtonList documents */
  delete?: InputMaybe<Array<CosmosElementButtonListWhereUniqueInput>>;
  /** Update multiple CosmosElementButtonList component instances */
  update?: InputMaybe<Array<CosmosElementButtonListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementButtonList component instances */
  upsert?: InputMaybe<Array<CosmosElementButtonListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementButtonListUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementButtonListUpdateManyLocalizationsInput>;
};

export type CosmosElementButtonListUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementButtonListUpdateManyLocalizationInput = {
  data: CosmosElementButtonListUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementButtonListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementButtonListUpdateManyLocalizationInput>>;
};

export type CosmosElementButtonListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementButtonListUpdateManyInput;
  /** Document search */
  where: CosmosElementButtonListWhereInput;
};

export type CosmosElementButtonListUpdateOneInlineInput = {
  /** Create and connect one CosmosElementButtonList document */
  create?: InputMaybe<CosmosElementButtonListCreateInput>;
  /** Delete currently connected CosmosElementButtonList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementButtonList document */
  update?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementButtonList document */
  upsert?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementButtonListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementButtonListWhereUniqueInput;
};

export type CosmosElementButtonListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementButtonListUpdateInput;
  /** Unique document search */
  where: CosmosElementButtonListWhereUniqueInput;
};

export type CosmosElementButtonListUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementButtonListCreateInput;
  /** Update document if it exists */
  update: CosmosElementButtonListUpdateInput;
};

export type CosmosElementButtonListUpsertLocalizationInput = {
  create: CosmosElementButtonListCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementButtonListUpdateLocalizationDataInput;
};

export type CosmosElementButtonListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementButtonListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementButtonListWhereUniqueInput;
};

export type CosmosElementButtonListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementButtonListUpsertInput;
  /** Unique document search */
  where: CosmosElementButtonListWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementButtonListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementButtonListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementButtonListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementButtonListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementButtonList record uniquely */
export type CosmosElementButtonListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CosmosElementButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
};

export enum CosmosElementButtonOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosElementButtonParent = CosmosElementAccordionTierCtaCard | CosmosElementAccordionTierFeatureCard | CosmosElementAriesCard | CosmosElementButtonList | CosmosElementComplexCtaCard | CosmosElementDownloadCard | CosmosElementGameDevFeatureCard | CosmosElementGeminiCard | CosmosElementIconSectionHeading | CosmosElementLearnDocumentationCard | CosmosElementLicenseCardCore | CosmosElementLicenseTopCard | CosmosElementSectionHeading | CosmosElementTabbedBlogCardsItem | CosmosElementTabbedContentImageItem | CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosSectionCkRichText | CosmosSectionCommunity | CosmosSectionContentLargeImage | CosmosSectionContentSliderAsset | CosmosSectionFaq | CosmosSectionFaqSearch | CosmosSectionGameDevFeatureCard | CosmosSectionLogoMultiCard | CosmosSectionRichText | ElementLearnCategory;

export type CosmosElementButtonParentConnectInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardConnectInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardConnectInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardConnectInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListConnectInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardConnectInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardConnectInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardConnectInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardConnectInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingConnectInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardConnectInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreConnectInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardConnectInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingConnectInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemConnectInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemConnectInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextConnectInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityConnectInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageConnectInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetConnectInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqConnectInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchConnectInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextConnectInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryConnectInput>;
};

export type CosmosElementButtonParentCreateInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardCreateInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListCreateInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardCreateInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingCreateInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardCreateInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreCreateInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardCreateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemCreateInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextCreateInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextCreateInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateInput>;
};

export type CosmosElementButtonParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementButtonParent documents */
  create?: InputMaybe<Array<CosmosElementButtonParentCreateInput>>;
};

export type CosmosElementButtonParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementButtonParent document */
  create?: InputMaybe<CosmosElementButtonParentCreateInput>;
};

export type CosmosElementButtonParentCreateWithPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateWithPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateWithPositionInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardCreateWithPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListCreateWithPositionInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardCreateWithPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateWithPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateWithPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateWithPositionInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingCreateWithPositionInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardCreateWithPositionInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreCreateWithPositionInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardCreateWithPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateWithPositionInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateWithPositionInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemCreateWithPositionInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextCreateWithPositionInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateWithPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateWithPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateWithPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateWithPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateWithPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateWithPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextCreateWithPositionInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateWithPositionInput>;
};

export type CosmosElementButtonParentUpdateInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpdateInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardUpdateInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpdateInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateInput>;
};

export type CosmosElementButtonParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementButtonParent component instances */
  create?: InputMaybe<Array<CosmosElementButtonParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementButtonParent documents */
  delete?: InputMaybe<Array<CosmosElementButtonParentWhereUniqueInput>>;
  /** Update multiple CosmosElementButtonParent component instances */
  update?: InputMaybe<Array<CosmosElementButtonParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementButtonParent component instances */
  upsert?: InputMaybe<Array<CosmosElementButtonParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementButtonParentUpdateManyWithNestedWhereInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateManyWithNestedWhereInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpdateManyWithNestedWhereInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateManyWithNestedWhereInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardUpdateManyWithNestedWhereInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateManyWithNestedWhereInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateManyWithNestedWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateManyWithNestedWhereInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpdateManyWithNestedWhereInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateManyWithNestedWhereInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateManyWithNestedWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateManyWithNestedWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateManyWithNestedWhereInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateManyWithNestedWhereInput>;
};

export type CosmosElementButtonParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementButtonParent document */
  create?: InputMaybe<CosmosElementButtonParentCreateInput>;
  /** Delete currently connected CosmosElementButtonParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementButtonParent document */
  update?: InputMaybe<CosmosElementButtonParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementButtonParent document */
  upsert?: InputMaybe<CosmosElementButtonParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementButtonParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpdateWithNestedWhereUniqueInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateWithNestedWhereUniqueInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementButtonParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemUpsertWithNestedWhereUniqueInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpsertWithNestedWhereUniqueInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonParentWhereInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardWhereInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardWhereInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardWhereInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListWhereInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingWhereInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardWhereInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextWhereInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextWhereInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryWhereInput>;
};

export type CosmosElementButtonParentWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardWhereUniqueInput>;
  CosmosElementAriesCard?: InputMaybe<CosmosElementAriesCardWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListWhereUniqueInput>;
  CosmosElementComplexCtaCard?: InputMaybe<CosmosElementComplexCtaCardWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereUniqueInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingWhereUniqueInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardWhereUniqueInput>;
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreWhereUniqueInput>;
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereUniqueInput>;
  CosmosElementTabbedBlogCardsItem?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereUniqueInput>;
  CosmosElementTabbedContentImageItem?: InputMaybe<CosmosElementTabbedContentImageItemWhereUniqueInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextWhereUniqueInput>;
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryWhereUniqueInput>;
};

export type CosmosElementButtonUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementButtonUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
};

export type CosmosElementButtonUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementButtonUpdateLocalizationInput = {
  data: CosmosElementButtonUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementButtonUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementButtonCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementButtonUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementButtonUpsertLocalizationInput>>;
};

export type CosmosElementButtonUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementButton component instances */
  create?: InputMaybe<Array<CosmosElementButtonCreateWithPositionInput>>;
  /** Delete multiple CosmosElementButton documents */
  delete?: InputMaybe<Array<CosmosElementButtonWhereUniqueInput>>;
  /** Update multiple CosmosElementButton component instances */
  update?: InputMaybe<Array<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementButton component instances */
  upsert?: InputMaybe<Array<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementButtonUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementButtonUpdateManyLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
};

export type CosmosElementButtonUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementButtonUpdateManyLocalizationInput = {
  data: CosmosElementButtonUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementButtonUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementButtonUpdateManyLocalizationInput>>;
};

export type CosmosElementButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementButtonUpdateManyInput;
  /** Document search */
  where: CosmosElementButtonWhereInput;
};

export type CosmosElementButtonUpdateOneInlineInput = {
  /** Create and connect one CosmosElementButton document */
  create?: InputMaybe<CosmosElementButtonCreateInput>;
  /** Delete currently connected CosmosElementButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementButton document */
  update?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementButton document */
  upsert?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementButtonUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementButtonWhereUniqueInput;
};

export type CosmosElementButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementButtonUpdateInput;
  /** Unique document search */
  where: CosmosElementButtonWhereUniqueInput;
};

export type CosmosElementButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementButtonCreateInput;
  /** Update document if it exists */
  update: CosmosElementButtonUpdateInput;
};

export type CosmosElementButtonUpsertLocalizationInput = {
  create: CosmosElementButtonCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementButtonUpdateLocalizationDataInput;
};

export type CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementButtonUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementButtonWhereUniqueInput;
};

export type CosmosElementButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementButtonUpsertInput;
  /** Unique document search */
  where: CosmosElementButtonWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
};

/** References CosmosElementButton record uniquely */
export type CosmosElementButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementCalloutCard = Entity & {
  __typename?: 'CosmosElementCalloutCard';
  buttons: Array<CosmosElementIconButton>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Optional EDS icon to show at the top of the card */
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementCalloutCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementCalloutCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosElementCalloutCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementCalloutCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementCalloutCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementCalloutCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementCalloutCardConnection = {
  __typename?: 'CosmosElementCalloutCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementCalloutCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementCalloutCardCreateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementCalloutCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCalloutCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCalloutCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementCalloutCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCalloutCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementCalloutCardCreateLocalizationInput>>;
};

export type CosmosElementCalloutCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCalloutCard documents */
  create?: InputMaybe<Array<CosmosElementCalloutCardCreateInput>>;
};

export type CosmosElementCalloutCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementCalloutCard document */
  create?: InputMaybe<CosmosElementCalloutCardCreateInput>;
};

export type CosmosElementCalloutCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementCalloutCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementCalloutCardEdge = {
  __typename?: 'CosmosElementCalloutCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementCalloutCard;
};

/** Identifies documents */
export type CosmosElementCalloutCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCalloutCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCalloutCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCalloutCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementCalloutCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementCalloutCardParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementCalloutCardParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementCalloutCardParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementCalloutCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementCalloutCardParent documents */
  connect?: InputMaybe<Array<CosmosElementCalloutCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementCalloutCardParent documents */
  create?: InputMaybe<Array<CosmosElementCalloutCardParentCreateInput>>;
};

export type CosmosElementCalloutCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementCalloutCardParent document */
  connect?: InputMaybe<CosmosElementCalloutCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCalloutCardParent document */
  create?: InputMaybe<CosmosElementCalloutCardParentCreateInput>;
};

export type CosmosElementCalloutCardParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementCalloutCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementCalloutCardParent documents */
  connect?: InputMaybe<Array<CosmosElementCalloutCardParentConnectInput>>;
  /** Create and connect multiple CosmosElementCalloutCardParent documents */
  create?: InputMaybe<Array<CosmosElementCalloutCardParentCreateInput>>;
  /** Delete multiple CosmosElementCalloutCardParent documents */
  delete?: InputMaybe<Array<CosmosElementCalloutCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementCalloutCardParent documents */
  disconnect?: InputMaybe<Array<CosmosElementCalloutCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementCalloutCardParent documents */
  set?: InputMaybe<Array<CosmosElementCalloutCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementCalloutCardParent documents */
  update?: InputMaybe<Array<CosmosElementCalloutCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementCalloutCardParent documents */
  upsert?: InputMaybe<Array<CosmosElementCalloutCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementCalloutCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementCalloutCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementCalloutCardParent document */
  connect?: InputMaybe<CosmosElementCalloutCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCalloutCardParent document */
  create?: InputMaybe<CosmosElementCalloutCardParentCreateInput>;
  /** Delete currently connected CosmosElementCalloutCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementCalloutCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCalloutCardParent document */
  update?: InputMaybe<CosmosElementCalloutCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCalloutCardParent document */
  upsert?: InputMaybe<CosmosElementCalloutCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCalloutCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementCalloutCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCalloutCardParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementCalloutCardParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementCalloutCardUpdateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementCalloutCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementCalloutCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementCalloutCardUpdateLocalizationInput = {
  data: CosmosElementCalloutCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCalloutCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementCalloutCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCalloutCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementCalloutCardUpsertLocalizationInput>>;
};

export type CosmosElementCalloutCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCalloutCard component instances */
  create?: InputMaybe<Array<CosmosElementCalloutCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCalloutCard documents */
  delete?: InputMaybe<Array<CosmosElementCalloutCardWhereUniqueInput>>;
  /** Update multiple CosmosElementCalloutCard component instances */
  update?: InputMaybe<Array<CosmosElementCalloutCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCalloutCard component instances */
  upsert?: InputMaybe<Array<CosmosElementCalloutCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCalloutCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementCalloutCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementCalloutCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementCalloutCardUpdateManyLocalizationInput = {
  data: CosmosElementCalloutCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCalloutCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCalloutCardUpdateManyLocalizationInput>>;
};

export type CosmosElementCalloutCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementCalloutCardUpdateManyInput;
  /** Document search */
  where: CosmosElementCalloutCardWhereInput;
};

export type CosmosElementCalloutCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCalloutCard document */
  create?: InputMaybe<CosmosElementCalloutCardCreateInput>;
  /** Delete currently connected CosmosElementCalloutCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCalloutCard document */
  update?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCalloutCard document */
  upsert?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCalloutCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementCalloutCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCalloutCardWhereUniqueInput;
};

export type CosmosElementCalloutCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementCalloutCardUpdateInput;
  /** Unique document search */
  where: CosmosElementCalloutCardWhereUniqueInput;
};

export type CosmosElementCalloutCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementCalloutCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementCalloutCardUpdateInput;
};

export type CosmosElementCalloutCardUpsertLocalizationInput = {
  create: CosmosElementCalloutCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementCalloutCardUpdateLocalizationDataInput;
};

export type CosmosElementCalloutCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementCalloutCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCalloutCardWhereUniqueInput;
};

export type CosmosElementCalloutCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementCalloutCardUpsertInput;
  /** Unique document search */
  where: CosmosElementCalloutCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementCalloutCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCalloutCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCalloutCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCalloutCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementCalloutCard record uniquely */
export type CosmosElementCalloutCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementCheckListItem = Entity & {
  __typename?: 'CosmosElementCheckListItem';
  icon?: Maybe<CosmosEnumCheckListIcons>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementCheckListItem>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementCheckListItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementCheckListItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementCheckListItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementCheckListItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementCheckListItemConnection = {
  __typename?: 'CosmosElementCheckListItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementCheckListItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementCheckListItemCreateInput = {
  icon?: InputMaybe<CosmosEnumCheckListIcons>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementCheckListItemCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCheckListItemCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCheckListItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementCheckListItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCheckListItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementCheckListItemCreateLocalizationInput>>;
};

export type CosmosElementCheckListItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCheckListItem documents */
  create?: InputMaybe<Array<CosmosElementCheckListItemCreateInput>>;
};

export type CosmosElementCheckListItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementCheckListItem document */
  create?: InputMaybe<CosmosElementCheckListItemCreateInput>;
};

export type CosmosElementCheckListItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementCheckListItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementCheckListItemEdge = {
  __typename?: 'CosmosElementCheckListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementCheckListItem;
};

/** Identifies documents */
export type CosmosElementCheckListItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCheckListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCheckListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCheckListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumCheckListIcons>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<CosmosEnumCheckListIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<CosmosEnumCheckListIcons>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumCheckListIcons>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementCheckListItemOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementCheckListItemParent = CosmosElementLicenseTopCard;

export type CosmosElementCheckListItemParentConnectInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardConnectInput>;
};

export type CosmosElementCheckListItemParentCreateInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardCreateInput>;
};

export type CosmosElementCheckListItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCheckListItemParent documents */
  create?: InputMaybe<Array<CosmosElementCheckListItemParentCreateInput>>;
};

export type CosmosElementCheckListItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementCheckListItemParent document */
  create?: InputMaybe<CosmosElementCheckListItemParentCreateInput>;
};

export type CosmosElementCheckListItemParentCreateWithPositionInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardCreateWithPositionInput>;
};

export type CosmosElementCheckListItemParentUpdateInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateInput>;
};

export type CosmosElementCheckListItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCheckListItemParent component instances */
  create?: InputMaybe<Array<CosmosElementCheckListItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCheckListItemParent documents */
  delete?: InputMaybe<Array<CosmosElementCheckListItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementCheckListItemParent component instances */
  update?: InputMaybe<Array<CosmosElementCheckListItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCheckListItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementCheckListItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCheckListItemParentUpdateManyWithNestedWhereInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementCheckListItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCheckListItemParent document */
  create?: InputMaybe<CosmosElementCheckListItemParentCreateInput>;
  /** Delete currently connected CosmosElementCheckListItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCheckListItemParent document */
  update?: InputMaybe<CosmosElementCheckListItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCheckListItemParent document */
  upsert?: InputMaybe<CosmosElementCheckListItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCheckListItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementCheckListItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementCheckListItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementCheckListItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCheckListItemParentWhereInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardWhereInput>;
};

export type CosmosElementCheckListItemParentWhereUniqueInput = {
  CosmosElementLicenseTopCard?: InputMaybe<CosmosElementLicenseTopCardWhereUniqueInput>;
};

export type CosmosElementCheckListItemUpdateInput = {
  icon?: InputMaybe<CosmosEnumCheckListIcons>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementCheckListItemUpdateLocalizationsInput>;
};

export type CosmosElementCheckListItemUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCheckListItemUpdateLocalizationInput = {
  data: CosmosElementCheckListItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCheckListItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementCheckListItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCheckListItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementCheckListItemUpsertLocalizationInput>>;
};

export type CosmosElementCheckListItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCheckListItem component instances */
  create?: InputMaybe<Array<CosmosElementCheckListItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCheckListItem documents */
  delete?: InputMaybe<Array<CosmosElementCheckListItemWhereUniqueInput>>;
  /** Update multiple CosmosElementCheckListItem component instances */
  update?: InputMaybe<Array<CosmosElementCheckListItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCheckListItem component instances */
  upsert?: InputMaybe<Array<CosmosElementCheckListItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCheckListItemUpdateManyInput = {
  icon?: InputMaybe<CosmosEnumCheckListIcons>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementCheckListItemUpdateManyLocalizationsInput>;
};

export type CosmosElementCheckListItemUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCheckListItemUpdateManyLocalizationInput = {
  data: CosmosElementCheckListItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCheckListItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCheckListItemUpdateManyLocalizationInput>>;
};

export type CosmosElementCheckListItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementCheckListItemUpdateManyInput;
  /** Document search */
  where: CosmosElementCheckListItemWhereInput;
};

export type CosmosElementCheckListItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCheckListItem document */
  create?: InputMaybe<CosmosElementCheckListItemCreateInput>;
  /** Delete currently connected CosmosElementCheckListItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCheckListItem document */
  update?: InputMaybe<CosmosElementCheckListItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCheckListItem document */
  upsert?: InputMaybe<CosmosElementCheckListItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCheckListItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementCheckListItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCheckListItemWhereUniqueInput;
};

export type CosmosElementCheckListItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementCheckListItemUpdateInput;
  /** Unique document search */
  where: CosmosElementCheckListItemWhereUniqueInput;
};

export type CosmosElementCheckListItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementCheckListItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementCheckListItemUpdateInput;
};

export type CosmosElementCheckListItemUpsertLocalizationInput = {
  create: CosmosElementCheckListItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementCheckListItemUpdateLocalizationDataInput;
};

export type CosmosElementCheckListItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementCheckListItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCheckListItemWhereUniqueInput;
};

export type CosmosElementCheckListItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementCheckListItemUpsertInput;
  /** Unique document search */
  where: CosmosElementCheckListItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementCheckListItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCheckListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCheckListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCheckListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumCheckListIcons>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<CosmosEnumCheckListIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<CosmosEnumCheckListIcons>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumCheckListIcons>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementCheckListItem record uniquely */
export type CosmosElementCheckListItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementCkEditorText = Entity & {
  __typename?: 'CosmosElementCkEditorText';
  ckText?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementCkEditorText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementCkEditorTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementCkEditorTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementCkEditorTextCollapsible = Entity & {
  __typename?: 'CosmosElementCkEditorTextCollapsible';
  ckText?: Maybe<Scalars['String']['output']>;
  collapseButtonLabel?: Maybe<Scalars['String']['output']>;
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementCkEditorTextCollapsible>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementCkEditorTextCollapsibleLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementCkEditorTextCollapsibleUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementCkEditorTextCollapsibleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementCkEditorTextCollapsibleWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementCkEditorTextCollapsibleConnection = {
  __typename?: 'CosmosElementCkEditorTextCollapsibleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementCkEditorTextCollapsibleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementCkEditorTextCollapsibleCreateInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** collapseButtonLabel input for default locale (en) */
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementCkEditorTextCollapsibleCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCkEditorTextCollapsibleCreateLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCkEditorTextCollapsibleCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementCkEditorTextCollapsibleCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCkEditorTextCollapsibleCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleCreateLocalizationInput>>;
};

export type CosmosElementCkEditorTextCollapsibleCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCkEditorTextCollapsible documents */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleCreateInput>>;
};

export type CosmosElementCkEditorTextCollapsibleCreateOneInlineInput = {
  /** Create and connect one CosmosElementCkEditorTextCollapsible document */
  create?: InputMaybe<CosmosElementCkEditorTextCollapsibleCreateInput>;
};

export type CosmosElementCkEditorTextCollapsibleCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementCkEditorTextCollapsibleCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementCkEditorTextCollapsibleEdge = {
  __typename?: 'CosmosElementCkEditorTextCollapsibleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementCkEditorTextCollapsible;
};

/** Identifies documents */
export type CosmosElementCkEditorTextCollapsibleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementCkEditorTextCollapsibleOrderByInput {
  CkTextAsc = 'ckText_ASC',
  CkTextDesc = 'ckText_DESC',
  CollapseButtonLabelAsc = 'collapseButtonLabel_ASC',
  CollapseButtonLabelDesc = 'collapseButtonLabel_DESC',
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementCkEditorTextCollapsibleParent = CosmosPageLegalContent;

export type CosmosElementCkEditorTextCollapsibleParentConnectInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentCreateInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementCkEditorTextCollapsibleParent documents */
  connect?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementCkEditorTextCollapsibleParent documents */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentCreateInput>>;
};

export type CosmosElementCkEditorTextCollapsibleParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementCkEditorTextCollapsibleParent document */
  connect?: InputMaybe<CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCkEditorTextCollapsibleParent document */
  create?: InputMaybe<CosmosElementCkEditorTextCollapsibleParentCreateInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentUpdateInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementCkEditorTextCollapsibleParent documents */
  connect?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentConnectInput>>;
  /** Create and connect multiple CosmosElementCkEditorTextCollapsibleParent documents */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentCreateInput>>;
  /** Delete multiple CosmosElementCkEditorTextCollapsibleParent documents */
  delete?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementCkEditorTextCollapsibleParent documents */
  disconnect?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementCkEditorTextCollapsibleParent documents */
  set?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput>>;
  /** Update multiple CosmosElementCkEditorTextCollapsibleParent documents */
  update?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementCkEditorTextCollapsibleParent documents */
  upsert?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementCkEditorTextCollapsibleParentUpdateManyWithNestedWhereInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementCkEditorTextCollapsibleParent document */
  connect?: InputMaybe<CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCkEditorTextCollapsibleParent document */
  create?: InputMaybe<CosmosElementCkEditorTextCollapsibleParentCreateInput>;
  /** Delete currently connected CosmosElementCkEditorTextCollapsibleParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementCkEditorTextCollapsibleParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCkEditorTextCollapsibleParent document */
  update?: InputMaybe<CosmosElementCkEditorTextCollapsibleParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCkEditorTextCollapsibleParent document */
  upsert?: InputMaybe<CosmosElementCkEditorTextCollapsibleParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentWhereInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
};

export type CosmosElementCkEditorTextCollapsibleParentWhereUniqueInput = {
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** collapseButtonLabel input for default locale (en) */
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateLocalizationsInput>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateLocalizationInput = {
  data: CosmosElementCkEditorTextCollapsibleUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCkEditorTextCollapsibleUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleUpsertLocalizationInput>>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCkEditorTextCollapsible component instances */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCkEditorTextCollapsible documents */
  delete?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereUniqueInput>>;
  /** Update multiple CosmosElementCkEditorTextCollapsible component instances */
  update?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCkEditorTextCollapsible component instances */
  upsert?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateManyInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** collapseButtonLabel input for default locale (en) */
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateManyLocalizationsInput>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateManyLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateManyLocalizationInput = {
  data: CosmosElementCkEditorTextCollapsibleUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCkEditorTextCollapsibleUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleUpdateManyLocalizationInput>>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementCkEditorTextCollapsibleUpdateManyInput;
  /** Document search */
  where: CosmosElementCkEditorTextCollapsibleWhereInput;
};

export type CosmosElementCkEditorTextCollapsibleUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCkEditorTextCollapsible document */
  create?: InputMaybe<CosmosElementCkEditorTextCollapsibleCreateInput>;
  /** Delete currently connected CosmosElementCkEditorTextCollapsible document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCkEditorTextCollapsible document */
  update?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCkEditorTextCollapsible document */
  upsert?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextCollapsibleUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCkEditorTextCollapsibleWhereUniqueInput;
};

export type CosmosElementCkEditorTextCollapsibleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementCkEditorTextCollapsibleUpdateInput;
  /** Unique document search */
  where: CosmosElementCkEditorTextCollapsibleWhereUniqueInput;
};

export type CosmosElementCkEditorTextCollapsibleUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementCkEditorTextCollapsibleCreateInput;
  /** Update document if it exists */
  update: CosmosElementCkEditorTextCollapsibleUpdateInput;
};

export type CosmosElementCkEditorTextCollapsibleUpsertLocalizationInput = {
  create: CosmosElementCkEditorTextCollapsibleCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementCkEditorTextCollapsibleUpdateLocalizationDataInput;
};

export type CosmosElementCkEditorTextCollapsibleUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCkEditorTextCollapsibleWhereUniqueInput;
};

export type CosmosElementCkEditorTextCollapsibleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementCkEditorTextCollapsibleUpsertInput;
  /** Unique document search */
  where: CosmosElementCkEditorTextCollapsibleWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementCkEditorTextCollapsibleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCkEditorTextCollapsibleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ckText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ckText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ckText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ckText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ckText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ckText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ckText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ckText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ckText_starts_with?: InputMaybe<Scalars['String']['input']>;
  collapseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  collapseButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  collapseButtonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  collapseButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  collapseButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  collapseButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  collapseButtonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  collapseButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  collapseButtonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  collapseButtonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementCkEditorTextCollapsible record uniquely */
export type CosmosElementCkEditorTextCollapsibleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementCkEditorTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementCkEditorTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementCkEditorTextConnection = {
  __typename?: 'CosmosElementCkEditorTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementCkEditorTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementCkEditorTextCreateInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementCkEditorTextCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCkEditorTextCreateLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCkEditorTextCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementCkEditorTextCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCkEditorTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCreateLocalizationInput>>;
};

export type CosmosElementCkEditorTextCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCkEditorText documents */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCreateInput>>;
};

export type CosmosElementCkEditorTextCreateOneInlineInput = {
  /** Create and connect one CosmosElementCkEditorText document */
  create?: InputMaybe<CosmosElementCkEditorTextCreateInput>;
};

export type CosmosElementCkEditorTextCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementCkEditorTextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementCkEditorTextEdge = {
  __typename?: 'CosmosElementCkEditorTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementCkEditorText;
};

/** Identifies documents */
export type CosmosElementCkEditorTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCkEditorTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCkEditorTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCkEditorTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementCkEditorTextOrderByInput {
  CkTextAsc = 'ckText_ASC',
  CkTextDesc = 'ckText_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementCkEditorTextParent = CosmosPageBlogDetail | CosmosPageLegalContent | CosmosPagePluginDetail;

export type CosmosElementCkEditorTextParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementCkEditorTextParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementCkEditorTextParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementCkEditorTextParent documents */
  connect?: InputMaybe<Array<CosmosElementCkEditorTextParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementCkEditorTextParent documents */
  create?: InputMaybe<Array<CosmosElementCkEditorTextParentCreateInput>>;
};

export type CosmosElementCkEditorTextParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementCkEditorTextParent document */
  connect?: InputMaybe<CosmosElementCkEditorTextParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCkEditorTextParent document */
  create?: InputMaybe<CosmosElementCkEditorTextParentCreateInput>;
};

export type CosmosElementCkEditorTextParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementCkEditorTextParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementCkEditorTextParent documents */
  connect?: InputMaybe<Array<CosmosElementCkEditorTextParentConnectInput>>;
  /** Create and connect multiple CosmosElementCkEditorTextParent documents */
  create?: InputMaybe<Array<CosmosElementCkEditorTextParentCreateInput>>;
  /** Delete multiple CosmosElementCkEditorTextParent documents */
  delete?: InputMaybe<Array<CosmosElementCkEditorTextParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementCkEditorTextParent documents */
  disconnect?: InputMaybe<Array<CosmosElementCkEditorTextParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementCkEditorTextParent documents */
  set?: InputMaybe<Array<CosmosElementCkEditorTextParentWhereUniqueInput>>;
  /** Update multiple CosmosElementCkEditorTextParent documents */
  update?: InputMaybe<Array<CosmosElementCkEditorTextParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementCkEditorTextParent documents */
  upsert?: InputMaybe<Array<CosmosElementCkEditorTextParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementCkEditorTextParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementCkEditorTextParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementCkEditorTextParent document */
  connect?: InputMaybe<CosmosElementCkEditorTextParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCkEditorTextParent document */
  create?: InputMaybe<CosmosElementCkEditorTextParentCreateInput>;
  /** Delete currently connected CosmosElementCkEditorTextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementCkEditorTextParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCkEditorTextParent document */
  update?: InputMaybe<CosmosElementCkEditorTextParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCkEditorTextParent document */
  upsert?: InputMaybe<CosmosElementCkEditorTextParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementCkEditorTextParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementCkEditorTextUpdateInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementCkEditorTextUpdateLocalizationsInput>;
};

export type CosmosElementCkEditorTextUpdateLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCkEditorTextUpdateLocalizationInput = {
  data: CosmosElementCkEditorTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCkEditorTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCkEditorTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementCkEditorTextUpsertLocalizationInput>>;
};

export type CosmosElementCkEditorTextUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCkEditorText component instances */
  create?: InputMaybe<Array<CosmosElementCkEditorTextCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCkEditorText documents */
  delete?: InputMaybe<Array<CosmosElementCkEditorTextWhereUniqueInput>>;
  /** Update multiple CosmosElementCkEditorText component instances */
  update?: InputMaybe<Array<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCkEditorText component instances */
  upsert?: InputMaybe<Array<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCkEditorTextUpdateManyInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementCkEditorTextUpdateManyLocalizationsInput>;
};

export type CosmosElementCkEditorTextUpdateManyLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCkEditorTextUpdateManyLocalizationInput = {
  data: CosmosElementCkEditorTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCkEditorTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCkEditorTextUpdateManyLocalizationInput>>;
};

export type CosmosElementCkEditorTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementCkEditorTextUpdateManyInput;
  /** Document search */
  where: CosmosElementCkEditorTextWhereInput;
};

export type CosmosElementCkEditorTextUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCkEditorText document */
  create?: InputMaybe<CosmosElementCkEditorTextCreateInput>;
  /** Delete currently connected CosmosElementCkEditorText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCkEditorText document */
  update?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCkEditorText document */
  upsert?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCkEditorTextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementCkEditorTextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCkEditorTextWhereUniqueInput;
};

export type CosmosElementCkEditorTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementCkEditorTextUpdateInput;
  /** Unique document search */
  where: CosmosElementCkEditorTextWhereUniqueInput;
};

export type CosmosElementCkEditorTextUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementCkEditorTextCreateInput;
  /** Update document if it exists */
  update: CosmosElementCkEditorTextUpdateInput;
};

export type CosmosElementCkEditorTextUpsertLocalizationInput = {
  create: CosmosElementCkEditorTextCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementCkEditorTextUpdateLocalizationDataInput;
};

export type CosmosElementCkEditorTextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementCkEditorTextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCkEditorTextWhereUniqueInput;
};

export type CosmosElementCkEditorTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementCkEditorTextUpsertInput;
  /** Unique document search */
  where: CosmosElementCkEditorTextWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementCkEditorTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCkEditorTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCkEditorTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCkEditorTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ckText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ckText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ckText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ckText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ckText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ckText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ckText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ckText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ckText_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementCkEditorText record uniquely */
export type CosmosElementCkEditorTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementCompare = Entity & {
  __typename?: 'CosmosElementCompare';
  attribution?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  leftImage?: Maybe<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementCompare>;
  rightImage?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementCompareLeftImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementCompareLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementCompareRightImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementCompareUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementCompareConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementCompareWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementCompareConnection = {
  __typename?: 'CosmosElementCompareConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementCompareEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementCompareCreateInput = {
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  leftImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementCompareCreateLocalizationsInput>;
  rightImage?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCompareCreateLocalizationDataInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCompareCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementCompareCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCompareCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementCompareCreateLocalizationInput>>;
};

export type CosmosElementCompareCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCompare documents */
  create?: InputMaybe<Array<CosmosElementCompareCreateInput>>;
};

export type CosmosElementCompareCreateOneInlineInput = {
  /** Create and connect one CosmosElementCompare document */
  create?: InputMaybe<CosmosElementCompareCreateInput>;
};

export type CosmosElementCompareCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementCompareCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementCompareEdge = {
  __typename?: 'CosmosElementCompareEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementCompare;
};

/** Identifies documents */
export type CosmosElementCompareManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCompareWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCompareWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCompareWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  leftImage?: InputMaybe<AssetWhereInput>;
  rightImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementCompareOrderByInput {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementCompareParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementCompareParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementCompareParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementCompareParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementCompareParent documents */
  connect?: InputMaybe<Array<CosmosElementCompareParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementCompareParent documents */
  create?: InputMaybe<Array<CosmosElementCompareParentCreateInput>>;
};

export type CosmosElementCompareParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementCompareParent document */
  connect?: InputMaybe<CosmosElementCompareParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCompareParent document */
  create?: InputMaybe<CosmosElementCompareParentCreateInput>;
};

export type CosmosElementCompareParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementCompareParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementCompareParent documents */
  connect?: InputMaybe<Array<CosmosElementCompareParentConnectInput>>;
  /** Create and connect multiple CosmosElementCompareParent documents */
  create?: InputMaybe<Array<CosmosElementCompareParentCreateInput>>;
  /** Delete multiple CosmosElementCompareParent documents */
  delete?: InputMaybe<Array<CosmosElementCompareParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementCompareParent documents */
  disconnect?: InputMaybe<Array<CosmosElementCompareParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementCompareParent documents */
  set?: InputMaybe<Array<CosmosElementCompareParentWhereUniqueInput>>;
  /** Update multiple CosmosElementCompareParent documents */
  update?: InputMaybe<Array<CosmosElementCompareParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementCompareParent documents */
  upsert?: InputMaybe<Array<CosmosElementCompareParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementCompareParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementCompareParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementCompareParent document */
  connect?: InputMaybe<CosmosElementCompareParentWhereUniqueInput>;
  /** Create and connect one CosmosElementCompareParent document */
  create?: InputMaybe<CosmosElementCompareParentCreateInput>;
  /** Delete currently connected CosmosElementCompareParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementCompareParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCompareParent document */
  update?: InputMaybe<CosmosElementCompareParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCompareParent document */
  upsert?: InputMaybe<CosmosElementCompareParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCompareParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementCompareParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCompareParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementCompareParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementCompareUpdateInput = {
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  leftImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementCompareUpdateLocalizationsInput>;
  rightImage?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type CosmosElementCompareUpdateLocalizationDataInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCompareUpdateLocalizationInput = {
  data: CosmosElementCompareUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCompareUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementCompareCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCompareUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementCompareUpsertLocalizationInput>>;
};

export type CosmosElementCompareUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCompare component instances */
  create?: InputMaybe<Array<CosmosElementCompareCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCompare documents */
  delete?: InputMaybe<Array<CosmosElementCompareWhereUniqueInput>>;
  /** Update multiple CosmosElementCompare component instances */
  update?: InputMaybe<Array<CosmosElementCompareUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCompare component instances */
  upsert?: InputMaybe<Array<CosmosElementCompareUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCompareUpdateManyInput = {
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementCompareUpdateManyLocalizationsInput>;
};

export type CosmosElementCompareUpdateManyLocalizationDataInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCompareUpdateManyLocalizationInput = {
  data: CosmosElementCompareUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCompareUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCompareUpdateManyLocalizationInput>>;
};

export type CosmosElementCompareUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementCompareUpdateManyInput;
  /** Document search */
  where: CosmosElementCompareWhereInput;
};

export type CosmosElementCompareUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCompare document */
  create?: InputMaybe<CosmosElementCompareCreateInput>;
  /** Delete currently connected CosmosElementCompare document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCompare document */
  update?: InputMaybe<CosmosElementCompareUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCompare document */
  upsert?: InputMaybe<CosmosElementCompareUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCompareUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementCompareUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCompareWhereUniqueInput;
};

export type CosmosElementCompareUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementCompareUpdateInput;
  /** Unique document search */
  where: CosmosElementCompareWhereUniqueInput;
};

export type CosmosElementCompareUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementCompareCreateInput;
  /** Update document if it exists */
  update: CosmosElementCompareUpdateInput;
};

export type CosmosElementCompareUpsertLocalizationInput = {
  create: CosmosElementCompareCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementCompareUpdateLocalizationDataInput;
};

export type CosmosElementCompareUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementCompareUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCompareWhereUniqueInput;
};

export type CosmosElementCompareUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementCompareUpsertInput;
  /** Unique document search */
  where: CosmosElementCompareWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementCompareWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCompareWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCompareWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCompareWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  attribution_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  attribution_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  attribution_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  attribution_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  attribution_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  attribution_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  attribution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  attribution_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  attribution_starts_with?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  leftImage?: InputMaybe<AssetWhereInput>;
  rightImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementCompare record uniquely */
export type CosmosElementCompareWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementComplexCtaCard = Entity & {
  __typename?: 'CosmosElementComplexCtaCard';
  button?: Maybe<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementComplexCtaCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementComplexCtaCardButtonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementComplexCtaCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementComplexCtaCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementComplexCtaCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementComplexCtaCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementComplexCtaCardConnection = {
  __typename?: 'CosmosElementComplexCtaCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementComplexCtaCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementComplexCtaCardCreateInput = {
  button?: InputMaybe<CosmosElementButtonCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementComplexCtaCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementComplexCtaCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementComplexCtaCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementComplexCtaCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementComplexCtaCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementComplexCtaCardCreateLocalizationInput>>;
};

export type CosmosElementComplexCtaCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementComplexCtaCard documents */
  create?: InputMaybe<Array<CosmosElementComplexCtaCardCreateInput>>;
};

export type CosmosElementComplexCtaCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementComplexCtaCard document */
  create?: InputMaybe<CosmosElementComplexCtaCardCreateInput>;
};

export type CosmosElementComplexCtaCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementComplexCtaCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementComplexCtaCardEdge = {
  __typename?: 'CosmosElementComplexCtaCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementComplexCtaCard;
};

/** Identifies documents */
export type CosmosElementComplexCtaCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementComplexCtaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementComplexCtaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementComplexCtaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<CosmosElementButtonWhereInput>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementComplexCtaCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementComplexCtaCardParent = CosmosSectionComplexCtaCard;

export type CosmosElementComplexCtaCardParentConnectInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardConnectInput>;
};

export type CosmosElementComplexCtaCardParentCreateInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardCreateInput>;
};

export type CosmosElementComplexCtaCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementComplexCtaCardParent documents */
  create?: InputMaybe<Array<CosmosElementComplexCtaCardParentCreateInput>>;
};

export type CosmosElementComplexCtaCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementComplexCtaCardParent document */
  create?: InputMaybe<CosmosElementComplexCtaCardParentCreateInput>;
};

export type CosmosElementComplexCtaCardParentCreateWithPositionInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardCreateWithPositionInput>;
};

export type CosmosElementComplexCtaCardParentUpdateInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateInput>;
};

export type CosmosElementComplexCtaCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementComplexCtaCardParent component instances */
  create?: InputMaybe<Array<CosmosElementComplexCtaCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementComplexCtaCardParent documents */
  delete?: InputMaybe<Array<CosmosElementComplexCtaCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementComplexCtaCardParent component instances */
  update?: InputMaybe<Array<CosmosElementComplexCtaCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementComplexCtaCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementComplexCtaCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementComplexCtaCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementComplexCtaCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementComplexCtaCardParent document */
  create?: InputMaybe<CosmosElementComplexCtaCardParentCreateInput>;
  /** Delete currently connected CosmosElementComplexCtaCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementComplexCtaCardParent document */
  update?: InputMaybe<CosmosElementComplexCtaCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementComplexCtaCardParent document */
  upsert?: InputMaybe<CosmosElementComplexCtaCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementComplexCtaCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementComplexCtaCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementComplexCtaCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementComplexCtaCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementComplexCtaCardParentWhereInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardWhereInput>;
};

export type CosmosElementComplexCtaCardParentWhereUniqueInput = {
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardWhereUniqueInput>;
};

export type CosmosElementComplexCtaCardUpdateInput = {
  button?: InputMaybe<CosmosElementButtonUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementComplexCtaCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementComplexCtaCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementComplexCtaCardUpdateLocalizationInput = {
  data: CosmosElementComplexCtaCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementComplexCtaCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementComplexCtaCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementComplexCtaCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementComplexCtaCardUpsertLocalizationInput>>;
};

export type CosmosElementComplexCtaCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementComplexCtaCard component instances */
  create?: InputMaybe<Array<CosmosElementComplexCtaCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementComplexCtaCard documents */
  delete?: InputMaybe<Array<CosmosElementComplexCtaCardWhereUniqueInput>>;
  /** Update multiple CosmosElementComplexCtaCard component instances */
  update?: InputMaybe<Array<CosmosElementComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementComplexCtaCard component instances */
  upsert?: InputMaybe<Array<CosmosElementComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementComplexCtaCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementComplexCtaCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementComplexCtaCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementComplexCtaCardUpdateManyLocalizationInput = {
  data: CosmosElementComplexCtaCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementComplexCtaCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementComplexCtaCardUpdateManyLocalizationInput>>;
};

export type CosmosElementComplexCtaCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementComplexCtaCardUpdateManyInput;
  /** Document search */
  where: CosmosElementComplexCtaCardWhereInput;
};

export type CosmosElementComplexCtaCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementComplexCtaCard document */
  create?: InputMaybe<CosmosElementComplexCtaCardCreateInput>;
  /** Delete currently connected CosmosElementComplexCtaCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementComplexCtaCard document */
  update?: InputMaybe<CosmosElementComplexCtaCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementComplexCtaCard document */
  upsert?: InputMaybe<CosmosElementComplexCtaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementComplexCtaCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementComplexCtaCardWhereUniqueInput;
};

export type CosmosElementComplexCtaCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementComplexCtaCardUpdateInput;
  /** Unique document search */
  where: CosmosElementComplexCtaCardWhereUniqueInput;
};

export type CosmosElementComplexCtaCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementComplexCtaCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementComplexCtaCardUpdateInput;
};

export type CosmosElementComplexCtaCardUpsertLocalizationInput = {
  create: CosmosElementComplexCtaCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementComplexCtaCardUpdateLocalizationDataInput;
};

export type CosmosElementComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementComplexCtaCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementComplexCtaCardWhereUniqueInput;
};

export type CosmosElementComplexCtaCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementComplexCtaCardUpsertInput;
  /** Unique document search */
  where: CosmosElementComplexCtaCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementComplexCtaCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementComplexCtaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementComplexCtaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementComplexCtaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementComplexCtaCard record uniquely */
export type CosmosElementComplexCtaCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementCruxLink = Entity & {
  __typename?: 'CosmosElementCruxLink';
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementCruxLink>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementCruxLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementCruxLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementCruxLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementCruxLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementCruxLinkConnection = {
  __typename?: 'CosmosElementCruxLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementCruxLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementCruxLinkCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementCruxLinkCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCruxLinkCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementCruxLinkCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementCruxLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCruxLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementCruxLinkCreateLocalizationInput>>;
};

export type CosmosElementCruxLinkCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCruxLink documents */
  create?: InputMaybe<Array<CosmosElementCruxLinkCreateInput>>;
};

export type CosmosElementCruxLinkCreateOneInlineInput = {
  /** Create and connect one CosmosElementCruxLink document */
  create?: InputMaybe<CosmosElementCruxLinkCreateInput>;
};

export type CosmosElementCruxLinkCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementCruxLinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementCruxLinkEdge = {
  __typename?: 'CosmosElementCruxLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementCruxLink;
};

/** Identifies documents */
export type CosmosElementCruxLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCruxLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCruxLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCruxLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementCruxLinkOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementCruxLinkParent = CosmosSectionCrux;

export type CosmosElementCruxLinkParentConnectInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxConnectInput>;
};

export type CosmosElementCruxLinkParentCreateInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateInput>;
};

export type CosmosElementCruxLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementCruxLinkParent documents */
  create?: InputMaybe<Array<CosmosElementCruxLinkParentCreateInput>>;
};

export type CosmosElementCruxLinkParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementCruxLinkParent document */
  create?: InputMaybe<CosmosElementCruxLinkParentCreateInput>;
};

export type CosmosElementCruxLinkParentCreateWithPositionInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateWithPositionInput>;
};

export type CosmosElementCruxLinkParentUpdateInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateInput>;
};

export type CosmosElementCruxLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCruxLinkParent component instances */
  create?: InputMaybe<Array<CosmosElementCruxLinkParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCruxLinkParent documents */
  delete?: InputMaybe<Array<CosmosElementCruxLinkParentWhereUniqueInput>>;
  /** Update multiple CosmosElementCruxLinkParent component instances */
  update?: InputMaybe<Array<CosmosElementCruxLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCruxLinkParent component instances */
  upsert?: InputMaybe<Array<CosmosElementCruxLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCruxLinkParentUpdateManyWithNestedWhereInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateManyWithNestedWhereInput>;
};

export type CosmosElementCruxLinkParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCruxLinkParent document */
  create?: InputMaybe<CosmosElementCruxLinkParentCreateInput>;
  /** Delete currently connected CosmosElementCruxLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCruxLinkParent document */
  update?: InputMaybe<CosmosElementCruxLinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCruxLinkParent document */
  upsert?: InputMaybe<CosmosElementCruxLinkParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCruxLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementCruxLinkParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementCruxLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementCruxLinkParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCruxLinkParentWhereInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereInput>;
};

export type CosmosElementCruxLinkParentWhereUniqueInput = {
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereUniqueInput>;
};

export type CosmosElementCruxLinkUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementCruxLinkUpdateLocalizationsInput>;
};

export type CosmosElementCruxLinkUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCruxLinkUpdateLocalizationInput = {
  data: CosmosElementCruxLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCruxLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementCruxLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCruxLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementCruxLinkUpsertLocalizationInput>>;
};

export type CosmosElementCruxLinkUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementCruxLink component instances */
  create?: InputMaybe<Array<CosmosElementCruxLinkCreateWithPositionInput>>;
  /** Delete multiple CosmosElementCruxLink documents */
  delete?: InputMaybe<Array<CosmosElementCruxLinkWhereUniqueInput>>;
  /** Update multiple CosmosElementCruxLink component instances */
  update?: InputMaybe<Array<CosmosElementCruxLinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementCruxLink component instances */
  upsert?: InputMaybe<Array<CosmosElementCruxLinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementCruxLinkUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementCruxLinkUpdateManyLocalizationsInput>;
};

export type CosmosElementCruxLinkUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementCruxLinkUpdateManyLocalizationInput = {
  data: CosmosElementCruxLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementCruxLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementCruxLinkUpdateManyLocalizationInput>>;
};

export type CosmosElementCruxLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementCruxLinkUpdateManyInput;
  /** Document search */
  where: CosmosElementCruxLinkWhereInput;
};

export type CosmosElementCruxLinkUpdateOneInlineInput = {
  /** Create and connect one CosmosElementCruxLink document */
  create?: InputMaybe<CosmosElementCruxLinkCreateInput>;
  /** Delete currently connected CosmosElementCruxLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementCruxLink document */
  update?: InputMaybe<CosmosElementCruxLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementCruxLink document */
  upsert?: InputMaybe<CosmosElementCruxLinkUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementCruxLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementCruxLinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCruxLinkWhereUniqueInput;
};

export type CosmosElementCruxLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementCruxLinkUpdateInput;
  /** Unique document search */
  where: CosmosElementCruxLinkWhereUniqueInput;
};

export type CosmosElementCruxLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementCruxLinkCreateInput;
  /** Update document if it exists */
  update: CosmosElementCruxLinkUpdateInput;
};

export type CosmosElementCruxLinkUpsertLocalizationInput = {
  create: CosmosElementCruxLinkCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementCruxLinkUpdateLocalizationDataInput;
};

export type CosmosElementCruxLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementCruxLinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementCruxLinkWhereUniqueInput;
};

export type CosmosElementCruxLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementCruxLinkUpsertInput;
  /** Unique document search */
  where: CosmosElementCruxLinkWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementCruxLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementCruxLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementCruxLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementCruxLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementCruxLink record uniquely */
export type CosmosElementCruxLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementDelphinusCard = Entity & {
  __typename?: 'CosmosElementDelphinusCard';
  asset?: Maybe<Asset>;
  assetPosition?: Maybe<CosmosEnumIconPosition>;
  avatar?: Maybe<CosmosElementAvatar>;
  badge?: Maybe<CosmosElementTag>;
  desc?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementDelphinusCard>;
  preHeading?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  titleHref?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementDelphinusCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementDelphinusCardAvatarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementDelphinusCardBadgeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementDelphinusCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementDelphinusCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementDelphinusCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementDelphinusCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementDelphinusCardConnection = {
  __typename?: 'CosmosElementDelphinusCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementDelphinusCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementDelphinusCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  assetPosition?: InputMaybe<CosmosEnumIconPosition>;
  avatar?: InputMaybe<CosmosElementAvatarCreateOneInlineInput>;
  badge?: InputMaybe<CosmosElementTagCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementDelphinusCardCreateLocalizationsInput>;
  /** preHeading input for default locale (en) */
  preHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDelphinusCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  preHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDelphinusCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementDelphinusCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDelphinusCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementDelphinusCardCreateLocalizationInput>>;
};

export type CosmosElementDelphinusCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDelphinusCard documents */
  create?: InputMaybe<Array<CosmosElementDelphinusCardCreateInput>>;
};

export type CosmosElementDelphinusCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementDelphinusCard document */
  create?: InputMaybe<CosmosElementDelphinusCardCreateInput>;
};

export type CosmosElementDelphinusCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementDelphinusCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementDelphinusCardEdge = {
  __typename?: 'CosmosElementDelphinusCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementDelphinusCard;
};

/** Identifies documents */
export type CosmosElementDelphinusCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDelphinusCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDelphinusCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDelphinusCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  assetPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are contained in given list. */
  assetPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  assetPosition_not?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are not contained in given list. */
  assetPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  avatar?: InputMaybe<CosmosElementAvatarWhereInput>;
  badge?: InputMaybe<CosmosElementTagWhereInput>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementDelphinusCardOrderByInput {
  AssetPositionAsc = 'assetPosition_ASC',
  AssetPositionDesc = 'assetPosition_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PreHeadingAsc = 'preHeading_ASC',
  PreHeadingDesc = 'preHeading_DESC',
  TitleHrefAsc = 'titleHref_ASC',
  TitleHrefDesc = 'titleHref_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementDelphinusCardParent = CosmosSectionDelphinusCardsGrid;

export type CosmosElementDelphinusCardParentConnectInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridConnectInput>;
};

export type CosmosElementDelphinusCardParentCreateInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridCreateInput>;
};

export type CosmosElementDelphinusCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDelphinusCardParent documents */
  create?: InputMaybe<Array<CosmosElementDelphinusCardParentCreateInput>>;
};

export type CosmosElementDelphinusCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementDelphinusCardParent document */
  create?: InputMaybe<CosmosElementDelphinusCardParentCreateInput>;
};

export type CosmosElementDelphinusCardParentCreateWithPositionInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridCreateWithPositionInput>;
};

export type CosmosElementDelphinusCardParentUpdateInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateInput>;
};

export type CosmosElementDelphinusCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDelphinusCardParent component instances */
  create?: InputMaybe<Array<CosmosElementDelphinusCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDelphinusCardParent documents */
  delete?: InputMaybe<Array<CosmosElementDelphinusCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementDelphinusCardParent component instances */
  update?: InputMaybe<Array<CosmosElementDelphinusCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDelphinusCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementDelphinusCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDelphinusCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateManyWithNestedWhereInput>;
};

export type CosmosElementDelphinusCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDelphinusCardParent document */
  create?: InputMaybe<CosmosElementDelphinusCardParentCreateInput>;
  /** Delete currently connected CosmosElementDelphinusCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDelphinusCardParent document */
  update?: InputMaybe<CosmosElementDelphinusCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDelphinusCardParent document */
  upsert?: InputMaybe<CosmosElementDelphinusCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDelphinusCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDelphinusCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementDelphinusCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDelphinusCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDelphinusCardParentWhereInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridWhereInput>;
};

export type CosmosElementDelphinusCardParentWhereUniqueInput = {
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridWhereUniqueInput>;
};

export type CosmosElementDelphinusCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  assetPosition?: InputMaybe<CosmosEnumIconPosition>;
  avatar?: InputMaybe<CosmosElementAvatarUpdateOneInlineInput>;
  badge?: InputMaybe<CosmosElementTagUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementDelphinusCardUpdateLocalizationsInput>;
  /** preHeading input for default locale (en) */
  preHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDelphinusCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  preHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDelphinusCardUpdateLocalizationInput = {
  data: CosmosElementDelphinusCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDelphinusCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementDelphinusCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDelphinusCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementDelphinusCardUpsertLocalizationInput>>;
};

export type CosmosElementDelphinusCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDelphinusCard component instances */
  create?: InputMaybe<Array<CosmosElementDelphinusCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDelphinusCard documents */
  delete?: InputMaybe<Array<CosmosElementDelphinusCardWhereUniqueInput>>;
  /** Update multiple CosmosElementDelphinusCard component instances */
  update?: InputMaybe<Array<CosmosElementDelphinusCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDelphinusCard component instances */
  upsert?: InputMaybe<Array<CosmosElementDelphinusCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDelphinusCardUpdateManyInput = {
  assetPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementDelphinusCardUpdateManyLocalizationsInput>;
  /** preHeading input for default locale (en) */
  preHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDelphinusCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  preHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDelphinusCardUpdateManyLocalizationInput = {
  data: CosmosElementDelphinusCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDelphinusCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDelphinusCardUpdateManyLocalizationInput>>;
};

export type CosmosElementDelphinusCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementDelphinusCardUpdateManyInput;
  /** Document search */
  where: CosmosElementDelphinusCardWhereInput;
};

export type CosmosElementDelphinusCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDelphinusCard document */
  create?: InputMaybe<CosmosElementDelphinusCardCreateInput>;
  /** Delete currently connected CosmosElementDelphinusCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDelphinusCard document */
  update?: InputMaybe<CosmosElementDelphinusCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDelphinusCard document */
  upsert?: InputMaybe<CosmosElementDelphinusCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDelphinusCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementDelphinusCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDelphinusCardWhereUniqueInput;
};

export type CosmosElementDelphinusCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementDelphinusCardUpdateInput;
  /** Unique document search */
  where: CosmosElementDelphinusCardWhereUniqueInput;
};

export type CosmosElementDelphinusCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementDelphinusCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementDelphinusCardUpdateInput;
};

export type CosmosElementDelphinusCardUpsertLocalizationInput = {
  create: CosmosElementDelphinusCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementDelphinusCardUpdateLocalizationDataInput;
};

export type CosmosElementDelphinusCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementDelphinusCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDelphinusCardWhereUniqueInput;
};

export type CosmosElementDelphinusCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementDelphinusCardUpsertInput;
  /** Unique document search */
  where: CosmosElementDelphinusCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementDelphinusCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDelphinusCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDelphinusCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDelphinusCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  assetPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are contained in given list. */
  assetPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  assetPosition_not?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are not contained in given list. */
  assetPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  avatar?: InputMaybe<CosmosElementAvatarWhereInput>;
  badge?: InputMaybe<CosmosElementTagWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  preHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleHref_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleHref_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleHref_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleHref_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleHref_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleHref_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleHref_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleHref_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleHref_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementDelphinusCard record uniquely */
export type CosmosElementDelphinusCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementDocumentList = Entity & {
  __typename?: 'CosmosElementDocumentList';
  heading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  items: Array<CosmosElementDocumentListItem>;
  /** Unique identifier for this particular document list. */
  listId?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementDocumentList>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementDocumentListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementDocumentListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
};


export type CosmosElementDocumentListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementDocumentListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementDocumentListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementDocumentListWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementDocumentListConnection = {
  __typename?: 'CosmosElementDocumentListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementDocumentListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementDocumentListCreateInput = {
  /** heading input for default locale (en) */
  heading?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementDocumentListItemCreateManyInlineInput>;
  listId?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementDocumentListCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDocumentListCreateLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDocumentListCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementDocumentListCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDocumentListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementDocumentListCreateLocalizationInput>>;
};

export type CosmosElementDocumentListCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDocumentList documents */
  create?: InputMaybe<Array<CosmosElementDocumentListCreateInput>>;
};

export type CosmosElementDocumentListCreateOneInlineInput = {
  /** Create and connect one CosmosElementDocumentList document */
  create?: InputMaybe<CosmosElementDocumentListCreateInput>;
};

export type CosmosElementDocumentListCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementDocumentListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementDocumentListEdge = {
  __typename?: 'CosmosElementDocumentListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementDocumentList;
};

export type CosmosElementDocumentListItem = Entity & {
  __typename?: 'CosmosElementDocumentListItem';
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementDocumentListItem>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementDocumentListItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementDocumentListItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementDocumentListItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementDocumentListItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementDocumentListItemConnection = {
  __typename?: 'CosmosElementDocumentListItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementDocumentListItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementDocumentListItemCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementDocumentListItemCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDocumentListItemCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDocumentListItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementDocumentListItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDocumentListItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementDocumentListItemCreateLocalizationInput>>;
};

export type CosmosElementDocumentListItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDocumentListItem documents */
  create?: InputMaybe<Array<CosmosElementDocumentListItemCreateInput>>;
};

export type CosmosElementDocumentListItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementDocumentListItem document */
  create?: InputMaybe<CosmosElementDocumentListItemCreateInput>;
};

export type CosmosElementDocumentListItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementDocumentListItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementDocumentListItemEdge = {
  __typename?: 'CosmosElementDocumentListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementDocumentListItem;
};

/** Identifies documents */
export type CosmosElementDocumentListItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDocumentListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDocumentListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDocumentListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementDocumentListItemOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementDocumentListItemParent = CosmosElementDocumentList;

export type CosmosElementDocumentListItemParentConnectInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListConnectInput>;
};

export type CosmosElementDocumentListItemParentCreateInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListCreateInput>;
};

export type CosmosElementDocumentListItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDocumentListItemParent documents */
  create?: InputMaybe<Array<CosmosElementDocumentListItemParentCreateInput>>;
};

export type CosmosElementDocumentListItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementDocumentListItemParent document */
  create?: InputMaybe<CosmosElementDocumentListItemParentCreateInput>;
};

export type CosmosElementDocumentListItemParentCreateWithPositionInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListCreateWithPositionInput>;
};

export type CosmosElementDocumentListItemParentUpdateInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListUpdateInput>;
};

export type CosmosElementDocumentListItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDocumentListItemParent component instances */
  create?: InputMaybe<Array<CosmosElementDocumentListItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDocumentListItemParent documents */
  delete?: InputMaybe<Array<CosmosElementDocumentListItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementDocumentListItemParent component instances */
  update?: InputMaybe<Array<CosmosElementDocumentListItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDocumentListItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementDocumentListItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDocumentListItemParentUpdateManyWithNestedWhereInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListUpdateManyWithNestedWhereInput>;
};

export type CosmosElementDocumentListItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDocumentListItemParent document */
  create?: InputMaybe<CosmosElementDocumentListItemParentCreateInput>;
  /** Delete currently connected CosmosElementDocumentListItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDocumentListItemParent document */
  update?: InputMaybe<CosmosElementDocumentListItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDocumentListItemParent document */
  upsert?: InputMaybe<CosmosElementDocumentListItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDocumentListItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDocumentListItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementDocumentListItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDocumentListItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDocumentListItemParentWhereInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListWhereInput>;
};

export type CosmosElementDocumentListItemParentWhereUniqueInput = {
  CosmosElementDocumentList?: InputMaybe<CosmosElementDocumentListWhereUniqueInput>;
};

export type CosmosElementDocumentListItemUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementDocumentListItemUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDocumentListItemUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDocumentListItemUpdateLocalizationInput = {
  data: CosmosElementDocumentListItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDocumentListItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementDocumentListItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDocumentListItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementDocumentListItemUpsertLocalizationInput>>;
};

export type CosmosElementDocumentListItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDocumentListItem component instances */
  create?: InputMaybe<Array<CosmosElementDocumentListItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDocumentListItem documents */
  delete?: InputMaybe<Array<CosmosElementDocumentListItemWhereUniqueInput>>;
  /** Update multiple CosmosElementDocumentListItem component instances */
  update?: InputMaybe<Array<CosmosElementDocumentListItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDocumentListItem component instances */
  upsert?: InputMaybe<Array<CosmosElementDocumentListItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDocumentListItemUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementDocumentListItemUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDocumentListItemUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDocumentListItemUpdateManyLocalizationInput = {
  data: CosmosElementDocumentListItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDocumentListItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDocumentListItemUpdateManyLocalizationInput>>;
};

export type CosmosElementDocumentListItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementDocumentListItemUpdateManyInput;
  /** Document search */
  where: CosmosElementDocumentListItemWhereInput;
};

export type CosmosElementDocumentListItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDocumentListItem document */
  create?: InputMaybe<CosmosElementDocumentListItemCreateInput>;
  /** Delete currently connected CosmosElementDocumentListItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDocumentListItem document */
  update?: InputMaybe<CosmosElementDocumentListItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDocumentListItem document */
  upsert?: InputMaybe<CosmosElementDocumentListItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDocumentListItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementDocumentListItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDocumentListItemWhereUniqueInput;
};

export type CosmosElementDocumentListItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementDocumentListItemUpdateInput;
  /** Unique document search */
  where: CosmosElementDocumentListItemWhereUniqueInput;
};

export type CosmosElementDocumentListItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementDocumentListItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementDocumentListItemUpdateInput;
};

export type CosmosElementDocumentListItemUpsertLocalizationInput = {
  create: CosmosElementDocumentListItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementDocumentListItemUpdateLocalizationDataInput;
};

export type CosmosElementDocumentListItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementDocumentListItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDocumentListItemWhereUniqueInput;
};

export type CosmosElementDocumentListItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementDocumentListItemUpsertInput;
  /** Unique document search */
  where: CosmosElementDocumentListItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementDocumentListItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDocumentListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDocumentListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDocumentListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementDocumentListItem record uniquely */
export type CosmosElementDocumentListItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CosmosElementDocumentListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDocumentListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDocumentListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDocumentListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
  items_none?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
  items_some?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
  listId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  listId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  listId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  listId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  listId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  listId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  listId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  listId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  listId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  listId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementDocumentListOrderByInput {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ListIdAsc = 'listId_ASC',
  ListIdDesc = 'listId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementDocumentListUpdateInput = {
  /** heading input for default locale (en) */
  heading?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementDocumentListItemUpdateManyInlineInput>;
  listId?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementDocumentListUpdateLocalizationsInput>;
};

export type CosmosElementDocumentListUpdateLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDocumentListUpdateLocalizationInput = {
  data: CosmosElementDocumentListUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDocumentListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementDocumentListCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDocumentListUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementDocumentListUpsertLocalizationInput>>;
};

export type CosmosElementDocumentListUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDocumentList component instances */
  create?: InputMaybe<Array<CosmosElementDocumentListCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDocumentList documents */
  delete?: InputMaybe<Array<CosmosElementDocumentListWhereUniqueInput>>;
  /** Update multiple CosmosElementDocumentList component instances */
  update?: InputMaybe<Array<CosmosElementDocumentListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDocumentList component instances */
  upsert?: InputMaybe<Array<CosmosElementDocumentListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDocumentListUpdateManyInput = {
  /** heading input for default locale (en) */
  heading?: InputMaybe<Scalars['String']['input']>;
  listId?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementDocumentListUpdateManyLocalizationsInput>;
};

export type CosmosElementDocumentListUpdateManyLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDocumentListUpdateManyLocalizationInput = {
  data: CosmosElementDocumentListUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDocumentListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDocumentListUpdateManyLocalizationInput>>;
};

export type CosmosElementDocumentListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementDocumentListUpdateManyInput;
  /** Document search */
  where: CosmosElementDocumentListWhereInput;
};

export type CosmosElementDocumentListUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDocumentList document */
  create?: InputMaybe<CosmosElementDocumentListCreateInput>;
  /** Delete currently connected CosmosElementDocumentList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDocumentList document */
  update?: InputMaybe<CosmosElementDocumentListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDocumentList document */
  upsert?: InputMaybe<CosmosElementDocumentListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDocumentListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementDocumentListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDocumentListWhereUniqueInput;
};

export type CosmosElementDocumentListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementDocumentListUpdateInput;
  /** Unique document search */
  where: CosmosElementDocumentListWhereUniqueInput;
};

export type CosmosElementDocumentListUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementDocumentListCreateInput;
  /** Update document if it exists */
  update: CosmosElementDocumentListUpdateInput;
};

export type CosmosElementDocumentListUpsertLocalizationInput = {
  create: CosmosElementDocumentListCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementDocumentListUpdateLocalizationDataInput;
};

export type CosmosElementDocumentListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementDocumentListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDocumentListWhereUniqueInput;
};

export type CosmosElementDocumentListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementDocumentListUpsertInput;
  /** Unique document search */
  where: CosmosElementDocumentListWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementDocumentListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDocumentListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDocumentListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDocumentListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
  items_none?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
  items_some?: InputMaybe<CosmosElementDocumentListItemWhereInput>;
  listId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  listId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  listId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  listId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  listId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  listId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  listId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  listId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  listId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  listId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementDocumentList record uniquely */
export type CosmosElementDocumentListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementDownloadButton = Entity & {
  __typename?: 'CosmosElementDownloadButton';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementDownloadButton>;
  /** The url to download the Launcher installer for Mac */
  macUrl?: Maybe<Scalars['String']['output']>;
  /** On mobile devices, this will be displayed instead of the button that would otherwise be rendered */
  mobileDisclaimer?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant?: Maybe<CosmosEnumButtonVariants>;
  /** The URL to download the Launcher installer for Windows */
  windowsUrl?: Maybe<Scalars['String']['output']>;
};


export type CosmosElementDownloadButtonLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementDownloadButtonUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementDownloadButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementDownloadButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementDownloadButtonConnection = {
  __typename?: 'CosmosElementDownloadButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementDownloadButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementDownloadButtonCreateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementDownloadButtonCreateLocalizationsInput>;
  macUrl?: InputMaybe<Scalars['String']['input']>;
  /** mobileDisclaimer input for default locale (en) */
  mobileDisclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  windowsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDownloadButtonCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  mobileDisclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDownloadButtonCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementDownloadButtonCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadButtonCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementDownloadButtonCreateLocalizationInput>>;
};

export type CosmosElementDownloadButtonCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadButton documents */
  create?: InputMaybe<Array<CosmosElementDownloadButtonCreateInput>>;
};

export type CosmosElementDownloadButtonCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadButton document */
  create?: InputMaybe<CosmosElementDownloadButtonCreateInput>;
};

export type CosmosElementDownloadButtonCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementDownloadButtonCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementDownloadButtonEdge = {
  __typename?: 'CosmosElementDownloadButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementDownloadButton;
};

/** Identifies documents */
export type CosmosElementDownloadButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDownloadButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDownloadButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDownloadButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  macUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  macUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  macUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  macUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  macUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  macUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  macUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  macUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  macUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  macUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  windowsUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  windowsUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  windowsUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  windowsUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  windowsUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  windowsUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  windowsUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  windowsUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  windowsUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  windowsUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CosmosElementDownloadButtonOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  MacUrlAsc = 'macUrl_ASC',
  MacUrlDesc = 'macUrl_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  WindowsUrlAsc = 'windowsUrl_ASC',
  WindowsUrlDesc = 'windowsUrl_DESC'
}

export type CosmosElementDownloadButtonParent = CosmosElementDownloadCard;

export type CosmosElementDownloadButtonParentConnectInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardConnectInput>;
};

export type CosmosElementDownloadButtonParentCreateInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateInput>;
};

export type CosmosElementDownloadButtonParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadButtonParent documents */
  create?: InputMaybe<Array<CosmosElementDownloadButtonParentCreateInput>>;
};

export type CosmosElementDownloadButtonParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadButtonParent document */
  create?: InputMaybe<CosmosElementDownloadButtonParentCreateInput>;
};

export type CosmosElementDownloadButtonParentCreateWithPositionInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateWithPositionInput>;
};

export type CosmosElementDownloadButtonParentUpdateInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateInput>;
};

export type CosmosElementDownloadButtonParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadButtonParent component instances */
  create?: InputMaybe<Array<CosmosElementDownloadButtonParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadButtonParent documents */
  delete?: InputMaybe<Array<CosmosElementDownloadButtonParentWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadButtonParent component instances */
  update?: InputMaybe<Array<CosmosElementDownloadButtonParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadButtonParent component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadButtonParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadButtonParentUpdateManyWithNestedWhereInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementDownloadButtonParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadButtonParent document */
  create?: InputMaybe<CosmosElementDownloadButtonParentCreateInput>;
  /** Delete currently connected CosmosElementDownloadButtonParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadButtonParent document */
  update?: InputMaybe<CosmosElementDownloadButtonParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadButtonParent document */
  upsert?: InputMaybe<CosmosElementDownloadButtonParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadButtonParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadButtonParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadButtonParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadButtonParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadButtonParentWhereInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereInput>;
};

export type CosmosElementDownloadButtonParentWhereUniqueInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereUniqueInput>;
};

export type CosmosElementDownloadButtonUpdateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementDownloadButtonUpdateLocalizationsInput>;
  macUrl?: InputMaybe<Scalars['String']['input']>;
  /** mobileDisclaimer input for default locale (en) */
  mobileDisclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  windowsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDownloadButtonUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  mobileDisclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementDownloadButtonUpdateLocalizationInput = {
  data: CosmosElementDownloadButtonUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadButtonUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementDownloadButtonCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDownloadButtonUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementDownloadButtonUpsertLocalizationInput>>;
};

export type CosmosElementDownloadButtonUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadButton component instances */
  create?: InputMaybe<Array<CosmosElementDownloadButtonCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadButton documents */
  delete?: InputMaybe<Array<CosmosElementDownloadButtonWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadButton component instances */
  update?: InputMaybe<Array<CosmosElementDownloadButtonUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadButton component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadButtonUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadButtonUpdateManyInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementDownloadButtonUpdateManyLocalizationsInput>;
  macUrl?: InputMaybe<Scalars['String']['input']>;
  /** mobileDisclaimer input for default locale (en) */
  mobileDisclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  windowsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDownloadButtonUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  mobileDisclaimer?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementDownloadButtonUpdateManyLocalizationInput = {
  data: CosmosElementDownloadButtonUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadButtonUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDownloadButtonUpdateManyLocalizationInput>>;
};

export type CosmosElementDownloadButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementDownloadButtonUpdateManyInput;
  /** Document search */
  where: CosmosElementDownloadButtonWhereInput;
};

export type CosmosElementDownloadButtonUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadButton document */
  create?: InputMaybe<CosmosElementDownloadButtonCreateInput>;
  /** Delete currently connected CosmosElementDownloadButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadButton document */
  update?: InputMaybe<CosmosElementDownloadButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadButton document */
  upsert?: InputMaybe<CosmosElementDownloadButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadButtonUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementDownloadButtonUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDownloadButtonWhereUniqueInput;
};

export type CosmosElementDownloadButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementDownloadButtonUpdateInput;
  /** Unique document search */
  where: CosmosElementDownloadButtonWhereUniqueInput;
};

export type CosmosElementDownloadButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementDownloadButtonCreateInput;
  /** Update document if it exists */
  update: CosmosElementDownloadButtonUpdateInput;
};

export type CosmosElementDownloadButtonUpsertLocalizationInput = {
  create: CosmosElementDownloadButtonCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementDownloadButtonUpdateLocalizationDataInput;
};

export type CosmosElementDownloadButtonUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementDownloadButtonUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDownloadButtonWhereUniqueInput;
};

export type CosmosElementDownloadButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementDownloadButtonUpsertInput;
  /** Unique document search */
  where: CosmosElementDownloadButtonWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementDownloadButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDownloadButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDownloadButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDownloadButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  macUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  macUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  macUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  macUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  macUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  macUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  macUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  macUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  macUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  macUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  windowsUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  windowsUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  windowsUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  windowsUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  windowsUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  windowsUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  windowsUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  windowsUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  windowsUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  windowsUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CosmosElementDownloadButton record uniquely */
export type CosmosElementDownloadButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementDownloadCard = Entity & {
  __typename?: 'CosmosElementDownloadCard';
  cta?: Maybe<CosmosElementDownloadCardctaUnion>;
  description: RichText;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementDownloadCard>;
  /** System stage field */
  stage: Stage;
  title: RichText;
  titleIcon?: Maybe<EdsIconsEnum>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementDownloadCardCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementDownloadCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementDownloadCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementDownloadCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementDownloadCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementDownloadCardConnection = {
  __typename?: 'CosmosElementDownloadCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementDownloadCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementDownloadCardCreateInput = {
  cta?: InputMaybe<CosmosElementDownloadCardctaUnionCreateOneInlineInput>;
  /** description input for default locale (en) */
  description: Scalars['RichTextAST']['input'];
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementDownloadCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title: Scalars['RichTextAST']['input'];
  titleIcon?: InputMaybe<EdsIconsEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDownloadCardCreateLocalizationDataInput = {
  description: Scalars['RichTextAST']['input'];
  title: Scalars['RichTextAST']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDownloadCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementDownloadCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementDownloadCardCreateLocalizationInput>>;
};

export type CosmosElementDownloadCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadCard documents */
  create?: InputMaybe<Array<CosmosElementDownloadCardCreateInput>>;
};

export type CosmosElementDownloadCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadCard document */
  create?: InputMaybe<CosmosElementDownloadCardCreateInput>;
};

export type CosmosElementDownloadCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementDownloadCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementDownloadCardEdge = {
  __typename?: 'CosmosElementDownloadCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementDownloadCard;
};

/** Identifies documents */
export type CosmosElementDownloadCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDownloadCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDownloadCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDownloadCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  cta?: InputMaybe<CosmosElementDownloadCardctaUnionWhereInput>;
  /** All values in which the union is empty. */
  cta_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  titleIcon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  titleIcon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleIcon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementDownloadCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleIconAsc = 'titleIcon_ASC',
  TitleIconDesc = 'titleIcon_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementDownloadCardParent = CosmosElementDownloadStep | CosmosSectionDownloadCard | CosmosSectionDownloadable;

export type CosmosElementDownloadCardParentConnectInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepConnectInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardConnectInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableConnectInput>;
};

export type CosmosElementDownloadCardParentCreateInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepCreateInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableCreateInput>;
};

export type CosmosElementDownloadCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadCardParent documents */
  create?: InputMaybe<Array<CosmosElementDownloadCardParentCreateInput>>;
};

export type CosmosElementDownloadCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadCardParent document */
  create?: InputMaybe<CosmosElementDownloadCardParentCreateInput>;
};

export type CosmosElementDownloadCardParentCreateWithPositionInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepCreateWithPositionInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateWithPositionInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableCreateWithPositionInput>;
};

export type CosmosElementDownloadCardParentUpdateInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepUpdateInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateInput>;
};

export type CosmosElementDownloadCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadCardParent component instances */
  create?: InputMaybe<Array<CosmosElementDownloadCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadCardParent documents */
  delete?: InputMaybe<Array<CosmosElementDownloadCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadCardParent component instances */
  update?: InputMaybe<Array<CosmosElementDownloadCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadCardParentUpdateManyWithNestedWhereInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepUpdateManyWithNestedWhereInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateManyWithNestedWhereInput>;
};

export type CosmosElementDownloadCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadCardParent document */
  create?: InputMaybe<CosmosElementDownloadCardParentCreateInput>;
  /** Delete currently connected CosmosElementDownloadCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadCardParent document */
  update?: InputMaybe<CosmosElementDownloadCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadCardParent document */
  upsert?: InputMaybe<CosmosElementDownloadCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardParentWhereInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableWhereInput>;
};

export type CosmosElementDownloadCardParentWhereUniqueInput = {
  CosmosElementDownloadStep?: InputMaybe<CosmosElementDownloadStepWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableWhereUniqueInput>;
};

export type CosmosElementDownloadCardUpdateInput = {
  cta?: InputMaybe<CosmosElementDownloadCardctaUnionUpdateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementDownloadCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleIcon?: InputMaybe<EdsIconsEnum>;
};

export type CosmosElementDownloadCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementDownloadCardUpdateLocalizationInput = {
  data: CosmosElementDownloadCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementDownloadCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDownloadCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementDownloadCardUpsertLocalizationInput>>;
};

export type CosmosElementDownloadCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadCard component instances */
  create?: InputMaybe<Array<CosmosElementDownloadCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadCard documents */
  delete?: InputMaybe<Array<CosmosElementDownloadCardWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadCard component instances */
  update?: InputMaybe<Array<CosmosElementDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadCard component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadCardUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementDownloadCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleIcon?: InputMaybe<EdsIconsEnum>;
};

export type CosmosElementDownloadCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementDownloadCardUpdateManyLocalizationInput = {
  data: CosmosElementDownloadCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDownloadCardUpdateManyLocalizationInput>>;
};

export type CosmosElementDownloadCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementDownloadCardUpdateManyInput;
  /** Document search */
  where: CosmosElementDownloadCardWhereInput;
};

export type CosmosElementDownloadCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadCard document */
  create?: InputMaybe<CosmosElementDownloadCardCreateInput>;
  /** Delete currently connected CosmosElementDownloadCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadCard document */
  update?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadCard document */
  upsert?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementDownloadCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDownloadCardWhereUniqueInput;
};

export type CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementDownloadCardUpdateInput;
  /** Unique document search */
  where: CosmosElementDownloadCardWhereUniqueInput;
};

export type CosmosElementDownloadCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementDownloadCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementDownloadCardUpdateInput;
};

export type CosmosElementDownloadCardUpsertLocalizationInput = {
  create: CosmosElementDownloadCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementDownloadCardUpdateLocalizationDataInput;
};

export type CosmosElementDownloadCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementDownloadCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDownloadCardWhereUniqueInput;
};

export type CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementDownloadCardUpsertInput;
  /** Unique document search */
  where: CosmosElementDownloadCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementDownloadCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDownloadCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDownloadCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDownloadCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  cta?: InputMaybe<CosmosElementDownloadCardctaUnionWhereInput>;
  /** All values in which the union is empty. */
  cta_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  titleIcon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  titleIcon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleIcon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementDownloadCard record uniquely */
export type CosmosElementDownloadCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementDownloadCardctaUnion = CosmosElementButton | CosmosElementDownloadButton | CosmosElementIconButton | CosmosElementLink | CosmosElementRichText;

export type CosmosElementDownloadCardctaUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkConnectInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextConnectInput>;
};

export type CosmosElementDownloadCardctaUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkCreateInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextCreateInput>;
};

export type CosmosElementDownloadCardctaUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadCardctaUnion documents */
  create?: InputMaybe<Array<CosmosElementDownloadCardctaUnionCreateInput>>;
};

export type CosmosElementDownloadCardctaUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadCardctaUnion document */
  create?: InputMaybe<CosmosElementDownloadCardctaUnionCreateInput>;
};

export type CosmosElementDownloadCardctaUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkCreateWithPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextCreateWithPositionInput>;
};

export type CosmosElementDownloadCardctaUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkUpdateInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateInput>;
};

export type CosmosElementDownloadCardctaUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadCardctaUnion component instances */
  create?: InputMaybe<Array<CosmosElementDownloadCardctaUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadCardctaUnion documents */
  delete?: InputMaybe<Array<CosmosElementDownloadCardctaUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadCardctaUnion component instances */
  update?: InputMaybe<Array<CosmosElementDownloadCardctaUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadCardctaUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadCardctaUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadCardctaUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkUpdateManyWithNestedWhereInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateManyWithNestedWhereInput>;
};

export type CosmosElementDownloadCardctaUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadCardctaUnion document */
  create?: InputMaybe<CosmosElementDownloadCardctaUnionCreateInput>;
  /** Delete currently connected CosmosElementDownloadCardctaUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadCardctaUnion document */
  update?: InputMaybe<CosmosElementDownloadCardctaUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadCardctaUnion document */
  upsert?: InputMaybe<CosmosElementDownloadCardctaUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardctaUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadCardctaUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkUpdateWithNestedWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardctaUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadCardctaUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkUpsertWithNestedWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadCardctaUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkWhereInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextWhereInput>;
};

export type CosmosElementDownloadCardctaUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementDownloadButton?: InputMaybe<CosmosElementDownloadButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
  CosmosElementLink?: InputMaybe<CosmosElementLinkWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextWhereUniqueInput>;
};

export type CosmosElementDownloadStep = Entity & {
  __typename?: 'CosmosElementDownloadStep';
  content: Array<CosmosElementDownloadCard>;
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementDownloadStep>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementDownloadStepContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementDownloadCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementDownloadCardWhereInput>;
};


export type CosmosElementDownloadStepLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementDownloadStepUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementDownloadStepConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementDownloadStepWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementDownloadStepConnection = {
  __typename?: 'CosmosElementDownloadStepConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementDownloadStepEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementDownloadStepCreateInput = {
  content?: InputMaybe<CosmosElementDownloadCardCreateManyInlineInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementDownloadStepCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDownloadStepCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementDownloadStepCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementDownloadStepCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadStepCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementDownloadStepCreateLocalizationInput>>;
};

export type CosmosElementDownloadStepCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadStep documents */
  create?: InputMaybe<Array<CosmosElementDownloadStepCreateInput>>;
};

export type CosmosElementDownloadStepCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadStep document */
  create?: InputMaybe<CosmosElementDownloadStepCreateInput>;
};

export type CosmosElementDownloadStepCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementDownloadStepCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementDownloadStepEdge = {
  __typename?: 'CosmosElementDownloadStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementDownloadStep;
};

/** Identifies documents */
export type CosmosElementDownloadStepManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDownloadStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDownloadStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDownloadStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content_every?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  content_none?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  content_some?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementDownloadStepOrderByInput {
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementDownloadStepParent = CosmosSectionDownloadCard;

export type CosmosElementDownloadStepParentConnectInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardConnectInput>;
};

export type CosmosElementDownloadStepParentCreateInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateInput>;
};

export type CosmosElementDownloadStepParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementDownloadStepParent documents */
  create?: InputMaybe<Array<CosmosElementDownloadStepParentCreateInput>>;
};

export type CosmosElementDownloadStepParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadStepParent document */
  create?: InputMaybe<CosmosElementDownloadStepParentCreateInput>;
};

export type CosmosElementDownloadStepParentCreateWithPositionInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateWithPositionInput>;
};

export type CosmosElementDownloadStepParentUpdateInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateInput>;
};

export type CosmosElementDownloadStepParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadStepParent component instances */
  create?: InputMaybe<Array<CosmosElementDownloadStepParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadStepParent documents */
  delete?: InputMaybe<Array<CosmosElementDownloadStepParentWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadStepParent component instances */
  update?: InputMaybe<Array<CosmosElementDownloadStepParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadStepParent component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadStepParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadStepParentUpdateManyWithNestedWhereInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementDownloadStepParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadStepParent document */
  create?: InputMaybe<CosmosElementDownloadStepParentCreateInput>;
  /** Delete currently connected CosmosElementDownloadStepParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadStepParent document */
  update?: InputMaybe<CosmosElementDownloadStepParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadStepParent document */
  upsert?: InputMaybe<CosmosElementDownloadStepParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadStepParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadStepParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadStepParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementDownloadStepParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadStepParentWhereInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereInput>;
};

export type CosmosElementDownloadStepParentWhereUniqueInput = {
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereUniqueInput>;
};

export type CosmosElementDownloadStepUpdateInput = {
  content?: InputMaybe<CosmosElementDownloadCardUpdateManyInlineInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementDownloadStepUpdateLocalizationsInput>;
};

export type CosmosElementDownloadStepUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDownloadStepUpdateLocalizationInput = {
  data: CosmosElementDownloadStepUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadStepUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementDownloadStepCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDownloadStepUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementDownloadStepUpsertLocalizationInput>>;
};

export type CosmosElementDownloadStepUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementDownloadStep component instances */
  create?: InputMaybe<Array<CosmosElementDownloadStepCreateWithPositionInput>>;
  /** Delete multiple CosmosElementDownloadStep documents */
  delete?: InputMaybe<Array<CosmosElementDownloadStepWhereUniqueInput>>;
  /** Update multiple CosmosElementDownloadStep component instances */
  update?: InputMaybe<Array<CosmosElementDownloadStepUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementDownloadStep component instances */
  upsert?: InputMaybe<Array<CosmosElementDownloadStepUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementDownloadStepUpdateManyInput = {
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementDownloadStepUpdateManyLocalizationsInput>;
};

export type CosmosElementDownloadStepUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementDownloadStepUpdateManyLocalizationInput = {
  data: CosmosElementDownloadStepUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementDownloadStepUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementDownloadStepUpdateManyLocalizationInput>>;
};

export type CosmosElementDownloadStepUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementDownloadStepUpdateManyInput;
  /** Document search */
  where: CosmosElementDownloadStepWhereInput;
};

export type CosmosElementDownloadStepUpdateOneInlineInput = {
  /** Create and connect one CosmosElementDownloadStep document */
  create?: InputMaybe<CosmosElementDownloadStepCreateInput>;
  /** Delete currently connected CosmosElementDownloadStep document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementDownloadStep document */
  update?: InputMaybe<CosmosElementDownloadStepUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementDownloadStep document */
  upsert?: InputMaybe<CosmosElementDownloadStepUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementDownloadStepUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementDownloadStepUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDownloadStepWhereUniqueInput;
};

export type CosmosElementDownloadStepUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementDownloadStepUpdateInput;
  /** Unique document search */
  where: CosmosElementDownloadStepWhereUniqueInput;
};

export type CosmosElementDownloadStepUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementDownloadStepCreateInput;
  /** Update document if it exists */
  update: CosmosElementDownloadStepUpdateInput;
};

export type CosmosElementDownloadStepUpsertLocalizationInput = {
  create: CosmosElementDownloadStepCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementDownloadStepUpdateLocalizationDataInput;
};

export type CosmosElementDownloadStepUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementDownloadStepUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementDownloadStepWhereUniqueInput;
};

export type CosmosElementDownloadStepUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementDownloadStepUpsertInput;
  /** Unique document search */
  where: CosmosElementDownloadStepWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementDownloadStepWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementDownloadStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementDownloadStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementDownloadStepWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  content_every?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  content_none?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  content_some?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementDownloadStep record uniquely */
export type CosmosElementDownloadStepWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementEdsIconLink = Entity & {
  __typename?: 'CosmosElementEdsIconLink';
  /** This will be the accessibility text for screen readers focusing on this link icon. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementEdsIconLink>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementEdsIconLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementEdsIconLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementEdsIconLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementEdsIconLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementEdsIconLinkConnection = {
  __typename?: 'CosmosElementEdsIconLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementEdsIconLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementEdsIconLinkCreateInput = {
  /** ariaLabel input for default locale (en) */
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementEdsIconLinkCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementEdsIconLinkCreateLocalizationDataInput = {
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementEdsIconLinkCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementEdsIconLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementEdsIconLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementEdsIconLinkCreateLocalizationInput>>;
};

export type CosmosElementEdsIconLinkCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementEdsIconLink documents */
  create?: InputMaybe<Array<CosmosElementEdsIconLinkCreateInput>>;
};

export type CosmosElementEdsIconLinkCreateOneInlineInput = {
  /** Create and connect one CosmosElementEdsIconLink document */
  create?: InputMaybe<CosmosElementEdsIconLinkCreateInput>;
};

export type CosmosElementEdsIconLinkCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementEdsIconLinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementEdsIconLinkEdge = {
  __typename?: 'CosmosElementEdsIconLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementEdsIconLink;
};

/** Identifies documents */
export type CosmosElementEdsIconLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementEdsIconLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementEdsIconLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementEdsIconLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementEdsIconLinkOrderByInput {
  AriaLabelAsc = 'ariaLabel_ASC',
  AriaLabelDesc = 'ariaLabel_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementEdsIconLinkParent = CosmosElementIconLinkGroup;

export type CosmosElementEdsIconLinkParentConnectInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupConnectInput>;
};

export type CosmosElementEdsIconLinkParentCreateInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupCreateInput>;
};

export type CosmosElementEdsIconLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementEdsIconLinkParent documents */
  create?: InputMaybe<Array<CosmosElementEdsIconLinkParentCreateInput>>;
};

export type CosmosElementEdsIconLinkParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementEdsIconLinkParent document */
  create?: InputMaybe<CosmosElementEdsIconLinkParentCreateInput>;
};

export type CosmosElementEdsIconLinkParentCreateWithPositionInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupCreateWithPositionInput>;
};

export type CosmosElementEdsIconLinkParentUpdateInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateInput>;
};

export type CosmosElementEdsIconLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementEdsIconLinkParent component instances */
  create?: InputMaybe<Array<CosmosElementEdsIconLinkParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementEdsIconLinkParent documents */
  delete?: InputMaybe<Array<CosmosElementEdsIconLinkParentWhereUniqueInput>>;
  /** Update multiple CosmosElementEdsIconLinkParent component instances */
  update?: InputMaybe<Array<CosmosElementEdsIconLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementEdsIconLinkParent component instances */
  upsert?: InputMaybe<Array<CosmosElementEdsIconLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementEdsIconLinkParentUpdateManyWithNestedWhereInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateManyWithNestedWhereInput>;
};

export type CosmosElementEdsIconLinkParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementEdsIconLinkParent document */
  create?: InputMaybe<CosmosElementEdsIconLinkParentCreateInput>;
  /** Delete currently connected CosmosElementEdsIconLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementEdsIconLinkParent document */
  update?: InputMaybe<CosmosElementEdsIconLinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementEdsIconLinkParent document */
  upsert?: InputMaybe<CosmosElementEdsIconLinkParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementEdsIconLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementEdsIconLinkParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementEdsIconLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementEdsIconLinkParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementEdsIconLinkParentWhereInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupWhereInput>;
};

export type CosmosElementEdsIconLinkParentWhereUniqueInput = {
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupWhereUniqueInput>;
};

export type CosmosElementEdsIconLinkUpdateInput = {
  /** ariaLabel input for default locale (en) */
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementEdsIconLinkUpdateLocalizationsInput>;
};

export type CosmosElementEdsIconLinkUpdateLocalizationDataInput = {
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementEdsIconLinkUpdateLocalizationInput = {
  data: CosmosElementEdsIconLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementEdsIconLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementEdsIconLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementEdsIconLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementEdsIconLinkUpsertLocalizationInput>>;
};

export type CosmosElementEdsIconLinkUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementEdsIconLink component instances */
  create?: InputMaybe<Array<CosmosElementEdsIconLinkCreateWithPositionInput>>;
  /** Delete multiple CosmosElementEdsIconLink documents */
  delete?: InputMaybe<Array<CosmosElementEdsIconLinkWhereUniqueInput>>;
  /** Update multiple CosmosElementEdsIconLink component instances */
  update?: InputMaybe<Array<CosmosElementEdsIconLinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementEdsIconLink component instances */
  upsert?: InputMaybe<Array<CosmosElementEdsIconLinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementEdsIconLinkUpdateManyInput = {
  /** ariaLabel input for default locale (en) */
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementEdsIconLinkUpdateManyLocalizationsInput>;
};

export type CosmosElementEdsIconLinkUpdateManyLocalizationDataInput = {
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementEdsIconLinkUpdateManyLocalizationInput = {
  data: CosmosElementEdsIconLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementEdsIconLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementEdsIconLinkUpdateManyLocalizationInput>>;
};

export type CosmosElementEdsIconLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementEdsIconLinkUpdateManyInput;
  /** Document search */
  where: CosmosElementEdsIconLinkWhereInput;
};

export type CosmosElementEdsIconLinkUpdateOneInlineInput = {
  /** Create and connect one CosmosElementEdsIconLink document */
  create?: InputMaybe<CosmosElementEdsIconLinkCreateInput>;
  /** Delete currently connected CosmosElementEdsIconLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementEdsIconLink document */
  update?: InputMaybe<CosmosElementEdsIconLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementEdsIconLink document */
  upsert?: InputMaybe<CosmosElementEdsIconLinkUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementEdsIconLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementEdsIconLinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementEdsIconLinkWhereUniqueInput;
};

export type CosmosElementEdsIconLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementEdsIconLinkUpdateInput;
  /** Unique document search */
  where: CosmosElementEdsIconLinkWhereUniqueInput;
};

export type CosmosElementEdsIconLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementEdsIconLinkCreateInput;
  /** Update document if it exists */
  update: CosmosElementEdsIconLinkUpdateInput;
};

export type CosmosElementEdsIconLinkUpsertLocalizationInput = {
  create: CosmosElementEdsIconLinkCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementEdsIconLinkUpdateLocalizationDataInput;
};

export type CosmosElementEdsIconLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementEdsIconLinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementEdsIconLinkWhereUniqueInput;
};

export type CosmosElementEdsIconLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementEdsIconLinkUpsertInput;
  /** Unique document search */
  where: CosmosElementEdsIconLinkWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementEdsIconLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementEdsIconLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementEdsIconLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementEdsIconLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ariaLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ariaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ariaLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ariaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ariaLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ariaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ariaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ariaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ariaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ariaLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementEdsIconLink record uniquely */
export type CosmosElementEdsIconLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementEventsTableRow = Entity & {
  __typename?: 'CosmosElementEventsTableRow';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  description?: Maybe<RichText>;
  /** The end time of the event (in your browser's local time zone). If left empty, only the start time will be shown. */
  endTimeAndDate?: Maybe<Scalars['DateTime']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementEventsTableRow>;
  location?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The start time of the event (in your browser's local time zone) */
  timeAndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Format to display the Time and Date in. If left empty, the Weekday, Month, Day, Time & TimeZone will be shown. */
  timeAndDateFormat?: Maybe<CosmosEnumTimeAndDateFormat>;
  /** Time zone to display the Time and Date in. If left empty, the time will be displayed on the page in the end user's local time zone. */
  timeZone?: Maybe<CosmosEnumTimeZone>;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementEventsTableRowLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementEventsTableRowUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementEventsTableRowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementEventsTableRowWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementEventsTableRowConnection = {
  __typename?: 'CosmosElementEventsTableRowConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementEventsTableRowEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementEventsTableRowCreateInput = {
  /** badgeLabel input for default locale (en) */
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  endTimeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementEventsTableRowCreateLocalizationsInput>;
  /** location input for default locale (en) */
  location?: InputMaybe<Scalars['String']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeAndDateFormat?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  timeZone?: InputMaybe<CosmosEnumTimeZone>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementEventsTableRowCreateLocalizationDataInput = {
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementEventsTableRowCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementEventsTableRowCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementEventsTableRowCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementEventsTableRowCreateLocalizationInput>>;
};

export type CosmosElementEventsTableRowCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementEventsTableRow documents */
  create?: InputMaybe<Array<CosmosElementEventsTableRowCreateInput>>;
};

export type CosmosElementEventsTableRowCreateOneInlineInput = {
  /** Create and connect one CosmosElementEventsTableRow document */
  create?: InputMaybe<CosmosElementEventsTableRowCreateInput>;
};

export type CosmosElementEventsTableRowCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementEventsTableRowCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementEventsTableRowEdge = {
  __typename?: 'CosmosElementEventsTableRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementEventsTableRow;
};

/** Identifies documents */
export type CosmosElementEventsTableRowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementEventsTableRowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementEventsTableRowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementEventsTableRowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  endTimeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endTimeAndDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endTimeAndDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endTimeAndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endTimeAndDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endTimeAndDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endTimeAndDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endTimeAndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeAndDateFormat?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  /** All values that are contained in given list. */
  timeAndDateFormat_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeAndDateFormat>>>;
  /** Any other value that exists and is not equal to the given value. */
  timeAndDateFormat_not?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  /** All values that are not contained in given list. */
  timeAndDateFormat_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeAndDateFormat>>>;
  /** All values greater than the given value. */
  timeAndDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  timeAndDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  timeAndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  timeAndDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  timeAndDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  timeAndDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  timeAndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  timeZone?: InputMaybe<CosmosEnumTimeZone>;
  /** All values that are contained in given list. */
  timeZone_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeZone>>>;
  /** Any other value that exists and is not equal to the given value. */
  timeZone_not?: InputMaybe<CosmosEnumTimeZone>;
  /** All values that are not contained in given list. */
  timeZone_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeZone>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementEventsTableRowOrderByInput {
  BadgeLabelAsc = 'badgeLabel_ASC',
  BadgeLabelDesc = 'badgeLabel_DESC',
  EndTimeAndDateAsc = 'endTimeAndDate_ASC',
  EndTimeAndDateDesc = 'endTimeAndDate_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  TimeAndDateFormatAsc = 'timeAndDateFormat_ASC',
  TimeAndDateFormatDesc = 'timeAndDateFormat_DESC',
  TimeAndDateAsc = 'timeAndDate_ASC',
  TimeAndDateDesc = 'timeAndDate_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementEventsTableRowParent = CosmosSectionEventsTable;

export type CosmosElementEventsTableRowParentConnectInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableConnectInput>;
};

export type CosmosElementEventsTableRowParentCreateInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableCreateInput>;
};

export type CosmosElementEventsTableRowParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementEventsTableRowParent documents */
  create?: InputMaybe<Array<CosmosElementEventsTableRowParentCreateInput>>;
};

export type CosmosElementEventsTableRowParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementEventsTableRowParent document */
  create?: InputMaybe<CosmosElementEventsTableRowParentCreateInput>;
};

export type CosmosElementEventsTableRowParentCreateWithPositionInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableCreateWithPositionInput>;
};

export type CosmosElementEventsTableRowParentUpdateInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateInput>;
};

export type CosmosElementEventsTableRowParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementEventsTableRowParent component instances */
  create?: InputMaybe<Array<CosmosElementEventsTableRowParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementEventsTableRowParent documents */
  delete?: InputMaybe<Array<CosmosElementEventsTableRowParentWhereUniqueInput>>;
  /** Update multiple CosmosElementEventsTableRowParent component instances */
  update?: InputMaybe<Array<CosmosElementEventsTableRowParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementEventsTableRowParent component instances */
  upsert?: InputMaybe<Array<CosmosElementEventsTableRowParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementEventsTableRowParentUpdateManyWithNestedWhereInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateManyWithNestedWhereInput>;
};

export type CosmosElementEventsTableRowParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementEventsTableRowParent document */
  create?: InputMaybe<CosmosElementEventsTableRowParentCreateInput>;
  /** Delete currently connected CosmosElementEventsTableRowParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementEventsTableRowParent document */
  update?: InputMaybe<CosmosElementEventsTableRowParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementEventsTableRowParent document */
  upsert?: InputMaybe<CosmosElementEventsTableRowParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementEventsTableRowParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementEventsTableRowParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementEventsTableRowParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementEventsTableRowParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementEventsTableRowParentWhereInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableWhereInput>;
};

export type CosmosElementEventsTableRowParentWhereUniqueInput = {
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableWhereUniqueInput>;
};

export type CosmosElementEventsTableRowUpdateInput = {
  /** badgeLabel input for default locale (en) */
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  endTimeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementEventsTableRowUpdateLocalizationsInput>;
  /** location input for default locale (en) */
  location?: InputMaybe<Scalars['String']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeAndDateFormat?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  timeZone?: InputMaybe<CosmosEnumTimeZone>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementEventsTableRowUpdateLocalizationDataInput = {
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementEventsTableRowUpdateLocalizationInput = {
  data: CosmosElementEventsTableRowUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementEventsTableRowUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementEventsTableRowCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementEventsTableRowUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementEventsTableRowUpsertLocalizationInput>>;
};

export type CosmosElementEventsTableRowUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementEventsTableRow component instances */
  create?: InputMaybe<Array<CosmosElementEventsTableRowCreateWithPositionInput>>;
  /** Delete multiple CosmosElementEventsTableRow documents */
  delete?: InputMaybe<Array<CosmosElementEventsTableRowWhereUniqueInput>>;
  /** Update multiple CosmosElementEventsTableRow component instances */
  update?: InputMaybe<Array<CosmosElementEventsTableRowUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementEventsTableRow component instances */
  upsert?: InputMaybe<Array<CosmosElementEventsTableRowUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementEventsTableRowUpdateManyInput = {
  /** badgeLabel input for default locale (en) */
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  endTimeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementEventsTableRowUpdateManyLocalizationsInput>;
  /** location input for default locale (en) */
  location?: InputMaybe<Scalars['String']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeAndDateFormat?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  timeZone?: InputMaybe<CosmosEnumTimeZone>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementEventsTableRowUpdateManyLocalizationDataInput = {
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementEventsTableRowUpdateManyLocalizationInput = {
  data: CosmosElementEventsTableRowUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementEventsTableRowUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementEventsTableRowUpdateManyLocalizationInput>>;
};

export type CosmosElementEventsTableRowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementEventsTableRowUpdateManyInput;
  /** Document search */
  where: CosmosElementEventsTableRowWhereInput;
};

export type CosmosElementEventsTableRowUpdateOneInlineInput = {
  /** Create and connect one CosmosElementEventsTableRow document */
  create?: InputMaybe<CosmosElementEventsTableRowCreateInput>;
  /** Delete currently connected CosmosElementEventsTableRow document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementEventsTableRow document */
  update?: InputMaybe<CosmosElementEventsTableRowUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementEventsTableRow document */
  upsert?: InputMaybe<CosmosElementEventsTableRowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementEventsTableRowUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementEventsTableRowUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementEventsTableRowWhereUniqueInput;
};

export type CosmosElementEventsTableRowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementEventsTableRowUpdateInput;
  /** Unique document search */
  where: CosmosElementEventsTableRowWhereUniqueInput;
};

export type CosmosElementEventsTableRowUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementEventsTableRowCreateInput;
  /** Update document if it exists */
  update: CosmosElementEventsTableRowUpdateInput;
};

export type CosmosElementEventsTableRowUpsertLocalizationInput = {
  create: CosmosElementEventsTableRowCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementEventsTableRowUpdateLocalizationDataInput;
};

export type CosmosElementEventsTableRowUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementEventsTableRowUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementEventsTableRowWhereUniqueInput;
};

export type CosmosElementEventsTableRowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementEventsTableRowUpsertInput;
  /** Unique document search */
  where: CosmosElementEventsTableRowWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementEventsTableRowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementEventsTableRowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementEventsTableRowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementEventsTableRowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  badgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  badgeLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  badgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  badgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  badgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  badgeLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  badgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  badgeLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  badgeLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  endTimeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endTimeAndDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endTimeAndDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endTimeAndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endTimeAndDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endTimeAndDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endTimeAndDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endTimeAndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  location_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  location_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  location_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  location_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  location_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  location_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  location_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  location_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  location_starts_with?: InputMaybe<Scalars['String']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeAndDateFormat?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  /** All values that are contained in given list. */
  timeAndDateFormat_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeAndDateFormat>>>;
  /** Any other value that exists and is not equal to the given value. */
  timeAndDateFormat_not?: InputMaybe<CosmosEnumTimeAndDateFormat>;
  /** All values that are not contained in given list. */
  timeAndDateFormat_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeAndDateFormat>>>;
  /** All values greater than the given value. */
  timeAndDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  timeAndDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  timeAndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  timeAndDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  timeAndDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  timeAndDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  timeAndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  timeZone?: InputMaybe<CosmosEnumTimeZone>;
  /** All values that are contained in given list. */
  timeZone_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeZone>>>;
  /** Any other value that exists and is not equal to the given value. */
  timeZone_not?: InputMaybe<CosmosEnumTimeZone>;
  /** All values that are not contained in given list. */
  timeZone_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumTimeZone>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementEventsTableRow record uniquely */
export type CosmosElementEventsTableRowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementFaqItem = Entity & {
  __typename?: 'CosmosElementFAQItem';
  /** This is the id (you might enter "general") that can be linked to (like "/faq/#general") from another page to scroll to this FAQ Item. */
  anchorLinkId?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<RichText>;
  /** Instead use First Item Default Open toggle one level up a schema. */
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementFaqItem>;
  question?: Maybe<RichText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementFaqItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementFaqItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementFaqItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementFaqItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementFaqItemConnection = {
  __typename?: 'CosmosElementFAQItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementFaqItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementFaqItemCreateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['RichTextAST']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementFaqItemCreateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementFaqItemCreateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['RichTextAST']['input']>;
  question?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementFaqItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementFaqItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFaqItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementFaqItemCreateLocalizationInput>>;
};

export type CosmosElementFaqItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementFAQItem documents */
  create?: InputMaybe<Array<CosmosElementFaqItemCreateInput>>;
};

export type CosmosElementFaqItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementFAQItem document */
  create?: InputMaybe<CosmosElementFaqItemCreateInput>;
};

export type CosmosElementFaqItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementFaqItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementFaqItemEdge = {
  __typename?: 'CosmosElementFAQItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementFaqItem;
};

/** Identifies documents */
export type CosmosElementFaqItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementFaqItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementFaqItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementFaqItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementFaqItemOrderByInput {
  AnchorLinkIdAsc = 'anchorLinkId_ASC',
  AnchorLinkIdDesc = 'anchorLinkId_DESC',
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementFaqItemParent = CosmosElementFaqTab | CosmosSectionFaq;

export type CosmosElementFaqItemParentConnectInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabConnectInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqConnectInput>;
};

export type CosmosElementFaqItemParentCreateInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabCreateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateInput>;
};

export type CosmosElementFaqItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementFAQItemParent documents */
  create?: InputMaybe<Array<CosmosElementFaqItemParentCreateInput>>;
};

export type CosmosElementFaqItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementFAQItemParent document */
  create?: InputMaybe<CosmosElementFaqItemParentCreateInput>;
};

export type CosmosElementFaqItemParentCreateWithPositionInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabCreateWithPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateWithPositionInput>;
};

export type CosmosElementFaqItemParentUpdateInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpdateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateInput>;
};

export type CosmosElementFaqItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementFAQItemParent component instances */
  create?: InputMaybe<Array<CosmosElementFaqItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementFAQItemParent documents */
  delete?: InputMaybe<Array<CosmosElementFaqItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementFAQItemParent component instances */
  update?: InputMaybe<Array<CosmosElementFaqItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementFAQItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementFaqItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementFaqItemParentUpdateManyWithNestedWhereInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpdateManyWithNestedWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateManyWithNestedWhereInput>;
};

export type CosmosElementFaqItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementFAQItemParent document */
  create?: InputMaybe<CosmosElementFaqItemParentCreateInput>;
  /** Delete currently connected CosmosElementFAQItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementFAQItemParent document */
  update?: InputMaybe<CosmosElementFaqItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementFAQItemParent document */
  upsert?: InputMaybe<CosmosElementFaqItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementFaqItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementFaqItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqItemParentWhereInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereInput>;
};

export type CosmosElementFaqItemParentWhereUniqueInput = {
  CosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereUniqueInput>;
};

export type CosmosElementFaqItemUpdateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['RichTextAST']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementFaqItemUpdateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementFaqItemUpdateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['RichTextAST']['input']>;
  question?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementFaqItemUpdateLocalizationInput = {
  data: CosmosElementFaqItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFaqItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementFaqItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementFaqItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementFaqItemUpsertLocalizationInput>>;
};

export type CosmosElementFaqItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementFAQItem component instances */
  create?: InputMaybe<Array<CosmosElementFaqItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementFAQItem documents */
  delete?: InputMaybe<Array<CosmosElementFaqItemWhereUniqueInput>>;
  /** Update multiple CosmosElementFAQItem component instances */
  update?: InputMaybe<Array<CosmosElementFaqItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementFAQItem component instances */
  upsert?: InputMaybe<Array<CosmosElementFaqItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementFaqItemUpdateManyInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['RichTextAST']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementFaqItemUpdateManyLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementFaqItemUpdateManyLocalizationDataInput = {
  answer?: InputMaybe<Scalars['RichTextAST']['input']>;
  question?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementFaqItemUpdateManyLocalizationInput = {
  data: CosmosElementFaqItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFaqItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementFaqItemUpdateManyLocalizationInput>>;
};

export type CosmosElementFaqItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementFaqItemUpdateManyInput;
  /** Document search */
  where: CosmosElementFaqItemWhereInput;
};

export type CosmosElementFaqItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementFAQItem document */
  create?: InputMaybe<CosmosElementFaqItemCreateInput>;
  /** Delete currently connected CosmosElementFAQItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementFAQItem document */
  update?: InputMaybe<CosmosElementFaqItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementFAQItem document */
  upsert?: InputMaybe<CosmosElementFaqItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementFaqItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementFaqItemWhereUniqueInput;
};

export type CosmosElementFaqItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementFaqItemUpdateInput;
  /** Unique document search */
  where: CosmosElementFaqItemWhereUniqueInput;
};

export type CosmosElementFaqItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementFaqItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementFaqItemUpdateInput;
};

export type CosmosElementFaqItemUpsertLocalizationInput = {
  create: CosmosElementFaqItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementFaqItemUpdateLocalizationDataInput;
};

export type CosmosElementFaqItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementFaqItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementFaqItemWhereUniqueInput;
};

export type CosmosElementFaqItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementFaqItemUpsertInput;
  /** Unique document search */
  where: CosmosElementFaqItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementFaqItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementFaqItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementFaqItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementFaqItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementFAQItem record uniquely */
export type CosmosElementFaqItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementFaqTab = Entity & {
  __typename?: 'CosmosElementFaqTab';
  /** This is the id (you might enter "general") that can be linked to (like "/faq/#general") from another page to scroll to this FAQ Tab. */
  anchorLinkId?: Maybe<Scalars['String']['output']>;
  firstItemDefaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Deprecated. For new FAQs, use [ref] FAQ Items. */
  items: Array<CosmosElementFaqItem>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementFaqTab>;
  /** Use for new/migrated FAQs. Mixing "FAQ Items" and "Ref FAQ Items" is not recommended. */
  refFaqItems: Array<CosmosReferenceFaqItem>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementFaqTabItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementFaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementFaqItemWhereInput>;
};


export type CosmosElementFaqTabLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementFaqTabRefFaqItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceFaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
};


export type CosmosElementFaqTabUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementFaqTabConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementFaqTabWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementFaqTabConnection = {
  __typename?: 'CosmosElementFaqTabConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementFaqTabEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementFaqTabCreateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<CosmosElementFaqItemCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementFaqTabCreateLocalizationsInput>;
  refFaqItems?: InputMaybe<CosmosReferenceFaqItemCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementFaqTabCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementFaqTabCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementFaqTabCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFaqTabCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementFaqTabCreateLocalizationInput>>;
};

export type CosmosElementFaqTabCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementFaqTab documents */
  create?: InputMaybe<Array<CosmosElementFaqTabCreateInput>>;
};

export type CosmosElementFaqTabCreateOneInlineInput = {
  /** Create and connect one CosmosElementFaqTab document */
  create?: InputMaybe<CosmosElementFaqTabCreateInput>;
};

export type CosmosElementFaqTabCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementFaqTabCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementFaqTabEdge = {
  __typename?: 'CosmosElementFaqTabEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementFaqTab;
};

/** Identifies documents */
export type CosmosElementFaqTabManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementFaqTabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementFaqTabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementFaqTabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  firstItemDefaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_none?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_some?: InputMaybe<CosmosElementFaqItemWhereInput>;
  refFaqItems_every?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_none?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_some?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementFaqTabOrderByInput {
  AnchorLinkIdAsc = 'anchorLinkId_ASC',
  AnchorLinkIdDesc = 'anchorLinkId_DESC',
  FirstItemDefaultOpenAsc = 'firstItemDefaultOpen_ASC',
  FirstItemDefaultOpenDesc = 'firstItemDefaultOpen_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementFaqTabParent = CosmosSectionFaqSearch;

export type CosmosElementFaqTabParentConnectInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchConnectInput>;
};

export type CosmosElementFaqTabParentCreateInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
};

export type CosmosElementFaqTabParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementFaqTabParent documents */
  create?: InputMaybe<Array<CosmosElementFaqTabParentCreateInput>>;
};

export type CosmosElementFaqTabParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementFaqTabParent document */
  create?: InputMaybe<CosmosElementFaqTabParentCreateInput>;
};

export type CosmosElementFaqTabParentCreateWithPositionInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateWithPositionInput>;
};

export type CosmosElementFaqTabParentUpdateInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateInput>;
};

export type CosmosElementFaqTabParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementFaqTabParent component instances */
  create?: InputMaybe<Array<CosmosElementFaqTabParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementFaqTabParent documents */
  delete?: InputMaybe<Array<CosmosElementFaqTabParentWhereUniqueInput>>;
  /** Update multiple CosmosElementFaqTabParent component instances */
  update?: InputMaybe<Array<CosmosElementFaqTabParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementFaqTabParent component instances */
  upsert?: InputMaybe<Array<CosmosElementFaqTabParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementFaqTabParentUpdateManyWithNestedWhereInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateManyWithNestedWhereInput>;
};

export type CosmosElementFaqTabParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementFaqTabParent document */
  create?: InputMaybe<CosmosElementFaqTabParentCreateInput>;
  /** Delete currently connected CosmosElementFaqTabParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementFaqTabParent document */
  update?: InputMaybe<CosmosElementFaqTabParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementFaqTabParent document */
  upsert?: InputMaybe<CosmosElementFaqTabParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqTabParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementFaqTabParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqTabParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementFaqTabParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqTabParentWhereInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereInput>;
};

export type CosmosElementFaqTabParentWhereUniqueInput = {
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereUniqueInput>;
};

export type CosmosElementFaqTabUpdateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<CosmosElementFaqItemUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementFaqTabUpdateLocalizationsInput>;
  refFaqItems?: InputMaybe<CosmosReferenceFaqItemUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementFaqTabUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementFaqTabUpdateLocalizationInput = {
  data: CosmosElementFaqTabUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFaqTabUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementFaqTabCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementFaqTabUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementFaqTabUpsertLocalizationInput>>;
};

export type CosmosElementFaqTabUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementFaqTab component instances */
  create?: InputMaybe<Array<CosmosElementFaqTabCreateWithPositionInput>>;
  /** Delete multiple CosmosElementFaqTab documents */
  delete?: InputMaybe<Array<CosmosElementFaqTabWhereUniqueInput>>;
  /** Update multiple CosmosElementFaqTab component instances */
  update?: InputMaybe<Array<CosmosElementFaqTabUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementFaqTab component instances */
  upsert?: InputMaybe<Array<CosmosElementFaqTabUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementFaqTabUpdateManyInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementFaqTabUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementFaqTabUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementFaqTabUpdateManyLocalizationInput = {
  data: CosmosElementFaqTabUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFaqTabUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementFaqTabUpdateManyLocalizationInput>>;
};

export type CosmosElementFaqTabUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementFaqTabUpdateManyInput;
  /** Document search */
  where: CosmosElementFaqTabWhereInput;
};

export type CosmosElementFaqTabUpdateOneInlineInput = {
  /** Create and connect one CosmosElementFaqTab document */
  create?: InputMaybe<CosmosElementFaqTabCreateInput>;
  /** Delete currently connected CosmosElementFaqTab document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementFaqTab document */
  update?: InputMaybe<CosmosElementFaqTabUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementFaqTab document */
  upsert?: InputMaybe<CosmosElementFaqTabUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFaqTabUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementFaqTabUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementFaqTabWhereUniqueInput;
};

export type CosmosElementFaqTabUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementFaqTabUpdateInput;
  /** Unique document search */
  where: CosmosElementFaqTabWhereUniqueInput;
};

export type CosmosElementFaqTabUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementFaqTabCreateInput;
  /** Update document if it exists */
  update: CosmosElementFaqTabUpdateInput;
};

export type CosmosElementFaqTabUpsertLocalizationInput = {
  create: CosmosElementFaqTabCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementFaqTabUpdateLocalizationDataInput;
};

export type CosmosElementFaqTabUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementFaqTabUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementFaqTabWhereUniqueInput;
};

export type CosmosElementFaqTabUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementFaqTabUpsertInput;
  /** Unique document search */
  where: CosmosElementFaqTabWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementFaqTabWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementFaqTabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementFaqTabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementFaqTabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  firstItemDefaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_none?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_some?: InputMaybe<CosmosElementFaqItemWhereInput>;
  refFaqItems_every?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_none?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_some?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementFaqTab record uniquely */
export type CosmosElementFaqTabWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementFeatureCard = Entity & {
  __typename?: 'CosmosElementFeatureCard';
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** aria-label for the image */
  imageLabel?: Maybe<Scalars['String']['output']>;
  /** Expected image aspect ratio is 16:9 */
  img: Asset;
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementFeatureCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementFeatureCardImgArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementFeatureCardConnection = {
  __typename?: 'CosmosElementFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementFeatureCardCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  img: AssetCreateOneInlineInput;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementFeatureCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementFeatureCardCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementFeatureCardCreateLocalizationInput>>;
};

export type CosmosElementFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementFeatureCard documents */
  create?: InputMaybe<Array<CosmosElementFeatureCardCreateInput>>;
};

export type CosmosElementFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementFeatureCard document */
  create?: InputMaybe<CosmosElementFeatureCardCreateInput>;
};

export type CosmosElementFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementFeatureCardEdge = {
  __typename?: 'CosmosElementFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementFeatureCard;
};

/** Identifies documents */
export type CosmosElementFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementFeatureCardOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageLabelAsc = 'imageLabel_ASC',
  ImageLabelDesc = 'imageLabel_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementFeatureCardParent = CosmosSectionFeatureCard;

export type CosmosElementFeatureCardParentConnectInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardConnectInput>;
};

export type CosmosElementFeatureCardParentCreateInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateInput>;
};

export type CosmosElementFeatureCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosElementFeatureCardParentCreateInput>>;
};

export type CosmosElementFeatureCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementFeatureCardParent document */
  create?: InputMaybe<CosmosElementFeatureCardParentCreateInput>;
};

export type CosmosElementFeatureCardParentCreateWithPositionInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateWithPositionInput>;
};

export type CosmosElementFeatureCardParentUpdateInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateInput>;
};

export type CosmosElementFeatureCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementFeatureCardParent component instances */
  create?: InputMaybe<Array<CosmosElementFeatureCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosElementFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementFeatureCardParent component instances */
  update?: InputMaybe<Array<CosmosElementFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementFeatureCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementFeatureCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementFeatureCardParent document */
  create?: InputMaybe<CosmosElementFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosElementFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementFeatureCardParent document */
  update?: InputMaybe<CosmosElementFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementFeatureCardParent document */
  upsert?: InputMaybe<CosmosElementFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFeatureCardParentWhereInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereInput>;
};

export type CosmosElementFeatureCardParentWhereUniqueInput = {
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereUniqueInput>;
};

export type CosmosElementFeatureCardUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<AssetUpdateOneInlineInput>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementFeatureCardUpdateLocalizationsInput>;
};

export type CosmosElementFeatureCardUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementFeatureCardUpdateLocalizationInput = {
  data: CosmosElementFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementFeatureCardUpsertLocalizationInput>>;
};

export type CosmosElementFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementFeatureCard component instances */
  create?: InputMaybe<Array<CosmosElementFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementFeatureCard documents */
  delete?: InputMaybe<Array<CosmosElementFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosElementFeatureCard component instances */
  update?: InputMaybe<Array<CosmosElementFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosElementFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementFeatureCardUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementFeatureCardUpdateManyLocalizationsInput>;
};

export type CosmosElementFeatureCardUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementFeatureCardUpdateManyLocalizationInput = {
  data: CosmosElementFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosElementFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosElementFeatureCardWhereInput;
};

export type CosmosElementFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementFeatureCard document */
  create?: InputMaybe<CosmosElementFeatureCardCreateInput>;
  /** Delete currently connected CosmosElementFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementFeatureCard document */
  update?: InputMaybe<CosmosElementFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementFeatureCard document */
  upsert?: InputMaybe<CosmosElementFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementFeatureCardWhereUniqueInput;
};

export type CosmosElementFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosElementFeatureCardWhereUniqueInput;
};

export type CosmosElementFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementFeatureCardUpdateInput;
};

export type CosmosElementFeatureCardUpsertLocalizationInput = {
  create: CosmosElementFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementFeatureCardUpdateLocalizationDataInput;
};

export type CosmosElementFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementFeatureCardWhereUniqueInput;
};

export type CosmosElementFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosElementFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<AssetWhereInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementFeatureCard record uniquely */
export type CosmosElementFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementGameDevFeatureCard = Entity & {
  __typename?: 'CosmosElementGameDevFeatureCard';
  asset?: Maybe<Asset>;
  buttons: Array<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Optional eyebrow text above the title */
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Badges above the Title and Description stack. */
  eyebrowBadges: Array<CosmosElementTag>;
  flip?: Maybe<Scalars['Boolean']['output']>;
  /** Gradient to be applied to any hrefs in the card title */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  links: Array<CosmosElementLink>;
  /** Displays the links as tag pills */
  linksAsTags?: Maybe<Scalars['Boolean']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementGameDevFeatureCard>;
  modButtons: Array<CosmosElementGameDevFeatureCardmodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementGameDevFeatureCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementGameDevFeatureCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementGameDevFeatureCardEyebrowBadgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTagWhereInput>;
};


export type CosmosElementGameDevFeatureCardLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLinkWhereInput>;
};


export type CosmosElementGameDevFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementGameDevFeatureCardModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementGameDevFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementGameDevFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementGameDevFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementGameDevFeatureCardConnection = {
  __typename?: 'CosmosElementGameDevFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementGameDevFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementGameDevFeatureCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowBadges?: InputMaybe<CosmosElementTagCreateManyInlineInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementLinkCreateManyInlineInput>;
  linksAsTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementGameDevFeatureCardCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementGameDevFeatureCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementGameDevFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementGameDevFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGameDevFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardCreateLocalizationInput>>;
};

export type CosmosElementGameDevFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGameDevFeatureCard documents */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardCreateInput>>;
};

export type CosmosElementGameDevFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementGameDevFeatureCard document */
  create?: InputMaybe<CosmosElementGameDevFeatureCardCreateInput>;
};

export type CosmosElementGameDevFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementGameDevFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementGameDevFeatureCardEdge = {
  __typename?: 'CosmosElementGameDevFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementGameDevFeatureCard;
};

/** Identifies documents */
export type CosmosElementGameDevFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  eyebrowBadges_every?: InputMaybe<CosmosElementTagWhereInput>;
  eyebrowBadges_none?: InputMaybe<CosmosElementTagWhereInput>;
  eyebrowBadges_some?: InputMaybe<CosmosElementTagWhereInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  linksAsTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  linksAsTags_not?: InputMaybe<Scalars['Boolean']['input']>;
  links_every?: InputMaybe<CosmosElementLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementLinkWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementGameDevFeatureCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  FlipAsc = 'flip_ASC',
  FlipDesc = 'flip_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  LinksAsTagsAsc = 'linksAsTags_ASC',
  LinksAsTagsDesc = 'linksAsTags_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementGameDevFeatureCardParent = CosmosElementAccordionFeatureCard | CosmosSectionGameDevFeatureCard;

export type CosmosElementGameDevFeatureCardParentConnectInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardConnectInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardConnectInput>;
};

export type CosmosElementGameDevFeatureCardParentCreateInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardCreateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateInput>;
};

export type CosmosElementGameDevFeatureCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGameDevFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardParentCreateInput>>;
};

export type CosmosElementGameDevFeatureCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementGameDevFeatureCardParent document */
  create?: InputMaybe<CosmosElementGameDevFeatureCardParentCreateInput>;
};

export type CosmosElementGameDevFeatureCardParentCreateWithPositionInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardCreateWithPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateWithPositionInput>;
};

export type CosmosElementGameDevFeatureCardParentUpdateInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardUpdateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateInput>;
};

export type CosmosElementGameDevFeatureCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGameDevFeatureCardParent component instances */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGameDevFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosElementGameDevFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementGameDevFeatureCardParent component instances */
  update?: InputMaybe<Array<CosmosElementGameDevFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGameDevFeatureCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementGameDevFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGameDevFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementGameDevFeatureCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGameDevFeatureCardParent document */
  create?: InputMaybe<CosmosElementGameDevFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosElementGameDevFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGameDevFeatureCardParent document */
  update?: InputMaybe<CosmosElementGameDevFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGameDevFeatureCardParent document */
  upsert?: InputMaybe<CosmosElementGameDevFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGameDevFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGameDevFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardParentWhereInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereInput>;
};

export type CosmosElementGameDevFeatureCardParentWhereUniqueInput = {
  CosmosElementAccordionFeatureCard?: InputMaybe<CosmosElementAccordionFeatureCardWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowBadges?: InputMaybe<CosmosElementTagUpdateManyInlineInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementLinkUpdateManyInlineInput>;
  linksAsTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementGameDevFeatureCardUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGameDevFeatureCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGameDevFeatureCardUpdateLocalizationInput = {
  data: CosmosElementGameDevFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGameDevFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementGameDevFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementGameDevFeatureCardUpsertLocalizationInput>>;
};

export type CosmosElementGameDevFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGameDevFeatureCard component instances */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGameDevFeatureCard documents */
  delete?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosElementGameDevFeatureCard component instances */
  update?: InputMaybe<Array<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGameDevFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGameDevFeatureCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  linksAsTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGameDevFeatureCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGameDevFeatureCardUpdateManyLocalizationInput = {
  data: CosmosElementGameDevFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGameDevFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementGameDevFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosElementGameDevFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementGameDevFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosElementGameDevFeatureCardWhereInput;
};

export type CosmosElementGameDevFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGameDevFeatureCard document */
  create?: InputMaybe<CosmosElementGameDevFeatureCardCreateInput>;
  /** Delete currently connected CosmosElementGameDevFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGameDevFeatureCard document */
  update?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGameDevFeatureCard document */
  upsert?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementGameDevFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGameDevFeatureCardWhereUniqueInput;
};

export type CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementGameDevFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosElementGameDevFeatureCardWhereUniqueInput;
};

export type CosmosElementGameDevFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementGameDevFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementGameDevFeatureCardUpdateInput;
};

export type CosmosElementGameDevFeatureCardUpsertLocalizationInput = {
  create: CosmosElementGameDevFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementGameDevFeatureCardUpdateLocalizationDataInput;
};

export type CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementGameDevFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGameDevFeatureCardWhereUniqueInput;
};

export type CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementGameDevFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosElementGameDevFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementGameDevFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGameDevFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowBadges_every?: InputMaybe<CosmosElementTagWhereInput>;
  eyebrowBadges_none?: InputMaybe<CosmosElementTagWhereInput>;
  eyebrowBadges_some?: InputMaybe<CosmosElementTagWhereInput>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  linksAsTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  linksAsTags_not?: InputMaybe<Scalars['Boolean']['input']>;
  links_every?: InputMaybe<CosmosElementLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementLinkWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementGameDevFeatureCard record uniquely */
export type CosmosElementGameDevFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosElementGameDevFeatureCardmodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGameDevFeatureCardmodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardmodButtonsUnionCreateInput>>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementGameDevFeatureCardmodButtonsUnion document */
  create?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionCreateInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGameDevFeatureCardmodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosElementGameDevFeatureCardmodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGameDevFeatureCardmodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosElementGameDevFeatureCardmodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementGameDevFeatureCardmodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosElementGameDevFeatureCardmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGameDevFeatureCardmodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementGameDevFeatureCardmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGameDevFeatureCardmodButtonsUnion document */
  create?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosElementGameDevFeatureCardmodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGameDevFeatureCardmodButtonsUnion document */
  update?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGameDevFeatureCardmodButtonsUnion document */
  upsert?: InputMaybe<CosmosElementGameDevFeatureCardmodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosElementGameDevFeatureCardmodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosElementGeminiCard = Entity & {
  __typename?: 'CosmosElementGeminiCard';
  /** This is the id (you might enter "pluginX") that can be linked to (like "<slug>#pluginX") from another page to scroll to this specific card. */
  anchorLinkId?: Maybe<Scalars['String']['output']>;
  /** Right side image asset */
  asset?: Maybe<Asset>;
  background?: Maybe<CosmosEnumMaterialCardBackground>;
  badge?: Maybe<CosmosElementTag>;
  /** Basic button array. Overridden if modular button array is specified. */
  buttons: Array<CosmosElementButton>;
  cardHref?: Maybe<Scalars['String']['output']>;
  /** Card description */
  desc?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<RichText>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  links: Array<CosmosElementGeminiLink>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementGeminiCard>;
  /** Array of button components */
  modButtons: Array<CosmosElementGeminiCardmodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementGeminiCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementGeminiCardBadgeArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementGeminiCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementGeminiCardLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementGeminiLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
};


export type CosmosElementGeminiCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementGeminiCardModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementGeminiCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementGeminiCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementGeminiCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementGeminiCardConnection = {
  __typename?: 'CosmosElementGeminiCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementGeminiCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementGeminiCardCreateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  background?: InputMaybe<CosmosEnumMaterialCardBackground>;
  badge?: InputMaybe<CosmosElementTagCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** cardHref input for default locale (en) */
  cardHref?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** heading input for default locale (en) */
  heading?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementGeminiLinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementGeminiCardCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementGeminiCardCreateLocalizationDataInput = {
  cardHref?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementGeminiCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementGeminiCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGeminiCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementGeminiCardCreateLocalizationInput>>;
};

export type CosmosElementGeminiCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGeminiCard documents */
  create?: InputMaybe<Array<CosmosElementGeminiCardCreateInput>>;
};

export type CosmosElementGeminiCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiCard document */
  create?: InputMaybe<CosmosElementGeminiCardCreateInput>;
};

export type CosmosElementGeminiCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementGeminiCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementGeminiCardEdge = {
  __typename?: 'CosmosElementGeminiCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementGeminiCard;
};

/** Identifies documents */
export type CosmosElementGeminiCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGeminiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGeminiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGeminiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  background?: InputMaybe<CosmosEnumMaterialCardBackground>;
  /** All values that are contained in given list. */
  background_in?: InputMaybe<Array<InputMaybe<CosmosEnumMaterialCardBackground>>>;
  /** Any other value that exists and is not equal to the given value. */
  background_not?: InputMaybe<CosmosEnumMaterialCardBackground>;
  /** All values that are not contained in given list. */
  background_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumMaterialCardBackground>>>;
  badge?: InputMaybe<CosmosElementTagWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementGeminiCardOrderByInput {
  AnchorLinkIdAsc = 'anchorLinkId_ASC',
  AnchorLinkIdDesc = 'anchorLinkId_DESC',
  BackgroundAsc = 'background_ASC',
  BackgroundDesc = 'background_DESC',
  CardHrefAsc = 'cardHref_ASC',
  CardHrefDesc = 'cardHref_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementGeminiCardParent = CosmosPageSearch | CosmosSectionGeminiCard;

export type CosmosElementGeminiCardParentConnectInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchConnectInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardConnectInput>;
};

export type CosmosElementGeminiCardParentCreateInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchCreateInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardCreateInput>;
};

export type CosmosElementGeminiCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementGeminiCardParent documents */
  connect?: InputMaybe<Array<CosmosElementGeminiCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementGeminiCardParent documents */
  create?: InputMaybe<Array<CosmosElementGeminiCardParentCreateInput>>;
};

export type CosmosElementGeminiCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementGeminiCardParent document */
  connect?: InputMaybe<CosmosElementGeminiCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementGeminiCardParent document */
  create?: InputMaybe<CosmosElementGeminiCardParentCreateInput>;
};

export type CosmosElementGeminiCardParentUpdateInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateInput>;
};

export type CosmosElementGeminiCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementGeminiCardParent documents */
  connect?: InputMaybe<Array<CosmosElementGeminiCardParentConnectInput>>;
  /** Create and connect multiple CosmosElementGeminiCardParent documents */
  create?: InputMaybe<Array<CosmosElementGeminiCardParentCreateInput>>;
  /** Delete multiple CosmosElementGeminiCardParent documents */
  delete?: InputMaybe<Array<CosmosElementGeminiCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementGeminiCardParent documents */
  disconnect?: InputMaybe<Array<CosmosElementGeminiCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementGeminiCardParent documents */
  set?: InputMaybe<Array<CosmosElementGeminiCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementGeminiCardParent documents */
  update?: InputMaybe<Array<CosmosElementGeminiCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementGeminiCardParent documents */
  upsert?: InputMaybe<Array<CosmosElementGeminiCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementGeminiCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementGeminiCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementGeminiCardParent document */
  connect?: InputMaybe<CosmosElementGeminiCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementGeminiCardParent document */
  create?: InputMaybe<CosmosElementGeminiCardParentCreateInput>;
  /** Delete currently connected CosmosElementGeminiCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementGeminiCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGeminiCardParent document */
  update?: InputMaybe<CosmosElementGeminiCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGeminiCardParent document */
  upsert?: InputMaybe<CosmosElementGeminiCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardParentWhereInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchWhereInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardWhereInput>;
};

export type CosmosElementGeminiCardParentWhereUniqueInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardWhereUniqueInput>;
};

export type CosmosElementGeminiCardUpdateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  background?: InputMaybe<CosmosEnumMaterialCardBackground>;
  badge?: InputMaybe<CosmosElementTagUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** cardHref input for default locale (en) */
  cardHref?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** heading input for default locale (en) */
  heading?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementGeminiLinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementGeminiCardUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGeminiCardUpdateLocalizationDataInput = {
  cardHref?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGeminiCardUpdateLocalizationInput = {
  data: CosmosElementGeminiCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGeminiCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementGeminiCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementGeminiCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementGeminiCardUpsertLocalizationInput>>;
};

export type CosmosElementGeminiCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGeminiCard component instances */
  create?: InputMaybe<Array<CosmosElementGeminiCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGeminiCard documents */
  delete?: InputMaybe<Array<CosmosElementGeminiCardWhereUniqueInput>>;
  /** Update multiple CosmosElementGeminiCard component instances */
  update?: InputMaybe<Array<CosmosElementGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGeminiCard component instances */
  upsert?: InputMaybe<Array<CosmosElementGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGeminiCardUpdateManyInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<CosmosEnumMaterialCardBackground>;
  /** cardHref input for default locale (en) */
  cardHref?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** heading input for default locale (en) */
  heading?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementGeminiCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGeminiCardUpdateManyLocalizationDataInput = {
  cardHref?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementGeminiCardUpdateManyLocalizationInput = {
  data: CosmosElementGeminiCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGeminiCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementGeminiCardUpdateManyLocalizationInput>>;
};

export type CosmosElementGeminiCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementGeminiCardUpdateManyInput;
  /** Document search */
  where: CosmosElementGeminiCardWhereInput;
};

export type CosmosElementGeminiCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiCard document */
  create?: InputMaybe<CosmosElementGeminiCardCreateInput>;
  /** Delete currently connected CosmosElementGeminiCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGeminiCard document */
  update?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGeminiCard document */
  upsert?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementGeminiCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGeminiCardWhereUniqueInput;
};

export type CosmosElementGeminiCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementGeminiCardUpdateInput;
  /** Unique document search */
  where: CosmosElementGeminiCardWhereUniqueInput;
};

export type CosmosElementGeminiCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementGeminiCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementGeminiCardUpdateInput;
};

export type CosmosElementGeminiCardUpsertLocalizationInput = {
  create: CosmosElementGeminiCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementGeminiCardUpdateLocalizationDataInput;
};

export type CosmosElementGeminiCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementGeminiCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGeminiCardWhereUniqueInput;
};

export type CosmosElementGeminiCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementGeminiCardUpsertInput;
  /** Unique document search */
  where: CosmosElementGeminiCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementGeminiCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGeminiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGeminiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGeminiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  background?: InputMaybe<CosmosEnumMaterialCardBackground>;
  /** All values that are contained in given list. */
  background_in?: InputMaybe<Array<InputMaybe<CosmosEnumMaterialCardBackground>>>;
  /** Any other value that exists and is not equal to the given value. */
  background_not?: InputMaybe<CosmosEnumMaterialCardBackground>;
  /** All values that are not contained in given list. */
  background_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumMaterialCardBackground>>>;
  badge?: InputMaybe<CosmosElementTagWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  cardHref?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardHref_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardHref_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardHref_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardHref_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardHref_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardHref_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardHref_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardHref_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardHref_starts_with?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementGeminiLinkWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementGeminiCard record uniquely */
export type CosmosElementGeminiCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementGeminiCardmodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosElementGeminiCardmodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGeminiCardmodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosElementGeminiCardmodButtonsUnionCreateInput>>;
};

export type CosmosElementGeminiCardmodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiCardmodButtonsUnion document */
  create?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionCreateInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGeminiCardmodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosElementGeminiCardmodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGeminiCardmodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosElementGeminiCardmodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementGeminiCardmodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosElementGeminiCardmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGeminiCardmodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementGeminiCardmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiCardmodButtonsUnion document */
  create?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosElementGeminiCardmodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGeminiCardmodButtonsUnion document */
  update?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGeminiCardmodButtonsUnion document */
  upsert?: InputMaybe<CosmosElementGeminiCardmodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosElementGeminiCardmodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosElementGeminiLink = Entity & {
  __typename?: 'CosmosElementGeminiLink';
  endIcon?: Maybe<CosmosEnumLinkIcons>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementGeminiLink>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementGeminiLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementGeminiLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementGeminiLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementGeminiLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementGeminiLinkConnection = {
  __typename?: 'CosmosElementGeminiLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementGeminiLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementGeminiLinkCreateInput = {
  endIcon?: InputMaybe<CosmosEnumLinkIcons>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementGeminiLinkCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementGeminiLinkCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementGeminiLinkCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementGeminiLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGeminiLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementGeminiLinkCreateLocalizationInput>>;
};

export type CosmosElementGeminiLinkCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGeminiLink documents */
  create?: InputMaybe<Array<CosmosElementGeminiLinkCreateInput>>;
};

export type CosmosElementGeminiLinkCreateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiLink document */
  create?: InputMaybe<CosmosElementGeminiLinkCreateInput>;
};

export type CosmosElementGeminiLinkCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementGeminiLinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementGeminiLinkEdge = {
  __typename?: 'CosmosElementGeminiLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementGeminiLink;
};

/** Identifies documents */
export type CosmosElementGeminiLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGeminiLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGeminiLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGeminiLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  endIcon?: InputMaybe<CosmosEnumLinkIcons>;
  /** All values that are contained in given list. */
  endIcon_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  endIcon_not?: InputMaybe<CosmosEnumLinkIcons>;
  /** All values that are not contained in given list. */
  endIcon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementGeminiLinkOrderByInput {
  EndIconAsc = 'endIcon_ASC',
  EndIconDesc = 'endIcon_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementGeminiLinkParent = CosmosElementGeminiCard;

export type CosmosElementGeminiLinkParentConnectInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardConnectInput>;
};

export type CosmosElementGeminiLinkParentCreateInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateInput>;
};

export type CosmosElementGeminiLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGeminiLinkParent documents */
  create?: InputMaybe<Array<CosmosElementGeminiLinkParentCreateInput>>;
};

export type CosmosElementGeminiLinkParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiLinkParent document */
  create?: InputMaybe<CosmosElementGeminiLinkParentCreateInput>;
};

export type CosmosElementGeminiLinkParentCreateWithPositionInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateWithPositionInput>;
};

export type CosmosElementGeminiLinkParentUpdateInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateInput>;
};

export type CosmosElementGeminiLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGeminiLinkParent component instances */
  create?: InputMaybe<Array<CosmosElementGeminiLinkParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGeminiLinkParent documents */
  delete?: InputMaybe<Array<CosmosElementGeminiLinkParentWhereUniqueInput>>;
  /** Update multiple CosmosElementGeminiLinkParent component instances */
  update?: InputMaybe<Array<CosmosElementGeminiLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGeminiLinkParent component instances */
  upsert?: InputMaybe<Array<CosmosElementGeminiLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGeminiLinkParentUpdateManyWithNestedWhereInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementGeminiLinkParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiLinkParent document */
  create?: InputMaybe<CosmosElementGeminiLinkParentCreateInput>;
  /** Delete currently connected CosmosElementGeminiLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGeminiLinkParent document */
  update?: InputMaybe<CosmosElementGeminiLinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGeminiLinkParent document */
  upsert?: InputMaybe<CosmosElementGeminiLinkParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGeminiLinkParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementGeminiLinkParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiLinkParentWhereInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereInput>;
};

export type CosmosElementGeminiLinkParentWhereUniqueInput = {
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereUniqueInput>;
};

export type CosmosElementGeminiLinkUpdateInput = {
  endIcon?: InputMaybe<CosmosEnumLinkIcons>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementGeminiLinkUpdateLocalizationsInput>;
};

export type CosmosElementGeminiLinkUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementGeminiLinkUpdateLocalizationInput = {
  data: CosmosElementGeminiLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGeminiLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementGeminiLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementGeminiLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementGeminiLinkUpsertLocalizationInput>>;
};

export type CosmosElementGeminiLinkUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGeminiLink component instances */
  create?: InputMaybe<Array<CosmosElementGeminiLinkCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGeminiLink documents */
  delete?: InputMaybe<Array<CosmosElementGeminiLinkWhereUniqueInput>>;
  /** Update multiple CosmosElementGeminiLink component instances */
  update?: InputMaybe<Array<CosmosElementGeminiLinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGeminiLink component instances */
  upsert?: InputMaybe<Array<CosmosElementGeminiLinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGeminiLinkUpdateManyInput = {
  endIcon?: InputMaybe<CosmosEnumLinkIcons>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementGeminiLinkUpdateManyLocalizationsInput>;
};

export type CosmosElementGeminiLinkUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementGeminiLinkUpdateManyLocalizationInput = {
  data: CosmosElementGeminiLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementGeminiLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementGeminiLinkUpdateManyLocalizationInput>>;
};

export type CosmosElementGeminiLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementGeminiLinkUpdateManyInput;
  /** Document search */
  where: CosmosElementGeminiLinkWhereInput;
};

export type CosmosElementGeminiLinkUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGeminiLink document */
  create?: InputMaybe<CosmosElementGeminiLinkCreateInput>;
  /** Delete currently connected CosmosElementGeminiLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGeminiLink document */
  update?: InputMaybe<CosmosElementGeminiLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGeminiLink document */
  upsert?: InputMaybe<CosmosElementGeminiLinkUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGeminiLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementGeminiLinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGeminiLinkWhereUniqueInput;
};

export type CosmosElementGeminiLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementGeminiLinkUpdateInput;
  /** Unique document search */
  where: CosmosElementGeminiLinkWhereUniqueInput;
};

export type CosmosElementGeminiLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementGeminiLinkCreateInput;
  /** Update document if it exists */
  update: CosmosElementGeminiLinkUpdateInput;
};

export type CosmosElementGeminiLinkUpsertLocalizationInput = {
  create: CosmosElementGeminiLinkCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementGeminiLinkUpdateLocalizationDataInput;
};

export type CosmosElementGeminiLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementGeminiLinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGeminiLinkWhereUniqueInput;
};

export type CosmosElementGeminiLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementGeminiLinkUpsertInput;
  /** Unique document search */
  where: CosmosElementGeminiLinkWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementGeminiLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGeminiLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGeminiLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGeminiLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  endIcon?: InputMaybe<CosmosEnumLinkIcons>;
  /** All values that are contained in given list. */
  endIcon_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  endIcon_not?: InputMaybe<CosmosEnumLinkIcons>;
  /** All values that are not contained in given list. */
  endIcon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementGeminiLink record uniquely */
export type CosmosElementGeminiLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementGithubGist = Entity & {
  __typename?: 'CosmosElementGithubGist';
  file?: Maybe<Scalars['String']['output']>;
  gistId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CosmosElementGithubGistConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementGithubGistWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementGithubGistConnection = {
  __typename?: 'CosmosElementGithubGistConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementGithubGistEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementGithubGistCreateInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  gistId?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementGithubGistCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementGithubGist documents */
  create?: InputMaybe<Array<CosmosElementGithubGistCreateInput>>;
};

export type CosmosElementGithubGistCreateOneInlineInput = {
  /** Create and connect one CosmosElementGithubGist document */
  create?: InputMaybe<CosmosElementGithubGistCreateInput>;
};

export type CosmosElementGithubGistCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementGithubGistCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementGithubGistEdge = {
  __typename?: 'CosmosElementGithubGistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementGithubGist;
};

/** Identifies documents */
export type CosmosElementGithubGistManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGithubGistWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGithubGistWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGithubGistWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  file_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  file_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  file_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  file_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  file_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  file_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  file_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  file_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  file_starts_with?: InputMaybe<Scalars['String']['input']>;
  gistId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  gistId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  gistId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  gistId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  gistId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  gistId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  gistId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  gistId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  gistId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  gistId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  username_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  username_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  username_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  username_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  username_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  username_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  username_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  username_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  username_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CosmosElementGithubGistOrderByInput {
  FileAsc = 'file_ASC',
  FileDesc = 'file_DESC',
  GistIdAsc = 'gistId_ASC',
  GistIdDesc = 'gistId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UsernameAsc = 'username_ASC',
  UsernameDesc = 'username_DESC'
}

export type CosmosElementGithubGistParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementGithubGistParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementGithubGistParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementGithubGistParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementGithubGistParent documents */
  connect?: InputMaybe<Array<CosmosElementGithubGistParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementGithubGistParent documents */
  create?: InputMaybe<Array<CosmosElementGithubGistParentCreateInput>>;
};

export type CosmosElementGithubGistParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementGithubGistParent document */
  connect?: InputMaybe<CosmosElementGithubGistParentWhereUniqueInput>;
  /** Create and connect one CosmosElementGithubGistParent document */
  create?: InputMaybe<CosmosElementGithubGistParentCreateInput>;
};

export type CosmosElementGithubGistParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementGithubGistParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementGithubGistParent documents */
  connect?: InputMaybe<Array<CosmosElementGithubGistParentConnectInput>>;
  /** Create and connect multiple CosmosElementGithubGistParent documents */
  create?: InputMaybe<Array<CosmosElementGithubGistParentCreateInput>>;
  /** Delete multiple CosmosElementGithubGistParent documents */
  delete?: InputMaybe<Array<CosmosElementGithubGistParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementGithubGistParent documents */
  disconnect?: InputMaybe<Array<CosmosElementGithubGistParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementGithubGistParent documents */
  set?: InputMaybe<Array<CosmosElementGithubGistParentWhereUniqueInput>>;
  /** Update multiple CosmosElementGithubGistParent documents */
  update?: InputMaybe<Array<CosmosElementGithubGistParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementGithubGistParent documents */
  upsert?: InputMaybe<Array<CosmosElementGithubGistParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementGithubGistParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementGithubGistParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementGithubGistParent document */
  connect?: InputMaybe<CosmosElementGithubGistParentWhereUniqueInput>;
  /** Create and connect one CosmosElementGithubGistParent document */
  create?: InputMaybe<CosmosElementGithubGistParentCreateInput>;
  /** Delete currently connected CosmosElementGithubGistParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementGithubGistParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGithubGistParent document */
  update?: InputMaybe<CosmosElementGithubGistParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGithubGistParent document */
  upsert?: InputMaybe<CosmosElementGithubGistParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGithubGistParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementGithubGistParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGithubGistParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementGithubGistParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementGithubGistUpdateInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  gistId?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementGithubGistUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementGithubGist component instances */
  create?: InputMaybe<Array<CosmosElementGithubGistCreateWithPositionInput>>;
  /** Delete multiple CosmosElementGithubGist documents */
  delete?: InputMaybe<Array<CosmosElementGithubGistWhereUniqueInput>>;
  /** Update multiple CosmosElementGithubGist component instances */
  update?: InputMaybe<Array<CosmosElementGithubGistUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementGithubGist component instances */
  upsert?: InputMaybe<Array<CosmosElementGithubGistUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementGithubGistUpdateManyInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  gistId?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementGithubGistUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementGithubGistUpdateManyInput;
  /** Document search */
  where: CosmosElementGithubGistWhereInput;
};

export type CosmosElementGithubGistUpdateOneInlineInput = {
  /** Create and connect one CosmosElementGithubGist document */
  create?: InputMaybe<CosmosElementGithubGistCreateInput>;
  /** Delete currently connected CosmosElementGithubGist document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementGithubGist document */
  update?: InputMaybe<CosmosElementGithubGistUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementGithubGist document */
  upsert?: InputMaybe<CosmosElementGithubGistUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementGithubGistUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementGithubGistUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGithubGistWhereUniqueInput;
};

export type CosmosElementGithubGistUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementGithubGistUpdateInput;
  /** Unique document search */
  where: CosmosElementGithubGistWhereUniqueInput;
};

export type CosmosElementGithubGistUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementGithubGistCreateInput;
  /** Update document if it exists */
  update: CosmosElementGithubGistUpdateInput;
};

export type CosmosElementGithubGistUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementGithubGistUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementGithubGistWhereUniqueInput;
};

export type CosmosElementGithubGistUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementGithubGistUpsertInput;
  /** Unique document search */
  where: CosmosElementGithubGistWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementGithubGistWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementGithubGistWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementGithubGistWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementGithubGistWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  file_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  file_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  file_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  file_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  file_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  file_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  file_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  file_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  file_starts_with?: InputMaybe<Scalars['String']['input']>;
  gistId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  gistId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  gistId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  gistId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  gistId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  gistId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  gistId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  gistId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  gistId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  gistId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  username_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  username_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  username_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  username_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  username_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  username_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  username_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  username_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  username_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CosmosElementGithubGist record uniquely */
export type CosmosElementGithubGistWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementHydrusColumn = Entity & {
  __typename?: 'CosmosElementHydrusColumn';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<CosmosElementHydrusLink>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementHydrusColumn>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  titleHref?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementHydrusColumnLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementHydrusLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
};


export type CosmosElementHydrusColumnLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementHydrusColumnUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementHydrusColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementHydrusColumnWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementHydrusColumnConnection = {
  __typename?: 'CosmosElementHydrusColumnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementHydrusColumnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementHydrusColumnCreateInput = {
  links?: InputMaybe<CosmosElementHydrusLinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementHydrusColumnCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementHydrusColumnCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementHydrusColumnCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementHydrusColumnCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementHydrusColumnCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementHydrusColumnCreateLocalizationInput>>;
};

export type CosmosElementHydrusColumnCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementHydrusColumn documents */
  create?: InputMaybe<Array<CosmosElementHydrusColumnCreateInput>>;
};

export type CosmosElementHydrusColumnCreateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusColumn document */
  create?: InputMaybe<CosmosElementHydrusColumnCreateInput>;
};

export type CosmosElementHydrusColumnCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementHydrusColumnCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementHydrusColumnEdge = {
  __typename?: 'CosmosElementHydrusColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementHydrusColumn;
};

/** Identifies documents */
export type CosmosElementHydrusColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementHydrusColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementHydrusColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementHydrusColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementHydrusColumnOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleHrefAsc = 'titleHref_ASC',
  TitleHrefDesc = 'titleHref_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementHydrusColumnParent = CosmosSectionHydrusColumnList;

export type CosmosElementHydrusColumnParentConnectInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListConnectInput>;
};

export type CosmosElementHydrusColumnParentCreateInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListCreateInput>;
};

export type CosmosElementHydrusColumnParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementHydrusColumnParent documents */
  create?: InputMaybe<Array<CosmosElementHydrusColumnParentCreateInput>>;
};

export type CosmosElementHydrusColumnParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusColumnParent document */
  create?: InputMaybe<CosmosElementHydrusColumnParentCreateInput>;
};

export type CosmosElementHydrusColumnParentCreateWithPositionInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListCreateWithPositionInput>;
};

export type CosmosElementHydrusColumnParentUpdateInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateInput>;
};

export type CosmosElementHydrusColumnParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementHydrusColumnParent component instances */
  create?: InputMaybe<Array<CosmosElementHydrusColumnParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementHydrusColumnParent documents */
  delete?: InputMaybe<Array<CosmosElementHydrusColumnParentWhereUniqueInput>>;
  /** Update multiple CosmosElementHydrusColumnParent component instances */
  update?: InputMaybe<Array<CosmosElementHydrusColumnParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementHydrusColumnParent component instances */
  upsert?: InputMaybe<Array<CosmosElementHydrusColumnParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementHydrusColumnParentUpdateManyWithNestedWhereInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateManyWithNestedWhereInput>;
};

export type CosmosElementHydrusColumnParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusColumnParent document */
  create?: InputMaybe<CosmosElementHydrusColumnParentCreateInput>;
  /** Delete currently connected CosmosElementHydrusColumnParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementHydrusColumnParent document */
  update?: InputMaybe<CosmosElementHydrusColumnParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementHydrusColumnParent document */
  upsert?: InputMaybe<CosmosElementHydrusColumnParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusColumnParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementHydrusColumnParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusColumnParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementHydrusColumnParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusColumnParentWhereInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListWhereInput>;
};

export type CosmosElementHydrusColumnParentWhereUniqueInput = {
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListWhereUniqueInput>;
};

export type CosmosElementHydrusColumnUpdateInput = {
  links?: InputMaybe<CosmosElementHydrusLinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementHydrusColumnUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementHydrusColumnUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementHydrusColumnUpdateLocalizationInput = {
  data: CosmosElementHydrusColumnUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementHydrusColumnUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementHydrusColumnCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementHydrusColumnUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementHydrusColumnUpsertLocalizationInput>>;
};

export type CosmosElementHydrusColumnUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementHydrusColumn component instances */
  create?: InputMaybe<Array<CosmosElementHydrusColumnCreateWithPositionInput>>;
  /** Delete multiple CosmosElementHydrusColumn documents */
  delete?: InputMaybe<Array<CosmosElementHydrusColumnWhereUniqueInput>>;
  /** Update multiple CosmosElementHydrusColumn component instances */
  update?: InputMaybe<Array<CosmosElementHydrusColumnUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementHydrusColumn component instances */
  upsert?: InputMaybe<Array<CosmosElementHydrusColumnUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementHydrusColumnUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementHydrusColumnUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementHydrusColumnUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementHydrusColumnUpdateManyLocalizationInput = {
  data: CosmosElementHydrusColumnUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementHydrusColumnUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementHydrusColumnUpdateManyLocalizationInput>>;
};

export type CosmosElementHydrusColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementHydrusColumnUpdateManyInput;
  /** Document search */
  where: CosmosElementHydrusColumnWhereInput;
};

export type CosmosElementHydrusColumnUpdateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusColumn document */
  create?: InputMaybe<CosmosElementHydrusColumnCreateInput>;
  /** Delete currently connected CosmosElementHydrusColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementHydrusColumn document */
  update?: InputMaybe<CosmosElementHydrusColumnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementHydrusColumn document */
  upsert?: InputMaybe<CosmosElementHydrusColumnUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusColumnUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementHydrusColumnUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementHydrusColumnWhereUniqueInput;
};

export type CosmosElementHydrusColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementHydrusColumnUpdateInput;
  /** Unique document search */
  where: CosmosElementHydrusColumnWhereUniqueInput;
};

export type CosmosElementHydrusColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementHydrusColumnCreateInput;
  /** Update document if it exists */
  update: CosmosElementHydrusColumnUpdateInput;
};

export type CosmosElementHydrusColumnUpsertLocalizationInput = {
  create: CosmosElementHydrusColumnCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementHydrusColumnUpdateLocalizationDataInput;
};

export type CosmosElementHydrusColumnUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementHydrusColumnUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementHydrusColumnWhereUniqueInput;
};

export type CosmosElementHydrusColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementHydrusColumnUpsertInput;
  /** Unique document search */
  where: CosmosElementHydrusColumnWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementHydrusColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementHydrusColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementHydrusColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementHydrusColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementHydrusLinkWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleHref_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleHref_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleHref_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleHref_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleHref_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleHref_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleHref_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleHref_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleHref_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementHydrusColumn record uniquely */
export type CosmosElementHydrusColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementHydrusLink = Entity & {
  __typename?: 'CosmosElementHydrusLink';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementHydrusLink>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementHydrusLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementHydrusLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementHydrusLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementHydrusLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementHydrusLinkConnection = {
  __typename?: 'CosmosElementHydrusLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementHydrusLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementHydrusLinkCreateInput = {
  /** badgeLabel input for default locale (en) */
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementHydrusLinkCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementHydrusLinkCreateLocalizationDataInput = {
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementHydrusLinkCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementHydrusLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementHydrusLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementHydrusLinkCreateLocalizationInput>>;
};

export type CosmosElementHydrusLinkCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementHydrusLink documents */
  create?: InputMaybe<Array<CosmosElementHydrusLinkCreateInput>>;
};

export type CosmosElementHydrusLinkCreateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusLink document */
  create?: InputMaybe<CosmosElementHydrusLinkCreateInput>;
};

export type CosmosElementHydrusLinkCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementHydrusLinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementHydrusLinkEdge = {
  __typename?: 'CosmosElementHydrusLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementHydrusLink;
};

/** Identifies documents */
export type CosmosElementHydrusLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementHydrusLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementHydrusLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementHydrusLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementHydrusLinkOrderByInput {
  BadgeLabelAsc = 'badgeLabel_ASC',
  BadgeLabelDesc = 'badgeLabel_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementHydrusLinkParent = CosmosElementHydrusColumn;

export type CosmosElementHydrusLinkParentConnectInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnConnectInput>;
};

export type CosmosElementHydrusLinkParentCreateInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnCreateInput>;
};

export type CosmosElementHydrusLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementHydrusLinkParent documents */
  create?: InputMaybe<Array<CosmosElementHydrusLinkParentCreateInput>>;
};

export type CosmosElementHydrusLinkParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusLinkParent document */
  create?: InputMaybe<CosmosElementHydrusLinkParentCreateInput>;
};

export type CosmosElementHydrusLinkParentCreateWithPositionInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnCreateWithPositionInput>;
};

export type CosmosElementHydrusLinkParentUpdateInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnUpdateInput>;
};

export type CosmosElementHydrusLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementHydrusLinkParent component instances */
  create?: InputMaybe<Array<CosmosElementHydrusLinkParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementHydrusLinkParent documents */
  delete?: InputMaybe<Array<CosmosElementHydrusLinkParentWhereUniqueInput>>;
  /** Update multiple CosmosElementHydrusLinkParent component instances */
  update?: InputMaybe<Array<CosmosElementHydrusLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementHydrusLinkParent component instances */
  upsert?: InputMaybe<Array<CosmosElementHydrusLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementHydrusLinkParentUpdateManyWithNestedWhereInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnUpdateManyWithNestedWhereInput>;
};

export type CosmosElementHydrusLinkParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusLinkParent document */
  create?: InputMaybe<CosmosElementHydrusLinkParentCreateInput>;
  /** Delete currently connected CosmosElementHydrusLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementHydrusLinkParent document */
  update?: InputMaybe<CosmosElementHydrusLinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementHydrusLinkParent document */
  upsert?: InputMaybe<CosmosElementHydrusLinkParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementHydrusLinkParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementHydrusLinkParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusLinkParentWhereInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
};

export type CosmosElementHydrusLinkParentWhereUniqueInput = {
  CosmosElementHydrusColumn?: InputMaybe<CosmosElementHydrusColumnWhereUniqueInput>;
};

export type CosmosElementHydrusLinkUpdateInput = {
  /** badgeLabel input for default locale (en) */
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementHydrusLinkUpdateLocalizationsInput>;
};

export type CosmosElementHydrusLinkUpdateLocalizationDataInput = {
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementHydrusLinkUpdateLocalizationInput = {
  data: CosmosElementHydrusLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementHydrusLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementHydrusLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementHydrusLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementHydrusLinkUpsertLocalizationInput>>;
};

export type CosmosElementHydrusLinkUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementHydrusLink component instances */
  create?: InputMaybe<Array<CosmosElementHydrusLinkCreateWithPositionInput>>;
  /** Delete multiple CosmosElementHydrusLink documents */
  delete?: InputMaybe<Array<CosmosElementHydrusLinkWhereUniqueInput>>;
  /** Update multiple CosmosElementHydrusLink component instances */
  update?: InputMaybe<Array<CosmosElementHydrusLinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementHydrusLink component instances */
  upsert?: InputMaybe<Array<CosmosElementHydrusLinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementHydrusLinkUpdateManyInput = {
  /** badgeLabel input for default locale (en) */
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementHydrusLinkUpdateManyLocalizationsInput>;
};

export type CosmosElementHydrusLinkUpdateManyLocalizationDataInput = {
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementHydrusLinkUpdateManyLocalizationInput = {
  data: CosmosElementHydrusLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementHydrusLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementHydrusLinkUpdateManyLocalizationInput>>;
};

export type CosmosElementHydrusLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementHydrusLinkUpdateManyInput;
  /** Document search */
  where: CosmosElementHydrusLinkWhereInput;
};

export type CosmosElementHydrusLinkUpdateOneInlineInput = {
  /** Create and connect one CosmosElementHydrusLink document */
  create?: InputMaybe<CosmosElementHydrusLinkCreateInput>;
  /** Delete currently connected CosmosElementHydrusLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementHydrusLink document */
  update?: InputMaybe<CosmosElementHydrusLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementHydrusLink document */
  upsert?: InputMaybe<CosmosElementHydrusLinkUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementHydrusLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementHydrusLinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementHydrusLinkWhereUniqueInput;
};

export type CosmosElementHydrusLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementHydrusLinkUpdateInput;
  /** Unique document search */
  where: CosmosElementHydrusLinkWhereUniqueInput;
};

export type CosmosElementHydrusLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementHydrusLinkCreateInput;
  /** Update document if it exists */
  update: CosmosElementHydrusLinkUpdateInput;
};

export type CosmosElementHydrusLinkUpsertLocalizationInput = {
  create: CosmosElementHydrusLinkCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementHydrusLinkUpdateLocalizationDataInput;
};

export type CosmosElementHydrusLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementHydrusLinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementHydrusLinkWhereUniqueInput;
};

export type CosmosElementHydrusLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementHydrusLinkUpsertInput;
  /** Unique document search */
  where: CosmosElementHydrusLinkWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementHydrusLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementHydrusLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementHydrusLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementHydrusLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  badgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  badgeLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  badgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  badgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  badgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  badgeLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  badgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  badgeLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  badgeLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementHydrusLink record uniquely */
export type CosmosElementHydrusLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementIconButton = Entity & {
  __typename?: 'CosmosElementIconButton';
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<CosmosEnumButtonIcons>;
  iconPosition?: Maybe<CosmosEnumIconPosition>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementIconButton>;
  /** Descriptive name for analytics */
  name?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant?: Maybe<CosmosEnumButtonVariants>;
};


export type CosmosElementIconButtonLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementIconButtonUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementIconButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementIconButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementIconButtonConnection = {
  __typename?: 'CosmosElementIconButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementIconButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementIconButtonCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumButtonIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementIconButtonCreateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
};

export type CosmosElementIconButtonCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIconButtonCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementIconButtonCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconButtonCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementIconButtonCreateLocalizationInput>>;
};

export type CosmosElementIconButtonCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIconButton documents */
  create?: InputMaybe<Array<CosmosElementIconButtonCreateInput>>;
};

export type CosmosElementIconButtonCreateOneInlineInput = {
  /** Create and connect one CosmosElementIconButton document */
  create?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementIconButtonCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementIconButtonCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementIconButtonEdge = {
  __typename?: 'CosmosElementIconButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementIconButton;
};

/** Identifies documents */
export type CosmosElementIconButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIconButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIconButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIconButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumButtonIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<CosmosEnumButtonIcons>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonIcons>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
};

export enum CosmosElementIconButtonOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosElementIconButtonParent = CosmosElementAccordionTierCtaCard | CosmosElementAccordionTierFeatureCard | CosmosElementBlogCard | CosmosElementCalloutCard | CosmosElementDownloadCard | CosmosElementGameDevFeatureCard | CosmosElementGeminiCard | CosmosElementIconSectionHeading | CosmosElementLicenseContactCard | CosmosElementLicenseSeat | CosmosElementPluginListItem | CosmosElementSectionHeading | CosmosElementTabbedFullWidthAssetItem | CosmosElementUserProfile | CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosSectionFaq | CosmosSectionFaqSearch | CosmosSectionLogoMultiCard | CosmosSectionNumberCallout | CosmosSectionSimpleCta;

export type CosmosElementIconButtonParentConnectInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardConnectInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardConnectInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardConnectInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardConnectInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardConnectInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardConnectInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardConnectInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingConnectInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardConnectInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatConnectInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemConnectInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingConnectInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemConnectInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileConnectInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqConnectInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutConnectInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaConnectInput>;
};

export type CosmosElementIconButtonParentCreateInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardCreateInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardCreateInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingCreateInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardCreateInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatCreateInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemCreateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaCreateInput>;
};

export type CosmosElementIconButtonParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIconButtonParent documents */
  create?: InputMaybe<Array<CosmosElementIconButtonParentCreateInput>>;
};

export type CosmosElementIconButtonParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementIconButtonParent document */
  create?: InputMaybe<CosmosElementIconButtonParentCreateInput>;
};

export type CosmosElementIconButtonParentCreateWithPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardCreateWithPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardCreateWithPositionInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardCreateWithPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardCreateWithPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateWithPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateWithPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateWithPositionInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingCreateWithPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardCreateWithPositionInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatCreateWithPositionInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemCreateWithPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateWithPositionInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateWithPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateWithPositionInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateWithPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateWithPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateWithPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaCreateWithPositionInput>;
};

export type CosmosElementIconButtonParentUpdateInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpdateInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateInput>;
};

export type CosmosElementIconButtonParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIconButtonParent component instances */
  create?: InputMaybe<Array<CosmosElementIconButtonParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIconButtonParent documents */
  delete?: InputMaybe<Array<CosmosElementIconButtonParentWhereUniqueInput>>;
  /** Update multiple CosmosElementIconButtonParent component instances */
  update?: InputMaybe<Array<CosmosElementIconButtonParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIconButtonParent component instances */
  upsert?: InputMaybe<Array<CosmosElementIconButtonParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIconButtonParentUpdateManyWithNestedWhereInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateManyWithNestedWhereInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpdateManyWithNestedWhereInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateManyWithNestedWhereInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateManyWithNestedWhereInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateManyWithNestedWhereInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateManyWithNestedWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateManyWithNestedWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateManyWithNestedWhereInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateManyWithNestedWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateManyWithNestedWhereInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateManyWithNestedWhereInput>;
};

export type CosmosElementIconButtonParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIconButtonParent document */
  create?: InputMaybe<CosmosElementIconButtonParentCreateInput>;
  /** Delete currently connected CosmosElementIconButtonParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconButtonParent document */
  update?: InputMaybe<CosmosElementIconButtonParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconButtonParent document */
  upsert?: InputMaybe<CosmosElementIconButtonParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconButtonParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementIconButtonParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateWithNestedWhereUniqueInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementIconButtonParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementIconButtonParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpsertWithNestedWhereUniqueInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpsertWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpsertWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconButtonParentWhereInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardWhereInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardWhereInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardWhereInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardWhereInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingWhereInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatWhereInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaWhereInput>;
};

export type CosmosElementIconButtonParentWhereUniqueInput = {
  CosmosElementAccordionTierCtaCard?: InputMaybe<CosmosElementAccordionTierCtaCardWhereUniqueInput>;
  CosmosElementAccordionTierFeatureCard?: InputMaybe<CosmosElementAccordionTierFeatureCardWhereUniqueInput>;
  CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereUniqueInput>;
  CosmosElementIconSectionHeading?: InputMaybe<CosmosElementIconSectionHeadingWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardWhereUniqueInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatWhereUniqueInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereUniqueInput>;
  CosmosElementTabbedFullWidthAssetItem?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereUniqueInput>;
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaWhereUniqueInput>;
};

export type CosmosElementIconButtonUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumButtonIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementIconButtonUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
};

export type CosmosElementIconButtonUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIconButtonUpdateLocalizationInput = {
  data: CosmosElementIconButtonUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconButtonUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementIconButtonCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIconButtonUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementIconButtonUpsertLocalizationInput>>;
};

export type CosmosElementIconButtonUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIconButton component instances */
  create?: InputMaybe<Array<CosmosElementIconButtonCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIconButton documents */
  delete?: InputMaybe<Array<CosmosElementIconButtonWhereUniqueInput>>;
  /** Update multiple CosmosElementIconButton component instances */
  update?: InputMaybe<Array<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIconButton component instances */
  upsert?: InputMaybe<Array<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIconButtonUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumButtonIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementIconButtonUpdateManyLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
};

export type CosmosElementIconButtonUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIconButtonUpdateManyLocalizationInput = {
  data: CosmosElementIconButtonUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconButtonUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIconButtonUpdateManyLocalizationInput>>;
};

export type CosmosElementIconButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementIconButtonUpdateManyInput;
  /** Document search */
  where: CosmosElementIconButtonWhereInput;
};

export type CosmosElementIconButtonUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIconButton document */
  create?: InputMaybe<CosmosElementIconButtonCreateInput>;
  /** Delete currently connected CosmosElementIconButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconButton document */
  update?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconButton document */
  upsert?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementIconButtonUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIconButtonWhereUniqueInput;
};

export type CosmosElementIconButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementIconButtonUpdateInput;
  /** Unique document search */
  where: CosmosElementIconButtonWhereUniqueInput;
};

export type CosmosElementIconButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementIconButtonCreateInput;
  /** Update document if it exists */
  update: CosmosElementIconButtonUpdateInput;
};

export type CosmosElementIconButtonUpsertLocalizationInput = {
  create: CosmosElementIconButtonCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementIconButtonUpdateLocalizationDataInput;
};

export type CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementIconButtonUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIconButtonWhereUniqueInput;
};

export type CosmosElementIconButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementIconButtonUpsertInput;
  /** Unique document search */
  where: CosmosElementIconButtonWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementIconButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIconButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIconButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIconButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumButtonIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<CosmosEnumButtonIcons>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonIcons>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumButtonVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumButtonVariants>>>;
};

/** References CosmosElementIconButton record uniquely */
export type CosmosElementIconButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementIconLinkGroup = Entity & {
  __typename?: 'CosmosElementIconLinkGroup';
  description?: Maybe<Scalars['String']['output']>;
  edsIconLinks: Array<CosmosElementEdsIconLink>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementIconLinkGroup>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementIconLinkGroupEdsIconLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementEdsIconLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
};


export type CosmosElementIconLinkGroupLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementIconLinkGroupUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementIconLinkGroupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementIconLinkGroupWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementIconLinkGroupConnection = {
  __typename?: 'CosmosElementIconLinkGroupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementIconLinkGroupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementIconLinkGroupCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  edsIconLinks?: InputMaybe<CosmosElementEdsIconLinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementIconLinkGroupCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIconLinkGroupCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIconLinkGroupCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementIconLinkGroupCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconLinkGroupCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementIconLinkGroupCreateLocalizationInput>>;
};

export type CosmosElementIconLinkGroupCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIconLinkGroup documents */
  create?: InputMaybe<Array<CosmosElementIconLinkGroupCreateInput>>;
};

export type CosmosElementIconLinkGroupCreateOneInlineInput = {
  /** Create and connect one CosmosElementIconLinkGroup document */
  create?: InputMaybe<CosmosElementIconLinkGroupCreateInput>;
};

export type CosmosElementIconLinkGroupCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementIconLinkGroupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementIconLinkGroupEdge = {
  __typename?: 'CosmosElementIconLinkGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementIconLinkGroup;
};

/** Identifies documents */
export type CosmosElementIconLinkGroupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIconLinkGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIconLinkGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIconLinkGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  edsIconLinks_every?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
  edsIconLinks_none?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
  edsIconLinks_some?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementIconLinkGroupOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementIconLinkGroupParent = CosmosPageBlogDetail;

export type CosmosElementIconLinkGroupParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
};

export type CosmosElementIconLinkGroupParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
};

export type CosmosElementIconLinkGroupParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementIconLinkGroupParent documents */
  connect?: InputMaybe<Array<CosmosElementIconLinkGroupParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementIconLinkGroupParent documents */
  create?: InputMaybe<Array<CosmosElementIconLinkGroupParentCreateInput>>;
};

export type CosmosElementIconLinkGroupParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementIconLinkGroupParent document */
  connect?: InputMaybe<CosmosElementIconLinkGroupParentWhereUniqueInput>;
  /** Create and connect one CosmosElementIconLinkGroupParent document */
  create?: InputMaybe<CosmosElementIconLinkGroupParentCreateInput>;
};

export type CosmosElementIconLinkGroupParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
};

export type CosmosElementIconLinkGroupParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementIconLinkGroupParent documents */
  connect?: InputMaybe<Array<CosmosElementIconLinkGroupParentConnectInput>>;
  /** Create and connect multiple CosmosElementIconLinkGroupParent documents */
  create?: InputMaybe<Array<CosmosElementIconLinkGroupParentCreateInput>>;
  /** Delete multiple CosmosElementIconLinkGroupParent documents */
  delete?: InputMaybe<Array<CosmosElementIconLinkGroupParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementIconLinkGroupParent documents */
  disconnect?: InputMaybe<Array<CosmosElementIconLinkGroupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementIconLinkGroupParent documents */
  set?: InputMaybe<Array<CosmosElementIconLinkGroupParentWhereUniqueInput>>;
  /** Update multiple CosmosElementIconLinkGroupParent documents */
  update?: InputMaybe<Array<CosmosElementIconLinkGroupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementIconLinkGroupParent documents */
  upsert?: InputMaybe<Array<CosmosElementIconLinkGroupParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementIconLinkGroupParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementIconLinkGroupParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementIconLinkGroupParent document */
  connect?: InputMaybe<CosmosElementIconLinkGroupParentWhereUniqueInput>;
  /** Create and connect one CosmosElementIconLinkGroupParent document */
  create?: InputMaybe<CosmosElementIconLinkGroupParentCreateInput>;
  /** Delete currently connected CosmosElementIconLinkGroupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementIconLinkGroupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconLinkGroupParent document */
  update?: InputMaybe<CosmosElementIconLinkGroupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconLinkGroupParent document */
  upsert?: InputMaybe<CosmosElementIconLinkGroupParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconLinkGroupParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementIconLinkGroupParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconLinkGroupParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
};

export type CosmosElementIconLinkGroupParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
};

export type CosmosElementIconLinkGroupUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  edsIconLinks?: InputMaybe<CosmosElementEdsIconLinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementIconLinkGroupUpdateLocalizationsInput>;
};

export type CosmosElementIconLinkGroupUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIconLinkGroupUpdateLocalizationInput = {
  data: CosmosElementIconLinkGroupUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconLinkGroupUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementIconLinkGroupCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIconLinkGroupUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementIconLinkGroupUpsertLocalizationInput>>;
};

export type CosmosElementIconLinkGroupUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIconLinkGroup component instances */
  create?: InputMaybe<Array<CosmosElementIconLinkGroupCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIconLinkGroup documents */
  delete?: InputMaybe<Array<CosmosElementIconLinkGroupWhereUniqueInput>>;
  /** Update multiple CosmosElementIconLinkGroup component instances */
  update?: InputMaybe<Array<CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIconLinkGroup component instances */
  upsert?: InputMaybe<Array<CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIconLinkGroupUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementIconLinkGroupUpdateManyLocalizationsInput>;
};

export type CosmosElementIconLinkGroupUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIconLinkGroupUpdateManyLocalizationInput = {
  data: CosmosElementIconLinkGroupUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconLinkGroupUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIconLinkGroupUpdateManyLocalizationInput>>;
};

export type CosmosElementIconLinkGroupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementIconLinkGroupUpdateManyInput;
  /** Document search */
  where: CosmosElementIconLinkGroupWhereInput;
};

export type CosmosElementIconLinkGroupUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIconLinkGroup document */
  create?: InputMaybe<CosmosElementIconLinkGroupCreateInput>;
  /** Delete currently connected CosmosElementIconLinkGroup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconLinkGroup document */
  update?: InputMaybe<CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconLinkGroup document */
  upsert?: InputMaybe<CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementIconLinkGroupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIconLinkGroupWhereUniqueInput;
};

export type CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementIconLinkGroupUpdateInput;
  /** Unique document search */
  where: CosmosElementIconLinkGroupWhereUniqueInput;
};

export type CosmosElementIconLinkGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementIconLinkGroupCreateInput;
  /** Update document if it exists */
  update: CosmosElementIconLinkGroupUpdateInput;
};

export type CosmosElementIconLinkGroupUpsertLocalizationInput = {
  create: CosmosElementIconLinkGroupCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementIconLinkGroupUpdateLocalizationDataInput;
};

export type CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementIconLinkGroupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIconLinkGroupWhereUniqueInput;
};

export type CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementIconLinkGroupUpsertInput;
  /** Unique document search */
  where: CosmosElementIconLinkGroupWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementIconLinkGroupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIconLinkGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIconLinkGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIconLinkGroupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  edsIconLinks_every?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
  edsIconLinks_none?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
  edsIconLinks_some?: InputMaybe<CosmosElementEdsIconLinkWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementIconLinkGroup record uniquely */
export type CosmosElementIconLinkGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementIconSectionHeading = Entity & {
  __typename?: 'CosmosElementIconSectionHeading';
  /** Basic button array. Overridden if modular button array is specified. */
  buttons: Array<CosmosElementButton>;
  /** Centers the content and stacks the content vertically. */
  centeredVerticalStack?: Maybe<Scalars['Boolean']['output']>;
  /** Uses a smaller variant for the title */
  compressedTitle?: Maybe<Scalars['Boolean']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementIconSectionHeading>;
  /** Array of button components */
  modButtons: Array<CosmosElementIconSectionHeadingmodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  titleGradient?: Maybe<CosmosEnumEdsGradients>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementIconSectionHeadingButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementIconSectionHeadingLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementIconSectionHeadingModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementIconSectionHeadingUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementIconSectionHeadingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementIconSectionHeadingWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementIconSectionHeadingConnection = {
  __typename?: 'CosmosElementIconSectionHeadingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementIconSectionHeadingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementIconSectionHeadingCreateInput = {
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementIconSectionHeadingCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIconSectionHeadingCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIconSectionHeadingCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementIconSectionHeadingCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconSectionHeadingCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingCreateLocalizationInput>>;
};

export type CosmosElementIconSectionHeadingCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIconSectionHeading documents */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingCreateInput>>;
};

export type CosmosElementIconSectionHeadingCreateOneInlineInput = {
  /** Create and connect one CosmosElementIconSectionHeading document */
  create?: InputMaybe<CosmosElementIconSectionHeadingCreateInput>;
};

export type CosmosElementIconSectionHeadingCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementIconSectionHeadingCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementIconSectionHeadingEdge = {
  __typename?: 'CosmosElementIconSectionHeadingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementIconSectionHeading;
};

/** Identifies documents */
export type CosmosElementIconSectionHeadingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredVerticalStack_not?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  compressedTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionWhereInput>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  titleGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  titleGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementIconSectionHeadingOrderByInput {
  CenteredVerticalStackAsc = 'centeredVerticalStack_ASC',
  CenteredVerticalStackDesc = 'centeredVerticalStack_DESC',
  CompressedTitleAsc = 'compressedTitle_ASC',
  CompressedTitleDesc = 'compressedTitle_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleGradientAsc = 'titleGradient_ASC',
  TitleGradientDesc = 'titleGradient_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementIconSectionHeadingParent = CosmosConfigSection;

export type CosmosElementIconSectionHeadingParentConnectInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionConnectInput>;
};

export type CosmosElementIconSectionHeadingParentCreateInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionCreateInput>;
};

export type CosmosElementIconSectionHeadingParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIconSectionHeadingParent documents */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingParentCreateInput>>;
};

export type CosmosElementIconSectionHeadingParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementIconSectionHeadingParent document */
  create?: InputMaybe<CosmosElementIconSectionHeadingParentCreateInput>;
};

export type CosmosElementIconSectionHeadingParentCreateWithPositionInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionCreateWithPositionInput>;
};

export type CosmosElementIconSectionHeadingParentUpdateInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateInput>;
};

export type CosmosElementIconSectionHeadingParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIconSectionHeadingParent component instances */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIconSectionHeadingParent documents */
  delete?: InputMaybe<Array<CosmosElementIconSectionHeadingParentWhereUniqueInput>>;
  /** Update multiple CosmosElementIconSectionHeadingParent component instances */
  update?: InputMaybe<Array<CosmosElementIconSectionHeadingParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIconSectionHeadingParent component instances */
  upsert?: InputMaybe<Array<CosmosElementIconSectionHeadingParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIconSectionHeadingParentUpdateManyWithNestedWhereInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosElementIconSectionHeadingParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIconSectionHeadingParent document */
  create?: InputMaybe<CosmosElementIconSectionHeadingParentCreateInput>;
  /** Delete currently connected CosmosElementIconSectionHeadingParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconSectionHeadingParent document */
  update?: InputMaybe<CosmosElementIconSectionHeadingParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconSectionHeadingParent document */
  upsert?: InputMaybe<CosmosElementIconSectionHeadingParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementIconSectionHeadingParentUpdateWithNestedWhereUniqueInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementIconSectionHeadingParentUpsertWithNestedWhereUniqueInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingParentWhereInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionWhereInput>;
};

export type CosmosElementIconSectionHeadingParentWhereUniqueInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingUpdateInput = {
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementIconSectionHeadingUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
};

export type CosmosElementIconSectionHeadingUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementIconSectionHeadingUpdateLocalizationInput = {
  data: CosmosElementIconSectionHeadingUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconSectionHeadingUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIconSectionHeadingUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementIconSectionHeadingUpsertLocalizationInput>>;
};

export type CosmosElementIconSectionHeadingUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIconSectionHeading component instances */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIconSectionHeading documents */
  delete?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereUniqueInput>>;
  /** Update multiple CosmosElementIconSectionHeading component instances */
  update?: InputMaybe<Array<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIconSectionHeading component instances */
  upsert?: InputMaybe<Array<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIconSectionHeadingUpdateManyInput = {
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementIconSectionHeadingUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
};

export type CosmosElementIconSectionHeadingUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementIconSectionHeadingUpdateManyLocalizationInput = {
  data: CosmosElementIconSectionHeadingUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIconSectionHeadingUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIconSectionHeadingUpdateManyLocalizationInput>>;
};

export type CosmosElementIconSectionHeadingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementIconSectionHeadingUpdateManyInput;
  /** Document search */
  where: CosmosElementIconSectionHeadingWhereInput;
};

export type CosmosElementIconSectionHeadingUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIconSectionHeading document */
  create?: InputMaybe<CosmosElementIconSectionHeadingCreateInput>;
  /** Delete currently connected CosmosElementIconSectionHeading document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconSectionHeading document */
  update?: InputMaybe<CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconSectionHeading document */
  upsert?: InputMaybe<CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementIconSectionHeadingUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIconSectionHeadingWhereUniqueInput;
};

export type CosmosElementIconSectionHeadingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementIconSectionHeadingUpdateInput;
  /** Unique document search */
  where: CosmosElementIconSectionHeadingWhereUniqueInput;
};

export type CosmosElementIconSectionHeadingUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementIconSectionHeadingCreateInput;
  /** Update document if it exists */
  update: CosmosElementIconSectionHeadingUpdateInput;
};

export type CosmosElementIconSectionHeadingUpsertLocalizationInput = {
  create: CosmosElementIconSectionHeadingCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementIconSectionHeadingUpdateLocalizationDataInput;
};

export type CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementIconSectionHeadingUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIconSectionHeadingWhereUniqueInput;
};

export type CosmosElementIconSectionHeadingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementIconSectionHeadingUpsertInput;
  /** Unique document search */
  where: CosmosElementIconSectionHeadingWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementIconSectionHeadingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIconSectionHeadingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredVerticalStack_not?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  compressedTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionWhereInput>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  titleGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  titleGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementIconSectionHeading record uniquely */
export type CosmosElementIconSectionHeadingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosElementIconSectionHeadingmodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIconSectionHeadingmodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingmodButtonsUnionCreateInput>>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementIconSectionHeadingmodButtonsUnion document */
  create?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionCreateInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIconSectionHeadingmodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosElementIconSectionHeadingmodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIconSectionHeadingmodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosElementIconSectionHeadingmodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementIconSectionHeadingmodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosElementIconSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIconSectionHeadingmodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementIconSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIconSectionHeadingmodButtonsUnion document */
  create?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosElementIconSectionHeadingmodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIconSectionHeadingmodButtonsUnion document */
  update?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIconSectionHeadingmodButtonsUnion document */
  upsert?: InputMaybe<CosmosElementIconSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosElementIconSectionHeadingmodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

/** Image tag or badge component which includes an Image and a corresponding label with an href. See the NewsCard's author tag as an example. */
export type CosmosElementImageTag = Entity & {
  __typename?: 'CosmosElementImageTag';
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  label: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementImageTag>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Image tag or badge component which includes an Image and a corresponding label with an href. See the NewsCard's author tag as an example. */
export type CosmosElementImageTagImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Image tag or badge component which includes an Image and a corresponding label with an href. See the NewsCard's author tag as an example. */
export type CosmosElementImageTagLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Image tag or badge component which includes an Image and a corresponding label with an href. See the NewsCard's author tag as an example. */
export type CosmosElementImageTagUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementImageTagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementImageTagWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementImageTagConnection = {
  __typename?: 'CosmosElementImageTagConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementImageTagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementImageTagCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** label input for default locale (en) */
  label: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementImageTagCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementImageTagCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementImageTagCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementImageTagCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementImageTagCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementImageTagCreateLocalizationInput>>;
};

export type CosmosElementImageTagCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementImageTag documents */
  create?: InputMaybe<Array<CosmosElementImageTagCreateInput>>;
};

export type CosmosElementImageTagCreateOneInlineInput = {
  /** Create and connect one CosmosElementImageTag document */
  create?: InputMaybe<CosmosElementImageTagCreateInput>;
};

export type CosmosElementImageTagCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementImageTagCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementImageTagEdge = {
  __typename?: 'CosmosElementImageTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementImageTag;
};

/** Identifies documents */
export type CosmosElementImageTagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementImageTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementImageTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementImageTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementImageTagOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementImageTagParent = CosmosConfigBlog | CosmosElementNewsCard;

export type CosmosElementImageTagParentConnectInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogConnectInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardConnectInput>;
};

export type CosmosElementImageTagParentCreateInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogCreateInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardCreateInput>;
};

export type CosmosElementImageTagParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementImageTagParent documents */
  create?: InputMaybe<Array<CosmosElementImageTagParentCreateInput>>;
};

export type CosmosElementImageTagParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementImageTagParent document */
  create?: InputMaybe<CosmosElementImageTagParentCreateInput>;
};

export type CosmosElementImageTagParentCreateWithPositionInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogCreateWithPositionInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardCreateWithPositionInput>;
};

export type CosmosElementImageTagParentUpdateInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateInput>;
};

export type CosmosElementImageTagParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementImageTagParent component instances */
  create?: InputMaybe<Array<CosmosElementImageTagParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementImageTagParent documents */
  delete?: InputMaybe<Array<CosmosElementImageTagParentWhereUniqueInput>>;
  /** Update multiple CosmosElementImageTagParent component instances */
  update?: InputMaybe<Array<CosmosElementImageTagParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementImageTagParent component instances */
  upsert?: InputMaybe<Array<CosmosElementImageTagParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementImageTagParentUpdateManyWithNestedWhereInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateManyWithNestedWhereInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementImageTagParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementImageTagParent document */
  create?: InputMaybe<CosmosElementImageTagParentCreateInput>;
  /** Delete currently connected CosmosElementImageTagParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementImageTagParent document */
  update?: InputMaybe<CosmosElementImageTagParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementImageTagParent document */
  upsert?: InputMaybe<CosmosElementImageTagParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementImageTagParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementImageTagParentUpdateWithNestedWhereUniqueInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpdateWithNestedWhereUniqueInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementImageTagParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementImageTagParentUpsertWithNestedWhereUniqueInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogUpsertWithNestedWhereUniqueInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementImageTagParentWhereInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogWhereInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardWhereInput>;
};

export type CosmosElementImageTagParentWhereUniqueInput = {
  CosmosConfigBlog?: InputMaybe<CosmosConfigBlogWhereUniqueInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardWhereUniqueInput>;
};

export type CosmosElementImageTagUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementImageTagUpdateLocalizationsInput>;
};

export type CosmosElementImageTagUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementImageTagUpdateLocalizationInput = {
  data: CosmosElementImageTagUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementImageTagUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementImageTagCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementImageTagUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementImageTagUpsertLocalizationInput>>;
};

export type CosmosElementImageTagUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementImageTag component instances */
  create?: InputMaybe<Array<CosmosElementImageTagCreateWithPositionInput>>;
  /** Delete multiple CosmosElementImageTag documents */
  delete?: InputMaybe<Array<CosmosElementImageTagWhereUniqueInput>>;
  /** Update multiple CosmosElementImageTag component instances */
  update?: InputMaybe<Array<CosmosElementImageTagUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementImageTag component instances */
  upsert?: InputMaybe<Array<CosmosElementImageTagUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementImageTagUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementImageTagUpdateManyLocalizationsInput>;
};

export type CosmosElementImageTagUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementImageTagUpdateManyLocalizationInput = {
  data: CosmosElementImageTagUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementImageTagUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementImageTagUpdateManyLocalizationInput>>;
};

export type CosmosElementImageTagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementImageTagUpdateManyInput;
  /** Document search */
  where: CosmosElementImageTagWhereInput;
};

export type CosmosElementImageTagUpdateOneInlineInput = {
  /** Create and connect one CosmosElementImageTag document */
  create?: InputMaybe<CosmosElementImageTagCreateInput>;
  /** Delete currently connected CosmosElementImageTag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementImageTag document */
  update?: InputMaybe<CosmosElementImageTagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementImageTag document */
  upsert?: InputMaybe<CosmosElementImageTagUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementImageTagUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementImageTagUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementImageTagWhereUniqueInput;
};

export type CosmosElementImageTagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementImageTagUpdateInput;
  /** Unique document search */
  where: CosmosElementImageTagWhereUniqueInput;
};

export type CosmosElementImageTagUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementImageTagCreateInput;
  /** Update document if it exists */
  update: CosmosElementImageTagUpdateInput;
};

export type CosmosElementImageTagUpsertLocalizationInput = {
  create: CosmosElementImageTagCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementImageTagUpdateLocalizationDataInput;
};

export type CosmosElementImageTagUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementImageTagUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementImageTagWhereUniqueInput;
};

export type CosmosElementImageTagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementImageTagUpsertInput;
  /** Unique document search */
  where: CosmosElementImageTagWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementImageTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementImageTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementImageTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementImageTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementImageTag record uniquely */
export type CosmosElementImageTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementIndustry = Entity & {
  __typename?: 'CosmosElementIndustry';
  dataRouterId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementIndustry>;
  salesForceId: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementIndustryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementIndustryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementIndustryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementIndustryWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementIndustryConnection = {
  __typename?: 'CosmosElementIndustryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementIndustryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementIndustryCreateInput = {
  dataRouterId?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementIndustryCreateLocalizationsInput>;
  salesForceId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIndustryCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementIndustryCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementIndustryCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIndustryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementIndustryCreateLocalizationInput>>;
};

export type CosmosElementIndustryCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementIndustry documents */
  create?: InputMaybe<Array<CosmosElementIndustryCreateInput>>;
};

export type CosmosElementIndustryCreateOneInlineInput = {
  /** Create and connect one CosmosElementIndustry document */
  create?: InputMaybe<CosmosElementIndustryCreateInput>;
};

export type CosmosElementIndustryCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementIndustryCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementIndustryEdge = {
  __typename?: 'CosmosElementIndustryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementIndustry;
};

/** Identifies documents */
export type CosmosElementIndustryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIndustryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIndustryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIndustryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dataRouterId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dataRouterId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dataRouterId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dataRouterId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dataRouterId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dataRouterId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dataRouterId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dataRouterId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dataRouterId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dataRouterId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  salesForceId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  salesForceId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  salesForceId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  salesForceId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  salesForceId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  salesForceId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  salesForceId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  salesForceId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  salesForceId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  salesForceId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementIndustryOrderByInput {
  DataRouterIdAsc = 'dataRouterId_ASC',
  DataRouterIdDesc = 'dataRouterId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SalesForceIdAsc = 'salesForceId_ASC',
  SalesForceIdDesc = 'salesForceId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementIndustryParent = CosmosRefIndustryList;

export type CosmosElementIndustryParentConnectInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListConnectInput>;
};

export type CosmosElementIndustryParentCreateInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListCreateInput>;
};

export type CosmosElementIndustryParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementIndustryParent documents */
  connect?: InputMaybe<Array<CosmosElementIndustryParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementIndustryParent documents */
  create?: InputMaybe<Array<CosmosElementIndustryParentCreateInput>>;
};

export type CosmosElementIndustryParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementIndustryParent document */
  connect?: InputMaybe<CosmosElementIndustryParentWhereUniqueInput>;
  /** Create and connect one CosmosElementIndustryParent document */
  create?: InputMaybe<CosmosElementIndustryParentCreateInput>;
};

export type CosmosElementIndustryParentUpdateInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListUpdateInput>;
};

export type CosmosElementIndustryParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementIndustryParent documents */
  connect?: InputMaybe<Array<CosmosElementIndustryParentConnectInput>>;
  /** Create and connect multiple CosmosElementIndustryParent documents */
  create?: InputMaybe<Array<CosmosElementIndustryParentCreateInput>>;
  /** Delete multiple CosmosElementIndustryParent documents */
  delete?: InputMaybe<Array<CosmosElementIndustryParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementIndustryParent documents */
  disconnect?: InputMaybe<Array<CosmosElementIndustryParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementIndustryParent documents */
  set?: InputMaybe<Array<CosmosElementIndustryParentWhereUniqueInput>>;
  /** Update multiple CosmosElementIndustryParent documents */
  update?: InputMaybe<Array<CosmosElementIndustryParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementIndustryParent documents */
  upsert?: InputMaybe<Array<CosmosElementIndustryParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementIndustryParentUpdateManyWithNestedWhereInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListUpdateManyWithNestedWhereInput>;
};

export type CosmosElementIndustryParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementIndustryParent document */
  connect?: InputMaybe<CosmosElementIndustryParentWhereUniqueInput>;
  /** Create and connect one CosmosElementIndustryParent document */
  create?: InputMaybe<CosmosElementIndustryParentCreateInput>;
  /** Delete currently connected CosmosElementIndustryParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementIndustryParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIndustryParent document */
  update?: InputMaybe<CosmosElementIndustryParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIndustryParent document */
  upsert?: InputMaybe<CosmosElementIndustryParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIndustryParentUpdateWithNestedWhereUniqueInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementIndustryParentUpsertWithNestedWhereUniqueInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIndustryParentWhereInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListWhereInput>;
};

export type CosmosElementIndustryParentWhereUniqueInput = {
  CosmosRefIndustryList?: InputMaybe<CosmosRefIndustryListWhereUniqueInput>;
};

export type CosmosElementIndustryUpdateInput = {
  dataRouterId?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementIndustryUpdateLocalizationsInput>;
  salesForceId?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIndustryUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIndustryUpdateLocalizationInput = {
  data: CosmosElementIndustryUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIndustryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementIndustryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIndustryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementIndustryUpsertLocalizationInput>>;
};

export type CosmosElementIndustryUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementIndustry component instances */
  create?: InputMaybe<Array<CosmosElementIndustryCreateWithPositionInput>>;
  /** Delete multiple CosmosElementIndustry documents */
  delete?: InputMaybe<Array<CosmosElementIndustryWhereUniqueInput>>;
  /** Update multiple CosmosElementIndustry component instances */
  update?: InputMaybe<Array<CosmosElementIndustryUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementIndustry component instances */
  upsert?: InputMaybe<Array<CosmosElementIndustryUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementIndustryUpdateManyInput = {
  dataRouterId?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementIndustryUpdateManyLocalizationsInput>;
  salesForceId?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIndustryUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementIndustryUpdateManyLocalizationInput = {
  data: CosmosElementIndustryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementIndustryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementIndustryUpdateManyLocalizationInput>>;
};

export type CosmosElementIndustryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementIndustryUpdateManyInput;
  /** Document search */
  where: CosmosElementIndustryWhereInput;
};

export type CosmosElementIndustryUpdateOneInlineInput = {
  /** Create and connect one CosmosElementIndustry document */
  create?: InputMaybe<CosmosElementIndustryCreateInput>;
  /** Delete currently connected CosmosElementIndustry document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementIndustry document */
  update?: InputMaybe<CosmosElementIndustryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementIndustry document */
  upsert?: InputMaybe<CosmosElementIndustryUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementIndustryUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementIndustryUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIndustryWhereUniqueInput;
};

export type CosmosElementIndustryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementIndustryUpdateInput;
  /** Unique document search */
  where: CosmosElementIndustryWhereUniqueInput;
};

export type CosmosElementIndustryUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementIndustryCreateInput;
  /** Update document if it exists */
  update: CosmosElementIndustryUpdateInput;
};

export type CosmosElementIndustryUpsertLocalizationInput = {
  create: CosmosElementIndustryCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementIndustryUpdateLocalizationDataInput;
};

export type CosmosElementIndustryUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementIndustryUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementIndustryWhereUniqueInput;
};

export type CosmosElementIndustryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementIndustryUpsertInput;
  /** Unique document search */
  where: CosmosElementIndustryWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementIndustryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementIndustryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementIndustryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementIndustryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dataRouterId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dataRouterId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dataRouterId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dataRouterId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dataRouterId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dataRouterId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dataRouterId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dataRouterId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dataRouterId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dataRouterId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  salesForceId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  salesForceId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  salesForceId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  salesForceId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  salesForceId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  salesForceId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  salesForceId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  salesForceId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  salesForceId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  salesForceId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementIndustry record uniquely */
export type CosmosElementIndustryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A list of questions answered by an interviewee */
export type CosmosElementInterview = Entity & {
  __typename?: 'CosmosElementInterview';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  interviewee?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementInterview>;
  questions: Array<CosmosElementInterviewQuestion>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A list of questions answered by an interviewee */
export type CosmosElementInterviewLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** A list of questions answered by an interviewee */
export type CosmosElementInterviewQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementInterviewQuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
};


/** A list of questions answered by an interviewee */
export type CosmosElementInterviewUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementInterviewConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementInterviewWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementInterviewConnection = {
  __typename?: 'CosmosElementInterviewConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementInterviewEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementInterviewCreateInput = {
  /** interviewee input for default locale (en) */
  interviewee?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementInterviewCreateLocalizationsInput>;
  questions?: InputMaybe<CosmosElementInterviewQuestionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementInterviewCreateLocalizationDataInput = {
  interviewee?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementInterviewCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementInterviewCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementInterviewCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementInterviewCreateLocalizationInput>>;
};

export type CosmosElementInterviewCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementInterview documents */
  create?: InputMaybe<Array<CosmosElementInterviewCreateInput>>;
};

export type CosmosElementInterviewCreateOneInlineInput = {
  /** Create and connect one CosmosElementInterview document */
  create?: InputMaybe<CosmosElementInterviewCreateInput>;
};

export type CosmosElementInterviewCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementInterviewCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementInterviewEdge = {
  __typename?: 'CosmosElementInterviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementInterview;
};

/** Identifies documents */
export type CosmosElementInterviewManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementInterviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementInterviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementInterviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  questions_every?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
  questions_none?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
  questions_some?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementInterviewOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IntervieweeAsc = 'interviewee_ASC',
  IntervieweeDesc = 'interviewee_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementInterviewParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementInterviewParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementInterviewParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementInterviewParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementInterviewParent documents */
  connect?: InputMaybe<Array<CosmosElementInterviewParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementInterviewParent documents */
  create?: InputMaybe<Array<CosmosElementInterviewParentCreateInput>>;
};

export type CosmosElementInterviewParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementInterviewParent document */
  connect?: InputMaybe<CosmosElementInterviewParentWhereUniqueInput>;
  /** Create and connect one CosmosElementInterviewParent document */
  create?: InputMaybe<CosmosElementInterviewParentCreateInput>;
};

export type CosmosElementInterviewParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementInterviewParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementInterviewParent documents */
  connect?: InputMaybe<Array<CosmosElementInterviewParentConnectInput>>;
  /** Create and connect multiple CosmosElementInterviewParent documents */
  create?: InputMaybe<Array<CosmosElementInterviewParentCreateInput>>;
  /** Delete multiple CosmosElementInterviewParent documents */
  delete?: InputMaybe<Array<CosmosElementInterviewParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementInterviewParent documents */
  disconnect?: InputMaybe<Array<CosmosElementInterviewParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementInterviewParent documents */
  set?: InputMaybe<Array<CosmosElementInterviewParentWhereUniqueInput>>;
  /** Update multiple CosmosElementInterviewParent documents */
  update?: InputMaybe<Array<CosmosElementInterviewParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementInterviewParent documents */
  upsert?: InputMaybe<Array<CosmosElementInterviewParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementInterviewParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementInterviewParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementInterviewParent document */
  connect?: InputMaybe<CosmosElementInterviewParentWhereUniqueInput>;
  /** Create and connect one CosmosElementInterviewParent document */
  create?: InputMaybe<CosmosElementInterviewParentCreateInput>;
  /** Delete currently connected CosmosElementInterviewParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementInterviewParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementInterviewParent document */
  update?: InputMaybe<CosmosElementInterviewParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementInterviewParent document */
  upsert?: InputMaybe<CosmosElementInterviewParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementInterviewParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementInterviewQuestion = Entity & {
  __typename?: 'CosmosElementInterviewQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementInterviewQuestion>;
  question?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementInterviewQuestionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementInterviewQuestionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementInterviewQuestionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementInterviewQuestionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementInterviewQuestionConnection = {
  __typename?: 'CosmosElementInterviewQuestionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementInterviewQuestionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementInterviewQuestionCreateInput = {
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementInterviewQuestionCreateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementInterviewQuestionCreateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementInterviewQuestionCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementInterviewQuestionCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementInterviewQuestionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementInterviewQuestionCreateLocalizationInput>>;
};

export type CosmosElementInterviewQuestionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementInterviewQuestion documents */
  create?: InputMaybe<Array<CosmosElementInterviewQuestionCreateInput>>;
};

export type CosmosElementInterviewQuestionCreateOneInlineInput = {
  /** Create and connect one CosmosElementInterviewQuestion document */
  create?: InputMaybe<CosmosElementInterviewQuestionCreateInput>;
};

export type CosmosElementInterviewQuestionCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementInterviewQuestionCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementInterviewQuestionEdge = {
  __typename?: 'CosmosElementInterviewQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementInterviewQuestion;
};

/** Identifies documents */
export type CosmosElementInterviewQuestionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementInterviewQuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementInterviewQuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementInterviewQuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementInterviewQuestionOrderByInput {
  AnswerAsc = 'answer_ASC',
  AnswerDesc = 'answer_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementInterviewQuestionParent = CosmosElementInterview;

export type CosmosElementInterviewQuestionParentConnectInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewConnectInput>;
};

export type CosmosElementInterviewQuestionParentCreateInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewCreateInput>;
};

export type CosmosElementInterviewQuestionParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementInterviewQuestionParent documents */
  create?: InputMaybe<Array<CosmosElementInterviewQuestionParentCreateInput>>;
};

export type CosmosElementInterviewQuestionParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementInterviewQuestionParent document */
  create?: InputMaybe<CosmosElementInterviewQuestionParentCreateInput>;
};

export type CosmosElementInterviewQuestionParentCreateWithPositionInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewCreateWithPositionInput>;
};

export type CosmosElementInterviewQuestionParentUpdateInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateInput>;
};

export type CosmosElementInterviewQuestionParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementInterviewQuestionParent component instances */
  create?: InputMaybe<Array<CosmosElementInterviewQuestionParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementInterviewQuestionParent documents */
  delete?: InputMaybe<Array<CosmosElementInterviewQuestionParentWhereUniqueInput>>;
  /** Update multiple CosmosElementInterviewQuestionParent component instances */
  update?: InputMaybe<Array<CosmosElementInterviewQuestionParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementInterviewQuestionParent component instances */
  upsert?: InputMaybe<Array<CosmosElementInterviewQuestionParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementInterviewQuestionParentUpdateManyWithNestedWhereInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateManyWithNestedWhereInput>;
};

export type CosmosElementInterviewQuestionParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementInterviewQuestionParent document */
  create?: InputMaybe<CosmosElementInterviewQuestionParentCreateInput>;
  /** Delete currently connected CosmosElementInterviewQuestionParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementInterviewQuestionParent document */
  update?: InputMaybe<CosmosElementInterviewQuestionParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementInterviewQuestionParent document */
  upsert?: InputMaybe<CosmosElementInterviewQuestionParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewQuestionParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementInterviewQuestionParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewQuestionParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementInterviewQuestionParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewQuestionParentWhereInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewWhereInput>;
};

export type CosmosElementInterviewQuestionParentWhereUniqueInput = {
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewWhereUniqueInput>;
};

export type CosmosElementInterviewQuestionUpdateInput = {
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementInterviewQuestionUpdateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementInterviewQuestionUpdateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementInterviewQuestionUpdateLocalizationInput = {
  data: CosmosElementInterviewQuestionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementInterviewQuestionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementInterviewQuestionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementInterviewQuestionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementInterviewQuestionUpsertLocalizationInput>>;
};

export type CosmosElementInterviewQuestionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementInterviewQuestion component instances */
  create?: InputMaybe<Array<CosmosElementInterviewQuestionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementInterviewQuestion documents */
  delete?: InputMaybe<Array<CosmosElementInterviewQuestionWhereUniqueInput>>;
  /** Update multiple CosmosElementInterviewQuestion component instances */
  update?: InputMaybe<Array<CosmosElementInterviewQuestionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementInterviewQuestion component instances */
  upsert?: InputMaybe<Array<CosmosElementInterviewQuestionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementInterviewQuestionUpdateManyInput = {
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementInterviewQuestionUpdateManyLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementInterviewQuestionUpdateManyLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementInterviewQuestionUpdateManyLocalizationInput = {
  data: CosmosElementInterviewQuestionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementInterviewQuestionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementInterviewQuestionUpdateManyLocalizationInput>>;
};

export type CosmosElementInterviewQuestionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementInterviewQuestionUpdateManyInput;
  /** Document search */
  where: CosmosElementInterviewQuestionWhereInput;
};

export type CosmosElementInterviewQuestionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementInterviewQuestion document */
  create?: InputMaybe<CosmosElementInterviewQuestionCreateInput>;
  /** Delete currently connected CosmosElementInterviewQuestion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementInterviewQuestion document */
  update?: InputMaybe<CosmosElementInterviewQuestionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementInterviewQuestion document */
  upsert?: InputMaybe<CosmosElementInterviewQuestionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewQuestionUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementInterviewQuestionUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementInterviewQuestionWhereUniqueInput;
};

export type CosmosElementInterviewQuestionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementInterviewQuestionUpdateInput;
  /** Unique document search */
  where: CosmosElementInterviewQuestionWhereUniqueInput;
};

export type CosmosElementInterviewQuestionUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementInterviewQuestionCreateInput;
  /** Update document if it exists */
  update: CosmosElementInterviewQuestionUpdateInput;
};

export type CosmosElementInterviewQuestionUpsertLocalizationInput = {
  create: CosmosElementInterviewQuestionCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementInterviewQuestionUpdateLocalizationDataInput;
};

export type CosmosElementInterviewQuestionUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementInterviewQuestionUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementInterviewQuestionWhereUniqueInput;
};

export type CosmosElementInterviewQuestionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementInterviewQuestionUpsertInput;
  /** Unique document search */
  where: CosmosElementInterviewQuestionWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementInterviewQuestionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementInterviewQuestionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementInterviewQuestionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementInterviewQuestionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  answer_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  answer_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  answer_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  answer_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  answer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  answer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  answer_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementInterviewQuestion record uniquely */
export type CosmosElementInterviewQuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementInterviewUpdateInput = {
  /** interviewee input for default locale (en) */
  interviewee?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementInterviewUpdateLocalizationsInput>;
  questions?: InputMaybe<CosmosElementInterviewQuestionUpdateManyInlineInput>;
};

export type CosmosElementInterviewUpdateLocalizationDataInput = {
  interviewee?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementInterviewUpdateLocalizationInput = {
  data: CosmosElementInterviewUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementInterviewUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementInterviewCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementInterviewUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementInterviewUpsertLocalizationInput>>;
};

export type CosmosElementInterviewUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementInterview component instances */
  create?: InputMaybe<Array<CosmosElementInterviewCreateWithPositionInput>>;
  /** Delete multiple CosmosElementInterview documents */
  delete?: InputMaybe<Array<CosmosElementInterviewWhereUniqueInput>>;
  /** Update multiple CosmosElementInterview component instances */
  update?: InputMaybe<Array<CosmosElementInterviewUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementInterview component instances */
  upsert?: InputMaybe<Array<CosmosElementInterviewUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementInterviewUpdateManyInput = {
  /** interviewee input for default locale (en) */
  interviewee?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementInterviewUpdateManyLocalizationsInput>;
};

export type CosmosElementInterviewUpdateManyLocalizationDataInput = {
  interviewee?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementInterviewUpdateManyLocalizationInput = {
  data: CosmosElementInterviewUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementInterviewUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementInterviewUpdateManyLocalizationInput>>;
};

export type CosmosElementInterviewUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementInterviewUpdateManyInput;
  /** Document search */
  where: CosmosElementInterviewWhereInput;
};

export type CosmosElementInterviewUpdateOneInlineInput = {
  /** Create and connect one CosmosElementInterview document */
  create?: InputMaybe<CosmosElementInterviewCreateInput>;
  /** Delete currently connected CosmosElementInterview document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementInterview document */
  update?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementInterview document */
  upsert?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementInterviewUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementInterviewUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementInterviewWhereUniqueInput;
};

export type CosmosElementInterviewUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementInterviewUpdateInput;
  /** Unique document search */
  where: CosmosElementInterviewWhereUniqueInput;
};

export type CosmosElementInterviewUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementInterviewCreateInput;
  /** Update document if it exists */
  update: CosmosElementInterviewUpdateInput;
};

export type CosmosElementInterviewUpsertLocalizationInput = {
  create: CosmosElementInterviewCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementInterviewUpdateLocalizationDataInput;
};

export type CosmosElementInterviewUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementInterviewUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementInterviewWhereUniqueInput;
};

export type CosmosElementInterviewUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementInterviewUpsertInput;
  /** Unique document search */
  where: CosmosElementInterviewWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementInterviewWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementInterviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementInterviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementInterviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  interviewee?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  interviewee_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  interviewee_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  interviewee_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  interviewee_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  interviewee_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  interviewee_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  interviewee_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  interviewee_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  interviewee_starts_with?: InputMaybe<Scalars['String']['input']>;
  questions_every?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
  questions_none?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
  questions_some?: InputMaybe<CosmosElementInterviewQuestionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementInterview record uniquely */
export type CosmosElementInterviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLearnDocumentationCard = Entity & {
  __typename?: 'CosmosElementLearnDocumentationCard';
  cta?: Maybe<CosmosElementButton>;
  description?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  links: Array<CosmosElementLink>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLearnDocumentationCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLearnDocumentationCardCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementLearnDocumentationCardLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLinkWhereInput>;
};


export type CosmosElementLearnDocumentationCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLearnDocumentationCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLearnDocumentationCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLearnDocumentationCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLearnDocumentationCardConnection = {
  __typename?: 'CosmosElementLearnDocumentationCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLearnDocumentationCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLearnDocumentationCardCreateInput = {
  cta?: InputMaybe<CosmosElementButtonCreateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementLinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLearnDocumentationCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnDocumentationCardCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnDocumentationCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLearnDocumentationCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnDocumentationCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLearnDocumentationCardCreateLocalizationInput>>;
};

export type CosmosElementLearnDocumentationCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnDocumentationCard documents */
  create?: InputMaybe<Array<CosmosElementLearnDocumentationCardCreateInput>>;
};

export type CosmosElementLearnDocumentationCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnDocumentationCard document */
  create?: InputMaybe<CosmosElementLearnDocumentationCardCreateInput>;
};

export type CosmosElementLearnDocumentationCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLearnDocumentationCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLearnDocumentationCardEdge = {
  __typename?: 'CosmosElementLearnDocumentationCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLearnDocumentationCard;
};

/** Identifies documents */
export type CosmosElementLearnDocumentationCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<CosmosElementButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<CosmosElementLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLearnDocumentationCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLearnDocumentationCardParent = ElementLearnCategory;

export type CosmosElementLearnDocumentationCardParentConnectInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryConnectInput>;
};

export type CosmosElementLearnDocumentationCardParentCreateInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateInput>;
};

export type CosmosElementLearnDocumentationCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnDocumentationCardParent documents */
  create?: InputMaybe<Array<CosmosElementLearnDocumentationCardParentCreateInput>>;
};

export type CosmosElementLearnDocumentationCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnDocumentationCardParent document */
  create?: InputMaybe<CosmosElementLearnDocumentationCardParentCreateInput>;
};

export type CosmosElementLearnDocumentationCardParentCreateWithPositionInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateWithPositionInput>;
};

export type CosmosElementLearnDocumentationCardParentUpdateInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateInput>;
};

export type CosmosElementLearnDocumentationCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnDocumentationCardParent component instances */
  create?: InputMaybe<Array<CosmosElementLearnDocumentationCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnDocumentationCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLearnDocumentationCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnDocumentationCardParent component instances */
  update?: InputMaybe<Array<CosmosElementLearnDocumentationCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnDocumentationCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnDocumentationCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnDocumentationCardParentUpdateManyWithNestedWhereInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLearnDocumentationCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnDocumentationCardParent document */
  create?: InputMaybe<CosmosElementLearnDocumentationCardParentCreateInput>;
  /** Delete currently connected CosmosElementLearnDocumentationCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnDocumentationCardParent document */
  update?: InputMaybe<CosmosElementLearnDocumentationCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnDocumentationCardParent document */
  upsert?: InputMaybe<CosmosElementLearnDocumentationCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnDocumentationCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnDocumentationCardParentUpdateWithNestedWhereUniqueInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnDocumentationCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnDocumentationCardParentUpsertWithNestedWhereUniqueInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnDocumentationCardParentWhereInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryWhereInput>;
};

export type CosmosElementLearnDocumentationCardParentWhereUniqueInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryWhereUniqueInput>;
};

export type CosmosElementLearnDocumentationCardUpdateInput = {
  cta?: InputMaybe<CosmosElementButtonUpdateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementLinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLearnDocumentationCardUpdateLocalizationsInput>;
};

export type CosmosElementLearnDocumentationCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLearnDocumentationCardUpdateLocalizationInput = {
  data: CosmosElementLearnDocumentationCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnDocumentationCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLearnDocumentationCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnDocumentationCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLearnDocumentationCardUpsertLocalizationInput>>;
};

export type CosmosElementLearnDocumentationCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnDocumentationCard component instances */
  create?: InputMaybe<Array<CosmosElementLearnDocumentationCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnDocumentationCard documents */
  delete?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnDocumentationCard component instances */
  update?: InputMaybe<Array<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnDocumentationCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnDocumentationCardUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLearnDocumentationCardUpdateManyLocalizationsInput>;
};

export type CosmosElementLearnDocumentationCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLearnDocumentationCardUpdateManyLocalizationInput = {
  data: CosmosElementLearnDocumentationCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnDocumentationCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnDocumentationCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLearnDocumentationCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLearnDocumentationCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLearnDocumentationCardWhereInput;
};

export type CosmosElementLearnDocumentationCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnDocumentationCard document */
  create?: InputMaybe<CosmosElementLearnDocumentationCardCreateInput>;
  /** Delete currently connected CosmosElementLearnDocumentationCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnDocumentationCard document */
  update?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnDocumentationCard document */
  upsert?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLearnDocumentationCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnDocumentationCardWhereUniqueInput;
};

export type CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLearnDocumentationCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLearnDocumentationCardWhereUniqueInput;
};

export type CosmosElementLearnDocumentationCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLearnDocumentationCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLearnDocumentationCardUpdateInput;
};

export type CosmosElementLearnDocumentationCardUpsertLocalizationInput = {
  create: CosmosElementLearnDocumentationCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLearnDocumentationCardUpdateLocalizationDataInput;
};

export type CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLearnDocumentationCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnDocumentationCardWhereUniqueInput;
};

export type CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLearnDocumentationCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLearnDocumentationCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLearnDocumentationCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnDocumentationCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<CosmosElementButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<CosmosElementLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLearnDocumentationCard record uniquely */
export type CosmosElementLearnDocumentationCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLearnImageCard = Entity & {
  __typename?: 'CosmosElementLearnImageCard';
  desc?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageLabel?: Maybe<Scalars['String']['output']>;
  img?: Maybe<Asset>;
  industries: Array<CosmosEnumLearnTabs>;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLearnImageCard>;
  source?: Maybe<CosmosElementLearnImageCardSource>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type CosmosElementLearnImageCardImgArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementLearnImageCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLearnImageCardSourceArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementLearnImageCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLearnImageCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLearnImageCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLearnImageCardConnection = {
  __typename?: 'CosmosElementLearnImageCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLearnImageCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLearnImageCardCreateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<AssetCreateOneInlineInput>;
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLearnImageCardCreateLocalizationsInput>;
  source?: InputMaybe<CosmosElementLearnImageCardSourceCreateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** url input for default locale (en) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLearnImageCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnImageCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLearnImageCardCreateLocalizationInput>>;
};

export type CosmosElementLearnImageCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnImageCard documents */
  create?: InputMaybe<Array<CosmosElementLearnImageCardCreateInput>>;
};

export type CosmosElementLearnImageCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCard document */
  create?: InputMaybe<CosmosElementLearnImageCardCreateInput>;
};

export type CosmosElementLearnImageCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLearnImageCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLearnImageCardEdge = {
  __typename?: 'CosmosElementLearnImageCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLearnImageCard;
};

/** Identifies documents */
export type CosmosElementLearnImageCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnImageCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnImageCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnImageCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains *all* items provided to the filter */
  industries_contains_all?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  industries_contains_none?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains at least one item provided to the filter */
  industries_contains_some?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  industries_not?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CosmosElementLearnImageCardSourceWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLearnImageCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageLabelAsc = 'imageLabel_ASC',
  ImageLabelDesc = 'imageLabel_DESC',
  IndustriesAsc = 'industries_ASC',
  IndustriesDesc = 'industries_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type CosmosElementLearnImageCardParent = ElementLearnCategory;

export type CosmosElementLearnImageCardParentConnectInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryConnectInput>;
};

export type CosmosElementLearnImageCardParentCreateInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateInput>;
};

export type CosmosElementLearnImageCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnImageCardParent documents */
  create?: InputMaybe<Array<CosmosElementLearnImageCardParentCreateInput>>;
};

export type CosmosElementLearnImageCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCardParent document */
  create?: InputMaybe<CosmosElementLearnImageCardParentCreateInput>;
};

export type CosmosElementLearnImageCardParentCreateWithPositionInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateWithPositionInput>;
};

export type CosmosElementLearnImageCardParentUpdateInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateInput>;
};

export type CosmosElementLearnImageCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnImageCardParent component instances */
  create?: InputMaybe<Array<CosmosElementLearnImageCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnImageCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLearnImageCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnImageCardParent component instances */
  update?: InputMaybe<Array<CosmosElementLearnImageCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnImageCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnImageCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnImageCardParentUpdateManyWithNestedWhereInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLearnImageCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCardParent document */
  create?: InputMaybe<CosmosElementLearnImageCardParentCreateInput>;
  /** Delete currently connected CosmosElementLearnImageCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnImageCardParent document */
  update?: InputMaybe<CosmosElementLearnImageCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnImageCardParent document */
  upsert?: InputMaybe<CosmosElementLearnImageCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnImageCardParentUpdateWithNestedWhereUniqueInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnImageCardParentUpsertWithNestedWhereUniqueInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardParentWhereInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryWhereInput>;
};

export type CosmosElementLearnImageCardParentWhereUniqueInput = {
  ElementLearnCategory?: InputMaybe<ElementLearnCategoryWhereUniqueInput>;
};

export type CosmosElementLearnImageCardSource = Entity & {
  __typename?: 'CosmosElementLearnImageCardSource';
  ago?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLearnImageCardSource>;
  /** System stage field */
  stage: Stage;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLearnImageCardSourceLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLearnImageCardSourceUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLearnImageCardSourceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLearnImageCardSourceWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLearnImageCardSourceConnection = {
  __typename?: 'CosmosElementLearnImageCardSourceConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLearnImageCardSourceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLearnImageCardSourceCreateInput = {
  /** ago input for default locale (en) */
  ago?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLearnImageCardSourceCreateLocalizationsInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnImageCardSourceCreateLocalizationDataInput = {
  ago?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnImageCardSourceCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLearnImageCardSourceCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnImageCardSourceCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLearnImageCardSourceCreateLocalizationInput>>;
};

export type CosmosElementLearnImageCardSourceCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnImageCardSource documents */
  create?: InputMaybe<Array<CosmosElementLearnImageCardSourceCreateInput>>;
};

export type CosmosElementLearnImageCardSourceCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCardSource document */
  create?: InputMaybe<CosmosElementLearnImageCardSourceCreateInput>;
};

export type CosmosElementLearnImageCardSourceCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLearnImageCardSourceCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLearnImageCardSourceEdge = {
  __typename?: 'CosmosElementLearnImageCardSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLearnImageCardSource;
};

/** Identifies documents */
export type CosmosElementLearnImageCardSourceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  timestamp_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  timestamp_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  timestamp_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  timestamp_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLearnImageCardSourceOrderByInput {
  AgoAsc = 'ago_ASC',
  AgoDesc = 'ago_DESC',
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TimestampAsc = 'timestamp_ASC',
  TimestampDesc = 'timestamp_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLearnImageCardSourceParent = CosmosElementLearnImageCard;

export type CosmosElementLearnImageCardSourceParentConnectInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardConnectInput>;
};

export type CosmosElementLearnImageCardSourceParentCreateInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardCreateInput>;
};

export type CosmosElementLearnImageCardSourceParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnImageCardSourceParent documents */
  create?: InputMaybe<Array<CosmosElementLearnImageCardSourceParentCreateInput>>;
};

export type CosmosElementLearnImageCardSourceParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCardSourceParent document */
  create?: InputMaybe<CosmosElementLearnImageCardSourceParentCreateInput>;
};

export type CosmosElementLearnImageCardSourceParentCreateWithPositionInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardCreateWithPositionInput>;
};

export type CosmosElementLearnImageCardSourceParentUpdateInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateInput>;
};

export type CosmosElementLearnImageCardSourceParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnImageCardSourceParent component instances */
  create?: InputMaybe<Array<CosmosElementLearnImageCardSourceParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnImageCardSourceParent documents */
  delete?: InputMaybe<Array<CosmosElementLearnImageCardSourceParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnImageCardSourceParent component instances */
  update?: InputMaybe<Array<CosmosElementLearnImageCardSourceParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnImageCardSourceParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnImageCardSourceParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnImageCardSourceParentUpdateManyWithNestedWhereInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLearnImageCardSourceParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCardSourceParent document */
  create?: InputMaybe<CosmosElementLearnImageCardSourceParentCreateInput>;
  /** Delete currently connected CosmosElementLearnImageCardSourceParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnImageCardSourceParent document */
  update?: InputMaybe<CosmosElementLearnImageCardSourceParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnImageCardSourceParent document */
  upsert?: InputMaybe<CosmosElementLearnImageCardSourceParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardSourceParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnImageCardSourceParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardSourceParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnImageCardSourceParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardSourceParentWhereInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardWhereInput>;
};

export type CosmosElementLearnImageCardSourceParentWhereUniqueInput = {
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardWhereUniqueInput>;
};

export type CosmosElementLearnImageCardSourceUpdateInput = {
  /** ago input for default locale (en) */
  ago?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLearnImageCardSourceUpdateLocalizationsInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnImageCardSourceUpdateLocalizationDataInput = {
  ago?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardSourceUpdateLocalizationInput = {
  data: CosmosElementLearnImageCardSourceUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnImageCardSourceUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLearnImageCardSourceCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnImageCardSourceUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLearnImageCardSourceUpsertLocalizationInput>>;
};

export type CosmosElementLearnImageCardSourceUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnImageCardSource component instances */
  create?: InputMaybe<Array<CosmosElementLearnImageCardSourceCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnImageCardSource documents */
  delete?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnImageCardSource component instances */
  update?: InputMaybe<Array<CosmosElementLearnImageCardSourceUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnImageCardSource component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnImageCardSourceUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnImageCardSourceUpdateManyInput = {
  /** ago input for default locale (en) */
  ago?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLearnImageCardSourceUpdateManyLocalizationsInput>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnImageCardSourceUpdateManyLocalizationDataInput = {
  ago?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardSourceUpdateManyLocalizationInput = {
  data: CosmosElementLearnImageCardSourceUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnImageCardSourceUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnImageCardSourceUpdateManyLocalizationInput>>;
};

export type CosmosElementLearnImageCardSourceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLearnImageCardSourceUpdateManyInput;
  /** Document search */
  where: CosmosElementLearnImageCardSourceWhereInput;
};

export type CosmosElementLearnImageCardSourceUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCardSource document */
  create?: InputMaybe<CosmosElementLearnImageCardSourceCreateInput>;
  /** Delete currently connected CosmosElementLearnImageCardSource document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnImageCardSource document */
  update?: InputMaybe<CosmosElementLearnImageCardSourceUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnImageCardSource document */
  upsert?: InputMaybe<CosmosElementLearnImageCardSourceUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardSourceUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLearnImageCardSourceUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnImageCardSourceWhereUniqueInput;
};

export type CosmosElementLearnImageCardSourceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLearnImageCardSourceUpdateInput;
  /** Unique document search */
  where: CosmosElementLearnImageCardSourceWhereUniqueInput;
};

export type CosmosElementLearnImageCardSourceUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLearnImageCardSourceCreateInput;
  /** Update document if it exists */
  update: CosmosElementLearnImageCardSourceUpdateInput;
};

export type CosmosElementLearnImageCardSourceUpsertLocalizationInput = {
  create: CosmosElementLearnImageCardSourceCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLearnImageCardSourceUpdateLocalizationDataInput;
};

export type CosmosElementLearnImageCardSourceUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLearnImageCardSourceUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnImageCardSourceWhereUniqueInput;
};

export type CosmosElementLearnImageCardSourceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLearnImageCardSourceUpsertInput;
  /** Unique document search */
  where: CosmosElementLearnImageCardSourceWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLearnImageCardSourceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnImageCardSourceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ago?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ago_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ago_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ago_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ago_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ago_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ago_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ago_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ago_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ago_starts_with?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  timestamp_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  timestamp_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  timestamp_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  timestamp_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  timestamp_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  timestamp_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLearnImageCardSource record uniquely */
export type CosmosElementLearnImageCardSourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLearnImageCardUpdateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<AssetUpdateOneInlineInput>;
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLearnImageCardUpdateLocalizationsInput>;
  source?: InputMaybe<CosmosElementLearnImageCardSourceUpdateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** url input for default locale (en) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardUpdateLocalizationInput = {
  data: CosmosElementLearnImageCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnImageCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLearnImageCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnImageCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLearnImageCardUpsertLocalizationInput>>;
};

export type CosmosElementLearnImageCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnImageCard component instances */
  create?: InputMaybe<Array<CosmosElementLearnImageCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnImageCard documents */
  delete?: InputMaybe<Array<CosmosElementLearnImageCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnImageCard component instances */
  update?: InputMaybe<Array<CosmosElementLearnImageCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnImageCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnImageCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnImageCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLearnImageCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** url input for default locale (en) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnImageCardUpdateManyLocalizationInput = {
  data: CosmosElementLearnImageCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnImageCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnImageCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLearnImageCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLearnImageCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLearnImageCardWhereInput;
};

export type CosmosElementLearnImageCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnImageCard document */
  create?: InputMaybe<CosmosElementLearnImageCardCreateInput>;
  /** Delete currently connected CosmosElementLearnImageCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnImageCard document */
  update?: InputMaybe<CosmosElementLearnImageCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnImageCard document */
  upsert?: InputMaybe<CosmosElementLearnImageCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnImageCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLearnImageCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnImageCardWhereUniqueInput;
};

export type CosmosElementLearnImageCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLearnImageCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLearnImageCardWhereUniqueInput;
};

export type CosmosElementLearnImageCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLearnImageCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLearnImageCardUpdateInput;
};

export type CosmosElementLearnImageCardUpsertLocalizationInput = {
  create: CosmosElementLearnImageCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLearnImageCardUpdateLocalizationDataInput;
};

export type CosmosElementLearnImageCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLearnImageCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnImageCardWhereUniqueInput;
};

export type CosmosElementLearnImageCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLearnImageCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLearnImageCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLearnImageCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnImageCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnImageCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnImageCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains *all* items provided to the filter */
  industries_contains_all?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  industries_contains_none?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains at least one item provided to the filter */
  industries_contains_some?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  industries_not?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CosmosElementLearnImageCardSourceWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CosmosElementLearnImageCard record uniquely */
export type CosmosElementLearnImageCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLearnTab = Entity & {
  __typename?: 'CosmosElementLearnTab';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLearnTab>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: CosmosEnumLearnTabs;
};


export type CosmosElementLearnTabLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLearnTabUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLearnTabConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLearnTabWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLearnTabConnection = {
  __typename?: 'CosmosElementLearnTabConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLearnTabEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLearnTabCreateInput = {
  /** label input for default locale (en) */
  label: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLearnTabCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: CosmosEnumLearnTabs;
};

export type CosmosElementLearnTabCreateLocalizationDataInput = {
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLearnTabCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLearnTabCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnTabCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLearnTabCreateLocalizationInput>>;
};

export type CosmosElementLearnTabCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnTab documents */
  create?: InputMaybe<Array<CosmosElementLearnTabCreateInput>>;
};

export type CosmosElementLearnTabCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnTab document */
  create?: InputMaybe<CosmosElementLearnTabCreateInput>;
};

export type CosmosElementLearnTabCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLearnTabCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLearnTabEdge = {
  __typename?: 'CosmosElementLearnTabEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLearnTab;
};

/** Identifies documents */
export type CosmosElementLearnTabManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnTabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnTabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnTabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  value?: InputMaybe<CosmosEnumLearnTabs>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnTabs>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<CosmosEnumLearnTabs>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnTabs>>>;
};

export enum CosmosElementLearnTabOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ValueAsc = 'value_ASC',
  ValueDesc = 'value_DESC'
}

export type CosmosElementLearnTabParent = CosmosSectionLearn;

export type CosmosElementLearnTabParentConnectInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnConnectInput>;
};

export type CosmosElementLearnTabParentCreateInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateInput>;
};

export type CosmosElementLearnTabParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLearnTabParent documents */
  create?: InputMaybe<Array<CosmosElementLearnTabParentCreateInput>>;
};

export type CosmosElementLearnTabParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLearnTabParent document */
  create?: InputMaybe<CosmosElementLearnTabParentCreateInput>;
};

export type CosmosElementLearnTabParentCreateWithPositionInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateWithPositionInput>;
};

export type CosmosElementLearnTabParentUpdateInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateInput>;
};

export type CosmosElementLearnTabParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnTabParent component instances */
  create?: InputMaybe<Array<CosmosElementLearnTabParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnTabParent documents */
  delete?: InputMaybe<Array<CosmosElementLearnTabParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnTabParent component instances */
  update?: InputMaybe<Array<CosmosElementLearnTabParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnTabParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnTabParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnTabParentUpdateManyWithNestedWhereInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLearnTabParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnTabParent document */
  create?: InputMaybe<CosmosElementLearnTabParentCreateInput>;
  /** Delete currently connected CosmosElementLearnTabParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnTabParent document */
  update?: InputMaybe<CosmosElementLearnTabParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnTabParent document */
  upsert?: InputMaybe<CosmosElementLearnTabParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnTabParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnTabParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnTabParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLearnTabParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnTabParentWhereInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereInput>;
};

export type CosmosElementLearnTabParentWhereUniqueInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereUniqueInput>;
};

export type CosmosElementLearnTabUpdateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLearnTabUpdateLocalizationsInput>;
  value?: InputMaybe<CosmosEnumLearnTabs>;
};

export type CosmosElementLearnTabUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnTabUpdateLocalizationInput = {
  data: CosmosElementLearnTabUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnTabUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLearnTabCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnTabUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLearnTabUpsertLocalizationInput>>;
};

export type CosmosElementLearnTabUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLearnTab component instances */
  create?: InputMaybe<Array<CosmosElementLearnTabCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLearnTab documents */
  delete?: InputMaybe<Array<CosmosElementLearnTabWhereUniqueInput>>;
  /** Update multiple CosmosElementLearnTab component instances */
  update?: InputMaybe<Array<CosmosElementLearnTabUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLearnTab component instances */
  upsert?: InputMaybe<Array<CosmosElementLearnTabUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLearnTabUpdateManyInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLearnTabUpdateManyLocalizationsInput>;
  value?: InputMaybe<CosmosEnumLearnTabs>;
};

export type CosmosElementLearnTabUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLearnTabUpdateManyLocalizationInput = {
  data: CosmosElementLearnTabUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLearnTabUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLearnTabUpdateManyLocalizationInput>>;
};

export type CosmosElementLearnTabUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLearnTabUpdateManyInput;
  /** Document search */
  where: CosmosElementLearnTabWhereInput;
};

export type CosmosElementLearnTabUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLearnTab document */
  create?: InputMaybe<CosmosElementLearnTabCreateInput>;
  /** Delete currently connected CosmosElementLearnTab document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLearnTab document */
  update?: InputMaybe<CosmosElementLearnTabUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLearnTab document */
  upsert?: InputMaybe<CosmosElementLearnTabUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLearnTabUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLearnTabUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnTabWhereUniqueInput;
};

export type CosmosElementLearnTabUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLearnTabUpdateInput;
  /** Unique document search */
  where: CosmosElementLearnTabWhereUniqueInput;
};

export type CosmosElementLearnTabUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLearnTabCreateInput;
  /** Update document if it exists */
  update: CosmosElementLearnTabUpdateInput;
};

export type CosmosElementLearnTabUpsertLocalizationInput = {
  create: CosmosElementLearnTabCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLearnTabUpdateLocalizationDataInput;
};

export type CosmosElementLearnTabUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLearnTabUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLearnTabWhereUniqueInput;
};

export type CosmosElementLearnTabUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLearnTabUpsertInput;
  /** Unique document search */
  where: CosmosElementLearnTabWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLearnTabWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLearnTabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLearnTabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLearnTabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  value?: InputMaybe<CosmosEnumLearnTabs>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnTabs>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<CosmosEnumLearnTabs>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnTabs>>>;
};

/** References CosmosElementLearnTab record uniquely */
export type CosmosElementLearnTabWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseCardCore = Entity & {
  __typename?: 'CosmosElementLicenseCardCore';
  buttons: Array<CosmosElementButton>;
  countriesToOverride: Array<CosmosEnumCountryCodes>;
  countryOverride?: Maybe<CosmosElementLicenseCardCore>;
  description?: Maybe<RichText>;
  example?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseCardCore>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseCardCoreButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementLicenseCardCoreCountryOverrideArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementLicenseCardCoreLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseCardCoreUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseCardCoreConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseCardCoreWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseCardCoreConnection = {
  __typename?: 'CosmosElementLicenseCardCoreConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseCardCoreEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseCardCoreCreateInput = {
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseCardCoreCreateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** example input for default locale (en) */
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseCardCoreCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseCardCoreCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseCardCoreCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseCardCoreCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCardCoreCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseCardCoreCreateLocalizationInput>>;
};

export type CosmosElementLicenseCardCoreCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseCardCore documents */
  create?: InputMaybe<Array<CosmosElementLicenseCardCoreCreateInput>>;
};

export type CosmosElementLicenseCardCoreCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardCore document */
  create?: InputMaybe<CosmosElementLicenseCardCoreCreateInput>;
};

export type CosmosElementLicenseCardCoreCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseCardCoreCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseCardCoreEdge = {
  __typename?: 'CosmosElementLicenseCardCoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseCardCore;
};

/** Identifies documents */
export type CosmosElementLicenseCardCoreManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains *all* items provided to the filter */
  countriesToOverride_contains_all?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  countriesToOverride_contains_none?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains at least one item provided to the filter */
  countriesToOverride_contains_some?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  countriesToOverride_not?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseCardCoreOrderByInput {
  CountriesToOverrideAsc = 'countriesToOverride_ASC',
  CountriesToOverrideDesc = 'countriesToOverride_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseCardCoreParent = CosmosElementLicenseCardCore | CosmosElementLicenseMainCard;

export type CosmosElementLicenseCardCoreParentConnectInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreConnectInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardConnectInput>;
};

export type CosmosElementLicenseCardCoreParentCreateInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreCreateInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardCreateInput>;
};

export type CosmosElementLicenseCardCoreParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseCardCoreParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseCardCoreParentCreateInput>>;
};

export type CosmosElementLicenseCardCoreParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardCoreParent document */
  create?: InputMaybe<CosmosElementLicenseCardCoreParentCreateInput>;
};

export type CosmosElementLicenseCardCoreParentCreateWithPositionInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreCreateWithPositionInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardCreateWithPositionInput>;
};

export type CosmosElementLicenseCardCoreParentUpdateInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateInput>;
};

export type CosmosElementLicenseCardCoreParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseCardCoreParent component instances */
  create?: InputMaybe<Array<CosmosElementLicenseCardCoreParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseCardCoreParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseCardCoreParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseCardCoreParent component instances */
  update?: InputMaybe<Array<CosmosElementLicenseCardCoreParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseCardCoreParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseCardCoreParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseCardCoreParentUpdateManyWithNestedWhereInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseCardCoreParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardCoreParent document */
  create?: InputMaybe<CosmosElementLicenseCardCoreParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseCardCoreParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseCardCoreParent document */
  update?: InputMaybe<CosmosElementLicenseCardCoreParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseCardCoreParent document */
  upsert?: InputMaybe<CosmosElementLicenseCardCoreParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardCoreParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseCardCoreParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardCoreParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseCardCoreParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardCoreParentWhereInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
};

export type CosmosElementLicenseCardCoreParentWhereUniqueInput = {
  CosmosElementLicenseCardCore?: InputMaybe<CosmosElementLicenseCardCoreWhereUniqueInput>;
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardWhereUniqueInput>;
};

export type CosmosElementLicenseCardCoreUpdateInput = {
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseCardCoreUpdateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** example input for default locale (en) */
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseCardCoreUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardCoreUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardCoreUpdateLocalizationInput = {
  data: CosmosElementLicenseCardCoreUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCardCoreUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseCardCoreCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseCardCoreUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseCardCoreUpsertLocalizationInput>>;
};

export type CosmosElementLicenseCardCoreUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseCardCore component instances */
  create?: InputMaybe<Array<CosmosElementLicenseCardCoreCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseCardCore documents */
  delete?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseCardCore component instances */
  update?: InputMaybe<Array<CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseCardCore component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseCardCoreUpdateManyInput = {
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** example input for default locale (en) */
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseCardCoreUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardCoreUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardCoreUpdateManyLocalizationInput = {
  data: CosmosElementLicenseCardCoreUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCardCoreUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseCardCoreUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseCardCoreUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseCardCoreUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseCardCoreWhereInput;
};

export type CosmosElementLicenseCardCoreUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardCore document */
  create?: InputMaybe<CosmosElementLicenseCardCoreCreateInput>;
  /** Delete currently connected CosmosElementLicenseCardCore document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseCardCore document */
  update?: InputMaybe<CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseCardCore document */
  upsert?: InputMaybe<CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseCardCoreUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseCardCoreWhereUniqueInput;
};

export type CosmosElementLicenseCardCoreUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseCardCoreUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseCardCoreWhereUniqueInput;
};

export type CosmosElementLicenseCardCoreUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseCardCoreCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseCardCoreUpdateInput;
};

export type CosmosElementLicenseCardCoreUpsertLocalizationInput = {
  create: CosmosElementLicenseCardCoreCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseCardCoreUpdateLocalizationDataInput;
};

export type CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseCardCoreUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseCardCoreWhereUniqueInput;
};

export type CosmosElementLicenseCardCoreUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseCardCoreUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseCardCoreWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseCardCoreWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseCardCoreWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains *all* items provided to the filter */
  countriesToOverride_contains_all?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  countriesToOverride_contains_none?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains at least one item provided to the filter */
  countriesToOverride_contains_some?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  countriesToOverride_not?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseCardCore record uniquely */
export type CosmosElementLicenseCardCoreWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseCardTop = Entity & {
  __typename?: 'CosmosElementLicenseCardTop';
  description?: Maybe<RichText>;
  example?: Maybe<RichText>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseCardTop>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseCardTopLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseCardTopUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseCardTopConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseCardTopWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseCardTopConnection = {
  __typename?: 'CosmosElementLicenseCardTopConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseCardTopEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseCardTopCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** example input for default locale (en) */
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseCardTopCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseCardTopCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseCardTopCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseCardTopCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCardTopCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseCardTopCreateLocalizationInput>>;
};

export type CosmosElementLicenseCardTopCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseCardTop documents */
  create?: InputMaybe<Array<CosmosElementLicenseCardTopCreateInput>>;
};

export type CosmosElementLicenseCardTopCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardTop document */
  create?: InputMaybe<CosmosElementLicenseCardTopCreateInput>;
};

export type CosmosElementLicenseCardTopCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseCardTopCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseCardTopEdge = {
  __typename?: 'CosmosElementLicenseCardTopEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseCardTop;
};

/** Identifies documents */
export type CosmosElementLicenseCardTopManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseCardTopWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseCardTopWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseCardTopWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseCardTopOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseCardTopParent = CosmosElementLicenseMainCard;

export type CosmosElementLicenseCardTopParentConnectInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardConnectInput>;
};

export type CosmosElementLicenseCardTopParentCreateInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardCreateInput>;
};

export type CosmosElementLicenseCardTopParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseCardTopParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseCardTopParentCreateInput>>;
};

export type CosmosElementLicenseCardTopParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardTopParent document */
  create?: InputMaybe<CosmosElementLicenseCardTopParentCreateInput>;
};

export type CosmosElementLicenseCardTopParentCreateWithPositionInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardCreateWithPositionInput>;
};

export type CosmosElementLicenseCardTopParentUpdateInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateInput>;
};

export type CosmosElementLicenseCardTopParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseCardTopParent component instances */
  create?: InputMaybe<Array<CosmosElementLicenseCardTopParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseCardTopParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseCardTopParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseCardTopParent component instances */
  update?: InputMaybe<Array<CosmosElementLicenseCardTopParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseCardTopParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseCardTopParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseCardTopParentUpdateManyWithNestedWhereInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseCardTopParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardTopParent document */
  create?: InputMaybe<CosmosElementLicenseCardTopParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseCardTopParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseCardTopParent document */
  update?: InputMaybe<CosmosElementLicenseCardTopParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseCardTopParent document */
  upsert?: InputMaybe<CosmosElementLicenseCardTopParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardTopParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseCardTopParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardTopParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseCardTopParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardTopParentWhereInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
};

export type CosmosElementLicenseCardTopParentWhereUniqueInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardWhereUniqueInput>;
};

export type CosmosElementLicenseCardTopUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** example input for default locale (en) */
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseCardTopUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardTopUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardTopUpdateLocalizationInput = {
  data: CosmosElementLicenseCardTopUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCardTopUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseCardTopCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseCardTopUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseCardTopUpsertLocalizationInput>>;
};

export type CosmosElementLicenseCardTopUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseCardTop component instances */
  create?: InputMaybe<Array<CosmosElementLicenseCardTopCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseCardTop documents */
  delete?: InputMaybe<Array<CosmosElementLicenseCardTopWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseCardTop component instances */
  update?: InputMaybe<Array<CosmosElementLicenseCardTopUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseCardTop component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseCardTopUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseCardTopUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** example input for default locale (en) */
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseCardTopUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardTopUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  example?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCardTopUpdateManyLocalizationInput = {
  data: CosmosElementLicenseCardTopUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCardTopUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseCardTopUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseCardTopUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseCardTopUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseCardTopWhereInput;
};

export type CosmosElementLicenseCardTopUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCardTop document */
  create?: InputMaybe<CosmosElementLicenseCardTopCreateInput>;
  /** Delete currently connected CosmosElementLicenseCardTop document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseCardTop document */
  update?: InputMaybe<CosmosElementLicenseCardTopUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseCardTop document */
  upsert?: InputMaybe<CosmosElementLicenseCardTopUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCardTopUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseCardTopUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseCardTopWhereUniqueInput;
};

export type CosmosElementLicenseCardTopUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseCardTopUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseCardTopWhereUniqueInput;
};

export type CosmosElementLicenseCardTopUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseCardTopCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseCardTopUpdateInput;
};

export type CosmosElementLicenseCardTopUpsertLocalizationInput = {
  create: CosmosElementLicenseCardTopCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseCardTopUpdateLocalizationDataInput;
};

export type CosmosElementLicenseCardTopUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseCardTopUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseCardTopWhereUniqueInput;
};

export type CosmosElementLicenseCardTopUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseCardTopUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseCardTopWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseCardTopWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseCardTopWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseCardTopWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseCardTopWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseCardTop record uniquely */
export type CosmosElementLicenseCardTopWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseCollapsedCard = Entity & {
  __typename?: 'CosmosElementLicenseCollapsedCard';
  description?: Maybe<RichText>;
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseCollapsedCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseCollapsedCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseCollapsedCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseCollapsedCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseCollapsedCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseCollapsedCardConnection = {
  __typename?: 'CosmosElementLicenseCollapsedCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseCollapsedCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseCollapsedCardCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseCollapsedCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseCollapsedCardCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseCollapsedCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseCollapsedCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCollapsedCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseCollapsedCardCreateLocalizationInput>>;
};

export type CosmosElementLicenseCollapsedCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseCollapsedCard documents */
  create?: InputMaybe<Array<CosmosElementLicenseCollapsedCardCreateInput>>;
};

export type CosmosElementLicenseCollapsedCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCollapsedCard document */
  create?: InputMaybe<CosmosElementLicenseCollapsedCardCreateInput>;
};

export type CosmosElementLicenseCollapsedCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseCollapsedCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseCollapsedCardEdge = {
  __typename?: 'CosmosElementLicenseCollapsedCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseCollapsedCard;
};

/** Identifies documents */
export type CosmosElementLicenseCollapsedCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseCollapsedCardOrderByInput {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseCollapsedCardParent = CosmosSectionLicensesCollapsed;

export type CosmosElementLicenseCollapsedCardParentConnectInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedConnectInput>;
};

export type CosmosElementLicenseCollapsedCardParentCreateInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
};

export type CosmosElementLicenseCollapsedCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseCollapsedCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseCollapsedCardParentCreateInput>>;
};

export type CosmosElementLicenseCollapsedCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCollapsedCardParent document */
  create?: InputMaybe<CosmosElementLicenseCollapsedCardParentCreateInput>;
};

export type CosmosElementLicenseCollapsedCardParentCreateWithPositionInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateWithPositionInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpdateInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseCollapsedCardParent component instances */
  create?: InputMaybe<Array<CosmosElementLicenseCollapsedCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseCollapsedCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseCollapsedCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseCollapsedCardParent component instances */
  update?: InputMaybe<Array<CosmosElementLicenseCollapsedCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseCollapsedCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseCollapsedCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseCollapsedCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCollapsedCardParent document */
  create?: InputMaybe<CosmosElementLicenseCollapsedCardParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseCollapsedCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseCollapsedCardParent document */
  update?: InputMaybe<CosmosElementLicenseCollapsedCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseCollapsedCardParent document */
  upsert?: InputMaybe<CosmosElementLicenseCollapsedCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseCollapsedCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCollapsedCardParentWhereInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereInput>;
};

export type CosmosElementLicenseCollapsedCardParentWhereUniqueInput = {
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereUniqueInput>;
};

export type CosmosElementLicenseCollapsedCardUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseCollapsedCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCollapsedCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCollapsedCardUpdateLocalizationInput = {
  data: CosmosElementLicenseCollapsedCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCollapsedCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseCollapsedCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseCollapsedCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseCollapsedCardUpsertLocalizationInput>>;
};

export type CosmosElementLicenseCollapsedCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseCollapsedCard component instances */
  create?: InputMaybe<Array<CosmosElementLicenseCollapsedCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseCollapsedCard documents */
  delete?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseCollapsedCard component instances */
  update?: InputMaybe<Array<CosmosElementLicenseCollapsedCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseCollapsedCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseCollapsedCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseCollapsedCardUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseCollapsedCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCollapsedCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseCollapsedCardUpdateManyLocalizationInput = {
  data: CosmosElementLicenseCollapsedCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseCollapsedCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseCollapsedCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseCollapsedCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseCollapsedCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseCollapsedCardWhereInput;
};

export type CosmosElementLicenseCollapsedCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseCollapsedCard document */
  create?: InputMaybe<CosmosElementLicenseCollapsedCardCreateInput>;
  /** Delete currently connected CosmosElementLicenseCollapsedCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseCollapsedCard document */
  update?: InputMaybe<CosmosElementLicenseCollapsedCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseCollapsedCard document */
  upsert?: InputMaybe<CosmosElementLicenseCollapsedCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseCollapsedCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseCollapsedCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseCollapsedCardWhereUniqueInput;
};

export type CosmosElementLicenseCollapsedCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseCollapsedCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseCollapsedCardWhereUniqueInput;
};

export type CosmosElementLicenseCollapsedCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseCollapsedCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseCollapsedCardUpdateInput;
};

export type CosmosElementLicenseCollapsedCardUpsertLocalizationInput = {
  create: CosmosElementLicenseCollapsedCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseCollapsedCardUpdateLocalizationDataInput;
};

export type CosmosElementLicenseCollapsedCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseCollapsedCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseCollapsedCardWhereUniqueInput;
};

export type CosmosElementLicenseCollapsedCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseCollapsedCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseCollapsedCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseCollapsedCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseCollapsedCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseCollapsedCard record uniquely */
export type CosmosElementLicenseCollapsedCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseContactCard = Entity & {
  __typename?: 'CosmosElementLicenseContactCard';
  buttons: Array<CosmosElementIconButton>;
  description?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseContactCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseContactCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosElementLicenseContactCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseContactCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseContactCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseContactCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseContactCardConnection = {
  __typename?: 'CosmosElementLicenseContactCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseContactCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseContactCardCreateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseContactCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseContactCardCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseContactCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseContactCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseContactCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseContactCardCreateLocalizationInput>>;
};

export type CosmosElementLicenseContactCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseContactCard documents */
  create?: InputMaybe<Array<CosmosElementLicenseContactCardCreateInput>>;
};

export type CosmosElementLicenseContactCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseContactCard document */
  create?: InputMaybe<CosmosElementLicenseContactCardCreateInput>;
};

export type CosmosElementLicenseContactCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseContactCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseContactCardEdge = {
  __typename?: 'CosmosElementLicenseContactCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseContactCard;
};

/** Identifies documents */
export type CosmosElementLicenseContactCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseContactCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseContactCardParent = CosmosPageBlogDetail | CosmosPageLicense | CosmosPagePluginDetail | CosmosSectionSlimContactCard;

export type CosmosElementLicenseContactCardParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardConnectInput>;
};

export type CosmosElementLicenseContactCardParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardCreateInput>;
};

export type CosmosElementLicenseContactCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementLicenseContactCardParent documents */
  connect?: InputMaybe<Array<CosmosElementLicenseContactCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementLicenseContactCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseContactCardParentCreateInput>>;
};

export type CosmosElementLicenseContactCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementLicenseContactCardParent document */
  connect?: InputMaybe<CosmosElementLicenseContactCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementLicenseContactCardParent document */
  create?: InputMaybe<CosmosElementLicenseContactCardParentCreateInput>;
};

export type CosmosElementLicenseContactCardParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateInput>;
};

export type CosmosElementLicenseContactCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementLicenseContactCardParent documents */
  connect?: InputMaybe<Array<CosmosElementLicenseContactCardParentConnectInput>>;
  /** Create and connect multiple CosmosElementLicenseContactCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseContactCardParentCreateInput>>;
  /** Delete multiple CosmosElementLicenseContactCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseContactCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementLicenseContactCardParent documents */
  disconnect?: InputMaybe<Array<CosmosElementLicenseContactCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementLicenseContactCardParent documents */
  set?: InputMaybe<Array<CosmosElementLicenseContactCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseContactCardParent documents */
  update?: InputMaybe<Array<CosmosElementLicenseContactCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementLicenseContactCardParent documents */
  upsert?: InputMaybe<Array<CosmosElementLicenseContactCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementLicenseContactCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseContactCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementLicenseContactCardParent document */
  connect?: InputMaybe<CosmosElementLicenseContactCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementLicenseContactCardParent document */
  create?: InputMaybe<CosmosElementLicenseContactCardParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseContactCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementLicenseContactCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseContactCardParent document */
  update?: InputMaybe<CosmosElementLicenseContactCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseContactCardParent document */
  upsert?: InputMaybe<CosmosElementLicenseContactCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseContactCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseContactCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseContactCardParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardWhereInput>;
};

export type CosmosElementLicenseContactCardParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardWhereUniqueInput>;
};

export type CosmosElementLicenseContactCardUpdateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseContactCardUpdateLocalizationsInput>;
};

export type CosmosElementLicenseContactCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLicenseContactCardUpdateLocalizationInput = {
  data: CosmosElementLicenseContactCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseContactCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseContactCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseContactCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseContactCardUpsertLocalizationInput>>;
};

export type CosmosElementLicenseContactCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseContactCard component instances */
  create?: InputMaybe<Array<CosmosElementLicenseContactCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseContactCard documents */
  delete?: InputMaybe<Array<CosmosElementLicenseContactCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseContactCard component instances */
  update?: InputMaybe<Array<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseContactCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseContactCardUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseContactCardUpdateManyLocalizationsInput>;
};

export type CosmosElementLicenseContactCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLicenseContactCardUpdateManyLocalizationInput = {
  data: CosmosElementLicenseContactCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseContactCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseContactCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseContactCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseContactCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseContactCardWhereInput;
};

export type CosmosElementLicenseContactCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseContactCard document */
  create?: InputMaybe<CosmosElementLicenseContactCardCreateInput>;
  /** Delete currently connected CosmosElementLicenseContactCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseContactCard document */
  update?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseContactCard document */
  upsert?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseContactCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseContactCardWhereUniqueInput;
};

export type CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseContactCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseContactCardWhereUniqueInput;
};

export type CosmosElementLicenseContactCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseContactCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseContactCardUpdateInput;
};

export type CosmosElementLicenseContactCardUpsertLocalizationInput = {
  create: CosmosElementLicenseContactCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseContactCardUpdateLocalizationDataInput;
};

export type CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseContactCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseContactCardWhereUniqueInput;
};

export type CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseContactCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseContactCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseContactCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseContactCard record uniquely */
export type CosmosElementLicenseContactCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseMainCard = Entity & {
  __typename?: 'CosmosElementLicenseMainCard';
  cardSections: Array<CosmosElementLicenseCardCore>;
  cardTop?: Maybe<CosmosElementLicenseCardTop>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseMainCard>;
  seats?: Maybe<CosmosElementLicenseSeat>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseMainCardCardSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLicenseCardCoreOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
};


export type CosmosElementLicenseMainCardCardTopArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementLicenseMainCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseMainCardSeatsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementLicenseMainCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseMainCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseMainCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseMainCardConnection = {
  __typename?: 'CosmosElementLicenseMainCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseMainCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseMainCardCreateInput = {
  cardSections?: InputMaybe<CosmosElementLicenseCardCoreCreateManyInlineInput>;
  cardTop?: InputMaybe<CosmosElementLicenseCardTopCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseMainCardCreateLocalizationsInput>;
  seats?: InputMaybe<CosmosElementLicenseSeatCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseMainCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseMainCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseMainCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseMainCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseMainCardCreateLocalizationInput>>;
};

export type CosmosElementLicenseMainCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseMainCard documents */
  create?: InputMaybe<Array<CosmosElementLicenseMainCardCreateInput>>;
};

export type CosmosElementLicenseMainCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseMainCard document */
  create?: InputMaybe<CosmosElementLicenseMainCardCreateInput>;
};

export type CosmosElementLicenseMainCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseMainCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseMainCardEdge = {
  __typename?: 'CosmosElementLicenseMainCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseMainCard;
};

/** Identifies documents */
export type CosmosElementLicenseMainCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseMainCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseMainCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseMainCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardSections_every?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  cardSections_none?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  cardSections_some?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  cardTop?: InputMaybe<CosmosElementLicenseCardTopWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<CosmosElementLicenseSeatWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseMainCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseMainCardParent = CosmosPageLicense;

export type CosmosElementLicenseMainCardParentConnectInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseConnectInput>;
};

export type CosmosElementLicenseMainCardParentCreateInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseCreateInput>;
};

export type CosmosElementLicenseMainCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementLicenseMainCardParent documents */
  connect?: InputMaybe<Array<CosmosElementLicenseMainCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementLicenseMainCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseMainCardParentCreateInput>>;
};

export type CosmosElementLicenseMainCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementLicenseMainCardParent document */
  connect?: InputMaybe<CosmosElementLicenseMainCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementLicenseMainCardParent document */
  create?: InputMaybe<CosmosElementLicenseMainCardParentCreateInput>;
};

export type CosmosElementLicenseMainCardParentUpdateInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateInput>;
};

export type CosmosElementLicenseMainCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementLicenseMainCardParent documents */
  connect?: InputMaybe<Array<CosmosElementLicenseMainCardParentConnectInput>>;
  /** Create and connect multiple CosmosElementLicenseMainCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseMainCardParentCreateInput>>;
  /** Delete multiple CosmosElementLicenseMainCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseMainCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementLicenseMainCardParent documents */
  disconnect?: InputMaybe<Array<CosmosElementLicenseMainCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementLicenseMainCardParent documents */
  set?: InputMaybe<Array<CosmosElementLicenseMainCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseMainCardParent documents */
  update?: InputMaybe<Array<CosmosElementLicenseMainCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementLicenseMainCardParent documents */
  upsert?: InputMaybe<Array<CosmosElementLicenseMainCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementLicenseMainCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseMainCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementLicenseMainCardParent document */
  connect?: InputMaybe<CosmosElementLicenseMainCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementLicenseMainCardParent document */
  create?: InputMaybe<CosmosElementLicenseMainCardParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseMainCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementLicenseMainCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseMainCardParent document */
  update?: InputMaybe<CosmosElementLicenseMainCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseMainCardParent document */
  upsert?: InputMaybe<CosmosElementLicenseMainCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseMainCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseMainCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseMainCardParentWhereInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereInput>;
};

export type CosmosElementLicenseMainCardParentWhereUniqueInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
};

export type CosmosElementLicenseMainCardUpdateInput = {
  cardSections?: InputMaybe<CosmosElementLicenseCardCoreUpdateManyInlineInput>;
  cardTop?: InputMaybe<CosmosElementLicenseCardTopUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseMainCardUpdateLocalizationsInput>;
  seats?: InputMaybe<CosmosElementLicenseSeatUpdateOneInlineInput>;
};

export type CosmosElementLicenseMainCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseMainCardUpdateLocalizationInput = {
  data: CosmosElementLicenseMainCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseMainCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseMainCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseMainCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseMainCardUpsertLocalizationInput>>;
};

export type CosmosElementLicenseMainCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseMainCard component instances */
  create?: InputMaybe<Array<CosmosElementLicenseMainCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseMainCard documents */
  delete?: InputMaybe<Array<CosmosElementLicenseMainCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseMainCard component instances */
  update?: InputMaybe<Array<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseMainCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseMainCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseMainCardUpdateManyLocalizationsInput>;
};

export type CosmosElementLicenseMainCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseMainCardUpdateManyLocalizationInput = {
  data: CosmosElementLicenseMainCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseMainCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseMainCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseMainCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseMainCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseMainCardWhereInput;
};

export type CosmosElementLicenseMainCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseMainCard document */
  create?: InputMaybe<CosmosElementLicenseMainCardCreateInput>;
  /** Delete currently connected CosmosElementLicenseMainCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseMainCard document */
  update?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseMainCard document */
  upsert?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseMainCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseMainCardWhereUniqueInput;
};

export type CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseMainCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseMainCardWhereUniqueInput;
};

export type CosmosElementLicenseMainCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseMainCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseMainCardUpdateInput;
};

export type CosmosElementLicenseMainCardUpsertLocalizationInput = {
  create: CosmosElementLicenseMainCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseMainCardUpdateLocalizationDataInput;
};

export type CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseMainCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseMainCardWhereUniqueInput;
};

export type CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseMainCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseMainCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseMainCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseMainCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseMainCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseMainCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardSections_every?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  cardSections_none?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  cardSections_some?: InputMaybe<CosmosElementLicenseCardCoreWhereInput>;
  cardTop?: InputMaybe<CosmosElementLicenseCardTopWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<CosmosElementLicenseSeatWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseMainCard record uniquely */
export type CosmosElementLicenseMainCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseSeat = Entity & {
  __typename?: 'CosmosElementLicenseSeat';
  addButtonLabel?: Maybe<Scalars['String']['output']>;
  buttons: Array<CosmosElementIconButton>;
  countriesToOverride: Array<CosmosEnumCountryCodes>;
  countryOverride?: Maybe<CosmosElementLicenseSeat>;
  description?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseSeat>;
  minusButtonLabel?: Maybe<Scalars['String']['output']>;
  perSeatPerYear?: Maybe<Scalars['String']['output']>;
  perYear?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  taxes?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseSeatButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosElementLicenseSeatCountryOverrideArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementLicenseSeatLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseSeatUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseSeatConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseSeatWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseSeatConnection = {
  __typename?: 'CosmosElementLicenseSeatConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseSeatEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseSeatCreateInput = {
  /** addButtonLabel input for default locale (en) */
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseSeatCreateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseSeatCreateLocalizationsInput>;
  /** minusButtonLabel input for default locale (en) */
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** perSeatPerYear input for default locale (en) */
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  /** perYear input for default locale (en) */
  perYear?: InputMaybe<Scalars['String']['input']>;
  /** taxes input for default locale (en) */
  taxes?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseSeatCreateLocalizationDataInput = {
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  perYear?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseSeatCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseSeatCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseSeatCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseSeatCreateLocalizationInput>>;
};

export type CosmosElementLicenseSeatCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseSeat documents */
  create?: InputMaybe<Array<CosmosElementLicenseSeatCreateInput>>;
};

export type CosmosElementLicenseSeatCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseSeat document */
  create?: InputMaybe<CosmosElementLicenseSeatCreateInput>;
};

export type CosmosElementLicenseSeatCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseSeatCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseSeatEdge = {
  __typename?: 'CosmosElementLicenseSeatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseSeat;
};

/** Identifies documents */
export type CosmosElementLicenseSeatManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseSeatWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseSeatWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseSeatWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains *all* items provided to the filter */
  countriesToOverride_contains_all?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  countriesToOverride_contains_none?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains at least one item provided to the filter */
  countriesToOverride_contains_some?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  countriesToOverride_not?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseSeatWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseSeatOrderByInput {
  AddButtonLabelAsc = 'addButtonLabel_ASC',
  AddButtonLabelDesc = 'addButtonLabel_DESC',
  CountriesToOverrideAsc = 'countriesToOverride_ASC',
  CountriesToOverrideDesc = 'countriesToOverride_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MinusButtonLabelAsc = 'minusButtonLabel_ASC',
  MinusButtonLabelDesc = 'minusButtonLabel_DESC',
  PerSeatPerYearAsc = 'perSeatPerYear_ASC',
  PerSeatPerYearDesc = 'perSeatPerYear_DESC',
  PerYearAsc = 'perYear_ASC',
  PerYearDesc = 'perYear_DESC',
  TaxesAsc = 'taxes_ASC',
  TaxesDesc = 'taxes_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseSeatParent = CosmosElementLicenseMainCard | CosmosElementLicenseSeat;

export type CosmosElementLicenseSeatParentConnectInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardConnectInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatConnectInput>;
};

export type CosmosElementLicenseSeatParentCreateInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardCreateInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatCreateInput>;
};

export type CosmosElementLicenseSeatParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseSeatParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseSeatParentCreateInput>>;
};

export type CosmosElementLicenseSeatParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseSeatParent document */
  create?: InputMaybe<CosmosElementLicenseSeatParentCreateInput>;
};

export type CosmosElementLicenseSeatParentCreateWithPositionInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardCreateWithPositionInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatCreateWithPositionInput>;
};

export type CosmosElementLicenseSeatParentUpdateInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateInput>;
};

export type CosmosElementLicenseSeatParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseSeatParent component instances */
  create?: InputMaybe<Array<CosmosElementLicenseSeatParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseSeatParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseSeatParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseSeatParent component instances */
  update?: InputMaybe<Array<CosmosElementLicenseSeatParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseSeatParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseSeatParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseSeatParentUpdateManyWithNestedWhereInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseSeatParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseSeatParent document */
  create?: InputMaybe<CosmosElementLicenseSeatParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseSeatParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseSeatParent document */
  update?: InputMaybe<CosmosElementLicenseSeatParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseSeatParent document */
  upsert?: InputMaybe<CosmosElementLicenseSeatParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseSeatParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseSeatParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseSeatParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLicenseSeatParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseSeatParentWhereInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatWhereInput>;
};

export type CosmosElementLicenseSeatParentWhereUniqueInput = {
  CosmosElementLicenseMainCard?: InputMaybe<CosmosElementLicenseMainCardWhereUniqueInput>;
  CosmosElementLicenseSeat?: InputMaybe<CosmosElementLicenseSeatWhereUniqueInput>;
};

export type CosmosElementLicenseSeatUpdateInput = {
  /** addButtonLabel input for default locale (en) */
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseSeatUpdateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseSeatUpdateLocalizationsInput>;
  /** minusButtonLabel input for default locale (en) */
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** perSeatPerYear input for default locale (en) */
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  /** perYear input for default locale (en) */
  perYear?: InputMaybe<Scalars['String']['input']>;
  /** taxes input for default locale (en) */
  taxes?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseSeatUpdateLocalizationDataInput = {
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  perYear?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseSeatUpdateLocalizationInput = {
  data: CosmosElementLicenseSeatUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseSeatUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseSeatCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseSeatUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseSeatUpsertLocalizationInput>>;
};

export type CosmosElementLicenseSeatUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseSeat component instances */
  create?: InputMaybe<Array<CosmosElementLicenseSeatCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseSeat documents */
  delete?: InputMaybe<Array<CosmosElementLicenseSeatWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseSeat component instances */
  update?: InputMaybe<Array<CosmosElementLicenseSeatUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseSeat component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseSeatUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseSeatUpdateManyInput = {
  /** addButtonLabel input for default locale (en) */
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseSeatUpdateManyLocalizationsInput>;
  /** minusButtonLabel input for default locale (en) */
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** perSeatPerYear input for default locale (en) */
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  /** perYear input for default locale (en) */
  perYear?: InputMaybe<Scalars['String']['input']>;
  /** taxes input for default locale (en) */
  taxes?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseSeatUpdateManyLocalizationDataInput = {
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  perYear?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseSeatUpdateManyLocalizationInput = {
  data: CosmosElementLicenseSeatUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseSeatUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseSeatUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseSeatUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseSeatUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseSeatWhereInput;
};

export type CosmosElementLicenseSeatUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseSeat document */
  create?: InputMaybe<CosmosElementLicenseSeatCreateInput>;
  /** Delete currently connected CosmosElementLicenseSeat document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseSeat document */
  update?: InputMaybe<CosmosElementLicenseSeatUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseSeat document */
  upsert?: InputMaybe<CosmosElementLicenseSeatUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseSeatUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseSeatUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseSeatWhereUniqueInput;
};

export type CosmosElementLicenseSeatUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseSeatUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseSeatWhereUniqueInput;
};

export type CosmosElementLicenseSeatUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseSeatCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseSeatUpdateInput;
};

export type CosmosElementLicenseSeatUpsertLocalizationInput = {
  create: CosmosElementLicenseSeatCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseSeatUpdateLocalizationDataInput;
};

export type CosmosElementLicenseSeatUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseSeatUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseSeatWhereUniqueInput;
};

export type CosmosElementLicenseSeatUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseSeatUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseSeatWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseSeatWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseSeatWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseSeatWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseSeatWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  addButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  addButtonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  addButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  addButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  addButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  addButtonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  addButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  addButtonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  addButtonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  countriesToOverride?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains *all* items provided to the filter */
  countriesToOverride_contains_all?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  countriesToOverride_contains_none?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains at least one item provided to the filter */
  countriesToOverride_contains_some?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  countriesToOverride_not?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  countryOverride?: InputMaybe<CosmosElementLicenseSeatWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  minusButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  minusButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  minusButtonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  minusButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  minusButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  minusButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  minusButtonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  minusButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  minusButtonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  minusButtonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  perSeatPerYear?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  perSeatPerYear_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  perSeatPerYear_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  perSeatPerYear_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  perSeatPerYear_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  perSeatPerYear_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  perSeatPerYear_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  perSeatPerYear_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  perSeatPerYear_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  perSeatPerYear_starts_with?: InputMaybe<Scalars['String']['input']>;
  perYear?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  perYear_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  perYear_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  perYear_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  perYear_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  perYear_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  perYear_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  perYear_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  perYear_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  perYear_starts_with?: InputMaybe<Scalars['String']['input']>;
  taxes?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  taxes_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  taxes_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  taxes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  taxes_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  taxes_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  taxes_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  taxes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  taxes_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  taxes_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseSeat record uniquely */
export type CosmosElementLicenseSeatWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLicenseTopCard = Entity & {
  __typename?: 'CosmosElementLicenseTopCard';
  bullets: Array<RichText>;
  buttons: Array<CosmosElementButton>;
  checkList: Array<CosmosElementCheckListItem>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLicenseTopCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLicenseTopCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementLicenseTopCardCheckListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementCheckListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementCheckListItemWhereInput>;
};


export type CosmosElementLicenseTopCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLicenseTopCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLicenseTopCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLicenseTopCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLicenseTopCardConnection = {
  __typename?: 'CosmosElementLicenseTopCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLicenseTopCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLicenseTopCardCreateInput = {
  /** bullets input for default locale (en) */
  bullets?: InputMaybe<Array<Scalars['RichTextAST']['input']>>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  checkList?: InputMaybe<CosmosElementCheckListItemCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLicenseTopCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseTopCardCreateLocalizationDataInput = {
  bullets?: InputMaybe<Array<Scalars['RichTextAST']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLicenseTopCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLicenseTopCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseTopCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLicenseTopCardCreateLocalizationInput>>;
};

export type CosmosElementLicenseTopCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLicenseTopCard documents */
  create?: InputMaybe<Array<CosmosElementLicenseTopCardCreateInput>>;
};

export type CosmosElementLicenseTopCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseTopCard document */
  create?: InputMaybe<CosmosElementLicenseTopCardCreateInput>;
};

export type CosmosElementLicenseTopCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLicenseTopCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLicenseTopCardEdge = {
  __typename?: 'CosmosElementLicenseTopCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLicenseTopCard;
};

/** Identifies documents */
export type CosmosElementLicenseTopCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseTopCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseTopCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseTopCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  checkList_every?: InputMaybe<CosmosElementCheckListItemWhereInput>;
  checkList_none?: InputMaybe<CosmosElementCheckListItemWhereInput>;
  checkList_some?: InputMaybe<CosmosElementCheckListItemWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLicenseTopCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLicenseTopCardParent = CosmosPageLicense | CosmosSectionLicensesCollapsed;

export type CosmosElementLicenseTopCardParentConnectInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseConnectInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedConnectInput>;
};

export type CosmosElementLicenseTopCardParentCreateInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseCreateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
};

export type CosmosElementLicenseTopCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementLicenseTopCardParent documents */
  connect?: InputMaybe<Array<CosmosElementLicenseTopCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementLicenseTopCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseTopCardParentCreateInput>>;
};

export type CosmosElementLicenseTopCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementLicenseTopCardParent document */
  connect?: InputMaybe<CosmosElementLicenseTopCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementLicenseTopCardParent document */
  create?: InputMaybe<CosmosElementLicenseTopCardParentCreateInput>;
};

export type CosmosElementLicenseTopCardParentUpdateInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateInput>;
};

export type CosmosElementLicenseTopCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementLicenseTopCardParent documents */
  connect?: InputMaybe<Array<CosmosElementLicenseTopCardParentConnectInput>>;
  /** Create and connect multiple CosmosElementLicenseTopCardParent documents */
  create?: InputMaybe<Array<CosmosElementLicenseTopCardParentCreateInput>>;
  /** Delete multiple CosmosElementLicenseTopCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLicenseTopCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementLicenseTopCardParent documents */
  disconnect?: InputMaybe<Array<CosmosElementLicenseTopCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementLicenseTopCardParent documents */
  set?: InputMaybe<Array<CosmosElementLicenseTopCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseTopCardParent documents */
  update?: InputMaybe<Array<CosmosElementLicenseTopCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementLicenseTopCardParent documents */
  upsert?: InputMaybe<Array<CosmosElementLicenseTopCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementLicenseTopCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateManyWithNestedWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLicenseTopCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementLicenseTopCardParent document */
  connect?: InputMaybe<CosmosElementLicenseTopCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementLicenseTopCardParent document */
  create?: InputMaybe<CosmosElementLicenseTopCardParentCreateInput>;
  /** Delete currently connected CosmosElementLicenseTopCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementLicenseTopCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseTopCardParent document */
  update?: InputMaybe<CosmosElementLicenseTopCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseTopCardParent document */
  upsert?: InputMaybe<CosmosElementLicenseTopCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseTopCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseTopCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseTopCardParentWhereInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereInput>;
};

export type CosmosElementLicenseTopCardParentWhereUniqueInput = {
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereUniqueInput>;
};

export type CosmosElementLicenseTopCardUpdateInput = {
  /** bullets input for default locale (en) */
  bullets?: InputMaybe<Array<Scalars['RichTextAST']['input']>>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  checkList?: InputMaybe<CosmosElementCheckListItemUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLicenseTopCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseTopCardUpdateLocalizationDataInput = {
  bullets?: InputMaybe<Array<Scalars['RichTextAST']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseTopCardUpdateLocalizationInput = {
  data: CosmosElementLicenseTopCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseTopCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLicenseTopCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseTopCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLicenseTopCardUpsertLocalizationInput>>;
};

export type CosmosElementLicenseTopCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLicenseTopCard component instances */
  create?: InputMaybe<Array<CosmosElementLicenseTopCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLicenseTopCard documents */
  delete?: InputMaybe<Array<CosmosElementLicenseTopCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLicenseTopCard component instances */
  update?: InputMaybe<Array<CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLicenseTopCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLicenseTopCardUpdateManyInput = {
  /** bullets input for default locale (en) */
  bullets?: InputMaybe<Array<Scalars['RichTextAST']['input']>>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLicenseTopCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseTopCardUpdateManyLocalizationDataInput = {
  bullets?: InputMaybe<Array<Scalars['RichTextAST']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLicenseTopCardUpdateManyLocalizationInput = {
  data: CosmosElementLicenseTopCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLicenseTopCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLicenseTopCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLicenseTopCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLicenseTopCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLicenseTopCardWhereInput;
};

export type CosmosElementLicenseTopCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLicenseTopCard document */
  create?: InputMaybe<CosmosElementLicenseTopCardCreateInput>;
  /** Delete currently connected CosmosElementLicenseTopCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLicenseTopCard document */
  update?: InputMaybe<CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLicenseTopCard document */
  upsert?: InputMaybe<CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLicenseTopCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseTopCardWhereUniqueInput;
};

export type CosmosElementLicenseTopCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLicenseTopCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLicenseTopCardWhereUniqueInput;
};

export type CosmosElementLicenseTopCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLicenseTopCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLicenseTopCardUpdateInput;
};

export type CosmosElementLicenseTopCardUpsertLocalizationInput = {
  create: CosmosElementLicenseTopCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLicenseTopCardUpdateLocalizationDataInput;
};

export type CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLicenseTopCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLicenseTopCardWhereUniqueInput;
};

export type CosmosElementLicenseTopCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLicenseTopCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLicenseTopCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLicenseTopCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLicenseTopCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLicenseTopCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLicenseTopCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  checkList_every?: InputMaybe<CosmosElementCheckListItemWhereInput>;
  checkList_none?: InputMaybe<CosmosElementCheckListItemWhereInput>;
  checkList_some?: InputMaybe<CosmosElementCheckListItemWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLicenseTopCard record uniquely */
export type CosmosElementLicenseTopCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLink = Entity & {
  __typename?: 'CosmosElementLink';
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<CosmosEnumLinkIcons>;
  iconPosition?: Maybe<CosmosEnumIconPosition>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLink>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLinkConnection = {
  __typename?: 'CosmosElementLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLinkCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumLinkIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLinkCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLinkCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLinkCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLinkCreateLocalizationInput>>;
};

export type CosmosElementLinkCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLink documents */
  create?: InputMaybe<Array<CosmosElementLinkCreateInput>>;
};

export type CosmosElementLinkCreateOneInlineInput = {
  /** Create and connect one CosmosElementLink document */
  create?: InputMaybe<CosmosElementLinkCreateInput>;
};

export type CosmosElementLinkCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLinkEdge = {
  __typename?: 'CosmosElementLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLink;
};

/** Identifies documents */
export type CosmosElementLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumLinkIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<CosmosEnumLinkIcons>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLinkOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLinkParent = CommunityCard | CosmosElementDownloadCard | CosmosElementGameDevFeatureCard | CosmosElementLearnDocumentationCard | CosmosSectionCrux | CosmosSectionLicensesCollapsed | CosmosSectionLogoMultiCard;

export type CosmosElementLinkParentConnectInput = {
  CommunityCard?: InputMaybe<CommunityCardConnectInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardConnectInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardConnectInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardConnectInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxConnectInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
};

export type CosmosElementLinkParentCreateInput = {
  CommunityCard?: InputMaybe<CommunityCardCreateInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardCreateInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
};

export type CosmosElementLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLinkParent documents */
  create?: InputMaybe<Array<CosmosElementLinkParentCreateInput>>;
};

export type CosmosElementLinkParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLinkParent document */
  create?: InputMaybe<CosmosElementLinkParentCreateInput>;
};

export type CosmosElementLinkParentCreateWithPositionInput = {
  CommunityCard?: InputMaybe<CommunityCardCreateWithPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateWithPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateWithPositionInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardCreateWithPositionInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateWithPositionInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateWithPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
};

export type CosmosElementLinkParentUpdateInput = {
  CommunityCard?: InputMaybe<CommunityCardUpdateInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
};

export type CosmosElementLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLinkParent component instances */
  create?: InputMaybe<Array<CosmosElementLinkParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLinkParent documents */
  delete?: InputMaybe<Array<CosmosElementLinkParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLinkParent component instances */
  update?: InputMaybe<Array<CosmosElementLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLinkParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLinkParentUpdateManyWithNestedWhereInput = {
  CommunityCard?: InputMaybe<CommunityCardUpdateManyWithNestedWhereInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateManyWithNestedWhereInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateManyWithNestedWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLinkParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLinkParent document */
  create?: InputMaybe<CosmosElementLinkParentCreateInput>;
  /** Delete currently connected CosmosElementLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLinkParent document */
  update?: InputMaybe<CosmosElementLinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLinkParent document */
  upsert?: InputMaybe<CosmosElementLinkParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CommunityCard?: InputMaybe<CommunityCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLinkParentUpdateWithNestedWhereUniqueInput = {
  CommunityCard?: InputMaybe<CommunityCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CommunityCard?: InputMaybe<CommunityCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLinkParentUpsertWithNestedWhereUniqueInput = {
  CommunityCard?: InputMaybe<CommunityCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLinkParentWhereInput = {
  CommunityCard?: InputMaybe<CommunityCardWhereInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardWhereInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
};

export type CosmosElementLinkParentWhereUniqueInput = {
  CommunityCard?: InputMaybe<CommunityCardWhereUniqueInput>;
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereUniqueInput>;
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
};

export type CosmosElementLinkUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumLinkIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLinkUpdateLocalizationsInput>;
};

export type CosmosElementLinkUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLinkUpdateLocalizationInput = {
  data: CosmosElementLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLinkUpsertLocalizationInput>>;
};

export type CosmosElementLinkUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLink component instances */
  create?: InputMaybe<Array<CosmosElementLinkCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLink documents */
  delete?: InputMaybe<Array<CosmosElementLinkWhereUniqueInput>>;
  /** Update multiple CosmosElementLink component instances */
  update?: InputMaybe<Array<CosmosElementLinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLink component instances */
  upsert?: InputMaybe<Array<CosmosElementLinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLinkUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumLinkIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLinkUpdateManyLocalizationsInput>;
};

export type CosmosElementLinkUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLinkUpdateManyLocalizationInput = {
  data: CosmosElementLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLinkUpdateManyLocalizationInput>>;
};

export type CosmosElementLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLinkUpdateManyInput;
  /** Document search */
  where: CosmosElementLinkWhereInput;
};

export type CosmosElementLinkUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLink document */
  create?: InputMaybe<CosmosElementLinkCreateInput>;
  /** Delete currently connected CosmosElementLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLink document */
  update?: InputMaybe<CosmosElementLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLink document */
  upsert?: InputMaybe<CosmosElementLinkUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLinkWhereUniqueInput;
};

export type CosmosElementLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLinkUpdateInput;
  /** Unique document search */
  where: CosmosElementLinkWhereUniqueInput;
};

export type CosmosElementLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLinkCreateInput;
  /** Update document if it exists */
  update: CosmosElementLinkUpdateInput;
};

export type CosmosElementLinkUpsertLocalizationInput = {
  create: CosmosElementLinkCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLinkUpdateLocalizationDataInput;
};

export type CosmosElementLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLinkWhereUniqueInput;
};

export type CosmosElementLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLinkUpsertInput;
  /** Unique document search */
  where: CosmosElementLinkWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<CosmosEnumLinkIcons>;
  iconPosition?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<CosmosEnumIconPosition>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumIconPosition>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<CosmosEnumLinkIcons>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLinkIcons>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLink record uniquely */
export type CosmosElementLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementLogo = Entity & {
  __typename?: 'CosmosElementLogo';
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Asset;
  landscape: Scalars['Boolean']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLogo>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementLogoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLogoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLogoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLogoWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLogoConnection = {
  __typename?: 'CosmosElementLogoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLogoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLogoCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  image: AssetCreateOneInlineInput;
  landscape: Scalars['Boolean']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLogoCreateLocalizationsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLogoCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLogoCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLogoCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLogoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLogoCreateLocalizationInput>>;
};

export type CosmosElementLogoCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLogo documents */
  create?: InputMaybe<Array<CosmosElementLogoCreateInput>>;
};

export type CosmosElementLogoCreateOneInlineInput = {
  /** Create and connect one CosmosElementLogo document */
  create?: InputMaybe<CosmosElementLogoCreateInput>;
};

export type CosmosElementLogoCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLogoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLogoEdge = {
  __typename?: 'CosmosElementLogoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLogo;
};

/** Identifies documents */
export type CosmosElementLogoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLogoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLogoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLogoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  landscape?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  landscape_not?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type CosmosElementLogoMultiCard = Entity & {
  __typename?: 'CosmosElementLogoMultiCard';
  desc?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementLogoMultiCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementLogoMultiCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementLogoMultiCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementLogoMultiCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementLogoMultiCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementLogoMultiCardConnection = {
  __typename?: 'CosmosElementLogoMultiCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementLogoMultiCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementLogoMultiCardCreateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementLogoMultiCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLogoMultiCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementLogoMultiCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementLogoMultiCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLogoMultiCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementLogoMultiCardCreateLocalizationInput>>;
};

export type CosmosElementLogoMultiCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLogoMultiCard documents */
  create?: InputMaybe<Array<CosmosElementLogoMultiCardCreateInput>>;
};

export type CosmosElementLogoMultiCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementLogoMultiCard document */
  create?: InputMaybe<CosmosElementLogoMultiCardCreateInput>;
};

export type CosmosElementLogoMultiCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementLogoMultiCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementLogoMultiCardEdge = {
  __typename?: 'CosmosElementLogoMultiCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementLogoMultiCard;
};

/** Identifies documents */
export type CosmosElementLogoMultiCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLogoMultiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLogoMultiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLogoMultiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementLogoMultiCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLogoMultiCardParent = CosmosSectionLogoMultiCard;

export type CosmosElementLogoMultiCardParentConnectInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
};

export type CosmosElementLogoMultiCardParentCreateInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
};

export type CosmosElementLogoMultiCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLogoMultiCardParent documents */
  create?: InputMaybe<Array<CosmosElementLogoMultiCardParentCreateInput>>;
};

export type CosmosElementLogoMultiCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLogoMultiCardParent document */
  create?: InputMaybe<CosmosElementLogoMultiCardParentCreateInput>;
};

export type CosmosElementLogoMultiCardParentCreateWithPositionInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
};

export type CosmosElementLogoMultiCardParentUpdateInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
};

export type CosmosElementLogoMultiCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLogoMultiCardParent component instances */
  create?: InputMaybe<Array<CosmosElementLogoMultiCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLogoMultiCardParent documents */
  delete?: InputMaybe<Array<CosmosElementLogoMultiCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLogoMultiCardParent component instances */
  update?: InputMaybe<Array<CosmosElementLogoMultiCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLogoMultiCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLogoMultiCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLogoMultiCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLogoMultiCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLogoMultiCardParent document */
  create?: InputMaybe<CosmosElementLogoMultiCardParentCreateInput>;
  /** Delete currently connected CosmosElementLogoMultiCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLogoMultiCardParent document */
  update?: InputMaybe<CosmosElementLogoMultiCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLogoMultiCardParent document */
  upsert?: InputMaybe<CosmosElementLogoMultiCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoMultiCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLogoMultiCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoMultiCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLogoMultiCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoMultiCardParentWhereInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
};

export type CosmosElementLogoMultiCardParentWhereUniqueInput = {
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
};

export type CosmosElementLogoMultiCardUpdateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLogoMultiCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLogoMultiCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLogoMultiCardUpdateLocalizationInput = {
  data: CosmosElementLogoMultiCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLogoMultiCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLogoMultiCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLogoMultiCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLogoMultiCardUpsertLocalizationInput>>;
};

export type CosmosElementLogoMultiCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLogoMultiCard component instances */
  create?: InputMaybe<Array<CosmosElementLogoMultiCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLogoMultiCard documents */
  delete?: InputMaybe<Array<CosmosElementLogoMultiCardWhereUniqueInput>>;
  /** Update multiple CosmosElementLogoMultiCard component instances */
  update?: InputMaybe<Array<CosmosElementLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLogoMultiCard component instances */
  upsert?: InputMaybe<Array<CosmosElementLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLogoMultiCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLogoMultiCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLogoMultiCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementLogoMultiCardUpdateManyLocalizationInput = {
  data: CosmosElementLogoMultiCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLogoMultiCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLogoMultiCardUpdateManyLocalizationInput>>;
};

export type CosmosElementLogoMultiCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLogoMultiCardUpdateManyInput;
  /** Document search */
  where: CosmosElementLogoMultiCardWhereInput;
};

export type CosmosElementLogoMultiCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLogoMultiCard document */
  create?: InputMaybe<CosmosElementLogoMultiCardCreateInput>;
  /** Delete currently connected CosmosElementLogoMultiCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLogoMultiCard document */
  update?: InputMaybe<CosmosElementLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLogoMultiCard document */
  upsert?: InputMaybe<CosmosElementLogoMultiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLogoMultiCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLogoMultiCardWhereUniqueInput;
};

export type CosmosElementLogoMultiCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLogoMultiCardUpdateInput;
  /** Unique document search */
  where: CosmosElementLogoMultiCardWhereUniqueInput;
};

export type CosmosElementLogoMultiCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLogoMultiCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementLogoMultiCardUpdateInput;
};

export type CosmosElementLogoMultiCardUpsertLocalizationInput = {
  create: CosmosElementLogoMultiCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLogoMultiCardUpdateLocalizationDataInput;
};

export type CosmosElementLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLogoMultiCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLogoMultiCardWhereUniqueInput;
};

export type CosmosElementLogoMultiCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLogoMultiCardUpsertInput;
  /** Unique document search */
  where: CosmosElementLogoMultiCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLogoMultiCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLogoMultiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLogoMultiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLogoMultiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLogoMultiCard record uniquely */
export type CosmosElementLogoMultiCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CosmosElementLogoOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LandscapeAsc = 'landscape_ASC',
  LandscapeDesc = 'landscape_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementLogoParent = CosmosSectionLogoList;

export type CosmosElementLogoParentConnectInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListConnectInput>;
};

export type CosmosElementLogoParentCreateInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateInput>;
};

export type CosmosElementLogoParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementLogoParent documents */
  create?: InputMaybe<Array<CosmosElementLogoParentCreateInput>>;
};

export type CosmosElementLogoParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementLogoParent document */
  create?: InputMaybe<CosmosElementLogoParentCreateInput>;
};

export type CosmosElementLogoParentCreateWithPositionInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateWithPositionInput>;
};

export type CosmosElementLogoParentUpdateInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateInput>;
};

export type CosmosElementLogoParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLogoParent component instances */
  create?: InputMaybe<Array<CosmosElementLogoParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLogoParent documents */
  delete?: InputMaybe<Array<CosmosElementLogoParentWhereUniqueInput>>;
  /** Update multiple CosmosElementLogoParent component instances */
  update?: InputMaybe<Array<CosmosElementLogoParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLogoParent component instances */
  upsert?: InputMaybe<Array<CosmosElementLogoParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLogoParentUpdateManyWithNestedWhereInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateManyWithNestedWhereInput>;
};

export type CosmosElementLogoParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLogoParent document */
  create?: InputMaybe<CosmosElementLogoParentCreateInput>;
  /** Delete currently connected CosmosElementLogoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLogoParent document */
  update?: InputMaybe<CosmosElementLogoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLogoParent document */
  upsert?: InputMaybe<CosmosElementLogoParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLogoParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementLogoParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoParentWhereInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereInput>;
};

export type CosmosElementLogoParentWhereUniqueInput = {
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereUniqueInput>;
};

export type CosmosElementLogoUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  landscape?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementLogoUpdateLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLogoUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLogoUpdateLocalizationInput = {
  data: CosmosElementLogoUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLogoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementLogoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLogoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementLogoUpsertLocalizationInput>>;
};

export type CosmosElementLogoUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementLogo component instances */
  create?: InputMaybe<Array<CosmosElementLogoCreateWithPositionInput>>;
  /** Delete multiple CosmosElementLogo documents */
  delete?: InputMaybe<Array<CosmosElementLogoWhereUniqueInput>>;
  /** Update multiple CosmosElementLogo component instances */
  update?: InputMaybe<Array<CosmosElementLogoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementLogo component instances */
  upsert?: InputMaybe<Array<CosmosElementLogoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementLogoUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  landscape?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementLogoUpdateManyLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLogoUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementLogoUpdateManyLocalizationInput = {
  data: CosmosElementLogoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementLogoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementLogoUpdateManyLocalizationInput>>;
};

export type CosmosElementLogoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementLogoUpdateManyInput;
  /** Document search */
  where: CosmosElementLogoWhereInput;
};

export type CosmosElementLogoUpdateOneInlineInput = {
  /** Create and connect one CosmosElementLogo document */
  create?: InputMaybe<CosmosElementLogoCreateInput>;
  /** Delete currently connected CosmosElementLogo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementLogo document */
  update?: InputMaybe<CosmosElementLogoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementLogo document */
  upsert?: InputMaybe<CosmosElementLogoUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementLogoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementLogoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLogoWhereUniqueInput;
};

export type CosmosElementLogoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementLogoUpdateInput;
  /** Unique document search */
  where: CosmosElementLogoWhereUniqueInput;
};

export type CosmosElementLogoUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementLogoCreateInput;
  /** Update document if it exists */
  update: CosmosElementLogoUpdateInput;
};

export type CosmosElementLogoUpsertLocalizationInput = {
  create: CosmosElementLogoCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementLogoUpdateLocalizationDataInput;
};

export type CosmosElementLogoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementLogoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementLogoWhereUniqueInput;
};

export type CosmosElementLogoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementLogoUpsertInput;
  /** Unique document search */
  where: CosmosElementLogoWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementLogoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementLogoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementLogoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementLogoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  landscape?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  landscape_not?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementLogo record uniquely */
export type CosmosElementLogoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementNewsCard = Entity & {
  __typename?: 'CosmosElementNewsCard';
  authorTag?: Maybe<CosmosElementImageTag>;
  description?: Maybe<RichText>;
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Asset;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementNewsCard>;
  /** System stage field */
  stage: Stage;
  tag?: Maybe<CosmosElementTag>;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementNewsCardAuthorTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementNewsCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementNewsCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementNewsCardTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementNewsCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementNewsCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementNewsCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementNewsCardConnection = {
  __typename?: 'CosmosElementNewsCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementNewsCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementNewsCardCreateInput = {
  authorTag?: InputMaybe<CosmosElementImageTagCreateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  image: AssetCreateOneInlineInput;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementNewsCardCreateLocalizationsInput>;
  tag?: InputMaybe<CosmosElementTagCreateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementNewsCardCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementNewsCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementNewsCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNewsCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementNewsCardCreateLocalizationInput>>;
};

export type CosmosElementNewsCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementNewsCard documents */
  create?: InputMaybe<Array<CosmosElementNewsCardCreateInput>>;
};

export type CosmosElementNewsCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementNewsCard document */
  create?: InputMaybe<CosmosElementNewsCardCreateInput>;
};

export type CosmosElementNewsCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementNewsCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementNewsCardEdge = {
  __typename?: 'CosmosElementNewsCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementNewsCard;
};

/** Identifies documents */
export type CosmosElementNewsCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementNewsCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementNewsCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementNewsCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorTag?: InputMaybe<CosmosElementImageTagWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<CosmosElementTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementNewsCardOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementNewsCardParent = CosmosSectionNewsCard;

export type CosmosElementNewsCardParentConnectInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardConnectInput>;
};

export type CosmosElementNewsCardParentCreateInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardCreateInput>;
};

export type CosmosElementNewsCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementNewsCardParent documents */
  create?: InputMaybe<Array<CosmosElementNewsCardParentCreateInput>>;
};

export type CosmosElementNewsCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementNewsCardParent document */
  create?: InputMaybe<CosmosElementNewsCardParentCreateInput>;
};

export type CosmosElementNewsCardParentCreateWithPositionInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardCreateWithPositionInput>;
};

export type CosmosElementNewsCardParentUpdateInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateInput>;
};

export type CosmosElementNewsCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementNewsCardParent component instances */
  create?: InputMaybe<Array<CosmosElementNewsCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementNewsCardParent documents */
  delete?: InputMaybe<Array<CosmosElementNewsCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementNewsCardParent component instances */
  update?: InputMaybe<Array<CosmosElementNewsCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementNewsCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementNewsCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementNewsCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementNewsCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementNewsCardParent document */
  create?: InputMaybe<CosmosElementNewsCardParentCreateInput>;
  /** Delete currently connected CosmosElementNewsCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementNewsCardParent document */
  update?: InputMaybe<CosmosElementNewsCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementNewsCardParent document */
  upsert?: InputMaybe<CosmosElementNewsCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementNewsCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementNewsCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsCardParentWhereInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardWhereInput>;
};

export type CosmosElementNewsCardParentWhereUniqueInput = {
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardWhereUniqueInput>;
};

export type CosmosElementNewsCardUpdateInput = {
  authorTag?: InputMaybe<CosmosElementImageTagUpdateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementNewsCardUpdateLocalizationsInput>;
  tag?: InputMaybe<CosmosElementTagUpdateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsCardUpdateLocalizationInput = {
  data: CosmosElementNewsCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNewsCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementNewsCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementNewsCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementNewsCardUpsertLocalizationInput>>;
};

export type CosmosElementNewsCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementNewsCard component instances */
  create?: InputMaybe<Array<CosmosElementNewsCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementNewsCard documents */
  delete?: InputMaybe<Array<CosmosElementNewsCardWhereUniqueInput>>;
  /** Update multiple CosmosElementNewsCard component instances */
  update?: InputMaybe<Array<CosmosElementNewsCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementNewsCard component instances */
  upsert?: InputMaybe<Array<CosmosElementNewsCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementNewsCardUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementNewsCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsCardUpdateManyLocalizationInput = {
  data: CosmosElementNewsCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNewsCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementNewsCardUpdateManyLocalizationInput>>;
};

export type CosmosElementNewsCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementNewsCardUpdateManyInput;
  /** Document search */
  where: CosmosElementNewsCardWhereInput;
};

export type CosmosElementNewsCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementNewsCard document */
  create?: InputMaybe<CosmosElementNewsCardCreateInput>;
  /** Delete currently connected CosmosElementNewsCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementNewsCard document */
  update?: InputMaybe<CosmosElementNewsCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementNewsCard document */
  upsert?: InputMaybe<CosmosElementNewsCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementNewsCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementNewsCardWhereUniqueInput;
};

export type CosmosElementNewsCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementNewsCardUpdateInput;
  /** Unique document search */
  where: CosmosElementNewsCardWhereUniqueInput;
};

export type CosmosElementNewsCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementNewsCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementNewsCardUpdateInput;
};

export type CosmosElementNewsCardUpsertLocalizationInput = {
  create: CosmosElementNewsCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementNewsCardUpdateLocalizationDataInput;
};

export type CosmosElementNewsCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementNewsCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementNewsCardWhereUniqueInput;
};

export type CosmosElementNewsCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementNewsCardUpsertInput;
  /** Unique document search */
  where: CosmosElementNewsCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementNewsCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementNewsCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementNewsCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementNewsCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  authorTag?: InputMaybe<CosmosElementImageTagWhereInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<CosmosElementTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementNewsCard record uniquely */
export type CosmosElementNewsCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementNewsMediaCard = Entity & {
  __typename?: 'CosmosElementNewsMediaCard';
  asset?: Maybe<Asset>;
  author?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementNewsMediaCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementNewsMediaCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementNewsMediaCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementNewsMediaCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementNewsMediaCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementNewsMediaCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementNewsMediaCardConnection = {
  __typename?: 'CosmosElementNewsMediaCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementNewsMediaCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementNewsMediaCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  /** author input for default locale (en) */
  author?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementNewsMediaCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementNewsMediaCardCreateLocalizationDataInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementNewsMediaCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementNewsMediaCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNewsMediaCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementNewsMediaCardCreateLocalizationInput>>;
};

export type CosmosElementNewsMediaCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementNewsMediaCard documents */
  create?: InputMaybe<Array<CosmosElementNewsMediaCardCreateInput>>;
};

export type CosmosElementNewsMediaCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementNewsMediaCard document */
  create?: InputMaybe<CosmosElementNewsMediaCardCreateInput>;
};

export type CosmosElementNewsMediaCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementNewsMediaCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementNewsMediaCardEdge = {
  __typename?: 'CosmosElementNewsMediaCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementNewsMediaCard;
};

/** Identifies documents */
export type CosmosElementNewsMediaCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementNewsMediaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementNewsMediaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementNewsMediaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementNewsMediaCardOrderByInput {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementNewsMediaCardParent = CosmosSectionNewsMediaCard;

export type CosmosElementNewsMediaCardParentConnectInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardConnectInput>;
};

export type CosmosElementNewsMediaCardParentCreateInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
};

export type CosmosElementNewsMediaCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementNewsMediaCardParent documents */
  create?: InputMaybe<Array<CosmosElementNewsMediaCardParentCreateInput>>;
};

export type CosmosElementNewsMediaCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementNewsMediaCardParent document */
  create?: InputMaybe<CosmosElementNewsMediaCardParentCreateInput>;
};

export type CosmosElementNewsMediaCardParentCreateWithPositionInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateWithPositionInput>;
};

export type CosmosElementNewsMediaCardParentUpdateInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateInput>;
};

export type CosmosElementNewsMediaCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementNewsMediaCardParent component instances */
  create?: InputMaybe<Array<CosmosElementNewsMediaCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementNewsMediaCardParent documents */
  delete?: InputMaybe<Array<CosmosElementNewsMediaCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementNewsMediaCardParent component instances */
  update?: InputMaybe<Array<CosmosElementNewsMediaCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementNewsMediaCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementNewsMediaCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementNewsMediaCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementNewsMediaCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementNewsMediaCardParent document */
  create?: InputMaybe<CosmosElementNewsMediaCardParentCreateInput>;
  /** Delete currently connected CosmosElementNewsMediaCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementNewsMediaCardParent document */
  update?: InputMaybe<CosmosElementNewsMediaCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementNewsMediaCardParent document */
  upsert?: InputMaybe<CosmosElementNewsMediaCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsMediaCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementNewsMediaCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsMediaCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementNewsMediaCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsMediaCardParentWhereInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereInput>;
};

export type CosmosElementNewsMediaCardParentWhereUniqueInput = {
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereUniqueInput>;
};

export type CosmosElementNewsMediaCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** author input for default locale (en) */
  author?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementNewsMediaCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsMediaCardUpdateLocalizationDataInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsMediaCardUpdateLocalizationInput = {
  data: CosmosElementNewsMediaCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNewsMediaCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementNewsMediaCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementNewsMediaCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementNewsMediaCardUpsertLocalizationInput>>;
};

export type CosmosElementNewsMediaCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementNewsMediaCard component instances */
  create?: InputMaybe<Array<CosmosElementNewsMediaCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementNewsMediaCard documents */
  delete?: InputMaybe<Array<CosmosElementNewsMediaCardWhereUniqueInput>>;
  /** Update multiple CosmosElementNewsMediaCard component instances */
  update?: InputMaybe<Array<CosmosElementNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementNewsMediaCard component instances */
  upsert?: InputMaybe<Array<CosmosElementNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementNewsMediaCardUpdateManyInput = {
  /** author input for default locale (en) */
  author?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementNewsMediaCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsMediaCardUpdateManyLocalizationDataInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementNewsMediaCardUpdateManyLocalizationInput = {
  data: CosmosElementNewsMediaCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNewsMediaCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementNewsMediaCardUpdateManyLocalizationInput>>;
};

export type CosmosElementNewsMediaCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementNewsMediaCardUpdateManyInput;
  /** Document search */
  where: CosmosElementNewsMediaCardWhereInput;
};

export type CosmosElementNewsMediaCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementNewsMediaCard document */
  create?: InputMaybe<CosmosElementNewsMediaCardCreateInput>;
  /** Delete currently connected CosmosElementNewsMediaCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementNewsMediaCard document */
  update?: InputMaybe<CosmosElementNewsMediaCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementNewsMediaCard document */
  upsert?: InputMaybe<CosmosElementNewsMediaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementNewsMediaCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementNewsMediaCardWhereUniqueInput;
};

export type CosmosElementNewsMediaCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementNewsMediaCardUpdateInput;
  /** Unique document search */
  where: CosmosElementNewsMediaCardWhereUniqueInput;
};

export type CosmosElementNewsMediaCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementNewsMediaCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementNewsMediaCardUpdateInput;
};

export type CosmosElementNewsMediaCardUpsertLocalizationInput = {
  create: CosmosElementNewsMediaCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementNewsMediaCardUpdateLocalizationDataInput;
};

export type CosmosElementNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementNewsMediaCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementNewsMediaCardWhereUniqueInput;
};

export type CosmosElementNewsMediaCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementNewsMediaCardUpsertInput;
  /** Unique document search */
  where: CosmosElementNewsMediaCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementNewsMediaCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementNewsMediaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementNewsMediaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementNewsMediaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementNewsMediaCard record uniquely */
export type CosmosElementNewsMediaCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementNumberCallout = Entity & {
  __typename?: 'CosmosElementNumberCallout';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementNumberCallout>;
  number?: Maybe<Scalars['Int']['output']>;
  /** String and display value of the highlighted number. Has priority. */
  numberDisplay?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementNumberCalloutLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementNumberCalloutUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementNumberCalloutConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementNumberCalloutWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementNumberCalloutConnection = {
  __typename?: 'CosmosElementNumberCalloutConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementNumberCalloutEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementNumberCalloutCreateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementNumberCalloutCreateLocalizationsInput>;
  number?: InputMaybe<Scalars['Int']['input']>;
  numberDisplay?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementNumberCalloutCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementNumberCalloutCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementNumberCalloutCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNumberCalloutCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementNumberCalloutCreateLocalizationInput>>;
};

export type CosmosElementNumberCalloutCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementNumberCallout documents */
  create?: InputMaybe<Array<CosmosElementNumberCalloutCreateInput>>;
};

export type CosmosElementNumberCalloutCreateOneInlineInput = {
  /** Create and connect one CosmosElementNumberCallout document */
  create?: InputMaybe<CosmosElementNumberCalloutCreateInput>;
};

export type CosmosElementNumberCalloutCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementNumberCalloutCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementNumberCalloutEdge = {
  __typename?: 'CosmosElementNumberCalloutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementNumberCallout;
};

/** Identifies documents */
export type CosmosElementNumberCalloutManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementNumberCalloutWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementNumberCalloutWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementNumberCalloutWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  numberDisplay?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  numberDisplay_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  numberDisplay_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  numberDisplay_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  numberDisplay_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  numberDisplay_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  numberDisplay_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  numberDisplay_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  numberDisplay_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  numberDisplay_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementNumberCalloutOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  NumberDisplayAsc = 'numberDisplay_ASC',
  NumberDisplayDesc = 'numberDisplay_DESC',
  NumberAsc = 'number_ASC',
  NumberDesc = 'number_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementNumberCalloutParent = CosmosSectionNumberCallout;

export type CosmosElementNumberCalloutParentConnectInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutConnectInput>;
};

export type CosmosElementNumberCalloutParentCreateInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateInput>;
};

export type CosmosElementNumberCalloutParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementNumberCalloutParent documents */
  create?: InputMaybe<Array<CosmosElementNumberCalloutParentCreateInput>>;
};

export type CosmosElementNumberCalloutParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementNumberCalloutParent document */
  create?: InputMaybe<CosmosElementNumberCalloutParentCreateInput>;
};

export type CosmosElementNumberCalloutParentCreateWithPositionInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateWithPositionInput>;
};

export type CosmosElementNumberCalloutParentUpdateInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateInput>;
};

export type CosmosElementNumberCalloutParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementNumberCalloutParent component instances */
  create?: InputMaybe<Array<CosmosElementNumberCalloutParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementNumberCalloutParent documents */
  delete?: InputMaybe<Array<CosmosElementNumberCalloutParentWhereUniqueInput>>;
  /** Update multiple CosmosElementNumberCalloutParent component instances */
  update?: InputMaybe<Array<CosmosElementNumberCalloutParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementNumberCalloutParent component instances */
  upsert?: InputMaybe<Array<CosmosElementNumberCalloutParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementNumberCalloutParentUpdateManyWithNestedWhereInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateManyWithNestedWhereInput>;
};

export type CosmosElementNumberCalloutParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementNumberCalloutParent document */
  create?: InputMaybe<CosmosElementNumberCalloutParentCreateInput>;
  /** Delete currently connected CosmosElementNumberCalloutParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementNumberCalloutParent document */
  update?: InputMaybe<CosmosElementNumberCalloutParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementNumberCalloutParent document */
  upsert?: InputMaybe<CosmosElementNumberCalloutParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNumberCalloutParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementNumberCalloutParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementNumberCalloutParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementNumberCalloutParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNumberCalloutParentWhereInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereInput>;
};

export type CosmosElementNumberCalloutParentWhereUniqueInput = {
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereUniqueInput>;
};

export type CosmosElementNumberCalloutUpdateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementNumberCalloutUpdateLocalizationsInput>;
  number?: InputMaybe<Scalars['Int']['input']>;
  numberDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementNumberCalloutUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementNumberCalloutUpdateLocalizationInput = {
  data: CosmosElementNumberCalloutUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNumberCalloutUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementNumberCalloutCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementNumberCalloutUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementNumberCalloutUpsertLocalizationInput>>;
};

export type CosmosElementNumberCalloutUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementNumberCallout component instances */
  create?: InputMaybe<Array<CosmosElementNumberCalloutCreateWithPositionInput>>;
  /** Delete multiple CosmosElementNumberCallout documents */
  delete?: InputMaybe<Array<CosmosElementNumberCalloutWhereUniqueInput>>;
  /** Update multiple CosmosElementNumberCallout component instances */
  update?: InputMaybe<Array<CosmosElementNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementNumberCallout component instances */
  upsert?: InputMaybe<Array<CosmosElementNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementNumberCalloutUpdateManyInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementNumberCalloutUpdateManyLocalizationsInput>;
  number?: InputMaybe<Scalars['Int']['input']>;
  numberDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementNumberCalloutUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementNumberCalloutUpdateManyLocalizationInput = {
  data: CosmosElementNumberCalloutUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementNumberCalloutUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementNumberCalloutUpdateManyLocalizationInput>>;
};

export type CosmosElementNumberCalloutUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementNumberCalloutUpdateManyInput;
  /** Document search */
  where: CosmosElementNumberCalloutWhereInput;
};

export type CosmosElementNumberCalloutUpdateOneInlineInput = {
  /** Create and connect one CosmosElementNumberCallout document */
  create?: InputMaybe<CosmosElementNumberCalloutCreateInput>;
  /** Delete currently connected CosmosElementNumberCallout document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementNumberCallout document */
  update?: InputMaybe<CosmosElementNumberCalloutUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementNumberCallout document */
  upsert?: InputMaybe<CosmosElementNumberCalloutUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementNumberCalloutUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementNumberCalloutWhereUniqueInput;
};

export type CosmosElementNumberCalloutUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementNumberCalloutUpdateInput;
  /** Unique document search */
  where: CosmosElementNumberCalloutWhereUniqueInput;
};

export type CosmosElementNumberCalloutUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementNumberCalloutCreateInput;
  /** Update document if it exists */
  update: CosmosElementNumberCalloutUpdateInput;
};

export type CosmosElementNumberCalloutUpsertLocalizationInput = {
  create: CosmosElementNumberCalloutCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementNumberCalloutUpdateLocalizationDataInput;
};

export type CosmosElementNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementNumberCalloutUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementNumberCalloutWhereUniqueInput;
};

export type CosmosElementNumberCalloutUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementNumberCalloutUpsertInput;
  /** Unique document search */
  where: CosmosElementNumberCalloutWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementNumberCalloutWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementNumberCalloutWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementNumberCalloutWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementNumberCalloutWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  numberDisplay?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  numberDisplay_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  numberDisplay_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  numberDisplay_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  numberDisplay_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  numberDisplay_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  numberDisplay_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  numberDisplay_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  numberDisplay_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  numberDisplay_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values greater than the given value. */
  number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  number_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  number_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  number_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementNumberCallout record uniquely */
export type CosmosElementNumberCalloutWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementPluginDownload = Entity & {
  __typename?: 'CosmosElementPluginDownload';
  desc?: Maybe<Scalars['String']['output']>;
  details: Array<CosmosElementPluginDownloadDetail>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementPluginDownload>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementPluginDownloadDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementPluginDownloadDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
};


export type CosmosElementPluginDownloadLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementPluginDownloadUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementPluginDownloadConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementPluginDownloadWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementPluginDownloadConnection = {
  __typename?: 'CosmosElementPluginDownloadConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementPluginDownloadEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementPluginDownloadCreateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<CosmosElementPluginDownloadDetailCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementPluginDownloadCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementPluginDownloadCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementPluginDownloadCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementPluginDownloadCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginDownloadCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementPluginDownloadCreateLocalizationInput>>;
};

export type CosmosElementPluginDownloadCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementPluginDownload documents */
  create?: InputMaybe<Array<CosmosElementPluginDownloadCreateInput>>;
};

export type CosmosElementPluginDownloadCreateOneInlineInput = {
  /** Create and connect one CosmosElementPluginDownload document */
  create?: InputMaybe<CosmosElementPluginDownloadCreateInput>;
};

export type CosmosElementPluginDownloadCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementPluginDownloadCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

export type CosmosElementPluginDownloadDetail = Entity & {
  __typename?: 'CosmosElementPluginDownloadDetail';
  dateLastUpdated?: Maybe<Scalars['Date']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  infoContent?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementPluginDownloadDetail>;
  operatingSystem?: Maybe<CosmosEnumOperatingSystems>;
  releaseNotesUrl?: Maybe<Scalars['String']['output']>;
  sizeInBytes?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  tpsNoticesUrl?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementPluginDownloadDetailLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementPluginDownloadDetailUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementPluginDownloadDetailConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementPluginDownloadDetailWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementPluginDownloadDetailConnection = {
  __typename?: 'CosmosElementPluginDownloadDetailConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementPluginDownloadDetailEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementPluginDownloadDetailCreateInput = {
  dateLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** infoContent input for default locale (en) */
  infoContent?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementPluginDownloadDetailCreateLocalizationsInput>;
  operatingSystem?: InputMaybe<CosmosEnumOperatingSystems>;
  releaseNotesUrl?: InputMaybe<Scalars['String']['input']>;
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  tpsNoticesUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementPluginDownloadDetailCreateLocalizationDataInput = {
  infoContent?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementPluginDownloadDetailCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementPluginDownloadDetailCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginDownloadDetailCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementPluginDownloadDetailCreateLocalizationInput>>;
};

export type CosmosElementPluginDownloadDetailCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementPluginDownloadDetail documents */
  create?: InputMaybe<Array<CosmosElementPluginDownloadDetailCreateInput>>;
};

export type CosmosElementPluginDownloadDetailCreateOneInlineInput = {
  /** Create and connect one CosmosElementPluginDownloadDetail document */
  create?: InputMaybe<CosmosElementPluginDownloadDetailCreateInput>;
};

export type CosmosElementPluginDownloadDetailCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementPluginDownloadDetailCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementPluginDownloadDetailEdge = {
  __typename?: 'CosmosElementPluginDownloadDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementPluginDownloadDetail;
};

/** Identifies documents */
export type CosmosElementPluginDownloadDetailManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dateLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  dateLastUpdated_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  dateLastUpdated_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  dateLastUpdated_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  dateLastUpdated_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  dateLastUpdated_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  dateLastUpdated_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  dateLastUpdated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  downloadUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  downloadUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  downloadUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  downloadUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  downloadUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  downloadUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  downloadUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  downloadUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  downloadUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  operatingSystem?: InputMaybe<CosmosEnumOperatingSystems>;
  /** All values that are contained in given list. */
  operatingSystem_in?: InputMaybe<Array<InputMaybe<CosmosEnumOperatingSystems>>>;
  /** Any other value that exists and is not equal to the given value. */
  operatingSystem_not?: InputMaybe<CosmosEnumOperatingSystems>;
  /** All values that are not contained in given list. */
  operatingSystem_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumOperatingSystems>>>;
  releaseNotesUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  releaseNotesUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  releaseNotesUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  releaseNotesUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  releaseNotesUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  releaseNotesUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  releaseNotesUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  releaseNotesUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  releaseNotesUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  releaseNotesUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sizeInBytes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sizeInBytes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sizeInBytes_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sizeInBytes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sizeInBytes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sizeInBytes_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sizeInBytes_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tpsNoticesUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tpsNoticesUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tpsNoticesUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tpsNoticesUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tpsNoticesUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tpsNoticesUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tpsNoticesUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tpsNoticesUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tpsNoticesUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tpsNoticesUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementPluginDownloadDetailOrderByInput {
  DateLastUpdatedAsc = 'dateLastUpdated_ASC',
  DateLastUpdatedDesc = 'dateLastUpdated_DESC',
  DownloadUrlAsc = 'downloadUrl_ASC',
  DownloadUrlDesc = 'downloadUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InfoContentAsc = 'infoContent_ASC',
  InfoContentDesc = 'infoContent_DESC',
  OperatingSystemAsc = 'operatingSystem_ASC',
  OperatingSystemDesc = 'operatingSystem_DESC',
  ReleaseNotesUrlAsc = 'releaseNotesUrl_ASC',
  ReleaseNotesUrlDesc = 'releaseNotesUrl_DESC',
  SizeInBytesAsc = 'sizeInBytes_ASC',
  SizeInBytesDesc = 'sizeInBytes_DESC',
  TpsNoticesUrlAsc = 'tpsNoticesUrl_ASC',
  TpsNoticesUrlDesc = 'tpsNoticesUrl_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementPluginDownloadDetailParent = CosmosElementPluginDownload | CosmosElementPluginListItem;

export type CosmosElementPluginDownloadDetailParentConnectInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadConnectInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemConnectInput>;
};

export type CosmosElementPluginDownloadDetailParentCreateInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadCreateInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemCreateInput>;
};

export type CosmosElementPluginDownloadDetailParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementPluginDownloadDetailParent documents */
  create?: InputMaybe<Array<CosmosElementPluginDownloadDetailParentCreateInput>>;
};

export type CosmosElementPluginDownloadDetailParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementPluginDownloadDetailParent document */
  create?: InputMaybe<CosmosElementPluginDownloadDetailParentCreateInput>;
};

export type CosmosElementPluginDownloadDetailParentCreateWithPositionInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadCreateWithPositionInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemCreateWithPositionInput>;
};

export type CosmosElementPluginDownloadDetailParentUpdateInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadUpdateInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateInput>;
};

export type CosmosElementPluginDownloadDetailParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementPluginDownloadDetailParent component instances */
  create?: InputMaybe<Array<CosmosElementPluginDownloadDetailParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementPluginDownloadDetailParent documents */
  delete?: InputMaybe<Array<CosmosElementPluginDownloadDetailParentWhereUniqueInput>>;
  /** Update multiple CosmosElementPluginDownloadDetailParent component instances */
  update?: InputMaybe<Array<CosmosElementPluginDownloadDetailParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementPluginDownloadDetailParent component instances */
  upsert?: InputMaybe<Array<CosmosElementPluginDownloadDetailParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementPluginDownloadDetailParentUpdateManyWithNestedWhereInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadUpdateManyWithNestedWhereInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateManyWithNestedWhereInput>;
};

export type CosmosElementPluginDownloadDetailParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementPluginDownloadDetailParent document */
  create?: InputMaybe<CosmosElementPluginDownloadDetailParentCreateInput>;
  /** Delete currently connected CosmosElementPluginDownloadDetailParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementPluginDownloadDetailParent document */
  update?: InputMaybe<CosmosElementPluginDownloadDetailParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementPluginDownloadDetailParent document */
  upsert?: InputMaybe<CosmosElementPluginDownloadDetailParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadDetailParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementPluginDownloadDetailParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadUpdateWithNestedWhereUniqueInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadDetailParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementPluginDownloadDetailParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadUpsertWithNestedWhereUniqueInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadDetailParentWhereInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemWhereInput>;
};

export type CosmosElementPluginDownloadDetailParentWhereUniqueInput = {
  CosmosElementPluginDownload?: InputMaybe<CosmosElementPluginDownloadWhereUniqueInput>;
  CosmosElementPluginListItem?: InputMaybe<CosmosElementPluginListItemWhereUniqueInput>;
};

export type CosmosElementPluginDownloadDetailUpdateInput = {
  dateLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** infoContent input for default locale (en) */
  infoContent?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementPluginDownloadDetailUpdateLocalizationsInput>;
  operatingSystem?: InputMaybe<CosmosEnumOperatingSystems>;
  releaseNotesUrl?: InputMaybe<Scalars['String']['input']>;
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  tpsNoticesUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadDetailUpdateLocalizationDataInput = {
  infoContent?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadDetailUpdateLocalizationInput = {
  data: CosmosElementPluginDownloadDetailUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginDownloadDetailUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementPluginDownloadDetailCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementPluginDownloadDetailUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementPluginDownloadDetailUpsertLocalizationInput>>;
};

export type CosmosElementPluginDownloadDetailUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementPluginDownloadDetail component instances */
  create?: InputMaybe<Array<CosmosElementPluginDownloadDetailCreateWithPositionInput>>;
  /** Delete multiple CosmosElementPluginDownloadDetail documents */
  delete?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereUniqueInput>>;
  /** Update multiple CosmosElementPluginDownloadDetail component instances */
  update?: InputMaybe<Array<CosmosElementPluginDownloadDetailUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementPluginDownloadDetail component instances */
  upsert?: InputMaybe<Array<CosmosElementPluginDownloadDetailUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementPluginDownloadDetailUpdateManyInput = {
  dateLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** infoContent input for default locale (en) */
  infoContent?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementPluginDownloadDetailUpdateManyLocalizationsInput>;
  operatingSystem?: InputMaybe<CosmosEnumOperatingSystems>;
  releaseNotesUrl?: InputMaybe<Scalars['String']['input']>;
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  tpsNoticesUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadDetailUpdateManyLocalizationDataInput = {
  infoContent?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadDetailUpdateManyLocalizationInput = {
  data: CosmosElementPluginDownloadDetailUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginDownloadDetailUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementPluginDownloadDetailUpdateManyLocalizationInput>>;
};

export type CosmosElementPluginDownloadDetailUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementPluginDownloadDetailUpdateManyInput;
  /** Document search */
  where: CosmosElementPluginDownloadDetailWhereInput;
};

export type CosmosElementPluginDownloadDetailUpdateOneInlineInput = {
  /** Create and connect one CosmosElementPluginDownloadDetail document */
  create?: InputMaybe<CosmosElementPluginDownloadDetailCreateInput>;
  /** Delete currently connected CosmosElementPluginDownloadDetail document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementPluginDownloadDetail document */
  update?: InputMaybe<CosmosElementPluginDownloadDetailUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementPluginDownloadDetail document */
  upsert?: InputMaybe<CosmosElementPluginDownloadDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadDetailUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementPluginDownloadDetailUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementPluginDownloadDetailWhereUniqueInput;
};

export type CosmosElementPluginDownloadDetailUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementPluginDownloadDetailUpdateInput;
  /** Unique document search */
  where: CosmosElementPluginDownloadDetailWhereUniqueInput;
};

export type CosmosElementPluginDownloadDetailUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementPluginDownloadDetailCreateInput;
  /** Update document if it exists */
  update: CosmosElementPluginDownloadDetailUpdateInput;
};

export type CosmosElementPluginDownloadDetailUpsertLocalizationInput = {
  create: CosmosElementPluginDownloadDetailCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementPluginDownloadDetailUpdateLocalizationDataInput;
};

export type CosmosElementPluginDownloadDetailUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementPluginDownloadDetailUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementPluginDownloadDetailWhereUniqueInput;
};

export type CosmosElementPluginDownloadDetailUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementPluginDownloadDetailUpsertInput;
  /** Unique document search */
  where: CosmosElementPluginDownloadDetailWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementPluginDownloadDetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementPluginDownloadDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dateLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  dateLastUpdated_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  dateLastUpdated_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  dateLastUpdated_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  dateLastUpdated_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  dateLastUpdated_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  dateLastUpdated_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  dateLastUpdated_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  downloadUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  downloadUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  downloadUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  downloadUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  downloadUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  downloadUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  downloadUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  downloadUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  downloadUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  infoContent?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  infoContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  infoContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  infoContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  infoContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  infoContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  infoContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  infoContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  infoContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  infoContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  operatingSystem?: InputMaybe<CosmosEnumOperatingSystems>;
  /** All values that are contained in given list. */
  operatingSystem_in?: InputMaybe<Array<InputMaybe<CosmosEnumOperatingSystems>>>;
  /** Any other value that exists and is not equal to the given value. */
  operatingSystem_not?: InputMaybe<CosmosEnumOperatingSystems>;
  /** All values that are not contained in given list. */
  operatingSystem_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumOperatingSystems>>>;
  releaseNotesUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  releaseNotesUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  releaseNotesUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  releaseNotesUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  releaseNotesUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  releaseNotesUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  releaseNotesUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  releaseNotesUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  releaseNotesUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  releaseNotesUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  sizeInBytes?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  sizeInBytes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  sizeInBytes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  sizeInBytes_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  sizeInBytes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  sizeInBytes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sizeInBytes_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  sizeInBytes_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tpsNoticesUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tpsNoticesUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tpsNoticesUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tpsNoticesUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tpsNoticesUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tpsNoticesUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tpsNoticesUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tpsNoticesUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tpsNoticesUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tpsNoticesUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementPluginDownloadDetail record uniquely */
export type CosmosElementPluginDownloadDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type CosmosElementPluginDownloadEdge = {
  __typename?: 'CosmosElementPluginDownloadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementPluginDownload;
};

/** Identifies documents */
export type CosmosElementPluginDownloadManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementPluginDownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementPluginDownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementPluginDownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  details_every?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  details_none?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  details_some?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementPluginDownloadOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementPluginDownloadParent = CosmosPagePluginDetail;

export type CosmosElementPluginDownloadParentConnectInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementPluginDownloadParentCreateInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementPluginDownloadParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementPluginDownloadParent documents */
  connect?: InputMaybe<Array<CosmosElementPluginDownloadParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementPluginDownloadParent documents */
  create?: InputMaybe<Array<CosmosElementPluginDownloadParentCreateInput>>;
};

export type CosmosElementPluginDownloadParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementPluginDownloadParent document */
  connect?: InputMaybe<CosmosElementPluginDownloadParentWhereUniqueInput>;
  /** Create and connect one CosmosElementPluginDownloadParent document */
  create?: InputMaybe<CosmosElementPluginDownloadParentCreateInput>;
};

export type CosmosElementPluginDownloadParentUpdateInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementPluginDownloadParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementPluginDownloadParent documents */
  connect?: InputMaybe<Array<CosmosElementPluginDownloadParentConnectInput>>;
  /** Create and connect multiple CosmosElementPluginDownloadParent documents */
  create?: InputMaybe<Array<CosmosElementPluginDownloadParentCreateInput>>;
  /** Delete multiple CosmosElementPluginDownloadParent documents */
  delete?: InputMaybe<Array<CosmosElementPluginDownloadParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementPluginDownloadParent documents */
  disconnect?: InputMaybe<Array<CosmosElementPluginDownloadParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementPluginDownloadParent documents */
  set?: InputMaybe<Array<CosmosElementPluginDownloadParentWhereUniqueInput>>;
  /** Update multiple CosmosElementPluginDownloadParent documents */
  update?: InputMaybe<Array<CosmosElementPluginDownloadParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementPluginDownloadParent documents */
  upsert?: InputMaybe<Array<CosmosElementPluginDownloadParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementPluginDownloadParentUpdateManyWithNestedWhereInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementPluginDownloadParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementPluginDownloadParent document */
  connect?: InputMaybe<CosmosElementPluginDownloadParentWhereUniqueInput>;
  /** Create and connect one CosmosElementPluginDownloadParent document */
  create?: InputMaybe<CosmosElementPluginDownloadParentCreateInput>;
  /** Delete currently connected CosmosElementPluginDownloadParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementPluginDownloadParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementPluginDownloadParent document */
  update?: InputMaybe<CosmosElementPluginDownloadParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementPluginDownloadParent document */
  upsert?: InputMaybe<CosmosElementPluginDownloadParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadParentUpdateWithNestedWhereUniqueInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadParentUpsertWithNestedWhereUniqueInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadParentWhereInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementPluginDownloadParentWhereUniqueInput = {
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementPluginDownloadUpdateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<CosmosElementPluginDownloadDetailUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementPluginDownloadUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadUpdateLocalizationInput = {
  data: CosmosElementPluginDownloadUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginDownloadUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementPluginDownloadCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementPluginDownloadUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementPluginDownloadUpsertLocalizationInput>>;
};

export type CosmosElementPluginDownloadUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementPluginDownload component instances */
  create?: InputMaybe<Array<CosmosElementPluginDownloadCreateWithPositionInput>>;
  /** Delete multiple CosmosElementPluginDownload documents */
  delete?: InputMaybe<Array<CosmosElementPluginDownloadWhereUniqueInput>>;
  /** Update multiple CosmosElementPluginDownload component instances */
  update?: InputMaybe<Array<CosmosElementPluginDownloadUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementPluginDownload component instances */
  upsert?: InputMaybe<Array<CosmosElementPluginDownloadUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementPluginDownloadUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementPluginDownloadUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginDownloadUpdateManyLocalizationInput = {
  data: CosmosElementPluginDownloadUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginDownloadUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementPluginDownloadUpdateManyLocalizationInput>>;
};

export type CosmosElementPluginDownloadUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementPluginDownloadUpdateManyInput;
  /** Document search */
  where: CosmosElementPluginDownloadWhereInput;
};

export type CosmosElementPluginDownloadUpdateOneInlineInput = {
  /** Create and connect one CosmosElementPluginDownload document */
  create?: InputMaybe<CosmosElementPluginDownloadCreateInput>;
  /** Delete currently connected CosmosElementPluginDownload document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementPluginDownload document */
  update?: InputMaybe<CosmosElementPluginDownloadUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementPluginDownload document */
  upsert?: InputMaybe<CosmosElementPluginDownloadUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginDownloadUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementPluginDownloadUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementPluginDownloadWhereUniqueInput;
};

export type CosmosElementPluginDownloadUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementPluginDownloadUpdateInput;
  /** Unique document search */
  where: CosmosElementPluginDownloadWhereUniqueInput;
};

export type CosmosElementPluginDownloadUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementPluginDownloadCreateInput;
  /** Update document if it exists */
  update: CosmosElementPluginDownloadUpdateInput;
};

export type CosmosElementPluginDownloadUpsertLocalizationInput = {
  create: CosmosElementPluginDownloadCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementPluginDownloadUpdateLocalizationDataInput;
};

export type CosmosElementPluginDownloadUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementPluginDownloadUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementPluginDownloadWhereUniqueInput;
};

export type CosmosElementPluginDownloadUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementPluginDownloadUpsertInput;
  /** Unique document search */
  where: CosmosElementPluginDownloadWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementPluginDownloadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementPluginDownloadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementPluginDownloadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementPluginDownloadWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  details_every?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  details_none?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  details_some?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementPluginDownload record uniquely */
export type CosmosElementPluginDownloadWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementPluginListItem = Entity & {
  __typename?: 'CosmosElementPluginListItem';
  compatibilityTags: Array<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  downloads: Array<CosmosElementPluginDownloadDetail>;
  extraButtons: Array<CosmosElementIconButton>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementPluginListItem>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementPluginListItemDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementPluginDownloadDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
};


export type CosmosElementPluginListItemExtraButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosElementPluginListItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementPluginListItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementPluginListItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementPluginListItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementPluginListItemConnection = {
  __typename?: 'CosmosElementPluginListItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementPluginListItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementPluginListItemCreateInput = {
  /** compatibilityTags input for default locale (en) */
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  downloads?: InputMaybe<CosmosElementPluginDownloadDetailCreateManyInlineInput>;
  extraButtons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementPluginListItemCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementPluginListItemCreateLocalizationDataInput = {
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementPluginListItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementPluginListItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginListItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementPluginListItemCreateLocalizationInput>>;
};

export type CosmosElementPluginListItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementPluginListItem documents */
  create?: InputMaybe<Array<CosmosElementPluginListItemCreateInput>>;
};

export type CosmosElementPluginListItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementPluginListItem document */
  create?: InputMaybe<CosmosElementPluginListItemCreateInput>;
};

export type CosmosElementPluginListItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementPluginListItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementPluginListItemEdge = {
  __typename?: 'CosmosElementPluginListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementPluginListItem;
};

/** Identifies documents */
export type CosmosElementPluginListItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementPluginListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementPluginListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementPluginListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  downloads_every?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  downloads_none?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  downloads_some?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  extraButtons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  extraButtons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  extraButtons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  learnMoreUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  learnMoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  learnMoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  learnMoreUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  learnMoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  learnMoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  learnMoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  learnMoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  learnMoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementPluginListItemOrderByInput {
  CompatibilityTagsAsc = 'compatibilityTags_ASC',
  CompatibilityTagsDesc = 'compatibilityTags_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LearnMoreUrlAsc = 'learnMoreUrl_ASC',
  LearnMoreUrlDesc = 'learnMoreUrl_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementPluginListItemParent = CosmosSectionPluginListTable;

export type CosmosElementPluginListItemParentConnectInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableConnectInput>;
};

export type CosmosElementPluginListItemParentCreateInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableCreateInput>;
};

export type CosmosElementPluginListItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementPluginListItemParent documents */
  create?: InputMaybe<Array<CosmosElementPluginListItemParentCreateInput>>;
};

export type CosmosElementPluginListItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementPluginListItemParent document */
  create?: InputMaybe<CosmosElementPluginListItemParentCreateInput>;
};

export type CosmosElementPluginListItemParentCreateWithPositionInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableCreateWithPositionInput>;
};

export type CosmosElementPluginListItemParentUpdateInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateInput>;
};

export type CosmosElementPluginListItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementPluginListItemParent component instances */
  create?: InputMaybe<Array<CosmosElementPluginListItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementPluginListItemParent documents */
  delete?: InputMaybe<Array<CosmosElementPluginListItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementPluginListItemParent component instances */
  update?: InputMaybe<Array<CosmosElementPluginListItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementPluginListItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementPluginListItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementPluginListItemParentUpdateManyWithNestedWhereInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateManyWithNestedWhereInput>;
};

export type CosmosElementPluginListItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementPluginListItemParent document */
  create?: InputMaybe<CosmosElementPluginListItemParentCreateInput>;
  /** Delete currently connected CosmosElementPluginListItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementPluginListItemParent document */
  update?: InputMaybe<CosmosElementPluginListItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementPluginListItemParent document */
  upsert?: InputMaybe<CosmosElementPluginListItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginListItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementPluginListItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginListItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementPluginListItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginListItemParentWhereInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableWhereInput>;
};

export type CosmosElementPluginListItemParentWhereUniqueInput = {
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableWhereUniqueInput>;
};

export type CosmosElementPluginListItemUpdateInput = {
  /** compatibilityTags input for default locale (en) */
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  downloads?: InputMaybe<CosmosElementPluginDownloadDetailUpdateManyInlineInput>;
  extraButtons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementPluginListItemUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginListItemUpdateLocalizationDataInput = {
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginListItemUpdateLocalizationInput = {
  data: CosmosElementPluginListItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginListItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementPluginListItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementPluginListItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementPluginListItemUpsertLocalizationInput>>;
};

export type CosmosElementPluginListItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementPluginListItem component instances */
  create?: InputMaybe<Array<CosmosElementPluginListItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementPluginListItem documents */
  delete?: InputMaybe<Array<CosmosElementPluginListItemWhereUniqueInput>>;
  /** Update multiple CosmosElementPluginListItem component instances */
  update?: InputMaybe<Array<CosmosElementPluginListItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementPluginListItem component instances */
  upsert?: InputMaybe<Array<CosmosElementPluginListItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementPluginListItemUpdateManyInput = {
  /** compatibilityTags input for default locale (en) */
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementPluginListItemUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginListItemUpdateManyLocalizationDataInput = {
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementPluginListItemUpdateManyLocalizationInput = {
  data: CosmosElementPluginListItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementPluginListItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementPluginListItemUpdateManyLocalizationInput>>;
};

export type CosmosElementPluginListItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementPluginListItemUpdateManyInput;
  /** Document search */
  where: CosmosElementPluginListItemWhereInput;
};

export type CosmosElementPluginListItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementPluginListItem document */
  create?: InputMaybe<CosmosElementPluginListItemCreateInput>;
  /** Delete currently connected CosmosElementPluginListItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementPluginListItem document */
  update?: InputMaybe<CosmosElementPluginListItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementPluginListItem document */
  upsert?: InputMaybe<CosmosElementPluginListItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementPluginListItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementPluginListItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementPluginListItemWhereUniqueInput;
};

export type CosmosElementPluginListItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementPluginListItemUpdateInput;
  /** Unique document search */
  where: CosmosElementPluginListItemWhereUniqueInput;
};

export type CosmosElementPluginListItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementPluginListItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementPluginListItemUpdateInput;
};

export type CosmosElementPluginListItemUpsertLocalizationInput = {
  create: CosmosElementPluginListItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementPluginListItemUpdateLocalizationDataInput;
};

export type CosmosElementPluginListItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementPluginListItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementPluginListItemWhereUniqueInput;
};

export type CosmosElementPluginListItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementPluginListItemUpsertInput;
  /** Unique document search */
  where: CosmosElementPluginListItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementPluginListItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementPluginListItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementPluginListItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementPluginListItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  compatibilityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  compatibilityTags_contains_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  compatibilityTags_contains_none?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  compatibilityTags_contains_some?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  compatibilityTags_not?: InputMaybe<Array<Scalars['String']['input']>>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  downloads_every?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  downloads_none?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  downloads_some?: InputMaybe<CosmosElementPluginDownloadDetailWhereInput>;
  extraButtons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  extraButtons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  extraButtons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  learnMoreUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  learnMoreUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  learnMoreUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  learnMoreUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  learnMoreUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  learnMoreUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  learnMoreUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  learnMoreUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  learnMoreUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementPluginListItem record uniquely */
export type CosmosElementPluginListItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementQuote = Entity & {
  __typename?: 'CosmosElementQuote';
  /** A brief description of the quote source */
  description?: Maybe<Scalars['String']['output']>;
  /** The gradient of the Quote icon (defaults to blue) */
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementQuote>;
  quote?: Maybe<Scalars['String']['output']>;
  /** The source of the quote */
  source?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementQuoteLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementQuoteUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementQuoteConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementQuoteWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementQuoteConnection = {
  __typename?: 'CosmosElementQuoteConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementQuoteEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementQuoteCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementQuoteCreateLocalizationsInput>;
  /** quote input for default locale (en) */
  quote?: InputMaybe<Scalars['String']['input']>;
  /** source input for default locale (en) */
  source?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementQuoteCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementQuoteCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementQuoteCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementQuoteCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementQuoteCreateLocalizationInput>>;
};

export type CosmosElementQuoteCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementQuote documents */
  create?: InputMaybe<Array<CosmosElementQuoteCreateInput>>;
};

export type CosmosElementQuoteCreateOneInlineInput = {
  /** Create and connect one CosmosElementQuote document */
  create?: InputMaybe<CosmosElementQuoteCreateInput>;
};

export type CosmosElementQuoteCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementQuoteCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementQuoteEdge = {
  __typename?: 'CosmosElementQuoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementQuote;
};

/** Identifies documents */
export type CosmosElementQuoteManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementQuoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementQuoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementQuoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementQuoteOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  QuoteAsc = 'quote_ASC',
  QuoteDesc = 'quote_DESC',
  SourceAsc = 'source_ASC',
  SourceDesc = 'source_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementQuoteParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosSectionQuote;

export type CosmosElementQuoteParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteConnectInput>;
};

export type CosmosElementQuoteParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteCreateInput>;
};

export type CosmosElementQuoteParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementQuoteParent documents */
  connect?: InputMaybe<Array<CosmosElementQuoteParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementQuoteParent documents */
  create?: InputMaybe<Array<CosmosElementQuoteParentCreateInput>>;
};

export type CosmosElementQuoteParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementQuoteParent document */
  connect?: InputMaybe<CosmosElementQuoteParentWhereUniqueInput>;
  /** Create and connect one CosmosElementQuoteParent document */
  create?: InputMaybe<CosmosElementQuoteParentCreateInput>;
};

export type CosmosElementQuoteParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateInput>;
};

export type CosmosElementQuoteParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementQuoteParent documents */
  connect?: InputMaybe<Array<CosmosElementQuoteParentConnectInput>>;
  /** Create and connect multiple CosmosElementQuoteParent documents */
  create?: InputMaybe<Array<CosmosElementQuoteParentCreateInput>>;
  /** Delete multiple CosmosElementQuoteParent documents */
  delete?: InputMaybe<Array<CosmosElementQuoteParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementQuoteParent documents */
  disconnect?: InputMaybe<Array<CosmosElementQuoteParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementQuoteParent documents */
  set?: InputMaybe<Array<CosmosElementQuoteParentWhereUniqueInput>>;
  /** Update multiple CosmosElementQuoteParent documents */
  update?: InputMaybe<Array<CosmosElementQuoteParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementQuoteParent documents */
  upsert?: InputMaybe<Array<CosmosElementQuoteParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementQuoteParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateManyWithNestedWhereInput>;
};

export type CosmosElementQuoteParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementQuoteParent document */
  connect?: InputMaybe<CosmosElementQuoteParentWhereUniqueInput>;
  /** Create and connect one CosmosElementQuoteParent document */
  create?: InputMaybe<CosmosElementQuoteParentCreateInput>;
  /** Delete currently connected CosmosElementQuoteParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementQuoteParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementQuoteParent document */
  update?: InputMaybe<CosmosElementQuoteParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementQuoteParent document */
  upsert?: InputMaybe<CosmosElementQuoteParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementQuoteParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementQuoteParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementQuoteParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteWhereInput>;
};

export type CosmosElementQuoteParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteWhereUniqueInput>;
};

export type CosmosElementQuoteUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementQuoteUpdateLocalizationsInput>;
  /** quote input for default locale (en) */
  quote?: InputMaybe<Scalars['String']['input']>;
  /** source input for default locale (en) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementQuoteUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementQuoteUpdateLocalizationInput = {
  data: CosmosElementQuoteUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementQuoteUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementQuoteCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementQuoteUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementQuoteUpsertLocalizationInput>>;
};

export type CosmosElementQuoteUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementQuote component instances */
  create?: InputMaybe<Array<CosmosElementQuoteCreateWithPositionInput>>;
  /** Delete multiple CosmosElementQuote documents */
  delete?: InputMaybe<Array<CosmosElementQuoteWhereUniqueInput>>;
  /** Update multiple CosmosElementQuote component instances */
  update?: InputMaybe<Array<CosmosElementQuoteUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementQuote component instances */
  upsert?: InputMaybe<Array<CosmosElementQuoteUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementQuoteUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementQuoteUpdateManyLocalizationsInput>;
  /** quote input for default locale (en) */
  quote?: InputMaybe<Scalars['String']['input']>;
  /** source input for default locale (en) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementQuoteUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementQuoteUpdateManyLocalizationInput = {
  data: CosmosElementQuoteUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementQuoteUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementQuoteUpdateManyLocalizationInput>>;
};

export type CosmosElementQuoteUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementQuoteUpdateManyInput;
  /** Document search */
  where: CosmosElementQuoteWhereInput;
};

export type CosmosElementQuoteUpdateOneInlineInput = {
  /** Create and connect one CosmosElementQuote document */
  create?: InputMaybe<CosmosElementQuoteCreateInput>;
  /** Delete currently connected CosmosElementQuote document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementQuote document */
  update?: InputMaybe<CosmosElementQuoteUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementQuote document */
  upsert?: InputMaybe<CosmosElementQuoteUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementQuoteUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementQuoteUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementQuoteWhereUniqueInput;
};

export type CosmosElementQuoteUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementQuoteUpdateInput;
  /** Unique document search */
  where: CosmosElementQuoteWhereUniqueInput;
};

export type CosmosElementQuoteUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementQuoteCreateInput;
  /** Update document if it exists */
  update: CosmosElementQuoteUpdateInput;
};

export type CosmosElementQuoteUpsertLocalizationInput = {
  create: CosmosElementQuoteCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementQuoteUpdateLocalizationDataInput;
};

export type CosmosElementQuoteUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementQuoteUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementQuoteWhereUniqueInput;
};

export type CosmosElementQuoteUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementQuoteUpsertInput;
  /** Unique document search */
  where: CosmosElementQuoteWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementQuoteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementQuoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementQuoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementQuoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  quote_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  quote_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  quote_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  quote_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  quote_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  quote_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  quote_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  quote_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  quote_starts_with?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  source_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementQuote record uniquely */
export type CosmosElementQuoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementResearchCard = Entity & {
  __typename?: 'CosmosElementResearchCard';
  asset?: Maybe<Asset>;
  desc?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementResearchCard>;
  publicationDate?: Maybe<Scalars['Date']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementResearchCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementResearchCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementResearchCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementResearchCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementResearchCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementResearchCardConnection = {
  __typename?: 'CosmosElementResearchCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementResearchCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementResearchCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** footer input for default locale (en) */
  footer?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementResearchCardCreateLocalizationsInput>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementResearchCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementResearchCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementResearchCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementResearchCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementResearchCardCreateLocalizationInput>>;
};

export type CosmosElementResearchCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementResearchCard documents */
  create?: InputMaybe<Array<CosmosElementResearchCardCreateInput>>;
};

export type CosmosElementResearchCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementResearchCard document */
  create?: InputMaybe<CosmosElementResearchCardCreateInput>;
};

export type CosmosElementResearchCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementResearchCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementResearchCardEdge = {
  __typename?: 'CosmosElementResearchCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementResearchCard;
};

/** Identifies documents */
export type CosmosElementResearchCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementResearchCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementResearchCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementResearchCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  publicationDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  publicationDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  publicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  publicationDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  publicationDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publicationDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  publicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementResearchCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  FooterAsc = 'footer_ASC',
  FooterDesc = 'footer_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublicationDateAsc = 'publicationDate_ASC',
  PublicationDateDesc = 'publicationDate_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementResearchCardParent = CosmosPageResearch;

export type CosmosElementResearchCardParentConnectInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
};

export type CosmosElementResearchCardParentCreateInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
};

export type CosmosElementResearchCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementResearchCardParent documents */
  connect?: InputMaybe<Array<CosmosElementResearchCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementResearchCardParent documents */
  create?: InputMaybe<Array<CosmosElementResearchCardParentCreateInput>>;
};

export type CosmosElementResearchCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementResearchCardParent document */
  connect?: InputMaybe<CosmosElementResearchCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementResearchCardParent document */
  create?: InputMaybe<CosmosElementResearchCardParentCreateInput>;
};

export type CosmosElementResearchCardParentUpdateInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
};

export type CosmosElementResearchCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementResearchCardParent documents */
  connect?: InputMaybe<Array<CosmosElementResearchCardParentConnectInput>>;
  /** Create and connect multiple CosmosElementResearchCardParent documents */
  create?: InputMaybe<Array<CosmosElementResearchCardParentCreateInput>>;
  /** Delete multiple CosmosElementResearchCardParent documents */
  delete?: InputMaybe<Array<CosmosElementResearchCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementResearchCardParent documents */
  disconnect?: InputMaybe<Array<CosmosElementResearchCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementResearchCardParent documents */
  set?: InputMaybe<Array<CosmosElementResearchCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementResearchCardParent documents */
  update?: InputMaybe<Array<CosmosElementResearchCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementResearchCardParent documents */
  upsert?: InputMaybe<Array<CosmosElementResearchCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementResearchCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
};

export type CosmosElementResearchCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementResearchCardParent document */
  connect?: InputMaybe<CosmosElementResearchCardParentWhereUniqueInput>;
  /** Create and connect one CosmosElementResearchCardParent document */
  create?: InputMaybe<CosmosElementResearchCardParentCreateInput>;
  /** Delete currently connected CosmosElementResearchCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementResearchCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementResearchCardParent document */
  update?: InputMaybe<CosmosElementResearchCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementResearchCardParent document */
  upsert?: InputMaybe<CosmosElementResearchCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementResearchCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementResearchCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementResearchCardParentWhereInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
};

export type CosmosElementResearchCardParentWhereUniqueInput = {
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
};

export type CosmosElementResearchCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** footer input for default locale (en) */
  footer?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementResearchCardUpdateLocalizationsInput>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementResearchCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementResearchCardUpdateLocalizationInput = {
  data: CosmosElementResearchCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementResearchCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementResearchCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementResearchCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementResearchCardUpsertLocalizationInput>>;
};

export type CosmosElementResearchCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementResearchCard component instances */
  create?: InputMaybe<Array<CosmosElementResearchCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementResearchCard documents */
  delete?: InputMaybe<Array<CosmosElementResearchCardWhereUniqueInput>>;
  /** Update multiple CosmosElementResearchCard component instances */
  update?: InputMaybe<Array<CosmosElementResearchCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementResearchCard component instances */
  upsert?: InputMaybe<Array<CosmosElementResearchCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementResearchCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** footer input for default locale (en) */
  footer?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementResearchCardUpdateManyLocalizationsInput>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementResearchCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementResearchCardUpdateManyLocalizationInput = {
  data: CosmosElementResearchCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementResearchCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementResearchCardUpdateManyLocalizationInput>>;
};

export type CosmosElementResearchCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementResearchCardUpdateManyInput;
  /** Document search */
  where: CosmosElementResearchCardWhereInput;
};

export type CosmosElementResearchCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementResearchCard document */
  create?: InputMaybe<CosmosElementResearchCardCreateInput>;
  /** Delete currently connected CosmosElementResearchCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementResearchCard document */
  update?: InputMaybe<CosmosElementResearchCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementResearchCard document */
  upsert?: InputMaybe<CosmosElementResearchCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementResearchCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementResearchCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementResearchCardWhereUniqueInput;
};

export type CosmosElementResearchCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementResearchCardUpdateInput;
  /** Unique document search */
  where: CosmosElementResearchCardWhereUniqueInput;
};

export type CosmosElementResearchCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementResearchCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementResearchCardUpdateInput;
};

export type CosmosElementResearchCardUpsertLocalizationInput = {
  create: CosmosElementResearchCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementResearchCardUpdateLocalizationDataInput;
};

export type CosmosElementResearchCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementResearchCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementResearchCardWhereUniqueInput;
};

export type CosmosElementResearchCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementResearchCardUpsertInput;
  /** Unique document search */
  where: CosmosElementResearchCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementResearchCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementResearchCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementResearchCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementResearchCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  footer_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  footer_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  footer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  footer_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  footer_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  footer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  footer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  footer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  footer_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  publicationDate_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  publicationDate_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  publicationDate_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  publicationDate_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  publicationDate_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publicationDate_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  publicationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementResearchCard record uniquely */
export type CosmosElementResearchCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementResellerCard = Entity & {
  __typename?: 'CosmosElementResellerCard';
  city?: Maybe<Scalars['String']['output']>;
  continents: Array<CosmosEnumResellerContinents>;
  email?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementResellerCard>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  street?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CosmosElementResellerCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementResellerCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementResellerCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementResellerCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementResellerCardConnection = {
  __typename?: 'CosmosElementResellerCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementResellerCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementResellerCardCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  continents?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementResellerCardCreateLocalizationsInput>;
  location?: InputMaybe<LocationInput>;
  /** name input for default locale (en) */
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementResellerCardCreateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementResellerCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementResellerCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementResellerCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementResellerCardCreateLocalizationInput>>;
};

export type CosmosElementResellerCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementResellerCard documents */
  create?: InputMaybe<Array<CosmosElementResellerCardCreateInput>>;
};

export type CosmosElementResellerCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementResellerCard document */
  create?: InputMaybe<CosmosElementResellerCardCreateInput>;
};

export type CosmosElementResellerCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementResellerCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementResellerCardEdge = {
  __typename?: 'CosmosElementResellerCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementResellerCard;
};

/** Identifies documents */
export type CosmosElementResellerCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementResellerCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementResellerCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementResellerCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  city_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  city_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  city_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  city_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  city_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  city_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  city_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  city_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  city_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  continents?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array contains *all* items provided to the filter */
  continents_contains_all?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  continents_contains_none?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array contains at least one item provided to the filter */
  continents_contains_some?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  continents_not?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  phone_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  phone_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  phone_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  phone_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  phone_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  phone_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  phone_starts_with?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  postalCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  postalCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  postalCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  postalCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  postalCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  postalCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  postalCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  postalCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  postalCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  region_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  region_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  region_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  region_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  region_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  region_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  region_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  region_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  region_starts_with?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  street_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  street_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  street_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  street_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  street_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  street_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  street_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  street_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  street_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  website?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CosmosElementResellerCardOrderByInput {
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  ContinentsAsc = 'continents_ASC',
  ContinentsDesc = 'continents_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  PostalCodeAsc = 'postalCode_ASC',
  PostalCodeDesc = 'postalCode_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  StreetAsc = 'street_ASC',
  StreetDesc = 'street_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebsiteAsc = 'website_ASC',
  WebsiteDesc = 'website_DESC'
}

export type CosmosElementResellerCardParent = CosmosSectionResellersSearch;

export type CosmosElementResellerCardParentConnectInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchConnectInput>;
};

export type CosmosElementResellerCardParentCreateInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchCreateInput>;
};

export type CosmosElementResellerCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementResellerCardParent documents */
  create?: InputMaybe<Array<CosmosElementResellerCardParentCreateInput>>;
};

export type CosmosElementResellerCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementResellerCardParent document */
  create?: InputMaybe<CosmosElementResellerCardParentCreateInput>;
};

export type CosmosElementResellerCardParentCreateWithPositionInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchCreateWithPositionInput>;
};

export type CosmosElementResellerCardParentUpdateInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateInput>;
};

export type CosmosElementResellerCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementResellerCardParent component instances */
  create?: InputMaybe<Array<CosmosElementResellerCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementResellerCardParent documents */
  delete?: InputMaybe<Array<CosmosElementResellerCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementResellerCardParent component instances */
  update?: InputMaybe<Array<CosmosElementResellerCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementResellerCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementResellerCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementResellerCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateManyWithNestedWhereInput>;
};

export type CosmosElementResellerCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementResellerCardParent document */
  create?: InputMaybe<CosmosElementResellerCardParentCreateInput>;
  /** Delete currently connected CosmosElementResellerCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementResellerCardParent document */
  update?: InputMaybe<CosmosElementResellerCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementResellerCardParent document */
  upsert?: InputMaybe<CosmosElementResellerCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementResellerCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementResellerCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementResellerCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementResellerCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementResellerCardParentWhereInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchWhereInput>;
};

export type CosmosElementResellerCardParentWhereUniqueInput = {
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchWhereUniqueInput>;
};

export type CosmosElementResellerCardUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  continents?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementResellerCardUpdateLocalizationsInput>;
  location?: InputMaybe<LocationInput>;
  /** name input for default locale (en) */
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementResellerCardUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementResellerCardUpdateLocalizationInput = {
  data: CosmosElementResellerCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementResellerCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementResellerCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementResellerCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementResellerCardUpsertLocalizationInput>>;
};

export type CosmosElementResellerCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementResellerCard component instances */
  create?: InputMaybe<Array<CosmosElementResellerCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementResellerCard documents */
  delete?: InputMaybe<Array<CosmosElementResellerCardWhereUniqueInput>>;
  /** Update multiple CosmosElementResellerCard component instances */
  update?: InputMaybe<Array<CosmosElementResellerCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementResellerCard component instances */
  upsert?: InputMaybe<Array<CosmosElementResellerCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementResellerCardUpdateManyInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  continents?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementResellerCardUpdateManyLocalizationsInput>;
  location?: InputMaybe<LocationInput>;
  /** name input for default locale (en) */
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementResellerCardUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementResellerCardUpdateManyLocalizationInput = {
  data: CosmosElementResellerCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementResellerCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementResellerCardUpdateManyLocalizationInput>>;
};

export type CosmosElementResellerCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementResellerCardUpdateManyInput;
  /** Document search */
  where: CosmosElementResellerCardWhereInput;
};

export type CosmosElementResellerCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementResellerCard document */
  create?: InputMaybe<CosmosElementResellerCardCreateInput>;
  /** Delete currently connected CosmosElementResellerCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementResellerCard document */
  update?: InputMaybe<CosmosElementResellerCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementResellerCard document */
  upsert?: InputMaybe<CosmosElementResellerCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementResellerCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementResellerCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementResellerCardWhereUniqueInput;
};

export type CosmosElementResellerCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementResellerCardUpdateInput;
  /** Unique document search */
  where: CosmosElementResellerCardWhereUniqueInput;
};

export type CosmosElementResellerCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementResellerCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementResellerCardUpdateInput;
};

export type CosmosElementResellerCardUpsertLocalizationInput = {
  create: CosmosElementResellerCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementResellerCardUpdateLocalizationDataInput;
};

export type CosmosElementResellerCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementResellerCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementResellerCardWhereUniqueInput;
};

export type CosmosElementResellerCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementResellerCardUpsertInput;
  /** Unique document search */
  where: CosmosElementResellerCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementResellerCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementResellerCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementResellerCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementResellerCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  city_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  city_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  city_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  city_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  city_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  city_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  city_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  city_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  city_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  continents?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array contains *all* items provided to the filter */
  continents_contains_all?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  continents_contains_none?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array contains at least one item provided to the filter */
  continents_contains_some?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  continents_not?: InputMaybe<Array<CosmosEnumResellerContinents>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  phone_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  phone_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  phone_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  phone_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  phone_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  phone_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  phone_starts_with?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  postalCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  postalCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  postalCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  postalCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  postalCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  postalCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  postalCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  postalCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  postalCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  region_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  region_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  region_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  region_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  region_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  region_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  region_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  region_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  region_starts_with?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  street_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  street_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  street_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  street_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  street_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  street_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  street_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  street_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  street_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  website?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  website_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  website_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  website_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  website_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  website_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  website_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  website_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  website_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  website_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CosmosElementResellerCard record uniquely */
export type CosmosElementResellerCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementRichText = Entity & {
  __typename?: 'CosmosElementRichText';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementRichText>;
  /** System stage field */
  stage: Stage;
  text: RichText;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementRichTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementRichTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementRichTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementRichTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementRichTextConnection = {
  __typename?: 'CosmosElementRichTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementRichTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementRichTextCreateInput = {
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementRichTextCreateLocalizationsInput>;
  /** text input for default locale (en) */
  text: Scalars['RichTextAST']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementRichTextCreateLocalizationDataInput = {
  text: Scalars['RichTextAST']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementRichTextCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementRichTextCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementRichTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementRichTextCreateLocalizationInput>>;
};

export type CosmosElementRichTextCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementRichText documents */
  create?: InputMaybe<Array<CosmosElementRichTextCreateInput>>;
};

export type CosmosElementRichTextCreateOneInlineInput = {
  /** Create and connect one CosmosElementRichText document */
  create?: InputMaybe<CosmosElementRichTextCreateInput>;
};

export type CosmosElementRichTextCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementRichTextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementRichTextEdge = {
  __typename?: 'CosmosElementRichTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementRichText;
};

/** Identifies documents */
export type CosmosElementRichTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementRichTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementRichTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementRichTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementRichTextOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementRichTextParent = CosmosElementDownloadCard | CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementRichTextParentConnectInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementRichTextParentCreateInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementRichTextParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementRichTextParent documents */
  connect?: InputMaybe<Array<CosmosElementRichTextParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementRichTextParent documents */
  create?: InputMaybe<Array<CosmosElementRichTextParentCreateInput>>;
};

export type CosmosElementRichTextParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementRichTextParent document */
  connect?: InputMaybe<CosmosElementRichTextParentWhereUniqueInput>;
  /** Create and connect one CosmosElementRichTextParent document */
  create?: InputMaybe<CosmosElementRichTextParentCreateInput>;
};

export type CosmosElementRichTextParentUpdateInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementRichTextParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementRichTextParent documents */
  connect?: InputMaybe<Array<CosmosElementRichTextParentConnectInput>>;
  /** Create and connect multiple CosmosElementRichTextParent documents */
  create?: InputMaybe<Array<CosmosElementRichTextParentCreateInput>>;
  /** Delete multiple CosmosElementRichTextParent documents */
  delete?: InputMaybe<Array<CosmosElementRichTextParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementRichTextParent documents */
  disconnect?: InputMaybe<Array<CosmosElementRichTextParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementRichTextParent documents */
  set?: InputMaybe<Array<CosmosElementRichTextParentWhereUniqueInput>>;
  /** Update multiple CosmosElementRichTextParent documents */
  update?: InputMaybe<Array<CosmosElementRichTextParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementRichTextParent documents */
  upsert?: InputMaybe<Array<CosmosElementRichTextParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementRichTextParentUpdateManyWithNestedWhereInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementRichTextParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementRichTextParent document */
  connect?: InputMaybe<CosmosElementRichTextParentWhereUniqueInput>;
  /** Create and connect one CosmosElementRichTextParent document */
  create?: InputMaybe<CosmosElementRichTextParentCreateInput>;
  /** Delete currently connected CosmosElementRichTextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementRichTextParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementRichTextParent document */
  update?: InputMaybe<CosmosElementRichTextParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementRichTextParent document */
  upsert?: InputMaybe<CosmosElementRichTextParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementRichTextParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementRichTextParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementRichTextParentWhereInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementRichTextParentWhereUniqueInput = {
  CosmosElementDownloadCard?: InputMaybe<CosmosElementDownloadCardWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementRichTextUpdateInput = {
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementRichTextUpdateLocalizationsInput>;
  /** text input for default locale (en) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementRichTextUpdateLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementRichTextUpdateLocalizationInput = {
  data: CosmosElementRichTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementRichTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementRichTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementRichTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementRichTextUpsertLocalizationInput>>;
};

export type CosmosElementRichTextUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementRichText component instances */
  create?: InputMaybe<Array<CosmosElementRichTextCreateWithPositionInput>>;
  /** Delete multiple CosmosElementRichText documents */
  delete?: InputMaybe<Array<CosmosElementRichTextWhereUniqueInput>>;
  /** Update multiple CosmosElementRichText component instances */
  update?: InputMaybe<Array<CosmosElementRichTextUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementRichText component instances */
  upsert?: InputMaybe<Array<CosmosElementRichTextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementRichTextUpdateManyInput = {
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementRichTextUpdateManyLocalizationsInput>;
  /** text input for default locale (en) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementRichTextUpdateManyLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementRichTextUpdateManyLocalizationInput = {
  data: CosmosElementRichTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementRichTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementRichTextUpdateManyLocalizationInput>>;
};

export type CosmosElementRichTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementRichTextUpdateManyInput;
  /** Document search */
  where: CosmosElementRichTextWhereInput;
};

export type CosmosElementRichTextUpdateOneInlineInput = {
  /** Create and connect one CosmosElementRichText document */
  create?: InputMaybe<CosmosElementRichTextCreateInput>;
  /** Delete currently connected CosmosElementRichText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementRichText document */
  update?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementRichText document */
  upsert?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementRichTextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementRichTextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementRichTextWhereUniqueInput;
};

export type CosmosElementRichTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementRichTextUpdateInput;
  /** Unique document search */
  where: CosmosElementRichTextWhereUniqueInput;
};

export type CosmosElementRichTextUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementRichTextCreateInput;
  /** Update document if it exists */
  update: CosmosElementRichTextUpdateInput;
};

export type CosmosElementRichTextUpsertLocalizationInput = {
  create: CosmosElementRichTextCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementRichTextUpdateLocalizationDataInput;
};

export type CosmosElementRichTextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementRichTextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementRichTextWhereUniqueInput;
};

export type CosmosElementRichTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementRichTextUpsertInput;
  /** Unique document search */
  where: CosmosElementRichTextWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementRichTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementRichTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementRichTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementRichTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementRichText record uniquely */
export type CosmosElementRichTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementSearchFilter = Entity & {
  __typename?: 'CosmosElementSearchFilter';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementSearchFilter>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type CosmosElementSearchFilterLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementSearchFilterUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementSearchFilterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementSearchFilterWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementSearchFilterConnection = {
  __typename?: 'CosmosElementSearchFilterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementSearchFilterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementSearchFilterCreateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementSearchFilterCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSearchFilterCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementSearchFilterCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementSearchFilterCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSearchFilterCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementSearchFilterCreateLocalizationInput>>;
};

export type CosmosElementSearchFilterCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementSearchFilter documents */
  create?: InputMaybe<Array<CosmosElementSearchFilterCreateInput>>;
};

export type CosmosElementSearchFilterCreateOneInlineInput = {
  /** Create and connect one CosmosElementSearchFilter document */
  create?: InputMaybe<CosmosElementSearchFilterCreateInput>;
};

export type CosmosElementSearchFilterCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementSearchFilterCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementSearchFilterEdge = {
  __typename?: 'CosmosElementSearchFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementSearchFilter;
};

/** Identifies documents */
export type CosmosElementSearchFilterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementSearchFilterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementSearchFilterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementSearchFilterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CosmosElementSearchFilterOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ValueAsc = 'value_ASC',
  ValueDesc = 'value_DESC'
}

export type CosmosElementSearchFilterParent = CosmosPageSearch;

export type CosmosElementSearchFilterParentConnectInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchConnectInput>;
};

export type CosmosElementSearchFilterParentCreateInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchCreateInput>;
};

export type CosmosElementSearchFilterParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementSearchFilterParent documents */
  connect?: InputMaybe<Array<CosmosElementSearchFilterParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementSearchFilterParent documents */
  create?: InputMaybe<Array<CosmosElementSearchFilterParentCreateInput>>;
};

export type CosmosElementSearchFilterParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementSearchFilterParent document */
  connect?: InputMaybe<CosmosElementSearchFilterParentWhereUniqueInput>;
  /** Create and connect one CosmosElementSearchFilterParent document */
  create?: InputMaybe<CosmosElementSearchFilterParentCreateInput>;
};

export type CosmosElementSearchFilterParentUpdateInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateInput>;
};

export type CosmosElementSearchFilterParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementSearchFilterParent documents */
  connect?: InputMaybe<Array<CosmosElementSearchFilterParentConnectInput>>;
  /** Create and connect multiple CosmosElementSearchFilterParent documents */
  create?: InputMaybe<Array<CosmosElementSearchFilterParentCreateInput>>;
  /** Delete multiple CosmosElementSearchFilterParent documents */
  delete?: InputMaybe<Array<CosmosElementSearchFilterParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementSearchFilterParent documents */
  disconnect?: InputMaybe<Array<CosmosElementSearchFilterParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementSearchFilterParent documents */
  set?: InputMaybe<Array<CosmosElementSearchFilterParentWhereUniqueInput>>;
  /** Update multiple CosmosElementSearchFilterParent documents */
  update?: InputMaybe<Array<CosmosElementSearchFilterParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementSearchFilterParent documents */
  upsert?: InputMaybe<Array<CosmosElementSearchFilterParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementSearchFilterParentUpdateManyWithNestedWhereInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateManyWithNestedWhereInput>;
};

export type CosmosElementSearchFilterParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementSearchFilterParent document */
  connect?: InputMaybe<CosmosElementSearchFilterParentWhereUniqueInput>;
  /** Create and connect one CosmosElementSearchFilterParent document */
  create?: InputMaybe<CosmosElementSearchFilterParentCreateInput>;
  /** Delete currently connected CosmosElementSearchFilterParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementSearchFilterParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSearchFilterParent document */
  update?: InputMaybe<CosmosElementSearchFilterParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSearchFilterParent document */
  upsert?: InputMaybe<CosmosElementSearchFilterParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSearchFilterParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementSearchFilterParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSearchFilterParentWhereInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchWhereInput>;
};

export type CosmosElementSearchFilterParentWhereUniqueInput = {
  CosmosPageSearch?: InputMaybe<CosmosPageSearchWhereUniqueInput>;
};

export type CosmosElementSearchFilterUpdateInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementSearchFilterUpdateLocalizationsInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSearchFilterUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSearchFilterUpdateLocalizationInput = {
  data: CosmosElementSearchFilterUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSearchFilterUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementSearchFilterCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementSearchFilterUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementSearchFilterUpsertLocalizationInput>>;
};

export type CosmosElementSearchFilterUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementSearchFilter component instances */
  create?: InputMaybe<Array<CosmosElementSearchFilterCreateWithPositionInput>>;
  /** Delete multiple CosmosElementSearchFilter documents */
  delete?: InputMaybe<Array<CosmosElementSearchFilterWhereUniqueInput>>;
  /** Update multiple CosmosElementSearchFilter component instances */
  update?: InputMaybe<Array<CosmosElementSearchFilterUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementSearchFilter component instances */
  upsert?: InputMaybe<Array<CosmosElementSearchFilterUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementSearchFilterUpdateManyInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementSearchFilterUpdateManyLocalizationsInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSearchFilterUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSearchFilterUpdateManyLocalizationInput = {
  data: CosmosElementSearchFilterUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSearchFilterUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementSearchFilterUpdateManyLocalizationInput>>;
};

export type CosmosElementSearchFilterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementSearchFilterUpdateManyInput;
  /** Document search */
  where: CosmosElementSearchFilterWhereInput;
};

export type CosmosElementSearchFilterUpdateOneInlineInput = {
  /** Create and connect one CosmosElementSearchFilter document */
  create?: InputMaybe<CosmosElementSearchFilterCreateInput>;
  /** Delete currently connected CosmosElementSearchFilter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSearchFilter document */
  update?: InputMaybe<CosmosElementSearchFilterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSearchFilter document */
  upsert?: InputMaybe<CosmosElementSearchFilterUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSearchFilterUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementSearchFilterUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementSearchFilterWhereUniqueInput;
};

export type CosmosElementSearchFilterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementSearchFilterUpdateInput;
  /** Unique document search */
  where: CosmosElementSearchFilterWhereUniqueInput;
};

export type CosmosElementSearchFilterUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementSearchFilterCreateInput;
  /** Update document if it exists */
  update: CosmosElementSearchFilterUpdateInput;
};

export type CosmosElementSearchFilterUpsertLocalizationInput = {
  create: CosmosElementSearchFilterCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementSearchFilterUpdateLocalizationDataInput;
};

export type CosmosElementSearchFilterUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementSearchFilterUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementSearchFilterWhereUniqueInput;
};

export type CosmosElementSearchFilterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementSearchFilterUpsertInput;
  /** Unique document search */
  where: CosmosElementSearchFilterWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementSearchFilterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementSearchFilterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementSearchFilterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementSearchFilterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CosmosElementSearchFilter record uniquely */
export type CosmosElementSearchFilterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementSectionHeading = Entity & {
  __typename?: 'CosmosElementSectionHeading';
  /** The buttons will be rendered on the flex-start and in the stack with the title and description. Defaults false. */
  buttonAlignLeft?: Maybe<Scalars['Boolean']['output']>;
  /** Basic button array. Overridden if modular button array is specified. */
  buttons: Array<CosmosElementButton>;
  /** Centers the content and stacks the content vertically. */
  centeredVerticalStack?: Maybe<Scalars['Boolean']['output']>;
  /** Uses a smaller variant for the title */
  compressedTitle?: Maybe<Scalars['Boolean']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementSectionHeading>;
  /** Array of button components */
  modButtons: Array<CosmosElementSectionHeadingmodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  titleGradient?: Maybe<CosmosEnumEdsGradients>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementSectionHeadingButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementSectionHeadingLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementSectionHeadingModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosElementSectionHeadingUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementSectionHeadingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementSectionHeadingWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementSectionHeadingConnection = {
  __typename?: 'CosmosElementSectionHeadingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementSectionHeadingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementSectionHeadingCreateInput = {
  buttonAlignLeft?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementSectionHeadingCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementSectionHeadingCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementSectionHeadingCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementSectionHeadingCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSectionHeadingCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementSectionHeadingCreateLocalizationInput>>;
};

export type CosmosElementSectionHeadingCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementSectionHeading documents */
  create?: InputMaybe<Array<CosmosElementSectionHeadingCreateInput>>;
};

export type CosmosElementSectionHeadingCreateOneInlineInput = {
  /** Create and connect one CosmosElementSectionHeading document */
  create?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
};

export type CosmosElementSectionHeadingCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementSectionHeadingCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementSectionHeadingEdge = {
  __typename?: 'CosmosElementSectionHeadingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementSectionHeading;
};

/** Identifies documents */
export type CosmosElementSectionHeadingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementSectionHeadingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementSectionHeadingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementSectionHeadingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonAlignLeft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  buttonAlignLeft_not?: InputMaybe<Scalars['Boolean']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredVerticalStack_not?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  compressedTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionWhereInput>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  titleGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  titleGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementSectionHeadingOrderByInput {
  ButtonAlignLeftAsc = 'buttonAlignLeft_ASC',
  ButtonAlignLeftDesc = 'buttonAlignLeft_DESC',
  CenteredVerticalStackAsc = 'centeredVerticalStack_ASC',
  CenteredVerticalStackDesc = 'centeredVerticalStack_DESC',
  CompressedTitleAsc = 'compressedTitle_ASC',
  CompressedTitleDesc = 'compressedTitle_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleGradientAsc = 'titleGradient_ASC',
  TitleGradientDesc = 'titleGradient_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementSectionHeadingParent = CosmosConfigSection | CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementSectionHeadingParentConnectInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementSectionHeadingParentCreateInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementSectionHeadingParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementSectionHeadingParent documents */
  connect?: InputMaybe<Array<CosmosElementSectionHeadingParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementSectionHeadingParent documents */
  create?: InputMaybe<Array<CosmosElementSectionHeadingParentCreateInput>>;
};

export type CosmosElementSectionHeadingParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementSectionHeadingParent document */
  connect?: InputMaybe<CosmosElementSectionHeadingParentWhereUniqueInput>;
  /** Create and connect one CosmosElementSectionHeadingParent document */
  create?: InputMaybe<CosmosElementSectionHeadingParentCreateInput>;
};

export type CosmosElementSectionHeadingParentUpdateInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementSectionHeadingParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementSectionHeadingParent documents */
  connect?: InputMaybe<Array<CosmosElementSectionHeadingParentConnectInput>>;
  /** Create and connect multiple CosmosElementSectionHeadingParent documents */
  create?: InputMaybe<Array<CosmosElementSectionHeadingParentCreateInput>>;
  /** Delete multiple CosmosElementSectionHeadingParent documents */
  delete?: InputMaybe<Array<CosmosElementSectionHeadingParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementSectionHeadingParent documents */
  disconnect?: InputMaybe<Array<CosmosElementSectionHeadingParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementSectionHeadingParent documents */
  set?: InputMaybe<Array<CosmosElementSectionHeadingParentWhereUniqueInput>>;
  /** Update multiple CosmosElementSectionHeadingParent documents */
  update?: InputMaybe<Array<CosmosElementSectionHeadingParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementSectionHeadingParent documents */
  upsert?: InputMaybe<Array<CosmosElementSectionHeadingParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementSectionHeadingParentUpdateManyWithNestedWhereInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementSectionHeadingParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementSectionHeadingParent document */
  connect?: InputMaybe<CosmosElementSectionHeadingParentWhereUniqueInput>;
  /** Create and connect one CosmosElementSectionHeadingParent document */
  create?: InputMaybe<CosmosElementSectionHeadingParentCreateInput>;
  /** Delete currently connected CosmosElementSectionHeadingParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementSectionHeadingParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSectionHeadingParent document */
  update?: InputMaybe<CosmosElementSectionHeadingParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSectionHeadingParent document */
  upsert?: InputMaybe<CosmosElementSectionHeadingParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingParentUpdateWithNestedWhereUniqueInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingParentUpsertWithNestedWhereUniqueInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingParentWhereInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementSectionHeadingParentWhereUniqueInput = {
  CosmosConfigSection?: InputMaybe<CosmosConfigSectionWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementSectionHeadingUpdateInput = {
  buttonAlignLeft?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementSectionHeadingUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
};

export type CosmosElementSectionHeadingUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementSectionHeadingUpdateLocalizationInput = {
  data: CosmosElementSectionHeadingUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSectionHeadingUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementSectionHeadingCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementSectionHeadingUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementSectionHeadingUpsertLocalizationInput>>;
};

export type CosmosElementSectionHeadingUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementSectionHeading component instances */
  create?: InputMaybe<Array<CosmosElementSectionHeadingCreateWithPositionInput>>;
  /** Delete multiple CosmosElementSectionHeading documents */
  delete?: InputMaybe<Array<CosmosElementSectionHeadingWhereUniqueInput>>;
  /** Update multiple CosmosElementSectionHeading component instances */
  update?: InputMaybe<Array<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementSectionHeading component instances */
  upsert?: InputMaybe<Array<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementSectionHeadingUpdateManyInput = {
  buttonAlignLeft?: InputMaybe<Scalars['Boolean']['input']>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementSectionHeadingUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
};

export type CosmosElementSectionHeadingUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementSectionHeadingUpdateManyLocalizationInput = {
  data: CosmosElementSectionHeadingUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSectionHeadingUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementSectionHeadingUpdateManyLocalizationInput>>;
};

export type CosmosElementSectionHeadingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementSectionHeadingUpdateManyInput;
  /** Document search */
  where: CosmosElementSectionHeadingWhereInput;
};

export type CosmosElementSectionHeadingUpdateOneInlineInput = {
  /** Create and connect one CosmosElementSectionHeading document */
  create?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
  /** Delete currently connected CosmosElementSectionHeading document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSectionHeading document */
  update?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSectionHeading document */
  upsert?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementSectionHeadingUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementSectionHeadingWhereUniqueInput;
};

export type CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementSectionHeadingUpdateInput;
  /** Unique document search */
  where: CosmosElementSectionHeadingWhereUniqueInput;
};

export type CosmosElementSectionHeadingUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementSectionHeadingCreateInput;
  /** Update document if it exists */
  update: CosmosElementSectionHeadingUpdateInput;
};

export type CosmosElementSectionHeadingUpsertLocalizationInput = {
  create: CosmosElementSectionHeadingCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementSectionHeadingUpdateLocalizationDataInput;
};

export type CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementSectionHeadingUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementSectionHeadingWhereUniqueInput;
};

export type CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementSectionHeadingUpsertInput;
  /** Unique document search */
  where: CosmosElementSectionHeadingWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementSectionHeadingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementSectionHeadingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementSectionHeadingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementSectionHeadingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonAlignLeft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  buttonAlignLeft_not?: InputMaybe<Scalars['Boolean']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centeredVerticalStack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredVerticalStack_not?: InputMaybe<Scalars['Boolean']['input']>;
  compressedTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  compressedTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionWhereInput>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  titleGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  titleGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementSectionHeading record uniquely */
export type CosmosElementSectionHeadingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementSectionHeadingmodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosElementSectionHeadingmodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementSectionHeadingmodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosElementSectionHeadingmodButtonsUnionCreateInput>>;
};

export type CosmosElementSectionHeadingmodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosElementSectionHeadingmodButtonsUnion document */
  create?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionCreateInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementSectionHeadingmodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosElementSectionHeadingmodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosElementSectionHeadingmodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosElementSectionHeadingmodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosElementSectionHeadingmodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosElementSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementSectionHeadingmodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosElementSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosElementSectionHeadingmodButtonsUnion document */
  create?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosElementSectionHeadingmodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSectionHeadingmodButtonsUnion document */
  update?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSectionHeadingmodButtonsUnion document */
  upsert?: InputMaybe<CosmosElementSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosElementSectionHeadingmodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosElementSpeakerCard = Entity & {
  __typename?: 'CosmosElementSpeakerCard';
  /** Speaker thumbnail asset */
  asset?: Maybe<Asset>;
  company?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Speaker card content icon */
  icon?: Maybe<EdsIconsEnum>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementSpeakerCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementSpeakerCardAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementSpeakerCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementSpeakerCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementSpeakerCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementSpeakerCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementSpeakerCardConnection = {
  __typename?: 'CosmosElementSpeakerCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementSpeakerCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementSpeakerCardCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  /** company input for default locale (en) */
  company?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementSpeakerCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementSpeakerCardCreateLocalizationDataInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementSpeakerCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementSpeakerCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSpeakerCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementSpeakerCardCreateLocalizationInput>>;
};

export type CosmosElementSpeakerCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementSpeakerCard documents */
  create?: InputMaybe<Array<CosmosElementSpeakerCardCreateInput>>;
};

export type CosmosElementSpeakerCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementSpeakerCard document */
  create?: InputMaybe<CosmosElementSpeakerCardCreateInput>;
};

export type CosmosElementSpeakerCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementSpeakerCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementSpeakerCardEdge = {
  __typename?: 'CosmosElementSpeakerCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementSpeakerCard;
};

/** Identifies documents */
export type CosmosElementSpeakerCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementSpeakerCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementSpeakerCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementSpeakerCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementSpeakerCardOrderByInput {
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementSpeakerCardParent = CosmosSectionSpeakerCard;

export type CosmosElementSpeakerCardParentConnectInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardConnectInput>;
};

export type CosmosElementSpeakerCardParentCreateInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardCreateInput>;
};

export type CosmosElementSpeakerCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementSpeakerCardParent documents */
  create?: InputMaybe<Array<CosmosElementSpeakerCardParentCreateInput>>;
};

export type CosmosElementSpeakerCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementSpeakerCardParent document */
  create?: InputMaybe<CosmosElementSpeakerCardParentCreateInput>;
};

export type CosmosElementSpeakerCardParentCreateWithPositionInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardCreateWithPositionInput>;
};

export type CosmosElementSpeakerCardParentUpdateInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateInput>;
};

export type CosmosElementSpeakerCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementSpeakerCardParent component instances */
  create?: InputMaybe<Array<CosmosElementSpeakerCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementSpeakerCardParent documents */
  delete?: InputMaybe<Array<CosmosElementSpeakerCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementSpeakerCardParent component instances */
  update?: InputMaybe<Array<CosmosElementSpeakerCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementSpeakerCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementSpeakerCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementSpeakerCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementSpeakerCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementSpeakerCardParent document */
  create?: InputMaybe<CosmosElementSpeakerCardParentCreateInput>;
  /** Delete currently connected CosmosElementSpeakerCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSpeakerCardParent document */
  update?: InputMaybe<CosmosElementSpeakerCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSpeakerCardParent document */
  upsert?: InputMaybe<CosmosElementSpeakerCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSpeakerCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementSpeakerCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementSpeakerCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementSpeakerCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSpeakerCardParentWhereInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardWhereInput>;
};

export type CosmosElementSpeakerCardParentWhereUniqueInput = {
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardWhereUniqueInput>;
};

export type CosmosElementSpeakerCardUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** company input for default locale (en) */
  company?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementSpeakerCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSpeakerCardUpdateLocalizationDataInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSpeakerCardUpdateLocalizationInput = {
  data: CosmosElementSpeakerCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSpeakerCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementSpeakerCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementSpeakerCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementSpeakerCardUpsertLocalizationInput>>;
};

export type CosmosElementSpeakerCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementSpeakerCard component instances */
  create?: InputMaybe<Array<CosmosElementSpeakerCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementSpeakerCard documents */
  delete?: InputMaybe<Array<CosmosElementSpeakerCardWhereUniqueInput>>;
  /** Update multiple CosmosElementSpeakerCard component instances */
  update?: InputMaybe<Array<CosmosElementSpeakerCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementSpeakerCard component instances */
  upsert?: InputMaybe<Array<CosmosElementSpeakerCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementSpeakerCardUpdateManyInput = {
  /** company input for default locale (en) */
  company?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementSpeakerCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSpeakerCardUpdateManyLocalizationDataInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementSpeakerCardUpdateManyLocalizationInput = {
  data: CosmosElementSpeakerCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementSpeakerCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementSpeakerCardUpdateManyLocalizationInput>>;
};

export type CosmosElementSpeakerCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementSpeakerCardUpdateManyInput;
  /** Document search */
  where: CosmosElementSpeakerCardWhereInput;
};

export type CosmosElementSpeakerCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementSpeakerCard document */
  create?: InputMaybe<CosmosElementSpeakerCardCreateInput>;
  /** Delete currently connected CosmosElementSpeakerCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementSpeakerCard document */
  update?: InputMaybe<CosmosElementSpeakerCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementSpeakerCard document */
  upsert?: InputMaybe<CosmosElementSpeakerCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementSpeakerCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementSpeakerCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementSpeakerCardWhereUniqueInput;
};

export type CosmosElementSpeakerCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementSpeakerCardUpdateInput;
  /** Unique document search */
  where: CosmosElementSpeakerCardWhereUniqueInput;
};

export type CosmosElementSpeakerCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementSpeakerCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementSpeakerCardUpdateInput;
};

export type CosmosElementSpeakerCardUpsertLocalizationInput = {
  create: CosmosElementSpeakerCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementSpeakerCardUpdateLocalizationDataInput;
};

export type CosmosElementSpeakerCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementSpeakerCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementSpeakerCardWhereUniqueInput;
};

export type CosmosElementSpeakerCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementSpeakerCardUpsertInput;
  /** Unique document search */
  where: CosmosElementSpeakerCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementSpeakerCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementSpeakerCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementSpeakerCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementSpeakerCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  company_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  company_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  company_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  company_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  company_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  company_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  company_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  company_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  company_starts_with?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementSpeakerCard record uniquely */
export type CosmosElementSpeakerCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementTabbedBlogCardsItem = Entity & {
  __typename?: 'CosmosElementTabbedBlogCardsItem';
  backgroundAsset?: Maybe<Asset>;
  buttons: Array<CosmosElementButton>;
  /** Default true, true stretches cards across whole width of the page, false to stay as forced column size for cards grid. */
  cardGridFitToWidth?: Maybe<Scalars['Boolean']['output']>;
  cards: Array<CosmosElementBlogCard>;
  description?: Maybe<Scalars['String']['output']>;
  /** Card list above normal Cards grid */
  featuredCards: Array<CosmosElementBlogCard>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementTabbedBlogCardsItem>;
  /** System stage field */
  stage: Stage;
  tabLabel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementTabbedBlogCardsItemBackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementTabbedBlogCardsItemButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementTabbedBlogCardsItemCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementBlogCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementBlogCardWhereInput>;
};


export type CosmosElementTabbedBlogCardsItemFeaturedCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementBlogCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementBlogCardWhereInput>;
};


export type CosmosElementTabbedBlogCardsItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementTabbedBlogCardsItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementTabbedBlogCardsItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementTabbedBlogCardsItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementTabbedBlogCardsItemConnection = {
  __typename?: 'CosmosElementTabbedBlogCardsItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementTabbedBlogCardsItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementTabbedBlogCardsItemCreateInput = {
  backgroundAsset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CosmosElementBlogCardCreateManyInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  featuredCards?: InputMaybe<CosmosElementBlogCardCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTabbedBlogCardsItemCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTabbedBlogCardsItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementTabbedBlogCardsItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedBlogCardsItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemCreateLocalizationInput>>;
};

export type CosmosElementTabbedBlogCardsItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTabbedBlogCardsItem documents */
  create?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemCreateInput>>;
};

export type CosmosElementTabbedBlogCardsItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedBlogCardsItem document */
  create?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateInput>;
};

export type CosmosElementTabbedBlogCardsItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementTabbedBlogCardsItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementTabbedBlogCardsItemEdge = {
  __typename?: 'CosmosElementTabbedBlogCardsItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementTabbedBlogCardsItem;
};

/** Identifies documents */
export type CosmosElementTabbedBlogCardsItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundAsset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cardGridFitToWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  cards_every?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementBlogCardWhereInput>;
  featuredCards_every?: InputMaybe<CosmosElementBlogCardWhereInput>;
  featuredCards_none?: InputMaybe<CosmosElementBlogCardWhereInput>;
  featuredCards_some?: InputMaybe<CosmosElementBlogCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementTabbedBlogCardsItemOrderByInput {
  CardGridFitToWidthAsc = 'cardGridFitToWidth_ASC',
  CardGridFitToWidthDesc = 'cardGridFitToWidth_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TabLabelAsc = 'tabLabel_ASC',
  TabLabelDesc = 'tabLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementTabbedBlogCardsItemParent = CosmosSectionTabbedBlogCard;

export type CosmosElementTabbedBlogCardsItemParentConnectInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardConnectInput>;
};

export type CosmosElementTabbedBlogCardsItemParentCreateInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardCreateInput>;
};

export type CosmosElementTabbedBlogCardsItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTabbedBlogCardsItemParent documents */
  create?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemParentCreateInput>>;
};

export type CosmosElementTabbedBlogCardsItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedBlogCardsItemParent document */
  create?: InputMaybe<CosmosElementTabbedBlogCardsItemParentCreateInput>;
};

export type CosmosElementTabbedBlogCardsItemParentCreateWithPositionInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardCreateWithPositionInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpdateInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTabbedBlogCardsItemParent component instances */
  create?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTabbedBlogCardsItemParent documents */
  delete?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementTabbedBlogCardsItemParent component instances */
  update?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTabbedBlogCardsItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTabbedBlogCardsItemParentUpdateManyWithNestedWhereInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedBlogCardsItemParent document */
  create?: InputMaybe<CosmosElementTabbedBlogCardsItemParentCreateInput>;
  /** Delete currently connected CosmosElementTabbedBlogCardsItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTabbedBlogCardsItemParent document */
  update?: InputMaybe<CosmosElementTabbedBlogCardsItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTabbedBlogCardsItemParent document */
  upsert?: InputMaybe<CosmosElementTabbedBlogCardsItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTabbedBlogCardsItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedBlogCardsItemParentWhereInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardWhereInput>;
};

export type CosmosElementTabbedBlogCardsItemParentWhereUniqueInput = {
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardWhereUniqueInput>;
};

export type CosmosElementTabbedBlogCardsItemUpdateInput = {
  backgroundAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CosmosElementBlogCardUpdateManyInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  featuredCards?: InputMaybe<CosmosElementBlogCardUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedBlogCardsItemUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedBlogCardsItemUpdateLocalizationInput = {
  data: CosmosElementTabbedBlogCardsItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedBlogCardsItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemUpsertLocalizationInput>>;
};

export type CosmosElementTabbedBlogCardsItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTabbedBlogCardsItem component instances */
  create?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTabbedBlogCardsItem documents */
  delete?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereUniqueInput>>;
  /** Update multiple CosmosElementTabbedBlogCardsItem component instances */
  update?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTabbedBlogCardsItem component instances */
  upsert?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTabbedBlogCardsItemUpdateManyInput = {
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateManyLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedBlogCardsItemUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedBlogCardsItemUpdateManyLocalizationInput = {
  data: CosmosElementTabbedBlogCardsItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedBlogCardsItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemUpdateManyLocalizationInput>>;
};

export type CosmosElementTabbedBlogCardsItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementTabbedBlogCardsItemUpdateManyInput;
  /** Document search */
  where: CosmosElementTabbedBlogCardsItemWhereInput;
};

export type CosmosElementTabbedBlogCardsItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedBlogCardsItem document */
  create?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateInput>;
  /** Delete currently connected CosmosElementTabbedBlogCardsItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTabbedBlogCardsItem document */
  update?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTabbedBlogCardsItem document */
  upsert?: InputMaybe<CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTabbedBlogCardsItemWhereUniqueInput;
};

export type CosmosElementTabbedBlogCardsItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementTabbedBlogCardsItemUpdateInput;
  /** Unique document search */
  where: CosmosElementTabbedBlogCardsItemWhereUniqueInput;
};

export type CosmosElementTabbedBlogCardsItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementTabbedBlogCardsItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementTabbedBlogCardsItemUpdateInput;
};

export type CosmosElementTabbedBlogCardsItemUpsertLocalizationInput = {
  create: CosmosElementTabbedBlogCardsItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementTabbedBlogCardsItemUpdateLocalizationDataInput;
};

export type CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementTabbedBlogCardsItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTabbedBlogCardsItemWhereUniqueInput;
};

export type CosmosElementTabbedBlogCardsItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementTabbedBlogCardsItemUpsertInput;
  /** Unique document search */
  where: CosmosElementTabbedBlogCardsItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementTabbedBlogCardsItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTabbedBlogCardsItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundAsset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cardGridFitToWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  cards_every?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementBlogCardWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuredCards_every?: InputMaybe<CosmosElementBlogCardWhereInput>;
  featuredCards_none?: InputMaybe<CosmosElementBlogCardWhereInput>;
  featuredCards_some?: InputMaybe<CosmosElementBlogCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementTabbedBlogCardsItem record uniquely */
export type CosmosElementTabbedBlogCardsItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementTabbedContentImageItem = Entity & {
  __typename?: 'CosmosElementTabbedContentImageItem';
  /** The primary image/video asset of the component. */
  asset?: Maybe<Asset>;
  /** The image asset to use for the blurred background effect around the primary asset. */
  blurredImage?: Maybe<Asset>;
  buttons: Array<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Horizontally flip the image and content */
  flip?: Maybe<Scalars['Boolean']['output']>;
  /** Gradient to apply to the title field for valid anchor tags. */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementTabbedContentImageItem>;
  /** System stage field */
  stage: Stage;
  /** The label of the tab/slide within the hero. */
  tabLabel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementTabbedContentImageItemAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementTabbedContentImageItemBlurredImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementTabbedContentImageItemButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosElementTabbedContentImageItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementTabbedContentImageItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementTabbedContentImageItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementTabbedContentImageItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementTabbedContentImageItemConnection = {
  __typename?: 'CosmosElementTabbedContentImageItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementTabbedContentImageItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementTabbedContentImageItemCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  blurredImage?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementTabbedContentImageItemCreateLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTabbedContentImageItemCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTabbedContentImageItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementTabbedContentImageItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedContentImageItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementTabbedContentImageItemCreateLocalizationInput>>;
};

export type CosmosElementTabbedContentImageItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTabbedContentImageItem documents */
  create?: InputMaybe<Array<CosmosElementTabbedContentImageItemCreateInput>>;
};

export type CosmosElementTabbedContentImageItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedContentImageItem document */
  create?: InputMaybe<CosmosElementTabbedContentImageItemCreateInput>;
};

export type CosmosElementTabbedContentImageItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementTabbedContentImageItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementTabbedContentImageItemEdge = {
  __typename?: 'CosmosElementTabbedContentImageItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementTabbedContentImageItem;
};

/** Identifies documents */
export type CosmosElementTabbedContentImageItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementTabbedContentImageItemOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  FlipAsc = 'flip_ASC',
  FlipDesc = 'flip_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TabLabelAsc = 'tabLabel_ASC',
  TabLabelDesc = 'tabLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementTabbedContentImageItemParent = CosmosSectionTabbedContentImage;

export type CosmosElementTabbedContentImageItemParentConnectInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageConnectInput>;
};

export type CosmosElementTabbedContentImageItemParentCreateInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageCreateInput>;
};

export type CosmosElementTabbedContentImageItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTabbedContentImageItemParent documents */
  create?: InputMaybe<Array<CosmosElementTabbedContentImageItemParentCreateInput>>;
};

export type CosmosElementTabbedContentImageItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedContentImageItemParent document */
  create?: InputMaybe<CosmosElementTabbedContentImageItemParentCreateInput>;
};

export type CosmosElementTabbedContentImageItemParentCreateWithPositionInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageCreateWithPositionInput>;
};

export type CosmosElementTabbedContentImageItemParentUpdateInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateInput>;
};

export type CosmosElementTabbedContentImageItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTabbedContentImageItemParent component instances */
  create?: InputMaybe<Array<CosmosElementTabbedContentImageItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTabbedContentImageItemParent documents */
  delete?: InputMaybe<Array<CosmosElementTabbedContentImageItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementTabbedContentImageItemParent component instances */
  update?: InputMaybe<Array<CosmosElementTabbedContentImageItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTabbedContentImageItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementTabbedContentImageItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTabbedContentImageItemParentUpdateManyWithNestedWhereInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateManyWithNestedWhereInput>;
};

export type CosmosElementTabbedContentImageItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedContentImageItemParent document */
  create?: InputMaybe<CosmosElementTabbedContentImageItemParentCreateInput>;
  /** Delete currently connected CosmosElementTabbedContentImageItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTabbedContentImageItemParent document */
  update?: InputMaybe<CosmosElementTabbedContentImageItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTabbedContentImageItemParent document */
  upsert?: InputMaybe<CosmosElementTabbedContentImageItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedContentImageItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTabbedContentImageItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedContentImageItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTabbedContentImageItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedContentImageItemParentWhereInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageWhereInput>;
};

export type CosmosElementTabbedContentImageItemParentWhereUniqueInput = {
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageWhereUniqueInput>;
};

export type CosmosElementTabbedContentImageItemUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  blurredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementTabbedContentImageItemUpdateLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedContentImageItemUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedContentImageItemUpdateLocalizationInput = {
  data: CosmosElementTabbedContentImageItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedContentImageItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementTabbedContentImageItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTabbedContentImageItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementTabbedContentImageItemUpsertLocalizationInput>>;
};

export type CosmosElementTabbedContentImageItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTabbedContentImageItem component instances */
  create?: InputMaybe<Array<CosmosElementTabbedContentImageItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTabbedContentImageItem documents */
  delete?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereUniqueInput>>;
  /** Update multiple CosmosElementTabbedContentImageItem component instances */
  update?: InputMaybe<Array<CosmosElementTabbedContentImageItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTabbedContentImageItem component instances */
  upsert?: InputMaybe<Array<CosmosElementTabbedContentImageItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTabbedContentImageItemUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementTabbedContentImageItemUpdateManyLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedContentImageItemUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedContentImageItemUpdateManyLocalizationInput = {
  data: CosmosElementTabbedContentImageItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedContentImageItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTabbedContentImageItemUpdateManyLocalizationInput>>;
};

export type CosmosElementTabbedContentImageItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementTabbedContentImageItemUpdateManyInput;
  /** Document search */
  where: CosmosElementTabbedContentImageItemWhereInput;
};

export type CosmosElementTabbedContentImageItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedContentImageItem document */
  create?: InputMaybe<CosmosElementTabbedContentImageItemCreateInput>;
  /** Delete currently connected CosmosElementTabbedContentImageItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTabbedContentImageItem document */
  update?: InputMaybe<CosmosElementTabbedContentImageItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTabbedContentImageItem document */
  upsert?: InputMaybe<CosmosElementTabbedContentImageItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedContentImageItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementTabbedContentImageItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTabbedContentImageItemWhereUniqueInput;
};

export type CosmosElementTabbedContentImageItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementTabbedContentImageItemUpdateInput;
  /** Unique document search */
  where: CosmosElementTabbedContentImageItemWhereUniqueInput;
};

export type CosmosElementTabbedContentImageItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementTabbedContentImageItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementTabbedContentImageItemUpdateInput;
};

export type CosmosElementTabbedContentImageItemUpsertLocalizationInput = {
  create: CosmosElementTabbedContentImageItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementTabbedContentImageItemUpdateLocalizationDataInput;
};

export type CosmosElementTabbedContentImageItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementTabbedContentImageItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTabbedContentImageItemWhereUniqueInput;
};

export type CosmosElementTabbedContentImageItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementTabbedContentImageItemUpsertInput;
  /** Unique document search */
  where: CosmosElementTabbedContentImageItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementTabbedContentImageItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTabbedContentImageItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementTabbedContentImageItem record uniquely */
export type CosmosElementTabbedContentImageItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Individual item/slide in the HeroBravo */
export type CosmosElementTabbedFullWidthAssetItem = Entity & {
  __typename?: 'CosmosElementTabbedFullWidthAssetItem';
  buttons: Array<CosmosElementIconButton>;
  desc?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Optional gradient to use in the title <a> tags */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The primary image/video asset displayed in the hero. */
  heroAsset?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementTabbedFullWidthAssetItem>;
  /** System stage field */
  stage: Stage;
  /** The label of the tab/slide within the hero. */
  tabLabel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Individual item/slide in the HeroBravo */
export type CosmosElementTabbedFullWidthAssetItemButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


/** Individual item/slide in the HeroBravo */
export type CosmosElementTabbedFullWidthAssetItemHeroAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Individual item/slide in the HeroBravo */
export type CosmosElementTabbedFullWidthAssetItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Individual item/slide in the HeroBravo */
export type CosmosElementTabbedFullWidthAssetItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementTabbedFullWidthAssetItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementTabbedFullWidthAssetItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementTabbedFullWidthAssetItemConnection = {
  __typename?: 'CosmosElementTabbedFullWidthAssetItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementTabbedFullWidthAssetItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementTabbedFullWidthAssetItemCreateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  heroAsset?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTabbedFullWidthAssetItemCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTabbedFullWidthAssetItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementTabbedFullWidthAssetItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedFullWidthAssetItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemCreateLocalizationInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTabbedFullWidthAssetItem documents */
  create?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemCreateInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemCreateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedFullWidthAssetItem document */
  create?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateInput>;
};

export type CosmosElementTabbedFullWidthAssetItemCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementTabbedFullWidthAssetItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementTabbedFullWidthAssetItemEdge = {
  __typename?: 'CosmosElementTabbedFullWidthAssetItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementTabbedFullWidthAssetItem;
};

/** Identifies documents */
export type CosmosElementTabbedFullWidthAssetItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  heroAsset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementTabbedFullWidthAssetItemOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TabLabelAsc = 'tabLabel_ASC',
  TabLabelDesc = 'tabLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementTabbedFullWidthAssetItemParent = CosmosSectionTabbedFullWidthAsset;

export type CosmosElementTabbedFullWidthAssetItemParentConnectInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetConnectInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentCreateInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTabbedFullWidthAssetItemParent documents */
  create?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemParentCreateInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedFullWidthAssetItemParent document */
  create?: InputMaybe<CosmosElementTabbedFullWidthAssetItemParentCreateInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentCreateWithPositionInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateWithPositionInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpdateInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTabbedFullWidthAssetItemParent component instances */
  create?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTabbedFullWidthAssetItemParent documents */
  delete?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemParentWhereUniqueInput>>;
  /** Update multiple CosmosElementTabbedFullWidthAssetItemParent component instances */
  update?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTabbedFullWidthAssetItemParent component instances */
  upsert?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpdateManyWithNestedWhereInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateManyWithNestedWhereInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedFullWidthAssetItemParent document */
  create?: InputMaybe<CosmosElementTabbedFullWidthAssetItemParentCreateInput>;
  /** Delete currently connected CosmosElementTabbedFullWidthAssetItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTabbedFullWidthAssetItemParent document */
  update?: InputMaybe<CosmosElementTabbedFullWidthAssetItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTabbedFullWidthAssetItemParent document */
  upsert?: InputMaybe<CosmosElementTabbedFullWidthAssetItemParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentWhereInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetWhereInput>;
};

export type CosmosElementTabbedFullWidthAssetItemParentWhereUniqueInput = {
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetWhereUniqueInput>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  heroAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateLocalizationInput = {
  data: CosmosElementTabbedFullWidthAssetItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemUpsertLocalizationInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTabbedFullWidthAssetItem component instances */
  create?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTabbedFullWidthAssetItem documents */
  delete?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereUniqueInput>>;
  /** Update multiple CosmosElementTabbedFullWidthAssetItem component instances */
  update?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTabbedFullWidthAssetItem component instances */
  upsert?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateManyLocalizationsInput>;
  /** tabLabel input for default locale (en) */
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateManyLocalizationInput = {
  data: CosmosElementTabbedFullWidthAssetItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemUpdateManyLocalizationInput>>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementTabbedFullWidthAssetItemUpdateManyInput;
  /** Document search */
  where: CosmosElementTabbedFullWidthAssetItemWhereInput;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTabbedFullWidthAssetItem document */
  create?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateInput>;
  /** Delete currently connected CosmosElementTabbedFullWidthAssetItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTabbedFullWidthAssetItem document */
  update?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTabbedFullWidthAssetItem document */
  upsert?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTabbedFullWidthAssetItemWhereUniqueInput;
};

export type CosmosElementTabbedFullWidthAssetItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementTabbedFullWidthAssetItemUpdateInput;
  /** Unique document search */
  where: CosmosElementTabbedFullWidthAssetItemWhereUniqueInput;
};

export type CosmosElementTabbedFullWidthAssetItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementTabbedFullWidthAssetItemCreateInput;
  /** Update document if it exists */
  update: CosmosElementTabbedFullWidthAssetItemUpdateInput;
};

export type CosmosElementTabbedFullWidthAssetItemUpsertLocalizationInput = {
  create: CosmosElementTabbedFullWidthAssetItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementTabbedFullWidthAssetItemUpdateLocalizationDataInput;
};

export type CosmosElementTabbedFullWidthAssetItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTabbedFullWidthAssetItemWhereUniqueInput;
};

export type CosmosElementTabbedFullWidthAssetItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementTabbedFullWidthAssetItemUpsertInput;
  /** Unique document search */
  where: CosmosElementTabbedFullWidthAssetItemWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementTabbedFullWidthAssetItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTabbedFullWidthAssetItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  heroAsset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementTabbedFullWidthAssetItem record uniquely */
export type CosmosElementTabbedFullWidthAssetItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Tag or badge component */
export type CosmosElementTag = Entity & {
  __typename?: 'CosmosElementTag';
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementTag>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Tag or badge component */
export type CosmosElementTagLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Tag or badge component */
export type CosmosElementTagUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementTagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementTagWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementTagConnection = {
  __typename?: 'CosmosElementTagConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementTagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementTagCreateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementTagCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTagCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTagCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementTagCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTagCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementTagCreateLocalizationInput>>;
};

export type CosmosElementTagCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTag documents */
  create?: InputMaybe<Array<CosmosElementTagCreateInput>>;
};

export type CosmosElementTagCreateOneInlineInput = {
  /** Create and connect one CosmosElementTag document */
  create?: InputMaybe<CosmosElementTagCreateInput>;
};

export type CosmosElementTagCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementTagCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementTagEdge = {
  __typename?: 'CosmosElementTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementTag;
};

/** Identifies documents */
export type CosmosElementTagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementTagOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementTagParent = CosmosElementDelphinusCard | CosmosElementGameDevFeatureCard | CosmosElementGeminiCard | CosmosElementNewsCard | CosmosSectionContentLargeImage | CosmosSectionContentSliderAsset | CosmosSectionFeatureCard;

export type CosmosElementTagParentConnectInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardConnectInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardConnectInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardConnectInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardConnectInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageConnectInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetConnectInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardConnectInput>;
};

export type CosmosElementTagParentCreateInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardCreateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardCreateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateInput>;
};

export type CosmosElementTagParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTagParent documents */
  create?: InputMaybe<Array<CosmosElementTagParentCreateInput>>;
};

export type CosmosElementTagParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementTagParent document */
  create?: InputMaybe<CosmosElementTagParentCreateInput>;
};

export type CosmosElementTagParentCreateWithPositionInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardCreateWithPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardCreateWithPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardCreateWithPositionInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardCreateWithPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateWithPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateWithPositionInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateWithPositionInput>;
};

export type CosmosElementTagParentUpdateInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateInput>;
};

export type CosmosElementTagParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTagParent component instances */
  create?: InputMaybe<Array<CosmosElementTagParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTagParent documents */
  delete?: InputMaybe<Array<CosmosElementTagParentWhereUniqueInput>>;
  /** Update multiple CosmosElementTagParent component instances */
  update?: InputMaybe<Array<CosmosElementTagParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTagParent component instances */
  upsert?: InputMaybe<Array<CosmosElementTagParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTagParentUpdateManyWithNestedWhereInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateManyWithNestedWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateManyWithNestedWhereInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateManyWithNestedWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementTagParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTagParent document */
  create?: InputMaybe<CosmosElementTagParentCreateInput>;
  /** Delete currently connected CosmosElementTagParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTagParent document */
  update?: InputMaybe<CosmosElementTagParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTagParent document */
  upsert?: InputMaybe<CosmosElementTagParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTagParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTagParentUpdateWithNestedWhereUniqueInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementTagParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementTagParentUpsertWithNestedWhereUniqueInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTagParentWhereInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereInput>;
};

export type CosmosElementTagParentWhereUniqueInput = {
  CosmosElementDelphinusCard?: InputMaybe<CosmosElementDelphinusCardWhereUniqueInput>;
  CosmosElementGameDevFeatureCard?: InputMaybe<CosmosElementGameDevFeatureCardWhereUniqueInput>;
  CosmosElementGeminiCard?: InputMaybe<CosmosElementGeminiCardWhereUniqueInput>;
  CosmosElementNewsCard?: InputMaybe<CosmosElementNewsCardWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereUniqueInput>;
};

export type CosmosElementTagUpdateInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementTagUpdateLocalizationsInput>;
};

export type CosmosElementTagUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementTagUpdateLocalizationInput = {
  data: CosmosElementTagUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTagUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementTagCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTagUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementTagUpsertLocalizationInput>>;
};

export type CosmosElementTagUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTag component instances */
  create?: InputMaybe<Array<CosmosElementTagCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTag documents */
  delete?: InputMaybe<Array<CosmosElementTagWhereUniqueInput>>;
  /** Update multiple CosmosElementTag component instances */
  update?: InputMaybe<Array<CosmosElementTagUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTag component instances */
  upsert?: InputMaybe<Array<CosmosElementTagUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTagUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementTagUpdateManyLocalizationsInput>;
};

export type CosmosElementTagUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementTagUpdateManyLocalizationInput = {
  data: CosmosElementTagUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTagUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTagUpdateManyLocalizationInput>>;
};

export type CosmosElementTagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementTagUpdateManyInput;
  /** Document search */
  where: CosmosElementTagWhereInput;
};

export type CosmosElementTagUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTag document */
  create?: InputMaybe<CosmosElementTagCreateInput>;
  /** Delete currently connected CosmosElementTag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTag document */
  update?: InputMaybe<CosmosElementTagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTag document */
  upsert?: InputMaybe<CosmosElementTagUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTagUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementTagUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTagWhereUniqueInput;
};

export type CosmosElementTagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementTagUpdateInput;
  /** Unique document search */
  where: CosmosElementTagWhereUniqueInput;
};

export type CosmosElementTagUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementTagCreateInput;
  /** Update document if it exists */
  update: CosmosElementTagUpdateInput;
};

export type CosmosElementTagUpsertLocalizationInput = {
  create: CosmosElementTagCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementTagUpdateLocalizationDataInput;
};

export type CosmosElementTagUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementTagUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTagWhereUniqueInput;
};

export type CosmosElementTagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementTagUpsertInput;
  /** Unique document search */
  where: CosmosElementTagWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementTag record uniquely */
export type CosmosElementTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementTitleAndDesc = Entity & {
  __typename?: 'CosmosElementTitleAndDesc';
  desc?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementTitleAndDesc>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementTitleAndDescLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementTitleAndDescUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementTitleAndDescConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementTitleAndDescWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementTitleAndDescConnection = {
  __typename?: 'CosmosElementTitleAndDescConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementTitleAndDescEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementTitleAndDescCreateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementTitleAndDescCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTitleAndDescCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementTitleAndDescCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementTitleAndDescCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTitleAndDescCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementTitleAndDescCreateLocalizationInput>>;
};

export type CosmosElementTitleAndDescCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementTitleAndDesc documents */
  create?: InputMaybe<Array<CosmosElementTitleAndDescCreateInput>>;
};

export type CosmosElementTitleAndDescCreateOneInlineInput = {
  /** Create and connect one CosmosElementTitleAndDesc document */
  create?: InputMaybe<CosmosElementTitleAndDescCreateInput>;
};

export type CosmosElementTitleAndDescCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementTitleAndDescCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementTitleAndDescEdge = {
  __typename?: 'CosmosElementTitleAndDescEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementTitleAndDesc;
};

/** Identifies documents */
export type CosmosElementTitleAndDescManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTitleAndDescWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTitleAndDescWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTitleAndDescWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementTitleAndDescOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementTitleAndDescParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementTitleAndDescParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementTitleAndDescParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementTitleAndDescParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementTitleAndDescParent documents */
  connect?: InputMaybe<Array<CosmosElementTitleAndDescParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementTitleAndDescParent documents */
  create?: InputMaybe<Array<CosmosElementTitleAndDescParentCreateInput>>;
};

export type CosmosElementTitleAndDescParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementTitleAndDescParent document */
  connect?: InputMaybe<CosmosElementTitleAndDescParentWhereUniqueInput>;
  /** Create and connect one CosmosElementTitleAndDescParent document */
  create?: InputMaybe<CosmosElementTitleAndDescParentCreateInput>;
};

export type CosmosElementTitleAndDescParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementTitleAndDescParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementTitleAndDescParent documents */
  connect?: InputMaybe<Array<CosmosElementTitleAndDescParentConnectInput>>;
  /** Create and connect multiple CosmosElementTitleAndDescParent documents */
  create?: InputMaybe<Array<CosmosElementTitleAndDescParentCreateInput>>;
  /** Delete multiple CosmosElementTitleAndDescParent documents */
  delete?: InputMaybe<Array<CosmosElementTitleAndDescParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementTitleAndDescParent documents */
  disconnect?: InputMaybe<Array<CosmosElementTitleAndDescParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementTitleAndDescParent documents */
  set?: InputMaybe<Array<CosmosElementTitleAndDescParentWhereUniqueInput>>;
  /** Update multiple CosmosElementTitleAndDescParent documents */
  update?: InputMaybe<Array<CosmosElementTitleAndDescParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementTitleAndDescParent documents */
  upsert?: InputMaybe<Array<CosmosElementTitleAndDescParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementTitleAndDescParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementTitleAndDescParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementTitleAndDescParent document */
  connect?: InputMaybe<CosmosElementTitleAndDescParentWhereUniqueInput>;
  /** Create and connect one CosmosElementTitleAndDescParent document */
  create?: InputMaybe<CosmosElementTitleAndDescParentCreateInput>;
  /** Delete currently connected CosmosElementTitleAndDescParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementTitleAndDescParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTitleAndDescParent document */
  update?: InputMaybe<CosmosElementTitleAndDescParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTitleAndDescParent document */
  upsert?: InputMaybe<CosmosElementTitleAndDescParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTitleAndDescParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementTitleAndDescParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTitleAndDescParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementTitleAndDescParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementTitleAndDescUpdateInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementTitleAndDescUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTitleAndDescUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTitleAndDescUpdateLocalizationInput = {
  data: CosmosElementTitleAndDescUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTitleAndDescUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementTitleAndDescCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTitleAndDescUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementTitleAndDescUpsertLocalizationInput>>;
};

export type CosmosElementTitleAndDescUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementTitleAndDesc component instances */
  create?: InputMaybe<Array<CosmosElementTitleAndDescCreateWithPositionInput>>;
  /** Delete multiple CosmosElementTitleAndDesc documents */
  delete?: InputMaybe<Array<CosmosElementTitleAndDescWhereUniqueInput>>;
  /** Update multiple CosmosElementTitleAndDesc component instances */
  update?: InputMaybe<Array<CosmosElementTitleAndDescUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementTitleAndDesc component instances */
  upsert?: InputMaybe<Array<CosmosElementTitleAndDescUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementTitleAndDescUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementTitleAndDescUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTitleAndDescUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosElementTitleAndDescUpdateManyLocalizationInput = {
  data: CosmosElementTitleAndDescUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementTitleAndDescUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementTitleAndDescUpdateManyLocalizationInput>>;
};

export type CosmosElementTitleAndDescUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementTitleAndDescUpdateManyInput;
  /** Document search */
  where: CosmosElementTitleAndDescWhereInput;
};

export type CosmosElementTitleAndDescUpdateOneInlineInput = {
  /** Create and connect one CosmosElementTitleAndDesc document */
  create?: InputMaybe<CosmosElementTitleAndDescCreateInput>;
  /** Delete currently connected CosmosElementTitleAndDesc document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementTitleAndDesc document */
  update?: InputMaybe<CosmosElementTitleAndDescUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementTitleAndDesc document */
  upsert?: InputMaybe<CosmosElementTitleAndDescUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementTitleAndDescUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementTitleAndDescUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTitleAndDescWhereUniqueInput;
};

export type CosmosElementTitleAndDescUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementTitleAndDescUpdateInput;
  /** Unique document search */
  where: CosmosElementTitleAndDescWhereUniqueInput;
};

export type CosmosElementTitleAndDescUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementTitleAndDescCreateInput;
  /** Update document if it exists */
  update: CosmosElementTitleAndDescUpdateInput;
};

export type CosmosElementTitleAndDescUpsertLocalizationInput = {
  create: CosmosElementTitleAndDescCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementTitleAndDescUpdateLocalizationDataInput;
};

export type CosmosElementTitleAndDescUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementTitleAndDescUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementTitleAndDescWhereUniqueInput;
};

export type CosmosElementTitleAndDescUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementTitleAndDescUpsertInput;
  /** Unique document search */
  where: CosmosElementTitleAndDescWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementTitleAndDescWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementTitleAndDescWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementTitleAndDescWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementTitleAndDescWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementTitleAndDesc record uniquely */
export type CosmosElementTitleAndDescWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementUserProfile = Entity & {
  __typename?: 'CosmosElementUserProfile';
  /** Image block used for all variants with Avatar design in Avatar variant, and CosmosImage design for Vertical/Horizontal variant. */
  avatar?: Maybe<CosmosElementAvatar>;
  button?: Maybe<CosmosElementIconButton>;
  desc?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementUserProfile>;
  /** Image as part of Title/Desc block positioned above Title. */
  logoImage?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Vertical/Horizontal will force one layout.
   * Avatar uses both layouts based on viewport.
   */
  variant?: Maybe<CosmosEnumUserProfileVariant>;
};


export type CosmosElementUserProfileAvatarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementUserProfileButtonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosElementUserProfileLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementUserProfileLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementUserProfileUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementUserProfileConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementUserProfileWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementUserProfileConnection = {
  __typename?: 'CosmosElementUserProfileConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementUserProfileEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementUserProfileCreateInput = {
  avatar?: InputMaybe<CosmosElementAvatarCreateOneInlineInput>;
  button?: InputMaybe<CosmosElementIconButtonCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementUserProfileCreateLocalizationsInput>;
  logoImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumUserProfileVariant>;
};

export type CosmosElementUserProfileCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementUserProfileCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementUserProfileCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementUserProfileCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementUserProfileCreateLocalizationInput>>;
};

export type CosmosElementUserProfileCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementUserProfile documents */
  create?: InputMaybe<Array<CosmosElementUserProfileCreateInput>>;
};

export type CosmosElementUserProfileCreateOneInlineInput = {
  /** Create and connect one CosmosElementUserProfile document */
  create?: InputMaybe<CosmosElementUserProfileCreateInput>;
};

export type CosmosElementUserProfileCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementUserProfileCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementUserProfileEdge = {
  __typename?: 'CosmosElementUserProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementUserProfile;
};

/** Identifies documents */
export type CosmosElementUserProfileManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementUserProfileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementUserProfileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementUserProfileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CosmosElementAvatarWhereInput>;
  button?: InputMaybe<CosmosElementIconButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumUserProfileVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumUserProfileVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumUserProfileVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumUserProfileVariant>>>;
};

export enum CosmosElementUserProfileOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosElementUserProfileParent = CosmosPageBlogDetail | CosmosPagePluginDetail;

export type CosmosElementUserProfileParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
};

export type CosmosElementUserProfileParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

export type CosmosElementUserProfileParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementUserProfileParent documents */
  connect?: InputMaybe<Array<CosmosElementUserProfileParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementUserProfileParent documents */
  create?: InputMaybe<Array<CosmosElementUserProfileParentCreateInput>>;
};

export type CosmosElementUserProfileParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementUserProfileParent document */
  connect?: InputMaybe<CosmosElementUserProfileParentWhereUniqueInput>;
  /** Create and connect one CosmosElementUserProfileParent document */
  create?: InputMaybe<CosmosElementUserProfileParentCreateInput>;
};

export type CosmosElementUserProfileParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
};

export type CosmosElementUserProfileParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementUserProfileParent documents */
  connect?: InputMaybe<Array<CosmosElementUserProfileParentConnectInput>>;
  /** Create and connect multiple CosmosElementUserProfileParent documents */
  create?: InputMaybe<Array<CosmosElementUserProfileParentCreateInput>>;
  /** Delete multiple CosmosElementUserProfileParent documents */
  delete?: InputMaybe<Array<CosmosElementUserProfileParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementUserProfileParent documents */
  disconnect?: InputMaybe<Array<CosmosElementUserProfileParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementUserProfileParent documents */
  set?: InputMaybe<Array<CosmosElementUserProfileParentWhereUniqueInput>>;
  /** Update multiple CosmosElementUserProfileParent documents */
  update?: InputMaybe<Array<CosmosElementUserProfileParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementUserProfileParent documents */
  upsert?: InputMaybe<Array<CosmosElementUserProfileParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementUserProfileParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
};

export type CosmosElementUserProfileParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementUserProfileParent document */
  connect?: InputMaybe<CosmosElementUserProfileParentWhereUniqueInput>;
  /** Create and connect one CosmosElementUserProfileParent document */
  create?: InputMaybe<CosmosElementUserProfileParentCreateInput>;
  /** Delete currently connected CosmosElementUserProfileParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementUserProfileParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementUserProfileParent document */
  update?: InputMaybe<CosmosElementUserProfileParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementUserProfileParent document */
  upsert?: InputMaybe<CosmosElementUserProfileParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementUserProfileParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementUserProfileParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementUserProfileParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};

export type CosmosElementUserProfileParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
};

export type CosmosElementUserProfileUpdateInput = {
  avatar?: InputMaybe<CosmosElementAvatarUpdateOneInlineInput>;
  button?: InputMaybe<CosmosElementIconButtonUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementUserProfileUpdateLocalizationsInput>;
  logoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumUserProfileVariant>;
};

export type CosmosElementUserProfileUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementUserProfileUpdateLocalizationInput = {
  data: CosmosElementUserProfileUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementUserProfileUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementUserProfileCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementUserProfileUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementUserProfileUpsertLocalizationInput>>;
};

export type CosmosElementUserProfileUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementUserProfile component instances */
  create?: InputMaybe<Array<CosmosElementUserProfileCreateWithPositionInput>>;
  /** Delete multiple CosmosElementUserProfile documents */
  delete?: InputMaybe<Array<CosmosElementUserProfileWhereUniqueInput>>;
  /** Update multiple CosmosElementUserProfile component instances */
  update?: InputMaybe<Array<CosmosElementUserProfileUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementUserProfile component instances */
  upsert?: InputMaybe<Array<CosmosElementUserProfileUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementUserProfileUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementUserProfileUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumUserProfileVariant>;
};

export type CosmosElementUserProfileUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementUserProfileUpdateManyLocalizationInput = {
  data: CosmosElementUserProfileUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementUserProfileUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementUserProfileUpdateManyLocalizationInput>>;
};

export type CosmosElementUserProfileUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementUserProfileUpdateManyInput;
  /** Document search */
  where: CosmosElementUserProfileWhereInput;
};

export type CosmosElementUserProfileUpdateOneInlineInput = {
  /** Create and connect one CosmosElementUserProfile document */
  create?: InputMaybe<CosmosElementUserProfileCreateInput>;
  /** Delete currently connected CosmosElementUserProfile document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementUserProfile document */
  update?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementUserProfile document */
  upsert?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementUserProfileUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementUserProfileUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementUserProfileWhereUniqueInput;
};

export type CosmosElementUserProfileUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementUserProfileUpdateInput;
  /** Unique document search */
  where: CosmosElementUserProfileWhereUniqueInput;
};

export type CosmosElementUserProfileUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementUserProfileCreateInput;
  /** Update document if it exists */
  update: CosmosElementUserProfileUpdateInput;
};

export type CosmosElementUserProfileUpsertLocalizationInput = {
  create: CosmosElementUserProfileCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementUserProfileUpdateLocalizationDataInput;
};

export type CosmosElementUserProfileUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementUserProfileUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementUserProfileWhereUniqueInput;
};

export type CosmosElementUserProfileUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementUserProfileUpsertInput;
  /** Unique document search */
  where: CosmosElementUserProfileWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementUserProfileWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementUserProfileWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementUserProfileWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementUserProfileWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CosmosElementAvatarWhereInput>;
  button?: InputMaybe<CosmosElementIconButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumUserProfileVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumUserProfileVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumUserProfileVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumUserProfileVariant>>>;
};

/** References CosmosElementUserProfile record uniquely */
export type CosmosElementUserProfileWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Card inspired from the ones at the bottom of Unreal Tournament's website. */
export type CosmosElementUtCard = Entity & {
  __typename?: 'CosmosElementUtCard';
  /** The background image of the card. The card is rendered with a 9/16 aspect ratio. */
  cardImage?: Maybe<Asset>;
  /** The relative or absolute URL to navigate to on click of the card. */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Aria label for the card */
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementUtCard>;
  /** Centered svg in the middle of the card. */
  logoImage?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Card inspired from the ones at the bottom of Unreal Tournament's website. */
export type CosmosElementUtCardCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Card inspired from the ones at the bottom of Unreal Tournament's website. */
export type CosmosElementUtCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Card inspired from the ones at the bottom of Unreal Tournament's website. */
export type CosmosElementUtCardLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Card inspired from the ones at the bottom of Unreal Tournament's website. */
export type CosmosElementUtCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementUtCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementUtCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementUtCardConnection = {
  __typename?: 'CosmosElementUtCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementUtCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementUtCardCreateInput = {
  cardImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementUtCardCreateLocalizationsInput>;
  logoImage?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementUtCardCreateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementUtCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementUtCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementUtCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementUtCardCreateLocalizationInput>>;
};

export type CosmosElementUtCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementUtCard documents */
  create?: InputMaybe<Array<CosmosElementUtCardCreateInput>>;
};

export type CosmosElementUtCardCreateOneInlineInput = {
  /** Create and connect one CosmosElementUtCard document */
  create?: InputMaybe<CosmosElementUtCardCreateInput>;
};

export type CosmosElementUtCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementUtCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementUtCardEdge = {
  __typename?: 'CosmosElementUtCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementUtCard;
};

/** Identifies documents */
export type CosmosElementUtCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementUtCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementUtCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementUtCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementUtCardOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementUtCardParent = CosmosSectionUtCard;

export type CosmosElementUtCardParentConnectInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardConnectInput>;
};

export type CosmosElementUtCardParentCreateInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardCreateInput>;
};

export type CosmosElementUtCardParentCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementUtCardParent documents */
  create?: InputMaybe<Array<CosmosElementUtCardParentCreateInput>>;
};

export type CosmosElementUtCardParentCreateOneInlineInput = {
  /** Create and connect one CosmosElementUtCardParent document */
  create?: InputMaybe<CosmosElementUtCardParentCreateInput>;
};

export type CosmosElementUtCardParentCreateWithPositionInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardCreateWithPositionInput>;
};

export type CosmosElementUtCardParentUpdateInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateInput>;
};

export type CosmosElementUtCardParentUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementUtCardParent component instances */
  create?: InputMaybe<Array<CosmosElementUtCardParentCreateWithPositionInput>>;
  /** Delete multiple CosmosElementUtCardParent documents */
  delete?: InputMaybe<Array<CosmosElementUtCardParentWhereUniqueInput>>;
  /** Update multiple CosmosElementUtCardParent component instances */
  update?: InputMaybe<Array<CosmosElementUtCardParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementUtCardParent component instances */
  upsert?: InputMaybe<Array<CosmosElementUtCardParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementUtCardParentUpdateManyWithNestedWhereInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateManyWithNestedWhereInput>;
};

export type CosmosElementUtCardParentUpdateOneInlineInput = {
  /** Create and connect one CosmosElementUtCardParent document */
  create?: InputMaybe<CosmosElementUtCardParentCreateInput>;
  /** Delete currently connected CosmosElementUtCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementUtCardParent document */
  update?: InputMaybe<CosmosElementUtCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementUtCardParent document */
  upsert?: InputMaybe<CosmosElementUtCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementUtCardParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementUtCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementUtCardParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosElementUtCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementUtCardParentWhereInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardWhereInput>;
};

export type CosmosElementUtCardParentWhereUniqueInput = {
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardWhereUniqueInput>;
};

export type CosmosElementUtCardUpdateInput = {
  cardImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementUtCardUpdateLocalizationsInput>;
  logoImage?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type CosmosElementUtCardUpdateLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementUtCardUpdateLocalizationInput = {
  data: CosmosElementUtCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementUtCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementUtCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementUtCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementUtCardUpsertLocalizationInput>>;
};

export type CosmosElementUtCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementUtCard component instances */
  create?: InputMaybe<Array<CosmosElementUtCardCreateWithPositionInput>>;
  /** Delete multiple CosmosElementUtCard documents */
  delete?: InputMaybe<Array<CosmosElementUtCardWhereUniqueInput>>;
  /** Update multiple CosmosElementUtCard component instances */
  update?: InputMaybe<Array<CosmosElementUtCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementUtCard component instances */
  upsert?: InputMaybe<Array<CosmosElementUtCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementUtCardUpdateManyInput = {
  /** href input for default locale (en) */
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementUtCardUpdateManyLocalizationsInput>;
};

export type CosmosElementUtCardUpdateManyLocalizationDataInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementUtCardUpdateManyLocalizationInput = {
  data: CosmosElementUtCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementUtCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementUtCardUpdateManyLocalizationInput>>;
};

export type CosmosElementUtCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementUtCardUpdateManyInput;
  /** Document search */
  where: CosmosElementUtCardWhereInput;
};

export type CosmosElementUtCardUpdateOneInlineInput = {
  /** Create and connect one CosmosElementUtCard document */
  create?: InputMaybe<CosmosElementUtCardCreateInput>;
  /** Delete currently connected CosmosElementUtCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementUtCard document */
  update?: InputMaybe<CosmosElementUtCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementUtCard document */
  upsert?: InputMaybe<CosmosElementUtCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementUtCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementUtCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementUtCardWhereUniqueInput;
};

export type CosmosElementUtCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementUtCardUpdateInput;
  /** Unique document search */
  where: CosmosElementUtCardWhereUniqueInput;
};

export type CosmosElementUtCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementUtCardCreateInput;
  /** Update document if it exists */
  update: CosmosElementUtCardUpdateInput;
};

export type CosmosElementUtCardUpsertLocalizationInput = {
  create: CosmosElementUtCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementUtCardUpdateLocalizationDataInput;
};

export type CosmosElementUtCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementUtCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementUtCardWhereUniqueInput;
};

export type CosmosElementUtCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementUtCardUpsertInput;
  /** Unique document search */
  where: CosmosElementUtCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementUtCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementUtCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementUtCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementUtCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardImage?: InputMaybe<AssetWhereInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementUtCard record uniquely */
export type CosmosElementUtCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosElementVideoEmbed = Entity & {
  __typename?: 'CosmosElementVideoEmbed';
  attribution?: Maybe<Scalars['String']['output']>;
  /** Disables the overlay with the Play button and just shows the iframe immediately */
  disableOverlay?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** This URL would be the page to embed in an iframe. Certain URLs, such as those containing bilibili or twitch.tv, will open in a new tab rather than be embedded on the page. */
  iframeSrc?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosElementVideoEmbed>;
  /** This will be the image displayed until the Play button is clicked. If not chosen here, then the original thumbnail for the embed (such as a YouTube thumbnail) will be shown instead. */
  overlayImage?: Maybe<Asset>;
  /** This will be the accessibility text for screen readers focusing on the Play button. If left empty, this will fall back to "Play Video". */
  playButtonAriaLabel?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosElementVideoEmbedLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosElementVideoEmbedOverlayImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosElementVideoEmbedUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosElementVideoEmbedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosElementVideoEmbedWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosElementVideoEmbedConnection = {
  __typename?: 'CosmosElementVideoEmbedConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosElementVideoEmbedEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosElementVideoEmbedCreateInput = {
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** disableOverlay input for default locale (en) */
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** iframeSrc input for default locale (en) */
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosElementVideoEmbedCreateLocalizationsInput>;
  overlayImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** playButtonAriaLabel input for default locale (en) */
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementVideoEmbedCreateLocalizationDataInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosElementVideoEmbedCreateLocalizationInput = {
  /** Localization input */
  data: CosmosElementVideoEmbedCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementVideoEmbedCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosElementVideoEmbedCreateLocalizationInput>>;
};

export type CosmosElementVideoEmbedCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosElementVideoEmbed documents */
  create?: InputMaybe<Array<CosmosElementVideoEmbedCreateInput>>;
};

export type CosmosElementVideoEmbedCreateOneInlineInput = {
  /** Create and connect one CosmosElementVideoEmbed document */
  create?: InputMaybe<CosmosElementVideoEmbedCreateInput>;
};

export type CosmosElementVideoEmbedCreateWithPositionInput = {
  /** Document to create */
  data: CosmosElementVideoEmbedCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosElementVideoEmbedEdge = {
  __typename?: 'CosmosElementVideoEmbedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosElementVideoEmbed;
};

/** Identifies documents */
export type CosmosElementVideoEmbedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementVideoEmbedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementVideoEmbedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementVideoEmbedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  overlayImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosElementVideoEmbedOrderByInput {
  AttributionAsc = 'attribution_ASC',
  AttributionDesc = 'attribution_DESC',
  DisableOverlayAsc = 'disableOverlay_ASC',
  DisableOverlayDesc = 'disableOverlay_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IframeSrcAsc = 'iframeSrc_ASC',
  IframeSrcDesc = 'iframeSrc_DESC',
  PlayButtonAriaLabelAsc = 'playButtonAriaLabel_ASC',
  PlayButtonAriaLabelDesc = 'playButtonAriaLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosElementVideoEmbedParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosSectionEmbed;

export type CosmosElementVideoEmbedParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedConnectInput>;
};

export type CosmosElementVideoEmbedParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedCreateInput>;
};

export type CosmosElementVideoEmbedParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosElementVideoEmbedParent documents */
  connect?: InputMaybe<Array<CosmosElementVideoEmbedParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosElementVideoEmbedParent documents */
  create?: InputMaybe<Array<CosmosElementVideoEmbedParentCreateInput>>;
};

export type CosmosElementVideoEmbedParentCreateOneInlineInput = {
  /** Connect one existing CosmosElementVideoEmbedParent document */
  connect?: InputMaybe<CosmosElementVideoEmbedParentWhereUniqueInput>;
  /** Create and connect one CosmosElementVideoEmbedParent document */
  create?: InputMaybe<CosmosElementVideoEmbedParentCreateInput>;
};

export type CosmosElementVideoEmbedParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateInput>;
};

export type CosmosElementVideoEmbedParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosElementVideoEmbedParent documents */
  connect?: InputMaybe<Array<CosmosElementVideoEmbedParentConnectInput>>;
  /** Create and connect multiple CosmosElementVideoEmbedParent documents */
  create?: InputMaybe<Array<CosmosElementVideoEmbedParentCreateInput>>;
  /** Delete multiple CosmosElementVideoEmbedParent documents */
  delete?: InputMaybe<Array<CosmosElementVideoEmbedParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosElementVideoEmbedParent documents */
  disconnect?: InputMaybe<Array<CosmosElementVideoEmbedParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosElementVideoEmbedParent documents */
  set?: InputMaybe<Array<CosmosElementVideoEmbedParentWhereUniqueInput>>;
  /** Update multiple CosmosElementVideoEmbedParent documents */
  update?: InputMaybe<Array<CosmosElementVideoEmbedParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosElementVideoEmbedParent documents */
  upsert?: InputMaybe<Array<CosmosElementVideoEmbedParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosElementVideoEmbedParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateManyWithNestedWhereInput>;
};

export type CosmosElementVideoEmbedParentUpdateOneInlineInput = {
  /** Connect existing CosmosElementVideoEmbedParent document */
  connect?: InputMaybe<CosmosElementVideoEmbedParentWhereUniqueInput>;
  /** Create and connect one CosmosElementVideoEmbedParent document */
  create?: InputMaybe<CosmosElementVideoEmbedParentCreateInput>;
  /** Delete currently connected CosmosElementVideoEmbedParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosElementVideoEmbedParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementVideoEmbedParent document */
  update?: InputMaybe<CosmosElementVideoEmbedParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementVideoEmbedParent document */
  upsert?: InputMaybe<CosmosElementVideoEmbedParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementVideoEmbedParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateWithNestedWhereUniqueInput>;
};

export type CosmosElementVideoEmbedParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementVideoEmbedParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedWhereInput>;
};

export type CosmosElementVideoEmbedParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedWhereUniqueInput>;
};

export type CosmosElementVideoEmbedUpdateInput = {
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** disableOverlay input for default locale (en) */
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** iframeSrc input for default locale (en) */
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosElementVideoEmbedUpdateLocalizationsInput>;
  overlayImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** playButtonAriaLabel input for default locale (en) */
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementVideoEmbedUpdateLocalizationDataInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementVideoEmbedUpdateLocalizationInput = {
  data: CosmosElementVideoEmbedUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementVideoEmbedUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosElementVideoEmbedCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementVideoEmbedUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosElementVideoEmbedUpsertLocalizationInput>>;
};

export type CosmosElementVideoEmbedUpdateManyInlineInput = {
  /** Create and connect multiple CosmosElementVideoEmbed component instances */
  create?: InputMaybe<Array<CosmosElementVideoEmbedCreateWithPositionInput>>;
  /** Delete multiple CosmosElementVideoEmbed documents */
  delete?: InputMaybe<Array<CosmosElementVideoEmbedWhereUniqueInput>>;
  /** Update multiple CosmosElementVideoEmbed component instances */
  update?: InputMaybe<Array<CosmosElementVideoEmbedUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosElementVideoEmbed component instances */
  upsert?: InputMaybe<Array<CosmosElementVideoEmbedUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosElementVideoEmbedUpdateManyInput = {
  /** attribution input for default locale (en) */
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** disableOverlay input for default locale (en) */
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** iframeSrc input for default locale (en) */
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosElementVideoEmbedUpdateManyLocalizationsInput>;
  /** playButtonAriaLabel input for default locale (en) */
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementVideoEmbedUpdateManyLocalizationDataInput = {
  attribution?: InputMaybe<Scalars['String']['input']>;
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosElementVideoEmbedUpdateManyLocalizationInput = {
  data: CosmosElementVideoEmbedUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosElementVideoEmbedUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosElementVideoEmbedUpdateManyLocalizationInput>>;
};

export type CosmosElementVideoEmbedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosElementVideoEmbedUpdateManyInput;
  /** Document search */
  where: CosmosElementVideoEmbedWhereInput;
};

export type CosmosElementVideoEmbedUpdateOneInlineInput = {
  /** Create and connect one CosmosElementVideoEmbed document */
  create?: InputMaybe<CosmosElementVideoEmbedCreateInput>;
  /** Delete currently connected CosmosElementVideoEmbed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosElementVideoEmbed document */
  update?: InputMaybe<CosmosElementVideoEmbedUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosElementVideoEmbed document */
  upsert?: InputMaybe<CosmosElementVideoEmbedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosElementVideoEmbedUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosElementVideoEmbedUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementVideoEmbedWhereUniqueInput;
};

export type CosmosElementVideoEmbedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosElementVideoEmbedUpdateInput;
  /** Unique document search */
  where: CosmosElementVideoEmbedWhereUniqueInput;
};

export type CosmosElementVideoEmbedUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosElementVideoEmbedCreateInput;
  /** Update document if it exists */
  update: CosmosElementVideoEmbedUpdateInput;
};

export type CosmosElementVideoEmbedUpsertLocalizationInput = {
  create: CosmosElementVideoEmbedCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosElementVideoEmbedUpdateLocalizationDataInput;
};

export type CosmosElementVideoEmbedUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosElementVideoEmbedUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosElementVideoEmbedWhereUniqueInput;
};

export type CosmosElementVideoEmbedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosElementVideoEmbedUpsertInput;
  /** Unique document search */
  where: CosmosElementVideoEmbedWhereUniqueInput;
};

/** Identifies documents */
export type CosmosElementVideoEmbedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosElementVideoEmbedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosElementVideoEmbedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosElementVideoEmbedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  attribution_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  attribution_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  attribution_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  attribution_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  attribution_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  attribution_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  attribution_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  attribution_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  attribution_starts_with?: InputMaybe<Scalars['String']['input']>;
  disableOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframeSrc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeSrc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeSrc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeSrc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeSrc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeSrc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeSrc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeSrc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeSrc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeSrc_starts_with?: InputMaybe<Scalars['String']['input']>;
  overlayImage?: InputMaybe<AssetWhereInput>;
  playButtonAriaLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  playButtonAriaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  playButtonAriaLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  playButtonAriaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  playButtonAriaLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  playButtonAriaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  playButtonAriaLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  playButtonAriaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  playButtonAriaLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  playButtonAriaLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosElementVideoEmbed record uniquely */
export type CosmosElementVideoEmbedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CosmosEnumApplicationFamily {
  EpicGamesStore = 'epic_games_store',
  Fortnite = 'fortnite',
  Metahuman = 'metahuman',
  OnlineServices = 'online_services',
  Realityscan = 'realityscan',
  Twinmotion = 'twinmotion',
  UnrealEngine = 'unreal_engine'
}

export enum CosmosEnumAvatarColors {
  Amber = 'amber',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Gray = 'gray',
  Green = 'green',
  Indigo = 'indigo',
  Lime = 'lime',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  Yellow = 'yellow'
}

export enum CosmosEnumBlobTableVariants {
  Blobs = 'blobs',
  CollectionBlobs = 'collectionBlobs'
}

/** The maximum cards to put on a row of BlogCards Section */
export enum CosmosEnumBlogCardsMaxSize {
  Four = 'four',
  Three = 'three',
  Two = 'two'
}

export enum CosmosEnumButtonIcons {
  ArrowDownToBracket = 'ArrowDownToBracket',
  ArrowRight = 'ArrowRight',
  ArrowRightCircleFilled = 'ArrowRightCircleFilled',
  ArrowUpRightFromSquare = 'ArrowUpRightFromSquare',
  BellBadge = 'BellBadge',
  Calendar = 'Calendar',
  ChevronDown = 'ChevronDown',
  ChevronRight = 'ChevronRight',
  Envelope = 'Envelope',
  EpicGames = 'EpicGames',
  Metahuman = 'Metahuman',
  Play = 'Play',
  RealityCapture = 'RealityCapture',
  RealityScan = 'RealityScan',
  ShoppingCart = 'ShoppingCart',
  TalkBubble = 'TalkBubble',
  Twinmotion = 'Twinmotion',
  UnrealEngine = 'UnrealEngine',
  UserPlus = 'UserPlus'
}

export enum CosmosEnumButtonVariants {
  Critical = 'critical',
  Ghost = 'ghost',
  GhostUnderline = 'ghostUnderline',
  Outline = 'outline',
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum CosmosEnumCheckListIcons {
  Check = 'check',
  Dot = 'dot'
}

export enum CosmosEnumComplexCtaVariant {
  FourColumns = 'FourColumns',
  ThreeColumns = 'ThreeColumns'
}

export enum CosmosEnumCountryCodes {
  By = 'BY',
  Ca = 'CA',
  Cn = 'CN',
  Ru = 'RU',
  Se = 'SE',
  Uk = 'UK',
  Us = 'US'
}

export enum CosmosEnumDirectoryVariant {
  GoldInstructors = 'GoldInstructors',
  ServicePartners = 'ServicePartners',
  TrainingPartners = 'TrainingPartners'
}

export enum CosmosEnumEdsBackgroundColors {
  Default = 'Default',
  ElevatedLowDefault = 'ElevatedLowDefault'
}

export enum CosmosEnumEdsGradients {
  Amber = 'amber',
  Blue = 'blue',
  Cyan = 'cyan',
  Green = 'green',
  Indigo = 'indigo',
  Lime = 'lime',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  Yellow = 'yellow'
}

export enum CosmosEnumFaqButtonsPosition {
  BottomLeft = 'bottomLeft',
  TopRight = 'topRight'
}

/** Gemini Cards Variants, check docs for more examples. */
export enum CosmosEnumGeminiVariants {
  FourUp = 'four_up',
  ThreeUp = 'three_up',
  TwoUp = 'two_up'
}

export enum CosmosEnumHeroAlphaVariants {
  Blurred = 'blurred',
  Fullwidth = 'fullwidth'
}

export enum CosmosEnumIconPosition {
  End = 'end',
  Start = 'start'
}

export enum CosmosEnumLatestNewsVariants {
  Large5 = 'large5',
  Medium3 = 'medium3',
  Medium4Up = 'medium4Up',
  MediumFlipFeatured10 = 'mediumFlipFeatured10',
  Small2 = 'small2',
  Small3 = 'small3',
  Small4 = 'small4'
}

export enum CosmosEnumLearnPostType {
  Course = 'course',
  LearningPath = 'learning_path',
  Post = 'post'
}

export enum CosmosEnumLearnTabs {
  Animation = 'animation',
  Architecture = 'architecture',
  FilmAndTv = 'film_and_tv',
  Games = 'games',
  Simulation = 'simulation',
  UnrealEditorForFortnite = 'unreal_editor_for_fortnite',
  VirtualProduction = 'virtual_production',
  Visualization = 'visualization'
}

export enum CosmosEnumLinkIcons {
  ArrowRight = 'ArrowRight',
  ArrowRightCircleFilled = 'ArrowRightCircleFilled',
  ChevronRight = 'ChevronRight'
}

/** Background animation for blurred RefSections */
export enum CosmosEnumLottieAnimation {
  FivePlanetsBlueGreen_6c = 'FivePlanets_BlueGreen_6c',
  FivePlanetsOrangeYellow_6d = 'FivePlanets_OrangeYellow_6d',
  FivePlanetsPinkPeach_6b = 'FivePlanets_PinkPeach_6b',
  FivePlanetsPurpleBlueGreen_6a = 'FivePlanets_PurpleBlueGreen_6a',
  MoonStarBlueGreen_9c = 'MoonStar_BlueGreen_9c',
  MoonStarOrangeYellow_9d = 'MoonStar_OrangeYellow_9d',
  MoonStarPinkPeach_9b = 'MoonStar_PinkPeach_9b',
  MoonStarPurpleBlueGreen_9a = 'MoonStar_PurpleBlueGreen_9a',
  StarCloverBlueGreen_7c = 'StarClover_BlueGreen_7c',
  StarCloverOrangeYellow_7d = 'StarClover_OrangeYellow_7d',
  StarCloverPinkPeach_7b = 'StarClover_PinkPeach_7b',
  StarCloverPurpleBlueGreen_7a = 'StarClover_PurpleBlueGreen_7a',
  SunMoonBlueGreen_8c = 'SunMoon_BlueGreen_8c',
  SunMoonOrangeYellow_8d = 'SunMoon_OrangeYellow_8d',
  SunMoonPinkPeach_8b = 'SunMoon_PinkPeach_8b',
  SunMoonPurpleBlueGreen_8a = 'SunMoon_PurpleBlueGreen_8a'
}

export enum CosmosEnumMaterialCardBackground {
  Dark = 'dark',
  Default = 'default',
  Light = 'light'
}

export enum CosmosEnumNumberCalloutVariants {
  ContentLargeImage = 'contentLargeImage',
  CountdownDaysHoursMinutes = 'countdownDaysHoursMinutes',
  EpicJobsAndOffices = 'epicJobsAndOffices'
}

export enum CosmosEnumOperatingSystems {
  Linux = 'linux',
  Macos = 'macos',
  Windows = 'windows'
}

export enum CosmosEnumResellerContinents {
  Africa = 'africa',
  Asia = 'asia',
  Australia = 'australia',
  Europe = 'europe',
  NorthAmerica = 'northAmerica',
  SouthAmerica = 'southAmerica'
}

/** Sets the section or component width. */
export enum CosmosEnumSectionSizes {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm'
}

/** Simple - Dark background + gradient anchors, Colorful - Gradient background + contrast anchors */
export enum CosmosEnumSimpleCtaStyle {
  Colorful = 'colorful',
  Simple = 'simple'
}

/** centered - one column centered, leftToRight - left oriented, twoColumn - two columns in desktop mode (md+) left-bottom oriented */
export enum CosmosEnumSimpleCtaVariant {
  Centered = 'centered',
  LeftToRight = 'leftToRight',
  TwoColumn = 'twoColumn'
}

export enum CosmosEnumTimeAndDateFormat {
  MonthDay = 'MonthDay',
  MonthDayYear = 'MonthDayYear',
  MonthYear = 'MonthYear',
  WeekdayMonthDayTimeTimeZone = 'WeekdayMonthDayTimeTimeZone',
  WeekdayMonthDayYearTimeTimeZone = 'WeekdayMonthDayYearTimeTimeZone'
}

export enum CosmosEnumTimeZone {
  AmericaAnchorage = 'America_Anchorage',
  AmericaBuenosAires = 'America_Buenos_Aires',
  AmericaChicago = 'America_Chicago',
  AmericaDenver = 'America_Denver',
  AmericaHalifax = 'America_Halifax',
  AmericaLosAngeles = 'America_Los_Angeles',
  AmericaNewYork = 'America_New_York',
  AmericaNoronha = 'America_Noronha',
  AsiaBangkok = 'Asia_Bangkok',
  AsiaDhaka = 'Asia_Dhaka',
  AsiaDubai = 'Asia_Dubai',
  AsiaKarachi = 'Asia_Karachi',
  AsiaShanghai = 'Asia_Shanghai',
  AsiaTokyo = 'Asia_Tokyo',
  AtlanticAzores = 'Atlantic_Azores',
  AustraliaSydney = 'Australia_Sydney',
  EtcGmtPlus_12 = 'Etc_GMT_plus_12',
  EuropeAthens = 'Europe_Athens',
  EuropeMoscow = 'Europe_Moscow',
  EuropeParis = 'Europe_Paris',
  PacificAuckland = 'Pacific_Auckland',
  PacificHonolulu = 'Pacific_Honolulu',
  PacificKiritimati = 'Pacific_Kiritimati',
  PacificNoumea = 'Pacific_Noumea',
  PacificPagoPago = 'Pacific_Pago_Pago',
  PacificTongatapu = 'Pacific_Tongatapu',
  Utc = 'UTC'
}

export enum CosmosEnumUserProfileVariant {
  Avatar = 'avatar',
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export type CosmosFeedBlogCard = Entity & Node & {
  __typename?: 'CosmosFeedBlogCard';
  blogConfig?: Maybe<CosmosConfigBlog>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosFeedBlogCard>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CosmosFeedBlogCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosFeedBlogCard>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosFeedBlogCardBlogConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosFeedBlogCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosFeedBlogCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosFeedBlogCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosFeedBlogCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosFeedBlogCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosFeedBlogCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosFeedBlogCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosFeedBlogCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosFeedBlogCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosFeedBlogCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosFeedBlogCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosFeedBlogCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosFeedBlogCardConnection = {
  __typename?: 'CosmosFeedBlogCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosFeedBlogCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosFeedBlogCardCreateInput = {
  blogConfig?: InputMaybe<CosmosConfigBlogCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosFeedBlogCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosFeedBlogCardCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosFeedBlogCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosFeedBlogCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosFeedBlogCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosFeedBlogCardCreateLocalizationInput>>;
};

export type CosmosFeedBlogCardCreateManyInlineInput = {
  /** Connect multiple existing CosmosFeedBlogCard documents */
  connect?: InputMaybe<Array<CosmosFeedBlogCardWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosFeedBlogCard documents */
  create?: InputMaybe<Array<CosmosFeedBlogCardCreateInput>>;
};

export type CosmosFeedBlogCardCreateOneInlineInput = {
  /** Connect one existing CosmosFeedBlogCard document */
  connect?: InputMaybe<CosmosFeedBlogCardWhereUniqueInput>;
  /** Create and connect one CosmosFeedBlogCard document */
  create?: InputMaybe<CosmosFeedBlogCardCreateInput>;
};

/** An edge in a connection. */
export type CosmosFeedBlogCardEdge = {
  __typename?: 'CosmosFeedBlogCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosFeedBlogCard;
};

/** Identifies documents */
export type CosmosFeedBlogCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosFeedBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosFeedBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosFeedBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blogConfig?: InputMaybe<CosmosConfigBlogWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosFeedBlogCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosFeedBlogCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosFeedBlogCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosFeedBlogCardOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosFeedBlogCardUpdateInput = {
  blogConfig?: InputMaybe<CosmosConfigBlogUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosFeedBlogCardUpdateLocalizationsInput>;
};

export type CosmosFeedBlogCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosFeedBlogCardUpdateLocalizationInput = {
  data: CosmosFeedBlogCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosFeedBlogCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosFeedBlogCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosFeedBlogCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosFeedBlogCardUpsertLocalizationInput>>;
};

export type CosmosFeedBlogCardUpdateManyInlineInput = {
  /** Connect multiple existing CosmosFeedBlogCard documents */
  connect?: InputMaybe<Array<CosmosFeedBlogCardConnectInput>>;
  /** Create and connect multiple CosmosFeedBlogCard documents */
  create?: InputMaybe<Array<CosmosFeedBlogCardCreateInput>>;
  /** Delete multiple CosmosFeedBlogCard documents */
  delete?: InputMaybe<Array<CosmosFeedBlogCardWhereUniqueInput>>;
  /** Disconnect multiple CosmosFeedBlogCard documents */
  disconnect?: InputMaybe<Array<CosmosFeedBlogCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosFeedBlogCard documents */
  set?: InputMaybe<Array<CosmosFeedBlogCardWhereUniqueInput>>;
  /** Update multiple CosmosFeedBlogCard documents */
  update?: InputMaybe<Array<CosmosFeedBlogCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosFeedBlogCard documents */
  upsert?: InputMaybe<Array<CosmosFeedBlogCardUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosFeedBlogCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosFeedBlogCardUpdateManyLocalizationsInput>;
};

export type CosmosFeedBlogCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosFeedBlogCardUpdateManyLocalizationInput = {
  data: CosmosFeedBlogCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosFeedBlogCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosFeedBlogCardUpdateManyLocalizationInput>>;
};

export type CosmosFeedBlogCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosFeedBlogCardUpdateManyInput;
  /** Document search */
  where: CosmosFeedBlogCardWhereInput;
};

export type CosmosFeedBlogCardUpdateOneInlineInput = {
  /** Connect existing CosmosFeedBlogCard document */
  connect?: InputMaybe<CosmosFeedBlogCardWhereUniqueInput>;
  /** Create and connect one CosmosFeedBlogCard document */
  create?: InputMaybe<CosmosFeedBlogCardCreateInput>;
  /** Delete currently connected CosmosFeedBlogCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosFeedBlogCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosFeedBlogCard document */
  update?: InputMaybe<CosmosFeedBlogCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosFeedBlogCard document */
  upsert?: InputMaybe<CosmosFeedBlogCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosFeedBlogCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosFeedBlogCardUpdateInput;
  /** Unique document search */
  where: CosmosFeedBlogCardWhereUniqueInput;
};

export type CosmosFeedBlogCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosFeedBlogCardCreateInput;
  /** Update document if it exists */
  update: CosmosFeedBlogCardUpdateInput;
};

export type CosmosFeedBlogCardUpsertLocalizationInput = {
  create: CosmosFeedBlogCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosFeedBlogCardUpdateLocalizationDataInput;
};

export type CosmosFeedBlogCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosFeedBlogCardUpsertInput;
  /** Unique document search */
  where: CosmosFeedBlogCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosFeedBlogCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosFeedBlogCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosFeedBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosFeedBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosFeedBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blogConfig?: InputMaybe<CosmosConfigBlogWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosFeedBlogCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosFeedBlogCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosFeedBlogCardWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosFeedBlogCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosFeedBlogCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosFeedBlogCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosFeedBlogCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosFeedBlogCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosFeedBlogCard record uniquely */
export type CosmosFeedBlogCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosHeroAlpha = Entity & {
  __typename?: 'CosmosHeroAlpha';
  blurredImage?: Maybe<Asset>;
  /** Basic button array. Overridden if modular button array is specified. */
  buttons: Array<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Optional gradient to use in the title <a> tags */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The primary image/video asset displayed in the hero. */
  heroAsset?: Maybe<Asset>;
  heroImageLabel?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosHeroAlpha>;
  logoImage?: Maybe<Asset>;
  /** Array of button components */
  modButtons: Array<CosmosHeroAlphamodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant?: Maybe<CosmosEnumHeroAlphaVariants>;
};


export type CosmosHeroAlphaBlurredImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroAlphaButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosHeroAlphaHeroAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroAlphaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosHeroAlphaLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroAlphaModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosHeroAlphaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosHeroAlphaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosHeroAlphaWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosHeroAlphaConnection = {
  __typename?: 'CosmosHeroAlphaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosHeroAlphaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosHeroAlphaCreateInput = {
  blurredImage?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  heroAsset?: InputMaybe<AssetCreateOneInlineInput>;
  /** heroImageLabel input for default locale (en) */
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosHeroAlphaCreateLocalizationsInput>;
  logoImage?: InputMaybe<AssetCreateOneInlineInput>;
  modButtons?: InputMaybe<CosmosHeroAlphamodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumHeroAlphaVariants>;
};

export type CosmosHeroAlphaCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroAlphaCreateLocalizationInput = {
  /** Localization input */
  data: CosmosHeroAlphaCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroAlphaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosHeroAlphaCreateLocalizationInput>>;
};

export type CosmosHeroAlphaCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroAlpha documents */
  create?: InputMaybe<Array<CosmosHeroAlphaCreateInput>>;
};

export type CosmosHeroAlphaCreateOneInlineInput = {
  /** Create and connect one CosmosHeroAlpha document */
  create?: InputMaybe<CosmosHeroAlphaCreateInput>;
};

export type CosmosHeroAlphaCreateWithPositionInput = {
  /** Document to create */
  data: CosmosHeroAlphaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosHeroAlphaEdge = {
  __typename?: 'CosmosHeroAlphaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosHeroAlpha;
};

/** Identifies documents */
export type CosmosHeroAlphaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroAlphaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroAlphaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroAlphaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  heroAsset?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosHeroAlphamodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumHeroAlphaVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumHeroAlphaVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumHeroAlphaVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumHeroAlphaVariants>>>;
};

export enum CosmosHeroAlphaOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  HeroImageLabelAsc = 'heroImageLabel_ASC',
  HeroImageLabelDesc = 'heroImageLabel_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosHeroAlphaParent = CosmosPageAgreement | CosmosPageBlogDetail | CosmosPageDirectory | CosmosPageHeroAndSection | CosmosPageLegalContent | CosmosPagePluginDetail | CosmosPageResearch;

export type CosmosHeroAlphaParentConnectInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryConnectInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionConnectInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
};

export type CosmosHeroAlphaParentCreateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryCreateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
};

export type CosmosHeroAlphaParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosHeroAlphaParent documents */
  connect?: InputMaybe<Array<CosmosHeroAlphaParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosHeroAlphaParent documents */
  create?: InputMaybe<Array<CosmosHeroAlphaParentCreateInput>>;
};

export type CosmosHeroAlphaParentCreateOneInlineInput = {
  /** Connect one existing CosmosHeroAlphaParent document */
  connect?: InputMaybe<CosmosHeroAlphaParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroAlphaParent document */
  create?: InputMaybe<CosmosHeroAlphaParentCreateInput>;
};

export type CosmosHeroAlphaParentUpdateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
};

export type CosmosHeroAlphaParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosHeroAlphaParent documents */
  connect?: InputMaybe<Array<CosmosHeroAlphaParentConnectInput>>;
  /** Create and connect multiple CosmosHeroAlphaParent documents */
  create?: InputMaybe<Array<CosmosHeroAlphaParentCreateInput>>;
  /** Delete multiple CosmosHeroAlphaParent documents */
  delete?: InputMaybe<Array<CosmosHeroAlphaParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosHeroAlphaParent documents */
  disconnect?: InputMaybe<Array<CosmosHeroAlphaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosHeroAlphaParent documents */
  set?: InputMaybe<Array<CosmosHeroAlphaParentWhereUniqueInput>>;
  /** Update multiple CosmosHeroAlphaParent documents */
  update?: InputMaybe<Array<CosmosHeroAlphaParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosHeroAlphaParent documents */
  upsert?: InputMaybe<Array<CosmosHeroAlphaParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosHeroAlphaParentUpdateManyWithNestedWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateManyWithNestedWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateManyWithNestedWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroAlphaParentUpdateOneInlineInput = {
  /** Connect existing CosmosHeroAlphaParent document */
  connect?: InputMaybe<CosmosHeroAlphaParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroAlphaParent document */
  create?: InputMaybe<CosmosHeroAlphaParentCreateInput>;
  /** Delete currently connected CosmosHeroAlphaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosHeroAlphaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroAlphaParent document */
  update?: InputMaybe<CosmosHeroAlphaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroAlphaParent document */
  upsert?: InputMaybe<CosmosHeroAlphaParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphaParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphaParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphaParentWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
};

export type CosmosHeroAlphaParentWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
};

export type CosmosHeroAlphaUpdateInput = {
  blurredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  heroAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** heroImageLabel input for default locale (en) */
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosHeroAlphaUpdateLocalizationsInput>;
  logoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  modButtons?: InputMaybe<CosmosHeroAlphamodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  variant?: InputMaybe<CosmosEnumHeroAlphaVariants>;
};

export type CosmosHeroAlphaUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroAlphaUpdateLocalizationInput = {
  data: CosmosHeroAlphaUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroAlphaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosHeroAlphaCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroAlphaUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosHeroAlphaUpsertLocalizationInput>>;
};

export type CosmosHeroAlphaUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroAlpha component instances */
  create?: InputMaybe<Array<CosmosHeroAlphaCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroAlpha documents */
  delete?: InputMaybe<Array<CosmosHeroAlphaWhereUniqueInput>>;
  /** Update multiple CosmosHeroAlpha component instances */
  update?: InputMaybe<Array<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroAlpha component instances */
  upsert?: InputMaybe<Array<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroAlphaUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** heroImageLabel input for default locale (en) */
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosHeroAlphaUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  variant?: InputMaybe<CosmosEnumHeroAlphaVariants>;
};

export type CosmosHeroAlphaUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroAlphaUpdateManyLocalizationInput = {
  data: CosmosHeroAlphaUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroAlphaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroAlphaUpdateManyLocalizationInput>>;
};

export type CosmosHeroAlphaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosHeroAlphaUpdateManyInput;
  /** Document search */
  where: CosmosHeroAlphaWhereInput;
};

export type CosmosHeroAlphaUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroAlpha document */
  create?: InputMaybe<CosmosHeroAlphaCreateInput>;
  /** Delete currently connected CosmosHeroAlpha document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroAlpha document */
  update?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroAlpha document */
  upsert?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroAlphaWhereUniqueInput;
};

export type CosmosHeroAlphaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosHeroAlphaUpdateInput;
  /** Unique document search */
  where: CosmosHeroAlphaWhereUniqueInput;
};

export type CosmosHeroAlphaUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosHeroAlphaCreateInput;
  /** Update document if it exists */
  update: CosmosHeroAlphaUpdateInput;
};

export type CosmosHeroAlphaUpsertLocalizationInput = {
  create: CosmosHeroAlphaCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosHeroAlphaUpdateLocalizationDataInput;
};

export type CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosHeroAlphaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroAlphaWhereUniqueInput;
};

export type CosmosHeroAlphaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosHeroAlphaUpsertInput;
  /** Unique document search */
  where: CosmosHeroAlphaWhereUniqueInput;
};

/** Identifies documents */
export type CosmosHeroAlphaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroAlphaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroAlphaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroAlphaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  heroAsset?: InputMaybe<AssetWhereInput>;
  heroImageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heroImageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heroImageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heroImageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heroImageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heroImageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heroImageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heroImageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heroImageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heroImageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosHeroAlphamodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumHeroAlphaVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumHeroAlphaVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumHeroAlphaVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumHeroAlphaVariants>>>;
};

/** References CosmosHeroAlpha record uniquely */
export type CosmosHeroAlphaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosHeroAlphamodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosHeroAlphamodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosHeroAlphamodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosHeroAlphamodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroAlphamodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosHeroAlphamodButtonsUnionCreateInput>>;
};

export type CosmosHeroAlphamodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosHeroAlphamodButtonsUnion document */
  create?: InputMaybe<CosmosHeroAlphamodButtonsUnionCreateInput>;
};

export type CosmosHeroAlphamodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroAlphamodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosHeroAlphamodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroAlphamodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosHeroAlphamodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosHeroAlphamodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosHeroAlphamodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroAlphamodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosHeroAlphamodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroAlphamodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroAlphamodButtonsUnion document */
  create?: InputMaybe<CosmosHeroAlphamodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosHeroAlphamodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroAlphamodButtonsUnion document */
  update?: InputMaybe<CosmosHeroAlphamodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroAlphamodButtonsUnion document */
  upsert?: InputMaybe<CosmosHeroAlphamodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosHeroAlphamodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroAlphamodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosHeroAlphamodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosHeroArticleImage = Entity & {
  __typename?: 'CosmosHeroArticleImage';
  /** Header image or video asset rendered below the title and tags. */
  asset?: Maybe<Asset>;
  /** Full width image or video in the background at the top of the page. */
  backgroundAsset?: Maybe<Asset>;
  /** Basic button array. Overridden if modular button array is specified. */
  buttons: Array<CosmosElementButton>;
  caption?: Maybe<Scalars['String']['output']>;
  /** Article short description */
  description?: Maybe<RichText>;
  /** Optional gradient to use in the title <a> tags */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosHeroArticleImage>;
  /** Array of button components */
  modButtons: Array<CosmosHeroArticleImagemodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  /** Article title */
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosHeroArticleImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroArticleImageBackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroArticleImageButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosHeroArticleImageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosHeroArticleImageModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosHeroArticleImageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosHeroArticleImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosHeroArticleImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosHeroArticleImageConnection = {
  __typename?: 'CosmosHeroArticleImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosHeroArticleImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosHeroArticleImageCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosHeroArticleImageCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroArticleImageCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroArticleImageCreateLocalizationInput = {
  /** Localization input */
  data: CosmosHeroArticleImageCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroArticleImageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosHeroArticleImageCreateLocalizationInput>>;
};

export type CosmosHeroArticleImageCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroArticleImage documents */
  create?: InputMaybe<Array<CosmosHeroArticleImageCreateInput>>;
};

export type CosmosHeroArticleImageCreateOneInlineInput = {
  /** Create and connect one CosmosHeroArticleImage document */
  create?: InputMaybe<CosmosHeroArticleImageCreateInput>;
};

export type CosmosHeroArticleImageCreateWithPositionInput = {
  /** Document to create */
  data: CosmosHeroArticleImageCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosHeroArticleImageEdge = {
  __typename?: 'CosmosHeroArticleImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosHeroArticleImage;
};

/** Identifies documents */
export type CosmosHeroArticleImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroArticleImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroArticleImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroArticleImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  backgroundAsset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosHeroArticleImageOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosHeroArticleImageParent = CosmosPageAgreement | CosmosPageBlogDetail | CosmosPageDirectory | CosmosPageHeroAndSection | CosmosPageLegalContent | CosmosPagePluginDetail | CosmosPageResearch;

export type CosmosHeroArticleImageParentConnectInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryConnectInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionConnectInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
};

export type CosmosHeroArticleImageParentCreateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryCreateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
};

export type CosmosHeroArticleImageParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosHeroArticleImageParent documents */
  connect?: InputMaybe<Array<CosmosHeroArticleImageParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosHeroArticleImageParent documents */
  create?: InputMaybe<Array<CosmosHeroArticleImageParentCreateInput>>;
};

export type CosmosHeroArticleImageParentCreateOneInlineInput = {
  /** Connect one existing CosmosHeroArticleImageParent document */
  connect?: InputMaybe<CosmosHeroArticleImageParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroArticleImageParent document */
  create?: InputMaybe<CosmosHeroArticleImageParentCreateInput>;
};

export type CosmosHeroArticleImageParentUpdateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
};

export type CosmosHeroArticleImageParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosHeroArticleImageParent documents */
  connect?: InputMaybe<Array<CosmosHeroArticleImageParentConnectInput>>;
  /** Create and connect multiple CosmosHeroArticleImageParent documents */
  create?: InputMaybe<Array<CosmosHeroArticleImageParentCreateInput>>;
  /** Delete multiple CosmosHeroArticleImageParent documents */
  delete?: InputMaybe<Array<CosmosHeroArticleImageParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosHeroArticleImageParent documents */
  disconnect?: InputMaybe<Array<CosmosHeroArticleImageParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosHeroArticleImageParent documents */
  set?: InputMaybe<Array<CosmosHeroArticleImageParentWhereUniqueInput>>;
  /** Update multiple CosmosHeroArticleImageParent documents */
  update?: InputMaybe<Array<CosmosHeroArticleImageParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosHeroArticleImageParent documents */
  upsert?: InputMaybe<Array<CosmosHeroArticleImageParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosHeroArticleImageParentUpdateManyWithNestedWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateManyWithNestedWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateManyWithNestedWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroArticleImageParentUpdateOneInlineInput = {
  /** Connect existing CosmosHeroArticleImageParent document */
  connect?: InputMaybe<CosmosHeroArticleImageParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroArticleImageParent document */
  create?: InputMaybe<CosmosHeroArticleImageParentCreateInput>;
  /** Delete currently connected CosmosHeroArticleImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosHeroArticleImageParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroArticleImageParent document */
  update?: InputMaybe<CosmosHeroArticleImageParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroArticleImageParent document */
  upsert?: InputMaybe<CosmosHeroArticleImageParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImageParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImageParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImageParentWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
};

export type CosmosHeroArticleImageParentWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
};

export type CosmosHeroArticleImageUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosHeroArticleImageUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroArticleImageUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroArticleImageUpdateLocalizationInput = {
  data: CosmosHeroArticleImageUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroArticleImageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosHeroArticleImageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroArticleImageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosHeroArticleImageUpsertLocalizationInput>>;
};

export type CosmosHeroArticleImageUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroArticleImage component instances */
  create?: InputMaybe<Array<CosmosHeroArticleImageCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroArticleImage documents */
  delete?: InputMaybe<Array<CosmosHeroArticleImageWhereUniqueInput>>;
  /** Update multiple CosmosHeroArticleImage component instances */
  update?: InputMaybe<Array<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroArticleImage component instances */
  upsert?: InputMaybe<Array<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroArticleImageUpdateManyInput = {
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosHeroArticleImageUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroArticleImageUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroArticleImageUpdateManyLocalizationInput = {
  data: CosmosHeroArticleImageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroArticleImageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroArticleImageUpdateManyLocalizationInput>>;
};

export type CosmosHeroArticleImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosHeroArticleImageUpdateManyInput;
  /** Document search */
  where: CosmosHeroArticleImageWhereInput;
};

export type CosmosHeroArticleImageUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroArticleImage document */
  create?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  /** Delete currently connected CosmosHeroArticleImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroArticleImage document */
  update?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroArticleImage document */
  upsert?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroArticleImageWhereUniqueInput;
};

export type CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosHeroArticleImageUpdateInput;
  /** Unique document search */
  where: CosmosHeroArticleImageWhereUniqueInput;
};

export type CosmosHeroArticleImageUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosHeroArticleImageCreateInput;
  /** Update document if it exists */
  update: CosmosHeroArticleImageUpdateInput;
};

export type CosmosHeroArticleImageUpsertLocalizationInput = {
  create: CosmosHeroArticleImageCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosHeroArticleImageUpdateLocalizationDataInput;
};

export type CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosHeroArticleImageUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroArticleImageWhereUniqueInput;
};

export type CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosHeroArticleImageUpsertInput;
  /** Unique document search */
  where: CosmosHeroArticleImageWhereUniqueInput;
};

/** Identifies documents */
export type CosmosHeroArticleImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroArticleImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroArticleImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroArticleImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  backgroundAsset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosHeroArticleImage record uniquely */
export type CosmosHeroArticleImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosHeroArticleImagemodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosHeroArticleImagemodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroArticleImagemodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosHeroArticleImagemodButtonsUnionCreateInput>>;
};

export type CosmosHeroArticleImagemodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosHeroArticleImagemodButtonsUnion document */
  create?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionCreateInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroArticleImagemodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosHeroArticleImagemodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroArticleImagemodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosHeroArticleImagemodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosHeroArticleImagemodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosHeroArticleImagemodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroArticleImagemodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosHeroArticleImagemodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroArticleImagemodButtonsUnion document */
  create?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosHeroArticleImagemodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroArticleImagemodButtonsUnion document */
  update?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroArticleImagemodButtonsUnion document */
  upsert?: InputMaybe<CosmosHeroArticleImagemodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosHeroArticleImagemodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosHeroBravo = Entity & {
  __typename?: 'CosmosHeroBravo';
  backgroundAsset?: Maybe<Asset>;
  /** Basic button array. Overridden if modular button array is specified. */
  buttons: Array<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** Optional gradient to use in the title <a> tags */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosHeroBravo>;
  /** Array of button components */
  modButtons: Array<CosmosHeroBravomodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosHeroBravoBackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroBravoButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosHeroBravoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosHeroBravoModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosHeroBravoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosHeroBravoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosHeroBravoWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosHeroBravoConnection = {
  __typename?: 'CosmosHeroBravoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosHeroBravoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosHeroBravoCreateInput = {
  backgroundAsset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosHeroBravoCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosHeroBravomodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroBravoCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroBravoCreateLocalizationInput = {
  /** Localization input */
  data: CosmosHeroBravoCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroBravoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosHeroBravoCreateLocalizationInput>>;
};

export type CosmosHeroBravoCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroBravo documents */
  create?: InputMaybe<Array<CosmosHeroBravoCreateInput>>;
};

export type CosmosHeroBravoCreateOneInlineInput = {
  /** Create and connect one CosmosHeroBravo document */
  create?: InputMaybe<CosmosHeroBravoCreateInput>;
};

export type CosmosHeroBravoCreateWithPositionInput = {
  /** Document to create */
  data: CosmosHeroBravoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosHeroBravoEdge = {
  __typename?: 'CosmosHeroBravoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosHeroBravo;
};

/** Identifies documents */
export type CosmosHeroBravoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroBravoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroBravoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroBravoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundAsset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosHeroBravomodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosHeroBravoOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosHeroBravoParent = CosmosPageAgreement | CosmosPageBlogDetail | CosmosPageDirectory | CosmosPageHeroAndSection | CosmosPageLegalContent | CosmosPagePluginDetail | CosmosPageResearch;

export type CosmosHeroBravoParentConnectInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryConnectInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionConnectInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
};

export type CosmosHeroBravoParentCreateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryCreateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
};

export type CosmosHeroBravoParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosHeroBravoParent documents */
  connect?: InputMaybe<Array<CosmosHeroBravoParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosHeroBravoParent documents */
  create?: InputMaybe<Array<CosmosHeroBravoParentCreateInput>>;
};

export type CosmosHeroBravoParentCreateOneInlineInput = {
  /** Connect one existing CosmosHeroBravoParent document */
  connect?: InputMaybe<CosmosHeroBravoParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroBravoParent document */
  create?: InputMaybe<CosmosHeroBravoParentCreateInput>;
};

export type CosmosHeroBravoParentUpdateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
};

export type CosmosHeroBravoParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosHeroBravoParent documents */
  connect?: InputMaybe<Array<CosmosHeroBravoParentConnectInput>>;
  /** Create and connect multiple CosmosHeroBravoParent documents */
  create?: InputMaybe<Array<CosmosHeroBravoParentCreateInput>>;
  /** Delete multiple CosmosHeroBravoParent documents */
  delete?: InputMaybe<Array<CosmosHeroBravoParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosHeroBravoParent documents */
  disconnect?: InputMaybe<Array<CosmosHeroBravoParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosHeroBravoParent documents */
  set?: InputMaybe<Array<CosmosHeroBravoParentWhereUniqueInput>>;
  /** Update multiple CosmosHeroBravoParent documents */
  update?: InputMaybe<Array<CosmosHeroBravoParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosHeroBravoParent documents */
  upsert?: InputMaybe<Array<CosmosHeroBravoParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosHeroBravoParentUpdateManyWithNestedWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateManyWithNestedWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateManyWithNestedWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroBravoParentUpdateOneInlineInput = {
  /** Connect existing CosmosHeroBravoParent document */
  connect?: InputMaybe<CosmosHeroBravoParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroBravoParent document */
  create?: InputMaybe<CosmosHeroBravoParentCreateInput>;
  /** Delete currently connected CosmosHeroBravoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosHeroBravoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroBravoParent document */
  update?: InputMaybe<CosmosHeroBravoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroBravoParent document */
  upsert?: InputMaybe<CosmosHeroBravoParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravoParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravoParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravoParentWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
};

export type CosmosHeroBravoParentWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
};

export type CosmosHeroBravoUpdateInput = {
  backgroundAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosHeroBravoUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosHeroBravomodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroBravoUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroBravoUpdateLocalizationInput = {
  data: CosmosHeroBravoUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroBravoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosHeroBravoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroBravoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosHeroBravoUpsertLocalizationInput>>;
};

export type CosmosHeroBravoUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroBravo component instances */
  create?: InputMaybe<Array<CosmosHeroBravoCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroBravo documents */
  delete?: InputMaybe<Array<CosmosHeroBravoWhereUniqueInput>>;
  /** Update multiple CosmosHeroBravo component instances */
  update?: InputMaybe<Array<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroBravo component instances */
  upsert?: InputMaybe<Array<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroBravoUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosHeroBravoUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroBravoUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroBravoUpdateManyLocalizationInput = {
  data: CosmosHeroBravoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroBravoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroBravoUpdateManyLocalizationInput>>;
};

export type CosmosHeroBravoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosHeroBravoUpdateManyInput;
  /** Document search */
  where: CosmosHeroBravoWhereInput;
};

export type CosmosHeroBravoUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroBravo document */
  create?: InputMaybe<CosmosHeroBravoCreateInput>;
  /** Delete currently connected CosmosHeroBravo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroBravo document */
  update?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroBravo document */
  upsert?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosHeroBravoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroBravoWhereUniqueInput;
};

export type CosmosHeroBravoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosHeroBravoUpdateInput;
  /** Unique document search */
  where: CosmosHeroBravoWhereUniqueInput;
};

export type CosmosHeroBravoUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosHeroBravoCreateInput;
  /** Update document if it exists */
  update: CosmosHeroBravoUpdateInput;
};

export type CosmosHeroBravoUpsertLocalizationInput = {
  create: CosmosHeroBravoCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosHeroBravoUpdateLocalizationDataInput;
};

export type CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosHeroBravoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroBravoWhereUniqueInput;
};

export type CosmosHeroBravoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosHeroBravoUpsertInput;
  /** Unique document search */
  where: CosmosHeroBravoWhereUniqueInput;
};

/** Identifies documents */
export type CosmosHeroBravoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroBravoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroBravoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroBravoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundAsset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosHeroBravomodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosHeroBravo record uniquely */
export type CosmosHeroBravoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosHeroBravomodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosHeroBravomodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosHeroBravomodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosHeroBravomodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroBravomodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosHeroBravomodButtonsUnionCreateInput>>;
};

export type CosmosHeroBravomodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosHeroBravomodButtonsUnion document */
  create?: InputMaybe<CosmosHeroBravomodButtonsUnionCreateInput>;
};

export type CosmosHeroBravomodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosHeroBravomodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosHeroBravomodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroBravomodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosHeroBravomodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroBravomodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosHeroBravomodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosHeroBravomodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosHeroBravomodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroBravomodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosHeroBravomodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroBravomodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroBravomodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroBravomodButtonsUnion document */
  create?: InputMaybe<CosmosHeroBravomodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosHeroBravomodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroBravomodButtonsUnion document */
  update?: InputMaybe<CosmosHeroBravomodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroBravomodButtonsUnion document */
  upsert?: InputMaybe<CosmosHeroBravomodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravomodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosHeroBravomodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravomodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosHeroBravomodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroBravomodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosHeroBravomodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosHeroGlow = Entity & {
  __typename?: 'CosmosHeroGlow';
  /** The source image to blur for the glow effect. */
  blurredImage?: Maybe<Asset>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Optional gradient to use in the title <a> tags */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosHeroGlow>;
  /** Align the hero with the narrow content common on Blog Detail pages. */
  narrow?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosHeroGlowBlurredImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosHeroGlowLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosHeroGlowUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosHeroGlowConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosHeroGlowWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosHeroGlowConnection = {
  __typename?: 'CosmosHeroGlowConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosHeroGlowEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosHeroGlowCreateInput = {
  blurredImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosHeroGlowCreateLocalizationsInput>;
  narrow?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroGlowCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosHeroGlowCreateLocalizationInput = {
  /** Localization input */
  data: CosmosHeroGlowCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroGlowCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosHeroGlowCreateLocalizationInput>>;
};

export type CosmosHeroGlowCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosHeroGlow documents */
  create?: InputMaybe<Array<CosmosHeroGlowCreateInput>>;
};

export type CosmosHeroGlowCreateOneInlineInput = {
  /** Create and connect one CosmosHeroGlow document */
  create?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosHeroGlowCreateWithPositionInput = {
  /** Document to create */
  data: CosmosHeroGlowCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosHeroGlowEdge = {
  __typename?: 'CosmosHeroGlowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosHeroGlow;
};

/** Identifies documents */
export type CosmosHeroGlowManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroGlowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroGlowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroGlowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  narrow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  narrow_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosHeroGlowOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NarrowAsc = 'narrow_ASC',
  NarrowDesc = 'narrow_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosHeroGlowParent = CosmosPageAgreement | CosmosPageBlogDetail | CosmosPageDirectory | CosmosPageHeroAndSection | CosmosPageLegalContent | CosmosPageLicense | CosmosPagePluginDetail | CosmosPageResearch;

export type CosmosHeroGlowParentConnectInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryConnectInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionConnectInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
};

export type CosmosHeroGlowParentCreateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryCreateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
};

export type CosmosHeroGlowParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosHeroGlowParent documents */
  connect?: InputMaybe<Array<CosmosHeroGlowParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosHeroGlowParent documents */
  create?: InputMaybe<Array<CosmosHeroGlowParentCreateInput>>;
};

export type CosmosHeroGlowParentCreateOneInlineInput = {
  /** Connect one existing CosmosHeroGlowParent document */
  connect?: InputMaybe<CosmosHeroGlowParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroGlowParent document */
  create?: InputMaybe<CosmosHeroGlowParentCreateInput>;
};

export type CosmosHeroGlowParentUpdateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
};

export type CosmosHeroGlowParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosHeroGlowParent documents */
  connect?: InputMaybe<Array<CosmosHeroGlowParentConnectInput>>;
  /** Create and connect multiple CosmosHeroGlowParent documents */
  create?: InputMaybe<Array<CosmosHeroGlowParentCreateInput>>;
  /** Delete multiple CosmosHeroGlowParent documents */
  delete?: InputMaybe<Array<CosmosHeroGlowParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosHeroGlowParent documents */
  disconnect?: InputMaybe<Array<CosmosHeroGlowParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosHeroGlowParent documents */
  set?: InputMaybe<Array<CosmosHeroGlowParentWhereUniqueInput>>;
  /** Update multiple CosmosHeroGlowParent documents */
  update?: InputMaybe<Array<CosmosHeroGlowParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosHeroGlowParent documents */
  upsert?: InputMaybe<Array<CosmosHeroGlowParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosHeroGlowParentUpdateManyWithNestedWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateManyWithNestedWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateManyWithNestedWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
};

export type CosmosHeroGlowParentUpdateOneInlineInput = {
  /** Connect existing CosmosHeroGlowParent document */
  connect?: InputMaybe<CosmosHeroGlowParentWhereUniqueInput>;
  /** Create and connect one CosmosHeroGlowParent document */
  create?: InputMaybe<CosmosHeroGlowParentCreateInput>;
  /** Delete currently connected CosmosHeroGlowParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosHeroGlowParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroGlowParent document */
  update?: InputMaybe<CosmosHeroGlowParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroGlowParent document */
  upsert?: InputMaybe<CosmosHeroGlowParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroGlowParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosHeroGlowParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroGlowParentWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
};

export type CosmosHeroGlowParentWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
};

export type CosmosHeroGlowUpdateInput = {
  blurredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosHeroGlowUpdateLocalizationsInput>;
  narrow?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroGlowUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroGlowUpdateLocalizationInput = {
  data: CosmosHeroGlowUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroGlowUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosHeroGlowCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroGlowUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosHeroGlowUpsertLocalizationInput>>;
};

export type CosmosHeroGlowUpdateManyInlineInput = {
  /** Create and connect multiple CosmosHeroGlow component instances */
  create?: InputMaybe<Array<CosmosHeroGlowCreateWithPositionInput>>;
  /** Delete multiple CosmosHeroGlow documents */
  delete?: InputMaybe<Array<CosmosHeroGlowWhereUniqueInput>>;
  /** Update multiple CosmosHeroGlow component instances */
  update?: InputMaybe<Array<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosHeroGlow component instances */
  upsert?: InputMaybe<Array<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosHeroGlowUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosHeroGlowUpdateManyLocalizationsInput>;
  narrow?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroGlowUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosHeroGlowUpdateManyLocalizationInput = {
  data: CosmosHeroGlowUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosHeroGlowUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosHeroGlowUpdateManyLocalizationInput>>;
};

export type CosmosHeroGlowUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosHeroGlowUpdateManyInput;
  /** Document search */
  where: CosmosHeroGlowWhereInput;
};

export type CosmosHeroGlowUpdateOneInlineInput = {
  /** Create and connect one CosmosHeroGlow document */
  create?: InputMaybe<CosmosHeroGlowCreateInput>;
  /** Delete currently connected CosmosHeroGlow document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosHeroGlow document */
  update?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosHeroGlow document */
  upsert?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosHeroGlowUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroGlowWhereUniqueInput;
};

export type CosmosHeroGlowUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosHeroGlowUpdateInput;
  /** Unique document search */
  where: CosmosHeroGlowWhereUniqueInput;
};

export type CosmosHeroGlowUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosHeroGlowCreateInput;
  /** Update document if it exists */
  update: CosmosHeroGlowUpdateInput;
};

export type CosmosHeroGlowUpsertLocalizationInput = {
  create: CosmosHeroGlowCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosHeroGlowUpdateLocalizationDataInput;
};

export type CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosHeroGlowUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosHeroGlowWhereUniqueInput;
};

export type CosmosHeroGlowUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosHeroGlowUpsertInput;
  /** Unique document search */
  where: CosmosHeroGlowWhereUniqueInput;
};

/** Identifies documents */
export type CosmosHeroGlowWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosHeroGlowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosHeroGlowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosHeroGlowWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  narrow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  narrow_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosHeroGlow record uniquely */
export type CosmosHeroGlowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosPageAgreement = Entity & Node & {
  __typename?: 'CosmosPageAgreement';
  agreementDetails?: Maybe<CosmosElementAgreementDetail>;
  blocked: Array<CosmosEnumCountryCodes>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageAgreement>;
  hero?: Maybe<CosmosPageAgreementheroUnion>;
  /** List of CosmosPageAgreement versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageAgreement>;
  metaTags?: Maybe<CosmosSeo>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refSections: Array<CosmosReferenceSection>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** Will be used as Agreement title override. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageAgreementAgreementDetailsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageAgreementCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageAgreementCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageAgreementDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageAgreementHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageAgreementHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageAgreementLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageAgreementMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageAgreementPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageAgreementPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageAgreementRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type CosmosPageAgreementScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageAgreementUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageAgreementUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageAgreementConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageAgreementWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageAgreementConnection = {
  __typename?: 'CosmosPageAgreementConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageAgreementEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageAgreementCreateInput = {
  agreementDetails?: InputMaybe<CosmosElementAgreementDetailCreateOneInlineInput>;
  blocked?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hero?: InputMaybe<CosmosPageAgreementheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageAgreementCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageAgreementCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageAgreementCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageAgreementCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageAgreementCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageAgreementCreateLocalizationInput>>;
};

export type CosmosPageAgreementCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageAgreement documents */
  connect?: InputMaybe<Array<CosmosPageAgreementWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageAgreement documents */
  create?: InputMaybe<Array<CosmosPageAgreementCreateInput>>;
};

export type CosmosPageAgreementCreateOneInlineInput = {
  /** Connect one existing CosmosPageAgreement document */
  connect?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  /** Create and connect one CosmosPageAgreement document */
  create?: InputMaybe<CosmosPageAgreementCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageAgreementEdge = {
  __typename?: 'CosmosPageAgreementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageAgreement;
};

/** Identifies documents */
export type CosmosPageAgreementManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageAgreementWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageAgreementWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageAgreementWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  agreementDetails?: InputMaybe<CosmosElementAgreementDetailWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  blocked?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains *all* items provided to the filter */
  blocked_contains_all?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  blocked_contains_none?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains at least one item provided to the filter */
  blocked_contains_some?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  blocked_not?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageAgreementWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageAgreementWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageAgreementWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageAgreementheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageAgreementOrderByInput {
  BlockedAsc = 'blocked_ASC',
  BlockedDesc = 'blocked_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageAgreementUpdateInput = {
  agreementDetails?: InputMaybe<CosmosElementAgreementDetailUpdateOneInlineInput>;
  blocked?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  hero?: InputMaybe<CosmosPageAgreementheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageAgreementUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageAgreementUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageAgreementUpdateLocalizationInput = {
  data: CosmosPageAgreementUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageAgreementUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageAgreementCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageAgreementUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageAgreementUpsertLocalizationInput>>;
};

export type CosmosPageAgreementUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageAgreement documents */
  connect?: InputMaybe<Array<CosmosPageAgreementConnectInput>>;
  /** Create and connect multiple CosmosPageAgreement documents */
  create?: InputMaybe<Array<CosmosPageAgreementCreateInput>>;
  /** Delete multiple CosmosPageAgreement documents */
  delete?: InputMaybe<Array<CosmosPageAgreementWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageAgreement documents */
  disconnect?: InputMaybe<Array<CosmosPageAgreementWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageAgreement documents */
  set?: InputMaybe<Array<CosmosPageAgreementWhereUniqueInput>>;
  /** Update multiple CosmosPageAgreement documents */
  update?: InputMaybe<Array<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageAgreement documents */
  upsert?: InputMaybe<Array<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageAgreementUpdateManyInput = {
  blocked?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageAgreementUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageAgreementUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageAgreementUpdateManyLocalizationInput = {
  data: CosmosPageAgreementUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageAgreementUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageAgreementUpdateManyLocalizationInput>>;
};

export type CosmosPageAgreementUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageAgreementUpdateManyInput;
  /** Document search */
  where: CosmosPageAgreementWhereInput;
};

export type CosmosPageAgreementUpdateOneInlineInput = {
  /** Connect existing CosmosPageAgreement document */
  connect?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  /** Create and connect one CosmosPageAgreement document */
  create?: InputMaybe<CosmosPageAgreementCreateInput>;
  /** Delete currently connected CosmosPageAgreement document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageAgreement document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageAgreement document */
  update?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageAgreement document */
  upsert?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageAgreementUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageAgreementUpdateInput;
  /** Unique document search */
  where: CosmosPageAgreementWhereUniqueInput;
};

export type CosmosPageAgreementUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageAgreementCreateInput;
  /** Update document if it exists */
  update: CosmosPageAgreementUpdateInput;
};

export type CosmosPageAgreementUpsertLocalizationInput = {
  create: CosmosPageAgreementCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageAgreementUpdateLocalizationDataInput;
};

export type CosmosPageAgreementUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageAgreementUpsertInput;
  /** Unique document search */
  where: CosmosPageAgreementWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageAgreementWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageAgreementWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageAgreementWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageAgreementWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageAgreementWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  agreementDetails?: InputMaybe<CosmosElementAgreementDetailWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  blocked?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains *all* items provided to the filter */
  blocked_contains_all?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  blocked_contains_none?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array contains at least one item provided to the filter */
  blocked_contains_some?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  blocked_not?: InputMaybe<Array<CosmosEnumCountryCodes>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageAgreementWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageAgreementWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageAgreementWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageAgreementheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageAgreementWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageAgreementWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageAgreementWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageAgreementWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageAgreementWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageAgreement record uniquely */
export type CosmosPageAgreementWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageAgreementheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPageAgreementheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPageAgreementheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPageAgreementheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageAgreementheroUnion documents */
  create?: InputMaybe<Array<CosmosPageAgreementheroUnionCreateInput>>;
};

export type CosmosPageAgreementheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageAgreementheroUnion document */
  create?: InputMaybe<CosmosPageAgreementheroUnionCreateInput>;
};

export type CosmosPageAgreementheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPageAgreementheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPageAgreementheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageAgreementheroUnion component instances */
  create?: InputMaybe<Array<CosmosPageAgreementheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageAgreementheroUnion documents */
  delete?: InputMaybe<Array<CosmosPageAgreementheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageAgreementheroUnion component instances */
  update?: InputMaybe<Array<CosmosPageAgreementheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageAgreementheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageAgreementheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageAgreementheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPageAgreementheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageAgreementheroUnion document */
  create?: InputMaybe<CosmosPageAgreementheroUnionCreateInput>;
  /** Delete currently connected CosmosPageAgreementheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageAgreementheroUnion document */
  update?: InputMaybe<CosmosPageAgreementheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageAgreementheroUnion document */
  upsert?: InputMaybe<CosmosPageAgreementheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageAgreementheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageAgreementheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageAgreementheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageAgreementheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageAgreementheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPageAgreementheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

export type CosmosPageBlogDetail = Entity & Node & {
  __typename?: 'CosmosPageBlogDetail';
  articleComponents: Array<CosmosPageBlogDetailarticleComponentsUnion>;
  /** Configuration for the blog */
  blogConfig?: Maybe<CosmosConfigBlog>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageBlogDetail>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<CosmosPageBlogDetailheroUnion>;
  /** List of CosmosPageBlogDetail versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageBlogDetail>;
  metaTags?: Maybe<CosmosSeo>;
  /** The owner for this page.  Set this field if this page belongs to an application other than the default. */
  owner?: Maybe<WfRefApplicationOwner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refSections: Array<CosmosReferenceSection>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageBlogDetailArticleComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosPageBlogDetailBlogConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageBlogDetailCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageBlogDetailCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageBlogDetailDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageBlogDetailHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageBlogDetailHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageBlogDetailLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageBlogDetailMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageBlogDetailOwnerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageBlogDetailPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageBlogDetailPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageBlogDetailRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type CosmosPageBlogDetailScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageBlogDetailUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageBlogDetailUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageBlogDetailConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageBlogDetailWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageBlogDetailConnection = {
  __typename?: 'CosmosPageBlogDetailConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageBlogDetailEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageBlogDetailCreateInput = {
  articleComponents?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionCreateManyInlineInput>;
  blogConfig?: InputMaybe<CosmosConfigBlogCreateOneInlineInput>;
  cm4qq4xk4039q07og6jd35xtr?: InputMaybe<CosmosSectionLatestNewsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageBlogDetailheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageBlogDetailCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerCreateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageBlogDetailCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageBlogDetailCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageBlogDetailCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageBlogDetailCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageBlogDetailCreateLocalizationInput>>;
};

export type CosmosPageBlogDetailCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageBlogDetail documents */
  connect?: InputMaybe<Array<CosmosPageBlogDetailWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageBlogDetail documents */
  create?: InputMaybe<Array<CosmosPageBlogDetailCreateInput>>;
};

export type CosmosPageBlogDetailCreateOneInlineInput = {
  /** Connect one existing CosmosPageBlogDetail document */
  connect?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  /** Create and connect one CosmosPageBlogDetail document */
  create?: InputMaybe<CosmosPageBlogDetailCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageBlogDetailEdge = {
  __typename?: 'CosmosPageBlogDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageBlogDetail;
};

/** Identifies documents */
export type CosmosPageBlogDetailManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageBlogDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageBlogDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageBlogDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  articleComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  articleComponents_some?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionWhereInput>;
  blogConfig?: InputMaybe<CosmosConfigBlogWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageBlogDetailWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageBlogDetailWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageBlogDetailWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageBlogDetailheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageBlogDetailOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageBlogDetailUpdateInput = {
  articleComponents?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionUpdateManyInlineInput>;
  blogConfig?: InputMaybe<CosmosConfigBlogUpdateOneInlineInput>;
  cm4qq4xk4039q07og6jd35xtr?: InputMaybe<CosmosSectionLatestNewsUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageBlogDetailheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageBlogDetailUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerUpdateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageBlogDetailUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageBlogDetailUpdateLocalizationInput = {
  data: CosmosPageBlogDetailUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageBlogDetailUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageBlogDetailCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageBlogDetailUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageBlogDetailUpsertLocalizationInput>>;
};

export type CosmosPageBlogDetailUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageBlogDetail documents */
  connect?: InputMaybe<Array<CosmosPageBlogDetailConnectInput>>;
  /** Create and connect multiple CosmosPageBlogDetail documents */
  create?: InputMaybe<Array<CosmosPageBlogDetailCreateInput>>;
  /** Delete multiple CosmosPageBlogDetail documents */
  delete?: InputMaybe<Array<CosmosPageBlogDetailWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageBlogDetail documents */
  disconnect?: InputMaybe<Array<CosmosPageBlogDetailWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageBlogDetail documents */
  set?: InputMaybe<Array<CosmosPageBlogDetailWhereUniqueInput>>;
  /** Update multiple CosmosPageBlogDetail documents */
  update?: InputMaybe<Array<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageBlogDetail documents */
  upsert?: InputMaybe<Array<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageBlogDetailUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageBlogDetailUpdateManyLocalizationsInput>;
};

export type CosmosPageBlogDetailUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageBlogDetailUpdateManyLocalizationInput = {
  data: CosmosPageBlogDetailUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageBlogDetailUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageBlogDetailUpdateManyLocalizationInput>>;
};

export type CosmosPageBlogDetailUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageBlogDetailUpdateManyInput;
  /** Document search */
  where: CosmosPageBlogDetailWhereInput;
};

export type CosmosPageBlogDetailUpdateOneInlineInput = {
  /** Connect existing CosmosPageBlogDetail document */
  connect?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  /** Create and connect one CosmosPageBlogDetail document */
  create?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  /** Delete currently connected CosmosPageBlogDetail document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageBlogDetail document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageBlogDetail document */
  update?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageBlogDetail document */
  upsert?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageBlogDetailUpdateInput;
  /** Unique document search */
  where: CosmosPageBlogDetailWhereUniqueInput;
};

export type CosmosPageBlogDetailUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageBlogDetailCreateInput;
  /** Update document if it exists */
  update: CosmosPageBlogDetailUpdateInput;
};

export type CosmosPageBlogDetailUpsertLocalizationInput = {
  create: CosmosPageBlogDetailCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageBlogDetailUpdateLocalizationDataInput;
};

export type CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageBlogDetailUpsertInput;
  /** Unique document search */
  where: CosmosPageBlogDetailWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageBlogDetailWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageBlogDetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageBlogDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageBlogDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageBlogDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  articleComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  articleComponents_some?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionWhereInput>;
  blogConfig?: InputMaybe<CosmosConfigBlogWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageBlogDetailWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageBlogDetailWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageBlogDetailWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageBlogDetailheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageBlogDetailWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageBlogDetailWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageBlogDetailWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageBlogDetailWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageBlogDetailWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageBlogDetail record uniquely */
export type CosmosPageBlogDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageBlogDetailarticleComponentsUnion = CosmosElementAsset | CosmosElementButtonList | CosmosElementCalloutCard | CosmosElementCkEditorText | CosmosElementCompare | CosmosElementGithubGist | CosmosElementIconLinkGroup | CosmosElementInterview | CosmosElementLicenseContactCard | CosmosElementQuote | CosmosElementRichText | CosmosElementSectionHeading | CosmosElementTitleAndDesc | CosmosElementUserProfile | CosmosElementVideoEmbed | CosmosSectionAssetCarousel | CosmosSectionAssetGallery | CosmosSectionContentLargeImage | CosmosSectionDivider | CosmosSectionLogoList | CosmosSectionLogoMultiCard | CosmosSectionNewsMediaCard | CosmosSectionSimpleCta;

export type CosmosPageBlogDetailarticleComponentsUnionConnectInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetConnectInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListConnectInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardConnectInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextConnectInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareConnectInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistConnectInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupConnectInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewConnectInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardConnectInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteConnectInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextConnectInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingConnectInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescConnectInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileConnectInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedConnectInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselConnectInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryConnectInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageConnectInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerConnectInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardConnectInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaConnectInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionCreateInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetCreateInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListCreateInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardCreateInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextCreateInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareCreateInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistCreateInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupCreateInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewCreateInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardCreateInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteCreateInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextCreateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescCreateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedCreateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerCreateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaCreateInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageBlogDetailarticleComponentsUnion documents */
  create?: InputMaybe<Array<CosmosPageBlogDetailarticleComponentsUnionCreateInput>>;
};

export type CosmosPageBlogDetailarticleComponentsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageBlogDetailarticleComponentsUnion document */
  create?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionCreateInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionCreateWithPositionInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetCreateWithPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListCreateWithPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardCreateWithPositionInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextCreateWithPositionInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareCreateWithPositionInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistCreateWithPositionInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupCreateWithPositionInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewCreateWithPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardCreateWithPositionInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteCreateWithPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextCreateWithPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateWithPositionInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescCreateWithPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateWithPositionInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedCreateWithPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateWithPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateWithPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateWithPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerCreateWithPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateWithPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateWithPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaCreateWithPositionInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpdateInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageBlogDetailarticleComponentsUnion component instances */
  create?: InputMaybe<Array<CosmosPageBlogDetailarticleComponentsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageBlogDetailarticleComponentsUnion documents */
  delete?: InputMaybe<Array<CosmosPageBlogDetailarticleComponentsUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageBlogDetailarticleComponentsUnion component instances */
  update?: InputMaybe<Array<CosmosPageBlogDetailarticleComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageBlogDetailarticleComponentsUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageBlogDetailarticleComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateManyWithNestedWhereInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateManyWithNestedWhereInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateManyWithNestedWhereInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateManyWithNestedWhereInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateManyWithNestedWhereInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateManyWithNestedWhereInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateManyWithNestedWhereInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateManyWithNestedWhereInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateManyWithNestedWhereInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateManyWithNestedWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateManyWithNestedWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateManyWithNestedWhereInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateManyWithNestedWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateManyWithNestedWhereInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateManyWithNestedWhereInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageBlogDetailarticleComponentsUnion document */
  create?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionCreateInput>;
  /** Delete currently connected CosmosPageBlogDetailarticleComponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageBlogDetailarticleComponentsUnion document */
  update?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageBlogDetailarticleComponentsUnion document */
  upsert?: InputMaybe<CosmosPageBlogDetailarticleComponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateWithNestedWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateWithNestedWhereUniqueInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpdateWithNestedWhereUniqueInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateWithNestedWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpsertWithNestedWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpsertWithNestedWhereUniqueInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupUpsertWithNestedWhereUniqueInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpsertWithNestedWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpsertWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionWhereInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetWhereInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListWhereInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardWhereInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextWhereInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareWhereInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistWhereInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupWhereInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewWhereInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteWhereInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaWhereInput>;
};

export type CosmosPageBlogDetailarticleComponentsUnionWhereUniqueInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardWhereUniqueInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextWhereUniqueInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareWhereUniqueInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistWhereUniqueInput>;
  CosmosElementIconLinkGroup?: InputMaybe<CosmosElementIconLinkGroupWhereUniqueInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardWhereUniqueInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereUniqueInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereUniqueInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaWhereUniqueInput>;
};

export type CosmosPageBlogDetailheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPageBlogDetailheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPageBlogDetailheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPageBlogDetailheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageBlogDetailheroUnion documents */
  create?: InputMaybe<Array<CosmosPageBlogDetailheroUnionCreateInput>>;
};

export type CosmosPageBlogDetailheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageBlogDetailheroUnion document */
  create?: InputMaybe<CosmosPageBlogDetailheroUnionCreateInput>;
};

export type CosmosPageBlogDetailheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPageBlogDetailheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPageBlogDetailheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageBlogDetailheroUnion component instances */
  create?: InputMaybe<Array<CosmosPageBlogDetailheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageBlogDetailheroUnion documents */
  delete?: InputMaybe<Array<CosmosPageBlogDetailheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageBlogDetailheroUnion component instances */
  update?: InputMaybe<Array<CosmosPageBlogDetailheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageBlogDetailheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageBlogDetailheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageBlogDetailheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPageBlogDetailheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageBlogDetailheroUnion document */
  create?: InputMaybe<CosmosPageBlogDetailheroUnionCreateInput>;
  /** Delete currently connected CosmosPageBlogDetailheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageBlogDetailheroUnion document */
  update?: InputMaybe<CosmosPageBlogDetailheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageBlogDetailheroUnion document */
  upsert?: InputMaybe<CosmosPageBlogDetailheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageBlogDetailheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageBlogDetailheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageBlogDetailheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPageBlogDetailheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

export type CosmosPageDirectory = Entity & Node & {
  __typename?: 'CosmosPageDirectory';
  bottomRefSections: Array<CosmosReferenceSection>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  directoryDesc?: Maybe<Scalars['String']['output']>;
  directoryEyebrow?: Maybe<Scalars['String']['output']>;
  directoryTitle?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageDirectory>;
  hero?: Maybe<CosmosPageDirectoryheroUnion>;
  /** List of CosmosPageDirectory versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  industryFilterLabel?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageDirectory>;
  metaTags?: Maybe<CosmosSeo>;
  noResultsLabel?: Maybe<Scalars['String']['output']>;
  /** The owner for this page.  Set this field if this page belongs to an application other than the default. */
  owner?: Maybe<WfRefApplicationOwner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  searchPlaceholder?: Maybe<Scalars['String']['output']>;
  serviceFilterLabel?: Maybe<Scalars['String']['output']>;
  serviceFilterPlaceholder?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  topRefSections: Array<CosmosReferenceSection>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  variant: CosmosEnumDirectoryVariant;
};


export type CosmosPageDirectoryBottomRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type CosmosPageDirectoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageDirectoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageDirectoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageDirectoryHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageDirectoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageDirectoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageDirectoryMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageDirectoryOwnerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageDirectoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageDirectoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageDirectoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageDirectoryTopRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type CosmosPageDirectoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageDirectoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageDirectoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageDirectoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageDirectoryConnection = {
  __typename?: 'CosmosPageDirectoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageDirectoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageDirectoryCreateInput = {
  bottomRefSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** directoryDesc input for default locale (en) */
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  /** directoryEyebrow input for default locale (en) */
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  /** directoryTitle input for default locale (en) */
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageDirectoryheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** industryFilterLabel input for default locale (en) */
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageDirectoryCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<WfRefApplicationOwnerCreateOneInlineInput>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** serviceFilterLabel input for default locale (en) */
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** serviceFilterPlaceholder input for default locale (en) */
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  topRefSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant: CosmosEnumDirectoryVariant;
};

export type CosmosPageDirectoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageDirectoryCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageDirectoryCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageDirectoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageDirectoryCreateLocalizationInput>>;
};

export type CosmosPageDirectoryCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageDirectory documents */
  connect?: InputMaybe<Array<CosmosPageDirectoryWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageDirectory documents */
  create?: InputMaybe<Array<CosmosPageDirectoryCreateInput>>;
};

export type CosmosPageDirectoryCreateOneInlineInput = {
  /** Connect one existing CosmosPageDirectory document */
  connect?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  /** Create and connect one CosmosPageDirectory document */
  create?: InputMaybe<CosmosPageDirectoryCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageDirectoryEdge = {
  __typename?: 'CosmosPageDirectoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageDirectory;
};

/** Identifies documents */
export type CosmosPageDirectoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageDirectoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageDirectoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageDirectoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bottomRefSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  bottomRefSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  bottomRefSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageDirectoryWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageDirectoryWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageDirectoryWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageDirectoryheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRefSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  topRefSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  topRefSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  variant?: InputMaybe<CosmosEnumDirectoryVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumDirectoryVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumDirectoryVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumDirectoryVariant>>>;
};

export enum CosmosPageDirectoryOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DirectoryDescAsc = 'directoryDesc_ASC',
  DirectoryDescDesc = 'directoryDesc_DESC',
  DirectoryEyebrowAsc = 'directoryEyebrow_ASC',
  DirectoryEyebrowDesc = 'directoryEyebrow_DESC',
  DirectoryTitleAsc = 'directoryTitle_ASC',
  DirectoryTitleDesc = 'directoryTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  IndustryFilterLabelAsc = 'industryFilterLabel_ASC',
  IndustryFilterLabelDesc = 'industryFilterLabel_DESC',
  NoResultsLabelAsc = 'noResultsLabel_ASC',
  NoResultsLabelDesc = 'noResultsLabel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SearchPlaceholderAsc = 'searchPlaceholder_ASC',
  SearchPlaceholderDesc = 'searchPlaceholder_DESC',
  ServiceFilterLabelAsc = 'serviceFilterLabel_ASC',
  ServiceFilterLabelDesc = 'serviceFilterLabel_DESC',
  ServiceFilterPlaceholderAsc = 'serviceFilterPlaceholder_ASC',
  ServiceFilterPlaceholderDesc = 'serviceFilterPlaceholder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosPageDirectoryUpdateInput = {
  bottomRefSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  /** directoryDesc input for default locale (en) */
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  /** directoryEyebrow input for default locale (en) */
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  /** directoryTitle input for default locale (en) */
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageDirectoryheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** industryFilterLabel input for default locale (en) */
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageDirectoryUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<WfRefApplicationOwnerUpdateOneInlineInput>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** serviceFilterLabel input for default locale (en) */
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** serviceFilterPlaceholder input for default locale (en) */
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  topRefSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  variant?: InputMaybe<CosmosEnumDirectoryVariant>;
};

export type CosmosPageDirectoryUpdateLocalizationDataInput = {
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageDirectoryUpdateLocalizationInput = {
  data: CosmosPageDirectoryUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageDirectoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageDirectoryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageDirectoryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageDirectoryUpsertLocalizationInput>>;
};

export type CosmosPageDirectoryUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageDirectory documents */
  connect?: InputMaybe<Array<CosmosPageDirectoryConnectInput>>;
  /** Create and connect multiple CosmosPageDirectory documents */
  create?: InputMaybe<Array<CosmosPageDirectoryCreateInput>>;
  /** Delete multiple CosmosPageDirectory documents */
  delete?: InputMaybe<Array<CosmosPageDirectoryWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageDirectory documents */
  disconnect?: InputMaybe<Array<CosmosPageDirectoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageDirectory documents */
  set?: InputMaybe<Array<CosmosPageDirectoryWhereUniqueInput>>;
  /** Update multiple CosmosPageDirectory documents */
  update?: InputMaybe<Array<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageDirectory documents */
  upsert?: InputMaybe<Array<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageDirectoryUpdateManyInput = {
  /** directoryDesc input for default locale (en) */
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  /** directoryEyebrow input for default locale (en) */
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  /** directoryTitle input for default locale (en) */
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** industryFilterLabel input for default locale (en) */
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageDirectoryUpdateManyLocalizationsInput>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** serviceFilterLabel input for default locale (en) */
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** serviceFilterPlaceholder input for default locale (en) */
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CosmosEnumDirectoryVariant>;
};

export type CosmosPageDirectoryUpdateManyLocalizationDataInput = {
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageDirectoryUpdateManyLocalizationInput = {
  data: CosmosPageDirectoryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageDirectoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageDirectoryUpdateManyLocalizationInput>>;
};

export type CosmosPageDirectoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageDirectoryUpdateManyInput;
  /** Document search */
  where: CosmosPageDirectoryWhereInput;
};

export type CosmosPageDirectoryUpdateOneInlineInput = {
  /** Connect existing CosmosPageDirectory document */
  connect?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  /** Create and connect one CosmosPageDirectory document */
  create?: InputMaybe<CosmosPageDirectoryCreateInput>;
  /** Delete currently connected CosmosPageDirectory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageDirectory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageDirectory document */
  update?: InputMaybe<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageDirectory document */
  upsert?: InputMaybe<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageDirectoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageDirectoryUpdateInput;
  /** Unique document search */
  where: CosmosPageDirectoryWhereUniqueInput;
};

export type CosmosPageDirectoryUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageDirectoryCreateInput;
  /** Update document if it exists */
  update: CosmosPageDirectoryUpdateInput;
};

export type CosmosPageDirectoryUpsertLocalizationInput = {
  create: CosmosPageDirectoryCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageDirectoryUpdateLocalizationDataInput;
};

export type CosmosPageDirectoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageDirectoryUpsertInput;
  /** Unique document search */
  where: CosmosPageDirectoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageDirectoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageDirectoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageDirectoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageDirectoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageDirectoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bottomRefSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  bottomRefSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  bottomRefSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  directoryDesc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  directoryDesc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  directoryDesc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  directoryDesc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  directoryDesc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  directoryDesc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  directoryDesc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  directoryDesc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  directoryDesc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  directoryDesc_starts_with?: InputMaybe<Scalars['String']['input']>;
  directoryEyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  directoryEyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  directoryEyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  directoryEyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  directoryEyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  directoryEyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  directoryEyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  directoryEyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  directoryEyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  directoryEyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  directoryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  directoryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  directoryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  directoryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  directoryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  directoryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  directoryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  directoryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  directoryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  directoryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CosmosPageDirectoryWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageDirectoryWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageDirectoryWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageDirectoryheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  industryFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  industryFilterLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  industryFilterLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  industryFilterLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  industryFilterLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  industryFilterLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  industryFilterLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  industryFilterLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  industryFilterLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  industryFilterLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  noResultsLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  noResultsLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  noResultsLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  noResultsLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  noResultsLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  noResultsLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  noResultsLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  noResultsLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  noResultsLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  searchPlaceholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  searchPlaceholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  searchPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  searchPlaceholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  searchPlaceholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  searchPlaceholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  searchPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  searchPlaceholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  searchPlaceholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  serviceFilterLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  serviceFilterLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  serviceFilterLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  serviceFilterLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  serviceFilterLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  serviceFilterLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  serviceFilterLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  serviceFilterLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  serviceFilterLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  serviceFilterLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  serviceFilterPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  serviceFilterPlaceholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  serviceFilterPlaceholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  serviceFilterPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  serviceFilterPlaceholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  serviceFilterPlaceholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  serviceFilterPlaceholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  serviceFilterPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  serviceFilterPlaceholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  serviceFilterPlaceholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRefSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  topRefSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  topRefSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  variant?: InputMaybe<CosmosEnumDirectoryVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumDirectoryVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumDirectoryVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumDirectoryVariant>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageDirectoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageDirectoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageDirectoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageDirectoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageDirectoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageDirectory record uniquely */
export type CosmosPageDirectoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageDirectoryheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPageDirectoryheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPageDirectoryheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPageDirectoryheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageDirectoryheroUnion documents */
  create?: InputMaybe<Array<CosmosPageDirectoryheroUnionCreateInput>>;
};

export type CosmosPageDirectoryheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageDirectoryheroUnion document */
  create?: InputMaybe<CosmosPageDirectoryheroUnionCreateInput>;
};

export type CosmosPageDirectoryheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPageDirectoryheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPageDirectoryheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageDirectoryheroUnion component instances */
  create?: InputMaybe<Array<CosmosPageDirectoryheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageDirectoryheroUnion documents */
  delete?: InputMaybe<Array<CosmosPageDirectoryheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageDirectoryheroUnion component instances */
  update?: InputMaybe<Array<CosmosPageDirectoryheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageDirectoryheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageDirectoryheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageDirectoryheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPageDirectoryheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageDirectoryheroUnion document */
  create?: InputMaybe<CosmosPageDirectoryheroUnionCreateInput>;
  /** Delete currently connected CosmosPageDirectoryheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageDirectoryheroUnion document */
  update?: InputMaybe<CosmosPageDirectoryheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageDirectoryheroUnion document */
  upsert?: InputMaybe<CosmosPageDirectoryheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageDirectoryheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageDirectoryheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageDirectoryheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageDirectoryheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageDirectoryheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPageDirectoryheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

export type CosmosPageEulaKey = Entity & Node & {
  __typename?: 'CosmosPageEulaKey';
  /** Optional banner text at the top of the page for 30 day change notices. */
  banner?: Maybe<Scalars['String']['output']>;
  /** If specified, only renders the banner when a matching country code is found within this csv string field */
  bannerCountryCodes?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Disclaimer shown above the title */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageEulaKey>;
  /** Key value from https://adminportal-website-gamedev.ol.epicgames.net/services/eula/ */
  eulaKey: Scalars['String']['output'];
  /** List of CosmosPageEulaKey versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageEulaKey>;
  metaTags?: Maybe<CosmosSeo>;
  /** The owner for this page.  Set this field if this page belongs to an application other than the default. */
  owner?: Maybe<WfRefApplicationOwner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** Subtitle shown below the title; typically used for links to a changelog */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Will be used as Eula Key title override. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageEulaKeyCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageEulaKeyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageEulaKeyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageEulaKeyHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageEulaKeyLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageEulaKeyMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageEulaKeyOwnerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageEulaKeyPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageEulaKeyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageEulaKeyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageEulaKeyUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageEulaKeyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageEulaKeyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageEulaKeyWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageEulaKeyConnection = {
  __typename?: 'CosmosPageEulaKeyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageEulaKeyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageEulaKeyCreateInput = {
  /** banner input for default locale (en) */
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** disclaimer input for default locale (en) */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  eulaKey: Scalars['String']['input'];
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageEulaKeyCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  /** subtitle input for default locale (en) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageEulaKeyCreateLocalizationDataInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageEulaKeyCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageEulaKeyCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageEulaKeyCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageEulaKeyCreateLocalizationInput>>;
};

export type CosmosPageEulaKeyCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageEulaKey documents */
  connect?: InputMaybe<Array<CosmosPageEulaKeyWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageEulaKey documents */
  create?: InputMaybe<Array<CosmosPageEulaKeyCreateInput>>;
};

export type CosmosPageEulaKeyCreateOneInlineInput = {
  /** Connect one existing CosmosPageEulaKey document */
  connect?: InputMaybe<CosmosPageEulaKeyWhereUniqueInput>;
  /** Create and connect one CosmosPageEulaKey document */
  create?: InputMaybe<CosmosPageEulaKeyCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageEulaKeyEdge = {
  __typename?: 'CosmosPageEulaKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageEulaKey;
};

/** Identifies documents */
export type CosmosPageEulaKeyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageEulaKeyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageEulaKeyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageEulaKeyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerCountryCodes_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerCountryCodes_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerCountryCodes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerCountryCodes_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerCountryCodes_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerCountryCodes_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerCountryCodes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerCountryCodes_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerCountryCodes_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageEulaKeyWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageEulaKeyWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageEulaKeyWhereStageInput>;
  eulaKey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eulaKey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eulaKey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eulaKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eulaKey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eulaKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eulaKey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eulaKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eulaKey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eulaKey_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageEulaKeyOrderByInput {
  BannerCountryCodesAsc = 'bannerCountryCodes_ASC',
  BannerCountryCodesDesc = 'bannerCountryCodes_DESC',
  BannerAsc = 'banner_ASC',
  BannerDesc = 'banner_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DisclaimerAsc = 'disclaimer_ASC',
  DisclaimerDesc = 'disclaimer_DESC',
  EulaKeyAsc = 'eulaKey_ASC',
  EulaKeyDesc = 'eulaKey_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageEulaKeyUpdateInput = {
  /** banner input for default locale (en) */
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** disclaimer input for default locale (en) */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  eulaKey?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageEulaKeyUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** subtitle input for default locale (en) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageEulaKeyUpdateLocalizationDataInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageEulaKeyUpdateLocalizationInput = {
  data: CosmosPageEulaKeyUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageEulaKeyUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageEulaKeyCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageEulaKeyUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageEulaKeyUpsertLocalizationInput>>;
};

export type CosmosPageEulaKeyUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageEulaKey documents */
  connect?: InputMaybe<Array<CosmosPageEulaKeyConnectInput>>;
  /** Create and connect multiple CosmosPageEulaKey documents */
  create?: InputMaybe<Array<CosmosPageEulaKeyCreateInput>>;
  /** Delete multiple CosmosPageEulaKey documents */
  delete?: InputMaybe<Array<CosmosPageEulaKeyWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageEulaKey documents */
  disconnect?: InputMaybe<Array<CosmosPageEulaKeyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageEulaKey documents */
  set?: InputMaybe<Array<CosmosPageEulaKeyWhereUniqueInput>>;
  /** Update multiple CosmosPageEulaKey documents */
  update?: InputMaybe<Array<CosmosPageEulaKeyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageEulaKey documents */
  upsert?: InputMaybe<Array<CosmosPageEulaKeyUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageEulaKeyUpdateManyInput = {
  /** banner input for default locale (en) */
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** disclaimer input for default locale (en) */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageEulaKeyUpdateManyLocalizationsInput>;
  /** subtitle input for default locale (en) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageEulaKeyUpdateManyLocalizationDataInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageEulaKeyUpdateManyLocalizationInput = {
  data: CosmosPageEulaKeyUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageEulaKeyUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageEulaKeyUpdateManyLocalizationInput>>;
};

export type CosmosPageEulaKeyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageEulaKeyUpdateManyInput;
  /** Document search */
  where: CosmosPageEulaKeyWhereInput;
};

export type CosmosPageEulaKeyUpdateOneInlineInput = {
  /** Connect existing CosmosPageEulaKey document */
  connect?: InputMaybe<CosmosPageEulaKeyWhereUniqueInput>;
  /** Create and connect one CosmosPageEulaKey document */
  create?: InputMaybe<CosmosPageEulaKeyCreateInput>;
  /** Delete currently connected CosmosPageEulaKey document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageEulaKey document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageEulaKey document */
  update?: InputMaybe<CosmosPageEulaKeyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageEulaKey document */
  upsert?: InputMaybe<CosmosPageEulaKeyUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageEulaKeyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageEulaKeyUpdateInput;
  /** Unique document search */
  where: CosmosPageEulaKeyWhereUniqueInput;
};

export type CosmosPageEulaKeyUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageEulaKeyCreateInput;
  /** Update document if it exists */
  update: CosmosPageEulaKeyUpdateInput;
};

export type CosmosPageEulaKeyUpsertLocalizationInput = {
  create: CosmosPageEulaKeyCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageEulaKeyUpdateLocalizationDataInput;
};

export type CosmosPageEulaKeyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageEulaKeyUpsertInput;
  /** Unique document search */
  where: CosmosPageEulaKeyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageEulaKeyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageEulaKeyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageEulaKeyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageEulaKeyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageEulaKeyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerCountryCodes_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerCountryCodes_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerCountryCodes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerCountryCodes_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerCountryCodes_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerCountryCodes_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerCountryCodes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerCountryCodes_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerCountryCodes_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  banner_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  banner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  banner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  banner_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  banner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  banner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  banner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  banner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  banner_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  disclaimer_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  disclaimer_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  disclaimer_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  disclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  disclaimer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  disclaimer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  disclaimer_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CosmosPageEulaKeyWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageEulaKeyWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageEulaKeyWhereStageInput>;
  eulaKey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eulaKey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eulaKey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eulaKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eulaKey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eulaKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eulaKey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eulaKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eulaKey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eulaKey_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageEulaKeyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageEulaKeyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageEulaKeyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageEulaKeyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageEulaKeyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageEulaKey record uniquely */
export type CosmosPageEulaKeyWhereUniqueInput = {
  eulaKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageFeed = Entity & Node & {
  __typename?: 'CosmosPageFeed';
  categories: Array<WfRefBlogCategory>;
  clearFiltersButtonLabel?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageFeed>;
  featuredLabel?: Maybe<Scalars['String']['output']>;
  /** List of CosmosPageFeed versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Shown when tags are loading. */
  loadingLabel?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageFeed>;
  metaTags?: Maybe<CosmosSeo>;
  /** The description to be shown when there are no results found */
  noResultsDescription?: Maybe<Scalars['String']['output']>;
  /** Tag search returns no results label */
  noResultsLabel?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  searchPlaceholder?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** Curated tag list */
  tags: Array<WfRefBlogTag>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageFeedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<WfRefBlogCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogCategoryWhereInput>;
};


export type CosmosPageFeedCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageFeedCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageFeedDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageFeedHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageFeedLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageFeedMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageFeedPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageFeedPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageFeedScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageFeedTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<WfRefBlogTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogTagWhereInput>;
};


export type CosmosPageFeedUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageFeedUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageFeedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageFeedWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageFeedConnection = {
  __typename?: 'CosmosPageFeedConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageFeedEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageFeedCreateInput = {
  categories?: InputMaybe<WfRefBlogCategoryCreateManyInlineInput>;
  /** clearFiltersButtonLabel input for default locale (en) */
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** featuredLabel input for default locale (en) */
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  /** loadingLabel input for default locale (en) */
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageFeedCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  /** noResultsDescription input for default locale (en) */
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  tags?: InputMaybe<WfRefBlogTagCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageFeedCreateLocalizationDataInput = {
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageFeedCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageFeedCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageFeedCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageFeedCreateLocalizationInput>>;
};

export type CosmosPageFeedCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageFeed documents */
  connect?: InputMaybe<Array<CosmosPageFeedWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageFeed documents */
  create?: InputMaybe<Array<CosmosPageFeedCreateInput>>;
};

export type CosmosPageFeedCreateOneInlineInput = {
  /** Connect one existing CosmosPageFeed document */
  connect?: InputMaybe<CosmosPageFeedWhereUniqueInput>;
  /** Create and connect one CosmosPageFeed document */
  create?: InputMaybe<CosmosPageFeedCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageFeedEdge = {
  __typename?: 'CosmosPageFeedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageFeed;
};

/** Identifies documents */
export type CosmosPageFeedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageFeedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageFeedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageFeedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_none?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_some?: InputMaybe<WfRefBlogCategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageFeedWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageFeedWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageFeedWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tags_every?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_none?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_some?: InputMaybe<WfRefBlogTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageFeedOrderByInput {
  ClearFiltersButtonLabelAsc = 'clearFiltersButtonLabel_ASC',
  ClearFiltersButtonLabelDesc = 'clearFiltersButtonLabel_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeaturedLabelAsc = 'featuredLabel_ASC',
  FeaturedLabelDesc = 'featuredLabel_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LoadingLabelAsc = 'loadingLabel_ASC',
  LoadingLabelDesc = 'loadingLabel_DESC',
  NoResultsDescriptionAsc = 'noResultsDescription_ASC',
  NoResultsDescriptionDesc = 'noResultsDescription_DESC',
  NoResultsLabelAsc = 'noResultsLabel_ASC',
  NoResultsLabelDesc = 'noResultsLabel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SearchPlaceholderAsc = 'searchPlaceholder_ASC',
  SearchPlaceholderDesc = 'searchPlaceholder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageFeedUpdateInput = {
  categories?: InputMaybe<WfRefBlogCategoryUpdateManyInlineInput>;
  /** clearFiltersButtonLabel input for default locale (en) */
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** featuredLabel input for default locale (en) */
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  /** loadingLabel input for default locale (en) */
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageFeedUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  /** noResultsDescription input for default locale (en) */
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<WfRefBlogTagUpdateManyInlineInput>;
};

export type CosmosPageFeedUpdateLocalizationDataInput = {
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageFeedUpdateLocalizationInput = {
  data: CosmosPageFeedUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageFeedUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageFeedCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageFeedUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageFeedUpsertLocalizationInput>>;
};

export type CosmosPageFeedUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageFeed documents */
  connect?: InputMaybe<Array<CosmosPageFeedConnectInput>>;
  /** Create and connect multiple CosmosPageFeed documents */
  create?: InputMaybe<Array<CosmosPageFeedCreateInput>>;
  /** Delete multiple CosmosPageFeed documents */
  delete?: InputMaybe<Array<CosmosPageFeedWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageFeed documents */
  disconnect?: InputMaybe<Array<CosmosPageFeedWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageFeed documents */
  set?: InputMaybe<Array<CosmosPageFeedWhereUniqueInput>>;
  /** Update multiple CosmosPageFeed documents */
  update?: InputMaybe<Array<CosmosPageFeedUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageFeed documents */
  upsert?: InputMaybe<Array<CosmosPageFeedUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageFeedUpdateManyInput = {
  /** clearFiltersButtonLabel input for default locale (en) */
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** featuredLabel input for default locale (en) */
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  /** loadingLabel input for default locale (en) */
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageFeedUpdateManyLocalizationsInput>;
  /** noResultsDescription input for default locale (en) */
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageFeedUpdateManyLocalizationDataInput = {
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageFeedUpdateManyLocalizationInput = {
  data: CosmosPageFeedUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageFeedUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageFeedUpdateManyLocalizationInput>>;
};

export type CosmosPageFeedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageFeedUpdateManyInput;
  /** Document search */
  where: CosmosPageFeedWhereInput;
};

export type CosmosPageFeedUpdateOneInlineInput = {
  /** Connect existing CosmosPageFeed document */
  connect?: InputMaybe<CosmosPageFeedWhereUniqueInput>;
  /** Create and connect one CosmosPageFeed document */
  create?: InputMaybe<CosmosPageFeedCreateInput>;
  /** Delete currently connected CosmosPageFeed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageFeed document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageFeed document */
  update?: InputMaybe<CosmosPageFeedUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageFeed document */
  upsert?: InputMaybe<CosmosPageFeedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageFeedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageFeedUpdateInput;
  /** Unique document search */
  where: CosmosPageFeedWhereUniqueInput;
};

export type CosmosPageFeedUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageFeedCreateInput;
  /** Update document if it exists */
  update: CosmosPageFeedUpdateInput;
};

export type CosmosPageFeedUpsertLocalizationInput = {
  create: CosmosPageFeedCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageFeedUpdateLocalizationDataInput;
};

export type CosmosPageFeedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageFeedUpsertInput;
  /** Unique document search */
  where: CosmosPageFeedWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageFeedWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageFeedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageFeedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageFeedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageFeedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  categories_every?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_none?: InputMaybe<WfRefBlogCategoryWhereInput>;
  categories_some?: InputMaybe<WfRefBlogCategoryWhereInput>;
  clearFiltersButtonLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  clearFiltersButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  clearFiltersButtonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  clearFiltersButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  clearFiltersButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  clearFiltersButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  clearFiltersButtonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  clearFiltersButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  clearFiltersButtonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  clearFiltersButtonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageFeedWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageFeedWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageFeedWhereStageInput>;
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  featuredLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  featuredLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  featuredLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featuredLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  featuredLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  featuredLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  featuredLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  featuredLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  featuredLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  loadingLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  loadingLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  loadingLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  loadingLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  loadingLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  loadingLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  loadingLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  loadingLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  loadingLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  noResultsDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  noResultsDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  noResultsDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  noResultsDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  noResultsDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  noResultsDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  noResultsDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  noResultsDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  noResultsDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  noResultsDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  noResultsLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  noResultsLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  noResultsLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  noResultsLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  noResultsLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  noResultsLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  noResultsLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  noResultsLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  noResultsLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  searchPlaceholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  searchPlaceholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  searchPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  searchPlaceholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  searchPlaceholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  searchPlaceholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  searchPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  searchPlaceholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  searchPlaceholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  tags_every?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_none?: InputMaybe<WfRefBlogTagWhereInput>;
  tags_some?: InputMaybe<WfRefBlogTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageFeedWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageFeedWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageFeedWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageFeedWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageFeedWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageFeed record uniquely */
export type CosmosPageFeedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageHeroAndSection = Entity & Node & {
  __typename?: 'CosmosPageHeroAndSection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageHeroAndSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<CosmosPageHeroAndSectionheroUnion>;
  /** List of CosmosPageHeroAndSection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageHeroAndSection>;
  metaTags?: Maybe<CosmosSeo>;
  /** The owner for this page.  Set this field if this page belongs to an application other than the default. */
  owner?: Maybe<WfRefApplicationOwner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refSections: Array<CosmosReferenceSection>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageHeroAndSectionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageHeroAndSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageHeroAndSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageHeroAndSectionHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageHeroAndSectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageHeroAndSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageHeroAndSectionMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageHeroAndSectionOwnerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageHeroAndSectionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageHeroAndSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageHeroAndSectionRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type CosmosPageHeroAndSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageHeroAndSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageHeroAndSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageHeroAndSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageHeroAndSectionConnection = {
  __typename?: 'CosmosPageHeroAndSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageHeroAndSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageHeroAndSectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageHeroAndSectionheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageHeroAndSectionCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerCreateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageHeroAndSectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageHeroAndSectionCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageHeroAndSectionCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageHeroAndSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageHeroAndSectionCreateLocalizationInput>>;
};

export type CosmosPageHeroAndSectionCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageHeroAndSection documents */
  connect?: InputMaybe<Array<CosmosPageHeroAndSectionWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageHeroAndSection documents */
  create?: InputMaybe<Array<CosmosPageHeroAndSectionCreateInput>>;
};

export type CosmosPageHeroAndSectionCreateOneInlineInput = {
  /** Connect one existing CosmosPageHeroAndSection document */
  connect?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  /** Create and connect one CosmosPageHeroAndSection document */
  create?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageHeroAndSectionEdge = {
  __typename?: 'CosmosPageHeroAndSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageHeroAndSection;
};

/** Identifies documents */
export type CosmosPageHeroAndSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageHeroAndSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageHeroAndSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageHeroAndSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageHeroAndSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageHeroAndSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageHeroAndSectionWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageHeroAndSectionheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageHeroAndSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageHeroAndSectionUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageHeroAndSectionheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageHeroAndSectionUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerUpdateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageHeroAndSectionUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageHeroAndSectionUpdateLocalizationInput = {
  data: CosmosPageHeroAndSectionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageHeroAndSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageHeroAndSectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageHeroAndSectionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageHeroAndSectionUpsertLocalizationInput>>;
};

export type CosmosPageHeroAndSectionUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageHeroAndSection documents */
  connect?: InputMaybe<Array<CosmosPageHeroAndSectionConnectInput>>;
  /** Create and connect multiple CosmosPageHeroAndSection documents */
  create?: InputMaybe<Array<CosmosPageHeroAndSectionCreateInput>>;
  /** Delete multiple CosmosPageHeroAndSection documents */
  delete?: InputMaybe<Array<CosmosPageHeroAndSectionWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageHeroAndSection documents */
  disconnect?: InputMaybe<Array<CosmosPageHeroAndSectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageHeroAndSection documents */
  set?: InputMaybe<Array<CosmosPageHeroAndSectionWhereUniqueInput>>;
  /** Update multiple CosmosPageHeroAndSection documents */
  update?: InputMaybe<Array<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageHeroAndSection documents */
  upsert?: InputMaybe<Array<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageHeroAndSectionUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageHeroAndSectionUpdateManyLocalizationsInput>;
};

export type CosmosPageHeroAndSectionUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageHeroAndSectionUpdateManyLocalizationInput = {
  data: CosmosPageHeroAndSectionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageHeroAndSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageHeroAndSectionUpdateManyLocalizationInput>>;
};

export type CosmosPageHeroAndSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageHeroAndSectionUpdateManyInput;
  /** Document search */
  where: CosmosPageHeroAndSectionWhereInput;
};

export type CosmosPageHeroAndSectionUpdateOneInlineInput = {
  /** Connect existing CosmosPageHeroAndSection document */
  connect?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  /** Create and connect one CosmosPageHeroAndSection document */
  create?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
  /** Delete currently connected CosmosPageHeroAndSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageHeroAndSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageHeroAndSection document */
  update?: InputMaybe<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageHeroAndSection document */
  upsert?: InputMaybe<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageHeroAndSectionUpdateInput;
  /** Unique document search */
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};

export type CosmosPageHeroAndSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageHeroAndSectionCreateInput;
  /** Update document if it exists */
  update: CosmosPageHeroAndSectionUpdateInput;
};

export type CosmosPageHeroAndSectionUpsertLocalizationInput = {
  create: CosmosPageHeroAndSectionCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageHeroAndSectionUpdateLocalizationDataInput;
};

export type CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageHeroAndSectionUpsertInput;
  /** Unique document search */
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageHeroAndSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageHeroAndSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageHeroAndSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageHeroAndSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageHeroAndSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageHeroAndSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageHeroAndSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageHeroAndSectionWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageHeroAndSectionheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageHeroAndSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageHeroAndSectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageHeroAndSectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageHeroAndSectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageHeroAndSectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageHeroAndSection record uniquely */
export type CosmosPageHeroAndSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageHeroAndSectionheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPageHeroAndSectionheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPageHeroAndSectionheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPageHeroAndSectionheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageHeroAndSectionheroUnion documents */
  create?: InputMaybe<Array<CosmosPageHeroAndSectionheroUnionCreateInput>>;
};

export type CosmosPageHeroAndSectionheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageHeroAndSectionheroUnion document */
  create?: InputMaybe<CosmosPageHeroAndSectionheroUnionCreateInput>;
};

export type CosmosPageHeroAndSectionheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageHeroAndSectionheroUnion component instances */
  create?: InputMaybe<Array<CosmosPageHeroAndSectionheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageHeroAndSectionheroUnion documents */
  delete?: InputMaybe<Array<CosmosPageHeroAndSectionheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageHeroAndSectionheroUnion component instances */
  update?: InputMaybe<Array<CosmosPageHeroAndSectionheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageHeroAndSectionheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageHeroAndSectionheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageHeroAndSectionheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageHeroAndSectionheroUnion document */
  create?: InputMaybe<CosmosPageHeroAndSectionheroUnionCreateInput>;
  /** Delete currently connected CosmosPageHeroAndSectionheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageHeroAndSectionheroUnion document */
  update?: InputMaybe<CosmosPageHeroAndSectionheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageHeroAndSectionheroUnion document */
  upsert?: InputMaybe<CosmosPageHeroAndSectionheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageHeroAndSectionheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageHeroAndSectionheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPageHeroAndSectionheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

export type CosmosPageLegalContent = Entity & Node & {
  __typename?: 'CosmosPageLegalContent';
  /** Optional banner text at the top of the page for 30 day change notices. */
  banner?: Maybe<Scalars['String']['output']>;
  /** If specified, only renders the banner when a matching country code is found within this csv string field */
  bannerCountryCodes?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageLegalContent>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<CosmosPageLegalContentheroUnion>;
  /** List of CosmosPageLegalContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageLegalContent>;
  metaTags?: Maybe<CosmosSeo>;
  /** The owner for this page.  Set this field if this page belongs to an application other than the default. */
  owner?: Maybe<WfRefApplicationOwner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  sections: Array<CosmosPageLegalContentsectionsUnion>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageLegalContentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageLegalContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageLegalContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageLegalContentHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageLegalContentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageLegalContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageLegalContentMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageLegalContentOwnerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageLegalContentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageLegalContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageLegalContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageLegalContentSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosPageLegalContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageLegalContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageLegalContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageLegalContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageLegalContentConnection = {
  __typename?: 'CosmosPageLegalContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageLegalContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageLegalContentCreateInput = {
  /** banner input for default locale (en) */
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageLegalContentheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageLegalContentCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerCreateOneInlineInput>;
  sections?: InputMaybe<CosmosPageLegalContentsectionsUnionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageLegalContentCreateLocalizationDataInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageLegalContentCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageLegalContentCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageLegalContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageLegalContentCreateLocalizationInput>>;
};

export type CosmosPageLegalContentCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageLegalContent documents */
  connect?: InputMaybe<Array<CosmosPageLegalContentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageLegalContent documents */
  create?: InputMaybe<Array<CosmosPageLegalContentCreateInput>>;
};

export type CosmosPageLegalContentCreateOneInlineInput = {
  /** Connect one existing CosmosPageLegalContent document */
  connect?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  /** Create and connect one CosmosPageLegalContent document */
  create?: InputMaybe<CosmosPageLegalContentCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageLegalContentEdge = {
  __typename?: 'CosmosPageLegalContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageLegalContent;
};

/** Identifies documents */
export type CosmosPageLegalContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageLegalContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageLegalContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageLegalContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerCountryCodes_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerCountryCodes_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerCountryCodes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerCountryCodes_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerCountryCodes_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerCountryCodes_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerCountryCodes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerCountryCodes_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerCountryCodes_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageLegalContentWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageLegalContentWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageLegalContentWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageLegalContentheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty. */
  sections_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sections_some?: InputMaybe<CosmosPageLegalContentsectionsUnionWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageLegalContentOrderByInput {
  BannerCountryCodesAsc = 'bannerCountryCodes_ASC',
  BannerCountryCodesDesc = 'bannerCountryCodes_DESC',
  BannerAsc = 'banner_ASC',
  BannerDesc = 'banner_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageLegalContentUpdateInput = {
  /** banner input for default locale (en) */
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageLegalContentheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageLegalContentUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  owner?: InputMaybe<WfRefApplicationOwnerUpdateOneInlineInput>;
  sections?: InputMaybe<CosmosPageLegalContentsectionsUnionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLegalContentUpdateLocalizationDataInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLegalContentUpdateLocalizationInput = {
  data: CosmosPageLegalContentUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageLegalContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageLegalContentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageLegalContentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageLegalContentUpsertLocalizationInput>>;
};

export type CosmosPageLegalContentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageLegalContent documents */
  connect?: InputMaybe<Array<CosmosPageLegalContentConnectInput>>;
  /** Create and connect multiple CosmosPageLegalContent documents */
  create?: InputMaybe<Array<CosmosPageLegalContentCreateInput>>;
  /** Delete multiple CosmosPageLegalContent documents */
  delete?: InputMaybe<Array<CosmosPageLegalContentWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageLegalContent documents */
  disconnect?: InputMaybe<Array<CosmosPageLegalContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageLegalContent documents */
  set?: InputMaybe<Array<CosmosPageLegalContentWhereUniqueInput>>;
  /** Update multiple CosmosPageLegalContent documents */
  update?: InputMaybe<Array<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageLegalContent documents */
  upsert?: InputMaybe<Array<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageLegalContentUpdateManyInput = {
  /** banner input for default locale (en) */
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageLegalContentUpdateManyLocalizationsInput>;
};

export type CosmosPageLegalContentUpdateManyLocalizationDataInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLegalContentUpdateManyLocalizationInput = {
  data: CosmosPageLegalContentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageLegalContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageLegalContentUpdateManyLocalizationInput>>;
};

export type CosmosPageLegalContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageLegalContentUpdateManyInput;
  /** Document search */
  where: CosmosPageLegalContentWhereInput;
};

export type CosmosPageLegalContentUpdateOneInlineInput = {
  /** Connect existing CosmosPageLegalContent document */
  connect?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  /** Create and connect one CosmosPageLegalContent document */
  create?: InputMaybe<CosmosPageLegalContentCreateInput>;
  /** Delete currently connected CosmosPageLegalContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageLegalContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageLegalContent document */
  update?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageLegalContent document */
  upsert?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageLegalContentUpdateInput;
  /** Unique document search */
  where: CosmosPageLegalContentWhereUniqueInput;
};

export type CosmosPageLegalContentUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageLegalContentCreateInput;
  /** Update document if it exists */
  update: CosmosPageLegalContentUpdateInput;
};

export type CosmosPageLegalContentUpsertLocalizationInput = {
  create: CosmosPageLegalContentCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageLegalContentUpdateLocalizationDataInput;
};

export type CosmosPageLegalContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageLegalContentUpsertInput;
  /** Unique document search */
  where: CosmosPageLegalContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageLegalContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageLegalContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageLegalContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageLegalContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageLegalContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerCountryCodes?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerCountryCodes_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerCountryCodes_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerCountryCodes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerCountryCodes_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerCountryCodes_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerCountryCodes_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerCountryCodes_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerCountryCodes_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerCountryCodes_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  banner_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  banner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  banner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  banner_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  banner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  banner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  banner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  banner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  banner_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageLegalContentWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageLegalContentWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageLegalContentWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageLegalContentheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty. */
  sections_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  sections_some?: InputMaybe<CosmosPageLegalContentsectionsUnionWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageLegalContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageLegalContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageLegalContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageLegalContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageLegalContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageLegalContent record uniquely */
export type CosmosPageLegalContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLegalContentheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPageLegalContentheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPageLegalContentheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPageLegalContentheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageLegalContentheroUnion documents */
  create?: InputMaybe<Array<CosmosPageLegalContentheroUnionCreateInput>>;
};

export type CosmosPageLegalContentheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageLegalContentheroUnion document */
  create?: InputMaybe<CosmosPageLegalContentheroUnionCreateInput>;
};

export type CosmosPageLegalContentheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPageLegalContentheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPageLegalContentheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageLegalContentheroUnion component instances */
  create?: InputMaybe<Array<CosmosPageLegalContentheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageLegalContentheroUnion documents */
  delete?: InputMaybe<Array<CosmosPageLegalContentheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageLegalContentheroUnion component instances */
  update?: InputMaybe<Array<CosmosPageLegalContentheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageLegalContentheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageLegalContentheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageLegalContentheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPageLegalContentheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageLegalContentheroUnion document */
  create?: InputMaybe<CosmosPageLegalContentheroUnionCreateInput>;
  /** Delete currently connected CosmosPageLegalContentheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageLegalContentheroUnion document */
  update?: InputMaybe<CosmosPageLegalContentheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageLegalContentheroUnion document */
  upsert?: InputMaybe<CosmosPageLegalContentheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageLegalContentheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageLegalContentheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPageLegalContentheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

export type CosmosPageLegalContentsectionsUnion = CosmosElementCkEditorText | CosmosElementCkEditorTextCollapsible;

export type CosmosPageLegalContentsectionsUnionConnectInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextConnectInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleConnectInput>;
};

export type CosmosPageLegalContentsectionsUnionCreateInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextCreateInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleCreateInput>;
};

export type CosmosPageLegalContentsectionsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageLegalContentsectionsUnion documents */
  create?: InputMaybe<Array<CosmosPageLegalContentsectionsUnionCreateInput>>;
};

export type CosmosPageLegalContentsectionsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageLegalContentsectionsUnion document */
  create?: InputMaybe<CosmosPageLegalContentsectionsUnionCreateInput>;
};

export type CosmosPageLegalContentsectionsUnionCreateWithPositionInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextCreateWithPositionInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleCreateWithPositionInput>;
};

export type CosmosPageLegalContentsectionsUnionUpdateInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateInput>;
};

export type CosmosPageLegalContentsectionsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageLegalContentsectionsUnion component instances */
  create?: InputMaybe<Array<CosmosPageLegalContentsectionsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageLegalContentsectionsUnion documents */
  delete?: InputMaybe<Array<CosmosPageLegalContentsectionsUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageLegalContentsectionsUnion component instances */
  update?: InputMaybe<Array<CosmosPageLegalContentsectionsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageLegalContentsectionsUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageLegalContentsectionsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageLegalContentsectionsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateManyWithNestedWhereInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateManyWithNestedWhereInput>;
};

export type CosmosPageLegalContentsectionsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageLegalContentsectionsUnion document */
  create?: InputMaybe<CosmosPageLegalContentsectionsUnionCreateInput>;
  /** Delete currently connected CosmosPageLegalContentsectionsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageLegalContentsectionsUnion document */
  update?: InputMaybe<CosmosPageLegalContentsectionsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageLegalContentsectionsUnion document */
  upsert?: InputMaybe<CosmosPageLegalContentsectionsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentsectionsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageLegalContentsectionsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentsectionsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageLegalContentsectionsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageLegalContentsectionsUnionWhereInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextWhereInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleWhereInput>;
};

export type CosmosPageLegalContentsectionsUnionWhereUniqueInput = {
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextWhereUniqueInput>;
  CosmosElementCkEditorTextCollapsible?: InputMaybe<CosmosElementCkEditorTextCollapsibleWhereUniqueInput>;
};

/** Model rendered at the /license page. */
export type CosmosPageLicense = Entity & Node & {
  __typename?: 'CosmosPageLicense';
  cardHeading?: Maybe<Scalars['String']['output']>;
  contactCard?: Maybe<CosmosElementLicenseContactCard>;
  contactCard2?: Maybe<CosmosElementLicenseContactCard>;
  /** An array of content large image sections above the license cards section */
  contentLargeImages: Array<CosmosSectionContentLargeImage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description just above the license cards section */
  desc?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageLicense>;
  freeCard?: Maybe<CosmosElementLicenseTopCard>;
  freeCardHeading?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<CosmosHeroGlow>;
  hideExampleLabel?: Maybe<Scalars['String']['output']>;
  /** List of CosmosPageLicense versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageLicense>;
  /** The two main cards for the license cards section (previously referred to as Royalty card and Subscription card) */
  mainCards: Array<CosmosElementLicenseMainCard>;
  metaTags?: Maybe<CosmosSeo>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refSections: Array<CosmosReferenceSection>;
  scheduledIn: Array<ScheduledOperation>;
  showExampleLabel?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Title just above the license cards section */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseContactCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseContactCard2Args = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseContentLargeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosSectionContentLargeImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseFreeCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseMainCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLicenseMainCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicensePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Model rendered at the /license page. */
export type CosmosPageLicensePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Model rendered at the /license page. */
export type CosmosPageLicenseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageLicenseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageLicenseWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageLicenseConnection = {
  __typename?: 'CosmosPageLicenseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageLicenseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageLicenseCreateInput = {
  /** cardHeading input for default locale (en) */
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  contactCard?: InputMaybe<CosmosElementLicenseContactCardCreateOneInlineInput>;
  contactCard2?: InputMaybe<CosmosElementLicenseContactCardCreateOneInlineInput>;
  contentLargeImages?: InputMaybe<CosmosSectionContentLargeImageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  freeCard?: InputMaybe<CosmosElementLicenseTopCardCreateOneInlineInput>;
  /** freeCardHeading input for default locale (en) */
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosHeroGlowCreateOneInlineInput>;
  /** hideExampleLabel input for default locale (en) */
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageLicenseCreateLocalizationsInput>;
  mainCards?: InputMaybe<CosmosElementLicenseMainCardCreateManyInlineInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  /** showExampleLabel input for default locale (en) */
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageLicenseCreateLocalizationDataInput = {
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageLicenseCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageLicenseCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageLicenseCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageLicenseCreateLocalizationInput>>;
};

export type CosmosPageLicenseCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageLicense documents */
  connect?: InputMaybe<Array<CosmosPageLicenseWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageLicense documents */
  create?: InputMaybe<Array<CosmosPageLicenseCreateInput>>;
};

export type CosmosPageLicenseCreateOneInlineInput = {
  /** Connect one existing CosmosPageLicense document */
  connect?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  /** Create and connect one CosmosPageLicense document */
  create?: InputMaybe<CosmosPageLicenseCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageLicenseEdge = {
  __typename?: 'CosmosPageLicenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageLicense;
};

/** Identifies documents */
export type CosmosPageLicenseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageLicenseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageLicenseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageLicenseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  contactCard?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  contactCard2?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  contentLargeImages_every?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  contentLargeImages_none?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  contentLargeImages_some?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageLicenseWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageLicenseWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageLicenseWhereStageInput>;
  freeCard?: InputMaybe<CosmosElementLicenseTopCardWhereInput>;
  hero?: InputMaybe<CosmosHeroGlowWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  mainCards_every?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  mainCards_none?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  mainCards_some?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageLicenseOrderByInput {
  CardHeadingAsc = 'cardHeading_ASC',
  CardHeadingDesc = 'cardHeading_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  FreeCardHeadingAsc = 'freeCardHeading_ASC',
  FreeCardHeadingDesc = 'freeCardHeading_DESC',
  HideExampleLabelAsc = 'hideExampleLabel_ASC',
  HideExampleLabelDesc = 'hideExampleLabel_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ShowExampleLabelAsc = 'showExampleLabel_ASC',
  ShowExampleLabelDesc = 'showExampleLabel_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageLicenseUpdateInput = {
  /** cardHeading input for default locale (en) */
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  contactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateOneInlineInput>;
  contactCard2?: InputMaybe<CosmosElementLicenseContactCardUpdateOneInlineInput>;
  contentLargeImages?: InputMaybe<CosmosSectionContentLargeImageUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  freeCard?: InputMaybe<CosmosElementLicenseTopCardUpdateOneInlineInput>;
  /** freeCardHeading input for default locale (en) */
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosHeroGlowUpdateOneInlineInput>;
  /** hideExampleLabel input for default locale (en) */
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageLicenseUpdateLocalizationsInput>;
  mainCards?: InputMaybe<CosmosElementLicenseMainCardUpdateManyInlineInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  /** showExampleLabel input for default locale (en) */
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLicenseUpdateLocalizationDataInput = {
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLicenseUpdateLocalizationInput = {
  data: CosmosPageLicenseUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageLicenseUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageLicenseCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageLicenseUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageLicenseUpsertLocalizationInput>>;
};

export type CosmosPageLicenseUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageLicense documents */
  connect?: InputMaybe<Array<CosmosPageLicenseConnectInput>>;
  /** Create and connect multiple CosmosPageLicense documents */
  create?: InputMaybe<Array<CosmosPageLicenseCreateInput>>;
  /** Delete multiple CosmosPageLicense documents */
  delete?: InputMaybe<Array<CosmosPageLicenseWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageLicense documents */
  disconnect?: InputMaybe<Array<CosmosPageLicenseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageLicense documents */
  set?: InputMaybe<Array<CosmosPageLicenseWhereUniqueInput>>;
  /** Update multiple CosmosPageLicense documents */
  update?: InputMaybe<Array<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageLicense documents */
  upsert?: InputMaybe<Array<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageLicenseUpdateManyInput = {
  /** cardHeading input for default locale (en) */
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** freeCardHeading input for default locale (en) */
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  /** hideExampleLabel input for default locale (en) */
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageLicenseUpdateManyLocalizationsInput>;
  /** showExampleLabel input for default locale (en) */
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLicenseUpdateManyLocalizationDataInput = {
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageLicenseUpdateManyLocalizationInput = {
  data: CosmosPageLicenseUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageLicenseUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageLicenseUpdateManyLocalizationInput>>;
};

export type CosmosPageLicenseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageLicenseUpdateManyInput;
  /** Document search */
  where: CosmosPageLicenseWhereInput;
};

export type CosmosPageLicenseUpdateOneInlineInput = {
  /** Connect existing CosmosPageLicense document */
  connect?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  /** Create and connect one CosmosPageLicense document */
  create?: InputMaybe<CosmosPageLicenseCreateInput>;
  /** Delete currently connected CosmosPageLicense document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageLicense document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageLicense document */
  update?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageLicense document */
  upsert?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageLicenseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageLicenseUpdateInput;
  /** Unique document search */
  where: CosmosPageLicenseWhereUniqueInput;
};

export type CosmosPageLicenseUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageLicenseCreateInput;
  /** Update document if it exists */
  update: CosmosPageLicenseUpdateInput;
};

export type CosmosPageLicenseUpsertLocalizationInput = {
  create: CosmosPageLicenseCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageLicenseUpdateLocalizationDataInput;
};

export type CosmosPageLicenseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageLicenseUpsertInput;
  /** Unique document search */
  where: CosmosPageLicenseWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageLicenseWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageLicenseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageLicenseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageLicenseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageLicenseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  contactCard?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  contactCard2?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  contentLargeImages_every?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  contentLargeImages_none?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  contentLargeImages_some?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CosmosPageLicenseWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageLicenseWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageLicenseWhereStageInput>;
  freeCard?: InputMaybe<CosmosElementLicenseTopCardWhereInput>;
  freeCardHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  freeCardHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  freeCardHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  freeCardHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  freeCardHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  freeCardHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  freeCardHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  freeCardHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  freeCardHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  freeCardHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosHeroGlowWhereInput>;
  hideExampleLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  hideExampleLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  hideExampleLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  hideExampleLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  hideExampleLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  hideExampleLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  hideExampleLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  hideExampleLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  hideExampleLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  hideExampleLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  mainCards_every?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  mainCards_none?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  mainCards_some?: InputMaybe<CosmosElementLicenseMainCardWhereInput>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showExampleLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  showExampleLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  showExampleLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  showExampleLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  showExampleLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  showExampleLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  showExampleLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  showExampleLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  showExampleLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  showExampleLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageLicenseWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageLicenseWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageLicenseWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageLicenseWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageLicenseWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageLicense record uniquely */
export type CosmosPageLicenseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPagePluginDetail = Entity & Node & {
  __typename?: 'CosmosPagePluginDetail';
  /** Optional field to override text for "Archived versions" list Title */
  archivedVersionsTitle?: Maybe<Scalars['String']['output']>;
  articleComponents: Array<CosmosPagePluginDetailarticleComponentsUnion>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPagePluginDetail>;
  /** Manually provide the plugin downloads. The first in the list is assumed latest. */
  downloads: Array<CosmosElementPluginDownload>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<CosmosPagePluginDetailheroUnion>;
  /** List of CosmosPagePluginDetail versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  latestCardSections: Array<CosmosElementTitleAndDesc>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPagePluginDetail>;
  metaTags?: Maybe<CosmosSeo>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refSections: Array<CosmosReferenceSection>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPagePluginDetailArticleComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosPagePluginDetailCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPagePluginDetailCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPagePluginDetailDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPagePluginDetailDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementPluginDownloadOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
};


export type CosmosPagePluginDetailHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPagePluginDetailHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPagePluginDetailLatestCardSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTitleAndDescOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
};


export type CosmosPagePluginDetailLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPagePluginDetailMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPagePluginDetailPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPagePluginDetailPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPagePluginDetailRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type CosmosPagePluginDetailScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPagePluginDetailUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPagePluginDetailUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPagePluginDetailConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPagePluginDetailWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPagePluginDetailConnection = {
  __typename?: 'CosmosPagePluginDetailConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPagePluginDetailEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPagePluginDetailCreateInput = {
  /** archivedVersionsTitle input for default locale (en) */
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  articleComponents?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloads?: InputMaybe<CosmosElementPluginDownloadCreateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPagePluginDetailheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  latestCardSections?: InputMaybe<CosmosElementTitleAndDescCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPagePluginDetailCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPagePluginDetailCreateLocalizationDataInput = {
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPagePluginDetailCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPagePluginDetailCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPagePluginDetailCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPagePluginDetailCreateLocalizationInput>>;
};

export type CosmosPagePluginDetailCreateManyInlineInput = {
  /** Connect multiple existing CosmosPagePluginDetail documents */
  connect?: InputMaybe<Array<CosmosPagePluginDetailWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPagePluginDetail documents */
  create?: InputMaybe<Array<CosmosPagePluginDetailCreateInput>>;
};

export type CosmosPagePluginDetailCreateOneInlineInput = {
  /** Connect one existing CosmosPagePluginDetail document */
  connect?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  /** Create and connect one CosmosPagePluginDetail document */
  create?: InputMaybe<CosmosPagePluginDetailCreateInput>;
};

/** An edge in a connection. */
export type CosmosPagePluginDetailEdge = {
  __typename?: 'CosmosPagePluginDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPagePluginDetail;
};

/** Identifies documents */
export type CosmosPagePluginDetailManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPagePluginDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPagePluginDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPagePluginDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  articleComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  articleComponents_some?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPagePluginDetailWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPagePluginDetailWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPagePluginDetailWhereStageInput>;
  downloads_every?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  downloads_none?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  downloads_some?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPagePluginDetailheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  latestCardSections_every?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  latestCardSections_none?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  latestCardSections_some?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPagePluginDetailOrderByInput {
  ArchivedVersionsTitleAsc = 'archivedVersionsTitle_ASC',
  ArchivedVersionsTitleDesc = 'archivedVersionsTitle_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPagePluginDetailUpdateInput = {
  /** archivedVersionsTitle input for default locale (en) */
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  articleComponents?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionUpdateManyInlineInput>;
  downloads?: InputMaybe<CosmosElementPluginDownloadUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPagePluginDetailheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  latestCardSections?: InputMaybe<CosmosElementTitleAndDescUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPagePluginDetailUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  refSections?: InputMaybe<CosmosReferenceSectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPagePluginDetailUpdateLocalizationDataInput = {
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPagePluginDetailUpdateLocalizationInput = {
  data: CosmosPagePluginDetailUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPagePluginDetailUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPagePluginDetailCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPagePluginDetailUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPagePluginDetailUpsertLocalizationInput>>;
};

export type CosmosPagePluginDetailUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPagePluginDetail documents */
  connect?: InputMaybe<Array<CosmosPagePluginDetailConnectInput>>;
  /** Create and connect multiple CosmosPagePluginDetail documents */
  create?: InputMaybe<Array<CosmosPagePluginDetailCreateInput>>;
  /** Delete multiple CosmosPagePluginDetail documents */
  delete?: InputMaybe<Array<CosmosPagePluginDetailWhereUniqueInput>>;
  /** Disconnect multiple CosmosPagePluginDetail documents */
  disconnect?: InputMaybe<Array<CosmosPagePluginDetailWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPagePluginDetail documents */
  set?: InputMaybe<Array<CosmosPagePluginDetailWhereUniqueInput>>;
  /** Update multiple CosmosPagePluginDetail documents */
  update?: InputMaybe<Array<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPagePluginDetail documents */
  upsert?: InputMaybe<Array<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPagePluginDetailUpdateManyInput = {
  /** archivedVersionsTitle input for default locale (en) */
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPagePluginDetailUpdateManyLocalizationsInput>;
};

export type CosmosPagePluginDetailUpdateManyLocalizationDataInput = {
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPagePluginDetailUpdateManyLocalizationInput = {
  data: CosmosPagePluginDetailUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPagePluginDetailUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPagePluginDetailUpdateManyLocalizationInput>>;
};

export type CosmosPagePluginDetailUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPagePluginDetailUpdateManyInput;
  /** Document search */
  where: CosmosPagePluginDetailWhereInput;
};

export type CosmosPagePluginDetailUpdateOneInlineInput = {
  /** Connect existing CosmosPagePluginDetail document */
  connect?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  /** Create and connect one CosmosPagePluginDetail document */
  create?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  /** Delete currently connected CosmosPagePluginDetail document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPagePluginDetail document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPagePluginDetail document */
  update?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPagePluginDetail document */
  upsert?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPagePluginDetailUpdateInput;
  /** Unique document search */
  where: CosmosPagePluginDetailWhereUniqueInput;
};

export type CosmosPagePluginDetailUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPagePluginDetailCreateInput;
  /** Update document if it exists */
  update: CosmosPagePluginDetailUpdateInput;
};

export type CosmosPagePluginDetailUpsertLocalizationInput = {
  create: CosmosPagePluginDetailCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPagePluginDetailUpdateLocalizationDataInput;
};

export type CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPagePluginDetailUpsertInput;
  /** Unique document search */
  where: CosmosPagePluginDetailWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPagePluginDetailWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPagePluginDetailWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPagePluginDetailWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPagePluginDetailWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPagePluginDetailWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  archivedVersionsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  archivedVersionsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  archivedVersionsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  archivedVersionsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  archivedVersionsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  archivedVersionsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  archivedVersionsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  archivedVersionsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  archivedVersionsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  archivedVersionsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  articleComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  articleComponents_some?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPagePluginDetailWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPagePluginDetailWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPagePluginDetailWhereStageInput>;
  downloads_every?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  downloads_none?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  downloads_some?: InputMaybe<CosmosElementPluginDownloadWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPagePluginDetailheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  latestCardSections_every?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  latestCardSections_none?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  latestCardSections_some?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_none?: InputMaybe<CosmosReferenceSectionWhereInput>;
  refSections_some?: InputMaybe<CosmosReferenceSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPagePluginDetailWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPagePluginDetailWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPagePluginDetailWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPagePluginDetailWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPagePluginDetailWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPagePluginDetail record uniquely */
export type CosmosPagePluginDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPagePluginDetailarticleComponentsUnion = CosmosElementAsset | CosmosElementButtonList | CosmosElementCalloutCard | CosmosElementCkEditorText | CosmosElementCompare | CosmosElementGithubGist | CosmosElementInterview | CosmosElementLicenseContactCard | CosmosElementQuote | CosmosElementRichText | CosmosElementSectionHeading | CosmosElementTitleAndDesc | CosmosElementUserProfile | CosmosElementVideoEmbed | CosmosSectionAssetCarousel | CosmosSectionAssetGallery | CosmosSectionContentLargeImage | CosmosSectionDivider | CosmosSectionLogoList | CosmosSectionLogoMultiCard | CosmosSectionNewsMediaCard;

export type CosmosPagePluginDetailarticleComponentsUnionConnectInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetConnectInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListConnectInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardConnectInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextConnectInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareConnectInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistConnectInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewConnectInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardConnectInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteConnectInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextConnectInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingConnectInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescConnectInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileConnectInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedConnectInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselConnectInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryConnectInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageConnectInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerConnectInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardConnectInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionCreateInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetCreateInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListCreateInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardCreateInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextCreateInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareCreateInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistCreateInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewCreateInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardCreateInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteCreateInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextCreateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescCreateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedCreateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerCreateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPagePluginDetailarticleComponentsUnion documents */
  create?: InputMaybe<Array<CosmosPagePluginDetailarticleComponentsUnionCreateInput>>;
};

export type CosmosPagePluginDetailarticleComponentsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPagePluginDetailarticleComponentsUnion document */
  create?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionCreateInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionCreateWithPositionInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetCreateWithPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListCreateWithPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardCreateWithPositionInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextCreateWithPositionInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareCreateWithPositionInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistCreateWithPositionInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewCreateWithPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardCreateWithPositionInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteCreateWithPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextCreateWithPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingCreateWithPositionInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescCreateWithPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileCreateWithPositionInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedCreateWithPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateWithPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateWithPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateWithPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerCreateWithPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateWithPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateWithPositionInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpdateInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPagePluginDetailarticleComponentsUnion component instances */
  create?: InputMaybe<Array<CosmosPagePluginDetailarticleComponentsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPagePluginDetailarticleComponentsUnion documents */
  delete?: InputMaybe<Array<CosmosPagePluginDetailarticleComponentsUnionWhereUniqueInput>>;
  /** Update multiple CosmosPagePluginDetailarticleComponentsUnion component instances */
  update?: InputMaybe<Array<CosmosPagePluginDetailarticleComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPagePluginDetailarticleComponentsUnion component instances */
  upsert?: InputMaybe<Array<CosmosPagePluginDetailarticleComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateManyWithNestedWhereInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateManyWithNestedWhereInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateManyWithNestedWhereInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateManyWithNestedWhereInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateManyWithNestedWhereInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateManyWithNestedWhereInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateManyWithNestedWhereInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateManyWithNestedWhereInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateManyWithNestedWhereInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateManyWithNestedWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateManyWithNestedWhereInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateManyWithNestedWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateManyWithNestedWhereInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateManyWithNestedWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateManyWithNestedWhereInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPagePluginDetailarticleComponentsUnion document */
  create?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionCreateInput>;
  /** Delete currently connected CosmosPagePluginDetailarticleComponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPagePluginDetailarticleComponentsUnion document */
  update?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPagePluginDetailarticleComponentsUnion document */
  upsert?: InputMaybe<CosmosPagePluginDetailarticleComponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpdateWithNestedWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpdateWithNestedWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpdateWithNestedWhereUniqueInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpdateWithNestedWhereUniqueInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpdateWithNestedWhereUniqueInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpdateWithNestedWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpdateWithNestedWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpdateWithNestedWhereUniqueInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpdateWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpdateWithNestedWhereUniqueInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetUpsertWithNestedWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListUpsertWithNestedWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextUpsertWithNestedWhereUniqueInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareUpsertWithNestedWhereUniqueInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistUpsertWithNestedWhereUniqueInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewUpsertWithNestedWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteUpsertWithNestedWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingUpsertWithNestedWhereUniqueInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescUpsertWithNestedWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileUpsertWithNestedWhereUniqueInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionWhereInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetWhereInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListWhereInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardWhereInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextWhereInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareWhereInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistWhereInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewWhereInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteWhereInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextWhereInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescWhereInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereInput>;
};

export type CosmosPagePluginDetailarticleComponentsUnionWhereUniqueInput = {
  CosmosElementAsset?: InputMaybe<CosmosElementAssetWhereUniqueInput>;
  CosmosElementButtonList?: InputMaybe<CosmosElementButtonListWhereUniqueInput>;
  CosmosElementCalloutCard?: InputMaybe<CosmosElementCalloutCardWhereUniqueInput>;
  CosmosElementCkEditorText?: InputMaybe<CosmosElementCkEditorTextWhereUniqueInput>;
  CosmosElementCompare?: InputMaybe<CosmosElementCompareWhereUniqueInput>;
  CosmosElementGithubGist?: InputMaybe<CosmosElementGithubGistWhereUniqueInput>;
  CosmosElementInterview?: InputMaybe<CosmosElementInterviewWhereUniqueInput>;
  CosmosElementLicenseContactCard?: InputMaybe<CosmosElementLicenseContactCardWhereUniqueInput>;
  CosmosElementQuote?: InputMaybe<CosmosElementQuoteWhereUniqueInput>;
  CosmosElementRichText?: InputMaybe<CosmosElementRichTextWhereUniqueInput>;
  CosmosElementSectionHeading?: InputMaybe<CosmosElementSectionHeadingWhereUniqueInput>;
  CosmosElementTitleAndDesc?: InputMaybe<CosmosElementTitleAndDescWhereUniqueInput>;
  CosmosElementUserProfile?: InputMaybe<CosmosElementUserProfileWhereUniqueInput>;
  CosmosElementVideoEmbed?: InputMaybe<CosmosElementVideoEmbedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereUniqueInput>;
};

export type CosmosPagePluginDetailheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPagePluginDetailheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPagePluginDetailheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPagePluginDetailheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPagePluginDetailheroUnion documents */
  create?: InputMaybe<Array<CosmosPagePluginDetailheroUnionCreateInput>>;
};

export type CosmosPagePluginDetailheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPagePluginDetailheroUnion document */
  create?: InputMaybe<CosmosPagePluginDetailheroUnionCreateInput>;
};

export type CosmosPagePluginDetailheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPagePluginDetailheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPagePluginDetailheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPagePluginDetailheroUnion component instances */
  create?: InputMaybe<Array<CosmosPagePluginDetailheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPagePluginDetailheroUnion documents */
  delete?: InputMaybe<Array<CosmosPagePluginDetailheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPagePluginDetailheroUnion component instances */
  update?: InputMaybe<Array<CosmosPagePluginDetailheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPagePluginDetailheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPagePluginDetailheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPagePluginDetailheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPagePluginDetailheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPagePluginDetailheroUnion document */
  create?: InputMaybe<CosmosPagePluginDetailheroUnionCreateInput>;
  /** Delete currently connected CosmosPagePluginDetailheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPagePluginDetailheroUnion document */
  update?: InputMaybe<CosmosPagePluginDetailheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPagePluginDetailheroUnion document */
  upsert?: InputMaybe<CosmosPagePluginDetailheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPagePluginDetailheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPagePluginDetailheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPagePluginDetailheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPagePluginDetailheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

/** A page which simply redirects somewhere else. */
export type CosmosPageRedirect = Entity & Node & {
  __typename?: 'CosmosPageRedirect';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Relative or absolute URL to use as the destination. */
  destination: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageRedirect>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CosmosPageRedirect versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageRedirect>;
  /** The owner for this page.  Set this field if this page belongs to an application other than the default. */
  owner?: Maybe<WfRefApplicationOwner>;
  /** This redirect will never ever change and will always go to the specified destination. */
  permanent?: Maybe<Scalars['Boolean']['output']>;
  prefixWithLocaleMatcher?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The path to redirect. Starts with a slash. e.g. /uses/games/indie-games */
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectOwnerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** A page which simply redirects somewhere else. */
export type CosmosPageRedirectUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageRedirectConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageRedirectWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageRedirectConnection = {
  __typename?: 'CosmosPageRedirectConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageRedirectEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageRedirectCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  destination: Scalars['String']['input'];
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageRedirectCreateLocalizationsInput>;
  owner?: InputMaybe<WfRefApplicationOwnerCreateOneInlineInput>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  prefixWithLocaleMatcher?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageRedirectCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageRedirectCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageRedirectCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageRedirectCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageRedirectCreateLocalizationInput>>;
};

export type CosmosPageRedirectCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageRedirect documents */
  connect?: InputMaybe<Array<CosmosPageRedirectWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageRedirect documents */
  create?: InputMaybe<Array<CosmosPageRedirectCreateInput>>;
};

export type CosmosPageRedirectCreateOneInlineInput = {
  /** Connect one existing CosmosPageRedirect document */
  connect?: InputMaybe<CosmosPageRedirectWhereUniqueInput>;
  /** Create and connect one CosmosPageRedirect document */
  create?: InputMaybe<CosmosPageRedirectCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageRedirectEdge = {
  __typename?: 'CosmosPageRedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageRedirect;
};

/** Identifies documents */
export type CosmosPageRedirectManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageRedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageRedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageRedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  destination_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  destination_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  destination_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  destination_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  destination_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CosmosPageRedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageRedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageRedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  permanent_not?: InputMaybe<Scalars['Boolean']['input']>;
  prefixWithLocaleMatcher?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  prefixWithLocaleMatcher_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageRedirectOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DestinationAsc = 'destination_ASC',
  DestinationDesc = 'destination_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PermanentAsc = 'permanent_ASC',
  PermanentDesc = 'permanent_DESC',
  PrefixWithLocaleMatcherAsc = 'prefixWithLocaleMatcher_ASC',
  PrefixWithLocaleMatcherDesc = 'prefixWithLocaleMatcher_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageRedirectUpdateInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageRedirectUpdateLocalizationsInput>;
  owner?: InputMaybe<WfRefApplicationOwnerUpdateOneInlineInput>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  prefixWithLocaleMatcher?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageRedirectUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageRedirectUpdateLocalizationInput = {
  data: CosmosPageRedirectUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageRedirectUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageRedirectCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageRedirectUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageRedirectUpsertLocalizationInput>>;
};

export type CosmosPageRedirectUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageRedirect documents */
  connect?: InputMaybe<Array<CosmosPageRedirectConnectInput>>;
  /** Create and connect multiple CosmosPageRedirect documents */
  create?: InputMaybe<Array<CosmosPageRedirectCreateInput>>;
  /** Delete multiple CosmosPageRedirect documents */
  delete?: InputMaybe<Array<CosmosPageRedirectWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageRedirect documents */
  disconnect?: InputMaybe<Array<CosmosPageRedirectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageRedirect documents */
  set?: InputMaybe<Array<CosmosPageRedirectWhereUniqueInput>>;
  /** Update multiple CosmosPageRedirect documents */
  update?: InputMaybe<Array<CosmosPageRedirectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageRedirect documents */
  upsert?: InputMaybe<Array<CosmosPageRedirectUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageRedirectUpdateManyInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageRedirectUpdateManyLocalizationsInput>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  prefixWithLocaleMatcher?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosPageRedirectUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageRedirectUpdateManyLocalizationInput = {
  data: CosmosPageRedirectUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageRedirectUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageRedirectUpdateManyLocalizationInput>>;
};

export type CosmosPageRedirectUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageRedirectUpdateManyInput;
  /** Document search */
  where: CosmosPageRedirectWhereInput;
};

export type CosmosPageRedirectUpdateOneInlineInput = {
  /** Connect existing CosmosPageRedirect document */
  connect?: InputMaybe<CosmosPageRedirectWhereUniqueInput>;
  /** Create and connect one CosmosPageRedirect document */
  create?: InputMaybe<CosmosPageRedirectCreateInput>;
  /** Delete currently connected CosmosPageRedirect document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageRedirect document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageRedirect document */
  update?: InputMaybe<CosmosPageRedirectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageRedirect document */
  upsert?: InputMaybe<CosmosPageRedirectUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageRedirectUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageRedirectUpdateInput;
  /** Unique document search */
  where: CosmosPageRedirectWhereUniqueInput;
};

export type CosmosPageRedirectUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageRedirectCreateInput;
  /** Update document if it exists */
  update: CosmosPageRedirectUpdateInput;
};

export type CosmosPageRedirectUpsertLocalizationInput = {
  create: CosmosPageRedirectCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageRedirectUpdateLocalizationDataInput;
};

export type CosmosPageRedirectUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageRedirectUpsertInput;
  /** Unique document search */
  where: CosmosPageRedirectWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageRedirectWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageRedirectWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageRedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageRedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageRedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  destination_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  destination_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  destination_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  destination_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  destination_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CosmosPageRedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageRedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageRedirectWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  owner?: InputMaybe<WfRefApplicationOwnerWhereInput>;
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  permanent_not?: InputMaybe<Scalars['Boolean']['input']>;
  prefixWithLocaleMatcher?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  prefixWithLocaleMatcher_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageRedirectWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageRedirectWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageRedirectWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageRedirectWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageRedirectWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageRedirect record uniquely */
export type CosmosPageRedirectWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageResearch = Entity & Node & {
  __typename?: 'CosmosPageResearch';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageResearch>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<CosmosPageResearchheroUnion>;
  /** List of CosmosPageResearch versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageResearch>;
  metaTags?: Maybe<CosmosSeo>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  researchCards: Array<CosmosElementResearchCard>;
  researchCardsSectionConfig?: Maybe<CosmosConfigSection>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageResearchCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageResearchCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageResearchDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageResearchHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageResearchHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageResearchLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageResearchMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageResearchPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageResearchPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageResearchResearchCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementResearchCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementResearchCardWhereInput>;
};


export type CosmosPageResearchResearchCardsSectionConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageResearchScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageResearchUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageResearchUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageResearchConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageResearchWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageResearchConnection = {
  __typename?: 'CosmosPageResearchConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageResearchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageResearchCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageResearchheroUnionCreateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageResearchCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  researchCards?: InputMaybe<CosmosElementResearchCardCreateManyInlineInput>;
  researchCardsSectionConfig?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageResearchCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageResearchCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageResearchCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageResearchCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageResearchCreateLocalizationInput>>;
};

export type CosmosPageResearchCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageResearch documents */
  connect?: InputMaybe<Array<CosmosPageResearchWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageResearch documents */
  create?: InputMaybe<Array<CosmosPageResearchCreateInput>>;
};

export type CosmosPageResearchCreateOneInlineInput = {
  /** Connect one existing CosmosPageResearch document */
  connect?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
  /** Create and connect one CosmosPageResearch document */
  create?: InputMaybe<CosmosPageResearchCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageResearchEdge = {
  __typename?: 'CosmosPageResearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageResearch;
};

/** Identifies documents */
export type CosmosPageResearchManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageResearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageResearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageResearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageResearchWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageResearchWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageResearchWhereStageInput>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageResearchheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  researchCardsSectionConfig?: InputMaybe<CosmosConfigSectionWhereInput>;
  researchCards_every?: InputMaybe<CosmosElementResearchCardWhereInput>;
  researchCards_none?: InputMaybe<CosmosElementResearchCardWhereInput>;
  researchCards_some?: InputMaybe<CosmosElementResearchCardWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageResearchOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageResearchUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hero?: InputMaybe<CosmosPageResearchheroUnionUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageResearchUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  researchCards?: InputMaybe<CosmosElementResearchCardUpdateManyInlineInput>;
  researchCardsSectionConfig?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageResearchUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageResearchUpdateLocalizationInput = {
  data: CosmosPageResearchUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageResearchUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageResearchCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageResearchUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageResearchUpsertLocalizationInput>>;
};

export type CosmosPageResearchUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageResearch documents */
  connect?: InputMaybe<Array<CosmosPageResearchConnectInput>>;
  /** Create and connect multiple CosmosPageResearch documents */
  create?: InputMaybe<Array<CosmosPageResearchCreateInput>>;
  /** Delete multiple CosmosPageResearch documents */
  delete?: InputMaybe<Array<CosmosPageResearchWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageResearch documents */
  disconnect?: InputMaybe<Array<CosmosPageResearchWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageResearch documents */
  set?: InputMaybe<Array<CosmosPageResearchWhereUniqueInput>>;
  /** Update multiple CosmosPageResearch documents */
  update?: InputMaybe<Array<CosmosPageResearchUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageResearch documents */
  upsert?: InputMaybe<Array<CosmosPageResearchUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageResearchUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageResearchUpdateManyLocalizationsInput>;
};

export type CosmosPageResearchUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageResearchUpdateManyLocalizationInput = {
  data: CosmosPageResearchUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageResearchUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageResearchUpdateManyLocalizationInput>>;
};

export type CosmosPageResearchUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageResearchUpdateManyInput;
  /** Document search */
  where: CosmosPageResearchWhereInput;
};

export type CosmosPageResearchUpdateOneInlineInput = {
  /** Connect existing CosmosPageResearch document */
  connect?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
  /** Create and connect one CosmosPageResearch document */
  create?: InputMaybe<CosmosPageResearchCreateInput>;
  /** Delete currently connected CosmosPageResearch document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageResearch document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageResearch document */
  update?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageResearch document */
  upsert?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageResearchUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageResearchUpdateInput;
  /** Unique document search */
  where: CosmosPageResearchWhereUniqueInput;
};

export type CosmosPageResearchUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageResearchCreateInput;
  /** Update document if it exists */
  update: CosmosPageResearchUpdateInput;
};

export type CosmosPageResearchUpsertLocalizationInput = {
  create: CosmosPageResearchCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageResearchUpdateLocalizationDataInput;
};

export type CosmosPageResearchUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageResearchUpsertInput;
  /** Unique document search */
  where: CosmosPageResearchWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageResearchWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageResearchWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageResearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageResearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageResearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageResearchWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageResearchWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageResearchWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the modular component is connected to the given models */
  hero?: InputMaybe<CosmosPageResearchheroUnionWhereInput>;
  /** All values in which the union is empty. */
  hero_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  researchCardsSectionConfig?: InputMaybe<CosmosConfigSectionWhereInput>;
  researchCards_every?: InputMaybe<CosmosElementResearchCardWhereInput>;
  researchCards_none?: InputMaybe<CosmosElementResearchCardWhereInput>;
  researchCards_some?: InputMaybe<CosmosElementResearchCardWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageResearchWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageResearchWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageResearchWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageResearchWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageResearchWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageResearch record uniquely */
export type CosmosPageResearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageResearchheroUnion = CosmosHeroAlpha | CosmosHeroArticleImage | CosmosHeroBravo | CosmosHeroGlow;

export type CosmosPageResearchheroUnionConnectInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaConnectInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageConnectInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoConnectInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowConnectInput>;
};

export type CosmosPageResearchheroUnionCreateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateInput>;
};

export type CosmosPageResearchheroUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosPageResearchheroUnion documents */
  create?: InputMaybe<Array<CosmosPageResearchheroUnionCreateInput>>;
};

export type CosmosPageResearchheroUnionCreateOneInlineInput = {
  /** Create and connect one CosmosPageResearchheroUnion document */
  create?: InputMaybe<CosmosPageResearchheroUnionCreateInput>;
};

export type CosmosPageResearchheroUnionCreateWithPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaCreateWithPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageCreateWithPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoCreateWithPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowCreateWithPositionInput>;
};

export type CosmosPageResearchheroUnionUpdateInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateInput>;
};

export type CosmosPageResearchheroUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosPageResearchheroUnion component instances */
  create?: InputMaybe<Array<CosmosPageResearchheroUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosPageResearchheroUnion documents */
  delete?: InputMaybe<Array<CosmosPageResearchheroUnionWhereUniqueInput>>;
  /** Update multiple CosmosPageResearchheroUnion component instances */
  update?: InputMaybe<Array<CosmosPageResearchheroUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosPageResearchheroUnion component instances */
  upsert?: InputMaybe<Array<CosmosPageResearchheroUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosPageResearchheroUnionUpdateManyWithNestedWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateManyWithNestedWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateManyWithNestedWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateManyWithNestedWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateManyWithNestedWhereInput>;
};

export type CosmosPageResearchheroUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosPageResearchheroUnion document */
  create?: InputMaybe<CosmosPageResearchheroUnionCreateInput>;
  /** Delete currently connected CosmosPageResearchheroUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageResearchheroUnion document */
  update?: InputMaybe<CosmosPageResearchheroUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageResearchheroUnion document */
  upsert?: InputMaybe<CosmosPageResearchheroUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageResearchheroUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageResearchheroUnionUpdateWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpdateWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpdateWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpdateWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpdateWithNestedWhereUniqueInput>;
};

export type CosmosPageResearchheroUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosPageResearchheroUnionUpsertWithNestedWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaUpsertWithNestedWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageUpsertWithNestedWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoUpsertWithNestedWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageResearchheroUnionWhereInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereInput>;
};

export type CosmosPageResearchheroUnionWhereUniqueInput = {
  CosmosHeroAlpha?: InputMaybe<CosmosHeroAlphaWhereUniqueInput>;
  CosmosHeroArticleImage?: InputMaybe<CosmosHeroArticleImageWhereUniqueInput>;
  CosmosHeroBravo?: InputMaybe<CosmosHeroBravoWhereUniqueInput>;
  CosmosHeroGlow?: InputMaybe<CosmosHeroGlowWhereUniqueInput>;
};

export type CosmosPageSearch = Entity & Node & {
  __typename?: 'CosmosPageSearch';
  clearSearchLabel?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  defaultSearchFilter?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosPageSearch>;
  /** List of CosmosPageSearch versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** Shown when tags are loading. */
  loadingLabel?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosPageSearch>;
  metaTags?: Maybe<CosmosSeo>;
  /** Label for when Search returns no results */
  noResultsLabel?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  searchFilters: Array<CosmosElementSearchFilter>;
  searchPlaceholder?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  suggestedLinks: Array<CosmosElementGeminiCard>;
  suggestedLinksLabel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosPageSearchCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageSearchCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageSearchDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosPageSearchHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosPageSearchLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosPageSearchMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageSearchPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageSearchPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosPageSearchScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosPageSearchSearchFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementSearchFilterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementSearchFilterWhereInput>;
};


export type CosmosPageSearchSuggestedLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementGeminiCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementGeminiCardWhereInput>;
};


export type CosmosPageSearchUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosPageSearchUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosPageSearchConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosPageSearchWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosPageSearchConnection = {
  __typename?: 'CosmosPageSearchConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosPageSearchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosPageSearchCreateInput = {
  /** clearSearchLabel input for default locale (en) */
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** defaultSearchFilter input for default locale (en) */
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** loadingLabel input for default locale (en) */
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosPageSearchCreateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoCreateOneInlineInput>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<CosmosElementSearchFilterCreateManyInlineInput>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  suggestedLinks?: InputMaybe<CosmosElementGeminiCardCreateManyInlineInput>;
  /** suggestedLinksLabel input for default locale (en) */
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageSearchCreateLocalizationDataInput = {
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosPageSearchCreateLocalizationInput = {
  /** Localization input */
  data: CosmosPageSearchCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageSearchCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosPageSearchCreateLocalizationInput>>;
};

export type CosmosPageSearchCreateManyInlineInput = {
  /** Connect multiple existing CosmosPageSearch documents */
  connect?: InputMaybe<Array<CosmosPageSearchWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosPageSearch documents */
  create?: InputMaybe<Array<CosmosPageSearchCreateInput>>;
};

export type CosmosPageSearchCreateOneInlineInput = {
  /** Connect one existing CosmosPageSearch document */
  connect?: InputMaybe<CosmosPageSearchWhereUniqueInput>;
  /** Create and connect one CosmosPageSearch document */
  create?: InputMaybe<CosmosPageSearchCreateInput>;
};

/** An edge in a connection. */
export type CosmosPageSearchEdge = {
  __typename?: 'CosmosPageSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosPageSearch;
};

/** Identifies documents */
export type CosmosPageSearchManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosPageSearchWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageSearchWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageSearchWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchFilters_every?: InputMaybe<CosmosElementSearchFilterWhereInput>;
  searchFilters_none?: InputMaybe<CosmosElementSearchFilterWhereInput>;
  searchFilters_some?: InputMaybe<CosmosElementSearchFilterWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  suggestedLinks_every?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  suggestedLinks_none?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  suggestedLinks_some?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosPageSearchOrderByInput {
  ClearSearchLabelAsc = 'clearSearchLabel_ASC',
  ClearSearchLabelDesc = 'clearSearchLabel_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DefaultSearchFilterAsc = 'defaultSearchFilter_ASC',
  DefaultSearchFilterDesc = 'defaultSearchFilter_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  LoadingLabelAsc = 'loadingLabel_ASC',
  LoadingLabelDesc = 'loadingLabel_DESC',
  NoResultsLabelAsc = 'noResultsLabel_ASC',
  NoResultsLabelDesc = 'noResultsLabel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SearchPlaceholderAsc = 'searchPlaceholder_ASC',
  SearchPlaceholderDesc = 'searchPlaceholder_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SuggestedLinksLabelAsc = 'suggestedLinksLabel_ASC',
  SuggestedLinksLabelDesc = 'suggestedLinksLabel_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosPageSearchUpdateInput = {
  /** clearSearchLabel input for default locale (en) */
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  /** defaultSearchFilter input for default locale (en) */
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** loadingLabel input for default locale (en) */
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosPageSearchUpdateLocalizationsInput>;
  metaTags?: InputMaybe<CosmosSeoUpdateOneInlineInput>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<CosmosElementSearchFilterUpdateManyInlineInput>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  suggestedLinks?: InputMaybe<CosmosElementGeminiCardUpdateManyInlineInput>;
  /** suggestedLinksLabel input for default locale (en) */
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageSearchUpdateLocalizationDataInput = {
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageSearchUpdateLocalizationInput = {
  data: CosmosPageSearchUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageSearchUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosPageSearchCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageSearchUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosPageSearchUpsertLocalizationInput>>;
};

export type CosmosPageSearchUpdateManyInlineInput = {
  /** Connect multiple existing CosmosPageSearch documents */
  connect?: InputMaybe<Array<CosmosPageSearchConnectInput>>;
  /** Create and connect multiple CosmosPageSearch documents */
  create?: InputMaybe<Array<CosmosPageSearchCreateInput>>;
  /** Delete multiple CosmosPageSearch documents */
  delete?: InputMaybe<Array<CosmosPageSearchWhereUniqueInput>>;
  /** Disconnect multiple CosmosPageSearch documents */
  disconnect?: InputMaybe<Array<CosmosPageSearchWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosPageSearch documents */
  set?: InputMaybe<Array<CosmosPageSearchWhereUniqueInput>>;
  /** Update multiple CosmosPageSearch documents */
  update?: InputMaybe<Array<CosmosPageSearchUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosPageSearch documents */
  upsert?: InputMaybe<Array<CosmosPageSearchUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosPageSearchUpdateManyInput = {
  /** clearSearchLabel input for default locale (en) */
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  /** defaultSearchFilter input for default locale (en) */
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** loadingLabel input for default locale (en) */
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosPageSearchUpdateManyLocalizationsInput>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchPlaceholder input for default locale (en) */
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** suggestedLinksLabel input for default locale (en) */
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageSearchUpdateManyLocalizationDataInput = {
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosPageSearchUpdateManyLocalizationInput = {
  data: CosmosPageSearchUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosPageSearchUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosPageSearchUpdateManyLocalizationInput>>;
};

export type CosmosPageSearchUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosPageSearchUpdateManyInput;
  /** Document search */
  where: CosmosPageSearchWhereInput;
};

export type CosmosPageSearchUpdateOneInlineInput = {
  /** Connect existing CosmosPageSearch document */
  connect?: InputMaybe<CosmosPageSearchWhereUniqueInput>;
  /** Create and connect one CosmosPageSearch document */
  create?: InputMaybe<CosmosPageSearchCreateInput>;
  /** Delete currently connected CosmosPageSearch document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosPageSearch document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosPageSearch document */
  update?: InputMaybe<CosmosPageSearchUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosPageSearch document */
  upsert?: InputMaybe<CosmosPageSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosPageSearchUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosPageSearchUpdateInput;
  /** Unique document search */
  where: CosmosPageSearchWhereUniqueInput;
};

export type CosmosPageSearchUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosPageSearchCreateInput;
  /** Update document if it exists */
  update: CosmosPageSearchUpdateInput;
};

export type CosmosPageSearchUpsertLocalizationInput = {
  create: CosmosPageSearchCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosPageSearchUpdateLocalizationDataInput;
};

export type CosmosPageSearchUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosPageSearchUpsertInput;
  /** Unique document search */
  where: CosmosPageSearchWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosPageSearchWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosPageSearchWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  clearSearchLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  clearSearchLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  clearSearchLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  clearSearchLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  clearSearchLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  clearSearchLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  clearSearchLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  clearSearchLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  clearSearchLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  clearSearchLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  defaultSearchFilter?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  defaultSearchFilter_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  defaultSearchFilter_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  defaultSearchFilter_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  defaultSearchFilter_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  defaultSearchFilter_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  defaultSearchFilter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  defaultSearchFilter_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  defaultSearchFilter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  defaultSearchFilter_starts_with?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CosmosPageSearchWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosPageSearchWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosPageSearchWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  loadingLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  loadingLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  loadingLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  loadingLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  loadingLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  loadingLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  loadingLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  loadingLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  loadingLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  loadingLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<CosmosSeoWhereInput>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  noResultsLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  noResultsLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  noResultsLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  noResultsLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  noResultsLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  noResultsLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  noResultsLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  noResultsLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  noResultsLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchFilters_every?: InputMaybe<CosmosElementSearchFilterWhereInput>;
  searchFilters_none?: InputMaybe<CosmosElementSearchFilterWhereInput>;
  searchFilters_some?: InputMaybe<CosmosElementSearchFilterWhereInput>;
  searchPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  searchPlaceholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  searchPlaceholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  searchPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  searchPlaceholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  searchPlaceholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  searchPlaceholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  searchPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  searchPlaceholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  searchPlaceholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  suggestedLinksLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  suggestedLinksLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  suggestedLinksLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  suggestedLinksLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  suggestedLinksLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  suggestedLinksLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  suggestedLinksLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  suggestedLinksLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  suggestedLinksLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  suggestedLinksLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  suggestedLinks_every?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  suggestedLinks_none?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  suggestedLinks_some?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosPageSearchWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosPageSearchWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosPageSearchWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosPageSearchWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosPageSearchWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosPageSearch record uniquely */
export type CosmosPageSearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosRefIndustryList = Entity & Node & {
  __typename?: 'CosmosRefIndustryList';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosRefIndustryList>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CosmosRefIndustryList versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  industries: Array<CosmosElementIndustry>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosRefIndustryList>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosRefIndustryListCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosRefIndustryListCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosRefIndustryListDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosRefIndustryListHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosRefIndustryListIndustriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIndustryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIndustryWhereInput>;
};


export type CosmosRefIndustryListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosRefIndustryListPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosRefIndustryListPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosRefIndustryListScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosRefIndustryListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosRefIndustryListUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosRefIndustryListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosRefIndustryListWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosRefIndustryListConnection = {
  __typename?: 'CosmosRefIndustryListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosRefIndustryListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosRefIndustryListCreateInput = {
  cm2998dn201xq07o52ztr2nwn?: InputMaybe<CosmosSectionNewsletterSignupCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<CosmosElementIndustryCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosRefIndustryListCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosRefIndustryListCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosRefIndustryListCreateLocalizationInput = {
  /** Localization input */
  data: CosmosRefIndustryListCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosRefIndustryListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosRefIndustryListCreateLocalizationInput>>;
};

export type CosmosRefIndustryListCreateManyInlineInput = {
  /** Connect multiple existing CosmosRefIndustryList documents */
  connect?: InputMaybe<Array<CosmosRefIndustryListWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosRefIndustryList documents */
  create?: InputMaybe<Array<CosmosRefIndustryListCreateInput>>;
};

export type CosmosRefIndustryListCreateOneInlineInput = {
  /** Connect one existing CosmosRefIndustryList document */
  connect?: InputMaybe<CosmosRefIndustryListWhereUniqueInput>;
  /** Create and connect one CosmosRefIndustryList document */
  create?: InputMaybe<CosmosRefIndustryListCreateInput>;
};

/** An edge in a connection. */
export type CosmosRefIndustryListEdge = {
  __typename?: 'CosmosRefIndustryListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosRefIndustryList;
};

/** Identifies documents */
export type CosmosRefIndustryListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosRefIndustryListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosRefIndustryListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosRefIndustryListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosRefIndustryListWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosRefIndustryListWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosRefIndustryListWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  industries_every?: InputMaybe<CosmosElementIndustryWhereInput>;
  industries_none?: InputMaybe<CosmosElementIndustryWhereInput>;
  industries_some?: InputMaybe<CosmosElementIndustryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosRefIndustryListOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosRefIndustryListUpdateInput = {
  cm2998dn201xq07o52ztr2nwn?: InputMaybe<CosmosSectionNewsletterSignupUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<CosmosElementIndustryUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosRefIndustryListUpdateLocalizationsInput>;
};

export type CosmosRefIndustryListUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosRefIndustryListUpdateLocalizationInput = {
  data: CosmosRefIndustryListUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosRefIndustryListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosRefIndustryListCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosRefIndustryListUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosRefIndustryListUpsertLocalizationInput>>;
};

export type CosmosRefIndustryListUpdateManyInlineInput = {
  /** Connect multiple existing CosmosRefIndustryList documents */
  connect?: InputMaybe<Array<CosmosRefIndustryListConnectInput>>;
  /** Create and connect multiple CosmosRefIndustryList documents */
  create?: InputMaybe<Array<CosmosRefIndustryListCreateInput>>;
  /** Delete multiple CosmosRefIndustryList documents */
  delete?: InputMaybe<Array<CosmosRefIndustryListWhereUniqueInput>>;
  /** Disconnect multiple CosmosRefIndustryList documents */
  disconnect?: InputMaybe<Array<CosmosRefIndustryListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosRefIndustryList documents */
  set?: InputMaybe<Array<CosmosRefIndustryListWhereUniqueInput>>;
  /** Update multiple CosmosRefIndustryList documents */
  update?: InputMaybe<Array<CosmosRefIndustryListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosRefIndustryList documents */
  upsert?: InputMaybe<Array<CosmosRefIndustryListUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosRefIndustryListUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosRefIndustryListUpdateManyLocalizationsInput>;
};

export type CosmosRefIndustryListUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosRefIndustryListUpdateManyLocalizationInput = {
  data: CosmosRefIndustryListUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosRefIndustryListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosRefIndustryListUpdateManyLocalizationInput>>;
};

export type CosmosRefIndustryListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosRefIndustryListUpdateManyInput;
  /** Document search */
  where: CosmosRefIndustryListWhereInput;
};

export type CosmosRefIndustryListUpdateOneInlineInput = {
  /** Connect existing CosmosRefIndustryList document */
  connect?: InputMaybe<CosmosRefIndustryListWhereUniqueInput>;
  /** Create and connect one CosmosRefIndustryList document */
  create?: InputMaybe<CosmosRefIndustryListCreateInput>;
  /** Delete currently connected CosmosRefIndustryList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosRefIndustryList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosRefIndustryList document */
  update?: InputMaybe<CosmosRefIndustryListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosRefIndustryList document */
  upsert?: InputMaybe<CosmosRefIndustryListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosRefIndustryListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosRefIndustryListUpdateInput;
  /** Unique document search */
  where: CosmosRefIndustryListWhereUniqueInput;
};

export type CosmosRefIndustryListUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosRefIndustryListCreateInput;
  /** Update document if it exists */
  update: CosmosRefIndustryListUpdateInput;
};

export type CosmosRefIndustryListUpsertLocalizationInput = {
  create: CosmosRefIndustryListCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosRefIndustryListUpdateLocalizationDataInput;
};

export type CosmosRefIndustryListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosRefIndustryListUpsertInput;
  /** Unique document search */
  where: CosmosRefIndustryListWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosRefIndustryListWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosRefIndustryListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosRefIndustryListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosRefIndustryListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosRefIndustryListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosRefIndustryListWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosRefIndustryListWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosRefIndustryListWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  industries_every?: InputMaybe<CosmosElementIndustryWhereInput>;
  industries_none?: InputMaybe<CosmosElementIndustryWhereInput>;
  industries_some?: InputMaybe<CosmosElementIndustryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosRefIndustryListWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosRefIndustryListWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosRefIndustryListWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosRefIndustryListWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosRefIndustryListWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosRefIndustryList record uniquely */
export type CosmosRefIndustryListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItem = Entity & Node & {
  __typename?: 'CosmosReferenceFAQItem';
  anchorLinkId?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosReferenceFaqItem>;
  /** List of CosmosReferenceFAQItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosReferenceFaqItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  question?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
export type CosmosReferenceFaqItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosReferenceFaqItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosReferenceFaqItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosReferenceFaqItemConnection = {
  __typename?: 'CosmosReferenceFAQItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosReferenceFaqItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosReferenceFaqItemCreateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['String']['input']>;
  cmkbkbzpx1gvd07n18dgx0y62?: InputMaybe<CosmosSectionFaqCreateManyInlineInput>;
  cosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosReferenceFaqItemCreateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosReferenceFaqItemCreateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosReferenceFaqItemCreateLocalizationInput = {
  /** Localization input */
  data: CosmosReferenceFaqItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosReferenceFaqItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosReferenceFaqItemCreateLocalizationInput>>;
};

export type CosmosReferenceFaqItemCreateManyInlineInput = {
  /** Connect multiple existing CosmosReferenceFAQItem documents */
  connect?: InputMaybe<Array<CosmosReferenceFaqItemWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosReferenceFAQItem documents */
  create?: InputMaybe<Array<CosmosReferenceFaqItemCreateInput>>;
};

export type CosmosReferenceFaqItemCreateOneInlineInput = {
  /** Connect one existing CosmosReferenceFAQItem document */
  connect?: InputMaybe<CosmosReferenceFaqItemWhereUniqueInput>;
  /** Create and connect one CosmosReferenceFAQItem document */
  create?: InputMaybe<CosmosReferenceFaqItemCreateInput>;
};

/** An edge in a connection. */
export type CosmosReferenceFaqItemEdge = {
  __typename?: 'CosmosReferenceFAQItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosReferenceFaqItem;
};

/** Identifies documents */
export type CosmosReferenceFaqItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosReferenceFaqItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosReferenceFaqItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosReferenceFaqItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosReferenceFaqItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosReferenceFaqItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosReferenceFaqItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosReferenceFaqItemOrderByInput {
  AnchorLinkIdAsc = 'anchorLinkId_ASC',
  AnchorLinkIdDesc = 'anchorLinkId_DESC',
  AnswerAsc = 'answer_ASC',
  AnswerDesc = 'answer_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosReferenceFaqItemUpdateInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['String']['input']>;
  cmkbkbzpx1gvd07n18dgx0y62?: InputMaybe<CosmosSectionFaqUpdateManyInlineInput>;
  cosmosElementFaqTab?: InputMaybe<CosmosElementFaqTabUpdateOneInlineInput>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosReferenceFaqItemUpdateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosReferenceFaqItemUpdateLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosReferenceFaqItemUpdateLocalizationInput = {
  data: CosmosReferenceFaqItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosReferenceFaqItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosReferenceFaqItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosReferenceFaqItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosReferenceFaqItemUpsertLocalizationInput>>;
};

export type CosmosReferenceFaqItemUpdateManyInlineInput = {
  /** Connect multiple existing CosmosReferenceFAQItem documents */
  connect?: InputMaybe<Array<CosmosReferenceFaqItemConnectInput>>;
  /** Create and connect multiple CosmosReferenceFAQItem documents */
  create?: InputMaybe<Array<CosmosReferenceFaqItemCreateInput>>;
  /** Delete multiple CosmosReferenceFAQItem documents */
  delete?: InputMaybe<Array<CosmosReferenceFaqItemWhereUniqueInput>>;
  /** Disconnect multiple CosmosReferenceFAQItem documents */
  disconnect?: InputMaybe<Array<CosmosReferenceFaqItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosReferenceFAQItem documents */
  set?: InputMaybe<Array<CosmosReferenceFaqItemWhereUniqueInput>>;
  /** Update multiple CosmosReferenceFAQItem documents */
  update?: InputMaybe<Array<CosmosReferenceFaqItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosReferenceFAQItem documents */
  upsert?: InputMaybe<Array<CosmosReferenceFaqItemUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosReferenceFaqItemUpdateManyInput = {
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** answer input for default locale (en) */
  answer?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosReferenceFaqItemUpdateManyLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosReferenceFaqItemUpdateManyLocalizationDataInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosReferenceFaqItemUpdateManyLocalizationInput = {
  data: CosmosReferenceFaqItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosReferenceFaqItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosReferenceFaqItemUpdateManyLocalizationInput>>;
};

export type CosmosReferenceFaqItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosReferenceFaqItemUpdateManyInput;
  /** Document search */
  where: CosmosReferenceFaqItemWhereInput;
};

export type CosmosReferenceFaqItemUpdateOneInlineInput = {
  /** Connect existing CosmosReferenceFAQItem document */
  connect?: InputMaybe<CosmosReferenceFaqItemWhereUniqueInput>;
  /** Create and connect one CosmosReferenceFAQItem document */
  create?: InputMaybe<CosmosReferenceFaqItemCreateInput>;
  /** Delete currently connected CosmosReferenceFAQItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosReferenceFAQItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosReferenceFAQItem document */
  update?: InputMaybe<CosmosReferenceFaqItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosReferenceFAQItem document */
  upsert?: InputMaybe<CosmosReferenceFaqItemUpsertWithNestedWhereUniqueInput>;
};

export type CosmosReferenceFaqItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosReferenceFaqItemUpdateInput;
  /** Unique document search */
  where: CosmosReferenceFaqItemWhereUniqueInput;
};

export type CosmosReferenceFaqItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosReferenceFaqItemCreateInput;
  /** Update document if it exists */
  update: CosmosReferenceFaqItemUpdateInput;
};

export type CosmosReferenceFaqItemUpsertLocalizationInput = {
  create: CosmosReferenceFaqItemCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosReferenceFaqItemUpdateLocalizationDataInput;
};

export type CosmosReferenceFaqItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosReferenceFaqItemUpsertInput;
  /** Unique document search */
  where: CosmosReferenceFaqItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosReferenceFaqItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosReferenceFaqItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosReferenceFaqItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosReferenceFaqItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosReferenceFaqItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorLinkId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  anchorLinkId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  anchorLinkId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  anchorLinkId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  anchorLinkId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  anchorLinkId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  anchorLinkId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  anchorLinkId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  anchorLinkId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  anchorLinkId_starts_with?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  answer_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  answer_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  answer_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  answer_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  answer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  answer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  answer_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosReferenceFaqItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosReferenceFaqItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosReferenceFaqItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosReferenceFaqItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosReferenceFaqItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosReferenceFaqItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosReferenceFaqItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosReferenceFaqItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosReferenceFAQItem record uniquely */
export type CosmosReferenceFaqItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosReferenceSection = Entity & Node & {
  __typename?: 'CosmosReferenceSection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosReferenceSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CosmosReferenceSection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Mark this model as in development and prevent production publishes. */
  inDevelopment?: Maybe<WfEnumInDevelopmentStatus>;
  /** Used to describe the section and it's use to make it easier to reference.  This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosReferenceSection>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  section?: Maybe<CosmosReferenceSectionsectionUnion>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosReferenceSectionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosReferenceSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosReferenceSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosReferenceSectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosReferenceSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosReferenceSectionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosReferenceSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosReferenceSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosReferenceSectionSectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosReferenceSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CosmosReferenceSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosReferenceSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosReferenceSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosReferenceSectionConnection = {
  __typename?: 'CosmosReferenceSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosReferenceSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosReferenceSectionCreateInput = {
  cm02spw8u02t508ohgh18bhsv?: InputMaybe<CosmosPageHeroAndSectionCreateManyInlineInput>;
  cm02sqmh002vd08ohaa5t3gbj?: InputMaybe<CosmosPageBlogDetailCreateManyInlineInput>;
  cm02srkqi02xl08ohgfca6cap?: InputMaybe<CosmosPageAgreementCreateManyInlineInput>;
  cm5ww18tf05if07ofg2zghgyx?: InputMaybe<CosmosPageLicenseCreateManyInlineInput>;
  cma5rykg608da07oi3iulgkns?: InputMaybe<CosmosPagePluginDetailCreateManyInlineInput>;
  cmp311r8e015207oidvidhtc6?: InputMaybe<CosmosPageDirectoryCreateManyInlineInput>;
  cmp3117ry012x07oidt2b1td8?: InputMaybe<CosmosPageDirectoryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  instructions1723125044700CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableCreateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosReferenceSectionCreateLocalizationsInput>;
  section?: InputMaybe<CosmosReferenceSectionsectionUnionCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosReferenceSectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosReferenceSectionCreateLocalizationInput = {
  /** Localization input */
  data: CosmosReferenceSectionCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosReferenceSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosReferenceSectionCreateLocalizationInput>>;
};

export type CosmosReferenceSectionCreateManyInlineInput = {
  /** Connect multiple existing CosmosReferenceSection documents */
  connect?: InputMaybe<Array<CosmosReferenceSectionWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosReferenceSection documents */
  create?: InputMaybe<Array<CosmosReferenceSectionCreateInput>>;
};

export type CosmosReferenceSectionCreateOneInlineInput = {
  /** Connect one existing CosmosReferenceSection document */
  connect?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
  /** Create and connect one CosmosReferenceSection document */
  create?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

/** An edge in a connection. */
export type CosmosReferenceSectionEdge = {
  __typename?: 'CosmosReferenceSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosReferenceSection;
};

/** Identifies documents */
export type CosmosReferenceSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosReferenceSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosReferenceSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosReferenceSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosReferenceSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosReferenceSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosReferenceSectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the modular component is connected to the given models */
  section?: InputMaybe<CosmosReferenceSectionsectionUnionWhereInput>;
  /** All values in which the union is empty. */
  section_empty?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosReferenceSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosReferenceSectionUpdateInput = {
  cm02spw8u02t508ohgh18bhsv?: InputMaybe<CosmosPageHeroAndSectionUpdateManyInlineInput>;
  cm02sqmh002vd08ohaa5t3gbj?: InputMaybe<CosmosPageBlogDetailUpdateManyInlineInput>;
  cm02srkqi02xl08ohgfca6cap?: InputMaybe<CosmosPageAgreementUpdateManyInlineInput>;
  cm5ww18tf05if07ofg2zghgyx?: InputMaybe<CosmosPageLicenseUpdateManyInlineInput>;
  cma5rykg608da07oi3iulgkns?: InputMaybe<CosmosPagePluginDetailUpdateManyInlineInput>;
  cmp311r8e015207oidvidhtc6?: InputMaybe<CosmosPageDirectoryUpdateManyInlineInput>;
  cmp3117ry012x07oidt2b1td8?: InputMaybe<CosmosPageDirectoryUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  instructions1723125044700CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosReferenceSectionUpdateLocalizationsInput>;
  section?: InputMaybe<CosmosReferenceSectionsectionUnionUpdateOneInlineInput>;
};

export type CosmosReferenceSectionUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosReferenceSectionUpdateLocalizationInput = {
  data: CosmosReferenceSectionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosReferenceSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosReferenceSectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosReferenceSectionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosReferenceSectionUpsertLocalizationInput>>;
};

export type CosmosReferenceSectionUpdateManyInlineInput = {
  /** Connect multiple existing CosmosReferenceSection documents */
  connect?: InputMaybe<Array<CosmosReferenceSectionConnectInput>>;
  /** Create and connect multiple CosmosReferenceSection documents */
  create?: InputMaybe<Array<CosmosReferenceSectionCreateInput>>;
  /** Delete multiple CosmosReferenceSection documents */
  delete?: InputMaybe<Array<CosmosReferenceSectionWhereUniqueInput>>;
  /** Disconnect multiple CosmosReferenceSection documents */
  disconnect?: InputMaybe<Array<CosmosReferenceSectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosReferenceSection documents */
  set?: InputMaybe<Array<CosmosReferenceSectionWhereUniqueInput>>;
  /** Update multiple CosmosReferenceSection documents */
  update?: InputMaybe<Array<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosReferenceSection documents */
  upsert?: InputMaybe<Array<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosReferenceSectionUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosReferenceSectionUpdateManyLocalizationsInput>;
};

export type CosmosReferenceSectionUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosReferenceSectionUpdateManyLocalizationInput = {
  data: CosmosReferenceSectionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosReferenceSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosReferenceSectionUpdateManyLocalizationInput>>;
};

export type CosmosReferenceSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosReferenceSectionUpdateManyInput;
  /** Document search */
  where: CosmosReferenceSectionWhereInput;
};

export type CosmosReferenceSectionUpdateOneInlineInput = {
  /** Connect existing CosmosReferenceSection document */
  connect?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
  /** Create and connect one CosmosReferenceSection document */
  create?: InputMaybe<CosmosReferenceSectionCreateInput>;
  /** Delete currently connected CosmosReferenceSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosReferenceSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosReferenceSection document */
  update?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosReferenceSection document */
  upsert?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosReferenceSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosReferenceSectionUpdateInput;
  /** Unique document search */
  where: CosmosReferenceSectionWhereUniqueInput;
};

export type CosmosReferenceSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosReferenceSectionCreateInput;
  /** Update document if it exists */
  update: CosmosReferenceSectionUpdateInput;
};

export type CosmosReferenceSectionUpsertLocalizationInput = {
  create: CosmosReferenceSectionCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosReferenceSectionUpdateLocalizationDataInput;
};

export type CosmosReferenceSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosReferenceSectionUpsertInput;
  /** Unique document search */
  where: CosmosReferenceSectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosReferenceSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosReferenceSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosReferenceSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosReferenceSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosReferenceSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosReferenceSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosReferenceSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosReferenceSectionWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<WfEnumInDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<WfEnumInDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the modular component is connected to the given models */
  section?: InputMaybe<CosmosReferenceSectionsectionUnionWhereInput>;
  /** All values in which the union is empty. */
  section_empty?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosReferenceSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosReferenceSectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosReferenceSectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosReferenceSectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosReferenceSectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosReferenceSection record uniquely */
export type CosmosReferenceSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosReferenceSectionsectionUnion = CosmosSectionAccordionFeatureCard | CosmosSectionAccordionTierCards | CosmosSectionAriesCards | CosmosSectionAsset | CosmosSectionAssetCarousel | CosmosSectionAssetGallery | CosmosSectionBlobTable | CosmosSectionBlogCard | CosmosSectionCkRichText | CosmosSectionCommunity | CosmosSectionComplexCtaCard | CosmosSectionContentLargeImage | CosmosSectionContentSliderAsset | CosmosSectionCrux | CosmosSectionDelphinusCardsGrid | CosmosSectionDevelopersList | CosmosSectionDivider | CosmosSectionDownloadCard | CosmosSectionDownloadable | CosmosSectionEmbed | CosmosSectionEventsTable | CosmosSectionFaq | CosmosSectionFaqSearch | CosmosSectionFeatureCard | CosmosSectionGameDevFeatureCard | CosmosSectionGeminiCard | CosmosSectionHydrusColumnList | CosmosSectionLatestNews | CosmosSectionLearn | CosmosSectionLicensesCollapsed | CosmosSectionLogoList | CosmosSectionLogoMultiCard | CosmosSectionNewsCard | CosmosSectionNewsMediaCard | CosmosSectionNewsletterSignup | CosmosSectionNumberCallout | CosmosSectionPluginListTable | CosmosSectionQuote | CosmosSectionResellersSearch | CosmosSectionRichText | CosmosSectionSimpleCta | CosmosSectionSlimContactCard | CosmosSectionSpeakerCard | CosmosSectionTabbedBlogCard | CosmosSectionTabbedContentImage | CosmosSectionTabbedFullWidthAsset | CosmosSectionUtCard;

export type CosmosReferenceSectionsectionUnionConnectInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardConnectInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsConnectInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsConnectInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetConnectInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselConnectInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryConnectInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableConnectInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardConnectInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextConnectInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityConnectInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardConnectInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageConnectInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetConnectInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxConnectInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridConnectInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListConnectInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerConnectInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardConnectInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableConnectInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedConnectInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableConnectInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqConnectInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchConnectInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardConnectInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardConnectInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardConnectInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListConnectInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsConnectInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnConnectInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedConnectInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListConnectInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardConnectInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardConnectInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardConnectInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupConnectInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutConnectInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableConnectInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteConnectInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchConnectInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextConnectInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaConnectInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardConnectInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardConnectInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardConnectInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageConnectInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetConnectInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardConnectInput>;
};

export type CosmosReferenceSectionsectionUnionCreateInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardCreateInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsCreateInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsCreateInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetCreateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableCreateInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardCreateInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextCreateInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardCreateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridCreateInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListCreateInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerCreateInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableCreateInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedCreateInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableCreateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardCreateInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListCreateInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsCreateInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardCreateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupCreateInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableCreateInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteCreateInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchCreateInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextCreateInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaCreateInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardCreateInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardCreateInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardCreateInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageCreateInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardCreateInput>;
};

export type CosmosReferenceSectionsectionUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosReferenceSectionsectionUnion documents */
  create?: InputMaybe<Array<CosmosReferenceSectionsectionUnionCreateInput>>;
};

export type CosmosReferenceSectionsectionUnionCreateOneInlineInput = {
  /** Create and connect one CosmosReferenceSectionsectionUnion document */
  create?: InputMaybe<CosmosReferenceSectionsectionUnionCreateInput>;
};

export type CosmosReferenceSectionsectionUnionCreateWithPositionInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardCreateWithPositionInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsCreateWithPositionInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsCreateWithPositionInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetCreateWithPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselCreateWithPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryCreateWithPositionInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableCreateWithPositionInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardCreateWithPositionInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextCreateWithPositionInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityCreateWithPositionInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardCreateWithPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageCreateWithPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetCreateWithPositionInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxCreateWithPositionInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridCreateWithPositionInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListCreateWithPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerCreateWithPositionInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardCreateWithPositionInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableCreateWithPositionInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedCreateWithPositionInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableCreateWithPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqCreateWithPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchCreateWithPositionInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardCreateWithPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardCreateWithPositionInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardCreateWithPositionInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListCreateWithPositionInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsCreateWithPositionInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateWithPositionInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedCreateWithPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListCreateWithPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardCreateWithPositionInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardCreateWithPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardCreateWithPositionInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupCreateWithPositionInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutCreateWithPositionInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableCreateWithPositionInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteCreateWithPositionInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchCreateWithPositionInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextCreateWithPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaCreateWithPositionInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardCreateWithPositionInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardCreateWithPositionInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardCreateWithPositionInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageCreateWithPositionInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateWithPositionInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardCreateWithPositionInput>;
};

export type CosmosReferenceSectionsectionUnionUpdateInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupUpdateInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateInput>;
};

export type CosmosReferenceSectionsectionUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosReferenceSectionsectionUnion component instances */
  create?: InputMaybe<Array<CosmosReferenceSectionsectionUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosReferenceSectionsectionUnion documents */
  delete?: InputMaybe<Array<CosmosReferenceSectionsectionUnionWhereUniqueInput>>;
  /** Update multiple CosmosReferenceSectionsectionUnion component instances */
  update?: InputMaybe<Array<CosmosReferenceSectionsectionUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosReferenceSectionsectionUnion component instances */
  upsert?: InputMaybe<Array<CosmosReferenceSectionsectionUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosReferenceSectionsectionUnionUpdateManyWithNestedWhereInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateManyWithNestedWhereInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateManyWithNestedWhereInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateManyWithNestedWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateManyWithNestedWhereInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateManyWithNestedWhereInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateManyWithNestedWhereInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateManyWithNestedWhereInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateManyWithNestedWhereInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateManyWithNestedWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateManyWithNestedWhereInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateManyWithNestedWhereInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateManyWithNestedWhereInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateManyWithNestedWhereInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateManyWithNestedWhereInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateManyWithNestedWhereInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateManyWithNestedWhereInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateManyWithNestedWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateManyWithNestedWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateManyWithNestedWhereInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateManyWithNestedWhereInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateManyWithNestedWhereInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateManyWithNestedWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateManyWithNestedWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateManyWithNestedWhereInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupUpdateManyWithNestedWhereInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateManyWithNestedWhereInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateManyWithNestedWhereInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateManyWithNestedWhereInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateManyWithNestedWhereInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateManyWithNestedWhereInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateManyWithNestedWhereInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateManyWithNestedWhereInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateManyWithNestedWhereInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateManyWithNestedWhereInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateManyWithNestedWhereInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateManyWithNestedWhereInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateManyWithNestedWhereInput>;
};

export type CosmosReferenceSectionsectionUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosReferenceSectionsectionUnion document */
  create?: InputMaybe<CosmosReferenceSectionsectionUnionCreateInput>;
  /** Delete currently connected CosmosReferenceSectionsectionUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosReferenceSectionsectionUnion document */
  update?: InputMaybe<CosmosReferenceSectionsectionUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosReferenceSectionsectionUnion document */
  upsert?: InputMaybe<CosmosReferenceSectionsectionUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosReferenceSectionsectionUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosReferenceSectionsectionUnionUpdateWithNestedWhereUniqueInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupUpdateWithNestedWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpdateWithNestedWhereUniqueInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpdateWithNestedWhereUniqueInput>;
};

export type CosmosReferenceSectionsectionUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosReferenceSectionsectionUnionUpsertWithNestedWhereUniqueInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupUpsertWithNestedWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteUpsertWithNestedWhereUniqueInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosReferenceSectionsectionUnionWhereInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardWhereInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsWhereInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsWhereInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetWhereInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableWhereInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardWhereInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextWhereInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardWhereInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridWhereInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListWhereInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerWhereInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableWhereInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedWhereInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableWhereInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardWhereInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListWhereInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsWhereInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardWhereInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupWhereInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableWhereInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteWhereInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchWhereInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextWhereInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaWhereInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardWhereInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardWhereInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardWhereInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageWhereInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetWhereInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardWhereInput>;
};

export type CosmosReferenceSectionsectionUnionWhereUniqueInput = {
  CosmosSectionAccordionFeatureCard?: InputMaybe<CosmosSectionAccordionFeatureCardWhereUniqueInput>;
  CosmosSectionAccordionTierCards?: InputMaybe<CosmosSectionAccordionTierCardsWhereUniqueInput>;
  CosmosSectionAriesCards?: InputMaybe<CosmosSectionAriesCardsWhereUniqueInput>;
  CosmosSectionAsset?: InputMaybe<CosmosSectionAssetWhereUniqueInput>;
  CosmosSectionAssetCarousel?: InputMaybe<CosmosSectionAssetCarouselWhereUniqueInput>;
  CosmosSectionAssetGallery?: InputMaybe<CosmosSectionAssetGalleryWhereUniqueInput>;
  CosmosSectionBlobTable?: InputMaybe<CosmosSectionBlobTableWhereUniqueInput>;
  CosmosSectionBlogCard?: InputMaybe<CosmosSectionBlogCardWhereUniqueInput>;
  CosmosSectionCkRichText?: InputMaybe<CosmosSectionCkRichTextWhereUniqueInput>;
  CosmosSectionCommunity?: InputMaybe<CosmosSectionCommunityWhereUniqueInput>;
  CosmosSectionComplexCtaCard?: InputMaybe<CosmosSectionComplexCtaCardWhereUniqueInput>;
  CosmosSectionContentLargeImage?: InputMaybe<CosmosSectionContentLargeImageWhereUniqueInput>;
  CosmosSectionContentSliderAsset?: InputMaybe<CosmosSectionContentSliderAssetWhereUniqueInput>;
  CosmosSectionCrux?: InputMaybe<CosmosSectionCruxWhereUniqueInput>;
  CosmosSectionDelphinusCardsGrid?: InputMaybe<CosmosSectionDelphinusCardsGridWhereUniqueInput>;
  CosmosSectionDevelopersList?: InputMaybe<CosmosSectionDevelopersListWhereUniqueInput>;
  CosmosSectionDivider?: InputMaybe<CosmosSectionDividerWhereUniqueInput>;
  CosmosSectionDownloadCard?: InputMaybe<CosmosSectionDownloadCardWhereUniqueInput>;
  CosmosSectionDownloadable?: InputMaybe<CosmosSectionDownloadableWhereUniqueInput>;
  CosmosSectionEmbed?: InputMaybe<CosmosSectionEmbedWhereUniqueInput>;
  CosmosSectionEventsTable?: InputMaybe<CosmosSectionEventsTableWhereUniqueInput>;
  CosmosSectionFaq?: InputMaybe<CosmosSectionFaqWhereUniqueInput>;
  CosmosSectionFaqSearch?: InputMaybe<CosmosSectionFaqSearchWhereUniqueInput>;
  CosmosSectionFeatureCard?: InputMaybe<CosmosSectionFeatureCardWhereUniqueInput>;
  CosmosSectionGameDevFeatureCard?: InputMaybe<CosmosSectionGameDevFeatureCardWhereUniqueInput>;
  CosmosSectionGeminiCard?: InputMaybe<CosmosSectionGeminiCardWhereUniqueInput>;
  CosmosSectionHydrusColumnList?: InputMaybe<CosmosSectionHydrusColumnListWhereUniqueInput>;
  CosmosSectionLatestNews?: InputMaybe<CosmosSectionLatestNewsWhereUniqueInput>;
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereUniqueInput>;
  CosmosSectionLicensesCollapsed?: InputMaybe<CosmosSectionLicensesCollapsedWhereUniqueInput>;
  CosmosSectionLogoList?: InputMaybe<CosmosSectionLogoListWhereUniqueInput>;
  CosmosSectionLogoMultiCard?: InputMaybe<CosmosSectionLogoMultiCardWhereUniqueInput>;
  CosmosSectionNewsCard?: InputMaybe<CosmosSectionNewsCardWhereUniqueInput>;
  CosmosSectionNewsMediaCard?: InputMaybe<CosmosSectionNewsMediaCardWhereUniqueInput>;
  CosmosSectionNewsletterSignup?: InputMaybe<CosmosSectionNewsletterSignupWhereUniqueInput>;
  CosmosSectionNumberCallout?: InputMaybe<CosmosSectionNumberCalloutWhereUniqueInput>;
  CosmosSectionPluginListTable?: InputMaybe<CosmosSectionPluginListTableWhereUniqueInput>;
  CosmosSectionQuote?: InputMaybe<CosmosSectionQuoteWhereUniqueInput>;
  CosmosSectionResellersSearch?: InputMaybe<CosmosSectionResellersSearchWhereUniqueInput>;
  CosmosSectionRichText?: InputMaybe<CosmosSectionRichTextWhereUniqueInput>;
  CosmosSectionSimpleCta?: InputMaybe<CosmosSectionSimpleCtaWhereUniqueInput>;
  CosmosSectionSlimContactCard?: InputMaybe<CosmosSectionSlimContactCardWhereUniqueInput>;
  CosmosSectionSpeakerCard?: InputMaybe<CosmosSectionSpeakerCardWhereUniqueInput>;
  CosmosSectionTabbedBlogCard?: InputMaybe<CosmosSectionTabbedBlogCardWhereUniqueInput>;
  CosmosSectionTabbedContentImage?: InputMaybe<CosmosSectionTabbedContentImageWhereUniqueInput>;
  CosmosSectionTabbedFullWidthAsset?: InputMaybe<CosmosSectionTabbedFullWidthAssetWhereUniqueInput>;
  CosmosSectionUtCard?: InputMaybe<CosmosSectionUtCardWhereUniqueInput>;
};

export type CosmosRemoteLearn = Entity & Node & {
  __typename?: 'CosmosRemoteLearn';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CosmosRemoteLearn>;
  hashId: Scalars['String']['output'];
  /** List of CosmosRemoteLearn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  industries: Array<CosmosEnumLearnTabs>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  type: CosmosEnumLearnPostType;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CosmosRemoteLearnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosRemoteLearnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CosmosRemoteLearnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CosmosRemoteLearnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosRemoteLearnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CosmosRemoteLearnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CosmosRemoteLearnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosRemoteLearnWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosRemoteLearnConnection = {
  __typename?: 'CosmosRemoteLearnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosRemoteLearnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosRemoteLearnCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hashId: Scalars['String']['input'];
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  remoteCards1723125044707ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateOneInlineInput>;
  type: CosmosEnumLearnPostType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosRemoteLearnCreateManyInlineInput = {
  /** Connect multiple existing CosmosRemoteLearn documents */
  connect?: InputMaybe<Array<CosmosRemoteLearnWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosRemoteLearn documents */
  create?: InputMaybe<Array<CosmosRemoteLearnCreateInput>>;
};

export type CosmosRemoteLearnCreateOneInlineInput = {
  /** Connect one existing CosmosRemoteLearn document */
  connect?: InputMaybe<CosmosRemoteLearnWhereUniqueInput>;
  /** Create and connect one CosmosRemoteLearn document */
  create?: InputMaybe<CosmosRemoteLearnCreateInput>;
};

/** An edge in a connection. */
export type CosmosRemoteLearnEdge = {
  __typename?: 'CosmosRemoteLearnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosRemoteLearn;
};

/** Identifies documents */
export type CosmosRemoteLearnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosRemoteLearnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosRemoteLearnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosRemoteLearnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosRemoteLearnWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosRemoteLearnWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosRemoteLearnWhereStageInput>;
  hashId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  hashId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  hashId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  hashId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  hashId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  hashId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  hashId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  hashId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  hashId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  hashId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains *all* items provided to the filter */
  industries_contains_all?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  industries_contains_none?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains at least one item provided to the filter */
  industries_contains_some?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  industries_not?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  type?: InputMaybe<CosmosEnumLearnPostType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnPostType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<CosmosEnumLearnPostType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnPostType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CosmosRemoteLearnOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HashIdAsc = 'hashId_ASC',
  HashIdDesc = 'hashId_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndustriesAsc = 'industries_ASC',
  IndustriesDesc = 'industries_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosRemoteLearnUpdateInput = {
  hashId?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  remoteCards1723125044707ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateOneInlineInput>;
  type?: InputMaybe<CosmosEnumLearnPostType>;
};

export type CosmosRemoteLearnUpdateManyInlineInput = {
  /** Connect multiple existing CosmosRemoteLearn documents */
  connect?: InputMaybe<Array<CosmosRemoteLearnConnectInput>>;
  /** Create and connect multiple CosmosRemoteLearn documents */
  create?: InputMaybe<Array<CosmosRemoteLearnCreateInput>>;
  /** Delete multiple CosmosRemoteLearn documents */
  delete?: InputMaybe<Array<CosmosRemoteLearnWhereUniqueInput>>;
  /** Disconnect multiple CosmosRemoteLearn documents */
  disconnect?: InputMaybe<Array<CosmosRemoteLearnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosRemoteLearn documents */
  set?: InputMaybe<Array<CosmosRemoteLearnWhereUniqueInput>>;
  /** Update multiple CosmosRemoteLearn documents */
  update?: InputMaybe<Array<CosmosRemoteLearnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosRemoteLearn documents */
  upsert?: InputMaybe<Array<CosmosRemoteLearnUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosRemoteLearnUpdateManyInput = {
  hashId?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  type?: InputMaybe<CosmosEnumLearnPostType>;
};

export type CosmosRemoteLearnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosRemoteLearnUpdateManyInput;
  /** Document search */
  where: CosmosRemoteLearnWhereInput;
};

export type CosmosRemoteLearnUpdateOneInlineInput = {
  /** Connect existing CosmosRemoteLearn document */
  connect?: InputMaybe<CosmosRemoteLearnWhereUniqueInput>;
  /** Create and connect one CosmosRemoteLearn document */
  create?: InputMaybe<CosmosRemoteLearnCreateInput>;
  /** Delete currently connected CosmosRemoteLearn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosRemoteLearn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosRemoteLearn document */
  update?: InputMaybe<CosmosRemoteLearnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosRemoteLearn document */
  upsert?: InputMaybe<CosmosRemoteLearnUpsertWithNestedWhereUniqueInput>;
};

export type CosmosRemoteLearnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosRemoteLearnUpdateInput;
  /** Unique document search */
  where: CosmosRemoteLearnWhereUniqueInput;
};

export type CosmosRemoteLearnUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosRemoteLearnCreateInput;
  /** Update document if it exists */
  update: CosmosRemoteLearnUpdateInput;
};

export type CosmosRemoteLearnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosRemoteLearnUpsertInput;
  /** Unique document search */
  where: CosmosRemoteLearnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CosmosRemoteLearnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CosmosRemoteLearnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosRemoteLearnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosRemoteLearnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosRemoteLearnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CosmosRemoteLearnWhereStageInput>;
  documentInStages_none?: InputMaybe<CosmosRemoteLearnWhereStageInput>;
  documentInStages_some?: InputMaybe<CosmosRemoteLearnWhereStageInput>;
  hashId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  hashId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  hashId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  hashId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  hashId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  hashId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  hashId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  hashId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  hashId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  hashId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  industries?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains *all* items provided to the filter */
  industries_contains_all?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  industries_contains_none?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array contains at least one item provided to the filter */
  industries_contains_some?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  industries_not?: InputMaybe<Array<CosmosEnumLearnTabs>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  type?: InputMaybe<CosmosEnumLearnPostType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnPostType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<CosmosEnumLearnPostType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLearnPostType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CosmosRemoteLearnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosRemoteLearnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosRemoteLearnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosRemoteLearnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CosmosRemoteLearnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CosmosRemoteLearn record uniquely */
export type CosmosRemoteLearnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionAccordionFeatureCard = Entity & {
  __typename?: 'CosmosSectionAccordionFeatureCard';
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  items: Array<CosmosElementAccordionFeatureCard>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionAccordionFeatureCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionAccordionFeatureCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionAccordionFeatureCardItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementAccordionFeatureCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
};


export type CosmosSectionAccordionFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionAccordionFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionAccordionFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionAccordionFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionAccordionFeatureCardConnection = {
  __typename?: 'CosmosSectionAccordionFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionAccordionFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionAccordionFeatureCardCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementAccordionFeatureCardCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionAccordionFeatureCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAccordionFeatureCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAccordionFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionAccordionFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAccordionFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionAccordionFeatureCardCreateLocalizationInput>>;
};

export type CosmosSectionAccordionFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionAccordionFeatureCard documents */
  create?: InputMaybe<Array<CosmosSectionAccordionFeatureCardCreateInput>>;
};

export type CosmosSectionAccordionFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionAccordionFeatureCard document */
  create?: InputMaybe<CosmosSectionAccordionFeatureCardCreateInput>;
};

export type CosmosSectionAccordionFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionAccordionFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionAccordionFeatureCardEdge = {
  __typename?: 'CosmosSectionAccordionFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionAccordionFeatureCard;
};

/** Identifies documents */
export type CosmosSectionAccordionFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  items_none?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  items_some?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionAccordionFeatureCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionAccordionFeatureCardParent = CosmosReferenceSection;

export type CosmosSectionAccordionFeatureCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionAccordionFeatureCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionAccordionFeatureCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAccordionFeatureCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionAccordionFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentCreateInput>>;
};

export type CosmosSectionAccordionFeatureCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionAccordionFeatureCardParent document */
  connect?: InputMaybe<CosmosSectionAccordionFeatureCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAccordionFeatureCardParent document */
  create?: InputMaybe<CosmosSectionAccordionFeatureCardParentCreateInput>;
};

export type CosmosSectionAccordionFeatureCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionAccordionFeatureCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAccordionFeatureCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionAccordionFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentCreateInput>>;
  /** Delete multiple CosmosSectionAccordionFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionAccordionFeatureCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionAccordionFeatureCardParent documents */
  set?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionAccordionFeatureCardParent documents */
  update?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionAccordionFeatureCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionAccordionFeatureCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionAccordionFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionAccordionFeatureCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionAccordionFeatureCardParent document */
  connect?: InputMaybe<CosmosSectionAccordionFeatureCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAccordionFeatureCardParent document */
  create?: InputMaybe<CosmosSectionAccordionFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosSectionAccordionFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionAccordionFeatureCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAccordionFeatureCardParent document */
  update?: InputMaybe<CosmosSectionAccordionFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAccordionFeatureCardParent document */
  upsert?: InputMaybe<CosmosSectionAccordionFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionFeatureCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionAccordionFeatureCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionAccordionFeatureCardUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementAccordionFeatureCardUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateLocalizationsInput>;
};

export type CosmosSectionAccordionFeatureCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAccordionFeatureCardUpdateLocalizationInput = {
  data: CosmosSectionAccordionFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAccordionFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionAccordionFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAccordionFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionAccordionFeatureCardUpsertLocalizationInput>>;
};

export type CosmosSectionAccordionFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionAccordionFeatureCard component instances */
  create?: InputMaybe<Array<CosmosSectionAccordionFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionAccordionFeatureCard documents */
  delete?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionAccordionFeatureCard component instances */
  update?: InputMaybe<Array<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionAccordionFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionAccordionFeatureCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionAccordionFeatureCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAccordionFeatureCardUpdateManyLocalizationInput = {
  data: CosmosSectionAccordionFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAccordionFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAccordionFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionAccordionFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionAccordionFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionAccordionFeatureCardWhereInput;
};

export type CosmosSectionAccordionFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionAccordionFeatureCard document */
  create?: InputMaybe<CosmosSectionAccordionFeatureCardCreateInput>;
  /** Delete currently connected CosmosSectionAccordionFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAccordionFeatureCard document */
  update?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAccordionFeatureCard document */
  upsert?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionAccordionFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAccordionFeatureCardWhereUniqueInput;
};

export type CosmosSectionAccordionFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionAccordionFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionAccordionFeatureCardWhereUniqueInput;
};

export type CosmosSectionAccordionFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionAccordionFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionAccordionFeatureCardUpdateInput;
};

export type CosmosSectionAccordionFeatureCardUpsertLocalizationInput = {
  create: CosmosSectionAccordionFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionAccordionFeatureCardUpdateLocalizationDataInput;
};

export type CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionAccordionFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAccordionFeatureCardWhereUniqueInput;
};

export type CosmosSectionAccordionFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionAccordionFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionAccordionFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionAccordionFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAccordionFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  items_none?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  items_some?: InputMaybe<CosmosElementAccordionFeatureCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionAccordionFeatureCard record uniquely */
export type CosmosSectionAccordionFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionAccordionTierCards = Entity & {
  __typename?: 'CosmosSectionAccordionTierCards';
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  items: Array<CosmosElementAccordionTierCard>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionAccordionTierCards>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionAccordionTierCardsConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionAccordionTierCardsItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementAccordionTierCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
};


export type CosmosSectionAccordionTierCardsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionAccordionTierCardsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionAccordionTierCardsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionAccordionTierCardsWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionAccordionTierCardsConnection = {
  __typename?: 'CosmosSectionAccordionTierCardsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionAccordionTierCardsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionAccordionTierCardsCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementAccordionTierCardCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionAccordionTierCardsCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAccordionTierCardsCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAccordionTierCardsCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionAccordionTierCardsCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAccordionTierCardsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionAccordionTierCardsCreateLocalizationInput>>;
};

export type CosmosSectionAccordionTierCardsCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionAccordionTierCards documents */
  create?: InputMaybe<Array<CosmosSectionAccordionTierCardsCreateInput>>;
};

export type CosmosSectionAccordionTierCardsCreateOneInlineInput = {
  /** Create and connect one CosmosSectionAccordionTierCards document */
  create?: InputMaybe<CosmosSectionAccordionTierCardsCreateInput>;
};

export type CosmosSectionAccordionTierCardsCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionAccordionTierCardsCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionAccordionTierCardsEdge = {
  __typename?: 'CosmosSectionAccordionTierCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionAccordionTierCards;
};

/** Identifies documents */
export type CosmosSectionAccordionTierCardsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
  items_none?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
  items_some?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionAccordionTierCardsOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionAccordionTierCardsParent = CosmosReferenceSection;

export type CosmosSectionAccordionTierCardsParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionAccordionTierCardsParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionAccordionTierCardsParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAccordionTierCardsParent documents */
  connect?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionAccordionTierCardsParent documents */
  create?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentCreateInput>>;
};

export type CosmosSectionAccordionTierCardsParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionAccordionTierCardsParent document */
  connect?: InputMaybe<CosmosSectionAccordionTierCardsParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAccordionTierCardsParent document */
  create?: InputMaybe<CosmosSectionAccordionTierCardsParentCreateInput>;
};

export type CosmosSectionAccordionTierCardsParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionAccordionTierCardsParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAccordionTierCardsParent documents */
  connect?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentConnectInput>>;
  /** Create and connect multiple CosmosSectionAccordionTierCardsParent documents */
  create?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentCreateInput>>;
  /** Delete multiple CosmosSectionAccordionTierCardsParent documents */
  delete?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionAccordionTierCardsParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionAccordionTierCardsParent documents */
  set?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionAccordionTierCardsParent documents */
  update?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionAccordionTierCardsParent documents */
  upsert?: InputMaybe<Array<CosmosSectionAccordionTierCardsParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionAccordionTierCardsParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionAccordionTierCardsParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionAccordionTierCardsParent document */
  connect?: InputMaybe<CosmosSectionAccordionTierCardsParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAccordionTierCardsParent document */
  create?: InputMaybe<CosmosSectionAccordionTierCardsParentCreateInput>;
  /** Delete currently connected CosmosSectionAccordionTierCardsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionAccordionTierCardsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAccordionTierCardsParent document */
  update?: InputMaybe<CosmosSectionAccordionTierCardsParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAccordionTierCardsParent document */
  upsert?: InputMaybe<CosmosSectionAccordionTierCardsParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionTierCardsParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionTierCardsParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionTierCardsParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionAccordionTierCardsParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionAccordionTierCardsUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementAccordionTierCardUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionAccordionTierCardsUpdateLocalizationsInput>;
};

export type CosmosSectionAccordionTierCardsUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAccordionTierCardsUpdateLocalizationInput = {
  data: CosmosSectionAccordionTierCardsUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAccordionTierCardsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionAccordionTierCardsCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAccordionTierCardsUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionAccordionTierCardsUpsertLocalizationInput>>;
};

export type CosmosSectionAccordionTierCardsUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionAccordionTierCards component instances */
  create?: InputMaybe<Array<CosmosSectionAccordionTierCardsCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionAccordionTierCards documents */
  delete?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereUniqueInput>>;
  /** Update multiple CosmosSectionAccordionTierCards component instances */
  update?: InputMaybe<Array<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionAccordionTierCards component instances */
  upsert?: InputMaybe<Array<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionAccordionTierCardsUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionAccordionTierCardsUpdateManyLocalizationsInput>;
};

export type CosmosSectionAccordionTierCardsUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAccordionTierCardsUpdateManyLocalizationInput = {
  data: CosmosSectionAccordionTierCardsUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAccordionTierCardsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAccordionTierCardsUpdateManyLocalizationInput>>;
};

export type CosmosSectionAccordionTierCardsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionAccordionTierCardsUpdateManyInput;
  /** Document search */
  where: CosmosSectionAccordionTierCardsWhereInput;
};

export type CosmosSectionAccordionTierCardsUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionAccordionTierCards document */
  create?: InputMaybe<CosmosSectionAccordionTierCardsCreateInput>;
  /** Delete currently connected CosmosSectionAccordionTierCards document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAccordionTierCards document */
  update?: InputMaybe<CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAccordionTierCards document */
  upsert?: InputMaybe<CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionAccordionTierCardsUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAccordionTierCardsWhereUniqueInput;
};

export type CosmosSectionAccordionTierCardsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionAccordionTierCardsUpdateInput;
  /** Unique document search */
  where: CosmosSectionAccordionTierCardsWhereUniqueInput;
};

export type CosmosSectionAccordionTierCardsUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionAccordionTierCardsCreateInput;
  /** Update document if it exists */
  update: CosmosSectionAccordionTierCardsUpdateInput;
};

export type CosmosSectionAccordionTierCardsUpsertLocalizationInput = {
  create: CosmosSectionAccordionTierCardsCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionAccordionTierCardsUpdateLocalizationDataInput;
};

export type CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionAccordionTierCardsUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAccordionTierCardsWhereUniqueInput;
};

export type CosmosSectionAccordionTierCardsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionAccordionTierCardsUpsertInput;
  /** Unique document search */
  where: CosmosSectionAccordionTierCardsWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionAccordionTierCardsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAccordionTierCardsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
  items_none?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
  items_some?: InputMaybe<CosmosElementAccordionTierCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionAccordionTierCards record uniquely */
export type CosmosSectionAccordionTierCardsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionAriesCards = Entity & {
  __typename?: 'CosmosSectionAriesCards';
  cards: Array<CosmosElementAriesCard>;
  config?: Maybe<CosmosConfigSection>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionAriesCards>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionAriesCardsCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementAriesCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementAriesCardWhereInput>;
};


export type CosmosSectionAriesCardsConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionAriesCardsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionAriesCardsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionAriesCardsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionAriesCardsWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionAriesCardsConnection = {
  __typename?: 'CosmosSectionAriesCardsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionAriesCardsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionAriesCardsCreateInput = {
  cards?: InputMaybe<CosmosElementAriesCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionAriesCardsCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAriesCardsCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAriesCardsCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionAriesCardsCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAriesCardsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionAriesCardsCreateLocalizationInput>>;
};

export type CosmosSectionAriesCardsCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionAriesCards documents */
  create?: InputMaybe<Array<CosmosSectionAriesCardsCreateInput>>;
};

export type CosmosSectionAriesCardsCreateOneInlineInput = {
  /** Create and connect one CosmosSectionAriesCards document */
  create?: InputMaybe<CosmosSectionAriesCardsCreateInput>;
};

export type CosmosSectionAriesCardsCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionAriesCardsCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionAriesCardsEdge = {
  __typename?: 'CosmosSectionAriesCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionAriesCards;
};

/** Identifies documents */
export type CosmosSectionAriesCardsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAriesCardsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAriesCardsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAriesCardsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementAriesCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementAriesCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementAriesCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionAriesCardsOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionAriesCardsParent = CosmosReferenceSection;

export type CosmosSectionAriesCardsParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionAriesCardsParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionAriesCardsParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAriesCardsParent documents */
  connect?: InputMaybe<Array<CosmosSectionAriesCardsParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionAriesCardsParent documents */
  create?: InputMaybe<Array<CosmosSectionAriesCardsParentCreateInput>>;
};

export type CosmosSectionAriesCardsParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionAriesCardsParent document */
  connect?: InputMaybe<CosmosSectionAriesCardsParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAriesCardsParent document */
  create?: InputMaybe<CosmosSectionAriesCardsParentCreateInput>;
};

export type CosmosSectionAriesCardsParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionAriesCardsParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAriesCardsParent documents */
  connect?: InputMaybe<Array<CosmosSectionAriesCardsParentConnectInput>>;
  /** Create and connect multiple CosmosSectionAriesCardsParent documents */
  create?: InputMaybe<Array<CosmosSectionAriesCardsParentCreateInput>>;
  /** Delete multiple CosmosSectionAriesCardsParent documents */
  delete?: InputMaybe<Array<CosmosSectionAriesCardsParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionAriesCardsParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionAriesCardsParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionAriesCardsParent documents */
  set?: InputMaybe<Array<CosmosSectionAriesCardsParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionAriesCardsParent documents */
  update?: InputMaybe<Array<CosmosSectionAriesCardsParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionAriesCardsParent documents */
  upsert?: InputMaybe<Array<CosmosSectionAriesCardsParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionAriesCardsParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionAriesCardsParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionAriesCardsParent document */
  connect?: InputMaybe<CosmosSectionAriesCardsParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAriesCardsParent document */
  create?: InputMaybe<CosmosSectionAriesCardsParentCreateInput>;
  /** Delete currently connected CosmosSectionAriesCardsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionAriesCardsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAriesCardsParent document */
  update?: InputMaybe<CosmosSectionAriesCardsParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAriesCardsParent document */
  upsert?: InputMaybe<CosmosSectionAriesCardsParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAriesCardsParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionAriesCardsParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAriesCardsParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionAriesCardsParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionAriesCardsUpdateInput = {
  cards?: InputMaybe<CosmosElementAriesCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionAriesCardsUpdateLocalizationsInput>;
};

export type CosmosSectionAriesCardsUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAriesCardsUpdateLocalizationInput = {
  data: CosmosSectionAriesCardsUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAriesCardsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionAriesCardsCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAriesCardsUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionAriesCardsUpsertLocalizationInput>>;
};

export type CosmosSectionAriesCardsUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionAriesCards component instances */
  create?: InputMaybe<Array<CosmosSectionAriesCardsCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionAriesCards documents */
  delete?: InputMaybe<Array<CosmosSectionAriesCardsWhereUniqueInput>>;
  /** Update multiple CosmosSectionAriesCards component instances */
  update?: InputMaybe<Array<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionAriesCards component instances */
  upsert?: InputMaybe<Array<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionAriesCardsUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionAriesCardsUpdateManyLocalizationsInput>;
};

export type CosmosSectionAriesCardsUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAriesCardsUpdateManyLocalizationInput = {
  data: CosmosSectionAriesCardsUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAriesCardsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAriesCardsUpdateManyLocalizationInput>>;
};

export type CosmosSectionAriesCardsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionAriesCardsUpdateManyInput;
  /** Document search */
  where: CosmosSectionAriesCardsWhereInput;
};

export type CosmosSectionAriesCardsUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionAriesCards document */
  create?: InputMaybe<CosmosSectionAriesCardsCreateInput>;
  /** Delete currently connected CosmosSectionAriesCards document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAriesCards document */
  update?: InputMaybe<CosmosSectionAriesCardsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAriesCards document */
  upsert?: InputMaybe<CosmosSectionAriesCardsUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAriesCardsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionAriesCardsUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAriesCardsWhereUniqueInput;
};

export type CosmosSectionAriesCardsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionAriesCardsUpdateInput;
  /** Unique document search */
  where: CosmosSectionAriesCardsWhereUniqueInput;
};

export type CosmosSectionAriesCardsUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionAriesCardsCreateInput;
  /** Update document if it exists */
  update: CosmosSectionAriesCardsUpdateInput;
};

export type CosmosSectionAriesCardsUpsertLocalizationInput = {
  create: CosmosSectionAriesCardsCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionAriesCardsUpdateLocalizationDataInput;
};

export type CosmosSectionAriesCardsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionAriesCardsUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAriesCardsWhereUniqueInput;
};

export type CosmosSectionAriesCardsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionAriesCardsUpsertInput;
  /** Unique document search */
  where: CosmosSectionAriesCardsWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionAriesCardsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAriesCardsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAriesCardsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAriesCardsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementAriesCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementAriesCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementAriesCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionAriesCards record uniquely */
export type CosmosSectionAriesCardsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionAsset = Entity & {
  __typename?: 'CosmosSectionAsset';
  asset: Asset;
  caption?: Maybe<Scalars['String']['output']>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionAsset>;
  size?: Maybe<CosmosEnumSectionSizes>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionAssetAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionAssetConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionAssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionAssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionAssetCarousel = Entity & {
  __typename?: 'CosmosSectionAssetCarousel';
  assets: Array<Asset>;
  caption?: Maybe<Scalars['String']['output']>;
  /** Config for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionAssetCarousel>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionAssetCarouselAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type CosmosSectionAssetCarouselConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionAssetCarouselLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionAssetCarouselUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionAssetCarouselConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionAssetCarouselWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionAssetCarouselConnection = {
  __typename?: 'CosmosSectionAssetCarouselConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionAssetCarouselEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionAssetCarouselCreateInput = {
  assets?: InputMaybe<AssetCreateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionAssetCarouselCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAssetCarouselCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAssetCarouselCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionAssetCarouselCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetCarouselCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionAssetCarouselCreateLocalizationInput>>;
};

export type CosmosSectionAssetCarouselCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionAssetCarousel documents */
  create?: InputMaybe<Array<CosmosSectionAssetCarouselCreateInput>>;
};

export type CosmosSectionAssetCarouselCreateOneInlineInput = {
  /** Create and connect one CosmosSectionAssetCarousel document */
  create?: InputMaybe<CosmosSectionAssetCarouselCreateInput>;
};

export type CosmosSectionAssetCarouselCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionAssetCarouselCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionAssetCarouselEdge = {
  __typename?: 'CosmosSectionAssetCarouselEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionAssetCarousel;
};

/** Identifies documents */
export type CosmosSectionAssetCarouselManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAssetCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAssetCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAssetCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assets_every?: InputMaybe<AssetWhereInput>;
  assets_none?: InputMaybe<AssetWhereInput>;
  assets_some?: InputMaybe<AssetWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionAssetCarouselOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionAssetCarouselParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionAssetCarouselParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionAssetCarouselParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionAssetCarouselParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAssetCarouselParent documents */
  connect?: InputMaybe<Array<CosmosSectionAssetCarouselParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionAssetCarouselParent documents */
  create?: InputMaybe<Array<CosmosSectionAssetCarouselParentCreateInput>>;
};

export type CosmosSectionAssetCarouselParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionAssetCarouselParent document */
  connect?: InputMaybe<CosmosSectionAssetCarouselParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAssetCarouselParent document */
  create?: InputMaybe<CosmosSectionAssetCarouselParentCreateInput>;
};

export type CosmosSectionAssetCarouselParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionAssetCarouselParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAssetCarouselParent documents */
  connect?: InputMaybe<Array<CosmosSectionAssetCarouselParentConnectInput>>;
  /** Create and connect multiple CosmosSectionAssetCarouselParent documents */
  create?: InputMaybe<Array<CosmosSectionAssetCarouselParentCreateInput>>;
  /** Delete multiple CosmosSectionAssetCarouselParent documents */
  delete?: InputMaybe<Array<CosmosSectionAssetCarouselParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionAssetCarouselParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionAssetCarouselParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionAssetCarouselParent documents */
  set?: InputMaybe<Array<CosmosSectionAssetCarouselParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionAssetCarouselParent documents */
  update?: InputMaybe<Array<CosmosSectionAssetCarouselParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionAssetCarouselParent documents */
  upsert?: InputMaybe<Array<CosmosSectionAssetCarouselParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionAssetCarouselParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionAssetCarouselParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionAssetCarouselParent document */
  connect?: InputMaybe<CosmosSectionAssetCarouselParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAssetCarouselParent document */
  create?: InputMaybe<CosmosSectionAssetCarouselParentCreateInput>;
  /** Delete currently connected CosmosSectionAssetCarouselParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionAssetCarouselParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAssetCarouselParent document */
  update?: InputMaybe<CosmosSectionAssetCarouselParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAssetCarouselParent document */
  upsert?: InputMaybe<CosmosSectionAssetCarouselParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetCarouselParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetCarouselParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetCarouselParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionAssetCarouselParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionAssetCarouselUpdateInput = {
  assets?: InputMaybe<AssetUpdateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionAssetCarouselUpdateLocalizationsInput>;
};

export type CosmosSectionAssetCarouselUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAssetCarouselUpdateLocalizationInput = {
  data: CosmosSectionAssetCarouselUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetCarouselUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionAssetCarouselCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAssetCarouselUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionAssetCarouselUpsertLocalizationInput>>;
};

export type CosmosSectionAssetCarouselUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionAssetCarousel component instances */
  create?: InputMaybe<Array<CosmosSectionAssetCarouselCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionAssetCarousel documents */
  delete?: InputMaybe<Array<CosmosSectionAssetCarouselWhereUniqueInput>>;
  /** Update multiple CosmosSectionAssetCarousel component instances */
  update?: InputMaybe<Array<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionAssetCarousel component instances */
  upsert?: InputMaybe<Array<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionAssetCarouselUpdateManyInput = {
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionAssetCarouselUpdateManyLocalizationsInput>;
};

export type CosmosSectionAssetCarouselUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAssetCarouselUpdateManyLocalizationInput = {
  data: CosmosSectionAssetCarouselUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetCarouselUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAssetCarouselUpdateManyLocalizationInput>>;
};

export type CosmosSectionAssetCarouselUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionAssetCarouselUpdateManyInput;
  /** Document search */
  where: CosmosSectionAssetCarouselWhereInput;
};

export type CosmosSectionAssetCarouselUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionAssetCarousel document */
  create?: InputMaybe<CosmosSectionAssetCarouselCreateInput>;
  /** Delete currently connected CosmosSectionAssetCarousel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAssetCarousel document */
  update?: InputMaybe<CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAssetCarousel document */
  upsert?: InputMaybe<CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionAssetCarouselUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAssetCarouselWhereUniqueInput;
};

export type CosmosSectionAssetCarouselUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionAssetCarouselUpdateInput;
  /** Unique document search */
  where: CosmosSectionAssetCarouselWhereUniqueInput;
};

export type CosmosSectionAssetCarouselUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionAssetCarouselCreateInput;
  /** Update document if it exists */
  update: CosmosSectionAssetCarouselUpdateInput;
};

export type CosmosSectionAssetCarouselUpsertLocalizationInput = {
  create: CosmosSectionAssetCarouselCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionAssetCarouselUpdateLocalizationDataInput;
};

export type CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionAssetCarouselUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAssetCarouselWhereUniqueInput;
};

export type CosmosSectionAssetCarouselUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionAssetCarouselUpsertInput;
  /** Unique document search */
  where: CosmosSectionAssetCarouselWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionAssetCarouselWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAssetCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAssetCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAssetCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assets_every?: InputMaybe<AssetWhereInput>;
  assets_none?: InputMaybe<AssetWhereInput>;
  assets_some?: InputMaybe<AssetWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionAssetCarousel record uniquely */
export type CosmosSectionAssetCarouselWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionAssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionAssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionAssetConnection = {
  __typename?: 'CosmosSectionAssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionAssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionAssetCreateInput = {
  asset: AssetCreateOneInlineInput;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionAssetCreateLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAssetCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAssetCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionAssetCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionAssetCreateLocalizationInput>>;
};

export type CosmosSectionAssetCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionAsset documents */
  create?: InputMaybe<Array<CosmosSectionAssetCreateInput>>;
};

export type CosmosSectionAssetCreateOneInlineInput = {
  /** Create and connect one CosmosSectionAsset document */
  create?: InputMaybe<CosmosSectionAssetCreateInput>;
};

export type CosmosSectionAssetCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionAssetCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionAssetEdge = {
  __typename?: 'CosmosSectionAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionAsset;
};

export type CosmosSectionAssetGallery = Entity & {
  __typename?: 'CosmosSectionAssetGallery';
  assets: Array<Asset>;
  /** Config for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionAssetGallery>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionAssetGalleryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type CosmosSectionAssetGalleryConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionAssetGalleryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionAssetGalleryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionAssetGalleryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionAssetGalleryWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionAssetGalleryConnection = {
  __typename?: 'CosmosSectionAssetGalleryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionAssetGalleryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionAssetGalleryCreateInput = {
  assets?: InputMaybe<AssetCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionAssetGalleryCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAssetGalleryCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionAssetGalleryCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionAssetGalleryCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetGalleryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionAssetGalleryCreateLocalizationInput>>;
};

export type CosmosSectionAssetGalleryCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionAssetGallery documents */
  create?: InputMaybe<Array<CosmosSectionAssetGalleryCreateInput>>;
};

export type CosmosSectionAssetGalleryCreateOneInlineInput = {
  /** Create and connect one CosmosSectionAssetGallery document */
  create?: InputMaybe<CosmosSectionAssetGalleryCreateInput>;
};

export type CosmosSectionAssetGalleryCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionAssetGalleryCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionAssetGalleryEdge = {
  __typename?: 'CosmosSectionAssetGalleryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionAssetGallery;
};

/** Identifies documents */
export type CosmosSectionAssetGalleryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAssetGalleryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAssetGalleryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAssetGalleryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assets_every?: InputMaybe<AssetWhereInput>;
  assets_none?: InputMaybe<AssetWhereInput>;
  assets_some?: InputMaybe<AssetWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionAssetGalleryOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionAssetGalleryParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionAssetGalleryParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionAssetGalleryParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionAssetGalleryParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAssetGalleryParent documents */
  connect?: InputMaybe<Array<CosmosSectionAssetGalleryParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionAssetGalleryParent documents */
  create?: InputMaybe<Array<CosmosSectionAssetGalleryParentCreateInput>>;
};

export type CosmosSectionAssetGalleryParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionAssetGalleryParent document */
  connect?: InputMaybe<CosmosSectionAssetGalleryParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAssetGalleryParent document */
  create?: InputMaybe<CosmosSectionAssetGalleryParentCreateInput>;
};

export type CosmosSectionAssetGalleryParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionAssetGalleryParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAssetGalleryParent documents */
  connect?: InputMaybe<Array<CosmosSectionAssetGalleryParentConnectInput>>;
  /** Create and connect multiple CosmosSectionAssetGalleryParent documents */
  create?: InputMaybe<Array<CosmosSectionAssetGalleryParentCreateInput>>;
  /** Delete multiple CosmosSectionAssetGalleryParent documents */
  delete?: InputMaybe<Array<CosmosSectionAssetGalleryParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionAssetGalleryParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionAssetGalleryParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionAssetGalleryParent documents */
  set?: InputMaybe<Array<CosmosSectionAssetGalleryParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionAssetGalleryParent documents */
  update?: InputMaybe<Array<CosmosSectionAssetGalleryParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionAssetGalleryParent documents */
  upsert?: InputMaybe<Array<CosmosSectionAssetGalleryParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionAssetGalleryParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionAssetGalleryParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionAssetGalleryParent document */
  connect?: InputMaybe<CosmosSectionAssetGalleryParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAssetGalleryParent document */
  create?: InputMaybe<CosmosSectionAssetGalleryParentCreateInput>;
  /** Delete currently connected CosmosSectionAssetGalleryParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionAssetGalleryParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAssetGalleryParent document */
  update?: InputMaybe<CosmosSectionAssetGalleryParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAssetGalleryParent document */
  upsert?: InputMaybe<CosmosSectionAssetGalleryParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetGalleryParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetGalleryParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetGalleryParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionAssetGalleryParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionAssetGalleryUpdateInput = {
  assets?: InputMaybe<AssetUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionAssetGalleryUpdateLocalizationsInput>;
};

export type CosmosSectionAssetGalleryUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAssetGalleryUpdateLocalizationInput = {
  data: CosmosSectionAssetGalleryUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetGalleryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionAssetGalleryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAssetGalleryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionAssetGalleryUpsertLocalizationInput>>;
};

export type CosmosSectionAssetGalleryUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionAssetGallery component instances */
  create?: InputMaybe<Array<CosmosSectionAssetGalleryCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionAssetGallery documents */
  delete?: InputMaybe<Array<CosmosSectionAssetGalleryWhereUniqueInput>>;
  /** Update multiple CosmosSectionAssetGallery component instances */
  update?: InputMaybe<Array<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionAssetGallery component instances */
  upsert?: InputMaybe<Array<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionAssetGalleryUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionAssetGalleryUpdateManyLocalizationsInput>;
};

export type CosmosSectionAssetGalleryUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAssetGalleryUpdateManyLocalizationInput = {
  data: CosmosSectionAssetGalleryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetGalleryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAssetGalleryUpdateManyLocalizationInput>>;
};

export type CosmosSectionAssetGalleryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionAssetGalleryUpdateManyInput;
  /** Document search */
  where: CosmosSectionAssetGalleryWhereInput;
};

export type CosmosSectionAssetGalleryUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionAssetGallery document */
  create?: InputMaybe<CosmosSectionAssetGalleryCreateInput>;
  /** Delete currently connected CosmosSectionAssetGallery document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAssetGallery document */
  update?: InputMaybe<CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAssetGallery document */
  upsert?: InputMaybe<CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionAssetGalleryUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAssetGalleryWhereUniqueInput;
};

export type CosmosSectionAssetGalleryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionAssetGalleryUpdateInput;
  /** Unique document search */
  where: CosmosSectionAssetGalleryWhereUniqueInput;
};

export type CosmosSectionAssetGalleryUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionAssetGalleryCreateInput;
  /** Update document if it exists */
  update: CosmosSectionAssetGalleryUpdateInput;
};

export type CosmosSectionAssetGalleryUpsertLocalizationInput = {
  create: CosmosSectionAssetGalleryCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionAssetGalleryUpdateLocalizationDataInput;
};

export type CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionAssetGalleryUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAssetGalleryWhereUniqueInput;
};

export type CosmosSectionAssetGalleryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionAssetGalleryUpsertInput;
  /** Unique document search */
  where: CosmosSectionAssetGalleryWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionAssetGalleryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAssetGalleryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAssetGalleryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAssetGalleryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assets_every?: InputMaybe<AssetWhereInput>;
  assets_none?: InputMaybe<AssetWhereInput>;
  assets_some?: InputMaybe<AssetWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionAssetGallery record uniquely */
export type CosmosSectionAssetGalleryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CosmosSectionAssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionAssetOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionAssetParent = CosmosReferenceSection;

export type CosmosSectionAssetParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionAssetParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionAssetParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAssetParent documents */
  connect?: InputMaybe<Array<CosmosSectionAssetParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionAssetParent documents */
  create?: InputMaybe<Array<CosmosSectionAssetParentCreateInput>>;
};

export type CosmosSectionAssetParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionAssetParent document */
  connect?: InputMaybe<CosmosSectionAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAssetParent document */
  create?: InputMaybe<CosmosSectionAssetParentCreateInput>;
};

export type CosmosSectionAssetParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionAssetParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionAssetParent documents */
  connect?: InputMaybe<Array<CosmosSectionAssetParentConnectInput>>;
  /** Create and connect multiple CosmosSectionAssetParent documents */
  create?: InputMaybe<Array<CosmosSectionAssetParentCreateInput>>;
  /** Delete multiple CosmosSectionAssetParent documents */
  delete?: InputMaybe<Array<CosmosSectionAssetParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionAssetParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionAssetParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionAssetParent documents */
  set?: InputMaybe<Array<CosmosSectionAssetParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionAssetParent documents */
  update?: InputMaybe<Array<CosmosSectionAssetParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionAssetParent documents */
  upsert?: InputMaybe<Array<CosmosSectionAssetParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionAssetParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionAssetParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionAssetParent document */
  connect?: InputMaybe<CosmosSectionAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionAssetParent document */
  create?: InputMaybe<CosmosSectionAssetParentCreateInput>;
  /** Delete currently connected CosmosSectionAssetParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionAssetParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAssetParent document */
  update?: InputMaybe<CosmosSectionAssetParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAssetParent document */
  upsert?: InputMaybe<CosmosSectionAssetParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionAssetParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionAssetUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionAssetUpdateLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
};

export type CosmosSectionAssetUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAssetUpdateLocalizationInput = {
  data: CosmosSectionAssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionAssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionAssetUpsertLocalizationInput>>;
};

export type CosmosSectionAssetUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionAsset component instances */
  create?: InputMaybe<Array<CosmosSectionAssetCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionAsset documents */
  delete?: InputMaybe<Array<CosmosSectionAssetWhereUniqueInput>>;
  /** Update multiple CosmosSectionAsset component instances */
  update?: InputMaybe<Array<CosmosSectionAssetUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionAsset component instances */
  upsert?: InputMaybe<Array<CosmosSectionAssetUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionAssetUpdateManyInput = {
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionAssetUpdateManyLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
};

export type CosmosSectionAssetUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionAssetUpdateManyLocalizationInput = {
  data: CosmosSectionAssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionAssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionAssetUpdateManyLocalizationInput>>;
};

export type CosmosSectionAssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionAssetUpdateManyInput;
  /** Document search */
  where: CosmosSectionAssetWhereInput;
};

export type CosmosSectionAssetUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionAsset document */
  create?: InputMaybe<CosmosSectionAssetCreateInput>;
  /** Delete currently connected CosmosSectionAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionAsset document */
  update?: InputMaybe<CosmosSectionAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionAsset document */
  upsert?: InputMaybe<CosmosSectionAssetUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionAssetUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionAssetUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAssetWhereUniqueInput;
};

export type CosmosSectionAssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionAssetUpdateInput;
  /** Unique document search */
  where: CosmosSectionAssetWhereUniqueInput;
};

export type CosmosSectionAssetUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionAssetCreateInput;
  /** Update document if it exists */
  update: CosmosSectionAssetUpdateInput;
};

export type CosmosSectionAssetUpsertLocalizationInput = {
  create: CosmosSectionAssetCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionAssetUpdateLocalizationDataInput;
};

export type CosmosSectionAssetUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionAssetUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionAssetWhereUniqueInput;
};

export type CosmosSectionAssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionAssetUpsertInput;
  /** Unique document search */
  where: CosmosSectionAssetWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionAssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionAsset record uniquely */
export type CosmosSectionAssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionBlobTable = Entity & {
  __typename?: 'CosmosSectionBlobTable';
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The application variable to use for the API key. Dev team will provide. */
  environmentVariable: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Limit the number of blobs in the table */
  limit?: Maybe<Scalars['Int']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionBlobTable>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Determines which service function to call. Different teams implement their blobs differentlly. */
  variant?: Maybe<CosmosEnumBlobTableVariants>;
};


export type CosmosSectionBlobTableConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionBlobTableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionBlobTableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionBlobTableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionBlobTableWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionBlobTableConnection = {
  __typename?: 'CosmosSectionBlobTableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionBlobTableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionBlobTableCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  environmentVariable: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionBlobTableCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumBlobTableVariants>;
};

export type CosmosSectionBlobTableCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionBlobTableCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionBlobTableCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionBlobTableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionBlobTableCreateLocalizationInput>>;
};

export type CosmosSectionBlobTableCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionBlobTable documents */
  create?: InputMaybe<Array<CosmosSectionBlobTableCreateInput>>;
};

export type CosmosSectionBlobTableCreateOneInlineInput = {
  /** Create and connect one CosmosSectionBlobTable document */
  create?: InputMaybe<CosmosSectionBlobTableCreateInput>;
};

export type CosmosSectionBlobTableCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionBlobTableCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionBlobTableEdge = {
  __typename?: 'CosmosSectionBlobTableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionBlobTable;
};

/** Identifies documents */
export type CosmosSectionBlobTableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionBlobTableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionBlobTableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionBlobTableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  environmentVariable?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  environmentVariable_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  environmentVariable_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  environmentVariable_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  environmentVariable_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  environmentVariable_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  environmentVariable_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  environmentVariable_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  environmentVariable_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  environmentVariable_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumBlobTableVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlobTableVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumBlobTableVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlobTableVariants>>>;
};

export enum CosmosSectionBlobTableOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  EnvironmentVariableAsc = 'environmentVariable_ASC',
  EnvironmentVariableDesc = 'environmentVariable_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LimitAsc = 'limit_ASC',
  LimitDesc = 'limit_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosSectionBlobTableParent = CosmosReferenceSection;

export type CosmosSectionBlobTableParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionBlobTableParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionBlobTableParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionBlobTableParent documents */
  connect?: InputMaybe<Array<CosmosSectionBlobTableParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionBlobTableParent documents */
  create?: InputMaybe<Array<CosmosSectionBlobTableParentCreateInput>>;
};

export type CosmosSectionBlobTableParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionBlobTableParent document */
  connect?: InputMaybe<CosmosSectionBlobTableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionBlobTableParent document */
  create?: InputMaybe<CosmosSectionBlobTableParentCreateInput>;
};

export type CosmosSectionBlobTableParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionBlobTableParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionBlobTableParent documents */
  connect?: InputMaybe<Array<CosmosSectionBlobTableParentConnectInput>>;
  /** Create and connect multiple CosmosSectionBlobTableParent documents */
  create?: InputMaybe<Array<CosmosSectionBlobTableParentCreateInput>>;
  /** Delete multiple CosmosSectionBlobTableParent documents */
  delete?: InputMaybe<Array<CosmosSectionBlobTableParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionBlobTableParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionBlobTableParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionBlobTableParent documents */
  set?: InputMaybe<Array<CosmosSectionBlobTableParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionBlobTableParent documents */
  update?: InputMaybe<Array<CosmosSectionBlobTableParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionBlobTableParent documents */
  upsert?: InputMaybe<Array<CosmosSectionBlobTableParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionBlobTableParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionBlobTableParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionBlobTableParent document */
  connect?: InputMaybe<CosmosSectionBlobTableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionBlobTableParent document */
  create?: InputMaybe<CosmosSectionBlobTableParentCreateInput>;
  /** Delete currently connected CosmosSectionBlobTableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionBlobTableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionBlobTableParent document */
  update?: InputMaybe<CosmosSectionBlobTableParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionBlobTableParent document */
  upsert?: InputMaybe<CosmosSectionBlobTableParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlobTableParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlobTableParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlobTableParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionBlobTableParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionBlobTableUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  environmentVariable?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionBlobTableUpdateLocalizationsInput>;
  variant?: InputMaybe<CosmosEnumBlobTableVariants>;
};

export type CosmosSectionBlobTableUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionBlobTableUpdateLocalizationInput = {
  data: CosmosSectionBlobTableUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionBlobTableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionBlobTableCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionBlobTableUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionBlobTableUpsertLocalizationInput>>;
};

export type CosmosSectionBlobTableUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionBlobTable component instances */
  create?: InputMaybe<Array<CosmosSectionBlobTableCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionBlobTable documents */
  delete?: InputMaybe<Array<CosmosSectionBlobTableWhereUniqueInput>>;
  /** Update multiple CosmosSectionBlobTable component instances */
  update?: InputMaybe<Array<CosmosSectionBlobTableUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionBlobTable component instances */
  upsert?: InputMaybe<Array<CosmosSectionBlobTableUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionBlobTableUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  environmentVariable?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionBlobTableUpdateManyLocalizationsInput>;
  variant?: InputMaybe<CosmosEnumBlobTableVariants>;
};

export type CosmosSectionBlobTableUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionBlobTableUpdateManyLocalizationInput = {
  data: CosmosSectionBlobTableUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionBlobTableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionBlobTableUpdateManyLocalizationInput>>;
};

export type CosmosSectionBlobTableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionBlobTableUpdateManyInput;
  /** Document search */
  where: CosmosSectionBlobTableWhereInput;
};

export type CosmosSectionBlobTableUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionBlobTable document */
  create?: InputMaybe<CosmosSectionBlobTableCreateInput>;
  /** Delete currently connected CosmosSectionBlobTable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionBlobTable document */
  update?: InputMaybe<CosmosSectionBlobTableUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionBlobTable document */
  upsert?: InputMaybe<CosmosSectionBlobTableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlobTableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionBlobTableUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionBlobTableWhereUniqueInput;
};

export type CosmosSectionBlobTableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionBlobTableUpdateInput;
  /** Unique document search */
  where: CosmosSectionBlobTableWhereUniqueInput;
};

export type CosmosSectionBlobTableUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionBlobTableCreateInput;
  /** Update document if it exists */
  update: CosmosSectionBlobTableUpdateInput;
};

export type CosmosSectionBlobTableUpsertLocalizationInput = {
  create: CosmosSectionBlobTableCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionBlobTableUpdateLocalizationDataInput;
};

export type CosmosSectionBlobTableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionBlobTableUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionBlobTableWhereUniqueInput;
};

export type CosmosSectionBlobTableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionBlobTableUpsertInput;
  /** Unique document search */
  where: CosmosSectionBlobTableWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionBlobTableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionBlobTableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionBlobTableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionBlobTableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  environmentVariable?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  environmentVariable_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  environmentVariable_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  environmentVariable_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  environmentVariable_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  environmentVariable_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  environmentVariable_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  environmentVariable_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  environmentVariable_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  environmentVariable_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  limit_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  limit_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  limit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  limit_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  limit_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  limit_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  limit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumBlobTableVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlobTableVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumBlobTableVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlobTableVariants>>>;
};

/** References CosmosSectionBlobTable record uniquely */
export type CosmosSectionBlobTableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionBlogCard = Entity & {
  __typename?: 'CosmosSectionBlogCard';
  /** Default true, true stretches cards across whole width of the page, false to stay as forced column size for cards grid. */
  cardGridFitToWidth?: Maybe<Scalars['Boolean']['output']>;
  cards: Array<CosmosElementBlogCard>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionBlogCard>;
  /** Forces the number of cards in a row during layout */
  maxSize?: Maybe<CosmosEnumBlogCardsMaxSize>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionBlogCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementBlogCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementBlogCardWhereInput>;
};


export type CosmosSectionBlogCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionBlogCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionBlogCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionBlogCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionBlogCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionBlogCardConnection = {
  __typename?: 'CosmosSectionBlogCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionBlogCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionBlogCardCreateInput = {
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CosmosElementBlogCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionBlogCardCreateLocalizationsInput>;
  maxSize?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionBlogCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionBlogCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionBlogCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionBlogCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionBlogCardCreateLocalizationInput>>;
};

export type CosmosSectionBlogCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionBlogCard documents */
  create?: InputMaybe<Array<CosmosSectionBlogCardCreateInput>>;
};

export type CosmosSectionBlogCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionBlogCard document */
  create?: InputMaybe<CosmosSectionBlogCardCreateInput>;
};

export type CosmosSectionBlogCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionBlogCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionBlogCardEdge = {
  __typename?: 'CosmosSectionBlogCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionBlogCard;
};

/** Identifies documents */
export type CosmosSectionBlogCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cardGridFitToWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  cards_every?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementBlogCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  maxSize?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
  /** All values that are contained in given list. */
  maxSize_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlogCardsMaxSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  maxSize_not?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
  /** All values that are not contained in given list. */
  maxSize_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlogCardsMaxSize>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionBlogCardOrderByInput {
  CardGridFitToWidthAsc = 'cardGridFitToWidth_ASC',
  CardGridFitToWidthDesc = 'cardGridFitToWidth_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MaxSizeAsc = 'maxSize_ASC',
  MaxSizeDesc = 'maxSize_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionBlogCardParent = CosmosReferenceSection;

export type CosmosSectionBlogCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionBlogCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionBlogCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionBlogCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionBlogCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionBlogCardParent documents */
  create?: InputMaybe<Array<CosmosSectionBlogCardParentCreateInput>>;
};

export type CosmosSectionBlogCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionBlogCardParent document */
  connect?: InputMaybe<CosmosSectionBlogCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionBlogCardParent document */
  create?: InputMaybe<CosmosSectionBlogCardParentCreateInput>;
};

export type CosmosSectionBlogCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionBlogCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionBlogCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionBlogCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionBlogCardParent documents */
  create?: InputMaybe<Array<CosmosSectionBlogCardParentCreateInput>>;
  /** Delete multiple CosmosSectionBlogCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionBlogCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionBlogCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionBlogCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionBlogCardParent documents */
  set?: InputMaybe<Array<CosmosSectionBlogCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionBlogCardParent documents */
  update?: InputMaybe<Array<CosmosSectionBlogCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionBlogCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionBlogCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionBlogCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionBlogCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionBlogCardParent document */
  connect?: InputMaybe<CosmosSectionBlogCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionBlogCardParent document */
  create?: InputMaybe<CosmosSectionBlogCardParentCreateInput>;
  /** Delete currently connected CosmosSectionBlogCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionBlogCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionBlogCardParent document */
  update?: InputMaybe<CosmosSectionBlogCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionBlogCardParent document */
  upsert?: InputMaybe<CosmosSectionBlogCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlogCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlogCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlogCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionBlogCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionBlogCardUpdateInput = {
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CosmosElementBlogCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionBlogCardUpdateLocalizationsInput>;
  maxSize?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
};

export type CosmosSectionBlogCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionBlogCardUpdateLocalizationInput = {
  data: CosmosSectionBlogCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionBlogCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionBlogCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionBlogCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionBlogCardUpsertLocalizationInput>>;
};

export type CosmosSectionBlogCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionBlogCard component instances */
  create?: InputMaybe<Array<CosmosSectionBlogCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionBlogCard documents */
  delete?: InputMaybe<Array<CosmosSectionBlogCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionBlogCard component instances */
  update?: InputMaybe<Array<CosmosSectionBlogCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionBlogCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionBlogCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionBlogCardUpdateManyInput = {
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionBlogCardUpdateManyLocalizationsInput>;
  maxSize?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
};

export type CosmosSectionBlogCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionBlogCardUpdateManyLocalizationInput = {
  data: CosmosSectionBlogCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionBlogCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionBlogCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionBlogCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionBlogCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionBlogCardWhereInput;
};

export type CosmosSectionBlogCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionBlogCard document */
  create?: InputMaybe<CosmosSectionBlogCardCreateInput>;
  /** Delete currently connected CosmosSectionBlogCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionBlogCard document */
  update?: InputMaybe<CosmosSectionBlogCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionBlogCard document */
  upsert?: InputMaybe<CosmosSectionBlogCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionBlogCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionBlogCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionBlogCardWhereUniqueInput;
};

export type CosmosSectionBlogCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionBlogCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionBlogCardWhereUniqueInput;
};

export type CosmosSectionBlogCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionBlogCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionBlogCardUpdateInput;
};

export type CosmosSectionBlogCardUpsertLocalizationInput = {
  create: CosmosSectionBlogCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionBlogCardUpdateLocalizationDataInput;
};

export type CosmosSectionBlogCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionBlogCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionBlogCardWhereUniqueInput;
};

export type CosmosSectionBlogCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionBlogCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionBlogCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionBlogCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardGridFitToWidth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cardGridFitToWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  cards_every?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementBlogCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementBlogCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  maxSize?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
  /** All values that are contained in given list. */
  maxSize_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlogCardsMaxSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  maxSize_not?: InputMaybe<CosmosEnumBlogCardsMaxSize>;
  /** All values that are not contained in given list. */
  maxSize_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumBlogCardsMaxSize>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionBlogCard record uniquely */
export type CosmosSectionBlogCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionCkRichText = Entity & {
  __typename?: 'CosmosSectionCkRichText';
  buttons: Array<CosmosElementButton>;
  /** Center the text container */
  centered?: Maybe<Scalars['Boolean']['output']>;
  /** Center the buttons */
  centeredButton?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<CosmosConfigSection>;
  content?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionCkRichText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Wider max-width for the container */
  wide?: Maybe<Scalars['Boolean']['output']>;
};


export type CosmosSectionCkRichTextButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosSectionCkRichTextConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionCkRichTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionCkRichTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionCkRichTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionCkRichTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionCkRichTextConnection = {
  __typename?: 'CosmosSectionCkRichTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionCkRichTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionCkRichTextCreateInput = {
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionCkRichTextCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionCkRichTextCreateLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionCkRichTextCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionCkRichTextCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCkRichTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionCkRichTextCreateLocalizationInput>>;
};

export type CosmosSectionCkRichTextCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionCkRichText documents */
  create?: InputMaybe<Array<CosmosSectionCkRichTextCreateInput>>;
};

export type CosmosSectionCkRichTextCreateOneInlineInput = {
  /** Create and connect one CosmosSectionCkRichText document */
  create?: InputMaybe<CosmosSectionCkRichTextCreateInput>;
};

export type CosmosSectionCkRichTextCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionCkRichTextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionCkRichTextEdge = {
  __typename?: 'CosmosSectionCkRichTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionCkRichText;
};

/** Identifies documents */
export type CosmosSectionCkRichTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionCkRichTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionCkRichTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionCkRichTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  wide_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CosmosSectionCkRichTextOrderByInput {
  CenteredButtonAsc = 'centeredButton_ASC',
  CenteredButtonDesc = 'centeredButton_DESC',
  CenteredAsc = 'centered_ASC',
  CenteredDesc = 'centered_DESC',
  ContentAsc = 'content_ASC',
  ContentDesc = 'content_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WideAsc = 'wide_ASC',
  WideDesc = 'wide_DESC'
}

export type CosmosSectionCkRichTextParent = CosmosReferenceSection;

export type CosmosSectionCkRichTextParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionCkRichTextParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionCkRichTextParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionCkRichTextParent documents */
  connect?: InputMaybe<Array<CosmosSectionCkRichTextParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionCkRichTextParent documents */
  create?: InputMaybe<Array<CosmosSectionCkRichTextParentCreateInput>>;
};

export type CosmosSectionCkRichTextParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionCkRichTextParent document */
  connect?: InputMaybe<CosmosSectionCkRichTextParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionCkRichTextParent document */
  create?: InputMaybe<CosmosSectionCkRichTextParentCreateInput>;
};

export type CosmosSectionCkRichTextParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionCkRichTextParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionCkRichTextParent documents */
  connect?: InputMaybe<Array<CosmosSectionCkRichTextParentConnectInput>>;
  /** Create and connect multiple CosmosSectionCkRichTextParent documents */
  create?: InputMaybe<Array<CosmosSectionCkRichTextParentCreateInput>>;
  /** Delete multiple CosmosSectionCkRichTextParent documents */
  delete?: InputMaybe<Array<CosmosSectionCkRichTextParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionCkRichTextParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionCkRichTextParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionCkRichTextParent documents */
  set?: InputMaybe<Array<CosmosSectionCkRichTextParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionCkRichTextParent documents */
  update?: InputMaybe<Array<CosmosSectionCkRichTextParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionCkRichTextParent documents */
  upsert?: InputMaybe<Array<CosmosSectionCkRichTextParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionCkRichTextParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionCkRichTextParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionCkRichTextParent document */
  connect?: InputMaybe<CosmosSectionCkRichTextParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionCkRichTextParent document */
  create?: InputMaybe<CosmosSectionCkRichTextParentCreateInput>;
  /** Delete currently connected CosmosSectionCkRichTextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionCkRichTextParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionCkRichTextParent document */
  update?: InputMaybe<CosmosSectionCkRichTextParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionCkRichTextParent document */
  upsert?: InputMaybe<CosmosSectionCkRichTextParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCkRichTextParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionCkRichTextParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCkRichTextParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionCkRichTextParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionCkRichTextUpdateInput = {
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionCkRichTextUpdateLocalizationsInput>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionCkRichTextUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionCkRichTextUpdateLocalizationInput = {
  data: CosmosSectionCkRichTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCkRichTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionCkRichTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionCkRichTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionCkRichTextUpsertLocalizationInput>>;
};

export type CosmosSectionCkRichTextUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionCkRichText component instances */
  create?: InputMaybe<Array<CosmosSectionCkRichTextCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionCkRichText documents */
  delete?: InputMaybe<Array<CosmosSectionCkRichTextWhereUniqueInput>>;
  /** Update multiple CosmosSectionCkRichText component instances */
  update?: InputMaybe<Array<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionCkRichText component instances */
  upsert?: InputMaybe<Array<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionCkRichTextUpdateManyInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionCkRichTextUpdateManyLocalizationsInput>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionCkRichTextUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionCkRichTextUpdateManyLocalizationInput = {
  data: CosmosSectionCkRichTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCkRichTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionCkRichTextUpdateManyLocalizationInput>>;
};

export type CosmosSectionCkRichTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionCkRichTextUpdateManyInput;
  /** Document search */
  where: CosmosSectionCkRichTextWhereInput;
};

export type CosmosSectionCkRichTextUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionCkRichText document */
  create?: InputMaybe<CosmosSectionCkRichTextCreateInput>;
  /** Delete currently connected CosmosSectionCkRichText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionCkRichText document */
  update?: InputMaybe<CosmosSectionCkRichTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionCkRichText document */
  upsert?: InputMaybe<CosmosSectionCkRichTextUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCkRichTextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionCkRichTextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionCkRichTextWhereUniqueInput;
};

export type CosmosSectionCkRichTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionCkRichTextUpdateInput;
  /** Unique document search */
  where: CosmosSectionCkRichTextWhereUniqueInput;
};

export type CosmosSectionCkRichTextUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionCkRichTextCreateInput;
  /** Update document if it exists */
  update: CosmosSectionCkRichTextUpdateInput;
};

export type CosmosSectionCkRichTextUpsertLocalizationInput = {
  create: CosmosSectionCkRichTextCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionCkRichTextUpdateLocalizationDataInput;
};

export type CosmosSectionCkRichTextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionCkRichTextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionCkRichTextWhereUniqueInput;
};

export type CosmosSectionCkRichTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionCkRichTextUpsertInput;
  /** Unique document search */
  where: CosmosSectionCkRichTextWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionCkRichTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionCkRichTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionCkRichTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionCkRichTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  wide_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References CosmosSectionCkRichText record uniquely */
export type CosmosSectionCkRichTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionCommunity = Entity & {
  __typename?: 'CosmosSectionCommunity';
  /** Controls what data will be displayed */
  application?: Maybe<CosmosEnumApplicationFamily>;
  /** Config for the section */
  config?: Maybe<CosmosConfigSection>;
  /** Forum button */
  forumButton?: Maybe<CosmosElementButton>;
  /** You should add "{postsPerWeek}" string to the input field to show the posts per week number. */
  forumTitle?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionCommunity>;
  resources?: Maybe<CommunityResource>;
  skipCommunityTable?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionCommunityConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionCommunityForumButtonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionCommunityLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionCommunityResourcesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionCommunityUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionCommunityConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionCommunityWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionCommunityConnection = {
  __typename?: 'CosmosSectionCommunityConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionCommunityEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionCommunityCreateInput = {
  application?: InputMaybe<CosmosEnumApplicationFamily>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  forumButton?: InputMaybe<CosmosElementButtonCreateOneInlineInput>;
  /** forumTitle input for default locale (en) */
  forumTitle?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionCommunityCreateLocalizationsInput>;
  resources?: InputMaybe<CommunityResourceCreateOneInlineInput>;
  skipCommunityTable?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionCommunityCreateLocalizationDataInput = {
  forumTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionCommunityCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionCommunityCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCommunityCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionCommunityCreateLocalizationInput>>;
};

export type CosmosSectionCommunityCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionCommunity documents */
  create?: InputMaybe<Array<CosmosSectionCommunityCreateInput>>;
};

export type CosmosSectionCommunityCreateOneInlineInput = {
  /** Create and connect one CosmosSectionCommunity document */
  create?: InputMaybe<CosmosSectionCommunityCreateInput>;
};

export type CosmosSectionCommunityCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionCommunityCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionCommunityEdge = {
  __typename?: 'CosmosSectionCommunityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionCommunity;
};

/** Identifies documents */
export type CosmosSectionCommunityManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionCommunityWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionCommunityWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionCommunityWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are contained in given list. */
  application_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  /** Any other value that exists and is not equal to the given value. */
  application_not?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are not contained in given list. */
  application_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  forumButton?: InputMaybe<CosmosElementButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  resources?: InputMaybe<CommunityResourceWhereInput>;
  skipCommunityTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  skipCommunityTable_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionCommunityOrderByInput {
  ApplicationAsc = 'application_ASC',
  ApplicationDesc = 'application_DESC',
  ForumTitleAsc = 'forumTitle_ASC',
  ForumTitleDesc = 'forumTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SkipCommunityTableAsc = 'skipCommunityTable_ASC',
  SkipCommunityTableDesc = 'skipCommunityTable_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionCommunityParent = CosmosReferenceSection;

export type CosmosSectionCommunityParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionCommunityParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionCommunityParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionCommunityParent documents */
  connect?: InputMaybe<Array<CosmosSectionCommunityParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionCommunityParent documents */
  create?: InputMaybe<Array<CosmosSectionCommunityParentCreateInput>>;
};

export type CosmosSectionCommunityParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionCommunityParent document */
  connect?: InputMaybe<CosmosSectionCommunityParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionCommunityParent document */
  create?: InputMaybe<CosmosSectionCommunityParentCreateInput>;
};

export type CosmosSectionCommunityParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionCommunityParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionCommunityParent documents */
  connect?: InputMaybe<Array<CosmosSectionCommunityParentConnectInput>>;
  /** Create and connect multiple CosmosSectionCommunityParent documents */
  create?: InputMaybe<Array<CosmosSectionCommunityParentCreateInput>>;
  /** Delete multiple CosmosSectionCommunityParent documents */
  delete?: InputMaybe<Array<CosmosSectionCommunityParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionCommunityParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionCommunityParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionCommunityParent documents */
  set?: InputMaybe<Array<CosmosSectionCommunityParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionCommunityParent documents */
  update?: InputMaybe<Array<CosmosSectionCommunityParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionCommunityParent documents */
  upsert?: InputMaybe<Array<CosmosSectionCommunityParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionCommunityParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionCommunityParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionCommunityParent document */
  connect?: InputMaybe<CosmosSectionCommunityParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionCommunityParent document */
  create?: InputMaybe<CosmosSectionCommunityParentCreateInput>;
  /** Delete currently connected CosmosSectionCommunityParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionCommunityParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionCommunityParent document */
  update?: InputMaybe<CosmosSectionCommunityParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionCommunityParent document */
  upsert?: InputMaybe<CosmosSectionCommunityParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCommunityParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionCommunityParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCommunityParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionCommunityParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionCommunityUpdateInput = {
  application?: InputMaybe<CosmosEnumApplicationFamily>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  forumButton?: InputMaybe<CosmosElementButtonUpdateOneInlineInput>;
  /** forumTitle input for default locale (en) */
  forumTitle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionCommunityUpdateLocalizationsInput>;
  resources?: InputMaybe<CommunityResourceUpdateOneInlineInput>;
  skipCommunityTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionCommunityUpdateLocalizationDataInput = {
  forumTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionCommunityUpdateLocalizationInput = {
  data: CosmosSectionCommunityUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCommunityUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionCommunityCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionCommunityUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionCommunityUpsertLocalizationInput>>;
};

export type CosmosSectionCommunityUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionCommunity component instances */
  create?: InputMaybe<Array<CosmosSectionCommunityCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionCommunity documents */
  delete?: InputMaybe<Array<CosmosSectionCommunityWhereUniqueInput>>;
  /** Update multiple CosmosSectionCommunity component instances */
  update?: InputMaybe<Array<CosmosSectionCommunityUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionCommunity component instances */
  upsert?: InputMaybe<Array<CosmosSectionCommunityUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionCommunityUpdateManyInput = {
  application?: InputMaybe<CosmosEnumApplicationFamily>;
  /** forumTitle input for default locale (en) */
  forumTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionCommunityUpdateManyLocalizationsInput>;
  skipCommunityTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionCommunityUpdateManyLocalizationDataInput = {
  forumTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionCommunityUpdateManyLocalizationInput = {
  data: CosmosSectionCommunityUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCommunityUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionCommunityUpdateManyLocalizationInput>>;
};

export type CosmosSectionCommunityUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionCommunityUpdateManyInput;
  /** Document search */
  where: CosmosSectionCommunityWhereInput;
};

export type CosmosSectionCommunityUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionCommunity document */
  create?: InputMaybe<CosmosSectionCommunityCreateInput>;
  /** Delete currently connected CosmosSectionCommunity document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionCommunity document */
  update?: InputMaybe<CosmosSectionCommunityUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionCommunity document */
  upsert?: InputMaybe<CosmosSectionCommunityUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCommunityUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionCommunityUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionCommunityWhereUniqueInput;
};

export type CosmosSectionCommunityUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionCommunityUpdateInput;
  /** Unique document search */
  where: CosmosSectionCommunityWhereUniqueInput;
};

export type CosmosSectionCommunityUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionCommunityCreateInput;
  /** Update document if it exists */
  update: CosmosSectionCommunityUpdateInput;
};

export type CosmosSectionCommunityUpsertLocalizationInput = {
  create: CosmosSectionCommunityCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionCommunityUpdateLocalizationDataInput;
};

export type CosmosSectionCommunityUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionCommunityUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionCommunityWhereUniqueInput;
};

export type CosmosSectionCommunityUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionCommunityUpsertInput;
  /** Unique document search */
  where: CosmosSectionCommunityWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionCommunityWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionCommunityWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionCommunityWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionCommunityWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are contained in given list. */
  application_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  /** Any other value that exists and is not equal to the given value. */
  application_not?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are not contained in given list. */
  application_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  forumButton?: InputMaybe<CosmosElementButtonWhereInput>;
  forumTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  forumTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  forumTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  forumTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  forumTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  forumTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  forumTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  forumTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  forumTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  forumTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  resources?: InputMaybe<CommunityResourceWhereInput>;
  skipCommunityTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  skipCommunityTable_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionCommunity record uniquely */
export type CosmosSectionCommunityWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionComplexCtaCard = Entity & {
  __typename?: 'CosmosSectionComplexCtaCard';
  /** Description displayed below the cards */
  bottomDescription?: Maybe<RichText>;
  cards: Array<CosmosElementComplexCtaCard>;
  /** Select Complex CTA Variant (Default: ThreeColumns) */
  complexCtaVariant?: Maybe<CosmosEnumComplexCtaVariant>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionComplexCtaCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionComplexCtaCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementComplexCtaCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
};


export type CosmosSectionComplexCtaCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionComplexCtaCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionComplexCtaCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionComplexCtaCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionComplexCtaCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionComplexCtaCardConnection = {
  __typename?: 'CosmosSectionComplexCtaCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionComplexCtaCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionComplexCtaCardCreateInput = {
  /** bottomDescription input for default locale (en) */
  bottomDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  cards?: InputMaybe<CosmosElementComplexCtaCardCreateManyInlineInput>;
  complexCtaVariant?: InputMaybe<CosmosEnumComplexCtaVariant>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionComplexCtaCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionComplexCtaCardCreateLocalizationDataInput = {
  bottomDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionComplexCtaCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionComplexCtaCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionComplexCtaCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionComplexCtaCardCreateLocalizationInput>>;
};

export type CosmosSectionComplexCtaCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionComplexCtaCard documents */
  create?: InputMaybe<Array<CosmosSectionComplexCtaCardCreateInput>>;
};

export type CosmosSectionComplexCtaCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionComplexCtaCard document */
  create?: InputMaybe<CosmosSectionComplexCtaCardCreateInput>;
};

export type CosmosSectionComplexCtaCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionComplexCtaCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionComplexCtaCardEdge = {
  __typename?: 'CosmosSectionComplexCtaCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionComplexCtaCard;
};

/** Identifies documents */
export type CosmosSectionComplexCtaCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  complexCtaVariant?: InputMaybe<CosmosEnumComplexCtaVariant>;
  /** All values that are contained in given list. */
  complexCtaVariant_in?: InputMaybe<Array<InputMaybe<CosmosEnumComplexCtaVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  complexCtaVariant_not?: InputMaybe<CosmosEnumComplexCtaVariant>;
  /** All values that are not contained in given list. */
  complexCtaVariant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumComplexCtaVariant>>>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionComplexCtaCardOrderByInput {
  ComplexCtaVariantAsc = 'complexCtaVariant_ASC',
  ComplexCtaVariantDesc = 'complexCtaVariant_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionComplexCtaCardParent = CosmosReferenceSection;

export type CosmosSectionComplexCtaCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionComplexCtaCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionComplexCtaCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionComplexCtaCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionComplexCtaCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionComplexCtaCardParent documents */
  create?: InputMaybe<Array<CosmosSectionComplexCtaCardParentCreateInput>>;
};

export type CosmosSectionComplexCtaCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionComplexCtaCardParent document */
  connect?: InputMaybe<CosmosSectionComplexCtaCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionComplexCtaCardParent document */
  create?: InputMaybe<CosmosSectionComplexCtaCardParentCreateInput>;
};

export type CosmosSectionComplexCtaCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionComplexCtaCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionComplexCtaCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionComplexCtaCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionComplexCtaCardParent documents */
  create?: InputMaybe<Array<CosmosSectionComplexCtaCardParentCreateInput>>;
  /** Delete multiple CosmosSectionComplexCtaCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionComplexCtaCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionComplexCtaCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionComplexCtaCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionComplexCtaCardParent documents */
  set?: InputMaybe<Array<CosmosSectionComplexCtaCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionComplexCtaCardParent documents */
  update?: InputMaybe<Array<CosmosSectionComplexCtaCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionComplexCtaCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionComplexCtaCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionComplexCtaCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionComplexCtaCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionComplexCtaCardParent document */
  connect?: InputMaybe<CosmosSectionComplexCtaCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionComplexCtaCardParent document */
  create?: InputMaybe<CosmosSectionComplexCtaCardParentCreateInput>;
  /** Delete currently connected CosmosSectionComplexCtaCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionComplexCtaCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionComplexCtaCardParent document */
  update?: InputMaybe<CosmosSectionComplexCtaCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionComplexCtaCardParent document */
  upsert?: InputMaybe<CosmosSectionComplexCtaCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionComplexCtaCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionComplexCtaCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionComplexCtaCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionComplexCtaCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionComplexCtaCardUpdateInput = {
  /** bottomDescription input for default locale (en) */
  bottomDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  cards?: InputMaybe<CosmosElementComplexCtaCardUpdateManyInlineInput>;
  complexCtaVariant?: InputMaybe<CosmosEnumComplexCtaVariant>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionComplexCtaCardUpdateLocalizationsInput>;
};

export type CosmosSectionComplexCtaCardUpdateLocalizationDataInput = {
  bottomDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionComplexCtaCardUpdateLocalizationInput = {
  data: CosmosSectionComplexCtaCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionComplexCtaCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionComplexCtaCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionComplexCtaCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionComplexCtaCardUpsertLocalizationInput>>;
};

export type CosmosSectionComplexCtaCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionComplexCtaCard component instances */
  create?: InputMaybe<Array<CosmosSectionComplexCtaCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionComplexCtaCard documents */
  delete?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionComplexCtaCard component instances */
  update?: InputMaybe<Array<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionComplexCtaCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionComplexCtaCardUpdateManyInput = {
  /** bottomDescription input for default locale (en) */
  bottomDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
  complexCtaVariant?: InputMaybe<CosmosEnumComplexCtaVariant>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionComplexCtaCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionComplexCtaCardUpdateManyLocalizationDataInput = {
  bottomDescription?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionComplexCtaCardUpdateManyLocalizationInput = {
  data: CosmosSectionComplexCtaCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionComplexCtaCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionComplexCtaCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionComplexCtaCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionComplexCtaCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionComplexCtaCardWhereInput;
};

export type CosmosSectionComplexCtaCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionComplexCtaCard document */
  create?: InputMaybe<CosmosSectionComplexCtaCardCreateInput>;
  /** Delete currently connected CosmosSectionComplexCtaCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionComplexCtaCard document */
  update?: InputMaybe<CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionComplexCtaCard document */
  upsert?: InputMaybe<CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionComplexCtaCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionComplexCtaCardWhereUniqueInput;
};

export type CosmosSectionComplexCtaCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionComplexCtaCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionComplexCtaCardWhereUniqueInput;
};

export type CosmosSectionComplexCtaCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionComplexCtaCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionComplexCtaCardUpdateInput;
};

export type CosmosSectionComplexCtaCardUpsertLocalizationInput = {
  create: CosmosSectionComplexCtaCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionComplexCtaCardUpdateLocalizationDataInput;
};

export type CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionComplexCtaCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionComplexCtaCardWhereUniqueInput;
};

export type CosmosSectionComplexCtaCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionComplexCtaCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionComplexCtaCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionComplexCtaCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionComplexCtaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementComplexCtaCardWhereInput>;
  complexCtaVariant?: InputMaybe<CosmosEnumComplexCtaVariant>;
  /** All values that are contained in given list. */
  complexCtaVariant_in?: InputMaybe<Array<InputMaybe<CosmosEnumComplexCtaVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  complexCtaVariant_not?: InputMaybe<CosmosEnumComplexCtaVariant>;
  /** All values that are not contained in given list. */
  complexCtaVariant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumComplexCtaVariant>>>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionComplexCtaCard record uniquely */
export type CosmosSectionComplexCtaCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionContentLargeImage = Entity & {
  __typename?: 'CosmosSectionContentLargeImage';
  /** The primary image/video asset of the component. */
  asset?: Maybe<Asset>;
  badges: Array<CosmosElementTag>;
  /** The image asset to use for the blurred background effect around the primary asset. */
  blurredImage?: Maybe<Asset>;
  buttons: Array<CosmosElementButton>;
  caption?: Maybe<Scalars['String']['output']>;
  config?: Maybe<CosmosConfigSection>;
  desc?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Horizontally flip the image and content */
  flip?: Maybe<Scalars['Boolean']['output']>;
  /** Gradient to apply to the title field for valid anchor tags. */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageLabel?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionContentLargeImage>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Vertically center content within card */
  verticallyCenter?: Maybe<Scalars['Boolean']['output']>;
};


export type CosmosSectionContentLargeImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionContentLargeImageBadgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTagWhereInput>;
};


export type CosmosSectionContentLargeImageBlurredImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionContentLargeImageButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosSectionContentLargeImageConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionContentLargeImageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionContentLargeImageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionContentLargeImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionContentLargeImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionContentLargeImageConnection = {
  __typename?: 'CosmosSectionContentLargeImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionContentLargeImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionContentLargeImageCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  badges?: InputMaybe<CosmosElementTagCreateManyInlineInput>;
  blurredImage?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionContentLargeImageCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionContentLargeImageCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionContentLargeImageCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionContentLargeImageCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionContentLargeImageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionContentLargeImageCreateLocalizationInput>>;
};

export type CosmosSectionContentLargeImageCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionContentLargeImage documents */
  create?: InputMaybe<Array<CosmosSectionContentLargeImageCreateInput>>;
};

export type CosmosSectionContentLargeImageCreateOneInlineInput = {
  /** Create and connect one CosmosSectionContentLargeImage document */
  create?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
};

export type CosmosSectionContentLargeImageCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionContentLargeImageCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionContentLargeImageEdge = {
  __typename?: 'CosmosSectionContentLargeImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionContentLargeImage;
};

/** Identifies documents */
export type CosmosSectionContentLargeImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionContentLargeImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionContentLargeImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionContentLargeImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  badges_every?: InputMaybe<CosmosElementTagWhereInput>;
  badges_none?: InputMaybe<CosmosElementTagWhereInput>;
  badges_some?: InputMaybe<CosmosElementTagWhereInput>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CosmosSectionContentLargeImageOrderByInput {
  CaptionAsc = 'caption_ASC',
  CaptionDesc = 'caption_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  FlipAsc = 'flip_ASC',
  FlipDesc = 'flip_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageLabelAsc = 'imageLabel_ASC',
  ImageLabelDesc = 'imageLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VerticallyCenterAsc = 'verticallyCenter_ASC',
  VerticallyCenterDesc = 'verticallyCenter_DESC'
}

export type CosmosSectionContentLargeImageParent = CosmosPageBlogDetail | CosmosPageLicense | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionContentLargeImageParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionContentLargeImageParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionContentLargeImageParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionContentLargeImageParent documents */
  connect?: InputMaybe<Array<CosmosSectionContentLargeImageParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionContentLargeImageParent documents */
  create?: InputMaybe<Array<CosmosSectionContentLargeImageParentCreateInput>>;
};

export type CosmosSectionContentLargeImageParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionContentLargeImageParent document */
  connect?: InputMaybe<CosmosSectionContentLargeImageParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionContentLargeImageParent document */
  create?: InputMaybe<CosmosSectionContentLargeImageParentCreateInput>;
};

export type CosmosSectionContentLargeImageParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionContentLargeImageParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionContentLargeImageParent documents */
  connect?: InputMaybe<Array<CosmosSectionContentLargeImageParentConnectInput>>;
  /** Create and connect multiple CosmosSectionContentLargeImageParent documents */
  create?: InputMaybe<Array<CosmosSectionContentLargeImageParentCreateInput>>;
  /** Delete multiple CosmosSectionContentLargeImageParent documents */
  delete?: InputMaybe<Array<CosmosSectionContentLargeImageParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionContentLargeImageParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionContentLargeImageParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionContentLargeImageParent documents */
  set?: InputMaybe<Array<CosmosSectionContentLargeImageParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionContentLargeImageParent documents */
  update?: InputMaybe<Array<CosmosSectionContentLargeImageParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionContentLargeImageParent documents */
  upsert?: InputMaybe<Array<CosmosSectionContentLargeImageParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionContentLargeImageParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionContentLargeImageParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionContentLargeImageParent document */
  connect?: InputMaybe<CosmosSectionContentLargeImageParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionContentLargeImageParent document */
  create?: InputMaybe<CosmosSectionContentLargeImageParentCreateInput>;
  /** Delete currently connected CosmosSectionContentLargeImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionContentLargeImageParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionContentLargeImageParent document */
  update?: InputMaybe<CosmosSectionContentLargeImageParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionContentLargeImageParent document */
  upsert?: InputMaybe<CosmosSectionContentLargeImageParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentLargeImageParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentLargeImageParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentLargeImageParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionContentLargeImageParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionContentLargeImageUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  badges?: InputMaybe<CosmosElementTagUpdateManyInlineInput>;
  blurredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionContentLargeImageUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionContentLargeImageUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionContentLargeImageUpdateLocalizationInput = {
  data: CosmosSectionContentLargeImageUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionContentLargeImageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionContentLargeImageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionContentLargeImageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionContentLargeImageUpsertLocalizationInput>>;
};

export type CosmosSectionContentLargeImageUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionContentLargeImage component instances */
  create?: InputMaybe<Array<CosmosSectionContentLargeImageCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionContentLargeImage documents */
  delete?: InputMaybe<Array<CosmosSectionContentLargeImageWhereUniqueInput>>;
  /** Update multiple CosmosSectionContentLargeImage component instances */
  update?: InputMaybe<Array<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionContentLargeImage component instances */
  upsert?: InputMaybe<Array<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionContentLargeImageUpdateManyInput = {
  /** caption input for default locale (en) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionContentLargeImageUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionContentLargeImageUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionContentLargeImageUpdateManyLocalizationInput = {
  data: CosmosSectionContentLargeImageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionContentLargeImageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionContentLargeImageUpdateManyLocalizationInput>>;
};

export type CosmosSectionContentLargeImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionContentLargeImageUpdateManyInput;
  /** Document search */
  where: CosmosSectionContentLargeImageWhereInput;
};

export type CosmosSectionContentLargeImageUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionContentLargeImage document */
  create?: InputMaybe<CosmosSectionContentLargeImageCreateInput>;
  /** Delete currently connected CosmosSectionContentLargeImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionContentLargeImage document */
  update?: InputMaybe<CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionContentLargeImage document */
  upsert?: InputMaybe<CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionContentLargeImageUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionContentLargeImageWhereUniqueInput;
};

export type CosmosSectionContentLargeImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionContentLargeImageUpdateInput;
  /** Unique document search */
  where: CosmosSectionContentLargeImageWhereUniqueInput;
};

export type CosmosSectionContentLargeImageUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionContentLargeImageCreateInput;
  /** Update document if it exists */
  update: CosmosSectionContentLargeImageUpdateInput;
};

export type CosmosSectionContentLargeImageUpsertLocalizationInput = {
  create: CosmosSectionContentLargeImageCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionContentLargeImageUpdateLocalizationDataInput;
};

export type CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionContentLargeImageUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionContentLargeImageWhereUniqueInput;
};

export type CosmosSectionContentLargeImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionContentLargeImageUpsertInput;
  /** Unique document search */
  where: CosmosSectionContentLargeImageWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionContentLargeImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionContentLargeImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionContentLargeImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionContentLargeImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  badges_every?: InputMaybe<CosmosElementTagWhereInput>;
  badges_none?: InputMaybe<CosmosElementTagWhereInput>;
  badges_some?: InputMaybe<CosmosElementTagWhereInput>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References CosmosSectionContentLargeImage record uniquely */
export type CosmosSectionContentLargeImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionContentSliderAsset = Entity & {
  __typename?: 'CosmosSectionContentSliderAsset';
  assets: Array<Asset>;
  badges: Array<CosmosElementTag>;
  buttons: Array<CosmosElementButton>;
  config?: Maybe<CosmosConfigSection>;
  desc?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Horizontally flip the image and content */
  flip?: Maybe<Scalars['Boolean']['output']>;
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageLabel?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionContentSliderAsset>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Vertically center content within card */
  verticallyCenter?: Maybe<Scalars['Boolean']['output']>;
};


export type CosmosSectionContentSliderAssetAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type CosmosSectionContentSliderAssetBadgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTagWhereInput>;
};


export type CosmosSectionContentSliderAssetButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosSectionContentSliderAssetConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionContentSliderAssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionContentSliderAssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionContentSliderAssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionContentSliderAssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionContentSliderAssetConnection = {
  __typename?: 'CosmosSectionContentSliderAssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionContentSliderAssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionContentSliderAssetCreateInput = {
  assets?: InputMaybe<AssetCreateManyInlineInput>;
  badges?: InputMaybe<CosmosElementTagCreateManyInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionContentSliderAssetCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionContentSliderAssetCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionContentSliderAssetCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionContentSliderAssetCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionContentSliderAssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionContentSliderAssetCreateLocalizationInput>>;
};

export type CosmosSectionContentSliderAssetCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionContentSliderAsset documents */
  create?: InputMaybe<Array<CosmosSectionContentSliderAssetCreateInput>>;
};

export type CosmosSectionContentSliderAssetCreateOneInlineInput = {
  /** Create and connect one CosmosSectionContentSliderAsset document */
  create?: InputMaybe<CosmosSectionContentSliderAssetCreateInput>;
};

export type CosmosSectionContentSliderAssetCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionContentSliderAssetCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionContentSliderAssetEdge = {
  __typename?: 'CosmosSectionContentSliderAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionContentSliderAsset;
};

/** Identifies documents */
export type CosmosSectionContentSliderAssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assets_every?: InputMaybe<AssetWhereInput>;
  assets_none?: InputMaybe<AssetWhereInput>;
  assets_some?: InputMaybe<AssetWhereInput>;
  badges_every?: InputMaybe<CosmosElementTagWhereInput>;
  badges_none?: InputMaybe<CosmosElementTagWhereInput>;
  badges_some?: InputMaybe<CosmosElementTagWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CosmosSectionContentSliderAssetOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  FlipAsc = 'flip_ASC',
  FlipDesc = 'flip_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ImageLabelAsc = 'imageLabel_ASC',
  ImageLabelDesc = 'imageLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VerticallyCenterAsc = 'verticallyCenter_ASC',
  VerticallyCenterDesc = 'verticallyCenter_DESC'
}

export type CosmosSectionContentSliderAssetParent = CosmosReferenceSection;

export type CosmosSectionContentSliderAssetParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionContentSliderAssetParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionContentSliderAssetParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionContentSliderAssetParent documents */
  connect?: InputMaybe<Array<CosmosSectionContentSliderAssetParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionContentSliderAssetParent documents */
  create?: InputMaybe<Array<CosmosSectionContentSliderAssetParentCreateInput>>;
};

export type CosmosSectionContentSliderAssetParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionContentSliderAssetParent document */
  connect?: InputMaybe<CosmosSectionContentSliderAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionContentSliderAssetParent document */
  create?: InputMaybe<CosmosSectionContentSliderAssetParentCreateInput>;
};

export type CosmosSectionContentSliderAssetParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionContentSliderAssetParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionContentSliderAssetParent documents */
  connect?: InputMaybe<Array<CosmosSectionContentSliderAssetParentConnectInput>>;
  /** Create and connect multiple CosmosSectionContentSliderAssetParent documents */
  create?: InputMaybe<Array<CosmosSectionContentSliderAssetParentCreateInput>>;
  /** Delete multiple CosmosSectionContentSliderAssetParent documents */
  delete?: InputMaybe<Array<CosmosSectionContentSliderAssetParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionContentSliderAssetParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionContentSliderAssetParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionContentSliderAssetParent documents */
  set?: InputMaybe<Array<CosmosSectionContentSliderAssetParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionContentSliderAssetParent documents */
  update?: InputMaybe<Array<CosmosSectionContentSliderAssetParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionContentSliderAssetParent documents */
  upsert?: InputMaybe<Array<CosmosSectionContentSliderAssetParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionContentSliderAssetParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionContentSliderAssetParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionContentSliderAssetParent document */
  connect?: InputMaybe<CosmosSectionContentSliderAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionContentSliderAssetParent document */
  create?: InputMaybe<CosmosSectionContentSliderAssetParentCreateInput>;
  /** Delete currently connected CosmosSectionContentSliderAssetParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionContentSliderAssetParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionContentSliderAssetParent document */
  update?: InputMaybe<CosmosSectionContentSliderAssetParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionContentSliderAssetParent document */
  upsert?: InputMaybe<CosmosSectionContentSliderAssetParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentSliderAssetParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentSliderAssetParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentSliderAssetParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionContentSliderAssetParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionContentSliderAssetUpdateInput = {
  assets?: InputMaybe<AssetUpdateManyInlineInput>;
  badges?: InputMaybe<CosmosElementTagUpdateManyInlineInput>;
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionContentSliderAssetUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionContentSliderAssetUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionContentSliderAssetUpdateLocalizationInput = {
  data: CosmosSectionContentSliderAssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionContentSliderAssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionContentSliderAssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionContentSliderAssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionContentSliderAssetUpsertLocalizationInput>>;
};

export type CosmosSectionContentSliderAssetUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionContentSliderAsset component instances */
  create?: InputMaybe<Array<CosmosSectionContentSliderAssetCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionContentSliderAsset documents */
  delete?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereUniqueInput>>;
  /** Update multiple CosmosSectionContentSliderAsset component instances */
  update?: InputMaybe<Array<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionContentSliderAsset component instances */
  upsert?: InputMaybe<Array<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionContentSliderAssetUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** imageLabel input for default locale (en) */
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionContentSliderAssetUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionContentSliderAssetUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionContentSliderAssetUpdateManyLocalizationInput = {
  data: CosmosSectionContentSliderAssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionContentSliderAssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionContentSliderAssetUpdateManyLocalizationInput>>;
};

export type CosmosSectionContentSliderAssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionContentSliderAssetUpdateManyInput;
  /** Document search */
  where: CosmosSectionContentSliderAssetWhereInput;
};

export type CosmosSectionContentSliderAssetUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionContentSliderAsset document */
  create?: InputMaybe<CosmosSectionContentSliderAssetCreateInput>;
  /** Delete currently connected CosmosSectionContentSliderAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionContentSliderAsset document */
  update?: InputMaybe<CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionContentSliderAsset document */
  upsert?: InputMaybe<CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionContentSliderAssetUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionContentSliderAssetWhereUniqueInput;
};

export type CosmosSectionContentSliderAssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionContentSliderAssetUpdateInput;
  /** Unique document search */
  where: CosmosSectionContentSliderAssetWhereUniqueInput;
};

export type CosmosSectionContentSliderAssetUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionContentSliderAssetCreateInput;
  /** Update document if it exists */
  update: CosmosSectionContentSliderAssetUpdateInput;
};

export type CosmosSectionContentSliderAssetUpsertLocalizationInput = {
  create: CosmosSectionContentSliderAssetCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionContentSliderAssetUpdateLocalizationDataInput;
};

export type CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionContentSliderAssetUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionContentSliderAssetWhereUniqueInput;
};

export type CosmosSectionContentSliderAssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionContentSliderAssetUpsertInput;
  /** Unique document search */
  where: CosmosSectionContentSliderAssetWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionContentSliderAssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionContentSliderAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assets_every?: InputMaybe<AssetWhereInput>;
  assets_none?: InputMaybe<AssetWhereInput>;
  assets_some?: InputMaybe<AssetWhereInput>;
  badges_every?: InputMaybe<CosmosElementTagWhereInput>;
  badges_none?: InputMaybe<CosmosElementTagWhereInput>;
  badges_some?: InputMaybe<CosmosElementTagWhereInput>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References CosmosSectionContentSliderAsset record uniquely */
export type CosmosSectionContentSliderAssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionCrux = Entity & {
  __typename?: 'CosmosSectionCrux';
  /** Up to 4 cards can be rendered here */
  cards: Array<CosmosElementLink>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** Up to 4 crux links can be rendered here */
  cruxLinks: Array<CosmosElementCruxLink>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionCrux>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionCruxCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLinkWhereInput>;
};


export type CosmosSectionCruxConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionCruxCruxLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementCruxLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementCruxLinkWhereInput>;
};


export type CosmosSectionCruxLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionCruxUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionCruxConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionCruxWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionCruxConnection = {
  __typename?: 'CosmosSectionCruxConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionCruxEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionCruxCreateInput = {
  cards?: InputMaybe<CosmosElementLinkCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  cruxLinks?: InputMaybe<CosmosElementCruxLinkCreateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionCruxCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionCruxCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionCruxCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionCruxCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCruxCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionCruxCreateLocalizationInput>>;
};

export type CosmosSectionCruxCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionCrux documents */
  create?: InputMaybe<Array<CosmosSectionCruxCreateInput>>;
};

export type CosmosSectionCruxCreateOneInlineInput = {
  /** Create and connect one CosmosSectionCrux document */
  create?: InputMaybe<CosmosSectionCruxCreateInput>;
};

export type CosmosSectionCruxCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionCruxCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionCruxEdge = {
  __typename?: 'CosmosSectionCruxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionCrux;
};

/** Identifies documents */
export type CosmosSectionCruxManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionCruxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionCruxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionCruxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementLinkWhereInput>;
  cards_none?: InputMaybe<CosmosElementLinkWhereInput>;
  cards_some?: InputMaybe<CosmosElementLinkWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  cruxLinks_every?: InputMaybe<CosmosElementCruxLinkWhereInput>;
  cruxLinks_none?: InputMaybe<CosmosElementCruxLinkWhereInput>;
  cruxLinks_some?: InputMaybe<CosmosElementCruxLinkWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionCruxOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionCruxParent = CosmosReferenceSection;

export type CosmosSectionCruxParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionCruxParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionCruxParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionCruxParent documents */
  connect?: InputMaybe<Array<CosmosSectionCruxParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionCruxParent documents */
  create?: InputMaybe<Array<CosmosSectionCruxParentCreateInput>>;
};

export type CosmosSectionCruxParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionCruxParent document */
  connect?: InputMaybe<CosmosSectionCruxParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionCruxParent document */
  create?: InputMaybe<CosmosSectionCruxParentCreateInput>;
};

export type CosmosSectionCruxParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionCruxParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionCruxParent documents */
  connect?: InputMaybe<Array<CosmosSectionCruxParentConnectInput>>;
  /** Create and connect multiple CosmosSectionCruxParent documents */
  create?: InputMaybe<Array<CosmosSectionCruxParentCreateInput>>;
  /** Delete multiple CosmosSectionCruxParent documents */
  delete?: InputMaybe<Array<CosmosSectionCruxParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionCruxParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionCruxParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionCruxParent documents */
  set?: InputMaybe<Array<CosmosSectionCruxParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionCruxParent documents */
  update?: InputMaybe<Array<CosmosSectionCruxParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionCruxParent documents */
  upsert?: InputMaybe<Array<CosmosSectionCruxParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionCruxParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionCruxParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionCruxParent document */
  connect?: InputMaybe<CosmosSectionCruxParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionCruxParent document */
  create?: InputMaybe<CosmosSectionCruxParentCreateInput>;
  /** Delete currently connected CosmosSectionCruxParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionCruxParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionCruxParent document */
  update?: InputMaybe<CosmosSectionCruxParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionCruxParent document */
  upsert?: InputMaybe<CosmosSectionCruxParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCruxParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionCruxParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCruxParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionCruxParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionCruxUpdateInput = {
  cards?: InputMaybe<CosmosElementLinkUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  cruxLinks?: InputMaybe<CosmosElementCruxLinkUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionCruxUpdateLocalizationsInput>;
};

export type CosmosSectionCruxUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionCruxUpdateLocalizationInput = {
  data: CosmosSectionCruxUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCruxUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionCruxCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionCruxUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionCruxUpsertLocalizationInput>>;
};

export type CosmosSectionCruxUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionCrux component instances */
  create?: InputMaybe<Array<CosmosSectionCruxCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionCrux documents */
  delete?: InputMaybe<Array<CosmosSectionCruxWhereUniqueInput>>;
  /** Update multiple CosmosSectionCrux component instances */
  update?: InputMaybe<Array<CosmosSectionCruxUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionCrux component instances */
  upsert?: InputMaybe<Array<CosmosSectionCruxUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionCruxUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionCruxUpdateManyLocalizationsInput>;
};

export type CosmosSectionCruxUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionCruxUpdateManyLocalizationInput = {
  data: CosmosSectionCruxUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionCruxUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionCruxUpdateManyLocalizationInput>>;
};

export type CosmosSectionCruxUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionCruxUpdateManyInput;
  /** Document search */
  where: CosmosSectionCruxWhereInput;
};

export type CosmosSectionCruxUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionCrux document */
  create?: InputMaybe<CosmosSectionCruxCreateInput>;
  /** Delete currently connected CosmosSectionCrux document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionCrux document */
  update?: InputMaybe<CosmosSectionCruxUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionCrux document */
  upsert?: InputMaybe<CosmosSectionCruxUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionCruxUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionCruxUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionCruxWhereUniqueInput;
};

export type CosmosSectionCruxUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionCruxUpdateInput;
  /** Unique document search */
  where: CosmosSectionCruxWhereUniqueInput;
};

export type CosmosSectionCruxUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionCruxCreateInput;
  /** Update document if it exists */
  update: CosmosSectionCruxUpdateInput;
};

export type CosmosSectionCruxUpsertLocalizationInput = {
  create: CosmosSectionCruxCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionCruxUpdateLocalizationDataInput;
};

export type CosmosSectionCruxUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionCruxUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionCruxWhereUniqueInput;
};

export type CosmosSectionCruxUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionCruxUpsertInput;
  /** Unique document search */
  where: CosmosSectionCruxWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionCruxWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionCruxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionCruxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionCruxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementLinkWhereInput>;
  cards_none?: InputMaybe<CosmosElementLinkWhereInput>;
  cards_some?: InputMaybe<CosmosElementLinkWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  cruxLinks_every?: InputMaybe<CosmosElementCruxLinkWhereInput>;
  cruxLinks_none?: InputMaybe<CosmosElementCruxLinkWhereInput>;
  cruxLinks_some?: InputMaybe<CosmosElementCruxLinkWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionCrux record uniquely */
export type CosmosSectionCruxWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionDelphinusCardsGrid = Entity & {
  __typename?: 'CosmosSectionDelphinusCardsGrid';
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  grid: Array<CosmosElementDelphinusCard>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionDelphinusCardsGrid>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionDelphinusCardsGridConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDelphinusCardsGridGridArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementDelphinusCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
};


export type CosmosSectionDelphinusCardsGridLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionDelphinusCardsGridUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionDelphinusCardsGridConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionDelphinusCardsGridWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionDelphinusCardsGridConnection = {
  __typename?: 'CosmosSectionDelphinusCardsGridConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionDelphinusCardsGridEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionDelphinusCardsGridCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  grid?: InputMaybe<CosmosElementDelphinusCardCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionDelphinusCardsGridCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDelphinusCardsGridCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDelphinusCardsGridCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionDelphinusCardsGridCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDelphinusCardsGridCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionDelphinusCardsGridCreateLocalizationInput>>;
};

export type CosmosSectionDelphinusCardsGridCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionDelphinusCardsGrid documents */
  create?: InputMaybe<Array<CosmosSectionDelphinusCardsGridCreateInput>>;
};

export type CosmosSectionDelphinusCardsGridCreateOneInlineInput = {
  /** Create and connect one CosmosSectionDelphinusCardsGrid document */
  create?: InputMaybe<CosmosSectionDelphinusCardsGridCreateInput>;
};

export type CosmosSectionDelphinusCardsGridCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionDelphinusCardsGridCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionDelphinusCardsGridEdge = {
  __typename?: 'CosmosSectionDelphinusCardsGridEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionDelphinusCardsGrid;
};

/** Identifies documents */
export type CosmosSectionDelphinusCardsGridManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  grid_every?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  grid_none?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  grid_some?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionDelphinusCardsGridOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionDelphinusCardsGridParent = CosmosReferenceSection;

export type CosmosSectionDelphinusCardsGridParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionDelphinusCardsGridParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionDelphinusCardsGridParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDelphinusCardsGridParent documents */
  connect?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionDelphinusCardsGridParent documents */
  create?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentCreateInput>>;
};

export type CosmosSectionDelphinusCardsGridParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionDelphinusCardsGridParent document */
  connect?: InputMaybe<CosmosSectionDelphinusCardsGridParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDelphinusCardsGridParent document */
  create?: InputMaybe<CosmosSectionDelphinusCardsGridParentCreateInput>;
};

export type CosmosSectionDelphinusCardsGridParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionDelphinusCardsGridParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDelphinusCardsGridParent documents */
  connect?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentConnectInput>>;
  /** Create and connect multiple CosmosSectionDelphinusCardsGridParent documents */
  create?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentCreateInput>>;
  /** Delete multiple CosmosSectionDelphinusCardsGridParent documents */
  delete?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionDelphinusCardsGridParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionDelphinusCardsGridParent documents */
  set?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionDelphinusCardsGridParent documents */
  update?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionDelphinusCardsGridParent documents */
  upsert?: InputMaybe<Array<CosmosSectionDelphinusCardsGridParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionDelphinusCardsGridParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionDelphinusCardsGridParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionDelphinusCardsGridParent document */
  connect?: InputMaybe<CosmosSectionDelphinusCardsGridParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDelphinusCardsGridParent document */
  create?: InputMaybe<CosmosSectionDelphinusCardsGridParentCreateInput>;
  /** Delete currently connected CosmosSectionDelphinusCardsGridParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionDelphinusCardsGridParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDelphinusCardsGridParent document */
  update?: InputMaybe<CosmosSectionDelphinusCardsGridParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDelphinusCardsGridParent document */
  upsert?: InputMaybe<CosmosSectionDelphinusCardsGridParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDelphinusCardsGridParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionDelphinusCardsGridParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDelphinusCardsGridParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionDelphinusCardsGridParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionDelphinusCardsGridUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  grid?: InputMaybe<CosmosElementDelphinusCardUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateLocalizationsInput>;
};

export type CosmosSectionDelphinusCardsGridUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDelphinusCardsGridUpdateLocalizationInput = {
  data: CosmosSectionDelphinusCardsGridUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDelphinusCardsGridUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionDelphinusCardsGridCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDelphinusCardsGridUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionDelphinusCardsGridUpsertLocalizationInput>>;
};

export type CosmosSectionDelphinusCardsGridUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionDelphinusCardsGrid component instances */
  create?: InputMaybe<Array<CosmosSectionDelphinusCardsGridCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionDelphinusCardsGrid documents */
  delete?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereUniqueInput>>;
  /** Update multiple CosmosSectionDelphinusCardsGrid component instances */
  update?: InputMaybe<Array<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionDelphinusCardsGrid component instances */
  upsert?: InputMaybe<Array<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionDelphinusCardsGridUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateManyLocalizationsInput>;
};

export type CosmosSectionDelphinusCardsGridUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDelphinusCardsGridUpdateManyLocalizationInput = {
  data: CosmosSectionDelphinusCardsGridUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDelphinusCardsGridUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDelphinusCardsGridUpdateManyLocalizationInput>>;
};

export type CosmosSectionDelphinusCardsGridUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionDelphinusCardsGridUpdateManyInput;
  /** Document search */
  where: CosmosSectionDelphinusCardsGridWhereInput;
};

export type CosmosSectionDelphinusCardsGridUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionDelphinusCardsGrid document */
  create?: InputMaybe<CosmosSectionDelphinusCardsGridCreateInput>;
  /** Delete currently connected CosmosSectionDelphinusCardsGrid document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDelphinusCardsGrid document */
  update?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDelphinusCardsGrid document */
  upsert?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionDelphinusCardsGridUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDelphinusCardsGridWhereUniqueInput;
};

export type CosmosSectionDelphinusCardsGridUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionDelphinusCardsGridUpdateInput;
  /** Unique document search */
  where: CosmosSectionDelphinusCardsGridWhereUniqueInput;
};

export type CosmosSectionDelphinusCardsGridUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionDelphinusCardsGridCreateInput;
  /** Update document if it exists */
  update: CosmosSectionDelphinusCardsGridUpdateInput;
};

export type CosmosSectionDelphinusCardsGridUpsertLocalizationInput = {
  create: CosmosSectionDelphinusCardsGridCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionDelphinusCardsGridUpdateLocalizationDataInput;
};

export type CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionDelphinusCardsGridUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDelphinusCardsGridWhereUniqueInput;
};

export type CosmosSectionDelphinusCardsGridUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionDelphinusCardsGridUpsertInput;
  /** Unique document search */
  where: CosmosSectionDelphinusCardsGridWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionDelphinusCardsGridWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDelphinusCardsGridWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  grid_every?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  grid_none?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  grid_some?: InputMaybe<CosmosElementDelphinusCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionDelphinusCardsGrid record uniquely */
export type CosmosSectionDelphinusCardsGridWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionDevelopersList = Entity & {
  __typename?: 'CosmosSectionDevelopersList';
  config?: Maybe<CosmosConfigSection>;
  developersTsv?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionDevelopersList>;
  /** System stage field */
  stage: Stage;
  tableHeading?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionDevelopersListConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDevelopersListDevelopersTsvArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionDevelopersListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionDevelopersListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionDevelopersListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionDevelopersListWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionDevelopersListConnection = {
  __typename?: 'CosmosSectionDevelopersListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionDevelopersListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionDevelopersListCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  developersTsv?: InputMaybe<AssetCreateOneInlineInput>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionDevelopersListCreateLocalizationsInput>;
  /** tableHeading input for default locale (en) */
  tableHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDevelopersListCreateLocalizationDataInput = {
  tableHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDevelopersListCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionDevelopersListCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDevelopersListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionDevelopersListCreateLocalizationInput>>;
};

export type CosmosSectionDevelopersListCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionDevelopersList documents */
  create?: InputMaybe<Array<CosmosSectionDevelopersListCreateInput>>;
};

export type CosmosSectionDevelopersListCreateOneInlineInput = {
  /** Create and connect one CosmosSectionDevelopersList document */
  create?: InputMaybe<CosmosSectionDevelopersListCreateInput>;
};

export type CosmosSectionDevelopersListCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionDevelopersListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionDevelopersListEdge = {
  __typename?: 'CosmosSectionDevelopersListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionDevelopersList;
};

/** Identifies documents */
export type CosmosSectionDevelopersListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDevelopersListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDevelopersListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDevelopersListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  developersTsv?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  itemsPerPage_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  itemsPerPage_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  itemsPerPage_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  itemsPerPage_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  itemsPerPage_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  itemsPerPage_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  itemsPerPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionDevelopersListOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ItemsPerPageAsc = 'itemsPerPage_ASC',
  ItemsPerPageDesc = 'itemsPerPage_DESC',
  TableHeadingAsc = 'tableHeading_ASC',
  TableHeadingDesc = 'tableHeading_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionDevelopersListParent = CosmosReferenceSection;

export type CosmosSectionDevelopersListParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionDevelopersListParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionDevelopersListParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDevelopersListParent documents */
  connect?: InputMaybe<Array<CosmosSectionDevelopersListParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionDevelopersListParent documents */
  create?: InputMaybe<Array<CosmosSectionDevelopersListParentCreateInput>>;
};

export type CosmosSectionDevelopersListParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionDevelopersListParent document */
  connect?: InputMaybe<CosmosSectionDevelopersListParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDevelopersListParent document */
  create?: InputMaybe<CosmosSectionDevelopersListParentCreateInput>;
};

export type CosmosSectionDevelopersListParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionDevelopersListParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDevelopersListParent documents */
  connect?: InputMaybe<Array<CosmosSectionDevelopersListParentConnectInput>>;
  /** Create and connect multiple CosmosSectionDevelopersListParent documents */
  create?: InputMaybe<Array<CosmosSectionDevelopersListParentCreateInput>>;
  /** Delete multiple CosmosSectionDevelopersListParent documents */
  delete?: InputMaybe<Array<CosmosSectionDevelopersListParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionDevelopersListParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionDevelopersListParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionDevelopersListParent documents */
  set?: InputMaybe<Array<CosmosSectionDevelopersListParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionDevelopersListParent documents */
  update?: InputMaybe<Array<CosmosSectionDevelopersListParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionDevelopersListParent documents */
  upsert?: InputMaybe<Array<CosmosSectionDevelopersListParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionDevelopersListParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionDevelopersListParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionDevelopersListParent document */
  connect?: InputMaybe<CosmosSectionDevelopersListParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDevelopersListParent document */
  create?: InputMaybe<CosmosSectionDevelopersListParentCreateInput>;
  /** Delete currently connected CosmosSectionDevelopersListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionDevelopersListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDevelopersListParent document */
  update?: InputMaybe<CosmosSectionDevelopersListParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDevelopersListParent document */
  upsert?: InputMaybe<CosmosSectionDevelopersListParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDevelopersListParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionDevelopersListParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDevelopersListParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionDevelopersListParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionDevelopersListUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  developersTsv?: InputMaybe<AssetUpdateOneInlineInput>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionDevelopersListUpdateLocalizationsInput>;
  /** tableHeading input for default locale (en) */
  tableHeading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDevelopersListUpdateLocalizationDataInput = {
  tableHeading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDevelopersListUpdateLocalizationInput = {
  data: CosmosSectionDevelopersListUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDevelopersListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionDevelopersListCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDevelopersListUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionDevelopersListUpsertLocalizationInput>>;
};

export type CosmosSectionDevelopersListUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionDevelopersList component instances */
  create?: InputMaybe<Array<CosmosSectionDevelopersListCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionDevelopersList documents */
  delete?: InputMaybe<Array<CosmosSectionDevelopersListWhereUniqueInput>>;
  /** Update multiple CosmosSectionDevelopersList component instances */
  update?: InputMaybe<Array<CosmosSectionDevelopersListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionDevelopersList component instances */
  upsert?: InputMaybe<Array<CosmosSectionDevelopersListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionDevelopersListUpdateManyInput = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionDevelopersListUpdateManyLocalizationsInput>;
  /** tableHeading input for default locale (en) */
  tableHeading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDevelopersListUpdateManyLocalizationDataInput = {
  tableHeading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDevelopersListUpdateManyLocalizationInput = {
  data: CosmosSectionDevelopersListUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDevelopersListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDevelopersListUpdateManyLocalizationInput>>;
};

export type CosmosSectionDevelopersListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionDevelopersListUpdateManyInput;
  /** Document search */
  where: CosmosSectionDevelopersListWhereInput;
};

export type CosmosSectionDevelopersListUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionDevelopersList document */
  create?: InputMaybe<CosmosSectionDevelopersListCreateInput>;
  /** Delete currently connected CosmosSectionDevelopersList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDevelopersList document */
  update?: InputMaybe<CosmosSectionDevelopersListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDevelopersList document */
  upsert?: InputMaybe<CosmosSectionDevelopersListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDevelopersListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionDevelopersListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDevelopersListWhereUniqueInput;
};

export type CosmosSectionDevelopersListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionDevelopersListUpdateInput;
  /** Unique document search */
  where: CosmosSectionDevelopersListWhereUniqueInput;
};

export type CosmosSectionDevelopersListUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionDevelopersListCreateInput;
  /** Update document if it exists */
  update: CosmosSectionDevelopersListUpdateInput;
};

export type CosmosSectionDevelopersListUpsertLocalizationInput = {
  create: CosmosSectionDevelopersListCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionDevelopersListUpdateLocalizationDataInput;
};

export type CosmosSectionDevelopersListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionDevelopersListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDevelopersListWhereUniqueInput;
};

export type CosmosSectionDevelopersListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionDevelopersListUpsertInput;
  /** Unique document search */
  where: CosmosSectionDevelopersListWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionDevelopersListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDevelopersListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDevelopersListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDevelopersListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  developersTsv?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  itemsPerPage_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  itemsPerPage_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  itemsPerPage_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  itemsPerPage_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  itemsPerPage_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  itemsPerPage_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  itemsPerPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tableHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tableHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tableHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tableHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tableHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tableHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tableHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tableHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tableHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tableHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionDevelopersList record uniquely */
export type CosmosSectionDevelopersListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionDivider = Entity & {
  __typename?: 'CosmosSectionDivider';
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** Only set this value if both the previous and next sections are set to a non-default EDS Background Color. (That will ensure the page margins of this divider are also the same background color) */
  edsBackgroundColor?: Maybe<CosmosEnumEdsBackgroundColors>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionDivider>;
  /** Size of the divider. Default is "lg". "md" matches asset width. "sm" matches content width. */
  size?: Maybe<CosmosEnumSectionSizes>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionDividerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionDividerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionDividerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionDividerWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionDividerConnection = {
  __typename?: 'CosmosSectionDividerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionDividerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionDividerCreateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionDividerCreateLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDividerCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDividerCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionDividerCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDividerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionDividerCreateLocalizationInput>>;
};

export type CosmosSectionDividerCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionDivider documents */
  create?: InputMaybe<Array<CosmosSectionDividerCreateInput>>;
};

export type CosmosSectionDividerCreateOneInlineInput = {
  /** Create and connect one CosmosSectionDivider document */
  create?: InputMaybe<CosmosSectionDividerCreateInput>;
};

export type CosmosSectionDividerCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionDividerCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionDividerEdge = {
  __typename?: 'CosmosSectionDividerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionDivider;
};

/** Identifies documents */
export type CosmosSectionDividerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDividerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDividerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDividerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are contained in given list. */
  edsBackgroundColor_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  edsBackgroundColor_not?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are not contained in given list. */
  edsBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionDividerOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  EdsBackgroundColorAsc = 'edsBackgroundColor_ASC',
  EdsBackgroundColorDesc = 'edsBackgroundColor_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionDividerParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionDividerParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionDividerParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionDividerParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDividerParent documents */
  connect?: InputMaybe<Array<CosmosSectionDividerParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionDividerParent documents */
  create?: InputMaybe<Array<CosmosSectionDividerParentCreateInput>>;
};

export type CosmosSectionDividerParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionDividerParent document */
  connect?: InputMaybe<CosmosSectionDividerParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDividerParent document */
  create?: InputMaybe<CosmosSectionDividerParentCreateInput>;
};

export type CosmosSectionDividerParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionDividerParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDividerParent documents */
  connect?: InputMaybe<Array<CosmosSectionDividerParentConnectInput>>;
  /** Create and connect multiple CosmosSectionDividerParent documents */
  create?: InputMaybe<Array<CosmosSectionDividerParentCreateInput>>;
  /** Delete multiple CosmosSectionDividerParent documents */
  delete?: InputMaybe<Array<CosmosSectionDividerParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionDividerParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionDividerParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionDividerParent documents */
  set?: InputMaybe<Array<CosmosSectionDividerParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionDividerParent documents */
  update?: InputMaybe<Array<CosmosSectionDividerParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionDividerParent documents */
  upsert?: InputMaybe<Array<CosmosSectionDividerParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionDividerParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionDividerParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionDividerParent document */
  connect?: InputMaybe<CosmosSectionDividerParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDividerParent document */
  create?: InputMaybe<CosmosSectionDividerParentCreateInput>;
  /** Delete currently connected CosmosSectionDividerParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionDividerParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDividerParent document */
  update?: InputMaybe<CosmosSectionDividerParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDividerParent document */
  upsert?: InputMaybe<CosmosSectionDividerParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDividerParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionDividerParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDividerParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionDividerParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionDividerUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionDividerUpdateLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
};

export type CosmosSectionDividerUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDividerUpdateLocalizationInput = {
  data: CosmosSectionDividerUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDividerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionDividerCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDividerUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionDividerUpsertLocalizationInput>>;
};

export type CosmosSectionDividerUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionDivider component instances */
  create?: InputMaybe<Array<CosmosSectionDividerCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionDivider documents */
  delete?: InputMaybe<Array<CosmosSectionDividerWhereUniqueInput>>;
  /** Update multiple CosmosSectionDivider component instances */
  update?: InputMaybe<Array<CosmosSectionDividerUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionDivider component instances */
  upsert?: InputMaybe<Array<CosmosSectionDividerUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionDividerUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionDividerUpdateManyLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
};

export type CosmosSectionDividerUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDividerUpdateManyLocalizationInput = {
  data: CosmosSectionDividerUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDividerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDividerUpdateManyLocalizationInput>>;
};

export type CosmosSectionDividerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionDividerUpdateManyInput;
  /** Document search */
  where: CosmosSectionDividerWhereInput;
};

export type CosmosSectionDividerUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionDivider document */
  create?: InputMaybe<CosmosSectionDividerCreateInput>;
  /** Delete currently connected CosmosSectionDivider document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDivider document */
  update?: InputMaybe<CosmosSectionDividerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDivider document */
  upsert?: InputMaybe<CosmosSectionDividerUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDividerUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionDividerUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDividerWhereUniqueInput;
};

export type CosmosSectionDividerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionDividerUpdateInput;
  /** Unique document search */
  where: CosmosSectionDividerWhereUniqueInput;
};

export type CosmosSectionDividerUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionDividerCreateInput;
  /** Update document if it exists */
  update: CosmosSectionDividerUpdateInput;
};

export type CosmosSectionDividerUpsertLocalizationInput = {
  create: CosmosSectionDividerCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionDividerUpdateLocalizationDataInput;
};

export type CosmosSectionDividerUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionDividerUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDividerWhereUniqueInput;
};

export type CosmosSectionDividerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionDividerUpsertInput;
  /** Unique document search */
  where: CosmosSectionDividerWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionDividerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDividerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDividerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDividerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  edsBackgroundColor?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are contained in given list. */
  edsBackgroundColor_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  /** Any other value that exists and is not equal to the given value. */
  edsBackgroundColor_not?: InputMaybe<CosmosEnumEdsBackgroundColors>;
  /** All values that are not contained in given list. */
  edsBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsBackgroundColors>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionDivider record uniquely */
export type CosmosSectionDividerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionDownloadCard = Entity & {
  __typename?: 'CosmosSectionDownloadCard';
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<CosmosElementDownloadCard>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionDownloadCard>;
  /** System stage field */
  stage: Stage;
  steps: Array<CosmosElementDownloadStep>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionDownloadCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDownloadCardFooterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDownloadCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionDownloadCardStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementDownloadStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementDownloadStepWhereInput>;
};


export type CosmosSectionDownloadCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionDownloadCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionDownloadCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionDownloadCardConnection = {
  __typename?: 'CosmosSectionDownloadCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionDownloadCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionDownloadCardCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<CosmosElementDownloadCardCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionDownloadCardCreateLocalizationsInput>;
  steps?: InputMaybe<CosmosElementDownloadStepCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDownloadCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDownloadCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionDownloadCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDownloadCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionDownloadCardCreateLocalizationInput>>;
};

export type CosmosSectionDownloadCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionDownloadCard documents */
  create?: InputMaybe<Array<CosmosSectionDownloadCardCreateInput>>;
};

export type CosmosSectionDownloadCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionDownloadCard document */
  create?: InputMaybe<CosmosSectionDownloadCardCreateInput>;
};

export type CosmosSectionDownloadCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionDownloadCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionDownloadCardEdge = {
  __typename?: 'CosmosSectionDownloadCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionDownloadCard;
};

/** Identifies documents */
export type CosmosSectionDownloadCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDownloadCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDownloadCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDownloadCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  footer?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  steps_every?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  steps_none?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  steps_some?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionDownloadCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionDownloadCardParent = CosmosReferenceSection;

export type CosmosSectionDownloadCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionDownloadCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionDownloadCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDownloadCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionDownloadCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionDownloadCardParent documents */
  create?: InputMaybe<Array<CosmosSectionDownloadCardParentCreateInput>>;
};

export type CosmosSectionDownloadCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionDownloadCardParent document */
  connect?: InputMaybe<CosmosSectionDownloadCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDownloadCardParent document */
  create?: InputMaybe<CosmosSectionDownloadCardParentCreateInput>;
};

export type CosmosSectionDownloadCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionDownloadCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDownloadCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionDownloadCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionDownloadCardParent documents */
  create?: InputMaybe<Array<CosmosSectionDownloadCardParentCreateInput>>;
  /** Delete multiple CosmosSectionDownloadCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionDownloadCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionDownloadCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionDownloadCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionDownloadCardParent documents */
  set?: InputMaybe<Array<CosmosSectionDownloadCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionDownloadCardParent documents */
  update?: InputMaybe<Array<CosmosSectionDownloadCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionDownloadCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionDownloadCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionDownloadCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionDownloadCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionDownloadCardParent document */
  connect?: InputMaybe<CosmosSectionDownloadCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDownloadCardParent document */
  create?: InputMaybe<CosmosSectionDownloadCardParentCreateInput>;
  /** Delete currently connected CosmosSectionDownloadCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionDownloadCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDownloadCardParent document */
  update?: InputMaybe<CosmosSectionDownloadCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDownloadCardParent document */
  upsert?: InputMaybe<CosmosSectionDownloadCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionDownloadCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionDownloadCardUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<CosmosElementDownloadCardUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionDownloadCardUpdateLocalizationsInput>;
  steps?: InputMaybe<CosmosElementDownloadStepUpdateManyInlineInput>;
};

export type CosmosSectionDownloadCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDownloadCardUpdateLocalizationInput = {
  data: CosmosSectionDownloadCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDownloadCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionDownloadCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDownloadCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionDownloadCardUpsertLocalizationInput>>;
};

export type CosmosSectionDownloadCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionDownloadCard component instances */
  create?: InputMaybe<Array<CosmosSectionDownloadCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionDownloadCard documents */
  delete?: InputMaybe<Array<CosmosSectionDownloadCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionDownloadCard component instances */
  update?: InputMaybe<Array<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionDownloadCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionDownloadCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionDownloadCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionDownloadCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDownloadCardUpdateManyLocalizationInput = {
  data: CosmosSectionDownloadCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDownloadCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDownloadCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionDownloadCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionDownloadCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionDownloadCardWhereInput;
};

export type CosmosSectionDownloadCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionDownloadCard document */
  create?: InputMaybe<CosmosSectionDownloadCardCreateInput>;
  /** Delete currently connected CosmosSectionDownloadCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDownloadCard document */
  update?: InputMaybe<CosmosSectionDownloadCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDownloadCard document */
  upsert?: InputMaybe<CosmosSectionDownloadCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionDownloadCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDownloadCardWhereUniqueInput;
};

export type CosmosSectionDownloadCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionDownloadCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionDownloadCardWhereUniqueInput;
};

export type CosmosSectionDownloadCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionDownloadCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionDownloadCardUpdateInput;
};

export type CosmosSectionDownloadCardUpsertLocalizationInput = {
  create: CosmosSectionDownloadCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionDownloadCardUpdateLocalizationDataInput;
};

export type CosmosSectionDownloadCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionDownloadCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDownloadCardWhereUniqueInput;
};

export type CosmosSectionDownloadCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionDownloadCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionDownloadCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionDownloadCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDownloadCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDownloadCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDownloadCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  steps_every?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  steps_none?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  steps_some?: InputMaybe<CosmosElementDownloadStepWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionDownloadCard record uniquely */
export type CosmosSectionDownloadCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionDownloadable = Entity & {
  __typename?: 'CosmosSectionDownloadable';
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** Binary executables available for download */
  executables: Array<CosmosElementDownloadCard>;
  /** A card that will always be at the section bottom */
  footer?: Maybe<CosmosElementDownloadCard>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Download instuctions */
  instructions?: Maybe<CosmosReferenceSection>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionDownloadable>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionDownloadableConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDownloadableExecutablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementDownloadCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementDownloadCardWhereInput>;
};


export type CosmosSectionDownloadableFooterArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDownloadableInstructionsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionDownloadableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionDownloadableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionDownloadableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionDownloadableWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionDownloadableConnection = {
  __typename?: 'CosmosSectionDownloadableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionDownloadableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionDownloadableCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  executables?: InputMaybe<CosmosElementDownloadCardCreateManyInlineInput>;
  footer?: InputMaybe<CosmosElementDownloadCardCreateOneInlineInput>;
  instructions?: InputMaybe<CosmosReferenceSectionCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionDownloadableCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDownloadableCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionDownloadableCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionDownloadableCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDownloadableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionDownloadableCreateLocalizationInput>>;
};

export type CosmosSectionDownloadableCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionDownloadable documents */
  create?: InputMaybe<Array<CosmosSectionDownloadableCreateInput>>;
};

export type CosmosSectionDownloadableCreateOneInlineInput = {
  /** Create and connect one CosmosSectionDownloadable document */
  create?: InputMaybe<CosmosSectionDownloadableCreateInput>;
};

export type CosmosSectionDownloadableCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionDownloadableCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionDownloadableEdge = {
  __typename?: 'CosmosSectionDownloadableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionDownloadable;
};

/** Identifies documents */
export type CosmosSectionDownloadableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDownloadableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDownloadableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDownloadableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  executables_every?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  executables_none?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  executables_some?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  footer?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<CosmosReferenceSectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionDownloadableOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionDownloadableParent = CosmosReferenceSection;

export type CosmosSectionDownloadableParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionDownloadableParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionDownloadableParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDownloadableParent documents */
  connect?: InputMaybe<Array<CosmosSectionDownloadableParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionDownloadableParent documents */
  create?: InputMaybe<Array<CosmosSectionDownloadableParentCreateInput>>;
};

export type CosmosSectionDownloadableParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionDownloadableParent document */
  connect?: InputMaybe<CosmosSectionDownloadableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDownloadableParent document */
  create?: InputMaybe<CosmosSectionDownloadableParentCreateInput>;
};

export type CosmosSectionDownloadableParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionDownloadableParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionDownloadableParent documents */
  connect?: InputMaybe<Array<CosmosSectionDownloadableParentConnectInput>>;
  /** Create and connect multiple CosmosSectionDownloadableParent documents */
  create?: InputMaybe<Array<CosmosSectionDownloadableParentCreateInput>>;
  /** Delete multiple CosmosSectionDownloadableParent documents */
  delete?: InputMaybe<Array<CosmosSectionDownloadableParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionDownloadableParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionDownloadableParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionDownloadableParent documents */
  set?: InputMaybe<Array<CosmosSectionDownloadableParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionDownloadableParent documents */
  update?: InputMaybe<Array<CosmosSectionDownloadableParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionDownloadableParent documents */
  upsert?: InputMaybe<Array<CosmosSectionDownloadableParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionDownloadableParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionDownloadableParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionDownloadableParent document */
  connect?: InputMaybe<CosmosSectionDownloadableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionDownloadableParent document */
  create?: InputMaybe<CosmosSectionDownloadableParentCreateInput>;
  /** Delete currently connected CosmosSectionDownloadableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionDownloadableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDownloadableParent document */
  update?: InputMaybe<CosmosSectionDownloadableParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDownloadableParent document */
  upsert?: InputMaybe<CosmosSectionDownloadableParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadableParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadableParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadableParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionDownloadableParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionDownloadableUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  executables?: InputMaybe<CosmosElementDownloadCardUpdateManyInlineInput>;
  footer?: InputMaybe<CosmosElementDownloadCardUpdateOneInlineInput>;
  instructions?: InputMaybe<CosmosReferenceSectionUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionDownloadableUpdateLocalizationsInput>;
};

export type CosmosSectionDownloadableUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDownloadableUpdateLocalizationInput = {
  data: CosmosSectionDownloadableUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDownloadableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionDownloadableCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDownloadableUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionDownloadableUpsertLocalizationInput>>;
};

export type CosmosSectionDownloadableUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionDownloadable component instances */
  create?: InputMaybe<Array<CosmosSectionDownloadableCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionDownloadable documents */
  delete?: InputMaybe<Array<CosmosSectionDownloadableWhereUniqueInput>>;
  /** Update multiple CosmosSectionDownloadable component instances */
  update?: InputMaybe<Array<CosmosSectionDownloadableUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionDownloadable component instances */
  upsert?: InputMaybe<Array<CosmosSectionDownloadableUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionDownloadableUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionDownloadableUpdateManyLocalizationsInput>;
};

export type CosmosSectionDownloadableUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionDownloadableUpdateManyLocalizationInput = {
  data: CosmosSectionDownloadableUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionDownloadableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionDownloadableUpdateManyLocalizationInput>>;
};

export type CosmosSectionDownloadableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionDownloadableUpdateManyInput;
  /** Document search */
  where: CosmosSectionDownloadableWhereInput;
};

export type CosmosSectionDownloadableUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionDownloadable document */
  create?: InputMaybe<CosmosSectionDownloadableCreateInput>;
  /** Delete currently connected CosmosSectionDownloadable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionDownloadable document */
  update?: InputMaybe<CosmosSectionDownloadableUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionDownloadable document */
  upsert?: InputMaybe<CosmosSectionDownloadableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionDownloadableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionDownloadableUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDownloadableWhereUniqueInput;
};

export type CosmosSectionDownloadableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionDownloadableUpdateInput;
  /** Unique document search */
  where: CosmosSectionDownloadableWhereUniqueInput;
};

export type CosmosSectionDownloadableUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionDownloadableCreateInput;
  /** Update document if it exists */
  update: CosmosSectionDownloadableUpdateInput;
};

export type CosmosSectionDownloadableUpsertLocalizationInput = {
  create: CosmosSectionDownloadableCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionDownloadableUpdateLocalizationDataInput;
};

export type CosmosSectionDownloadableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionDownloadableUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionDownloadableWhereUniqueInput;
};

export type CosmosSectionDownloadableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionDownloadableUpsertInput;
  /** Unique document search */
  where: CosmosSectionDownloadableWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionDownloadableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionDownloadableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionDownloadableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionDownloadableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  executables_every?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  executables_none?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  executables_some?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  footer?: InputMaybe<CosmosElementDownloadCardWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<CosmosReferenceSectionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionDownloadable record uniquely */
export type CosmosSectionDownloadableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionEmbed = Entity & {
  __typename?: 'CosmosSectionEmbed';
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  embed?: Maybe<CosmosElementVideoEmbed>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionEmbed>;
  size?: Maybe<CosmosEnumSectionSizes>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionEmbedConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionEmbedEmbedArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionEmbedLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionEmbedUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionEmbedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionEmbedWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionEmbedConnection = {
  __typename?: 'CosmosSectionEmbedConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionEmbedEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionEmbedCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<CosmosElementVideoEmbedCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionEmbedCreateLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionEmbedCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionEmbedCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionEmbedCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionEmbedCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionEmbedCreateLocalizationInput>>;
};

export type CosmosSectionEmbedCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionEmbed documents */
  create?: InputMaybe<Array<CosmosSectionEmbedCreateInput>>;
};

export type CosmosSectionEmbedCreateOneInlineInput = {
  /** Create and connect one CosmosSectionEmbed document */
  create?: InputMaybe<CosmosSectionEmbedCreateInput>;
};

export type CosmosSectionEmbedCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionEmbedCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionEmbedEdge = {
  __typename?: 'CosmosSectionEmbedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionEmbed;
};

/** Identifies documents */
export type CosmosSectionEmbedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionEmbedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionEmbedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionEmbedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  embed?: InputMaybe<CosmosElementVideoEmbedWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionEmbedOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionEmbedParent = CosmosReferenceSection;

export type CosmosSectionEmbedParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionEmbedParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionEmbedParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionEmbedParent documents */
  connect?: InputMaybe<Array<CosmosSectionEmbedParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionEmbedParent documents */
  create?: InputMaybe<Array<CosmosSectionEmbedParentCreateInput>>;
};

export type CosmosSectionEmbedParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionEmbedParent document */
  connect?: InputMaybe<CosmosSectionEmbedParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionEmbedParent document */
  create?: InputMaybe<CosmosSectionEmbedParentCreateInput>;
};

export type CosmosSectionEmbedParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionEmbedParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionEmbedParent documents */
  connect?: InputMaybe<Array<CosmosSectionEmbedParentConnectInput>>;
  /** Create and connect multiple CosmosSectionEmbedParent documents */
  create?: InputMaybe<Array<CosmosSectionEmbedParentCreateInput>>;
  /** Delete multiple CosmosSectionEmbedParent documents */
  delete?: InputMaybe<Array<CosmosSectionEmbedParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionEmbedParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionEmbedParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionEmbedParent documents */
  set?: InputMaybe<Array<CosmosSectionEmbedParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionEmbedParent documents */
  update?: InputMaybe<Array<CosmosSectionEmbedParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionEmbedParent documents */
  upsert?: InputMaybe<Array<CosmosSectionEmbedParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionEmbedParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionEmbedParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionEmbedParent document */
  connect?: InputMaybe<CosmosSectionEmbedParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionEmbedParent document */
  create?: InputMaybe<CosmosSectionEmbedParentCreateInput>;
  /** Delete currently connected CosmosSectionEmbedParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionEmbedParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionEmbedParent document */
  update?: InputMaybe<CosmosSectionEmbedParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionEmbedParent document */
  upsert?: InputMaybe<CosmosSectionEmbedParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionEmbedParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionEmbedParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionEmbedParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionEmbedParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionEmbedUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<CosmosElementVideoEmbedUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionEmbedUpdateLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
};

export type CosmosSectionEmbedUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionEmbedUpdateLocalizationInput = {
  data: CosmosSectionEmbedUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionEmbedUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionEmbedCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionEmbedUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionEmbedUpsertLocalizationInput>>;
};

export type CosmosSectionEmbedUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionEmbed component instances */
  create?: InputMaybe<Array<CosmosSectionEmbedCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionEmbed documents */
  delete?: InputMaybe<Array<CosmosSectionEmbedWhereUniqueInput>>;
  /** Update multiple CosmosSectionEmbed component instances */
  update?: InputMaybe<Array<CosmosSectionEmbedUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionEmbed component instances */
  upsert?: InputMaybe<Array<CosmosSectionEmbedUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionEmbedUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionEmbedUpdateManyLocalizationsInput>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
};

export type CosmosSectionEmbedUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionEmbedUpdateManyLocalizationInput = {
  data: CosmosSectionEmbedUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionEmbedUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionEmbedUpdateManyLocalizationInput>>;
};

export type CosmosSectionEmbedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionEmbedUpdateManyInput;
  /** Document search */
  where: CosmosSectionEmbedWhereInput;
};

export type CosmosSectionEmbedUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionEmbed document */
  create?: InputMaybe<CosmosSectionEmbedCreateInput>;
  /** Delete currently connected CosmosSectionEmbed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionEmbed document */
  update?: InputMaybe<CosmosSectionEmbedUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionEmbed document */
  upsert?: InputMaybe<CosmosSectionEmbedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionEmbedUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionEmbedUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionEmbedWhereUniqueInput;
};

export type CosmosSectionEmbedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionEmbedUpdateInput;
  /** Unique document search */
  where: CosmosSectionEmbedWhereUniqueInput;
};

export type CosmosSectionEmbedUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionEmbedCreateInput;
  /** Update document if it exists */
  update: CosmosSectionEmbedUpdateInput;
};

export type CosmosSectionEmbedUpsertLocalizationInput = {
  create: CosmosSectionEmbedCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionEmbedUpdateLocalizationDataInput;
};

export type CosmosSectionEmbedUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionEmbedUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionEmbedWhereUniqueInput;
};

export type CosmosSectionEmbedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionEmbedUpsertInput;
  /** Unique document search */
  where: CosmosSectionEmbedWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionEmbedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionEmbedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionEmbedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionEmbedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<CosmosElementVideoEmbedWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<CosmosEnumSectionSizes>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSectionSizes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionEmbed record uniquely */
export type CosmosSectionEmbedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionEventsTable = Entity & {
  __typename?: 'CosmosSectionEventsTable';
  blurredImage?: Maybe<Asset>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  detailsColumnLabel?: Maybe<Scalars['String']['output']>;
  events: Array<CosmosElementEventsTableRow>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionEventsTable>;
  locationColumnLabel?: Maybe<Scalars['String']['output']>;
  pastTabLabel?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  titleColumnLabel?: Maybe<Scalars['String']['output']>;
  upcomingTabLabel?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionEventsTableBlurredImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionEventsTableConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionEventsTableEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementEventsTableRowOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
};


export type CosmosSectionEventsTableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionEventsTableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionEventsTableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionEventsTableWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionEventsTableConnection = {
  __typename?: 'CosmosSectionEventsTableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionEventsTableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionEventsTableCreateInput = {
  blurredImage?: InputMaybe<AssetCreateOneInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** detailsColumnLabel input for default locale (en) */
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<CosmosElementEventsTableRowCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionEventsTableCreateLocalizationsInput>;
  /** locationColumnLabel input for default locale (en) */
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** pastTabLabel input for default locale (en) */
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  /** titleColumnLabel input for default locale (en) */
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** upcomingTabLabel input for default locale (en) */
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionEventsTableCreateLocalizationDataInput = {
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionEventsTableCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionEventsTableCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionEventsTableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionEventsTableCreateLocalizationInput>>;
};

export type CosmosSectionEventsTableCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionEventsTable documents */
  create?: InputMaybe<Array<CosmosSectionEventsTableCreateInput>>;
};

export type CosmosSectionEventsTableCreateOneInlineInput = {
  /** Create and connect one CosmosSectionEventsTable document */
  create?: InputMaybe<CosmosSectionEventsTableCreateInput>;
};

export type CosmosSectionEventsTableCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionEventsTableCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionEventsTableEdge = {
  __typename?: 'CosmosSectionEventsTableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionEventsTable;
};

/** Identifies documents */
export type CosmosSectionEventsTableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionEventsTableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionEventsTableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionEventsTableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  events_every?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
  events_none?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
  events_some?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionEventsTableOrderByInput {
  DetailsColumnLabelAsc = 'detailsColumnLabel_ASC',
  DetailsColumnLabelDesc = 'detailsColumnLabel_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LocationColumnLabelAsc = 'locationColumnLabel_ASC',
  LocationColumnLabelDesc = 'locationColumnLabel_DESC',
  PastTabLabelAsc = 'pastTabLabel_ASC',
  PastTabLabelDesc = 'pastTabLabel_DESC',
  TitleColumnLabelAsc = 'titleColumnLabel_ASC',
  TitleColumnLabelDesc = 'titleColumnLabel_DESC',
  UpcomingTabLabelAsc = 'upcomingTabLabel_ASC',
  UpcomingTabLabelDesc = 'upcomingTabLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionEventsTableParent = CosmosReferenceSection;

export type CosmosSectionEventsTableParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionEventsTableParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionEventsTableParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionEventsTableParent documents */
  connect?: InputMaybe<Array<CosmosSectionEventsTableParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionEventsTableParent documents */
  create?: InputMaybe<Array<CosmosSectionEventsTableParentCreateInput>>;
};

export type CosmosSectionEventsTableParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionEventsTableParent document */
  connect?: InputMaybe<CosmosSectionEventsTableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionEventsTableParent document */
  create?: InputMaybe<CosmosSectionEventsTableParentCreateInput>;
};

export type CosmosSectionEventsTableParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionEventsTableParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionEventsTableParent documents */
  connect?: InputMaybe<Array<CosmosSectionEventsTableParentConnectInput>>;
  /** Create and connect multiple CosmosSectionEventsTableParent documents */
  create?: InputMaybe<Array<CosmosSectionEventsTableParentCreateInput>>;
  /** Delete multiple CosmosSectionEventsTableParent documents */
  delete?: InputMaybe<Array<CosmosSectionEventsTableParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionEventsTableParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionEventsTableParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionEventsTableParent documents */
  set?: InputMaybe<Array<CosmosSectionEventsTableParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionEventsTableParent documents */
  update?: InputMaybe<Array<CosmosSectionEventsTableParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionEventsTableParent documents */
  upsert?: InputMaybe<Array<CosmosSectionEventsTableParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionEventsTableParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionEventsTableParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionEventsTableParent document */
  connect?: InputMaybe<CosmosSectionEventsTableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionEventsTableParent document */
  create?: InputMaybe<CosmosSectionEventsTableParentCreateInput>;
  /** Delete currently connected CosmosSectionEventsTableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionEventsTableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionEventsTableParent document */
  update?: InputMaybe<CosmosSectionEventsTableParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionEventsTableParent document */
  upsert?: InputMaybe<CosmosSectionEventsTableParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionEventsTableParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionEventsTableParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionEventsTableParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionEventsTableParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionEventsTableUpdateInput = {
  blurredImage?: InputMaybe<AssetUpdateOneInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** detailsColumnLabel input for default locale (en) */
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<CosmosElementEventsTableRowUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionEventsTableUpdateLocalizationsInput>;
  /** locationColumnLabel input for default locale (en) */
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** pastTabLabel input for default locale (en) */
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  /** titleColumnLabel input for default locale (en) */
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** upcomingTabLabel input for default locale (en) */
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionEventsTableUpdateLocalizationDataInput = {
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionEventsTableUpdateLocalizationInput = {
  data: CosmosSectionEventsTableUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionEventsTableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionEventsTableCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionEventsTableUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionEventsTableUpsertLocalizationInput>>;
};

export type CosmosSectionEventsTableUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionEventsTable component instances */
  create?: InputMaybe<Array<CosmosSectionEventsTableCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionEventsTable documents */
  delete?: InputMaybe<Array<CosmosSectionEventsTableWhereUniqueInput>>;
  /** Update multiple CosmosSectionEventsTable component instances */
  update?: InputMaybe<Array<CosmosSectionEventsTableUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionEventsTable component instances */
  upsert?: InputMaybe<Array<CosmosSectionEventsTableUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionEventsTableUpdateManyInput = {
  /** detailsColumnLabel input for default locale (en) */
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionEventsTableUpdateManyLocalizationsInput>;
  /** locationColumnLabel input for default locale (en) */
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** pastTabLabel input for default locale (en) */
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  /** titleColumnLabel input for default locale (en) */
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** upcomingTabLabel input for default locale (en) */
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionEventsTableUpdateManyLocalizationDataInput = {
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionEventsTableUpdateManyLocalizationInput = {
  data: CosmosSectionEventsTableUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionEventsTableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionEventsTableUpdateManyLocalizationInput>>;
};

export type CosmosSectionEventsTableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionEventsTableUpdateManyInput;
  /** Document search */
  where: CosmosSectionEventsTableWhereInput;
};

export type CosmosSectionEventsTableUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionEventsTable document */
  create?: InputMaybe<CosmosSectionEventsTableCreateInput>;
  /** Delete currently connected CosmosSectionEventsTable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionEventsTable document */
  update?: InputMaybe<CosmosSectionEventsTableUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionEventsTable document */
  upsert?: InputMaybe<CosmosSectionEventsTableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionEventsTableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionEventsTableUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionEventsTableWhereUniqueInput;
};

export type CosmosSectionEventsTableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionEventsTableUpdateInput;
  /** Unique document search */
  where: CosmosSectionEventsTableWhereUniqueInput;
};

export type CosmosSectionEventsTableUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionEventsTableCreateInput;
  /** Update document if it exists */
  update: CosmosSectionEventsTableUpdateInput;
};

export type CosmosSectionEventsTableUpsertLocalizationInput = {
  create: CosmosSectionEventsTableCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionEventsTableUpdateLocalizationDataInput;
};

export type CosmosSectionEventsTableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionEventsTableUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionEventsTableWhereUniqueInput;
};

export type CosmosSectionEventsTableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionEventsTableUpsertInput;
  /** Unique document search */
  where: CosmosSectionEventsTableWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionEventsTableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionEventsTableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionEventsTableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionEventsTableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredImage?: InputMaybe<AssetWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  detailsColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  detailsColumnLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  detailsColumnLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  detailsColumnLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  detailsColumnLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  detailsColumnLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  detailsColumnLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  detailsColumnLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  detailsColumnLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  detailsColumnLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  events_every?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
  events_none?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
  events_some?: InputMaybe<CosmosElementEventsTableRowWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  locationColumnLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  locationColumnLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  locationColumnLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  locationColumnLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  locationColumnLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  locationColumnLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  locationColumnLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  locationColumnLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  locationColumnLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  pastTabLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pastTabLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pastTabLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pastTabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pastTabLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pastTabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pastTabLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pastTabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pastTabLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pastTabLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  titleColumnLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleColumnLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleColumnLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleColumnLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleColumnLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleColumnLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleColumnLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleColumnLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleColumnLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleColumnLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  upcomingTabLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  upcomingTabLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  upcomingTabLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  upcomingTabLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  upcomingTabLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  upcomingTabLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  upcomingTabLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  upcomingTabLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  upcomingTabLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  upcomingTabLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionEventsTable record uniquely */
export type CosmosSectionEventsTableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionFaq = Entity & {
  __typename?: 'CosmosSectionFaq';
  /** Config for the section */
  config?: Maybe<CosmosConfigSection>;
  faqButtons: Array<CosmosElementIconButton>;
  faqButtonsPosition?: Maybe<CosmosEnumFaqButtonsPosition>;
  firstItemDefaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Deprecated. For new FAQs, use [ref] FAQ Items. */
  items: Array<CosmosElementFaqItem>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionFaq>;
  modButtons: Array<CosmosSectionFaqmodButtonsUnion>;
  /** Use for new/migrated FAQs. Mixing "FAQ Items" and "Ref FAQ Items" is not recommended. */
  refFaqItems: Array<CosmosReferenceFaqItem>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionFaqConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionFaqFaqButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosSectionFaqItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementFaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementFaqItemWhereInput>;
};


export type CosmosSectionFaqLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionFaqModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosSectionFaqRefFaqItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosReferenceFaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
};


export type CosmosSectionFaqUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionFaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionFaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionFaqConnection = {
  __typename?: 'CosmosSectionFaqConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionFaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionFaqCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  faqButtons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<CosmosElementFaqItemCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionFaqCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosSectionFaqmodButtonsUnionCreateManyInlineInput>;
  refFaqItems?: InputMaybe<CosmosReferenceFaqItemCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionFaqCreateLocalizationDataInput = {
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionFaqCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionFaqCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFaqCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionFaqCreateLocalizationInput>>;
};

export type CosmosSectionFaqCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionFaq documents */
  create?: InputMaybe<Array<CosmosSectionFaqCreateInput>>;
};

export type CosmosSectionFaqCreateOneInlineInput = {
  /** Create and connect one CosmosSectionFaq document */
  create?: InputMaybe<CosmosSectionFaqCreateInput>;
};

export type CosmosSectionFaqCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionFaqCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionFaqEdge = {
  __typename?: 'CosmosSectionFaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionFaq;
};

/** Identifies documents */
export type CosmosSectionFaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionFaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionFaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionFaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are contained in given list. */
  faqButtonsPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  faqButtonsPosition_not?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are not contained in given list. */
  faqButtonsPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  faqButtons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  faqButtons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  faqButtons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  firstItemDefaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_none?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_some?: InputMaybe<CosmosElementFaqItemWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosSectionFaqmodButtonsUnionWhereInput>;
  refFaqItems_every?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_none?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_some?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionFaqOrderByInput {
  FaqButtonsPositionAsc = 'faqButtonsPosition_ASC',
  FaqButtonsPositionDesc = 'faqButtonsPosition_DESC',
  FirstItemDefaultOpenAsc = 'firstItemDefaultOpen_ASC',
  FirstItemDefaultOpenDesc = 'firstItemDefaultOpen_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionFaqParent = CosmosReferenceSection;

export type CosmosSectionFaqParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionFaqParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionFaqParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionFaqParent documents */
  connect?: InputMaybe<Array<CosmosSectionFaqParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionFaqParent documents */
  create?: InputMaybe<Array<CosmosSectionFaqParentCreateInput>>;
};

export type CosmosSectionFaqParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionFaqParent document */
  connect?: InputMaybe<CosmosSectionFaqParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionFaqParent document */
  create?: InputMaybe<CosmosSectionFaqParentCreateInput>;
};

export type CosmosSectionFaqParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionFaqParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionFaqParent documents */
  connect?: InputMaybe<Array<CosmosSectionFaqParentConnectInput>>;
  /** Create and connect multiple CosmosSectionFaqParent documents */
  create?: InputMaybe<Array<CosmosSectionFaqParentCreateInput>>;
  /** Delete multiple CosmosSectionFaqParent documents */
  delete?: InputMaybe<Array<CosmosSectionFaqParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionFaqParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionFaqParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionFaqParent documents */
  set?: InputMaybe<Array<CosmosSectionFaqParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionFaqParent documents */
  update?: InputMaybe<Array<CosmosSectionFaqParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionFaqParent documents */
  upsert?: InputMaybe<Array<CosmosSectionFaqParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionFaqParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionFaqParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionFaqParent document */
  connect?: InputMaybe<CosmosSectionFaqParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionFaqParent document */
  create?: InputMaybe<CosmosSectionFaqParentCreateInput>;
  /** Delete currently connected CosmosSectionFaqParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionFaqParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFaqParent document */
  update?: InputMaybe<CosmosSectionFaqParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFaqParent document */
  upsert?: InputMaybe<CosmosSectionFaqParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionFaqParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionFaqSearch = Entity & {
  __typename?: 'CosmosSectionFaqSearch';
  config?: Maybe<CosmosConfigSection>;
  desc?: Maybe<Scalars['String']['output']>;
  faqButtonsPosition?: Maybe<CosmosEnumFaqButtonsPosition>;
  faqTabs: Array<CosmosElementFaqTab>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionFaqSearch>;
  modButtons: Array<CosmosSectionFaqSearchmodButtonsUnion>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionFaqSearchConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionFaqSearchFaqTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementFaqTabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementFaqTabWhereInput>;
};


export type CosmosSectionFaqSearchLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionFaqSearchModButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosSectionFaqSearchUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionFaqSearchConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionFaqSearchWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionFaqSearchConnection = {
  __typename?: 'CosmosSectionFaqSearchConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionFaqSearchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionFaqSearchCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  faqTabs?: InputMaybe<CosmosElementFaqTabCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionFaqSearchCreateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionCreateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionFaqSearchCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionFaqSearchCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionFaqSearchCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFaqSearchCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionFaqSearchCreateLocalizationInput>>;
};

export type CosmosSectionFaqSearchCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionFaqSearch documents */
  create?: InputMaybe<Array<CosmosSectionFaqSearchCreateInput>>;
};

export type CosmosSectionFaqSearchCreateOneInlineInput = {
  /** Create and connect one CosmosSectionFaqSearch document */
  create?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
};

export type CosmosSectionFaqSearchCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionFaqSearchCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionFaqSearchEdge = {
  __typename?: 'CosmosSectionFaqSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionFaqSearch;
};

/** Identifies documents */
export type CosmosSectionFaqSearchManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionFaqSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionFaqSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionFaqSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are contained in given list. */
  faqButtonsPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  faqButtonsPosition_not?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are not contained in given list. */
  faqButtonsPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  faqTabs_every?: InputMaybe<CosmosElementFaqTabWhereInput>;
  faqTabs_none?: InputMaybe<CosmosElementFaqTabWhereInput>;
  faqTabs_some?: InputMaybe<CosmosElementFaqTabWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionFaqSearchOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  FaqButtonsPositionAsc = 'faqButtonsPosition_ASC',
  FaqButtonsPositionDesc = 'faqButtonsPosition_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionFaqSearchParent = CosmosReferenceSection;

export type CosmosSectionFaqSearchParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionFaqSearchParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionFaqSearchParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionFaqSearchParent documents */
  connect?: InputMaybe<Array<CosmosSectionFaqSearchParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionFaqSearchParent documents */
  create?: InputMaybe<Array<CosmosSectionFaqSearchParentCreateInput>>;
};

export type CosmosSectionFaqSearchParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionFaqSearchParent document */
  connect?: InputMaybe<CosmosSectionFaqSearchParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionFaqSearchParent document */
  create?: InputMaybe<CosmosSectionFaqSearchParentCreateInput>;
};

export type CosmosSectionFaqSearchParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionFaqSearchParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionFaqSearchParent documents */
  connect?: InputMaybe<Array<CosmosSectionFaqSearchParentConnectInput>>;
  /** Create and connect multiple CosmosSectionFaqSearchParent documents */
  create?: InputMaybe<Array<CosmosSectionFaqSearchParentCreateInput>>;
  /** Delete multiple CosmosSectionFaqSearchParent documents */
  delete?: InputMaybe<Array<CosmosSectionFaqSearchParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionFaqSearchParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionFaqSearchParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionFaqSearchParent documents */
  set?: InputMaybe<Array<CosmosSectionFaqSearchParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionFaqSearchParent documents */
  update?: InputMaybe<Array<CosmosSectionFaqSearchParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionFaqSearchParent documents */
  upsert?: InputMaybe<Array<CosmosSectionFaqSearchParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionFaqSearchParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionFaqSearchParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionFaqSearchParent document */
  connect?: InputMaybe<CosmosSectionFaqSearchParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionFaqSearchParent document */
  create?: InputMaybe<CosmosSectionFaqSearchParentCreateInput>;
  /** Delete currently connected CosmosSectionFaqSearchParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionFaqSearchParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFaqSearchParent document */
  update?: InputMaybe<CosmosSectionFaqSearchParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFaqSearchParent document */
  upsert?: InputMaybe<CosmosSectionFaqSearchParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionFaqSearchParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionFaqSearchUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  faqTabs?: InputMaybe<CosmosElementFaqTabUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionFaqSearchUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqSearchUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqSearchUpdateLocalizationInput = {
  data: CosmosSectionFaqSearchUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFaqSearchUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionFaqSearchCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionFaqSearchUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionFaqSearchUpsertLocalizationInput>>;
};

export type CosmosSectionFaqSearchUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionFaqSearch component instances */
  create?: InputMaybe<Array<CosmosSectionFaqSearchCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionFaqSearch documents */
  delete?: InputMaybe<Array<CosmosSectionFaqSearchWhereUniqueInput>>;
  /** Update multiple CosmosSectionFaqSearch component instances */
  update?: InputMaybe<Array<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionFaqSearch component instances */
  upsert?: InputMaybe<Array<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionFaqSearchUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionFaqSearchUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqSearchUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqSearchUpdateManyLocalizationInput = {
  data: CosmosSectionFaqSearchUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFaqSearchUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionFaqSearchUpdateManyLocalizationInput>>;
};

export type CosmosSectionFaqSearchUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionFaqSearchUpdateManyInput;
  /** Document search */
  where: CosmosSectionFaqSearchWhereInput;
};

export type CosmosSectionFaqSearchUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionFaqSearch document */
  create?: InputMaybe<CosmosSectionFaqSearchCreateInput>;
  /** Delete currently connected CosmosSectionFaqSearch document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFaqSearch document */
  update?: InputMaybe<CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFaqSearch document */
  upsert?: InputMaybe<CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionFaqSearchUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionFaqSearchWhereUniqueInput;
};

export type CosmosSectionFaqSearchUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionFaqSearchUpdateInput;
  /** Unique document search */
  where: CosmosSectionFaqSearchWhereUniqueInput;
};

export type CosmosSectionFaqSearchUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionFaqSearchCreateInput;
  /** Update document if it exists */
  update: CosmosSectionFaqSearchUpdateInput;
};

export type CosmosSectionFaqSearchUpsertLocalizationInput = {
  create: CosmosSectionFaqSearchCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionFaqSearchUpdateLocalizationDataInput;
};

export type CosmosSectionFaqSearchUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionFaqSearchUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionFaqSearchWhereUniqueInput;
};

export type CosmosSectionFaqSearchUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionFaqSearchUpsertInput;
  /** Unique document search */
  where: CosmosSectionFaqSearchWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionFaqSearchWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionFaqSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionFaqSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionFaqSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are contained in given list. */
  faqButtonsPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  faqButtonsPosition_not?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are not contained in given list. */
  faqButtonsPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  faqTabs_every?: InputMaybe<CosmosElementFaqTabWhereInput>;
  faqTabs_none?: InputMaybe<CosmosElementFaqTabWhereInput>;
  faqTabs_some?: InputMaybe<CosmosElementFaqTabWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionFaqSearch record uniquely */
export type CosmosSectionFaqSearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionFaqSearchmodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosSectionFaqSearchmodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionFaqSearchmodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosSectionFaqSearchmodButtonsUnionCreateInput>>;
};

export type CosmosSectionFaqSearchmodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosSectionFaqSearchmodButtonsUnion document */
  create?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionCreateInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionFaqSearchmodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosSectionFaqSearchmodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionFaqSearchmodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosSectionFaqSearchmodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosSectionFaqSearchmodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosSectionFaqSearchmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionFaqSearchmodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosSectionFaqSearchmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionFaqSearchmodButtonsUnion document */
  create?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosSectionFaqSearchmodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFaqSearchmodButtonsUnion document */
  update?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFaqSearchmodButtonsUnion document */
  upsert?: InputMaybe<CosmosSectionFaqSearchmodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosSectionFaqSearchmodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosSectionFaqUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  faqButtons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<CosmosElementFaqItemUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionFaqUpdateLocalizationsInput>;
  modButtons?: InputMaybe<CosmosSectionFaqmodButtonsUnionUpdateManyInlineInput>;
  refFaqItems?: InputMaybe<CosmosReferenceFaqItemUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqUpdateLocalizationInput = {
  data: CosmosSectionFaqUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFaqUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionFaqCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionFaqUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionFaqUpsertLocalizationInput>>;
};

export type CosmosSectionFaqUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionFaq component instances */
  create?: InputMaybe<Array<CosmosSectionFaqCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionFaq documents */
  delete?: InputMaybe<Array<CosmosSectionFaqWhereUniqueInput>>;
  /** Update multiple CosmosSectionFaq component instances */
  update?: InputMaybe<Array<CosmosSectionFaqUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionFaq component instances */
  upsert?: InputMaybe<Array<CosmosSectionFaqUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionFaqUpdateManyInput = {
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionFaqUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionFaqUpdateManyLocalizationInput = {
  data: CosmosSectionFaqUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFaqUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionFaqUpdateManyLocalizationInput>>;
};

export type CosmosSectionFaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionFaqUpdateManyInput;
  /** Document search */
  where: CosmosSectionFaqWhereInput;
};

export type CosmosSectionFaqUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionFaq document */
  create?: InputMaybe<CosmosSectionFaqCreateInput>;
  /** Delete currently connected CosmosSectionFaq document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFaq document */
  update?: InputMaybe<CosmosSectionFaqUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFaq document */
  upsert?: InputMaybe<CosmosSectionFaqUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionFaqUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionFaqWhereUniqueInput;
};

export type CosmosSectionFaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionFaqUpdateInput;
  /** Unique document search */
  where: CosmosSectionFaqWhereUniqueInput;
};

export type CosmosSectionFaqUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionFaqCreateInput;
  /** Update document if it exists */
  update: CosmosSectionFaqUpdateInput;
};

export type CosmosSectionFaqUpsertLocalizationInput = {
  create: CosmosSectionFaqCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionFaqUpdateLocalizationDataInput;
};

export type CosmosSectionFaqUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionFaqUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionFaqWhereUniqueInput;
};

export type CosmosSectionFaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionFaqUpsertInput;
  /** Unique document search */
  where: CosmosSectionFaqWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionFaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionFaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionFaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionFaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  faqButtonsPosition?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are contained in given list. */
  faqButtonsPosition_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  faqButtonsPosition_not?: InputMaybe<CosmosEnumFaqButtonsPosition>;
  /** All values that are not contained in given list. */
  faqButtonsPosition_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumFaqButtonsPosition>>>;
  faqButtons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  faqButtons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  faqButtons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  firstItemDefaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  firstItemDefaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_none?: InputMaybe<CosmosElementFaqItemWhereInput>;
  items_some?: InputMaybe<CosmosElementFaqItemWhereInput>;
  /** All values in which the union is empty. */
  modButtons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  modButtons_some?: InputMaybe<CosmosSectionFaqmodButtonsUnionWhereInput>;
  refFaqItems_every?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_none?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  refFaqItems_some?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionFaq record uniquely */
export type CosmosSectionFaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionFaqmodButtonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosSectionFaqmodButtonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosSectionFaqmodButtonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosSectionFaqmodButtonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionFaqmodButtonsUnion documents */
  create?: InputMaybe<Array<CosmosSectionFaqmodButtonsUnionCreateInput>>;
};

export type CosmosSectionFaqmodButtonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosSectionFaqmodButtonsUnion document */
  create?: InputMaybe<CosmosSectionFaqmodButtonsUnionCreateInput>;
};

export type CosmosSectionFaqmodButtonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionFaqmodButtonsUnion component instances */
  create?: InputMaybe<Array<CosmosSectionFaqmodButtonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionFaqmodButtonsUnion documents */
  delete?: InputMaybe<Array<CosmosSectionFaqmodButtonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosSectionFaqmodButtonsUnion component instances */
  update?: InputMaybe<Array<CosmosSectionFaqmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionFaqmodButtonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosSectionFaqmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionFaqmodButtonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionFaqmodButtonsUnion document */
  create?: InputMaybe<CosmosSectionFaqmodButtonsUnionCreateInput>;
  /** Delete currently connected CosmosSectionFaqmodButtonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFaqmodButtonsUnion document */
  update?: InputMaybe<CosmosSectionFaqmodButtonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFaqmodButtonsUnion document */
  upsert?: InputMaybe<CosmosSectionFaqmodButtonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosSectionFaqmodButtonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFaqmodButtonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosSectionFaqmodButtonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosSectionFeatureCard = Entity & {
  __typename?: 'CosmosSectionFeatureCard';
  cards: Array<CosmosElementFeatureCard>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionFeatureCard>;
  /** System stage field */
  stage: Stage;
  /** Label for the tags */
  tagListTitle?: Maybe<Scalars['String']['output']>;
  tags: Array<CosmosElementTag>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionFeatureCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementFeatureCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementFeatureCardWhereInput>;
};


export type CosmosSectionFeatureCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionFeatureCardTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTagWhereInput>;
};


export type CosmosSectionFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionFeatureCardConnection = {
  __typename?: 'CosmosSectionFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionFeatureCardCreateInput = {
  cards?: InputMaybe<CosmosElementFeatureCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionFeatureCardCreateLocalizationsInput>;
  /** tagListTitle input for default locale (en) */
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<CosmosElementTagCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionFeatureCardCreateLocalizationDataInput = {
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionFeatureCardCreateLocalizationInput>>;
};

export type CosmosSectionFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionFeatureCard documents */
  create?: InputMaybe<Array<CosmosSectionFeatureCardCreateInput>>;
};

export type CosmosSectionFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionFeatureCard document */
  create?: InputMaybe<CosmosSectionFeatureCardCreateInput>;
};

export type CosmosSectionFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionFeatureCardEdge = {
  __typename?: 'CosmosSectionFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionFeatureCard;
};

/** Identifies documents */
export type CosmosSectionFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementFeatureCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementFeatureCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementFeatureCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tags_every?: InputMaybe<CosmosElementTagWhereInput>;
  tags_none?: InputMaybe<CosmosElementTagWhereInput>;
  tags_some?: InputMaybe<CosmosElementTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionFeatureCardOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TagListTitleAsc = 'tagListTitle_ASC',
  TagListTitleDesc = 'tagListTitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionFeatureCardParent = CosmosReferenceSection;

export type CosmosSectionFeatureCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionFeatureCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionFeatureCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionFeatureCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionFeatureCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosSectionFeatureCardParentCreateInput>>;
};

export type CosmosSectionFeatureCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionFeatureCardParent document */
  connect?: InputMaybe<CosmosSectionFeatureCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionFeatureCardParent document */
  create?: InputMaybe<CosmosSectionFeatureCardParentCreateInput>;
};

export type CosmosSectionFeatureCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionFeatureCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionFeatureCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionFeatureCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosSectionFeatureCardParentCreateInput>>;
  /** Delete multiple CosmosSectionFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionFeatureCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionFeatureCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionFeatureCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionFeatureCardParent documents */
  set?: InputMaybe<Array<CosmosSectionFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionFeatureCardParent documents */
  update?: InputMaybe<Array<CosmosSectionFeatureCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionFeatureCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionFeatureCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionFeatureCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionFeatureCardParent document */
  connect?: InputMaybe<CosmosSectionFeatureCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionFeatureCardParent document */
  create?: InputMaybe<CosmosSectionFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosSectionFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionFeatureCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFeatureCardParent document */
  update?: InputMaybe<CosmosSectionFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFeatureCardParent document */
  upsert?: InputMaybe<CosmosSectionFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFeatureCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionFeatureCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionFeatureCardUpdateInput = {
  cards?: InputMaybe<CosmosElementFeatureCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionFeatureCardUpdateLocalizationsInput>;
  /** tagListTitle input for default locale (en) */
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<CosmosElementTagUpdateManyInlineInput>;
};

export type CosmosSectionFeatureCardUpdateLocalizationDataInput = {
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionFeatureCardUpdateLocalizationInput = {
  data: CosmosSectionFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionFeatureCardUpsertLocalizationInput>>;
};

export type CosmosSectionFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionFeatureCard component instances */
  create?: InputMaybe<Array<CosmosSectionFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionFeatureCard documents */
  delete?: InputMaybe<Array<CosmosSectionFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionFeatureCard component instances */
  update?: InputMaybe<Array<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionFeatureCardUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionFeatureCardUpdateManyLocalizationsInput>;
  /** tagListTitle input for default locale (en) */
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionFeatureCardUpdateManyLocalizationDataInput = {
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionFeatureCardUpdateManyLocalizationInput = {
  data: CosmosSectionFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionFeatureCardWhereInput;
};

export type CosmosSectionFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionFeatureCard document */
  create?: InputMaybe<CosmosSectionFeatureCardCreateInput>;
  /** Delete currently connected CosmosSectionFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionFeatureCard document */
  update?: InputMaybe<CosmosSectionFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionFeatureCard document */
  upsert?: InputMaybe<CosmosSectionFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionFeatureCardWhereUniqueInput;
};

export type CosmosSectionFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionFeatureCardWhereUniqueInput;
};

export type CosmosSectionFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionFeatureCardUpdateInput;
};

export type CosmosSectionFeatureCardUpsertLocalizationInput = {
  create: CosmosSectionFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionFeatureCardUpdateLocalizationDataInput;
};

export type CosmosSectionFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionFeatureCardWhereUniqueInput;
};

export type CosmosSectionFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementFeatureCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementFeatureCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementFeatureCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tagListTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tagListTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tagListTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tagListTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tagListTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tagListTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tagListTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tagListTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tagListTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tagListTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  tags_every?: InputMaybe<CosmosElementTagWhereInput>;
  tags_none?: InputMaybe<CosmosElementTagWhereInput>;
  tags_some?: InputMaybe<CosmosElementTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionFeatureCard record uniquely */
export type CosmosSectionFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionGameDevFeatureCard = Entity & {
  __typename?: 'CosmosSectionGameDevFeatureCard';
  /** Buttons displayed below the list of cards */
  buttons: Array<CosmosElementButton>;
  cards: Array<CosmosElementGameDevFeatureCard>;
  config?: Maybe<CosmosConfigSection>;
  /** Removes card backgrounds and also makes the images slightly larger per card  */
  disableCardBg?: Maybe<Scalars['Boolean']['output']>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionGameDevFeatureCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Vertically center title / description within card */
  verticallyCenter?: Maybe<Scalars['Boolean']['output']>;
};


export type CosmosSectionGameDevFeatureCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosSectionGameDevFeatureCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementGameDevFeatureCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
};


export type CosmosSectionGameDevFeatureCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionGameDevFeatureCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionGameDevFeatureCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionGameDevFeatureCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionGameDevFeatureCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionGameDevFeatureCardConnection = {
  __typename?: 'CosmosSectionGameDevFeatureCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionGameDevFeatureCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionGameDevFeatureCardCreateInput = {
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  cards?: InputMaybe<CosmosElementGameDevFeatureCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  disableCardBg?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionGameDevFeatureCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionGameDevFeatureCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionGameDevFeatureCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionGameDevFeatureCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionGameDevFeatureCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionGameDevFeatureCardCreateLocalizationInput>>;
};

export type CosmosSectionGameDevFeatureCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionGameDevFeatureCard documents */
  create?: InputMaybe<Array<CosmosSectionGameDevFeatureCardCreateInput>>;
};

export type CosmosSectionGameDevFeatureCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionGameDevFeatureCard document */
  create?: InputMaybe<CosmosSectionGameDevFeatureCardCreateInput>;
};

export type CosmosSectionGameDevFeatureCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionGameDevFeatureCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionGameDevFeatureCardEdge = {
  __typename?: 'CosmosSectionGameDevFeatureCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionGameDevFeatureCard;
};

/** Identifies documents */
export type CosmosSectionGameDevFeatureCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  cards_every?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  disableCardBg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableCardBg_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CosmosSectionGameDevFeatureCardOrderByInput {
  DisableCardBgAsc = 'disableCardBg_ASC',
  DisableCardBgDesc = 'disableCardBg_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VerticallyCenterAsc = 'verticallyCenter_ASC',
  VerticallyCenterDesc = 'verticallyCenter_DESC'
}

export type CosmosSectionGameDevFeatureCardParent = CosmosReferenceSection;

export type CosmosSectionGameDevFeatureCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionGameDevFeatureCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionGameDevFeatureCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionGameDevFeatureCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionGameDevFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentCreateInput>>;
};

export type CosmosSectionGameDevFeatureCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionGameDevFeatureCardParent document */
  connect?: InputMaybe<CosmosSectionGameDevFeatureCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionGameDevFeatureCardParent document */
  create?: InputMaybe<CosmosSectionGameDevFeatureCardParentCreateInput>;
};

export type CosmosSectionGameDevFeatureCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionGameDevFeatureCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionGameDevFeatureCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionGameDevFeatureCardParent documents */
  create?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentCreateInput>>;
  /** Delete multiple CosmosSectionGameDevFeatureCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionGameDevFeatureCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionGameDevFeatureCardParent documents */
  set?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionGameDevFeatureCardParent documents */
  update?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionGameDevFeatureCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionGameDevFeatureCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionGameDevFeatureCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionGameDevFeatureCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionGameDevFeatureCardParent document */
  connect?: InputMaybe<CosmosSectionGameDevFeatureCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionGameDevFeatureCardParent document */
  create?: InputMaybe<CosmosSectionGameDevFeatureCardParentCreateInput>;
  /** Delete currently connected CosmosSectionGameDevFeatureCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionGameDevFeatureCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionGameDevFeatureCardParent document */
  update?: InputMaybe<CosmosSectionGameDevFeatureCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionGameDevFeatureCardParent document */
  upsert?: InputMaybe<CosmosSectionGameDevFeatureCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionGameDevFeatureCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionGameDevFeatureCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionGameDevFeatureCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionGameDevFeatureCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionGameDevFeatureCardUpdateInput = {
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  cards?: InputMaybe<CosmosElementGameDevFeatureCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  disableCardBg?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateLocalizationsInput>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionGameDevFeatureCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionGameDevFeatureCardUpdateLocalizationInput = {
  data: CosmosSectionGameDevFeatureCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionGameDevFeatureCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionGameDevFeatureCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionGameDevFeatureCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionGameDevFeatureCardUpsertLocalizationInput>>;
};

export type CosmosSectionGameDevFeatureCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionGameDevFeatureCard component instances */
  create?: InputMaybe<Array<CosmosSectionGameDevFeatureCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionGameDevFeatureCard documents */
  delete?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionGameDevFeatureCard component instances */
  update?: InputMaybe<Array<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionGameDevFeatureCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionGameDevFeatureCardUpdateManyInput = {
  disableCardBg?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateManyLocalizationsInput>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionGameDevFeatureCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionGameDevFeatureCardUpdateManyLocalizationInput = {
  data: CosmosSectionGameDevFeatureCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionGameDevFeatureCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionGameDevFeatureCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionGameDevFeatureCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionGameDevFeatureCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionGameDevFeatureCardWhereInput;
};

export type CosmosSectionGameDevFeatureCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionGameDevFeatureCard document */
  create?: InputMaybe<CosmosSectionGameDevFeatureCardCreateInput>;
  /** Delete currently connected CosmosSectionGameDevFeatureCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionGameDevFeatureCard document */
  update?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionGameDevFeatureCard document */
  upsert?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionGameDevFeatureCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionGameDevFeatureCardWhereUniqueInput;
};

export type CosmosSectionGameDevFeatureCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionGameDevFeatureCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionGameDevFeatureCardWhereUniqueInput;
};

export type CosmosSectionGameDevFeatureCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionGameDevFeatureCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionGameDevFeatureCardUpdateInput;
};

export type CosmosSectionGameDevFeatureCardUpsertLocalizationInput = {
  create: CosmosSectionGameDevFeatureCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionGameDevFeatureCardUpdateLocalizationDataInput;
};

export type CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionGameDevFeatureCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionGameDevFeatureCardWhereUniqueInput;
};

export type CosmosSectionGameDevFeatureCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionGameDevFeatureCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionGameDevFeatureCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionGameDevFeatureCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionGameDevFeatureCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  cards_every?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementGameDevFeatureCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  disableCardBg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableCardBg_not?: InputMaybe<Scalars['Boolean']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References CosmosSectionGameDevFeatureCard record uniquely */
export type CosmosSectionGameDevFeatureCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionGeminiCard = Entity & {
  __typename?: 'CosmosSectionGeminiCard';
  cards: Array<CosmosElementGeminiCard>;
  /** UI will chose `two_up` (for <=2 cards) and `three_up` (for >=3 cards), but you can force specific Cards Variant for the grid. */
  cardsVariant?: Maybe<CosmosEnumGeminiVariants>;
  config?: Maybe<CosmosConfigSection>;
  desc?: Maybe<Scalars['String']['output']>;
  /** Optional gradient to use in the title <a> tags */
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionGeminiCard>;
  logoImage?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionGeminiCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementGeminiCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementGeminiCardWhereInput>;
};


export type CosmosSectionGeminiCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionGeminiCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionGeminiCardLogoImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionGeminiCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionGeminiCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionGeminiCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionGeminiCardConnection = {
  __typename?: 'CosmosSectionGeminiCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionGeminiCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionGeminiCardCreateInput = {
  cards?: InputMaybe<CosmosElementGeminiCardCreateManyInlineInput>;
  cardsVariant?: InputMaybe<CosmosEnumGeminiVariants>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionGeminiCardCreateLocalizationsInput>;
  logoImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionGeminiCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionGeminiCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionGeminiCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionGeminiCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionGeminiCardCreateLocalizationInput>>;
};

export type CosmosSectionGeminiCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionGeminiCard documents */
  create?: InputMaybe<Array<CosmosSectionGeminiCardCreateInput>>;
};

export type CosmosSectionGeminiCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionGeminiCard document */
  create?: InputMaybe<CosmosSectionGeminiCardCreateInput>;
};

export type CosmosSectionGeminiCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionGeminiCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionGeminiCardEdge = {
  __typename?: 'CosmosSectionGeminiCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionGeminiCard;
};

/** Identifies documents */
export type CosmosSectionGeminiCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionGeminiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionGeminiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionGeminiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardsVariant?: InputMaybe<CosmosEnumGeminiVariants>;
  /** All values that are contained in given list. */
  cardsVariant_in?: InputMaybe<Array<InputMaybe<CosmosEnumGeminiVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardsVariant_not?: InputMaybe<CosmosEnumGeminiVariants>;
  /** All values that are not contained in given list. */
  cardsVariant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumGeminiVariants>>>;
  cards_every?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionGeminiCardOrderByInput {
  CardsVariantAsc = 'cardsVariant_ASC',
  CardsVariantDesc = 'cardsVariant_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionGeminiCardParent = CosmosReferenceSection;

export type CosmosSectionGeminiCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionGeminiCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionGeminiCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionGeminiCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionGeminiCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionGeminiCardParent documents */
  create?: InputMaybe<Array<CosmosSectionGeminiCardParentCreateInput>>;
};

export type CosmosSectionGeminiCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionGeminiCardParent document */
  connect?: InputMaybe<CosmosSectionGeminiCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionGeminiCardParent document */
  create?: InputMaybe<CosmosSectionGeminiCardParentCreateInput>;
};

export type CosmosSectionGeminiCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionGeminiCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionGeminiCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionGeminiCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionGeminiCardParent documents */
  create?: InputMaybe<Array<CosmosSectionGeminiCardParentCreateInput>>;
  /** Delete multiple CosmosSectionGeminiCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionGeminiCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionGeminiCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionGeminiCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionGeminiCardParent documents */
  set?: InputMaybe<Array<CosmosSectionGeminiCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionGeminiCardParent documents */
  update?: InputMaybe<Array<CosmosSectionGeminiCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionGeminiCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionGeminiCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionGeminiCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionGeminiCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionGeminiCardParent document */
  connect?: InputMaybe<CosmosSectionGeminiCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionGeminiCardParent document */
  create?: InputMaybe<CosmosSectionGeminiCardParentCreateInput>;
  /** Delete currently connected CosmosSectionGeminiCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionGeminiCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionGeminiCardParent document */
  update?: InputMaybe<CosmosSectionGeminiCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionGeminiCardParent document */
  upsert?: InputMaybe<CosmosSectionGeminiCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionGeminiCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionGeminiCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionGeminiCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionGeminiCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionGeminiCardUpdateInput = {
  cards?: InputMaybe<CosmosElementGeminiCardUpdateManyInlineInput>;
  cardsVariant?: InputMaybe<CosmosEnumGeminiVariants>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionGeminiCardUpdateLocalizationsInput>;
  logoImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionGeminiCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionGeminiCardUpdateLocalizationInput = {
  data: CosmosSectionGeminiCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionGeminiCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionGeminiCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionGeminiCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionGeminiCardUpsertLocalizationInput>>;
};

export type CosmosSectionGeminiCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionGeminiCard component instances */
  create?: InputMaybe<Array<CosmosSectionGeminiCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionGeminiCard documents */
  delete?: InputMaybe<Array<CosmosSectionGeminiCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionGeminiCard component instances */
  update?: InputMaybe<Array<CosmosSectionGeminiCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionGeminiCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionGeminiCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionGeminiCardUpdateManyInput = {
  cardsVariant?: InputMaybe<CosmosEnumGeminiVariants>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionGeminiCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionGeminiCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionGeminiCardUpdateManyLocalizationInput = {
  data: CosmosSectionGeminiCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionGeminiCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionGeminiCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionGeminiCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionGeminiCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionGeminiCardWhereInput;
};

export type CosmosSectionGeminiCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionGeminiCard document */
  create?: InputMaybe<CosmosSectionGeminiCardCreateInput>;
  /** Delete currently connected CosmosSectionGeminiCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionGeminiCard document */
  update?: InputMaybe<CosmosSectionGeminiCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionGeminiCard document */
  upsert?: InputMaybe<CosmosSectionGeminiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionGeminiCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionGeminiCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionGeminiCardWhereUniqueInput;
};

export type CosmosSectionGeminiCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionGeminiCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionGeminiCardWhereUniqueInput;
};

export type CosmosSectionGeminiCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionGeminiCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionGeminiCardUpdateInput;
};

export type CosmosSectionGeminiCardUpsertLocalizationInput = {
  create: CosmosSectionGeminiCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionGeminiCardUpdateLocalizationDataInput;
};

export type CosmosSectionGeminiCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionGeminiCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionGeminiCardWhereUniqueInput;
};

export type CosmosSectionGeminiCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionGeminiCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionGeminiCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionGeminiCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionGeminiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionGeminiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionGeminiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardsVariant?: InputMaybe<CosmosEnumGeminiVariants>;
  /** All values that are contained in given list. */
  cardsVariant_in?: InputMaybe<Array<InputMaybe<CosmosEnumGeminiVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardsVariant_not?: InputMaybe<CosmosEnumGeminiVariants>;
  /** All values that are not contained in given list. */
  cardsVariant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumGeminiVariants>>>;
  cards_every?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementGeminiCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logoImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionGeminiCard record uniquely */
export type CosmosSectionGeminiCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionHydrusColumnList = Entity & {
  __typename?: 'CosmosSectionHydrusColumnList';
  /** A maximum of 4 columns of links will be rendered */
  columns: Array<CosmosElementHydrusColumn>;
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionHydrusColumnList>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionHydrusColumnListColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementHydrusColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
};


export type CosmosSectionHydrusColumnListConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionHydrusColumnListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionHydrusColumnListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionHydrusColumnListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionHydrusColumnListWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionHydrusColumnListConnection = {
  __typename?: 'CosmosSectionHydrusColumnListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionHydrusColumnListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionHydrusColumnListCreateInput = {
  columns?: InputMaybe<CosmosElementHydrusColumnCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionHydrusColumnListCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionHydrusColumnListCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionHydrusColumnListCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionHydrusColumnListCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionHydrusColumnListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionHydrusColumnListCreateLocalizationInput>>;
};

export type CosmosSectionHydrusColumnListCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionHydrusColumnList documents */
  create?: InputMaybe<Array<CosmosSectionHydrusColumnListCreateInput>>;
};

export type CosmosSectionHydrusColumnListCreateOneInlineInput = {
  /** Create and connect one CosmosSectionHydrusColumnList document */
  create?: InputMaybe<CosmosSectionHydrusColumnListCreateInput>;
};

export type CosmosSectionHydrusColumnListCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionHydrusColumnListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionHydrusColumnListEdge = {
  __typename?: 'CosmosSectionHydrusColumnListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionHydrusColumnList;
};

/** Identifies documents */
export type CosmosSectionHydrusColumnListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  columns_every?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
  columns_none?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
  columns_some?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionHydrusColumnListOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionHydrusColumnListParent = CosmosReferenceSection;

export type CosmosSectionHydrusColumnListParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionHydrusColumnListParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionHydrusColumnListParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionHydrusColumnListParent documents */
  connect?: InputMaybe<Array<CosmosSectionHydrusColumnListParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionHydrusColumnListParent documents */
  create?: InputMaybe<Array<CosmosSectionHydrusColumnListParentCreateInput>>;
};

export type CosmosSectionHydrusColumnListParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionHydrusColumnListParent document */
  connect?: InputMaybe<CosmosSectionHydrusColumnListParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionHydrusColumnListParent document */
  create?: InputMaybe<CosmosSectionHydrusColumnListParentCreateInput>;
};

export type CosmosSectionHydrusColumnListParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionHydrusColumnListParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionHydrusColumnListParent documents */
  connect?: InputMaybe<Array<CosmosSectionHydrusColumnListParentConnectInput>>;
  /** Create and connect multiple CosmosSectionHydrusColumnListParent documents */
  create?: InputMaybe<Array<CosmosSectionHydrusColumnListParentCreateInput>>;
  /** Delete multiple CosmosSectionHydrusColumnListParent documents */
  delete?: InputMaybe<Array<CosmosSectionHydrusColumnListParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionHydrusColumnListParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionHydrusColumnListParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionHydrusColumnListParent documents */
  set?: InputMaybe<Array<CosmosSectionHydrusColumnListParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionHydrusColumnListParent documents */
  update?: InputMaybe<Array<CosmosSectionHydrusColumnListParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionHydrusColumnListParent documents */
  upsert?: InputMaybe<Array<CosmosSectionHydrusColumnListParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionHydrusColumnListParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionHydrusColumnListParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionHydrusColumnListParent document */
  connect?: InputMaybe<CosmosSectionHydrusColumnListParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionHydrusColumnListParent document */
  create?: InputMaybe<CosmosSectionHydrusColumnListParentCreateInput>;
  /** Delete currently connected CosmosSectionHydrusColumnListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionHydrusColumnListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionHydrusColumnListParent document */
  update?: InputMaybe<CosmosSectionHydrusColumnListParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionHydrusColumnListParent document */
  upsert?: InputMaybe<CosmosSectionHydrusColumnListParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionHydrusColumnListParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionHydrusColumnListParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionHydrusColumnListParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionHydrusColumnListParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionHydrusColumnListUpdateInput = {
  columns?: InputMaybe<CosmosElementHydrusColumnUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionHydrusColumnListUpdateLocalizationsInput>;
};

export type CosmosSectionHydrusColumnListUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionHydrusColumnListUpdateLocalizationInput = {
  data: CosmosSectionHydrusColumnListUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionHydrusColumnListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionHydrusColumnListCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionHydrusColumnListUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionHydrusColumnListUpsertLocalizationInput>>;
};

export type CosmosSectionHydrusColumnListUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionHydrusColumnList component instances */
  create?: InputMaybe<Array<CosmosSectionHydrusColumnListCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionHydrusColumnList documents */
  delete?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereUniqueInput>>;
  /** Update multiple CosmosSectionHydrusColumnList component instances */
  update?: InputMaybe<Array<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionHydrusColumnList component instances */
  upsert?: InputMaybe<Array<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionHydrusColumnListUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionHydrusColumnListUpdateManyLocalizationsInput>;
};

export type CosmosSectionHydrusColumnListUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionHydrusColumnListUpdateManyLocalizationInput = {
  data: CosmosSectionHydrusColumnListUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionHydrusColumnListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionHydrusColumnListUpdateManyLocalizationInput>>;
};

export type CosmosSectionHydrusColumnListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionHydrusColumnListUpdateManyInput;
  /** Document search */
  where: CosmosSectionHydrusColumnListWhereInput;
};

export type CosmosSectionHydrusColumnListUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionHydrusColumnList document */
  create?: InputMaybe<CosmosSectionHydrusColumnListCreateInput>;
  /** Delete currently connected CosmosSectionHydrusColumnList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionHydrusColumnList document */
  update?: InputMaybe<CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionHydrusColumnList document */
  upsert?: InputMaybe<CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionHydrusColumnListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionHydrusColumnListWhereUniqueInput;
};

export type CosmosSectionHydrusColumnListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionHydrusColumnListUpdateInput;
  /** Unique document search */
  where: CosmosSectionHydrusColumnListWhereUniqueInput;
};

export type CosmosSectionHydrusColumnListUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionHydrusColumnListCreateInput;
  /** Update document if it exists */
  update: CosmosSectionHydrusColumnListUpdateInput;
};

export type CosmosSectionHydrusColumnListUpsertLocalizationInput = {
  create: CosmosSectionHydrusColumnListCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionHydrusColumnListUpdateLocalizationDataInput;
};

export type CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionHydrusColumnListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionHydrusColumnListWhereUniqueInput;
};

export type CosmosSectionHydrusColumnListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionHydrusColumnListUpsertInput;
  /** Unique document search */
  where: CosmosSectionHydrusColumnListWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionHydrusColumnListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionHydrusColumnListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  columns_every?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
  columns_none?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
  columns_some?: InputMaybe<CosmosElementHydrusColumnWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionHydrusColumnList record uniquely */
export type CosmosSectionHydrusColumnListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The section is used to add automatically pulled data from the feed */
export type CosmosSectionLatestNews = Entity & {
  __typename?: 'CosmosSectionLatestNews';
  config?: Maybe<CosmosConfigSection>;
  cosmosPageBlogDetails: Array<CosmosPageBlogDetail>;
  disableCategoryPills?: Maybe<Scalars['Boolean']['output']>;
  featuredLabel?: Maybe<Scalars['String']['output']>;
  /**
   * An optional field for the custom feed configuration.
   * An array of brands to filter by. The brand's query parameter filters results using:
   * • () (parentheses) = To add a tags filter to the brand.
   * • & (and) = AND (higher priority) → All tags must be present.
   * • | (pipe) = OR → At least one tag in the group must be present.
   * Example: brands=mh,ue(unreal&fortnite|fallguys) → unreal AND (fortnite OR fallguys) for the ue brand and all records for mh.
   */
  feedBrand?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionLatestNews>;
  preserveStickySort?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Allows selection of a preconfigured type and amount of cards which will display the latest articles from the feed service. If left empty, will default to Small2. */
  variant?: Maybe<CosmosEnumLatestNewsVariants>;
  wfRefBlogTags: Array<WfRefBlogTag>;
};


/** The section is used to add automatically pulled data from the feed */
export type CosmosSectionLatestNewsConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** The section is used to add automatically pulled data from the feed */
export type CosmosSectionLatestNewsCosmosPageBlogDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosPageBlogDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageBlogDetailWhereInput>;
};


/** The section is used to add automatically pulled data from the feed */
export type CosmosSectionLatestNewsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** The section is used to add automatically pulled data from the feed */
export type CosmosSectionLatestNewsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** The section is used to add automatically pulled data from the feed */
export type CosmosSectionLatestNewsWfRefBlogTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<WfRefBlogTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogTagWhereInput>;
};

export type CosmosSectionLatestNewsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionLatestNewsWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionLatestNewsConnection = {
  __typename?: 'CosmosSectionLatestNewsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionLatestNewsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionLatestNewsCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  cosmosPageBlogDetails?: InputMaybe<CosmosPageBlogDetailCreateManyInlineInput>;
  disableCategoryPills?: InputMaybe<Scalars['Boolean']['input']>;
  /** featuredLabel input for default locale (en) */
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  feedBrand?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionLatestNewsCreateLocalizationsInput>;
  preserveStickySort?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumLatestNewsVariants>;
  wfRefBlogTags?: InputMaybe<WfRefBlogTagCreateManyInlineInput>;
};

export type CosmosSectionLatestNewsCreateLocalizationDataInput = {
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLatestNewsCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionLatestNewsCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLatestNewsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionLatestNewsCreateLocalizationInput>>;
};

export type CosmosSectionLatestNewsCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionLatestNews documents */
  create?: InputMaybe<Array<CosmosSectionLatestNewsCreateInput>>;
};

export type CosmosSectionLatestNewsCreateOneInlineInput = {
  /** Create and connect one CosmosSectionLatestNews document */
  create?: InputMaybe<CosmosSectionLatestNewsCreateInput>;
};

export type CosmosSectionLatestNewsCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionLatestNewsCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionLatestNewsEdge = {
  __typename?: 'CosmosSectionLatestNewsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionLatestNews;
};

/** Identifies documents */
export type CosmosSectionLatestNewsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLatestNewsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLatestNewsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLatestNewsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  cosmosPageBlogDetails_every?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  cosmosPageBlogDetails_none?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  cosmosPageBlogDetails_some?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  disableCategoryPills?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableCategoryPills_not?: InputMaybe<Scalars['Boolean']['input']>;
  feedBrand?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  feedBrand_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  feedBrand_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  feedBrand_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  feedBrand_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  feedBrand_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  feedBrand_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  feedBrand_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  feedBrand_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  feedBrand_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  preserveStickySort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  preserveStickySort_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumLatestNewsVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumLatestNewsVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumLatestNewsVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLatestNewsVariants>>>;
  wfRefBlogTags_every?: InputMaybe<WfRefBlogTagWhereInput>;
  wfRefBlogTags_none?: InputMaybe<WfRefBlogTagWhereInput>;
  wfRefBlogTags_some?: InputMaybe<WfRefBlogTagWhereInput>;
};

export enum CosmosSectionLatestNewsOrderByInput {
  DisableCategoryPillsAsc = 'disableCategoryPills_ASC',
  DisableCategoryPillsDesc = 'disableCategoryPills_DESC',
  FeaturedLabelAsc = 'featuredLabel_ASC',
  FeaturedLabelDesc = 'featuredLabel_DESC',
  FeedBrandAsc = 'feedBrand_ASC',
  FeedBrandDesc = 'feedBrand_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PreserveStickySortAsc = 'preserveStickySort_ASC',
  PreserveStickySortDesc = 'preserveStickySort_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosSectionLatestNewsParent = CosmosReferenceSection;

export type CosmosSectionLatestNewsParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionLatestNewsParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionLatestNewsParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLatestNewsParent documents */
  connect?: InputMaybe<Array<CosmosSectionLatestNewsParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionLatestNewsParent documents */
  create?: InputMaybe<Array<CosmosSectionLatestNewsParentCreateInput>>;
};

export type CosmosSectionLatestNewsParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionLatestNewsParent document */
  connect?: InputMaybe<CosmosSectionLatestNewsParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLatestNewsParent document */
  create?: InputMaybe<CosmosSectionLatestNewsParentCreateInput>;
};

export type CosmosSectionLatestNewsParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionLatestNewsParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLatestNewsParent documents */
  connect?: InputMaybe<Array<CosmosSectionLatestNewsParentConnectInput>>;
  /** Create and connect multiple CosmosSectionLatestNewsParent documents */
  create?: InputMaybe<Array<CosmosSectionLatestNewsParentCreateInput>>;
  /** Delete multiple CosmosSectionLatestNewsParent documents */
  delete?: InputMaybe<Array<CosmosSectionLatestNewsParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionLatestNewsParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionLatestNewsParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionLatestNewsParent documents */
  set?: InputMaybe<Array<CosmosSectionLatestNewsParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionLatestNewsParent documents */
  update?: InputMaybe<Array<CosmosSectionLatestNewsParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionLatestNewsParent documents */
  upsert?: InputMaybe<Array<CosmosSectionLatestNewsParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionLatestNewsParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionLatestNewsParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionLatestNewsParent document */
  connect?: InputMaybe<CosmosSectionLatestNewsParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLatestNewsParent document */
  create?: InputMaybe<CosmosSectionLatestNewsParentCreateInput>;
  /** Delete currently connected CosmosSectionLatestNewsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionLatestNewsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLatestNewsParent document */
  update?: InputMaybe<CosmosSectionLatestNewsParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLatestNewsParent document */
  upsert?: InputMaybe<CosmosSectionLatestNewsParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLatestNewsParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionLatestNewsParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLatestNewsParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionLatestNewsParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionLatestNewsUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  cosmosPageBlogDetails?: InputMaybe<CosmosPageBlogDetailUpdateManyInlineInput>;
  disableCategoryPills?: InputMaybe<Scalars['Boolean']['input']>;
  /** featuredLabel input for default locale (en) */
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  feedBrand?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionLatestNewsUpdateLocalizationsInput>;
  preserveStickySort?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<CosmosEnumLatestNewsVariants>;
  wfRefBlogTags?: InputMaybe<WfRefBlogTagUpdateManyInlineInput>;
};

export type CosmosSectionLatestNewsUpdateLocalizationDataInput = {
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLatestNewsUpdateLocalizationInput = {
  data: CosmosSectionLatestNewsUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLatestNewsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionLatestNewsCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLatestNewsUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionLatestNewsUpsertLocalizationInput>>;
};

export type CosmosSectionLatestNewsUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionLatestNews component instances */
  create?: InputMaybe<Array<CosmosSectionLatestNewsCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionLatestNews documents */
  delete?: InputMaybe<Array<CosmosSectionLatestNewsWhereUniqueInput>>;
  /** Update multiple CosmosSectionLatestNews component instances */
  update?: InputMaybe<Array<CosmosSectionLatestNewsUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionLatestNews component instances */
  upsert?: InputMaybe<Array<CosmosSectionLatestNewsUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionLatestNewsUpdateManyInput = {
  disableCategoryPills?: InputMaybe<Scalars['Boolean']['input']>;
  /** featuredLabel input for default locale (en) */
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  feedBrand?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionLatestNewsUpdateManyLocalizationsInput>;
  preserveStickySort?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<CosmosEnumLatestNewsVariants>;
};

export type CosmosSectionLatestNewsUpdateManyLocalizationDataInput = {
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLatestNewsUpdateManyLocalizationInput = {
  data: CosmosSectionLatestNewsUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLatestNewsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLatestNewsUpdateManyLocalizationInput>>;
};

export type CosmosSectionLatestNewsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionLatestNewsUpdateManyInput;
  /** Document search */
  where: CosmosSectionLatestNewsWhereInput;
};

export type CosmosSectionLatestNewsUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionLatestNews document */
  create?: InputMaybe<CosmosSectionLatestNewsCreateInput>;
  /** Delete currently connected CosmosSectionLatestNews document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLatestNews document */
  update?: InputMaybe<CosmosSectionLatestNewsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLatestNews document */
  upsert?: InputMaybe<CosmosSectionLatestNewsUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLatestNewsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionLatestNewsUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLatestNewsWhereUniqueInput;
};

export type CosmosSectionLatestNewsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionLatestNewsUpdateInput;
  /** Unique document search */
  where: CosmosSectionLatestNewsWhereUniqueInput;
};

export type CosmosSectionLatestNewsUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionLatestNewsCreateInput;
  /** Update document if it exists */
  update: CosmosSectionLatestNewsUpdateInput;
};

export type CosmosSectionLatestNewsUpsertLocalizationInput = {
  create: CosmosSectionLatestNewsCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionLatestNewsUpdateLocalizationDataInput;
};

export type CosmosSectionLatestNewsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionLatestNewsUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLatestNewsWhereUniqueInput;
};

export type CosmosSectionLatestNewsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionLatestNewsUpsertInput;
  /** Unique document search */
  where: CosmosSectionLatestNewsWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionLatestNewsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLatestNewsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLatestNewsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLatestNewsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  cosmosPageBlogDetails_every?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  cosmosPageBlogDetails_none?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  cosmosPageBlogDetails_some?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  disableCategoryPills?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableCategoryPills_not?: InputMaybe<Scalars['Boolean']['input']>;
  featuredLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  featuredLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  featuredLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  featuredLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  featuredLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  featuredLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  featuredLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  featuredLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  featuredLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  featuredLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  feedBrand?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  feedBrand_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  feedBrand_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  feedBrand_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  feedBrand_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  feedBrand_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  feedBrand_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  feedBrand_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  feedBrand_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  feedBrand_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  preserveStickySort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  preserveStickySort_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumLatestNewsVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumLatestNewsVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumLatestNewsVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumLatestNewsVariants>>>;
  wfRefBlogTags_every?: InputMaybe<WfRefBlogTagWhereInput>;
  wfRefBlogTags_none?: InputMaybe<WfRefBlogTagWhereInput>;
  wfRefBlogTags_some?: InputMaybe<WfRefBlogTagWhereInput>;
};

/** References CosmosSectionLatestNews record uniquely */
export type CosmosSectionLatestNewsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionLearn = Entity & {
  __typename?: 'CosmosSectionLearn';
  applicationFamily?: Maybe<CosmosEnumApplicationFamily>;
  categories: Array<ElementLearnCategory>;
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionLearn>;
  /** System stage field */
  stage: Stage;
  tabs: Array<CosmosElementLearnTab>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionLearnCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ElementLearnCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ElementLearnCategoryWhereInput>;
};


export type CosmosSectionLearnConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionLearnLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionLearnTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLearnTabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLearnTabWhereInput>;
};


export type CosmosSectionLearnUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionLearnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionLearnWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionLearnConnection = {
  __typename?: 'CosmosSectionLearnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionLearnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionLearnCreateInput = {
  applicationFamily?: InputMaybe<CosmosEnumApplicationFamily>;
  categories?: InputMaybe<ElementLearnCategoryCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionLearnCreateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementLearnTabCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLearnCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLearnCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionLearnCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLearnCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionLearnCreateLocalizationInput>>;
};

export type CosmosSectionLearnCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionLearn documents */
  create?: InputMaybe<Array<CosmosSectionLearnCreateInput>>;
};

export type CosmosSectionLearnCreateOneInlineInput = {
  /** Create and connect one CosmosSectionLearn document */
  create?: InputMaybe<CosmosSectionLearnCreateInput>;
};

export type CosmosSectionLearnCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionLearnCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionLearnEdge = {
  __typename?: 'CosmosSectionLearnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionLearn;
};

/** Identifies documents */
export type CosmosSectionLearnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLearnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLearnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLearnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  applicationFamily?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are contained in given list. */
  applicationFamily_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  /** Any other value that exists and is not equal to the given value. */
  applicationFamily_not?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are not contained in given list. */
  applicationFamily_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  categories_every?: InputMaybe<ElementLearnCategoryWhereInput>;
  categories_none?: InputMaybe<ElementLearnCategoryWhereInput>;
  categories_some?: InputMaybe<ElementLearnCategoryWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabs_every?: InputMaybe<CosmosElementLearnTabWhereInput>;
  tabs_none?: InputMaybe<CosmosElementLearnTabWhereInput>;
  tabs_some?: InputMaybe<CosmosElementLearnTabWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionLearnOrderByInput {
  ApplicationFamilyAsc = 'applicationFamily_ASC',
  ApplicationFamilyDesc = 'applicationFamily_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionLearnParent = CosmosReferenceSection;

export type CosmosSectionLearnParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionLearnParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionLearnParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLearnParent documents */
  connect?: InputMaybe<Array<CosmosSectionLearnParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionLearnParent documents */
  create?: InputMaybe<Array<CosmosSectionLearnParentCreateInput>>;
};

export type CosmosSectionLearnParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionLearnParent document */
  connect?: InputMaybe<CosmosSectionLearnParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLearnParent document */
  create?: InputMaybe<CosmosSectionLearnParentCreateInput>;
};

export type CosmosSectionLearnParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionLearnParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLearnParent documents */
  connect?: InputMaybe<Array<CosmosSectionLearnParentConnectInput>>;
  /** Create and connect multiple CosmosSectionLearnParent documents */
  create?: InputMaybe<Array<CosmosSectionLearnParentCreateInput>>;
  /** Delete multiple CosmosSectionLearnParent documents */
  delete?: InputMaybe<Array<CosmosSectionLearnParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionLearnParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionLearnParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionLearnParent documents */
  set?: InputMaybe<Array<CosmosSectionLearnParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionLearnParent documents */
  update?: InputMaybe<Array<CosmosSectionLearnParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionLearnParent documents */
  upsert?: InputMaybe<Array<CosmosSectionLearnParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionLearnParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionLearnParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionLearnParent document */
  connect?: InputMaybe<CosmosSectionLearnParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLearnParent document */
  create?: InputMaybe<CosmosSectionLearnParentCreateInput>;
  /** Delete currently connected CosmosSectionLearnParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionLearnParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLearnParent document */
  update?: InputMaybe<CosmosSectionLearnParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLearnParent document */
  upsert?: InputMaybe<CosmosSectionLearnParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLearnParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionLearnParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLearnParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionLearnParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionLearnUpdateInput = {
  applicationFamily?: InputMaybe<CosmosEnumApplicationFamily>;
  categories?: InputMaybe<ElementLearnCategoryUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionLearnUpdateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementLearnTabUpdateManyInlineInput>;
};

export type CosmosSectionLearnUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLearnUpdateLocalizationInput = {
  data: CosmosSectionLearnUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLearnUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionLearnCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLearnUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionLearnUpsertLocalizationInput>>;
};

export type CosmosSectionLearnUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionLearn component instances */
  create?: InputMaybe<Array<CosmosSectionLearnCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionLearn documents */
  delete?: InputMaybe<Array<CosmosSectionLearnWhereUniqueInput>>;
  /** Update multiple CosmosSectionLearn component instances */
  update?: InputMaybe<Array<CosmosSectionLearnUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionLearn component instances */
  upsert?: InputMaybe<Array<CosmosSectionLearnUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionLearnUpdateManyInput = {
  applicationFamily?: InputMaybe<CosmosEnumApplicationFamily>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionLearnUpdateManyLocalizationsInput>;
};

export type CosmosSectionLearnUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLearnUpdateManyLocalizationInput = {
  data: CosmosSectionLearnUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLearnUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLearnUpdateManyLocalizationInput>>;
};

export type CosmosSectionLearnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionLearnUpdateManyInput;
  /** Document search */
  where: CosmosSectionLearnWhereInput;
};

export type CosmosSectionLearnUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionLearn document */
  create?: InputMaybe<CosmosSectionLearnCreateInput>;
  /** Delete currently connected CosmosSectionLearn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLearn document */
  update?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLearn document */
  upsert?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLearnUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionLearnUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLearnWhereUniqueInput;
};

export type CosmosSectionLearnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionLearnUpdateInput;
  /** Unique document search */
  where: CosmosSectionLearnWhereUniqueInput;
};

export type CosmosSectionLearnUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionLearnCreateInput;
  /** Update document if it exists */
  update: CosmosSectionLearnUpdateInput;
};

export type CosmosSectionLearnUpsertLocalizationInput = {
  create: CosmosSectionLearnCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionLearnUpdateLocalizationDataInput;
};

export type CosmosSectionLearnUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionLearnUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLearnWhereUniqueInput;
};

export type CosmosSectionLearnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionLearnUpsertInput;
  /** Unique document search */
  where: CosmosSectionLearnWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionLearnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLearnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLearnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLearnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  applicationFamily?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are contained in given list. */
  applicationFamily_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  /** Any other value that exists and is not equal to the given value. */
  applicationFamily_not?: InputMaybe<CosmosEnumApplicationFamily>;
  /** All values that are not contained in given list. */
  applicationFamily_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumApplicationFamily>>>;
  categories_every?: InputMaybe<ElementLearnCategoryWhereInput>;
  categories_none?: InputMaybe<ElementLearnCategoryWhereInput>;
  categories_some?: InputMaybe<ElementLearnCategoryWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabs_every?: InputMaybe<CosmosElementLearnTabWhereInput>;
  tabs_none?: InputMaybe<CosmosElementLearnTabWhereInput>;
  tabs_some?: InputMaybe<CosmosElementLearnTabWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionLearn record uniquely */
export type CosmosSectionLearnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionLicensesCollapsed = Entity & {
  __typename?: 'CosmosSectionLicensesCollapsed';
  collapsedCards: Array<CosmosElementLicenseCollapsedCard>;
  collapsedCardsHeading?: Maybe<Scalars['String']['output']>;
  collapsedCta?: Maybe<CosmosElementLink>;
  /** Config for the section */
  config?: Maybe<CosmosConfigSection>;
  freeHeading?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionLicensesCollapsed>;
  /** System stage field */
  stage: Stage;
  topCard?: Maybe<CosmosElementLicenseTopCard>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionLicensesCollapsedCollapsedCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLicenseCollapsedCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
};


export type CosmosSectionLicensesCollapsedCollapsedCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionLicensesCollapsedConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionLicensesCollapsedLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionLicensesCollapsedTopCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionLicensesCollapsedUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionLicensesCollapsedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionLicensesCollapsedWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionLicensesCollapsedConnection = {
  __typename?: 'CosmosSectionLicensesCollapsedConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionLicensesCollapsedEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionLicensesCollapsedCreateInput = {
  collapsedCards?: InputMaybe<CosmosElementLicenseCollapsedCardCreateManyInlineInput>;
  /** collapsedCardsHeading input for default locale (en) */
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  collapsedCta?: InputMaybe<CosmosElementLinkCreateOneInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** freeHeading input for default locale (en) */
  freeHeading?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionLicensesCollapsedCreateLocalizationsInput>;
  topCard?: InputMaybe<CosmosElementLicenseTopCardCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLicensesCollapsedCreateLocalizationDataInput = {
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  freeHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLicensesCollapsedCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionLicensesCollapsedCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLicensesCollapsedCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionLicensesCollapsedCreateLocalizationInput>>;
};

export type CosmosSectionLicensesCollapsedCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionLicensesCollapsed documents */
  create?: InputMaybe<Array<CosmosSectionLicensesCollapsedCreateInput>>;
};

export type CosmosSectionLicensesCollapsedCreateOneInlineInput = {
  /** Create and connect one CosmosSectionLicensesCollapsed document */
  create?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
};

export type CosmosSectionLicensesCollapsedCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionLicensesCollapsedCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionLicensesCollapsedEdge = {
  __typename?: 'CosmosSectionLicensesCollapsedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionLicensesCollapsed;
};

/** Identifies documents */
export type CosmosSectionLicensesCollapsedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  collapsedCards_every?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
  collapsedCards_none?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
  collapsedCards_some?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
  collapsedCta?: InputMaybe<CosmosElementLinkWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  topCard?: InputMaybe<CosmosElementLicenseTopCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionLicensesCollapsedOrderByInput {
  CollapsedCardsHeadingAsc = 'collapsedCardsHeading_ASC',
  CollapsedCardsHeadingDesc = 'collapsedCardsHeading_DESC',
  FreeHeadingAsc = 'freeHeading_ASC',
  FreeHeadingDesc = 'freeHeading_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionLicensesCollapsedParent = CosmosReferenceSection;

export type CosmosSectionLicensesCollapsedParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionLicensesCollapsedParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionLicensesCollapsedParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLicensesCollapsedParent documents */
  connect?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionLicensesCollapsedParent documents */
  create?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentCreateInput>>;
};

export type CosmosSectionLicensesCollapsedParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionLicensesCollapsedParent document */
  connect?: InputMaybe<CosmosSectionLicensesCollapsedParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLicensesCollapsedParent document */
  create?: InputMaybe<CosmosSectionLicensesCollapsedParentCreateInput>;
};

export type CosmosSectionLicensesCollapsedParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionLicensesCollapsedParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLicensesCollapsedParent documents */
  connect?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentConnectInput>>;
  /** Create and connect multiple CosmosSectionLicensesCollapsedParent documents */
  create?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentCreateInput>>;
  /** Delete multiple CosmosSectionLicensesCollapsedParent documents */
  delete?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionLicensesCollapsedParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionLicensesCollapsedParent documents */
  set?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionLicensesCollapsedParent documents */
  update?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionLicensesCollapsedParent documents */
  upsert?: InputMaybe<Array<CosmosSectionLicensesCollapsedParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionLicensesCollapsedParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionLicensesCollapsedParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionLicensesCollapsedParent document */
  connect?: InputMaybe<CosmosSectionLicensesCollapsedParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLicensesCollapsedParent document */
  create?: InputMaybe<CosmosSectionLicensesCollapsedParentCreateInput>;
  /** Delete currently connected CosmosSectionLicensesCollapsedParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionLicensesCollapsedParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLicensesCollapsedParent document */
  update?: InputMaybe<CosmosSectionLicensesCollapsedParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLicensesCollapsedParent document */
  upsert?: InputMaybe<CosmosSectionLicensesCollapsedParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLicensesCollapsedParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionLicensesCollapsedParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLicensesCollapsedParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionLicensesCollapsedParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionLicensesCollapsedUpdateInput = {
  collapsedCards?: InputMaybe<CosmosElementLicenseCollapsedCardUpdateManyInlineInput>;
  /** collapsedCardsHeading input for default locale (en) */
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  collapsedCta?: InputMaybe<CosmosElementLinkUpdateOneInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** freeHeading input for default locale (en) */
  freeHeading?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionLicensesCollapsedUpdateLocalizationsInput>;
  topCard?: InputMaybe<CosmosElementLicenseTopCardUpdateOneInlineInput>;
};

export type CosmosSectionLicensesCollapsedUpdateLocalizationDataInput = {
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  freeHeading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLicensesCollapsedUpdateLocalizationInput = {
  data: CosmosSectionLicensesCollapsedUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLicensesCollapsedUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionLicensesCollapsedCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLicensesCollapsedUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionLicensesCollapsedUpsertLocalizationInput>>;
};

export type CosmosSectionLicensesCollapsedUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionLicensesCollapsed component instances */
  create?: InputMaybe<Array<CosmosSectionLicensesCollapsedCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionLicensesCollapsed documents */
  delete?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereUniqueInput>>;
  /** Update multiple CosmosSectionLicensesCollapsed component instances */
  update?: InputMaybe<Array<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionLicensesCollapsed component instances */
  upsert?: InputMaybe<Array<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionLicensesCollapsedUpdateManyInput = {
  /** collapsedCardsHeading input for default locale (en) */
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  /** freeHeading input for default locale (en) */
  freeHeading?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionLicensesCollapsedUpdateManyLocalizationsInput>;
};

export type CosmosSectionLicensesCollapsedUpdateManyLocalizationDataInput = {
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  freeHeading?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLicensesCollapsedUpdateManyLocalizationInput = {
  data: CosmosSectionLicensesCollapsedUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLicensesCollapsedUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLicensesCollapsedUpdateManyLocalizationInput>>;
};

export type CosmosSectionLicensesCollapsedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionLicensesCollapsedUpdateManyInput;
  /** Document search */
  where: CosmosSectionLicensesCollapsedWhereInput;
};

export type CosmosSectionLicensesCollapsedUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionLicensesCollapsed document */
  create?: InputMaybe<CosmosSectionLicensesCollapsedCreateInput>;
  /** Delete currently connected CosmosSectionLicensesCollapsed document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLicensesCollapsed document */
  update?: InputMaybe<CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLicensesCollapsed document */
  upsert?: InputMaybe<CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionLicensesCollapsedUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLicensesCollapsedWhereUniqueInput;
};

export type CosmosSectionLicensesCollapsedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionLicensesCollapsedUpdateInput;
  /** Unique document search */
  where: CosmosSectionLicensesCollapsedWhereUniqueInput;
};

export type CosmosSectionLicensesCollapsedUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionLicensesCollapsedCreateInput;
  /** Update document if it exists */
  update: CosmosSectionLicensesCollapsedUpdateInput;
};

export type CosmosSectionLicensesCollapsedUpsertLocalizationInput = {
  create: CosmosSectionLicensesCollapsedCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionLicensesCollapsedUpdateLocalizationDataInput;
};

export type CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionLicensesCollapsedUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLicensesCollapsedWhereUniqueInput;
};

export type CosmosSectionLicensesCollapsedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionLicensesCollapsedUpsertInput;
  /** Unique document search */
  where: CosmosSectionLicensesCollapsedWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionLicensesCollapsedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLicensesCollapsedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  collapsedCardsHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  collapsedCardsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  collapsedCardsHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  collapsedCardsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  collapsedCardsHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  collapsedCardsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  collapsedCardsHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  collapsedCardsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  collapsedCardsHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  collapsedCardsHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  collapsedCards_every?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
  collapsedCards_none?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
  collapsedCards_some?: InputMaybe<CosmosElementLicenseCollapsedCardWhereInput>;
  collapsedCta?: InputMaybe<CosmosElementLinkWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  freeHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  freeHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  freeHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  freeHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  freeHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  freeHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  freeHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  freeHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  freeHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  freeHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  topCard?: InputMaybe<CosmosElementLicenseTopCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionLicensesCollapsed record uniquely */
export type CosmosSectionLicensesCollapsedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionLogoList = Entity & {
  __typename?: 'CosmosSectionLogoList';
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** Always render the logos in a grid without the marquee animation. */
  disableMarquee?: Maybe<Scalars['Boolean']['output']>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionLogoList>;
  logos: Array<CosmosElementLogo>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionLogoListConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionLogoListLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionLogoListLogosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLogoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLogoWhereInput>;
};


export type CosmosSectionLogoListUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionLogoListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionLogoListWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionLogoListConnection = {
  __typename?: 'CosmosSectionLogoListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionLogoListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionLogoListCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  disableMarquee?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionLogoListCreateLocalizationsInput>;
  logos?: InputMaybe<CosmosElementLogoCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLogoListCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLogoListCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionLogoListCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLogoListCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionLogoListCreateLocalizationInput>>;
};

export type CosmosSectionLogoListCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionLogoList documents */
  create?: InputMaybe<Array<CosmosSectionLogoListCreateInput>>;
};

export type CosmosSectionLogoListCreateOneInlineInput = {
  /** Create and connect one CosmosSectionLogoList document */
  create?: InputMaybe<CosmosSectionLogoListCreateInput>;
};

export type CosmosSectionLogoListCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionLogoListCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionLogoListEdge = {
  __typename?: 'CosmosSectionLogoListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionLogoList;
};

/** Identifies documents */
export type CosmosSectionLogoListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLogoListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLogoListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLogoListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  disableMarquee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableMarquee_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logos_every?: InputMaybe<CosmosElementLogoWhereInput>;
  logos_none?: InputMaybe<CosmosElementLogoWhereInput>;
  logos_some?: InputMaybe<CosmosElementLogoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionLogoListOrderByInput {
  DisableMarqueeAsc = 'disableMarquee_ASC',
  DisableMarqueeDesc = 'disableMarquee_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionLogoListParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionLogoListParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionLogoListParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionLogoListParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLogoListParent documents */
  connect?: InputMaybe<Array<CosmosSectionLogoListParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionLogoListParent documents */
  create?: InputMaybe<Array<CosmosSectionLogoListParentCreateInput>>;
};

export type CosmosSectionLogoListParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionLogoListParent document */
  connect?: InputMaybe<CosmosSectionLogoListParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLogoListParent document */
  create?: InputMaybe<CosmosSectionLogoListParentCreateInput>;
};

export type CosmosSectionLogoListParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionLogoListParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLogoListParent documents */
  connect?: InputMaybe<Array<CosmosSectionLogoListParentConnectInput>>;
  /** Create and connect multiple CosmosSectionLogoListParent documents */
  create?: InputMaybe<Array<CosmosSectionLogoListParentCreateInput>>;
  /** Delete multiple CosmosSectionLogoListParent documents */
  delete?: InputMaybe<Array<CosmosSectionLogoListParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionLogoListParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionLogoListParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionLogoListParent documents */
  set?: InputMaybe<Array<CosmosSectionLogoListParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionLogoListParent documents */
  update?: InputMaybe<Array<CosmosSectionLogoListParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionLogoListParent documents */
  upsert?: InputMaybe<Array<CosmosSectionLogoListParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionLogoListParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionLogoListParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionLogoListParent document */
  connect?: InputMaybe<CosmosSectionLogoListParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLogoListParent document */
  create?: InputMaybe<CosmosSectionLogoListParentCreateInput>;
  /** Delete currently connected CosmosSectionLogoListParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionLogoListParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLogoListParent document */
  update?: InputMaybe<CosmosSectionLogoListParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLogoListParent document */
  upsert?: InputMaybe<CosmosSectionLogoListParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoListParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoListParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoListParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionLogoListParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionLogoListUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  disableMarquee?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionLogoListUpdateLocalizationsInput>;
  logos?: InputMaybe<CosmosElementLogoUpdateManyInlineInput>;
};

export type CosmosSectionLogoListUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLogoListUpdateLocalizationInput = {
  data: CosmosSectionLogoListUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLogoListUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionLogoListCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLogoListUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionLogoListUpsertLocalizationInput>>;
};

export type CosmosSectionLogoListUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionLogoList component instances */
  create?: InputMaybe<Array<CosmosSectionLogoListCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionLogoList documents */
  delete?: InputMaybe<Array<CosmosSectionLogoListWhereUniqueInput>>;
  /** Update multiple CosmosSectionLogoList component instances */
  update?: InputMaybe<Array<CosmosSectionLogoListUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionLogoList component instances */
  upsert?: InputMaybe<Array<CosmosSectionLogoListUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionLogoListUpdateManyInput = {
  disableMarquee?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionLogoListUpdateManyLocalizationsInput>;
};

export type CosmosSectionLogoListUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionLogoListUpdateManyLocalizationInput = {
  data: CosmosSectionLogoListUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLogoListUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLogoListUpdateManyLocalizationInput>>;
};

export type CosmosSectionLogoListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionLogoListUpdateManyInput;
  /** Document search */
  where: CosmosSectionLogoListWhereInput;
};

export type CosmosSectionLogoListUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionLogoList document */
  create?: InputMaybe<CosmosSectionLogoListCreateInput>;
  /** Delete currently connected CosmosSectionLogoList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLogoList document */
  update?: InputMaybe<CosmosSectionLogoListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLogoList document */
  upsert?: InputMaybe<CosmosSectionLogoListUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoListUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionLogoListUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLogoListWhereUniqueInput;
};

export type CosmosSectionLogoListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionLogoListUpdateInput;
  /** Unique document search */
  where: CosmosSectionLogoListWhereUniqueInput;
};

export type CosmosSectionLogoListUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionLogoListCreateInput;
  /** Update document if it exists */
  update: CosmosSectionLogoListUpdateInput;
};

export type CosmosSectionLogoListUpsertLocalizationInput = {
  create: CosmosSectionLogoListCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionLogoListUpdateLocalizationDataInput;
};

export type CosmosSectionLogoListUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionLogoListUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLogoListWhereUniqueInput;
};

export type CosmosSectionLogoListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionLogoListUpsertInput;
  /** Unique document search */
  where: CosmosSectionLogoListWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionLogoListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLogoListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLogoListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLogoListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  disableMarquee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  disableMarquee_not?: InputMaybe<Scalars['Boolean']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  logos_every?: InputMaybe<CosmosElementLogoWhereInput>;
  logos_none?: InputMaybe<CosmosElementLogoWhereInput>;
  logos_some?: InputMaybe<CosmosElementLogoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionLogoList record uniquely */
export type CosmosSectionLogoListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionLogoMultiCard = Entity & {
  __typename?: 'CosmosSectionLogoMultiCard';
  buttons: Array<CosmosSectionLogoMultiCardbuttonsUnion>;
  cards: Array<CosmosElementLogoMultiCard>;
  config?: Maybe<CosmosConfigSection>;
  desc?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<CosmosElementLink>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionLogoMultiCard>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionLogoMultiCardButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CosmosSectionLogoMultiCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLogoMultiCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
};


export type CosmosSectionLogoMultiCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionLogoMultiCardLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLinkWhereInput>;
};


export type CosmosSectionLogoMultiCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionLogoMultiCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionLogoMultiCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionLogoMultiCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionLogoMultiCardConnection = {
  __typename?: 'CosmosSectionLogoMultiCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionLogoMultiCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionLogoMultiCardCreateInput = {
  buttons?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionCreateManyInlineInput>;
  cards?: InputMaybe<CosmosElementLogoMultiCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementLinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionLogoMultiCardCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLogoMultiCardCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionLogoMultiCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionLogoMultiCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLogoMultiCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardCreateLocalizationInput>>;
};

export type CosmosSectionLogoMultiCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionLogoMultiCard documents */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardCreateInput>>;
};

export type CosmosSectionLogoMultiCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionLogoMultiCard document */
  create?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
};

export type CosmosSectionLogoMultiCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionLogoMultiCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionLogoMultiCardEdge = {
  __typename?: 'CosmosSectionLogoMultiCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionLogoMultiCard;
};

/** Identifies documents */
export type CosmosSectionLogoMultiCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  buttons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  buttons_some?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionWhereInput>;
  cards_every?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<CosmosElementLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionLogoMultiCardOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionLogoMultiCardParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionLogoMultiCardParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionLogoMultiCardParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionLogoMultiCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLogoMultiCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionLogoMultiCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionLogoMultiCardParent documents */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardParentCreateInput>>;
};

export type CosmosSectionLogoMultiCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionLogoMultiCardParent document */
  connect?: InputMaybe<CosmosSectionLogoMultiCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLogoMultiCardParent document */
  create?: InputMaybe<CosmosSectionLogoMultiCardParentCreateInput>;
};

export type CosmosSectionLogoMultiCardParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionLogoMultiCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionLogoMultiCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionLogoMultiCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionLogoMultiCardParent documents */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardParentCreateInput>>;
  /** Delete multiple CosmosSectionLogoMultiCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionLogoMultiCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionLogoMultiCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionLogoMultiCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionLogoMultiCardParent documents */
  set?: InputMaybe<Array<CosmosSectionLogoMultiCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionLogoMultiCardParent documents */
  update?: InputMaybe<Array<CosmosSectionLogoMultiCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionLogoMultiCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionLogoMultiCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionLogoMultiCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionLogoMultiCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionLogoMultiCardParent document */
  connect?: InputMaybe<CosmosSectionLogoMultiCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionLogoMultiCardParent document */
  create?: InputMaybe<CosmosSectionLogoMultiCardParentCreateInput>;
  /** Delete currently connected CosmosSectionLogoMultiCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionLogoMultiCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLogoMultiCardParent document */
  update?: InputMaybe<CosmosSectionLogoMultiCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLogoMultiCardParent document */
  upsert?: InputMaybe<CosmosSectionLogoMultiCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionLogoMultiCardParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardUpdateInput = {
  buttons?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionUpdateManyInlineInput>;
  cards?: InputMaybe<CosmosElementLogoMultiCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<CosmosElementLinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionLogoMultiCardUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionLogoMultiCardUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionLogoMultiCardUpdateLocalizationInput = {
  data: CosmosSectionLogoMultiCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLogoMultiCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLogoMultiCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionLogoMultiCardUpsertLocalizationInput>>;
};

export type CosmosSectionLogoMultiCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionLogoMultiCard component instances */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionLogoMultiCard documents */
  delete?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionLogoMultiCard component instances */
  update?: InputMaybe<Array<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionLogoMultiCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionLogoMultiCardUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionLogoMultiCardUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionLogoMultiCardUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionLogoMultiCardUpdateManyLocalizationInput = {
  data: CosmosSectionLogoMultiCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionLogoMultiCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionLogoMultiCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionLogoMultiCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionLogoMultiCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionLogoMultiCardWhereInput;
};

export type CosmosSectionLogoMultiCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionLogoMultiCard document */
  create?: InputMaybe<CosmosSectionLogoMultiCardCreateInput>;
  /** Delete currently connected CosmosSectionLogoMultiCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLogoMultiCard document */
  update?: InputMaybe<CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLogoMultiCard document */
  upsert?: InputMaybe<CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionLogoMultiCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLogoMultiCardWhereUniqueInput;
};

export type CosmosSectionLogoMultiCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionLogoMultiCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionLogoMultiCardWhereUniqueInput;
};

export type CosmosSectionLogoMultiCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionLogoMultiCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionLogoMultiCardUpdateInput;
};

export type CosmosSectionLogoMultiCardUpsertLocalizationInput = {
  create: CosmosSectionLogoMultiCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionLogoMultiCardUpdateLocalizationDataInput;
};

export type CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionLogoMultiCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionLogoMultiCardWhereUniqueInput;
};

export type CosmosSectionLogoMultiCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionLogoMultiCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionLogoMultiCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionLogoMultiCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionLogoMultiCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  buttons_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  buttons_some?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionWhereInput>;
  cards_every?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementLogoMultiCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<CosmosElementLinkWhereInput>;
  links_none?: InputMaybe<CosmosElementLinkWhereInput>;
  links_some?: InputMaybe<CosmosElementLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionLogoMultiCard record uniquely */
export type CosmosSectionLogoMultiCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionLogoMultiCardbuttonsUnion = CosmosElementButton | CosmosElementIconButton;

export type CosmosSectionLogoMultiCardbuttonsUnionConnectInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonConnectInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonConnectInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionCreateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionLogoMultiCardbuttonsUnion documents */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardbuttonsUnionCreateInput>>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionCreateOneInlineInput = {
  /** Create and connect one CosmosSectionLogoMultiCardbuttonsUnion document */
  create?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionCreateInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionCreateWithPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonCreateWithPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonCreateWithPositionInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpdateInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionLogoMultiCardbuttonsUnion component instances */
  create?: InputMaybe<Array<CosmosSectionLogoMultiCardbuttonsUnionCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionLogoMultiCardbuttonsUnion documents */
  delete?: InputMaybe<Array<CosmosSectionLogoMultiCardbuttonsUnionWhereUniqueInput>>;
  /** Update multiple CosmosSectionLogoMultiCardbuttonsUnion component instances */
  update?: InputMaybe<Array<CosmosSectionLogoMultiCardbuttonsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionLogoMultiCardbuttonsUnion component instances */
  upsert?: InputMaybe<Array<CosmosSectionLogoMultiCardbuttonsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateManyWithNestedWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionLogoMultiCardbuttonsUnion document */
  create?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionCreateInput>;
  /** Delete currently connected CosmosSectionLogoMultiCardbuttonsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionLogoMultiCardbuttonsUnion document */
  update?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionLogoMultiCardbuttonsUnion document */
  upsert?: InputMaybe<CosmosSectionLogoMultiCardbuttonsUnionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpdateWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonUpsertWithNestedWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionWhereInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereInput>;
};

export type CosmosSectionLogoMultiCardbuttonsUnionWhereUniqueInput = {
  CosmosElementButton?: InputMaybe<CosmosElementButtonWhereUniqueInput>;
  CosmosElementIconButton?: InputMaybe<CosmosElementIconButtonWhereUniqueInput>;
};

export type CosmosSectionNewsCard = Entity & {
  __typename?: 'CosmosSectionNewsCard';
  cards: Array<CosmosElementNewsCard>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionNewsCard>;
  /** Maximum number of news cards to allow. Defaults to 2. */
  maxCount?: Maybe<EnumSmallNewsCardMax>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionNewsCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementNewsCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementNewsCardWhereInput>;
};


export type CosmosSectionNewsCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionNewsCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionNewsCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionNewsCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionNewsCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionNewsCardConnection = {
  __typename?: 'CosmosSectionNewsCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionNewsCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionNewsCardCreateInput = {
  cards?: InputMaybe<CosmosElementNewsCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionNewsCardCreateLocalizationsInput>;
  maxCount?: InputMaybe<EnumSmallNewsCardMax>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNewsCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNewsCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionNewsCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionNewsCardCreateLocalizationInput>>;
};

export type CosmosSectionNewsCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionNewsCard documents */
  create?: InputMaybe<Array<CosmosSectionNewsCardCreateInput>>;
};

export type CosmosSectionNewsCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionNewsCard document */
  create?: InputMaybe<CosmosSectionNewsCardCreateInput>;
};

export type CosmosSectionNewsCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionNewsCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionNewsCardEdge = {
  __typename?: 'CosmosSectionNewsCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionNewsCard;
};

/** Identifies documents */
export type CosmosSectionNewsCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNewsCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNewsCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNewsCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementNewsCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementNewsCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementNewsCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  maxCount?: InputMaybe<EnumSmallNewsCardMax>;
  /** All values that are contained in given list. */
  maxCount_in?: InputMaybe<Array<InputMaybe<EnumSmallNewsCardMax>>>;
  /** Any other value that exists and is not equal to the given value. */
  maxCount_not?: InputMaybe<EnumSmallNewsCardMax>;
  /** All values that are not contained in given list. */
  maxCount_not_in?: InputMaybe<Array<InputMaybe<EnumSmallNewsCardMax>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionNewsCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MaxCountAsc = 'maxCount_ASC',
  MaxCountDesc = 'maxCount_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionNewsCardParent = CosmosReferenceSection;

export type CosmosSectionNewsCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionNewsCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionNewsCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNewsCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionNewsCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionNewsCardParent documents */
  create?: InputMaybe<Array<CosmosSectionNewsCardParentCreateInput>>;
};

export type CosmosSectionNewsCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionNewsCardParent document */
  connect?: InputMaybe<CosmosSectionNewsCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNewsCardParent document */
  create?: InputMaybe<CosmosSectionNewsCardParentCreateInput>;
};

export type CosmosSectionNewsCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionNewsCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNewsCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionNewsCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionNewsCardParent documents */
  create?: InputMaybe<Array<CosmosSectionNewsCardParentCreateInput>>;
  /** Delete multiple CosmosSectionNewsCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionNewsCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionNewsCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionNewsCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionNewsCardParent documents */
  set?: InputMaybe<Array<CosmosSectionNewsCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionNewsCardParent documents */
  update?: InputMaybe<Array<CosmosSectionNewsCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionNewsCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionNewsCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionNewsCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionNewsCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionNewsCardParent document */
  connect?: InputMaybe<CosmosSectionNewsCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNewsCardParent document */
  create?: InputMaybe<CosmosSectionNewsCardParentCreateInput>;
  /** Delete currently connected CosmosSectionNewsCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionNewsCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNewsCardParent document */
  update?: InputMaybe<CosmosSectionNewsCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNewsCardParent document */
  upsert?: InputMaybe<CosmosSectionNewsCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionNewsCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionNewsCardUpdateInput = {
  cards?: InputMaybe<CosmosElementNewsCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionNewsCardUpdateLocalizationsInput>;
  maxCount?: InputMaybe<EnumSmallNewsCardMax>;
};

export type CosmosSectionNewsCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsCardUpdateLocalizationInput = {
  data: CosmosSectionNewsCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionNewsCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNewsCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionNewsCardUpsertLocalizationInput>>;
};

export type CosmosSectionNewsCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionNewsCard component instances */
  create?: InputMaybe<Array<CosmosSectionNewsCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionNewsCard documents */
  delete?: InputMaybe<Array<CosmosSectionNewsCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionNewsCard component instances */
  update?: InputMaybe<Array<CosmosSectionNewsCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionNewsCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionNewsCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionNewsCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionNewsCardUpdateManyLocalizationsInput>;
  maxCount?: InputMaybe<EnumSmallNewsCardMax>;
};

export type CosmosSectionNewsCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsCardUpdateManyLocalizationInput = {
  data: CosmosSectionNewsCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNewsCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionNewsCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionNewsCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionNewsCardWhereInput;
};

export type CosmosSectionNewsCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionNewsCard document */
  create?: InputMaybe<CosmosSectionNewsCardCreateInput>;
  /** Delete currently connected CosmosSectionNewsCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNewsCard document */
  update?: InputMaybe<CosmosSectionNewsCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNewsCard document */
  upsert?: InputMaybe<CosmosSectionNewsCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionNewsCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNewsCardWhereUniqueInput;
};

export type CosmosSectionNewsCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionNewsCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionNewsCardWhereUniqueInput;
};

export type CosmosSectionNewsCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionNewsCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionNewsCardUpdateInput;
};

export type CosmosSectionNewsCardUpsertLocalizationInput = {
  create: CosmosSectionNewsCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionNewsCardUpdateLocalizationDataInput;
};

export type CosmosSectionNewsCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionNewsCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNewsCardWhereUniqueInput;
};

export type CosmosSectionNewsCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionNewsCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionNewsCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionNewsCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNewsCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNewsCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNewsCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementNewsCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementNewsCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementNewsCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  maxCount?: InputMaybe<EnumSmallNewsCardMax>;
  /** All values that are contained in given list. */
  maxCount_in?: InputMaybe<Array<InputMaybe<EnumSmallNewsCardMax>>>;
  /** Any other value that exists and is not equal to the given value. */
  maxCount_not?: InputMaybe<EnumSmallNewsCardMax>;
  /** All values that are not contained in given list. */
  maxCount_not_in?: InputMaybe<Array<InputMaybe<EnumSmallNewsCardMax>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionNewsCard record uniquely */
export type CosmosSectionNewsCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionNewsMediaCard = Entity & {
  __typename?: 'CosmosSectionNewsMediaCard';
  cards: Array<CosmosElementNewsMediaCard>;
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionNewsMediaCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionNewsMediaCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementNewsMediaCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
};


export type CosmosSectionNewsMediaCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionNewsMediaCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionNewsMediaCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionNewsMediaCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionNewsMediaCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionNewsMediaCardConnection = {
  __typename?: 'CosmosSectionNewsMediaCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionNewsMediaCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionNewsMediaCardCreateInput = {
  cards?: InputMaybe<CosmosElementNewsMediaCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionNewsMediaCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNewsMediaCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNewsMediaCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionNewsMediaCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsMediaCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionNewsMediaCardCreateLocalizationInput>>;
};

export type CosmosSectionNewsMediaCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionNewsMediaCard documents */
  create?: InputMaybe<Array<CosmosSectionNewsMediaCardCreateInput>>;
};

export type CosmosSectionNewsMediaCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionNewsMediaCard document */
  create?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
};

export type CosmosSectionNewsMediaCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionNewsMediaCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionNewsMediaCardEdge = {
  __typename?: 'CosmosSectionNewsMediaCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionNewsMediaCard;
};

/** Identifies documents */
export type CosmosSectionNewsMediaCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionNewsMediaCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionNewsMediaCardParent = CosmosPageBlogDetail | CosmosPagePluginDetail | CosmosReferenceSection;

export type CosmosSectionNewsMediaCardParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionNewsMediaCardParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionNewsMediaCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNewsMediaCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionNewsMediaCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionNewsMediaCardParent documents */
  create?: InputMaybe<Array<CosmosSectionNewsMediaCardParentCreateInput>>;
};

export type CosmosSectionNewsMediaCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionNewsMediaCardParent document */
  connect?: InputMaybe<CosmosSectionNewsMediaCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNewsMediaCardParent document */
  create?: InputMaybe<CosmosSectionNewsMediaCardParentCreateInput>;
};

export type CosmosSectionNewsMediaCardParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionNewsMediaCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNewsMediaCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionNewsMediaCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionNewsMediaCardParent documents */
  create?: InputMaybe<Array<CosmosSectionNewsMediaCardParentCreateInput>>;
  /** Delete multiple CosmosSectionNewsMediaCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionNewsMediaCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionNewsMediaCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionNewsMediaCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionNewsMediaCardParent documents */
  set?: InputMaybe<Array<CosmosSectionNewsMediaCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionNewsMediaCardParent documents */
  update?: InputMaybe<Array<CosmosSectionNewsMediaCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionNewsMediaCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionNewsMediaCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionNewsMediaCardParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionNewsMediaCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionNewsMediaCardParent document */
  connect?: InputMaybe<CosmosSectionNewsMediaCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNewsMediaCardParent document */
  create?: InputMaybe<CosmosSectionNewsMediaCardParentCreateInput>;
  /** Delete currently connected CosmosSectionNewsMediaCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionNewsMediaCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNewsMediaCardParent document */
  update?: InputMaybe<CosmosSectionNewsMediaCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNewsMediaCardParent document */
  upsert?: InputMaybe<CosmosSectionNewsMediaCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsMediaCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsMediaCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsMediaCardParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionNewsMediaCardParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionNewsMediaCardUpdateInput = {
  cards?: InputMaybe<CosmosElementNewsMediaCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionNewsMediaCardUpdateLocalizationsInput>;
};

export type CosmosSectionNewsMediaCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsMediaCardUpdateLocalizationInput = {
  data: CosmosSectionNewsMediaCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsMediaCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionNewsMediaCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNewsMediaCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionNewsMediaCardUpsertLocalizationInput>>;
};

export type CosmosSectionNewsMediaCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionNewsMediaCard component instances */
  create?: InputMaybe<Array<CosmosSectionNewsMediaCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionNewsMediaCard documents */
  delete?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionNewsMediaCard component instances */
  update?: InputMaybe<Array<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionNewsMediaCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionNewsMediaCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionNewsMediaCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionNewsMediaCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsMediaCardUpdateManyLocalizationInput = {
  data: CosmosSectionNewsMediaCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsMediaCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNewsMediaCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionNewsMediaCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionNewsMediaCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionNewsMediaCardWhereInput;
};

export type CosmosSectionNewsMediaCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionNewsMediaCard document */
  create?: InputMaybe<CosmosSectionNewsMediaCardCreateInput>;
  /** Delete currently connected CosmosSectionNewsMediaCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNewsMediaCard document */
  update?: InputMaybe<CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNewsMediaCard document */
  upsert?: InputMaybe<CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionNewsMediaCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNewsMediaCardWhereUniqueInput;
};

export type CosmosSectionNewsMediaCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionNewsMediaCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionNewsMediaCardWhereUniqueInput;
};

export type CosmosSectionNewsMediaCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionNewsMediaCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionNewsMediaCardUpdateInput;
};

export type CosmosSectionNewsMediaCardUpsertLocalizationInput = {
  create: CosmosSectionNewsMediaCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionNewsMediaCardUpdateLocalizationDataInput;
};

export type CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionNewsMediaCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNewsMediaCardWhereUniqueInput;
};

export type CosmosSectionNewsMediaCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionNewsMediaCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionNewsMediaCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionNewsMediaCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNewsMediaCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementNewsMediaCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionNewsMediaCard record uniquely */
export type CosmosSectionNewsMediaCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionNewsletterSignup = Entity & {
  __typename?: 'CosmosSectionNewsletterSignup';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  industriesRef?: Maybe<CosmosRefIndustryList>;
  industryPlaceholder?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionNewsletterSignup>;
  signUpLabel?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  successDescription?: Maybe<Scalars['String']['output']>;
  successTitle?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionNewsletterSignupIndustriesRefArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionNewsletterSignupLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionNewsletterSignupUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionNewsletterSignupConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionNewsletterSignupWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionNewsletterSignupConnection = {
  __typename?: 'CosmosSectionNewsletterSignupConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionNewsletterSignupEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionNewsletterSignupCreateInput = {
  industriesRef?: InputMaybe<CosmosRefIndustryListCreateOneInlineInput>;
  /** industryPlaceholder input for default locale (en) */
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionNewsletterSignupCreateLocalizationsInput>;
  /** signUpLabel input for default locale (en) */
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  /** successDescription input for default locale (en) */
  successDescription?: InputMaybe<Scalars['String']['input']>;
  /** successTitle input for default locale (en) */
  successTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNewsletterSignupCreateLocalizationDataInput = {
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  successDescription?: InputMaybe<Scalars['String']['input']>;
  successTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNewsletterSignupCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionNewsletterSignupCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsletterSignupCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionNewsletterSignupCreateLocalizationInput>>;
};

export type CosmosSectionNewsletterSignupCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionNewsletterSignup documents */
  create?: InputMaybe<Array<CosmosSectionNewsletterSignupCreateInput>>;
};

export type CosmosSectionNewsletterSignupCreateOneInlineInput = {
  /** Create and connect one CosmosSectionNewsletterSignup document */
  create?: InputMaybe<CosmosSectionNewsletterSignupCreateInput>;
};

export type CosmosSectionNewsletterSignupCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionNewsletterSignupCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionNewsletterSignupEdge = {
  __typename?: 'CosmosSectionNewsletterSignupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionNewsletterSignup;
};

/** Identifies documents */
export type CosmosSectionNewsletterSignupManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  industriesRef?: InputMaybe<CosmosRefIndustryListWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionNewsletterSignupOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IndustryPlaceholderAsc = 'industryPlaceholder_ASC',
  IndustryPlaceholderDesc = 'industryPlaceholder_DESC',
  SignUpLabelAsc = 'signUpLabel_ASC',
  SignUpLabelDesc = 'signUpLabel_DESC',
  SuccessDescriptionAsc = 'successDescription_ASC',
  SuccessDescriptionDesc = 'successDescription_DESC',
  SuccessTitleAsc = 'successTitle_ASC',
  SuccessTitleDesc = 'successTitle_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionNewsletterSignupParent = CosmosReferenceSection;

export type CosmosSectionNewsletterSignupParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionNewsletterSignupParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionNewsletterSignupParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNewsletterSignupParent documents */
  connect?: InputMaybe<Array<CosmosSectionNewsletterSignupParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionNewsletterSignupParent documents */
  create?: InputMaybe<Array<CosmosSectionNewsletterSignupParentCreateInput>>;
};

export type CosmosSectionNewsletterSignupParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionNewsletterSignupParent document */
  connect?: InputMaybe<CosmosSectionNewsletterSignupParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNewsletterSignupParent document */
  create?: InputMaybe<CosmosSectionNewsletterSignupParentCreateInput>;
};

export type CosmosSectionNewsletterSignupParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionNewsletterSignupParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNewsletterSignupParent documents */
  connect?: InputMaybe<Array<CosmosSectionNewsletterSignupParentConnectInput>>;
  /** Create and connect multiple CosmosSectionNewsletterSignupParent documents */
  create?: InputMaybe<Array<CosmosSectionNewsletterSignupParentCreateInput>>;
  /** Delete multiple CosmosSectionNewsletterSignupParent documents */
  delete?: InputMaybe<Array<CosmosSectionNewsletterSignupParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionNewsletterSignupParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionNewsletterSignupParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionNewsletterSignupParent documents */
  set?: InputMaybe<Array<CosmosSectionNewsletterSignupParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionNewsletterSignupParent documents */
  update?: InputMaybe<Array<CosmosSectionNewsletterSignupParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionNewsletterSignupParent documents */
  upsert?: InputMaybe<Array<CosmosSectionNewsletterSignupParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionNewsletterSignupParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionNewsletterSignupParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionNewsletterSignupParent document */
  connect?: InputMaybe<CosmosSectionNewsletterSignupParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNewsletterSignupParent document */
  create?: InputMaybe<CosmosSectionNewsletterSignupParentCreateInput>;
  /** Delete currently connected CosmosSectionNewsletterSignupParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionNewsletterSignupParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNewsletterSignupParent document */
  update?: InputMaybe<CosmosSectionNewsletterSignupParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNewsletterSignupParent document */
  upsert?: InputMaybe<CosmosSectionNewsletterSignupParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsletterSignupParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsletterSignupParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsletterSignupParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionNewsletterSignupParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionNewsletterSignupUpdateInput = {
  industriesRef?: InputMaybe<CosmosRefIndustryListUpdateOneInlineInput>;
  /** industryPlaceholder input for default locale (en) */
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionNewsletterSignupUpdateLocalizationsInput>;
  /** signUpLabel input for default locale (en) */
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  /** successDescription input for default locale (en) */
  successDescription?: InputMaybe<Scalars['String']['input']>;
  /** successTitle input for default locale (en) */
  successTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsletterSignupUpdateLocalizationDataInput = {
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  successDescription?: InputMaybe<Scalars['String']['input']>;
  successTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsletterSignupUpdateLocalizationInput = {
  data: CosmosSectionNewsletterSignupUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsletterSignupUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionNewsletterSignupCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNewsletterSignupUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionNewsletterSignupUpsertLocalizationInput>>;
};

export type CosmosSectionNewsletterSignupUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionNewsletterSignup component instances */
  create?: InputMaybe<Array<CosmosSectionNewsletterSignupCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionNewsletterSignup documents */
  delete?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereUniqueInput>>;
  /** Update multiple CosmosSectionNewsletterSignup component instances */
  update?: InputMaybe<Array<CosmosSectionNewsletterSignupUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionNewsletterSignup component instances */
  upsert?: InputMaybe<Array<CosmosSectionNewsletterSignupUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionNewsletterSignupUpdateManyInput = {
  /** industryPlaceholder input for default locale (en) */
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionNewsletterSignupUpdateManyLocalizationsInput>;
  /** signUpLabel input for default locale (en) */
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  /** successDescription input for default locale (en) */
  successDescription?: InputMaybe<Scalars['String']['input']>;
  /** successTitle input for default locale (en) */
  successTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsletterSignupUpdateManyLocalizationDataInput = {
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  successDescription?: InputMaybe<Scalars['String']['input']>;
  successTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionNewsletterSignupUpdateManyLocalizationInput = {
  data: CosmosSectionNewsletterSignupUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNewsletterSignupUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNewsletterSignupUpdateManyLocalizationInput>>;
};

export type CosmosSectionNewsletterSignupUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionNewsletterSignupUpdateManyInput;
  /** Document search */
  where: CosmosSectionNewsletterSignupWhereInput;
};

export type CosmosSectionNewsletterSignupUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionNewsletterSignup document */
  create?: InputMaybe<CosmosSectionNewsletterSignupCreateInput>;
  /** Delete currently connected CosmosSectionNewsletterSignup document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNewsletterSignup document */
  update?: InputMaybe<CosmosSectionNewsletterSignupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNewsletterSignup document */
  upsert?: InputMaybe<CosmosSectionNewsletterSignupUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNewsletterSignupUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionNewsletterSignupUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNewsletterSignupWhereUniqueInput;
};

export type CosmosSectionNewsletterSignupUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionNewsletterSignupUpdateInput;
  /** Unique document search */
  where: CosmosSectionNewsletterSignupWhereUniqueInput;
};

export type CosmosSectionNewsletterSignupUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionNewsletterSignupCreateInput;
  /** Update document if it exists */
  update: CosmosSectionNewsletterSignupUpdateInput;
};

export type CosmosSectionNewsletterSignupUpsertLocalizationInput = {
  create: CosmosSectionNewsletterSignupCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionNewsletterSignupUpdateLocalizationDataInput;
};

export type CosmosSectionNewsletterSignupUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionNewsletterSignupUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNewsletterSignupWhereUniqueInput;
};

export type CosmosSectionNewsletterSignupUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionNewsletterSignupUpsertInput;
  /** Unique document search */
  where: CosmosSectionNewsletterSignupWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionNewsletterSignupWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNewsletterSignupWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  industriesRef?: InputMaybe<CosmosRefIndustryListWhereInput>;
  industryPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  industryPlaceholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  industryPlaceholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  industryPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  industryPlaceholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  industryPlaceholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  industryPlaceholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  industryPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  industryPlaceholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  industryPlaceholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  signUpLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  signUpLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  signUpLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  signUpLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  signUpLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  signUpLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  signUpLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  signUpLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  signUpLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  signUpLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  successDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  successTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  successTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  successTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  successTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  successTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  successTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  successTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  successTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  successTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  successTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionNewsletterSignup record uniquely */
export type CosmosSectionNewsletterSignupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionNumberCallout = Entity & {
  __typename?: 'CosmosSectionNumberCallout';
  /** The primary image/video asset of the component. */
  asset?: Maybe<Asset>;
  buttons: Array<CosmosElementIconButton>;
  callouts: Array<CosmosElementNumberCallout>;
  config?: Maybe<CosmosConfigSection>;
  desc?: Maybe<Scalars['String']['output']>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Horizontally flip the image and content */
  flip?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<EdsIconsEnum>;
  iconGradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionNumberCallout>;
  /** System stage field */
  stage: Stage;
  /** If the Countdown variant is selected, this should be the time to count down to (in your browser's local time zone) */
  timeAndDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<RichText>;
  titleGradient?: Maybe<CosmosEnumEdsGradients>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Allows selection of a set of external data to be fetched to overwrite the numbers for both callouts. If left empty, no external data will be fetched and only the static data from Hygraph will be shown on the page. */
  variant?: Maybe<CosmosEnumNumberCalloutVariants>;
  /** Vertically center content within card */
  verticallyCenter?: Maybe<Scalars['Boolean']['output']>;
};


export type CosmosSectionNumberCalloutAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionNumberCalloutButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


export type CosmosSectionNumberCalloutCalloutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementNumberCalloutOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
};


export type CosmosSectionNumberCalloutConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionNumberCalloutLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionNumberCalloutUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionNumberCalloutConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionNumberCalloutWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionNumberCalloutConnection = {
  __typename?: 'CosmosSectionNumberCalloutConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionNumberCalloutEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionNumberCalloutCreateInput = {
  asset?: InputMaybe<AssetCreateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  callouts?: InputMaybe<CosmosElementNumberCalloutCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionNumberCalloutCreateLocalizationsInput>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionNumberCalloutCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionNumberCalloutCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionNumberCalloutCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNumberCalloutCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionNumberCalloutCreateLocalizationInput>>;
};

export type CosmosSectionNumberCalloutCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionNumberCallout documents */
  create?: InputMaybe<Array<CosmosSectionNumberCalloutCreateInput>>;
};

export type CosmosSectionNumberCalloutCreateOneInlineInput = {
  /** Create and connect one CosmosSectionNumberCallout document */
  create?: InputMaybe<CosmosSectionNumberCalloutCreateInput>;
};

export type CosmosSectionNumberCalloutCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionNumberCalloutCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionNumberCalloutEdge = {
  __typename?: 'CosmosSectionNumberCalloutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionNumberCallout;
};

/** Identifies documents */
export type CosmosSectionNumberCalloutManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNumberCalloutWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNumberCalloutWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNumberCalloutWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  callouts_every?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
  callouts_none?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
  callouts_some?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  timeAndDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  timeAndDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  timeAndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  timeAndDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  timeAndDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  timeAndDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  timeAndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  titleGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  titleGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumNumberCalloutVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumNumberCalloutVariants>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CosmosSectionNumberCalloutOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  FlipAsc = 'flip_ASC',
  FlipDesc = 'flip_DESC',
  IconGradientAsc = 'iconGradient_ASC',
  IconGradientDesc = 'iconGradient_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TimeAndDateAsc = 'timeAndDate_ASC',
  TimeAndDateDesc = 'timeAndDate_DESC',
  TitleGradientAsc = 'titleGradient_ASC',
  TitleGradientDesc = 'titleGradient_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  VerticallyCenterAsc = 'verticallyCenter_ASC',
  VerticallyCenterDesc = 'verticallyCenter_DESC'
}

export type CosmosSectionNumberCalloutParent = CosmosReferenceSection;

export type CosmosSectionNumberCalloutParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionNumberCalloutParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionNumberCalloutParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNumberCalloutParent documents */
  connect?: InputMaybe<Array<CosmosSectionNumberCalloutParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionNumberCalloutParent documents */
  create?: InputMaybe<Array<CosmosSectionNumberCalloutParentCreateInput>>;
};

export type CosmosSectionNumberCalloutParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionNumberCalloutParent document */
  connect?: InputMaybe<CosmosSectionNumberCalloutParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNumberCalloutParent document */
  create?: InputMaybe<CosmosSectionNumberCalloutParentCreateInput>;
};

export type CosmosSectionNumberCalloutParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionNumberCalloutParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionNumberCalloutParent documents */
  connect?: InputMaybe<Array<CosmosSectionNumberCalloutParentConnectInput>>;
  /** Create and connect multiple CosmosSectionNumberCalloutParent documents */
  create?: InputMaybe<Array<CosmosSectionNumberCalloutParentCreateInput>>;
  /** Delete multiple CosmosSectionNumberCalloutParent documents */
  delete?: InputMaybe<Array<CosmosSectionNumberCalloutParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionNumberCalloutParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionNumberCalloutParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionNumberCalloutParent documents */
  set?: InputMaybe<Array<CosmosSectionNumberCalloutParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionNumberCalloutParent documents */
  update?: InputMaybe<Array<CosmosSectionNumberCalloutParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionNumberCalloutParent documents */
  upsert?: InputMaybe<Array<CosmosSectionNumberCalloutParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionNumberCalloutParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionNumberCalloutParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionNumberCalloutParent document */
  connect?: InputMaybe<CosmosSectionNumberCalloutParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionNumberCalloutParent document */
  create?: InputMaybe<CosmosSectionNumberCalloutParentCreateInput>;
  /** Delete currently connected CosmosSectionNumberCalloutParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionNumberCalloutParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNumberCalloutParent document */
  update?: InputMaybe<CosmosSectionNumberCalloutParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNumberCalloutParent document */
  upsert?: InputMaybe<CosmosSectionNumberCalloutParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNumberCalloutParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionNumberCalloutParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNumberCalloutParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionNumberCalloutParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionNumberCalloutUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  callouts?: InputMaybe<CosmosElementNumberCalloutUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionNumberCalloutUpdateLocalizationsInput>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  variant?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionNumberCalloutUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionNumberCalloutUpdateLocalizationInput = {
  data: CosmosSectionNumberCalloutUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNumberCalloutUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionNumberCalloutCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNumberCalloutUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionNumberCalloutUpsertLocalizationInput>>;
};

export type CosmosSectionNumberCalloutUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionNumberCallout component instances */
  create?: InputMaybe<Array<CosmosSectionNumberCalloutCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionNumberCallout documents */
  delete?: InputMaybe<Array<CosmosSectionNumberCalloutWhereUniqueInput>>;
  /** Update multiple CosmosSectionNumberCallout component instances */
  update?: InputMaybe<Array<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionNumberCallout component instances */
  upsert?: InputMaybe<Array<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionNumberCalloutUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionNumberCalloutUpdateManyLocalizationsInput>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  variant?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionNumberCalloutUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionNumberCalloutUpdateManyLocalizationInput = {
  data: CosmosSectionNumberCalloutUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionNumberCalloutUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionNumberCalloutUpdateManyLocalizationInput>>;
};

export type CosmosSectionNumberCalloutUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionNumberCalloutUpdateManyInput;
  /** Document search */
  where: CosmosSectionNumberCalloutWhereInput;
};

export type CosmosSectionNumberCalloutUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionNumberCallout document */
  create?: InputMaybe<CosmosSectionNumberCalloutCreateInput>;
  /** Delete currently connected CosmosSectionNumberCallout document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionNumberCallout document */
  update?: InputMaybe<CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionNumberCallout document */
  upsert?: InputMaybe<CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionNumberCalloutUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNumberCalloutWhereUniqueInput;
};

export type CosmosSectionNumberCalloutUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionNumberCalloutUpdateInput;
  /** Unique document search */
  where: CosmosSectionNumberCalloutWhereUniqueInput;
};

export type CosmosSectionNumberCalloutUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionNumberCalloutCreateInput;
  /** Update document if it exists */
  update: CosmosSectionNumberCalloutUpdateInput;
};

export type CosmosSectionNumberCalloutUpsertLocalizationInput = {
  create: CosmosSectionNumberCalloutCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionNumberCalloutUpdateLocalizationDataInput;
};

export type CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionNumberCalloutUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionNumberCalloutWhereUniqueInput;
};

export type CosmosSectionNumberCalloutUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionNumberCalloutUpsertInput;
  /** Unique document search */
  where: CosmosSectionNumberCalloutWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionNumberCalloutWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionNumberCalloutWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionNumberCalloutWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionNumberCalloutWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  callouts_every?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
  callouts_none?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
  callouts_some?: InputMaybe<CosmosElementNumberCalloutWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  flip_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<EdsIconsEnum>;
  iconGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  iconGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  iconGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIconsEnum>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIconsEnum>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  timeAndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  timeAndDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  timeAndDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  timeAndDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  timeAndDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  timeAndDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  timeAndDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  timeAndDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  titleGradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  titleGradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleGradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  titleGradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumNumberCalloutVariants>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumNumberCalloutVariants>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumNumberCalloutVariants>>>;
  verticallyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  verticallyCenter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References CosmosSectionNumberCallout record uniquely */
export type CosmosSectionNumberCalloutWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionPluginListTable = Entity & {
  __typename?: 'CosmosSectionPluginListTable';
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  items: Array<CosmosElementPluginListItem>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionPluginListTable>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionPluginListTableConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionPluginListTableItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementPluginListItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementPluginListItemWhereInput>;
};


export type CosmosSectionPluginListTableLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionPluginListTableUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionPluginListTableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionPluginListTableWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionPluginListTableConnection = {
  __typename?: 'CosmosSectionPluginListTableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionPluginListTableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionPluginListTableCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementPluginListItemCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionPluginListTableCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionPluginListTableCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionPluginListTableCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionPluginListTableCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionPluginListTableCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionPluginListTableCreateLocalizationInput>>;
};

export type CosmosSectionPluginListTableCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionPluginListTable documents */
  create?: InputMaybe<Array<CosmosSectionPluginListTableCreateInput>>;
};

export type CosmosSectionPluginListTableCreateOneInlineInput = {
  /** Create and connect one CosmosSectionPluginListTable document */
  create?: InputMaybe<CosmosSectionPluginListTableCreateInput>;
};

export type CosmosSectionPluginListTableCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionPluginListTableCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionPluginListTableEdge = {
  __typename?: 'CosmosSectionPluginListTableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionPluginListTable;
};

/** Identifies documents */
export type CosmosSectionPluginListTableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionPluginListTableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionPluginListTableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionPluginListTableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  items_none?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  items_some?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionPluginListTableOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionPluginListTableParent = CosmosReferenceSection;

export type CosmosSectionPluginListTableParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionPluginListTableParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionPluginListTableParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionPluginListTableParent documents */
  connect?: InputMaybe<Array<CosmosSectionPluginListTableParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionPluginListTableParent documents */
  create?: InputMaybe<Array<CosmosSectionPluginListTableParentCreateInput>>;
};

export type CosmosSectionPluginListTableParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionPluginListTableParent document */
  connect?: InputMaybe<CosmosSectionPluginListTableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionPluginListTableParent document */
  create?: InputMaybe<CosmosSectionPluginListTableParentCreateInput>;
};

export type CosmosSectionPluginListTableParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionPluginListTableParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionPluginListTableParent documents */
  connect?: InputMaybe<Array<CosmosSectionPluginListTableParentConnectInput>>;
  /** Create and connect multiple CosmosSectionPluginListTableParent documents */
  create?: InputMaybe<Array<CosmosSectionPluginListTableParentCreateInput>>;
  /** Delete multiple CosmosSectionPluginListTableParent documents */
  delete?: InputMaybe<Array<CosmosSectionPluginListTableParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionPluginListTableParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionPluginListTableParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionPluginListTableParent documents */
  set?: InputMaybe<Array<CosmosSectionPluginListTableParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionPluginListTableParent documents */
  update?: InputMaybe<Array<CosmosSectionPluginListTableParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionPluginListTableParent documents */
  upsert?: InputMaybe<Array<CosmosSectionPluginListTableParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionPluginListTableParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionPluginListTableParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionPluginListTableParent document */
  connect?: InputMaybe<CosmosSectionPluginListTableParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionPluginListTableParent document */
  create?: InputMaybe<CosmosSectionPluginListTableParentCreateInput>;
  /** Delete currently connected CosmosSectionPluginListTableParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionPluginListTableParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionPluginListTableParent document */
  update?: InputMaybe<CosmosSectionPluginListTableParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionPluginListTableParent document */
  upsert?: InputMaybe<CosmosSectionPluginListTableParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionPluginListTableParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionPluginListTableParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionPluginListTableParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionPluginListTableParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionPluginListTableUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<CosmosElementPluginListItemUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionPluginListTableUpdateLocalizationsInput>;
};

export type CosmosSectionPluginListTableUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionPluginListTableUpdateLocalizationInput = {
  data: CosmosSectionPluginListTableUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionPluginListTableUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionPluginListTableCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionPluginListTableUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionPluginListTableUpsertLocalizationInput>>;
};

export type CosmosSectionPluginListTableUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionPluginListTable component instances */
  create?: InputMaybe<Array<CosmosSectionPluginListTableCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionPluginListTable documents */
  delete?: InputMaybe<Array<CosmosSectionPluginListTableWhereUniqueInput>>;
  /** Update multiple CosmosSectionPluginListTable component instances */
  update?: InputMaybe<Array<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionPluginListTable component instances */
  upsert?: InputMaybe<Array<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionPluginListTableUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionPluginListTableUpdateManyLocalizationsInput>;
};

export type CosmosSectionPluginListTableUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionPluginListTableUpdateManyLocalizationInput = {
  data: CosmosSectionPluginListTableUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionPluginListTableUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionPluginListTableUpdateManyLocalizationInput>>;
};

export type CosmosSectionPluginListTableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionPluginListTableUpdateManyInput;
  /** Document search */
  where: CosmosSectionPluginListTableWhereInput;
};

export type CosmosSectionPluginListTableUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionPluginListTable document */
  create?: InputMaybe<CosmosSectionPluginListTableCreateInput>;
  /** Delete currently connected CosmosSectionPluginListTable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionPluginListTable document */
  update?: InputMaybe<CosmosSectionPluginListTableUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionPluginListTable document */
  upsert?: InputMaybe<CosmosSectionPluginListTableUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionPluginListTableUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionPluginListTableUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionPluginListTableWhereUniqueInput;
};

export type CosmosSectionPluginListTableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionPluginListTableUpdateInput;
  /** Unique document search */
  where: CosmosSectionPluginListTableWhereUniqueInput;
};

export type CosmosSectionPluginListTableUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionPluginListTableCreateInput;
  /** Update document if it exists */
  update: CosmosSectionPluginListTableUpdateInput;
};

export type CosmosSectionPluginListTableUpsertLocalizationInput = {
  create: CosmosSectionPluginListTableCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionPluginListTableUpdateLocalizationDataInput;
};

export type CosmosSectionPluginListTableUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionPluginListTableUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionPluginListTableWhereUniqueInput;
};

export type CosmosSectionPluginListTableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionPluginListTableUpsertInput;
  /** Unique document search */
  where: CosmosSectionPluginListTableWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionPluginListTableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionPluginListTableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionPluginListTableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionPluginListTableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  items_none?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  items_some?: InputMaybe<CosmosElementPluginListItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionPluginListTable record uniquely */
export type CosmosSectionPluginListTableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionQuote = Entity & {
  __typename?: 'CosmosSectionQuote';
  /** Configuration for the section */
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionQuote>;
  /** Up to 20 quotes can be rendered here */
  quotes: Array<CosmosElementQuote>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionQuoteConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionQuoteLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionQuoteQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementQuoteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementQuoteWhereInput>;
};


export type CosmosSectionQuoteUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionQuoteConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionQuoteWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionQuoteConnection = {
  __typename?: 'CosmosSectionQuoteConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionQuoteEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionQuoteCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionQuoteCreateLocalizationsInput>;
  quotes?: InputMaybe<CosmosElementQuoteCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionQuoteCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionQuoteCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionQuoteCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionQuoteCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionQuoteCreateLocalizationInput>>;
};

export type CosmosSectionQuoteCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionQuote documents */
  create?: InputMaybe<Array<CosmosSectionQuoteCreateInput>>;
};

export type CosmosSectionQuoteCreateOneInlineInput = {
  /** Create and connect one CosmosSectionQuote document */
  create?: InputMaybe<CosmosSectionQuoteCreateInput>;
};

export type CosmosSectionQuoteCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionQuoteCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionQuoteEdge = {
  __typename?: 'CosmosSectionQuoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionQuote;
};

/** Identifies documents */
export type CosmosSectionQuoteManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionQuoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionQuoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionQuoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  quotes_every?: InputMaybe<CosmosElementQuoteWhereInput>;
  quotes_none?: InputMaybe<CosmosElementQuoteWhereInput>;
  quotes_some?: InputMaybe<CosmosElementQuoteWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionQuoteOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionQuoteParent = CosmosReferenceSection;

export type CosmosSectionQuoteParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionQuoteParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionQuoteParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionQuoteParent documents */
  connect?: InputMaybe<Array<CosmosSectionQuoteParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionQuoteParent documents */
  create?: InputMaybe<Array<CosmosSectionQuoteParentCreateInput>>;
};

export type CosmosSectionQuoteParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionQuoteParent document */
  connect?: InputMaybe<CosmosSectionQuoteParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionQuoteParent document */
  create?: InputMaybe<CosmosSectionQuoteParentCreateInput>;
};

export type CosmosSectionQuoteParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionQuoteParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionQuoteParent documents */
  connect?: InputMaybe<Array<CosmosSectionQuoteParentConnectInput>>;
  /** Create and connect multiple CosmosSectionQuoteParent documents */
  create?: InputMaybe<Array<CosmosSectionQuoteParentCreateInput>>;
  /** Delete multiple CosmosSectionQuoteParent documents */
  delete?: InputMaybe<Array<CosmosSectionQuoteParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionQuoteParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionQuoteParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionQuoteParent documents */
  set?: InputMaybe<Array<CosmosSectionQuoteParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionQuoteParent documents */
  update?: InputMaybe<Array<CosmosSectionQuoteParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionQuoteParent documents */
  upsert?: InputMaybe<Array<CosmosSectionQuoteParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionQuoteParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionQuoteParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionQuoteParent document */
  connect?: InputMaybe<CosmosSectionQuoteParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionQuoteParent document */
  create?: InputMaybe<CosmosSectionQuoteParentCreateInput>;
  /** Delete currently connected CosmosSectionQuoteParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionQuoteParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionQuoteParent document */
  update?: InputMaybe<CosmosSectionQuoteParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionQuoteParent document */
  upsert?: InputMaybe<CosmosSectionQuoteParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionQuoteParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionQuoteParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionQuoteParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionQuoteParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionQuoteUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionQuoteUpdateLocalizationsInput>;
  quotes?: InputMaybe<CosmosElementQuoteUpdateManyInlineInput>;
};

export type CosmosSectionQuoteUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionQuoteUpdateLocalizationInput = {
  data: CosmosSectionQuoteUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionQuoteUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionQuoteCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionQuoteUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionQuoteUpsertLocalizationInput>>;
};

export type CosmosSectionQuoteUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionQuote component instances */
  create?: InputMaybe<Array<CosmosSectionQuoteCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionQuote documents */
  delete?: InputMaybe<Array<CosmosSectionQuoteWhereUniqueInput>>;
  /** Update multiple CosmosSectionQuote component instances */
  update?: InputMaybe<Array<CosmosSectionQuoteUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionQuote component instances */
  upsert?: InputMaybe<Array<CosmosSectionQuoteUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionQuoteUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionQuoteUpdateManyLocalizationsInput>;
};

export type CosmosSectionQuoteUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionQuoteUpdateManyLocalizationInput = {
  data: CosmosSectionQuoteUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionQuoteUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionQuoteUpdateManyLocalizationInput>>;
};

export type CosmosSectionQuoteUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionQuoteUpdateManyInput;
  /** Document search */
  where: CosmosSectionQuoteWhereInput;
};

export type CosmosSectionQuoteUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionQuote document */
  create?: InputMaybe<CosmosSectionQuoteCreateInput>;
  /** Delete currently connected CosmosSectionQuote document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionQuote document */
  update?: InputMaybe<CosmosSectionQuoteUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionQuote document */
  upsert?: InputMaybe<CosmosSectionQuoteUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionQuoteUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionQuoteUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionQuoteWhereUniqueInput;
};

export type CosmosSectionQuoteUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionQuoteUpdateInput;
  /** Unique document search */
  where: CosmosSectionQuoteWhereUniqueInput;
};

export type CosmosSectionQuoteUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionQuoteCreateInput;
  /** Update document if it exists */
  update: CosmosSectionQuoteUpdateInput;
};

export type CosmosSectionQuoteUpsertLocalizationInput = {
  create: CosmosSectionQuoteCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionQuoteUpdateLocalizationDataInput;
};

export type CosmosSectionQuoteUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionQuoteUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionQuoteWhereUniqueInput;
};

export type CosmosSectionQuoteUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionQuoteUpsertInput;
  /** Unique document search */
  where: CosmosSectionQuoteWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionQuoteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionQuoteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionQuoteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionQuoteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  quotes_every?: InputMaybe<CosmosElementQuoteWhereInput>;
  quotes_none?: InputMaybe<CosmosElementQuoteWhereInput>;
  quotes_some?: InputMaybe<CosmosElementQuoteWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionQuote record uniquely */
export type CosmosSectionQuoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionResellersSearch = Entity & {
  __typename?: 'CosmosSectionResellersSearch';
  blurredBackgroundImage?: Maybe<Asset>;
  /** Because of HG UI limitation one cards list should have only 50 items (all cards[X] fields will be combined into one list and sorted) */
  cards: Array<CosmosElementResellerCard>;
  /** Because of HG UI limitation one cards list should have only 50 items (all cards[X] fields will be combined into one list and sorted) */
  cards2: Array<CosmosElementResellerCard>;
  /** Because of HG UI limitation one cards list should have only 50 items (all cards[X] fields will be combined into one list and sorted) */
  cards3: Array<CosmosElementResellerCard>;
  /** Because of HG UI limitation one cards list should have only 50 items (all cards[X] fields will be combined into one list and sorted) */
  cards4: Array<CosmosElementResellerCard>;
  config?: Maybe<CosmosConfigSection>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionResellersSearch>;
  locationLinkTemplate?: Maybe<Scalars['String']['output']>;
  noResultsLabel?: Maybe<Scalars['String']['output']>;
  searchLabel?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Label for "View location" button */
  viewLocationLabel?: Maybe<Scalars['String']['output']>;
};


export type CosmosSectionResellersSearchBlurredBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CosmosSectionResellersSearchCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementResellerCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementResellerCardWhereInput>;
};


export type CosmosSectionResellersSearchCards2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementResellerCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementResellerCardWhereInput>;
};


export type CosmosSectionResellersSearchCards3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementResellerCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementResellerCardWhereInput>;
};


export type CosmosSectionResellersSearchCards4Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementResellerCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementResellerCardWhereInput>;
};


export type CosmosSectionResellersSearchConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionResellersSearchLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionResellersSearchUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionResellersSearchConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionResellersSearchWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionResellersSearchConnection = {
  __typename?: 'CosmosSectionResellersSearchConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionResellersSearchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionResellersSearchCreateInput = {
  blurredBackgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  cards?: InputMaybe<CosmosElementResellerCardCreateManyInlineInput>;
  cards2?: InputMaybe<CosmosElementResellerCardCreateManyInlineInput>;
  cards3?: InputMaybe<CosmosElementResellerCardCreateManyInlineInput>;
  cards4?: InputMaybe<CosmosElementResellerCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionResellersSearchCreateLocalizationsInput>;
  /** locationLinkTemplate input for default locale (en) */
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchLabel input for default locale (en) */
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** viewLocationLabel input for default locale (en) */
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionResellersSearchCreateLocalizationDataInput = {
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionResellersSearchCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionResellersSearchCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionResellersSearchCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionResellersSearchCreateLocalizationInput>>;
};

export type CosmosSectionResellersSearchCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionResellersSearch documents */
  create?: InputMaybe<Array<CosmosSectionResellersSearchCreateInput>>;
};

export type CosmosSectionResellersSearchCreateOneInlineInput = {
  /** Create and connect one CosmosSectionResellersSearch document */
  create?: InputMaybe<CosmosSectionResellersSearchCreateInput>;
};

export type CosmosSectionResellersSearchCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionResellersSearchCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionResellersSearchEdge = {
  __typename?: 'CosmosSectionResellersSearchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionResellersSearch;
};

/** Identifies documents */
export type CosmosSectionResellersSearchManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionResellersSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionResellersSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionResellersSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredBackgroundImage?: InputMaybe<AssetWhereInput>;
  cards2_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards2_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards2_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards3_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards3_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards3_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards4_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards4_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards4_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionResellersSearchOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LocationLinkTemplateAsc = 'locationLinkTemplate_ASC',
  LocationLinkTemplateDesc = 'locationLinkTemplate_DESC',
  NoResultsLabelAsc = 'noResultsLabel_ASC',
  NoResultsLabelDesc = 'noResultsLabel_DESC',
  SearchLabelAsc = 'searchLabel_ASC',
  SearchLabelDesc = 'searchLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  ViewLocationLabelAsc = 'viewLocationLabel_ASC',
  ViewLocationLabelDesc = 'viewLocationLabel_DESC'
}

export type CosmosSectionResellersSearchParent = CosmosReferenceSection;

export type CosmosSectionResellersSearchParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionResellersSearchParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionResellersSearchParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionResellersSearchParent documents */
  connect?: InputMaybe<Array<CosmosSectionResellersSearchParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionResellersSearchParent documents */
  create?: InputMaybe<Array<CosmosSectionResellersSearchParentCreateInput>>;
};

export type CosmosSectionResellersSearchParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionResellersSearchParent document */
  connect?: InputMaybe<CosmosSectionResellersSearchParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionResellersSearchParent document */
  create?: InputMaybe<CosmosSectionResellersSearchParentCreateInput>;
};

export type CosmosSectionResellersSearchParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionResellersSearchParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionResellersSearchParent documents */
  connect?: InputMaybe<Array<CosmosSectionResellersSearchParentConnectInput>>;
  /** Create and connect multiple CosmosSectionResellersSearchParent documents */
  create?: InputMaybe<Array<CosmosSectionResellersSearchParentCreateInput>>;
  /** Delete multiple CosmosSectionResellersSearchParent documents */
  delete?: InputMaybe<Array<CosmosSectionResellersSearchParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionResellersSearchParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionResellersSearchParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionResellersSearchParent documents */
  set?: InputMaybe<Array<CosmosSectionResellersSearchParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionResellersSearchParent documents */
  update?: InputMaybe<Array<CosmosSectionResellersSearchParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionResellersSearchParent documents */
  upsert?: InputMaybe<Array<CosmosSectionResellersSearchParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionResellersSearchParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionResellersSearchParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionResellersSearchParent document */
  connect?: InputMaybe<CosmosSectionResellersSearchParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionResellersSearchParent document */
  create?: InputMaybe<CosmosSectionResellersSearchParentCreateInput>;
  /** Delete currently connected CosmosSectionResellersSearchParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionResellersSearchParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionResellersSearchParent document */
  update?: InputMaybe<CosmosSectionResellersSearchParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionResellersSearchParent document */
  upsert?: InputMaybe<CosmosSectionResellersSearchParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionResellersSearchParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionResellersSearchParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionResellersSearchParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionResellersSearchParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionResellersSearchUpdateInput = {
  blurredBackgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  cards?: InputMaybe<CosmosElementResellerCardUpdateManyInlineInput>;
  cards2?: InputMaybe<CosmosElementResellerCardUpdateManyInlineInput>;
  cards3?: InputMaybe<CosmosElementResellerCardUpdateManyInlineInput>;
  cards4?: InputMaybe<CosmosElementResellerCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionResellersSearchUpdateLocalizationsInput>;
  /** locationLinkTemplate input for default locale (en) */
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchLabel input for default locale (en) */
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  /** viewLocationLabel input for default locale (en) */
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionResellersSearchUpdateLocalizationDataInput = {
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionResellersSearchUpdateLocalizationInput = {
  data: CosmosSectionResellersSearchUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionResellersSearchUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionResellersSearchCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionResellersSearchUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionResellersSearchUpsertLocalizationInput>>;
};

export type CosmosSectionResellersSearchUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionResellersSearch component instances */
  create?: InputMaybe<Array<CosmosSectionResellersSearchCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionResellersSearch documents */
  delete?: InputMaybe<Array<CosmosSectionResellersSearchWhereUniqueInput>>;
  /** Update multiple CosmosSectionResellersSearch component instances */
  update?: InputMaybe<Array<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionResellersSearch component instances */
  upsert?: InputMaybe<Array<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionResellersSearchUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionResellersSearchUpdateManyLocalizationsInput>;
  /** locationLinkTemplate input for default locale (en) */
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  /** noResultsLabel input for default locale (en) */
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** searchLabel input for default locale (en) */
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  /** viewLocationLabel input for default locale (en) */
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionResellersSearchUpdateManyLocalizationDataInput = {
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionResellersSearchUpdateManyLocalizationInput = {
  data: CosmosSectionResellersSearchUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionResellersSearchUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionResellersSearchUpdateManyLocalizationInput>>;
};

export type CosmosSectionResellersSearchUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionResellersSearchUpdateManyInput;
  /** Document search */
  where: CosmosSectionResellersSearchWhereInput;
};

export type CosmosSectionResellersSearchUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionResellersSearch document */
  create?: InputMaybe<CosmosSectionResellersSearchCreateInput>;
  /** Delete currently connected CosmosSectionResellersSearch document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionResellersSearch document */
  update?: InputMaybe<CosmosSectionResellersSearchUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionResellersSearch document */
  upsert?: InputMaybe<CosmosSectionResellersSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionResellersSearchUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionResellersSearchUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionResellersSearchWhereUniqueInput;
};

export type CosmosSectionResellersSearchUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionResellersSearchUpdateInput;
  /** Unique document search */
  where: CosmosSectionResellersSearchWhereUniqueInput;
};

export type CosmosSectionResellersSearchUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionResellersSearchCreateInput;
  /** Update document if it exists */
  update: CosmosSectionResellersSearchUpdateInput;
};

export type CosmosSectionResellersSearchUpsertLocalizationInput = {
  create: CosmosSectionResellersSearchCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionResellersSearchUpdateLocalizationDataInput;
};

export type CosmosSectionResellersSearchUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionResellersSearchUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionResellersSearchWhereUniqueInput;
};

export type CosmosSectionResellersSearchUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionResellersSearchUpsertInput;
  /** Unique document search */
  where: CosmosSectionResellersSearchWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionResellersSearchWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionResellersSearchWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionResellersSearchWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionResellersSearchWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  blurredBackgroundImage?: InputMaybe<AssetWhereInput>;
  cards2_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards2_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards2_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards3_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards3_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards3_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards4_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards4_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards4_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards_every?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementResellerCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementResellerCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  locationLinkTemplate_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  locationLinkTemplate_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  locationLinkTemplate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  locationLinkTemplate_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  locationLinkTemplate_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  locationLinkTemplate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  locationLinkTemplate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  locationLinkTemplate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  locationLinkTemplate_starts_with?: InputMaybe<Scalars['String']['input']>;
  noResultsLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  noResultsLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  noResultsLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  noResultsLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  noResultsLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  noResultsLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  noResultsLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  noResultsLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  noResultsLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  noResultsLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  searchLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  searchLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  searchLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  searchLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  searchLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  searchLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  searchLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  searchLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  searchLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  viewLocationLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  viewLocationLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  viewLocationLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  viewLocationLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  viewLocationLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  viewLocationLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  viewLocationLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  viewLocationLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  viewLocationLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  viewLocationLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** References CosmosSectionResellersSearch record uniquely */
export type CosmosSectionResellersSearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionRichText = Entity & {
  __typename?: 'CosmosSectionRichText';
  buttons: Array<CosmosElementButton>;
  /** Center the text container */
  centered?: Maybe<Scalars['Boolean']['output']>;
  /** Center the buttons */
  centeredButton?: Maybe<Scalars['Boolean']['output']>;
  config?: Maybe<CosmosConfigSection>;
  content?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionRichText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Wider max-width for the container */
  wide?: Maybe<Scalars['Boolean']['output']>;
};


export type CosmosSectionRichTextButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementButtonWhereInput>;
};


export type CosmosSectionRichTextConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionRichTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionRichTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionRichTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionRichTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionRichTextConnection = {
  __typename?: 'CosmosSectionRichTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionRichTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionRichTextCreateInput = {
  buttons?: InputMaybe<CosmosElementButtonCreateManyInlineInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionRichTextCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionRichTextCreateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionRichTextCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionRichTextCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionRichTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionRichTextCreateLocalizationInput>>;
};

export type CosmosSectionRichTextCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionRichText documents */
  create?: InputMaybe<Array<CosmosSectionRichTextCreateInput>>;
};

export type CosmosSectionRichTextCreateOneInlineInput = {
  /** Create and connect one CosmosSectionRichText document */
  create?: InputMaybe<CosmosSectionRichTextCreateInput>;
};

export type CosmosSectionRichTextCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionRichTextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionRichTextEdge = {
  __typename?: 'CosmosSectionRichTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionRichText;
};

/** Identifies documents */
export type CosmosSectionRichTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionRichTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionRichTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionRichTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  wide_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CosmosSectionRichTextOrderByInput {
  CenteredButtonAsc = 'centeredButton_ASC',
  CenteredButtonDesc = 'centeredButton_DESC',
  CenteredAsc = 'centered_ASC',
  CenteredDesc = 'centered_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WideAsc = 'wide_ASC',
  WideDesc = 'wide_DESC'
}

export type CosmosSectionRichTextParent = CosmosReferenceSection;

export type CosmosSectionRichTextParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionRichTextParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionRichTextParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionRichTextParent documents */
  connect?: InputMaybe<Array<CosmosSectionRichTextParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionRichTextParent documents */
  create?: InputMaybe<Array<CosmosSectionRichTextParentCreateInput>>;
};

export type CosmosSectionRichTextParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionRichTextParent document */
  connect?: InputMaybe<CosmosSectionRichTextParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionRichTextParent document */
  create?: InputMaybe<CosmosSectionRichTextParentCreateInput>;
};

export type CosmosSectionRichTextParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionRichTextParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionRichTextParent documents */
  connect?: InputMaybe<Array<CosmosSectionRichTextParentConnectInput>>;
  /** Create and connect multiple CosmosSectionRichTextParent documents */
  create?: InputMaybe<Array<CosmosSectionRichTextParentCreateInput>>;
  /** Delete multiple CosmosSectionRichTextParent documents */
  delete?: InputMaybe<Array<CosmosSectionRichTextParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionRichTextParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionRichTextParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionRichTextParent documents */
  set?: InputMaybe<Array<CosmosSectionRichTextParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionRichTextParent documents */
  update?: InputMaybe<Array<CosmosSectionRichTextParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionRichTextParent documents */
  upsert?: InputMaybe<Array<CosmosSectionRichTextParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionRichTextParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionRichTextParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionRichTextParent document */
  connect?: InputMaybe<CosmosSectionRichTextParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionRichTextParent document */
  create?: InputMaybe<CosmosSectionRichTextParentCreateInput>;
  /** Delete currently connected CosmosSectionRichTextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionRichTextParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionRichTextParent document */
  update?: InputMaybe<CosmosSectionRichTextParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionRichTextParent document */
  upsert?: InputMaybe<CosmosSectionRichTextParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionRichTextParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionRichTextParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionRichTextParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionRichTextParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionRichTextUpdateInput = {
  buttons?: InputMaybe<CosmosElementButtonUpdateManyInlineInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionRichTextUpdateLocalizationsInput>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionRichTextUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionRichTextUpdateLocalizationInput = {
  data: CosmosSectionRichTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionRichTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionRichTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionRichTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionRichTextUpsertLocalizationInput>>;
};

export type CosmosSectionRichTextUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionRichText component instances */
  create?: InputMaybe<Array<CosmosSectionRichTextCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionRichText documents */
  delete?: InputMaybe<Array<CosmosSectionRichTextWhereUniqueInput>>;
  /** Update multiple CosmosSectionRichText component instances */
  update?: InputMaybe<Array<CosmosSectionRichTextUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionRichText component instances */
  upsert?: InputMaybe<Array<CosmosSectionRichTextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionRichTextUpdateManyInput = {
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionRichTextUpdateManyLocalizationsInput>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CosmosSectionRichTextUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionRichTextUpdateManyLocalizationInput = {
  data: CosmosSectionRichTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionRichTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionRichTextUpdateManyLocalizationInput>>;
};

export type CosmosSectionRichTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionRichTextUpdateManyInput;
  /** Document search */
  where: CosmosSectionRichTextWhereInput;
};

export type CosmosSectionRichTextUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionRichText document */
  create?: InputMaybe<CosmosSectionRichTextCreateInput>;
  /** Delete currently connected CosmosSectionRichText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionRichText document */
  update?: InputMaybe<CosmosSectionRichTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionRichText document */
  upsert?: InputMaybe<CosmosSectionRichTextUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionRichTextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionRichTextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionRichTextWhereUniqueInput;
};

export type CosmosSectionRichTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionRichTextUpdateInput;
  /** Unique document search */
  where: CosmosSectionRichTextWhereUniqueInput;
};

export type CosmosSectionRichTextUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionRichTextCreateInput;
  /** Update document if it exists */
  update: CosmosSectionRichTextUpdateInput;
};

export type CosmosSectionRichTextUpsertLocalizationInput = {
  create: CosmosSectionRichTextCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionRichTextUpdateLocalizationDataInput;
};

export type CosmosSectionRichTextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionRichTextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionRichTextWhereUniqueInput;
};

export type CosmosSectionRichTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionRichTextUpsertInput;
  /** Unique document search */
  where: CosmosSectionRichTextWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionRichTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionRichTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionRichTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionRichTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementButtonWhereInput>;
  centered?: InputMaybe<Scalars['Boolean']['input']>;
  centeredButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centeredButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  centered_not?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  wide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  wide_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References CosmosSectionRichText record uniquely */
export type CosmosSectionRichTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Section uses Section Config Heading for Title, Desc, Buttons and Gradient. */
export type CosmosSectionSimpleCta = Entity & {
  __typename?: 'CosmosSectionSimpleCta';
  buttons: Array<CosmosElementIconButton>;
  desc?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  gradient?: Maybe<CosmosEnumEdsGradients>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionSimpleCta>;
  /** System stage field */
  stage: Stage;
  style?: Maybe<CosmosEnumSimpleCtaStyle>;
  title?: Maybe<RichText>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant?: Maybe<CosmosEnumSimpleCtaVariant>;
};


/** Section uses Section Config Heading for Title, Desc, Buttons and Gradient. */
export type CosmosSectionSimpleCtaButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementIconButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementIconButtonWhereInput>;
};


/** Section uses Section Config Heading for Title, Desc, Buttons and Gradient. */
export type CosmosSectionSimpleCtaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Section uses Section Config Heading for Title, Desc, Buttons and Gradient. */
export type CosmosSectionSimpleCtaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionSimpleCtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionSimpleCtaWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionSimpleCtaConnection = {
  __typename?: 'CosmosSectionSimpleCtaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionSimpleCtaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionSimpleCtaCreateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonCreateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionSimpleCtaCreateLocalizationsInput>;
  style?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CosmosEnumSimpleCtaVariant>;
};

export type CosmosSectionSimpleCtaCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionSimpleCtaCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionSimpleCtaCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSimpleCtaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionSimpleCtaCreateLocalizationInput>>;
};

export type CosmosSectionSimpleCtaCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionSimpleCta documents */
  create?: InputMaybe<Array<CosmosSectionSimpleCtaCreateInput>>;
};

export type CosmosSectionSimpleCtaCreateOneInlineInput = {
  /** Create and connect one CosmosSectionSimpleCta document */
  create?: InputMaybe<CosmosSectionSimpleCtaCreateInput>;
};

export type CosmosSectionSimpleCtaCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionSimpleCtaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionSimpleCtaEdge = {
  __typename?: 'CosmosSectionSimpleCtaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionSimpleCta;
};

/** Identifies documents */
export type CosmosSectionSimpleCtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionSimpleCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionSimpleCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionSimpleCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  style?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** All values that are contained in given list. */
  style_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaStyle>>>;
  /** Any other value that exists and is not equal to the given value. */
  style_not?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** All values that are not contained in given list. */
  style_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaStyle>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumSimpleCtaVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumSimpleCtaVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaVariant>>>;
};

export enum CosmosSectionSimpleCtaOrderByInput {
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  EyebrowAsc = 'eyebrow_ASC',
  EyebrowDesc = 'eyebrow_DESC',
  GradientAsc = 'gradient_ASC',
  GradientDesc = 'gradient_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  StyleAsc = 'style_ASC',
  StyleDesc = 'style_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CosmosSectionSimpleCtaParent = CosmosPageBlogDetail | CosmosReferenceSection;

export type CosmosSectionSimpleCtaParentConnectInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionSimpleCtaParentCreateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionSimpleCtaParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionSimpleCtaParent documents */
  connect?: InputMaybe<Array<CosmosSectionSimpleCtaParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionSimpleCtaParent documents */
  create?: InputMaybe<Array<CosmosSectionSimpleCtaParentCreateInput>>;
};

export type CosmosSectionSimpleCtaParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionSimpleCtaParent document */
  connect?: InputMaybe<CosmosSectionSimpleCtaParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionSimpleCtaParent document */
  create?: InputMaybe<CosmosSectionSimpleCtaParentCreateInput>;
};

export type CosmosSectionSimpleCtaParentUpdateInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionSimpleCtaParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionSimpleCtaParent documents */
  connect?: InputMaybe<Array<CosmosSectionSimpleCtaParentConnectInput>>;
  /** Create and connect multiple CosmosSectionSimpleCtaParent documents */
  create?: InputMaybe<Array<CosmosSectionSimpleCtaParentCreateInput>>;
  /** Delete multiple CosmosSectionSimpleCtaParent documents */
  delete?: InputMaybe<Array<CosmosSectionSimpleCtaParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionSimpleCtaParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionSimpleCtaParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionSimpleCtaParent documents */
  set?: InputMaybe<Array<CosmosSectionSimpleCtaParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionSimpleCtaParent documents */
  update?: InputMaybe<Array<CosmosSectionSimpleCtaParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionSimpleCtaParent documents */
  upsert?: InputMaybe<Array<CosmosSectionSimpleCtaParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionSimpleCtaParentUpdateManyWithNestedWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionSimpleCtaParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionSimpleCtaParent document */
  connect?: InputMaybe<CosmosSectionSimpleCtaParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionSimpleCtaParent document */
  create?: InputMaybe<CosmosSectionSimpleCtaParentCreateInput>;
  /** Delete currently connected CosmosSectionSimpleCtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionSimpleCtaParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionSimpleCtaParent document */
  update?: InputMaybe<CosmosSectionSimpleCtaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionSimpleCtaParent document */
  upsert?: InputMaybe<CosmosSectionSimpleCtaParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSimpleCtaParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionSimpleCtaParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSimpleCtaParentWhereInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionSimpleCtaParentWhereUniqueInput = {
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionSimpleCtaUpdateInput = {
  buttons?: InputMaybe<CosmosElementIconButtonUpdateManyInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionSimpleCtaUpdateLocalizationsInput>;
  style?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  variant?: InputMaybe<CosmosEnumSimpleCtaVariant>;
};

export type CosmosSectionSimpleCtaUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionSimpleCtaUpdateLocalizationInput = {
  data: CosmosSectionSimpleCtaUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSimpleCtaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionSimpleCtaCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionSimpleCtaUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionSimpleCtaUpsertLocalizationInput>>;
};

export type CosmosSectionSimpleCtaUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionSimpleCta component instances */
  create?: InputMaybe<Array<CosmosSectionSimpleCtaCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionSimpleCta documents */
  delete?: InputMaybe<Array<CosmosSectionSimpleCtaWhereUniqueInput>>;
  /** Update multiple CosmosSectionSimpleCta component instances */
  update?: InputMaybe<Array<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionSimpleCta component instances */
  upsert?: InputMaybe<Array<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionSimpleCtaUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** eyebrow input for default locale (en) */
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionSimpleCtaUpdateManyLocalizationsInput>;
  style?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  variant?: InputMaybe<CosmosEnumSimpleCtaVariant>;
};

export type CosmosSectionSimpleCtaUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type CosmosSectionSimpleCtaUpdateManyLocalizationInput = {
  data: CosmosSectionSimpleCtaUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSimpleCtaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionSimpleCtaUpdateManyLocalizationInput>>;
};

export type CosmosSectionSimpleCtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionSimpleCtaUpdateManyInput;
  /** Document search */
  where: CosmosSectionSimpleCtaWhereInput;
};

export type CosmosSectionSimpleCtaUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionSimpleCta document */
  create?: InputMaybe<CosmosSectionSimpleCtaCreateInput>;
  /** Delete currently connected CosmosSectionSimpleCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionSimpleCta document */
  update?: InputMaybe<CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionSimpleCta document */
  upsert?: InputMaybe<CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionSimpleCtaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionSimpleCtaWhereUniqueInput;
};

export type CosmosSectionSimpleCtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionSimpleCtaUpdateInput;
  /** Unique document search */
  where: CosmosSectionSimpleCtaWhereUniqueInput;
};

export type CosmosSectionSimpleCtaUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionSimpleCtaCreateInput;
  /** Update document if it exists */
  update: CosmosSectionSimpleCtaUpdateInput;
};

export type CosmosSectionSimpleCtaUpsertLocalizationInput = {
  create: CosmosSectionSimpleCtaCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionSimpleCtaUpdateLocalizationDataInput;
};

export type CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionSimpleCtaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionSimpleCtaWhereUniqueInput;
};

export type CosmosSectionSimpleCtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionSimpleCtaUpsertInput;
  /** Unique document search */
  where: CosmosSectionSimpleCtaWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionSimpleCtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionSimpleCtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionSimpleCtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionSimpleCtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttons_every?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_none?: InputMaybe<CosmosElementIconButtonWhereInput>;
  buttons_some?: InputMaybe<CosmosElementIconButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eyebrow_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eyebrow_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eyebrow_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eyebrow_starts_with?: InputMaybe<Scalars['String']['input']>;
  gradient?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are contained in given list. */
  gradient_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  /** Any other value that exists and is not equal to the given value. */
  gradient_not?: InputMaybe<CosmosEnumEdsGradients>;
  /** All values that are not contained in given list. */
  gradient_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumEdsGradients>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  style?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** All values that are contained in given list. */
  style_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaStyle>>>;
  /** Any other value that exists and is not equal to the given value. */
  style_not?: InputMaybe<CosmosEnumSimpleCtaStyle>;
  /** All values that are not contained in given list. */
  style_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaStyle>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CosmosEnumSimpleCtaVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CosmosEnumSimpleCtaVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CosmosEnumSimpleCtaVariant>>>;
};

/** References CosmosSectionSimpleCta record uniquely */
export type CosmosSectionSimpleCtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionSlimContactCard = Entity & {
  __typename?: 'CosmosSectionSlimContactCard';
  cards: Array<CosmosElementLicenseContactCard>;
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** Even if section has 1 card and no heading force show bottom padding */
  forceShowPaddingBottom?: Maybe<Scalars['Boolean']['output']>;
  /** Even if section has 1 card and no heading force show top padding */
  forceShowPaddingTop?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionSlimContactCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionSlimContactCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementLicenseContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
};


export type CosmosSectionSlimContactCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionSlimContactCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionSlimContactCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionSlimContactCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionSlimContactCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionSlimContactCardConnection = {
  __typename?: 'CosmosSectionSlimContactCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionSlimContactCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionSlimContactCardCreateInput = {
  cards?: InputMaybe<CosmosElementLicenseContactCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  forceShowPaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  forceShowPaddingTop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionSlimContactCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionSlimContactCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionSlimContactCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionSlimContactCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSlimContactCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionSlimContactCardCreateLocalizationInput>>;
};

export type CosmosSectionSlimContactCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionSlimContactCard documents */
  create?: InputMaybe<Array<CosmosSectionSlimContactCardCreateInput>>;
};

export type CosmosSectionSlimContactCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionSlimContactCard document */
  create?: InputMaybe<CosmosSectionSlimContactCardCreateInput>;
};

export type CosmosSectionSlimContactCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionSlimContactCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionSlimContactCardEdge = {
  __typename?: 'CosmosSectionSlimContactCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionSlimContactCard;
};

/** Identifies documents */
export type CosmosSectionSlimContactCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionSlimContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionSlimContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionSlimContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  forceShowPaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  forceShowPaddingBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  forceShowPaddingTop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  forceShowPaddingTop_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionSlimContactCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  ForceShowPaddingBottomAsc = 'forceShowPaddingBottom_ASC',
  ForceShowPaddingBottomDesc = 'forceShowPaddingBottom_DESC',
  ForceShowPaddingTopAsc = 'forceShowPaddingTop_ASC',
  ForceShowPaddingTopDesc = 'forceShowPaddingTop_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionSlimContactCardParent = CosmosReferenceSection;

export type CosmosSectionSlimContactCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionSlimContactCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionSlimContactCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionSlimContactCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionSlimContactCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionSlimContactCardParent documents */
  create?: InputMaybe<Array<CosmosSectionSlimContactCardParentCreateInput>>;
};

export type CosmosSectionSlimContactCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionSlimContactCardParent document */
  connect?: InputMaybe<CosmosSectionSlimContactCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionSlimContactCardParent document */
  create?: InputMaybe<CosmosSectionSlimContactCardParentCreateInput>;
};

export type CosmosSectionSlimContactCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionSlimContactCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionSlimContactCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionSlimContactCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionSlimContactCardParent documents */
  create?: InputMaybe<Array<CosmosSectionSlimContactCardParentCreateInput>>;
  /** Delete multiple CosmosSectionSlimContactCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionSlimContactCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionSlimContactCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionSlimContactCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionSlimContactCardParent documents */
  set?: InputMaybe<Array<CosmosSectionSlimContactCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionSlimContactCardParent documents */
  update?: InputMaybe<Array<CosmosSectionSlimContactCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionSlimContactCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionSlimContactCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionSlimContactCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionSlimContactCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionSlimContactCardParent document */
  connect?: InputMaybe<CosmosSectionSlimContactCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionSlimContactCardParent document */
  create?: InputMaybe<CosmosSectionSlimContactCardParentCreateInput>;
  /** Delete currently connected CosmosSectionSlimContactCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionSlimContactCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionSlimContactCardParent document */
  update?: InputMaybe<CosmosSectionSlimContactCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionSlimContactCardParent document */
  upsert?: InputMaybe<CosmosSectionSlimContactCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSlimContactCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionSlimContactCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSlimContactCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionSlimContactCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionSlimContactCardUpdateInput = {
  cards?: InputMaybe<CosmosElementLicenseContactCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  forceShowPaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  forceShowPaddingTop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionSlimContactCardUpdateLocalizationsInput>;
};

export type CosmosSectionSlimContactCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionSlimContactCardUpdateLocalizationInput = {
  data: CosmosSectionSlimContactCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSlimContactCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionSlimContactCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionSlimContactCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionSlimContactCardUpsertLocalizationInput>>;
};

export type CosmosSectionSlimContactCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionSlimContactCard component instances */
  create?: InputMaybe<Array<CosmosSectionSlimContactCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionSlimContactCard documents */
  delete?: InputMaybe<Array<CosmosSectionSlimContactCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionSlimContactCard component instances */
  update?: InputMaybe<Array<CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionSlimContactCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionSlimContactCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  forceShowPaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  forceShowPaddingTop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionSlimContactCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionSlimContactCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionSlimContactCardUpdateManyLocalizationInput = {
  data: CosmosSectionSlimContactCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSlimContactCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionSlimContactCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionSlimContactCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionSlimContactCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionSlimContactCardWhereInput;
};

export type CosmosSectionSlimContactCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionSlimContactCard document */
  create?: InputMaybe<CosmosSectionSlimContactCardCreateInput>;
  /** Delete currently connected CosmosSectionSlimContactCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionSlimContactCard document */
  update?: InputMaybe<CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionSlimContactCard document */
  upsert?: InputMaybe<CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionSlimContactCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionSlimContactCardWhereUniqueInput;
};

export type CosmosSectionSlimContactCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionSlimContactCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionSlimContactCardWhereUniqueInput;
};

export type CosmosSectionSlimContactCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionSlimContactCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionSlimContactCardUpdateInput;
};

export type CosmosSectionSlimContactCardUpsertLocalizationInput = {
  create: CosmosSectionSlimContactCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionSlimContactCardUpdateLocalizationDataInput;
};

export type CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionSlimContactCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionSlimContactCardWhereUniqueInput;
};

export type CosmosSectionSlimContactCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionSlimContactCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionSlimContactCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionSlimContactCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionSlimContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionSlimContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionSlimContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementLicenseContactCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  forceShowPaddingBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  forceShowPaddingBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  forceShowPaddingTop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  forceShowPaddingTop_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionSlimContactCard record uniquely */
export type CosmosSectionSlimContactCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionSpeakerCard = Entity & {
  __typename?: 'CosmosSectionSpeakerCard';
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionSpeakerCard>;
  speakers: Array<CosmosElementSpeakerCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionSpeakerCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionSpeakerCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionSpeakerCardSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementSpeakerCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
};


export type CosmosSectionSpeakerCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionSpeakerCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionSpeakerCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionSpeakerCardConnection = {
  __typename?: 'CosmosSectionSpeakerCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionSpeakerCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionSpeakerCardCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionSpeakerCardCreateLocalizationsInput>;
  speakers?: InputMaybe<CosmosElementSpeakerCardCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionSpeakerCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionSpeakerCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionSpeakerCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSpeakerCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionSpeakerCardCreateLocalizationInput>>;
};

export type CosmosSectionSpeakerCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionSpeakerCard documents */
  create?: InputMaybe<Array<CosmosSectionSpeakerCardCreateInput>>;
};

export type CosmosSectionSpeakerCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionSpeakerCard document */
  create?: InputMaybe<CosmosSectionSpeakerCardCreateInput>;
};

export type CosmosSectionSpeakerCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionSpeakerCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionSpeakerCardEdge = {
  __typename?: 'CosmosSectionSpeakerCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionSpeakerCard;
};

/** Identifies documents */
export type CosmosSectionSpeakerCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionSpeakerCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionSpeakerCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionSpeakerCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  speakers_every?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
  speakers_none?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
  speakers_some?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionSpeakerCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionSpeakerCardParent = CosmosReferenceSection;

export type CosmosSectionSpeakerCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionSpeakerCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionSpeakerCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionSpeakerCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionSpeakerCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionSpeakerCardParent documents */
  create?: InputMaybe<Array<CosmosSectionSpeakerCardParentCreateInput>>;
};

export type CosmosSectionSpeakerCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionSpeakerCardParent document */
  connect?: InputMaybe<CosmosSectionSpeakerCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionSpeakerCardParent document */
  create?: InputMaybe<CosmosSectionSpeakerCardParentCreateInput>;
};

export type CosmosSectionSpeakerCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionSpeakerCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionSpeakerCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionSpeakerCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionSpeakerCardParent documents */
  create?: InputMaybe<Array<CosmosSectionSpeakerCardParentCreateInput>>;
  /** Delete multiple CosmosSectionSpeakerCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionSpeakerCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionSpeakerCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionSpeakerCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionSpeakerCardParent documents */
  set?: InputMaybe<Array<CosmosSectionSpeakerCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionSpeakerCardParent documents */
  update?: InputMaybe<Array<CosmosSectionSpeakerCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionSpeakerCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionSpeakerCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionSpeakerCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionSpeakerCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionSpeakerCardParent document */
  connect?: InputMaybe<CosmosSectionSpeakerCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionSpeakerCardParent document */
  create?: InputMaybe<CosmosSectionSpeakerCardParentCreateInput>;
  /** Delete currently connected CosmosSectionSpeakerCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionSpeakerCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionSpeakerCardParent document */
  update?: InputMaybe<CosmosSectionSpeakerCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionSpeakerCardParent document */
  upsert?: InputMaybe<CosmosSectionSpeakerCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSpeakerCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionSpeakerCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSpeakerCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionSpeakerCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionSpeakerCardUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionSpeakerCardUpdateLocalizationsInput>;
  speakers?: InputMaybe<CosmosElementSpeakerCardUpdateManyInlineInput>;
};

export type CosmosSectionSpeakerCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionSpeakerCardUpdateLocalizationInput = {
  data: CosmosSectionSpeakerCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSpeakerCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionSpeakerCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionSpeakerCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionSpeakerCardUpsertLocalizationInput>>;
};

export type CosmosSectionSpeakerCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionSpeakerCard component instances */
  create?: InputMaybe<Array<CosmosSectionSpeakerCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionSpeakerCard documents */
  delete?: InputMaybe<Array<CosmosSectionSpeakerCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionSpeakerCard component instances */
  update?: InputMaybe<Array<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionSpeakerCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionSpeakerCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionSpeakerCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionSpeakerCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionSpeakerCardUpdateManyLocalizationInput = {
  data: CosmosSectionSpeakerCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionSpeakerCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionSpeakerCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionSpeakerCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionSpeakerCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionSpeakerCardWhereInput;
};

export type CosmosSectionSpeakerCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionSpeakerCard document */
  create?: InputMaybe<CosmosSectionSpeakerCardCreateInput>;
  /** Delete currently connected CosmosSectionSpeakerCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionSpeakerCard document */
  update?: InputMaybe<CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionSpeakerCard document */
  upsert?: InputMaybe<CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionSpeakerCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionSpeakerCardWhereUniqueInput;
};

export type CosmosSectionSpeakerCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionSpeakerCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionSpeakerCardWhereUniqueInput;
};

export type CosmosSectionSpeakerCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionSpeakerCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionSpeakerCardUpdateInput;
};

export type CosmosSectionSpeakerCardUpsertLocalizationInput = {
  create: CosmosSectionSpeakerCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionSpeakerCardUpdateLocalizationDataInput;
};

export type CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionSpeakerCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionSpeakerCardWhereUniqueInput;
};

export type CosmosSectionSpeakerCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionSpeakerCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionSpeakerCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionSpeakerCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionSpeakerCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionSpeakerCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionSpeakerCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  speakers_every?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
  speakers_none?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
  speakers_some?: InputMaybe<CosmosElementSpeakerCardWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionSpeakerCard record uniquely */
export type CosmosSectionSpeakerCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionTabbedBlogCard = Entity & {
  __typename?: 'CosmosSectionTabbedBlogCard';
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionTabbedBlogCard>;
  /** System stage field */
  stage: Stage;
  tabs: Array<CosmosElementTabbedBlogCardsItem>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionTabbedBlogCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionTabbedBlogCardTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTabbedBlogCardsItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
};


export type CosmosSectionTabbedBlogCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionTabbedBlogCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionTabbedBlogCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionTabbedBlogCardConnection = {
  __typename?: 'CosmosSectionTabbedBlogCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionTabbedBlogCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionTabbedBlogCardCreateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionTabbedBlogCardCreateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementTabbedBlogCardsItemCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionTabbedBlogCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionTabbedBlogCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionTabbedBlogCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedBlogCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionTabbedBlogCardCreateLocalizationInput>>;
};

export type CosmosSectionTabbedBlogCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionTabbedBlogCard documents */
  create?: InputMaybe<Array<CosmosSectionTabbedBlogCardCreateInput>>;
};

export type CosmosSectionTabbedBlogCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionTabbedBlogCard document */
  create?: InputMaybe<CosmosSectionTabbedBlogCardCreateInput>;
};

export type CosmosSectionTabbedBlogCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionTabbedBlogCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionTabbedBlogCardEdge = {
  __typename?: 'CosmosSectionTabbedBlogCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionTabbedBlogCard;
};

/** Identifies documents */
export type CosmosSectionTabbedBlogCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabs_every?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  tabs_none?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  tabs_some?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionTabbedBlogCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionTabbedBlogCardParent = CosmosReferenceSection;

export type CosmosSectionTabbedBlogCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionTabbedBlogCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionTabbedBlogCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionTabbedBlogCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionTabbedBlogCardParent documents */
  create?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentCreateInput>>;
};

export type CosmosSectionTabbedBlogCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionTabbedBlogCardParent document */
  connect?: InputMaybe<CosmosSectionTabbedBlogCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionTabbedBlogCardParent document */
  create?: InputMaybe<CosmosSectionTabbedBlogCardParentCreateInput>;
};

export type CosmosSectionTabbedBlogCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionTabbedBlogCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionTabbedBlogCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionTabbedBlogCardParent documents */
  create?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentCreateInput>>;
  /** Delete multiple CosmosSectionTabbedBlogCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionTabbedBlogCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionTabbedBlogCardParent documents */
  set?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionTabbedBlogCardParent documents */
  update?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionTabbedBlogCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionTabbedBlogCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionTabbedBlogCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionTabbedBlogCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionTabbedBlogCardParent document */
  connect?: InputMaybe<CosmosSectionTabbedBlogCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionTabbedBlogCardParent document */
  create?: InputMaybe<CosmosSectionTabbedBlogCardParentCreateInput>;
  /** Delete currently connected CosmosSectionTabbedBlogCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionTabbedBlogCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionTabbedBlogCardParent document */
  update?: InputMaybe<CosmosSectionTabbedBlogCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionTabbedBlogCardParent document */
  upsert?: InputMaybe<CosmosSectionTabbedBlogCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedBlogCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedBlogCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedBlogCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionTabbedBlogCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionTabbedBlogCardUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionTabbedBlogCardUpdateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementTabbedBlogCardsItemUpdateManyInlineInput>;
};

export type CosmosSectionTabbedBlogCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionTabbedBlogCardUpdateLocalizationInput = {
  data: CosmosSectionTabbedBlogCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedBlogCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionTabbedBlogCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionTabbedBlogCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionTabbedBlogCardUpsertLocalizationInput>>;
};

export type CosmosSectionTabbedBlogCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionTabbedBlogCard component instances */
  create?: InputMaybe<Array<CosmosSectionTabbedBlogCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionTabbedBlogCard documents */
  delete?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionTabbedBlogCard component instances */
  update?: InputMaybe<Array<CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionTabbedBlogCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionTabbedBlogCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionTabbedBlogCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionTabbedBlogCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionTabbedBlogCardUpdateManyLocalizationInput = {
  data: CosmosSectionTabbedBlogCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedBlogCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionTabbedBlogCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionTabbedBlogCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionTabbedBlogCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionTabbedBlogCardWhereInput;
};

export type CosmosSectionTabbedBlogCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionTabbedBlogCard document */
  create?: InputMaybe<CosmosSectionTabbedBlogCardCreateInput>;
  /** Delete currently connected CosmosSectionTabbedBlogCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionTabbedBlogCard document */
  update?: InputMaybe<CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionTabbedBlogCard document */
  upsert?: InputMaybe<CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionTabbedBlogCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionTabbedBlogCardWhereUniqueInput;
};

export type CosmosSectionTabbedBlogCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionTabbedBlogCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionTabbedBlogCardWhereUniqueInput;
};

export type CosmosSectionTabbedBlogCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionTabbedBlogCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionTabbedBlogCardUpdateInput;
};

export type CosmosSectionTabbedBlogCardUpsertLocalizationInput = {
  create: CosmosSectionTabbedBlogCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionTabbedBlogCardUpdateLocalizationDataInput;
};

export type CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionTabbedBlogCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionTabbedBlogCardWhereUniqueInput;
};

export type CosmosSectionTabbedBlogCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionTabbedBlogCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionTabbedBlogCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionTabbedBlogCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionTabbedBlogCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabs_every?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  tabs_none?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  tabs_some?: InputMaybe<CosmosElementTabbedBlogCardsItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionTabbedBlogCard record uniquely */
export type CosmosSectionTabbedBlogCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CosmosSectionTabbedContentImage = Entity & {
  __typename?: 'CosmosSectionTabbedContentImage';
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionTabbedContentImage>;
  /** System stage field */
  stage: Stage;
  tabs: Array<CosmosElementTabbedContentImageItem>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CosmosSectionTabbedContentImageConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CosmosSectionTabbedContentImageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CosmosSectionTabbedContentImageTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTabbedContentImageItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
};


export type CosmosSectionTabbedContentImageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionTabbedContentImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionTabbedContentImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionTabbedContentImageConnection = {
  __typename?: 'CosmosSectionTabbedContentImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionTabbedContentImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionTabbedContentImageCreateInput = {
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionTabbedContentImageCreateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementTabbedContentImageItemCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionTabbedContentImageCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionTabbedContentImageCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionTabbedContentImageCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedContentImageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionTabbedContentImageCreateLocalizationInput>>;
};

export type CosmosSectionTabbedContentImageCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionTabbedContentImage documents */
  create?: InputMaybe<Array<CosmosSectionTabbedContentImageCreateInput>>;
};

export type CosmosSectionTabbedContentImageCreateOneInlineInput = {
  /** Create and connect one CosmosSectionTabbedContentImage document */
  create?: InputMaybe<CosmosSectionTabbedContentImageCreateInput>;
};

export type CosmosSectionTabbedContentImageCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionTabbedContentImageCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionTabbedContentImageEdge = {
  __typename?: 'CosmosSectionTabbedContentImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionTabbedContentImage;
};

/** Identifies documents */
export type CosmosSectionTabbedContentImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabs_every?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  tabs_none?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  tabs_some?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionTabbedContentImageOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionTabbedContentImageParent = CosmosReferenceSection;

export type CosmosSectionTabbedContentImageParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionTabbedContentImageParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionTabbedContentImageParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionTabbedContentImageParent documents */
  connect?: InputMaybe<Array<CosmosSectionTabbedContentImageParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionTabbedContentImageParent documents */
  create?: InputMaybe<Array<CosmosSectionTabbedContentImageParentCreateInput>>;
};

export type CosmosSectionTabbedContentImageParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionTabbedContentImageParent document */
  connect?: InputMaybe<CosmosSectionTabbedContentImageParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionTabbedContentImageParent document */
  create?: InputMaybe<CosmosSectionTabbedContentImageParentCreateInput>;
};

export type CosmosSectionTabbedContentImageParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionTabbedContentImageParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionTabbedContentImageParent documents */
  connect?: InputMaybe<Array<CosmosSectionTabbedContentImageParentConnectInput>>;
  /** Create and connect multiple CosmosSectionTabbedContentImageParent documents */
  create?: InputMaybe<Array<CosmosSectionTabbedContentImageParentCreateInput>>;
  /** Delete multiple CosmosSectionTabbedContentImageParent documents */
  delete?: InputMaybe<Array<CosmosSectionTabbedContentImageParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionTabbedContentImageParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionTabbedContentImageParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionTabbedContentImageParent documents */
  set?: InputMaybe<Array<CosmosSectionTabbedContentImageParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionTabbedContentImageParent documents */
  update?: InputMaybe<Array<CosmosSectionTabbedContentImageParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionTabbedContentImageParent documents */
  upsert?: InputMaybe<Array<CosmosSectionTabbedContentImageParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionTabbedContentImageParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionTabbedContentImageParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionTabbedContentImageParent document */
  connect?: InputMaybe<CosmosSectionTabbedContentImageParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionTabbedContentImageParent document */
  create?: InputMaybe<CosmosSectionTabbedContentImageParentCreateInput>;
  /** Delete currently connected CosmosSectionTabbedContentImageParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionTabbedContentImageParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionTabbedContentImageParent document */
  update?: InputMaybe<CosmosSectionTabbedContentImageParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionTabbedContentImageParent document */
  upsert?: InputMaybe<CosmosSectionTabbedContentImageParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedContentImageParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedContentImageParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedContentImageParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionTabbedContentImageParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionTabbedContentImageUpdateInput = {
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionTabbedContentImageUpdateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementTabbedContentImageItemUpdateManyInlineInput>;
};

export type CosmosSectionTabbedContentImageUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionTabbedContentImageUpdateLocalizationInput = {
  data: CosmosSectionTabbedContentImageUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedContentImageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionTabbedContentImageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionTabbedContentImageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionTabbedContentImageUpsertLocalizationInput>>;
};

export type CosmosSectionTabbedContentImageUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionTabbedContentImage component instances */
  create?: InputMaybe<Array<CosmosSectionTabbedContentImageCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionTabbedContentImage documents */
  delete?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereUniqueInput>>;
  /** Update multiple CosmosSectionTabbedContentImage component instances */
  update?: InputMaybe<Array<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionTabbedContentImage component instances */
  upsert?: InputMaybe<Array<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionTabbedContentImageUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionTabbedContentImageUpdateManyLocalizationsInput>;
};

export type CosmosSectionTabbedContentImageUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionTabbedContentImageUpdateManyLocalizationInput = {
  data: CosmosSectionTabbedContentImageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedContentImageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionTabbedContentImageUpdateManyLocalizationInput>>;
};

export type CosmosSectionTabbedContentImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionTabbedContentImageUpdateManyInput;
  /** Document search */
  where: CosmosSectionTabbedContentImageWhereInput;
};

export type CosmosSectionTabbedContentImageUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionTabbedContentImage document */
  create?: InputMaybe<CosmosSectionTabbedContentImageCreateInput>;
  /** Delete currently connected CosmosSectionTabbedContentImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionTabbedContentImage document */
  update?: InputMaybe<CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionTabbedContentImage document */
  upsert?: InputMaybe<CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionTabbedContentImageUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionTabbedContentImageWhereUniqueInput;
};

export type CosmosSectionTabbedContentImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionTabbedContentImageUpdateInput;
  /** Unique document search */
  where: CosmosSectionTabbedContentImageWhereUniqueInput;
};

export type CosmosSectionTabbedContentImageUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionTabbedContentImageCreateInput;
  /** Update document if it exists */
  update: CosmosSectionTabbedContentImageUpdateInput;
};

export type CosmosSectionTabbedContentImageUpsertLocalizationInput = {
  create: CosmosSectionTabbedContentImageCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionTabbedContentImageUpdateLocalizationDataInput;
};

export type CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionTabbedContentImageUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionTabbedContentImageWhereUniqueInput;
};

export type CosmosSectionTabbedContentImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionTabbedContentImageUpsertInput;
  /** Unique document search */
  where: CosmosSectionTabbedContentImageWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionTabbedContentImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionTabbedContentImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabs_every?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  tabs_none?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  tabs_some?: InputMaybe<CosmosElementTabbedContentImageItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionTabbedContentImage record uniquely */
export type CosmosSectionTabbedContentImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Tabbed full width asset with content stack. Created for Twinmotion Uses pages. */
export type CosmosSectionTabbedFullWidthAsset = Entity & {
  __typename?: 'CosmosSectionTabbedFullWidthAsset';
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionTabbedFullWidthAsset>;
  /** System stage field */
  stage: Stage;
  tabs: Array<CosmosElementTabbedFullWidthAssetItem>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Tabbed full width asset with content stack. Created for Twinmotion Uses pages. */
export type CosmosSectionTabbedFullWidthAssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Tabbed full width asset with content stack. Created for Twinmotion Uses pages. */
export type CosmosSectionTabbedFullWidthAssetTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementTabbedFullWidthAssetItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
};


/** Tabbed full width asset with content stack. Created for Twinmotion Uses pages. */
export type CosmosSectionTabbedFullWidthAssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionTabbedFullWidthAssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionTabbedFullWidthAssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionTabbedFullWidthAssetConnection = {
  __typename?: 'CosmosSectionTabbedFullWidthAssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionTabbedFullWidthAssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionTabbedFullWidthAssetCreateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementTabbedFullWidthAssetItemCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionTabbedFullWidthAssetCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionTabbedFullWidthAssetCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionTabbedFullWidthAssetCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedFullWidthAssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetCreateLocalizationInput>>;
};

export type CosmosSectionTabbedFullWidthAssetCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionTabbedFullWidthAsset documents */
  create?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetCreateInput>>;
};

export type CosmosSectionTabbedFullWidthAssetCreateOneInlineInput = {
  /** Create and connect one CosmosSectionTabbedFullWidthAsset document */
  create?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateInput>;
};

export type CosmosSectionTabbedFullWidthAssetCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionTabbedFullWidthAssetCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionTabbedFullWidthAssetEdge = {
  __typename?: 'CosmosSectionTabbedFullWidthAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionTabbedFullWidthAsset;
};

/** Identifies documents */
export type CosmosSectionTabbedFullWidthAssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabs_every?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  tabs_none?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  tabs_some?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionTabbedFullWidthAssetOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionTabbedFullWidthAssetParent = CosmosReferenceSection;

export type CosmosSectionTabbedFullWidthAssetParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionTabbedFullWidthAssetParent documents */
  connect?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionTabbedFullWidthAssetParent documents */
  create?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentCreateInput>>;
};

export type CosmosSectionTabbedFullWidthAssetParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionTabbedFullWidthAssetParent document */
  connect?: InputMaybe<CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionTabbedFullWidthAssetParent document */
  create?: InputMaybe<CosmosSectionTabbedFullWidthAssetParentCreateInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionTabbedFullWidthAssetParent documents */
  connect?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentConnectInput>>;
  /** Create and connect multiple CosmosSectionTabbedFullWidthAssetParent documents */
  create?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentCreateInput>>;
  /** Delete multiple CosmosSectionTabbedFullWidthAssetParent documents */
  delete?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionTabbedFullWidthAssetParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionTabbedFullWidthAssetParent documents */
  set?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionTabbedFullWidthAssetParent documents */
  update?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionTabbedFullWidthAssetParent documents */
  upsert?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionTabbedFullWidthAssetParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionTabbedFullWidthAssetParent document */
  connect?: InputMaybe<CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionTabbedFullWidthAssetParent document */
  create?: InputMaybe<CosmosSectionTabbedFullWidthAssetParentCreateInput>;
  /** Delete currently connected CosmosSectionTabbedFullWidthAssetParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionTabbedFullWidthAssetParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionTabbedFullWidthAssetParent document */
  update?: InputMaybe<CosmosSectionTabbedFullWidthAssetParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionTabbedFullWidthAssetParent document */
  upsert?: InputMaybe<CosmosSectionTabbedFullWidthAssetParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionTabbedFullWidthAssetParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateLocalizationsInput>;
  tabs?: InputMaybe<CosmosElementTabbedFullWidthAssetItemUpdateManyInlineInput>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateLocalizationInput = {
  data: CosmosSectionTabbedFullWidthAssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedFullWidthAssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetUpsertLocalizationInput>>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionTabbedFullWidthAsset component instances */
  create?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionTabbedFullWidthAsset documents */
  delete?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereUniqueInput>>;
  /** Update multiple CosmosSectionTabbedFullWidthAsset component instances */
  update?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionTabbedFullWidthAsset component instances */
  upsert?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateManyLocalizationsInput>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateManyLocalizationInput = {
  data: CosmosSectionTabbedFullWidthAssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionTabbedFullWidthAssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetUpdateManyLocalizationInput>>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionTabbedFullWidthAssetUpdateManyInput;
  /** Document search */
  where: CosmosSectionTabbedFullWidthAssetWhereInput;
};

export type CosmosSectionTabbedFullWidthAssetUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionTabbedFullWidthAsset document */
  create?: InputMaybe<CosmosSectionTabbedFullWidthAssetCreateInput>;
  /** Delete currently connected CosmosSectionTabbedFullWidthAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionTabbedFullWidthAsset document */
  update?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionTabbedFullWidthAsset document */
  upsert?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionTabbedFullWidthAssetWhereUniqueInput;
};

export type CosmosSectionTabbedFullWidthAssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionTabbedFullWidthAssetUpdateInput;
  /** Unique document search */
  where: CosmosSectionTabbedFullWidthAssetWhereUniqueInput;
};

export type CosmosSectionTabbedFullWidthAssetUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionTabbedFullWidthAssetCreateInput;
  /** Update document if it exists */
  update: CosmosSectionTabbedFullWidthAssetUpdateInput;
};

export type CosmosSectionTabbedFullWidthAssetUpsertLocalizationInput = {
  create: CosmosSectionTabbedFullWidthAssetCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionTabbedFullWidthAssetUpdateLocalizationDataInput;
};

export type CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionTabbedFullWidthAssetUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionTabbedFullWidthAssetWhereUniqueInput;
};

export type CosmosSectionTabbedFullWidthAssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionTabbedFullWidthAssetUpsertInput;
  /** Unique document search */
  where: CosmosSectionTabbedFullWidthAssetWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionTabbedFullWidthAssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionTabbedFullWidthAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  tabs_every?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  tabs_none?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  tabs_some?: InputMaybe<CosmosElementTabbedFullWidthAssetItemWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionTabbedFullWidthAsset record uniquely */
export type CosmosSectionTabbedFullWidthAssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Section containing cards inspired by the ones at the bottom of Unreal Tournament's website. */
export type CosmosSectionUtCard = Entity & {
  __typename?: 'CosmosSectionUtCard';
  /** Suggested to use an even amount of cards to improve the look of the wrapping carousel. */
  cards: Array<CosmosElementUtCard>;
  config?: Maybe<CosmosConfigSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Description of the card for Hygraph UI use. Not shown publicly. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSectionUtCard>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Section containing cards inspired by the ones at the bottom of Unreal Tournament's website. */
export type CosmosSectionUtCardCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosElementUtCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosElementUtCardWhereInput>;
};


/** Section containing cards inspired by the ones at the bottom of Unreal Tournament's website. */
export type CosmosSectionUtCardConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Section containing cards inspired by the ones at the bottom of Unreal Tournament's website. */
export type CosmosSectionUtCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Section containing cards inspired by the ones at the bottom of Unreal Tournament's website. */
export type CosmosSectionUtCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSectionUtCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSectionUtCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSectionUtCardConnection = {
  __typename?: 'CosmosSectionUtCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSectionUtCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSectionUtCardCreateInput = {
  cards?: InputMaybe<CosmosElementUtCardCreateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSectionUtCardCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionUtCardCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSectionUtCardCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSectionUtCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionUtCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSectionUtCardCreateLocalizationInput>>;
};

export type CosmosSectionUtCardCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSectionUtCard documents */
  create?: InputMaybe<Array<CosmosSectionUtCardCreateInput>>;
};

export type CosmosSectionUtCardCreateOneInlineInput = {
  /** Create and connect one CosmosSectionUtCard document */
  create?: InputMaybe<CosmosSectionUtCardCreateInput>;
};

export type CosmosSectionUtCardCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSectionUtCardCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSectionUtCardEdge = {
  __typename?: 'CosmosSectionUtCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSectionUtCard;
};

/** Identifies documents */
export type CosmosSectionUtCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionUtCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionUtCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionUtCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementUtCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementUtCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementUtCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSectionUtCardOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSectionUtCardParent = CosmosReferenceSection;

export type CosmosSectionUtCardParentConnectInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionConnectInput>;
};

export type CosmosSectionUtCardParentCreateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionCreateInput>;
};

export type CosmosSectionUtCardParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSectionUtCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionUtCardParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSectionUtCardParent documents */
  create?: InputMaybe<Array<CosmosSectionUtCardParentCreateInput>>;
};

export type CosmosSectionUtCardParentCreateOneInlineInput = {
  /** Connect one existing CosmosSectionUtCardParent document */
  connect?: InputMaybe<CosmosSectionUtCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionUtCardParent document */
  create?: InputMaybe<CosmosSectionUtCardParentCreateInput>;
};

export type CosmosSectionUtCardParentUpdateInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateInput>;
};

export type CosmosSectionUtCardParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSectionUtCardParent documents */
  connect?: InputMaybe<Array<CosmosSectionUtCardParentConnectInput>>;
  /** Create and connect multiple CosmosSectionUtCardParent documents */
  create?: InputMaybe<Array<CosmosSectionUtCardParentCreateInput>>;
  /** Delete multiple CosmosSectionUtCardParent documents */
  delete?: InputMaybe<Array<CosmosSectionUtCardParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSectionUtCardParent documents */
  disconnect?: InputMaybe<Array<CosmosSectionUtCardParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSectionUtCardParent documents */
  set?: InputMaybe<Array<CosmosSectionUtCardParentWhereUniqueInput>>;
  /** Update multiple CosmosSectionUtCardParent documents */
  update?: InputMaybe<Array<CosmosSectionUtCardParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSectionUtCardParent documents */
  upsert?: InputMaybe<Array<CosmosSectionUtCardParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSectionUtCardParentUpdateManyWithNestedWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateManyWithNestedWhereInput>;
};

export type CosmosSectionUtCardParentUpdateOneInlineInput = {
  /** Connect existing CosmosSectionUtCardParent document */
  connect?: InputMaybe<CosmosSectionUtCardParentWhereUniqueInput>;
  /** Create and connect one CosmosSectionUtCardParent document */
  create?: InputMaybe<CosmosSectionUtCardParentCreateInput>;
  /** Delete currently connected CosmosSectionUtCardParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSectionUtCardParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionUtCardParent document */
  update?: InputMaybe<CosmosSectionUtCardParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionUtCardParent document */
  upsert?: InputMaybe<CosmosSectionUtCardParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionUtCardParentUpdateWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSectionUtCardParentUpsertWithNestedWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionUtCardParentWhereInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereInput>;
};

export type CosmosSectionUtCardParentWhereUniqueInput = {
  CosmosReferenceSection?: InputMaybe<CosmosReferenceSectionWhereUniqueInput>;
};

export type CosmosSectionUtCardUpdateInput = {
  cards?: InputMaybe<CosmosElementUtCardUpdateManyInlineInput>;
  config?: InputMaybe<CosmosConfigSectionUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSectionUtCardUpdateLocalizationsInput>;
};

export type CosmosSectionUtCardUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionUtCardUpdateLocalizationInput = {
  data: CosmosSectionUtCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionUtCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSectionUtCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionUtCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSectionUtCardUpsertLocalizationInput>>;
};

export type CosmosSectionUtCardUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSectionUtCard component instances */
  create?: InputMaybe<Array<CosmosSectionUtCardCreateWithPositionInput>>;
  /** Delete multiple CosmosSectionUtCard documents */
  delete?: InputMaybe<Array<CosmosSectionUtCardWhereUniqueInput>>;
  /** Update multiple CosmosSectionUtCard component instances */
  update?: InputMaybe<Array<CosmosSectionUtCardUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSectionUtCard component instances */
  upsert?: InputMaybe<Array<CosmosSectionUtCardUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSectionUtCardUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSectionUtCardUpdateManyLocalizationsInput>;
};

export type CosmosSectionUtCardUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSectionUtCardUpdateManyLocalizationInput = {
  data: CosmosSectionUtCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSectionUtCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSectionUtCardUpdateManyLocalizationInput>>;
};

export type CosmosSectionUtCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSectionUtCardUpdateManyInput;
  /** Document search */
  where: CosmosSectionUtCardWhereInput;
};

export type CosmosSectionUtCardUpdateOneInlineInput = {
  /** Create and connect one CosmosSectionUtCard document */
  create?: InputMaybe<CosmosSectionUtCardCreateInput>;
  /** Delete currently connected CosmosSectionUtCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSectionUtCard document */
  update?: InputMaybe<CosmosSectionUtCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSectionUtCard document */
  upsert?: InputMaybe<CosmosSectionUtCardUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSectionUtCardUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSectionUtCardUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionUtCardWhereUniqueInput;
};

export type CosmosSectionUtCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSectionUtCardUpdateInput;
  /** Unique document search */
  where: CosmosSectionUtCardWhereUniqueInput;
};

export type CosmosSectionUtCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSectionUtCardCreateInput;
  /** Update document if it exists */
  update: CosmosSectionUtCardUpdateInput;
};

export type CosmosSectionUtCardUpsertLocalizationInput = {
  create: CosmosSectionUtCardCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSectionUtCardUpdateLocalizationDataInput;
};

export type CosmosSectionUtCardUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSectionUtCardUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSectionUtCardWhereUniqueInput;
};

export type CosmosSectionUtCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSectionUtCardUpsertInput;
  /** Unique document search */
  where: CosmosSectionUtCardWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSectionUtCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSectionUtCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSectionUtCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSectionUtCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cards_every?: InputMaybe<CosmosElementUtCardWhereInput>;
  cards_none?: InputMaybe<CosmosElementUtCardWhereInput>;
  cards_some?: InputMaybe<CosmosElementUtCardWhereInput>;
  config?: InputMaybe<CosmosConfigSectionWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSectionUtCard record uniquely */
export type CosmosSectionUtCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Fields which declare SEO related meta tags on the page. */
export type CosmosSeo = Entity & {
  __typename?: 'CosmosSeo';
  /** Page description.  Used in meta tags. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CosmosSeo>;
  /** Set nofollow in the robots meta tag for this page. */
  noFollow?: Maybe<Scalars['Boolean']['output']>;
  /** Set noindex in the robots meta tag for this page. */
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  /** Image that will be shown in share cards on social media or messengers. (e.g. open graph image meta tag) */
  openGraphImage?: Maybe<Asset>;
  /** Optional field to set a different description to be used in the Open Graph and Twitter description tags. */
  socialDescription?: Maybe<Scalars['String']['output']>;
  /** Optional field to set a different title to be used in the Open Graph and Twitter title tags. */
  socialTitle?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The page title. Used in meta tags. */
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Fields which declare SEO related meta tags on the page. */
export type CosmosSeoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Fields which declare SEO related meta tags on the page. */
export type CosmosSeoOpenGraphImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Fields which declare SEO related meta tags on the page. */
export type CosmosSeoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CosmosSeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CosmosSeoWhereUniqueInput;
};

/** A connection to a list of items. */
export type CosmosSeoConnection = {
  __typename?: 'CosmosSeoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CosmosSeoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CosmosSeoCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CosmosSeoCreateLocalizationsInput>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** socialDescription input for default locale (en) */
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** socialTitle input for default locale (en) */
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSeoCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CosmosSeoCreateLocalizationInput = {
  /** Localization input */
  data: CosmosSeoCreateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSeoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CosmosSeoCreateLocalizationInput>>;
};

export type CosmosSeoCreateManyInlineInput = {
  /** Create and connect multiple existing CosmosSeo documents */
  create?: InputMaybe<Array<CosmosSeoCreateInput>>;
};

export type CosmosSeoCreateOneInlineInput = {
  /** Create and connect one CosmosSeo document */
  create?: InputMaybe<CosmosSeoCreateInput>;
};

export type CosmosSeoCreateWithPositionInput = {
  /** Document to create */
  data: CosmosSeoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CosmosSeoEdge = {
  __typename?: 'CosmosSeoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CosmosSeo;
};

/** Identifies documents */
export type CosmosSeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noFollow_not?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CosmosSeoOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NoFollowAsc = 'noFollow_ASC',
  NoFollowDesc = 'noFollow_DESC',
  NoIndexAsc = 'noIndex_ASC',
  NoIndexDesc = 'noIndex_DESC',
  SocialDescriptionAsc = 'socialDescription_ASC',
  SocialDescriptionDesc = 'socialDescription_DESC',
  SocialTitleAsc = 'socialTitle_ASC',
  SocialTitleDesc = 'socialTitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CosmosSeoParent = CosmosPageAgreement | CosmosPageBlogDetail | CosmosPageDirectory | CosmosPageEulaKey | CosmosPageFeed | CosmosPageHeroAndSection | CosmosPageLegalContent | CosmosPageLicense | CosmosPagePluginDetail | CosmosPageResearch | CosmosPageSearch;

export type CosmosSeoParentConnectInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementConnectInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailConnectInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryConnectInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyConnectInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedConnectInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionConnectInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentConnectInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseConnectInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailConnectInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchConnectInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchConnectInput>;
};

export type CosmosSeoParentCreateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementCreateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailCreateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryCreateInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyCreateInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedCreateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionCreateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentCreateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseCreateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailCreateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchCreateInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchCreateInput>;
};

export type CosmosSeoParentCreateManyInlineInput = {
  /** Connect multiple existing CosmosSeoParent documents */
  connect?: InputMaybe<Array<CosmosSeoParentWhereUniqueInput>>;
  /** Create and connect multiple existing CosmosSeoParent documents */
  create?: InputMaybe<Array<CosmosSeoParentCreateInput>>;
};

export type CosmosSeoParentCreateOneInlineInput = {
  /** Connect one existing CosmosSeoParent document */
  connect?: InputMaybe<CosmosSeoParentWhereUniqueInput>;
  /** Create and connect one CosmosSeoParent document */
  create?: InputMaybe<CosmosSeoParentCreateInput>;
};

export type CosmosSeoParentUpdateInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyUpdateInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedUpdateInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateInput>;
};

export type CosmosSeoParentUpdateManyInlineInput = {
  /** Connect multiple existing CosmosSeoParent documents */
  connect?: InputMaybe<Array<CosmosSeoParentConnectInput>>;
  /** Create and connect multiple CosmosSeoParent documents */
  create?: InputMaybe<Array<CosmosSeoParentCreateInput>>;
  /** Delete multiple CosmosSeoParent documents */
  delete?: InputMaybe<Array<CosmosSeoParentWhereUniqueInput>>;
  /** Disconnect multiple CosmosSeoParent documents */
  disconnect?: InputMaybe<Array<CosmosSeoParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CosmosSeoParent documents */
  set?: InputMaybe<Array<CosmosSeoParentWhereUniqueInput>>;
  /** Update multiple CosmosSeoParent documents */
  update?: InputMaybe<Array<CosmosSeoParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CosmosSeoParent documents */
  upsert?: InputMaybe<Array<CosmosSeoParentUpsertWithNestedWhereUniqueInput>>;
};

export type CosmosSeoParentUpdateManyWithNestedWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateManyWithNestedWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateManyWithNestedWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateManyWithNestedWhereInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyUpdateManyWithNestedWhereInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedUpdateManyWithNestedWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateManyWithNestedWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateManyWithNestedWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateManyWithNestedWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateManyWithNestedWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateManyWithNestedWhereInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateManyWithNestedWhereInput>;
};

export type CosmosSeoParentUpdateOneInlineInput = {
  /** Connect existing CosmosSeoParent document */
  connect?: InputMaybe<CosmosSeoParentWhereUniqueInput>;
  /** Create and connect one CosmosSeoParent document */
  create?: InputMaybe<CosmosSeoParentCreateInput>;
  /** Delete currently connected CosmosSeoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CosmosSeoParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSeoParent document */
  update?: InputMaybe<CosmosSeoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSeoParent document */
  upsert?: InputMaybe<CosmosSeoParentUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSeoParentUpdateWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpdateWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpdateWithNestedWhereUniqueInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyUpdateWithNestedWhereUniqueInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedUpdateWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpdateWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpdateWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpdateWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpdateWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpdateWithNestedWhereUniqueInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpdateWithNestedWhereUniqueInput>;
};

export type CosmosSeoParentUpsertWithNestedWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementUpsertWithNestedWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryUpsertWithNestedWhereUniqueInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyUpsertWithNestedWhereUniqueInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedUpsertWithNestedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionUpsertWithNestedWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentUpsertWithNestedWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseUpsertWithNestedWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailUpsertWithNestedWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchUpsertWithNestedWhereUniqueInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSeoParentWhereInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyWhereInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedWhereInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchWhereInput>;
};

export type CosmosSeoParentWhereUniqueInput = {
  CosmosPageAgreement?: InputMaybe<CosmosPageAgreementWhereUniqueInput>;
  CosmosPageBlogDetail?: InputMaybe<CosmosPageBlogDetailWhereUniqueInput>;
  CosmosPageDirectory?: InputMaybe<CosmosPageDirectoryWhereUniqueInput>;
  CosmosPageEulaKey?: InputMaybe<CosmosPageEulaKeyWhereUniqueInput>;
  CosmosPageFeed?: InputMaybe<CosmosPageFeedWhereUniqueInput>;
  CosmosPageHeroAndSection?: InputMaybe<CosmosPageHeroAndSectionWhereUniqueInput>;
  CosmosPageLegalContent?: InputMaybe<CosmosPageLegalContentWhereUniqueInput>;
  CosmosPageLicense?: InputMaybe<CosmosPageLicenseWhereUniqueInput>;
  CosmosPagePluginDetail?: InputMaybe<CosmosPagePluginDetailWhereUniqueInput>;
  CosmosPageResearch?: InputMaybe<CosmosPageResearchWhereUniqueInput>;
  CosmosPageSearch?: InputMaybe<CosmosPageSearchWhereUniqueInput>;
};

export type CosmosSeoUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CosmosSeoUpdateLocalizationsInput>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** socialDescription input for default locale (en) */
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** socialTitle input for default locale (en) */
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSeoUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSeoUpdateLocalizationInput = {
  data: CosmosSeoUpdateLocalizationDataInput;
  locale: Locale;
};

export type CosmosSeoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CosmosSeoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSeoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CosmosSeoUpsertLocalizationInput>>;
};

export type CosmosSeoUpdateManyInlineInput = {
  /** Create and connect multiple CosmosSeo component instances */
  create?: InputMaybe<Array<CosmosSeoCreateWithPositionInput>>;
  /** Delete multiple CosmosSeo documents */
  delete?: InputMaybe<Array<CosmosSeoWhereUniqueInput>>;
  /** Update multiple CosmosSeo component instances */
  update?: InputMaybe<Array<CosmosSeoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CosmosSeo component instances */
  upsert?: InputMaybe<Array<CosmosSeoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CosmosSeoUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CosmosSeoUpdateManyLocalizationsInput>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** socialDescription input for default locale (en) */
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** socialTitle input for default locale (en) */
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSeoUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CosmosSeoUpdateManyLocalizationInput = {
  data: CosmosSeoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CosmosSeoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CosmosSeoUpdateManyLocalizationInput>>;
};

export type CosmosSeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CosmosSeoUpdateManyInput;
  /** Document search */
  where: CosmosSeoWhereInput;
};

export type CosmosSeoUpdateOneInlineInput = {
  /** Create and connect one CosmosSeo document */
  create?: InputMaybe<CosmosSeoCreateInput>;
  /** Delete currently connected CosmosSeo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CosmosSeo document */
  update?: InputMaybe<CosmosSeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CosmosSeo document */
  upsert?: InputMaybe<CosmosSeoUpsertWithNestedWhereUniqueInput>;
};

export type CosmosSeoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CosmosSeoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSeoWhereUniqueInput;
};

export type CosmosSeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CosmosSeoUpdateInput;
  /** Unique document search */
  where: CosmosSeoWhereUniqueInput;
};

export type CosmosSeoUpsertInput = {
  /** Create document if it didn't exist */
  create: CosmosSeoCreateInput;
  /** Update document if it exists */
  update: CosmosSeoUpdateInput;
};

export type CosmosSeoUpsertLocalizationInput = {
  create: CosmosSeoCreateLocalizationDataInput;
  locale: Locale;
  update: CosmosSeoUpdateLocalizationDataInput;
};

export type CosmosSeoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CosmosSeoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CosmosSeoWhereUniqueInput;
};

export type CosmosSeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CosmosSeoUpsertInput;
  /** Unique document search */
  where: CosmosSeoWhereUniqueInput;
};

/** Identifies documents */
export type CosmosSeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CosmosSeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CosmosSeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CosmosSeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noFollow_not?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetWhereInput>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  socialDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  socialDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  socialDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  socialDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  socialDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  socialDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  socialDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  socialDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  socialTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  socialTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  socialTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  socialTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  socialTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  socialTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  socialTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  socialTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CosmosSeo record uniquely */
export type CosmosSeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

/** https://storybooks.ol.epicgames.net/eds-ephemeral/eds-web-react/main/?path=/story/components-icons-icon-library--icon-library */
export enum EdsIconsEnum {
  Apple = 'Apple',
  ArrowDownToBracket = 'ArrowDownToBracket',
  ArrowsCrossed = 'ArrowsCrossed',
  ArtStation = 'ArtStation',
  Bell = 'Bell',
  Blender = 'Blender',
  Bullhorn = 'Bullhorn',
  Camera = 'Camera',
  CheckmarkSeal = 'CheckmarkSeal',
  ChevronRight = 'ChevronRight',
  Clipboard = 'Clipboard',
  Clock = 'Clock',
  Code = 'Code',
  Compile = 'Compile',
  CompileFilled = 'CompileFilled',
  ComputerChip = 'ComputerChip',
  ComputerNetwork = 'ComputerNetwork',
  ComputerNetworkFilled = 'ComputerNetworkFilled',
  Cube = 'Cube',
  CurlyBraces = 'CurlyBraces',
  Discord = 'Discord',
  EasyAntiCheat = 'EasyAntiCheat',
  Envelope = 'Envelope',
  EnvelopeFilled = 'EnvelopeFilled',
  Epic = 'Epic',
  EpicGames = 'EpicGames',
  EpicRewards = 'EpicRewards',
  EpicRewardsFilled = 'EpicRewardsFilled',
  EyeSlash = 'EyeSlash',
  Fab = 'Fab',
  Facebook = 'Facebook',
  FallGuys = 'FallGuys',
  Figma = 'Figma',
  File = 'File',
  FileLines = 'FileLines',
  Folder = 'Folder',
  Fortnite = 'Fortnite',
  FortniteCreative = 'FortniteCreative',
  FutureTrash = 'FutureTrash',
  Gamepad = 'Gamepad',
  Globe = 'Globe',
  GlobeLocation = 'GlobeLocation',
  Google = 'Google',
  GraduationCap = 'GraduationCap',
  Instagram = 'Instagram',
  KidsWebServices = 'KidsWebServices',
  Language = 'Language',
  LegoBrick = 'LegoBrick',
  LegoHead = 'LegoHead',
  LifePreserver = 'LifePreserver',
  LinkedIn = 'LinkedIn',
  Linux = 'Linux',
  LocationDrop = 'LocationDrop',
  Metahuman = 'Metahuman',
  Naver = 'Naver',
  NeonGiant = 'NeonGiant',
  Newspaper = 'Newspaper',
  Note = 'Note',
  NotePen = 'NotePen',
  NotePenFilled = 'NotePenFilled',
  PalmTree = 'PalmTree',
  PercentSeal = 'PercentSeal',
  Pinterest = 'Pinterest',
  PlayStation = 'PlayStation',
  Postparty = 'Postparty',
  QuestionCircle = 'QuestionCircle',
  Quixel = 'Quixel',
  RealityCapture = 'RealityCapture',
  RealityScan = 'RealityScan',
  Reddit = 'Reddit',
  RiotGames = 'RiotGames',
  Rocket = 'Rocket',
  RocketLeague = 'RocketLeague',
  RocketLeagueSideswipe = 'RocketLeagueSideswipe',
  RouteStart = 'RouteStart',
  Scales = 'Scales',
  ShieldCheck = 'ShieldCheck',
  ShieldCheckFilled = 'ShieldCheckFilled',
  ShieldPlus = 'ShieldPlus',
  ShieldPlusFilled = 'ShieldPlusFilled',
  ShoppingCart = 'ShoppingCart',
  ShoppingCartFilled = 'ShoppingCartFilled',
  Slack = 'Slack',
  Snapchat = 'Snapchat',
  Sparkle = 'Sparkle',
  Stack3 = 'Stack3',
  Steam = 'Steam',
  TalkBubbleDots = 'TalkBubbleDots',
  Template = 'Template',
  TheCoalition = 'TheCoalition',
  TikTok = 'TikTok',
  Twinmotion = 'Twinmotion',
  Twitch = 'Twitch',
  TwitterX = 'TwitterX',
  Unity = 'Unity',
  UnrealEngine = 'UnrealEngine',
  Uplay = 'Uplay',
  User = 'User',
  UserGroup = 'UserGroup',
  UserMagnifier = 'UserMagnifier',
  UserPlus = 'UserPlus',
  Users = 'Users',
  Vk = 'VK',
  VRay = 'VRay',
  Verse = 'Verse',
  Video = 'Video',
  Wallet = 'Wallet',
  WeGame = 'WeGame',
  Weibo = 'Weibo',
  Windows = 'Windows',
  Xbox = 'Xbox',
  YouTube = 'YouTube',
  ZBrush = 'ZBrush'
}

export type ElementLearnCategory = Entity & {
  __typename?: 'ElementLearnCategory';
  /** Only for remote source */
  ago?: Maybe<Scalars['String']['output']>;
  cardCount?: Maybe<Scalars['Int']['output']>;
  cards: Array<ElementLearnCategorycardsUnion>;
  categoryType?: Maybe<EnumLearnCategories>;
  cta?: Maybe<CosmosElementButton>;
  desc?: Maybe<Scalars['String']['output']>;
  description?: Maybe<RichText>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ElementLearnCategory>;
  remoteCards: Array<CosmosRemoteLearn>;
  /** Remote source, cards will be loaded automatically  */
  remoteLearn?: Maybe<RemoteLearn>;
  squareImage?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<RichText>;
  /** Make the title clickable and set the href for when it is clicked. */
  titleHref?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ElementLearnCategoryCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ElementLearnCategoryCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ElementLearnCategoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type ElementLearnCategoryRemoteCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CosmosRemoteLearnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosRemoteLearnWhereInput>;
};


export type ElementLearnCategoryRemoteLearnArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ElementLearnCategoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type ElementLearnCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ElementLearnCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type ElementLearnCategoryConnection = {
  __typename?: 'ElementLearnCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ElementLearnCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ElementLearnCategoryCreateInput = {
  /** ago input for default locale (en) */
  ago?: InputMaybe<Scalars['String']['input']>;
  cardCount?: InputMaybe<Scalars['Int']['input']>;
  cards?: InputMaybe<ElementLearnCategorycardsUnionCreateManyInlineInput>;
  categoryType?: InputMaybe<EnumLearnCategories>;
  cta?: InputMaybe<CosmosElementButtonCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ElementLearnCategoryCreateLocalizationsInput>;
  remoteCards?: InputMaybe<CosmosRemoteLearnCreateManyInlineInput>;
  remoteLearn?: InputMaybe<RemoteLearnCreateOneInlineInput>;
  squareImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ElementLearnCategoryCreateLocalizationDataInput = {
  ago?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ElementLearnCategoryCreateLocalizationInput = {
  /** Localization input */
  data: ElementLearnCategoryCreateLocalizationDataInput;
  locale: Locale;
};

export type ElementLearnCategoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ElementLearnCategoryCreateLocalizationInput>>;
};

export type ElementLearnCategoryCreateManyInlineInput = {
  /** Create and connect multiple existing ElementLearnCategory documents */
  create?: InputMaybe<Array<ElementLearnCategoryCreateInput>>;
};

export type ElementLearnCategoryCreateOneInlineInput = {
  /** Create and connect one ElementLearnCategory document */
  create?: InputMaybe<ElementLearnCategoryCreateInput>;
};

export type ElementLearnCategoryCreateWithPositionInput = {
  /** Document to create */
  data: ElementLearnCategoryCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ElementLearnCategoryEdge = {
  __typename?: 'ElementLearnCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ElementLearnCategory;
};

/** Identifies documents */
export type ElementLearnCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ElementLearnCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ElementLearnCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ElementLearnCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardCount?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  cardCount_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  cardCount_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  cardCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  cardCount_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  cardCount_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cardCount_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  cardCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values in which the union is empty. */
  cards_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  cards_some?: InputMaybe<ElementLearnCategorycardsUnionWhereInput>;
  categoryType?: InputMaybe<EnumLearnCategories>;
  /** All values that are contained in given list. */
  categoryType_in?: InputMaybe<Array<InputMaybe<EnumLearnCategories>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryType_not?: InputMaybe<EnumLearnCategories>;
  /** All values that are not contained in given list. */
  categoryType_not_in?: InputMaybe<Array<InputMaybe<EnumLearnCategories>>>;
  cta?: InputMaybe<CosmosElementButtonWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  remoteCards_every?: InputMaybe<CosmosRemoteLearnWhereInput>;
  remoteCards_none?: InputMaybe<CosmosRemoteLearnWhereInput>;
  remoteCards_some?: InputMaybe<CosmosRemoteLearnWhereInput>;
  remoteLearn?: InputMaybe<RemoteLearnWhereInput>;
  squareImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  squareImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ElementLearnCategoryOrderByInput {
  AgoAsc = 'ago_ASC',
  AgoDesc = 'ago_DESC',
  CardCountAsc = 'cardCount_ASC',
  CardCountDesc = 'cardCount_DESC',
  CategoryTypeAsc = 'categoryType_ASC',
  CategoryTypeDesc = 'categoryType_DESC',
  DescAsc = 'desc_ASC',
  DescDesc = 'desc_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SquareImageAsc = 'squareImage_ASC',
  SquareImageDesc = 'squareImage_DESC',
  TitleHrefAsc = 'titleHref_ASC',
  TitleHrefDesc = 'titleHref_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ElementLearnCategoryParent = CosmosSectionLearn;

export type ElementLearnCategoryParentConnectInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnConnectInput>;
};

export type ElementLearnCategoryParentCreateInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateInput>;
};

export type ElementLearnCategoryParentCreateManyInlineInput = {
  /** Create and connect multiple existing ElementLearnCategoryParent documents */
  create?: InputMaybe<Array<ElementLearnCategoryParentCreateInput>>;
};

export type ElementLearnCategoryParentCreateOneInlineInput = {
  /** Create and connect one ElementLearnCategoryParent document */
  create?: InputMaybe<ElementLearnCategoryParentCreateInput>;
};

export type ElementLearnCategoryParentCreateWithPositionInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnCreateWithPositionInput>;
};

export type ElementLearnCategoryParentUpdateInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateInput>;
};

export type ElementLearnCategoryParentUpdateManyInlineInput = {
  /** Create and connect multiple ElementLearnCategoryParent component instances */
  create?: InputMaybe<Array<ElementLearnCategoryParentCreateWithPositionInput>>;
  /** Delete multiple ElementLearnCategoryParent documents */
  delete?: InputMaybe<Array<ElementLearnCategoryParentWhereUniqueInput>>;
  /** Update multiple ElementLearnCategoryParent component instances */
  update?: InputMaybe<Array<ElementLearnCategoryParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ElementLearnCategoryParent component instances */
  upsert?: InputMaybe<Array<ElementLearnCategoryParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ElementLearnCategoryParentUpdateManyWithNestedWhereInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateManyWithNestedWhereInput>;
};

export type ElementLearnCategoryParentUpdateOneInlineInput = {
  /** Create and connect one ElementLearnCategoryParent document */
  create?: InputMaybe<ElementLearnCategoryParentCreateInput>;
  /** Delete currently connected ElementLearnCategoryParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ElementLearnCategoryParent document */
  update?: InputMaybe<ElementLearnCategoryParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ElementLearnCategoryParent document */
  upsert?: InputMaybe<ElementLearnCategoryParentUpsertWithNestedWhereUniqueInput>;
};

export type ElementLearnCategoryParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ElementLearnCategoryParentUpdateWithNestedWhereUniqueInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpdateWithNestedWhereUniqueInput>;
};

export type ElementLearnCategoryParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ElementLearnCategoryParentUpsertWithNestedWhereUniqueInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnUpsertWithNestedWhereUniqueInput>;
};

export type ElementLearnCategoryParentWhereInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereInput>;
};

export type ElementLearnCategoryParentWhereUniqueInput = {
  CosmosSectionLearn?: InputMaybe<CosmosSectionLearnWhereUniqueInput>;
};

export type ElementLearnCategoryUpdateInput = {
  /** ago input for default locale (en) */
  ago?: InputMaybe<Scalars['String']['input']>;
  cardCount?: InputMaybe<Scalars['Int']['input']>;
  cards?: InputMaybe<ElementLearnCategorycardsUnionUpdateManyInlineInput>;
  categoryType?: InputMaybe<EnumLearnCategories>;
  cta?: InputMaybe<CosmosElementButtonUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ElementLearnCategoryUpdateLocalizationsInput>;
  remoteCards?: InputMaybe<CosmosRemoteLearnUpdateManyInlineInput>;
  remoteLearn?: InputMaybe<RemoteLearnUpdateOneInlineInput>;
  squareImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type ElementLearnCategoryUpdateLocalizationDataInput = {
  ago?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type ElementLearnCategoryUpdateLocalizationInput = {
  data: ElementLearnCategoryUpdateLocalizationDataInput;
  locale: Locale;
};

export type ElementLearnCategoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ElementLearnCategoryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ElementLearnCategoryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ElementLearnCategoryUpsertLocalizationInput>>;
};

export type ElementLearnCategoryUpdateManyInlineInput = {
  /** Create and connect multiple ElementLearnCategory component instances */
  create?: InputMaybe<Array<ElementLearnCategoryCreateWithPositionInput>>;
  /** Delete multiple ElementLearnCategory documents */
  delete?: InputMaybe<Array<ElementLearnCategoryWhereUniqueInput>>;
  /** Update multiple ElementLearnCategory component instances */
  update?: InputMaybe<Array<ElementLearnCategoryUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ElementLearnCategory component instances */
  upsert?: InputMaybe<Array<ElementLearnCategoryUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ElementLearnCategoryUpdateManyInput = {
  /** ago input for default locale (en) */
  ago?: InputMaybe<Scalars['String']['input']>;
  cardCount?: InputMaybe<Scalars['Int']['input']>;
  categoryType?: InputMaybe<EnumLearnCategories>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ElementLearnCategoryUpdateManyLocalizationsInput>;
  squareImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** titleHref input for default locale (en) */
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type ElementLearnCategoryUpdateManyLocalizationDataInput = {
  ago?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['RichTextAST']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
};

export type ElementLearnCategoryUpdateManyLocalizationInput = {
  data: ElementLearnCategoryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ElementLearnCategoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ElementLearnCategoryUpdateManyLocalizationInput>>;
};

export type ElementLearnCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ElementLearnCategoryUpdateManyInput;
  /** Document search */
  where: ElementLearnCategoryWhereInput;
};

export type ElementLearnCategoryUpdateOneInlineInput = {
  /** Create and connect one ElementLearnCategory document */
  create?: InputMaybe<ElementLearnCategoryCreateInput>;
  /** Delete currently connected ElementLearnCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ElementLearnCategory document */
  update?: InputMaybe<ElementLearnCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ElementLearnCategory document */
  upsert?: InputMaybe<ElementLearnCategoryUpsertWithNestedWhereUniqueInput>;
};

export type ElementLearnCategoryUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ElementLearnCategoryUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ElementLearnCategoryWhereUniqueInput;
};

export type ElementLearnCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ElementLearnCategoryUpdateInput;
  /** Unique document search */
  where: ElementLearnCategoryWhereUniqueInput;
};

export type ElementLearnCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: ElementLearnCategoryCreateInput;
  /** Update document if it exists */
  update: ElementLearnCategoryUpdateInput;
};

export type ElementLearnCategoryUpsertLocalizationInput = {
  create: ElementLearnCategoryCreateLocalizationDataInput;
  locale: Locale;
  update: ElementLearnCategoryUpdateLocalizationDataInput;
};

export type ElementLearnCategoryUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ElementLearnCategoryUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ElementLearnCategoryWhereUniqueInput;
};

export type ElementLearnCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ElementLearnCategoryUpsertInput;
  /** Unique document search */
  where: ElementLearnCategoryWhereUniqueInput;
};

/** Identifies documents */
export type ElementLearnCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ElementLearnCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ElementLearnCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ElementLearnCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ago?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ago_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ago_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ago_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ago_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ago_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ago_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ago_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ago_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ago_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardCount?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  cardCount_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  cardCount_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  cardCount_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  cardCount_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  cardCount_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  cardCount_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  cardCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values in which the union is empty. */
  cards_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  cards_some?: InputMaybe<ElementLearnCategorycardsUnionWhereInput>;
  categoryType?: InputMaybe<EnumLearnCategories>;
  /** All values that are contained in given list. */
  categoryType_in?: InputMaybe<Array<InputMaybe<EnumLearnCategories>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryType_not?: InputMaybe<EnumLearnCategories>;
  /** All values that are not contained in given list. */
  categoryType_not_in?: InputMaybe<Array<InputMaybe<EnumLearnCategories>>>;
  cta?: InputMaybe<CosmosElementButtonWhereInput>;
  desc?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  desc_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  desc_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  desc_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  desc_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  desc_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  desc_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  desc_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  desc_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  desc_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  remoteCards_every?: InputMaybe<CosmosRemoteLearnWhereInput>;
  remoteCards_none?: InputMaybe<CosmosRemoteLearnWhereInput>;
  remoteCards_some?: InputMaybe<CosmosRemoteLearnWhereInput>;
  remoteLearn?: InputMaybe<RemoteLearnWhereInput>;
  squareImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  squareImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  titleHref?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleHref_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleHref_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleHref_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleHref_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleHref_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleHref_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleHref_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleHref_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleHref_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ElementLearnCategory record uniquely */
export type ElementLearnCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ElementLearnCategorycardsUnion = CosmosElementLearnDocumentationCard | CosmosElementLearnImageCard;

export type ElementLearnCategorycardsUnionConnectInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardConnectInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardConnectInput>;
};

export type ElementLearnCategorycardsUnionCreateInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardCreateInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardCreateInput>;
};

export type ElementLearnCategorycardsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing ElementLearnCategorycardsUnion documents */
  create?: InputMaybe<Array<ElementLearnCategorycardsUnionCreateInput>>;
};

export type ElementLearnCategorycardsUnionCreateOneInlineInput = {
  /** Create and connect one ElementLearnCategorycardsUnion document */
  create?: InputMaybe<ElementLearnCategorycardsUnionCreateInput>;
};

export type ElementLearnCategorycardsUnionCreateWithPositionInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardCreateWithPositionInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardCreateWithPositionInput>;
};

export type ElementLearnCategorycardsUnionUpdateInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateInput>;
};

export type ElementLearnCategorycardsUnionUpdateManyInlineInput = {
  /** Create and connect multiple ElementLearnCategorycardsUnion component instances */
  create?: InputMaybe<Array<ElementLearnCategorycardsUnionCreateWithPositionInput>>;
  /** Delete multiple ElementLearnCategorycardsUnion documents */
  delete?: InputMaybe<Array<ElementLearnCategorycardsUnionWhereUniqueInput>>;
  /** Update multiple ElementLearnCategorycardsUnion component instances */
  update?: InputMaybe<Array<ElementLearnCategorycardsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ElementLearnCategorycardsUnion component instances */
  upsert?: InputMaybe<Array<ElementLearnCategorycardsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ElementLearnCategorycardsUnionUpdateManyWithNestedWhereInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateManyWithNestedWhereInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateManyWithNestedWhereInput>;
};

export type ElementLearnCategorycardsUnionUpdateOneInlineInput = {
  /** Create and connect one ElementLearnCategorycardsUnion document */
  create?: InputMaybe<ElementLearnCategorycardsUnionCreateInput>;
  /** Delete currently connected ElementLearnCategorycardsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ElementLearnCategorycardsUnion document */
  update?: InputMaybe<ElementLearnCategorycardsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ElementLearnCategorycardsUnion document */
  upsert?: InputMaybe<ElementLearnCategorycardsUnionUpsertWithNestedWhereUniqueInput>;
};

export type ElementLearnCategorycardsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ElementLearnCategorycardsUnionUpdateWithNestedWhereUniqueInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpdateWithNestedWhereUniqueInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpdateWithNestedWhereUniqueInput>;
};

export type ElementLearnCategorycardsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueAndPositionInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ElementLearnCategorycardsUnionUpsertWithNestedWhereUniqueInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardUpsertWithNestedWhereUniqueInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardUpsertWithNestedWhereUniqueInput>;
};

export type ElementLearnCategorycardsUnionWhereInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardWhereInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardWhereInput>;
};

export type ElementLearnCategorycardsUnionWhereUniqueInput = {
  CosmosElementLearnDocumentationCard?: InputMaybe<CosmosElementLearnDocumentationCardWhereUniqueInput>;
  CosmosElementLearnImageCard?: InputMaybe<CosmosElementLearnImageCardWhereUniqueInput>;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Asset system model */
  Asset = 'Asset',
  CommunityCard = 'CommunityCard',
  CommunityResource = 'CommunityResource',
  CosmosConfigBlog = 'CosmosConfigBlog',
  CosmosConfigSection = 'CosmosConfigSection',
  CosmosElementAccordionFeatureCard = 'CosmosElementAccordionFeatureCard',
  CosmosElementAccordionTierCard = 'CosmosElementAccordionTierCard',
  CosmosElementAccordionTierCtaCard = 'CosmosElementAccordionTierCtaCard',
  CosmosElementAccordionTierFeatureCard = 'CosmosElementAccordionTierFeatureCard',
  CosmosElementAgreementDetail = 'CosmosElementAgreementDetail',
  CosmosElementAriesCard = 'CosmosElementAriesCard',
  CosmosElementAsset = 'CosmosElementAsset',
  CosmosElementAvatar = 'CosmosElementAvatar',
  CosmosElementBlogCard = 'CosmosElementBlogCard',
  CosmosElementButton = 'CosmosElementButton',
  CosmosElementButtonList = 'CosmosElementButtonList',
  CosmosElementCalloutCard = 'CosmosElementCalloutCard',
  CosmosElementCheckListItem = 'CosmosElementCheckListItem',
  CosmosElementCkEditorText = 'CosmosElementCkEditorText',
  CosmosElementCkEditorTextCollapsible = 'CosmosElementCkEditorTextCollapsible',
  CosmosElementCompare = 'CosmosElementCompare',
  CosmosElementComplexCtaCard = 'CosmosElementComplexCtaCard',
  CosmosElementCruxLink = 'CosmosElementCruxLink',
  CosmosElementDelphinusCard = 'CosmosElementDelphinusCard',
  CosmosElementDocumentList = 'CosmosElementDocumentList',
  CosmosElementDocumentListItem = 'CosmosElementDocumentListItem',
  CosmosElementDownloadButton = 'CosmosElementDownloadButton',
  CosmosElementDownloadCard = 'CosmosElementDownloadCard',
  CosmosElementDownloadStep = 'CosmosElementDownloadStep',
  CosmosElementEdsIconLink = 'CosmosElementEdsIconLink',
  CosmosElementEventsTableRow = 'CosmosElementEventsTableRow',
  CosmosElementFaqItem = 'CosmosElementFAQItem',
  CosmosElementFaqTab = 'CosmosElementFaqTab',
  CosmosElementFeatureCard = 'CosmosElementFeatureCard',
  CosmosElementGameDevFeatureCard = 'CosmosElementGameDevFeatureCard',
  CosmosElementGeminiCard = 'CosmosElementGeminiCard',
  CosmosElementGeminiLink = 'CosmosElementGeminiLink',
  CosmosElementGithubGist = 'CosmosElementGithubGist',
  CosmosElementHydrusColumn = 'CosmosElementHydrusColumn',
  CosmosElementHydrusLink = 'CosmosElementHydrusLink',
  CosmosElementIconButton = 'CosmosElementIconButton',
  CosmosElementIconLinkGroup = 'CosmosElementIconLinkGroup',
  CosmosElementIconSectionHeading = 'CosmosElementIconSectionHeading',
  /** Image tag or badge component which includes an Image and a corresponding label with an href. See the NewsCard's author tag as an example. */
  CosmosElementImageTag = 'CosmosElementImageTag',
  CosmosElementIndustry = 'CosmosElementIndustry',
  /** A list of questions answered by an interviewee */
  CosmosElementInterview = 'CosmosElementInterview',
  CosmosElementInterviewQuestion = 'CosmosElementInterviewQuestion',
  CosmosElementLearnDocumentationCard = 'CosmosElementLearnDocumentationCard',
  CosmosElementLearnImageCard = 'CosmosElementLearnImageCard',
  CosmosElementLearnImageCardSource = 'CosmosElementLearnImageCardSource',
  CosmosElementLearnTab = 'CosmosElementLearnTab',
  CosmosElementLicenseCardCore = 'CosmosElementLicenseCardCore',
  CosmosElementLicenseCardTop = 'CosmosElementLicenseCardTop',
  CosmosElementLicenseCollapsedCard = 'CosmosElementLicenseCollapsedCard',
  CosmosElementLicenseContactCard = 'CosmosElementLicenseContactCard',
  CosmosElementLicenseMainCard = 'CosmosElementLicenseMainCard',
  CosmosElementLicenseSeat = 'CosmosElementLicenseSeat',
  CosmosElementLicenseTopCard = 'CosmosElementLicenseTopCard',
  CosmosElementLink = 'CosmosElementLink',
  CosmosElementLogo = 'CosmosElementLogo',
  CosmosElementLogoMultiCard = 'CosmosElementLogoMultiCard',
  CosmosElementNewsCard = 'CosmosElementNewsCard',
  CosmosElementNewsMediaCard = 'CosmosElementNewsMediaCard',
  CosmosElementNumberCallout = 'CosmosElementNumberCallout',
  CosmosElementPluginDownload = 'CosmosElementPluginDownload',
  CosmosElementPluginDownloadDetail = 'CosmosElementPluginDownloadDetail',
  CosmosElementPluginListItem = 'CosmosElementPluginListItem',
  CosmosElementQuote = 'CosmosElementQuote',
  CosmosElementResearchCard = 'CosmosElementResearchCard',
  CosmosElementResellerCard = 'CosmosElementResellerCard',
  CosmosElementRichText = 'CosmosElementRichText',
  CosmosElementSearchFilter = 'CosmosElementSearchFilter',
  CosmosElementSectionHeading = 'CosmosElementSectionHeading',
  CosmosElementSpeakerCard = 'CosmosElementSpeakerCard',
  CosmosElementTabbedBlogCardsItem = 'CosmosElementTabbedBlogCardsItem',
  CosmosElementTabbedContentImageItem = 'CosmosElementTabbedContentImageItem',
  /** Individual item/slide in the HeroBravo */
  CosmosElementTabbedFullWidthAssetItem = 'CosmosElementTabbedFullWidthAssetItem',
  /** Tag or badge component */
  CosmosElementTag = 'CosmosElementTag',
  CosmosElementTitleAndDesc = 'CosmosElementTitleAndDesc',
  CosmosElementUserProfile = 'CosmosElementUserProfile',
  /** Card inspired from the ones at the bottom of Unreal Tournament's website. */
  CosmosElementUtCard = 'CosmosElementUtCard',
  CosmosElementVideoEmbed = 'CosmosElementVideoEmbed',
  CosmosFeedBlogCard = 'CosmosFeedBlogCard',
  CosmosHeroAlpha = 'CosmosHeroAlpha',
  CosmosHeroArticleImage = 'CosmosHeroArticleImage',
  CosmosHeroBravo = 'CosmosHeroBravo',
  CosmosHeroGlow = 'CosmosHeroGlow',
  CosmosPageAgreement = 'CosmosPageAgreement',
  CosmosPageBlogDetail = 'CosmosPageBlogDetail',
  CosmosPageDirectory = 'CosmosPageDirectory',
  CosmosPageEulaKey = 'CosmosPageEulaKey',
  CosmosPageFeed = 'CosmosPageFeed',
  CosmosPageHeroAndSection = 'CosmosPageHeroAndSection',
  CosmosPageLegalContent = 'CosmosPageLegalContent',
  /** Model rendered at the /license page. */
  CosmosPageLicense = 'CosmosPageLicense',
  CosmosPagePluginDetail = 'CosmosPagePluginDetail',
  /** A page which simply redirects somewhere else. */
  CosmosPageRedirect = 'CosmosPageRedirect',
  CosmosPageResearch = 'CosmosPageResearch',
  CosmosPageSearch = 'CosmosPageSearch',
  CosmosRefIndustryList = 'CosmosRefIndustryList',
  /** Used to share FAQ Items. Changing items text or translation will change it across all places it is referenced. */
  CosmosReferenceFaqItem = 'CosmosReferenceFAQItem',
  CosmosReferenceSection = 'CosmosReferenceSection',
  CosmosRemoteLearn = 'CosmosRemoteLearn',
  CosmosSectionAccordionFeatureCard = 'CosmosSectionAccordionFeatureCard',
  CosmosSectionAccordionTierCards = 'CosmosSectionAccordionTierCards',
  CosmosSectionAriesCards = 'CosmosSectionAriesCards',
  CosmosSectionAsset = 'CosmosSectionAsset',
  CosmosSectionAssetCarousel = 'CosmosSectionAssetCarousel',
  CosmosSectionAssetGallery = 'CosmosSectionAssetGallery',
  CosmosSectionBlobTable = 'CosmosSectionBlobTable',
  CosmosSectionBlogCard = 'CosmosSectionBlogCard',
  CosmosSectionCkRichText = 'CosmosSectionCkRichText',
  CosmosSectionCommunity = 'CosmosSectionCommunity',
  CosmosSectionComplexCtaCard = 'CosmosSectionComplexCtaCard',
  CosmosSectionContentLargeImage = 'CosmosSectionContentLargeImage',
  CosmosSectionContentSliderAsset = 'CosmosSectionContentSliderAsset',
  CosmosSectionCrux = 'CosmosSectionCrux',
  CosmosSectionDelphinusCardsGrid = 'CosmosSectionDelphinusCardsGrid',
  CosmosSectionDevelopersList = 'CosmosSectionDevelopersList',
  CosmosSectionDivider = 'CosmosSectionDivider',
  CosmosSectionDownloadCard = 'CosmosSectionDownloadCard',
  CosmosSectionDownloadable = 'CosmosSectionDownloadable',
  CosmosSectionEmbed = 'CosmosSectionEmbed',
  CosmosSectionEventsTable = 'CosmosSectionEventsTable',
  CosmosSectionFaq = 'CosmosSectionFaq',
  CosmosSectionFaqSearch = 'CosmosSectionFaqSearch',
  CosmosSectionFeatureCard = 'CosmosSectionFeatureCard',
  CosmosSectionGameDevFeatureCard = 'CosmosSectionGameDevFeatureCard',
  CosmosSectionGeminiCard = 'CosmosSectionGeminiCard',
  CosmosSectionHydrusColumnList = 'CosmosSectionHydrusColumnList',
  /** The section is used to add automatically pulled data from the feed */
  CosmosSectionLatestNews = 'CosmosSectionLatestNews',
  CosmosSectionLearn = 'CosmosSectionLearn',
  CosmosSectionLicensesCollapsed = 'CosmosSectionLicensesCollapsed',
  CosmosSectionLogoList = 'CosmosSectionLogoList',
  CosmosSectionLogoMultiCard = 'CosmosSectionLogoMultiCard',
  CosmosSectionNewsCard = 'CosmosSectionNewsCard',
  CosmosSectionNewsMediaCard = 'CosmosSectionNewsMediaCard',
  CosmosSectionNewsletterSignup = 'CosmosSectionNewsletterSignup',
  CosmosSectionNumberCallout = 'CosmosSectionNumberCallout',
  CosmosSectionPluginListTable = 'CosmosSectionPluginListTable',
  CosmosSectionQuote = 'CosmosSectionQuote',
  CosmosSectionResellersSearch = 'CosmosSectionResellersSearch',
  CosmosSectionRichText = 'CosmosSectionRichText',
  /** Section uses Section Config Heading for Title, Desc, Buttons and Gradient. */
  CosmosSectionSimpleCta = 'CosmosSectionSimpleCta',
  CosmosSectionSlimContactCard = 'CosmosSectionSlimContactCard',
  CosmosSectionSpeakerCard = 'CosmosSectionSpeakerCard',
  CosmosSectionTabbedBlogCard = 'CosmosSectionTabbedBlogCard',
  CosmosSectionTabbedContentImage = 'CosmosSectionTabbedContentImage',
  /** Tabbed full width asset with content stack. Created for Twinmotion Uses pages. */
  CosmosSectionTabbedFullWidthAsset = 'CosmosSectionTabbedFullWidthAsset',
  /** Section containing cards inspired by the ones at the bottom of Unreal Tournament's website. */
  CosmosSectionUtCard = 'CosmosSectionUtCard',
  /** Fields which declare SEO related meta tags on the page. */
  CosmosSeo = 'CosmosSeo',
  ElementLearnCategory = 'ElementLearnCategory',
  RemoteLearn = 'RemoteLearn',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  /** User system model */
  User = 'User',
  WfRefApplicationOwner = 'WfRefApplicationOwner',
  WfRefBlogCategory = 'WfRefBlogCategory',
  WfRefBlogTag = 'WfRefBlogTag'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export enum EnumLearnCategories {
  AcademicResources = 'academic_resources',
  CommunityCourse = 'community_course',
  CommunityTutorial = 'community_tutorial',
  Course = 'course',
  Documentation = 'documentation',
  KnowledgeBase = 'knowledge_base',
  LearningPath = 'learning_path',
  Livestream = 'livestream',
  RecommendedCommunityTutorial = 'recommended_community_tutorial',
  SampleProjects = 'sample_projects',
  TalksAndDemos = 'talks_and_demos',
  Tutorial = 'tutorial'
}

/** Maximum cards to show. Defaults to 2. */
export enum EnumSmallNewsCardMax {
  Four = 'four',
  Two = 'two'
}

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one cosmosFeedBlogCard */
  createCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Create one cosmosPageAgreement */
  createCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Create one cosmosPageBlogDetail */
  createCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Create one cosmosPageDirectory */
  createCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Create one cosmosPageEulaKey */
  createCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Create one cosmosPageFeed */
  createCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Create one cosmosPageHeroAndSection */
  createCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Create one cosmosPageLegalContent */
  createCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Create one cosmosPageLicense */
  createCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Create one cosmosPagePluginDetail */
  createCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Create one cosmosPageRedirect */
  createCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Create one cosmosPageResearch */
  createCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Create one cosmosPageSearch */
  createCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Create one cosmosRefIndustryList */
  createCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Create one cosmosReferenceFAQItem */
  createCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Create one cosmosReferenceSection */
  createCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Create one cosmosRemoteLearn */
  createCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /** Create one remoteLearn */
  createRemoteLearn?: Maybe<RemoteLearn>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one wfRefApplicationOwner */
  createWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Create one wfRefBlogCategory */
  createWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Create one wfRefBlogTag */
  createWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one cosmosFeedBlogCard from _all_ existing stages. Returns deleted document. */
  deleteCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Delete one cosmosPageAgreement from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Delete one cosmosPageBlogDetail from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Delete one cosmosPageDirectory from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Delete one cosmosPageEulaKey from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Delete one cosmosPageFeed from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Delete one cosmosPageHeroAndSection from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Delete one cosmosPageLegalContent from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Delete one cosmosPageLicense from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Delete one cosmosPagePluginDetail from _all_ existing stages. Returns deleted document. */
  deleteCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Delete one cosmosPageRedirect from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Delete one cosmosPageResearch from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Delete one cosmosPageSearch from _all_ existing stages. Returns deleted document. */
  deleteCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Delete one cosmosRefIndustryList from _all_ existing stages. Returns deleted document. */
  deleteCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Delete one cosmosReferenceFAQItem from _all_ existing stages. Returns deleted document. */
  deleteCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Delete one cosmosReferenceSection from _all_ existing stages. Returns deleted document. */
  deleteCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Delete one cosmosRemoteLearn from _all_ existing stages. Returns deleted document. */
  deleteCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many CosmosFeedBlogCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosFeedBlogCardsConnection)
   */
  deleteManyCosmosFeedBlogCards: BatchPayload;
  /** Delete many CosmosFeedBlogCard documents, return deleted documents */
  deleteManyCosmosFeedBlogCardsConnection: CosmosFeedBlogCardConnection;
  /**
   * Delete many CosmosPageAgreement documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageAgreementsConnection)
   */
  deleteManyCosmosPageAgreements: BatchPayload;
  /** Delete many CosmosPageAgreement documents, return deleted documents */
  deleteManyCosmosPageAgreementsConnection: CosmosPageAgreementConnection;
  /**
   * Delete many CosmosPageBlogDetail documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageBlogDetailsConnection)
   */
  deleteManyCosmosPageBlogDetails: BatchPayload;
  /** Delete many CosmosPageBlogDetail documents, return deleted documents */
  deleteManyCosmosPageBlogDetailsConnection: CosmosPageBlogDetailConnection;
  /**
   * Delete many CosmosPageDirectory documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageDirectoriesConnection)
   */
  deleteManyCosmosPageDirectories: BatchPayload;
  /** Delete many CosmosPageDirectory documents, return deleted documents */
  deleteManyCosmosPageDirectoriesConnection: CosmosPageDirectoryConnection;
  /**
   * Delete many CosmosPageEulaKey documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageEulaKeysConnection)
   */
  deleteManyCosmosPageEulaKeys: BatchPayload;
  /** Delete many CosmosPageEulaKey documents, return deleted documents */
  deleteManyCosmosPageEulaKeysConnection: CosmosPageEulaKeyConnection;
  /**
   * Delete many CosmosPageFeed documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageFeedsConnection)
   */
  deleteManyCosmosPageFeeds: BatchPayload;
  /** Delete many CosmosPageFeed documents, return deleted documents */
  deleteManyCosmosPageFeedsConnection: CosmosPageFeedConnection;
  /**
   * Delete many CosmosPageHeroAndSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageHeroAndSectionsConnection)
   */
  deleteManyCosmosPageHeroAndSections: BatchPayload;
  /** Delete many CosmosPageHeroAndSection documents, return deleted documents */
  deleteManyCosmosPageHeroAndSectionsConnection: CosmosPageHeroAndSectionConnection;
  /**
   * Delete many CosmosPageLegalContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageLegalContentsConnection)
   */
  deleteManyCosmosPageLegalContents: BatchPayload;
  /** Delete many CosmosPageLegalContent documents, return deleted documents */
  deleteManyCosmosPageLegalContentsConnection: CosmosPageLegalContentConnection;
  /**
   * Delete many CosmosPageLicense documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageLicensesConnection)
   */
  deleteManyCosmosPageLicenses: BatchPayload;
  /** Delete many CosmosPageLicense documents, return deleted documents */
  deleteManyCosmosPageLicensesConnection: CosmosPageLicenseConnection;
  /**
   * Delete many CosmosPagePluginDetail documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPagePluginDetailsConnection)
   */
  deleteManyCosmosPagePluginDetails: BatchPayload;
  /** Delete many CosmosPagePluginDetail documents, return deleted documents */
  deleteManyCosmosPagePluginDetailsConnection: CosmosPagePluginDetailConnection;
  /**
   * Delete many CosmosPageRedirect documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageRedirectsConnection)
   */
  deleteManyCosmosPageRedirects: BatchPayload;
  /** Delete many CosmosPageRedirect documents, return deleted documents */
  deleteManyCosmosPageRedirectsConnection: CosmosPageRedirectConnection;
  /**
   * Delete many CosmosPageResearch documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageResearchesConnection)
   */
  deleteManyCosmosPageResearches: BatchPayload;
  /** Delete many CosmosPageResearch documents, return deleted documents */
  deleteManyCosmosPageResearchesConnection: CosmosPageResearchConnection;
  /**
   * Delete many CosmosPageSearch documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosPageSearchesConnection)
   */
  deleteManyCosmosPageSearches: BatchPayload;
  /** Delete many CosmosPageSearch documents, return deleted documents */
  deleteManyCosmosPageSearchesConnection: CosmosPageSearchConnection;
  /**
   * Delete many CosmosRefIndustryList documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosRefIndustryListsConnection)
   */
  deleteManyCosmosRefIndustryLists: BatchPayload;
  /** Delete many CosmosRefIndustryList documents, return deleted documents */
  deleteManyCosmosRefIndustryListsConnection: CosmosRefIndustryListConnection;
  /**
   * Delete many CosmosReferenceFAQItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosReferenceFAQItemsConnection)
   */
  deleteManyCosmosReferenceFAQItems: BatchPayload;
  /** Delete many CosmosReferenceFAQItem documents, return deleted documents */
  deleteManyCosmosReferenceFAQItemsConnection: CosmosReferenceFaqItemConnection;
  /**
   * Delete many CosmosReferenceSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosReferenceSectionsConnection)
   */
  deleteManyCosmosReferenceSections: BatchPayload;
  /** Delete many CosmosReferenceSection documents, return deleted documents */
  deleteManyCosmosReferenceSectionsConnection: CosmosReferenceSectionConnection;
  /**
   * Delete many CosmosRemoteLearn documents
   * @deprecated Please use the new paginated many mutation (deleteManyCosmosRemoteLearnsConnection)
   */
  deleteManyCosmosRemoteLearns: BatchPayload;
  /** Delete many CosmosRemoteLearn documents, return deleted documents */
  deleteManyCosmosRemoteLearnsConnection: CosmosRemoteLearnConnection;
  /**
   * Delete many RemoteLearn documents
   * @deprecated Please use the new paginated many mutation (deleteManyRemoteLearnsConnection)
   */
  deleteManyRemoteLearns: BatchPayload;
  /** Delete many RemoteLearn documents, return deleted documents */
  deleteManyRemoteLearnsConnection: RemoteLearnConnection;
  /**
   * Delete many WfRefApplicationOwner documents
   * @deprecated Please use the new paginated many mutation (deleteManyWfRefApplicationOwnersConnection)
   */
  deleteManyWfRefApplicationOwners: BatchPayload;
  /** Delete many WfRefApplicationOwner documents, return deleted documents */
  deleteManyWfRefApplicationOwnersConnection: WfRefApplicationOwnerConnection;
  /**
   * Delete many WfRefBlogCategory documents
   * @deprecated Please use the new paginated many mutation (deleteManyWfRefBlogCategoriesConnection)
   */
  deleteManyWfRefBlogCategories: BatchPayload;
  /** Delete many WfRefBlogCategory documents, return deleted documents */
  deleteManyWfRefBlogCategoriesConnection: WfRefBlogCategoryConnection;
  /**
   * Delete many WfRefBlogTag documents
   * @deprecated Please use the new paginated many mutation (deleteManyWfRefBlogTagsConnection)
   */
  deleteManyWfRefBlogTags: BatchPayload;
  /** Delete many WfRefBlogTag documents, return deleted documents */
  deleteManyWfRefBlogTagsConnection: WfRefBlogTagConnection;
  /** Delete one remoteLearn from _all_ existing stages. Returns deleted document. */
  deleteRemoteLearn?: Maybe<RemoteLearn>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one wfRefApplicationOwner from _all_ existing stages. Returns deleted document. */
  deleteWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Delete one wfRefBlogCategory from _all_ existing stages. Returns deleted document. */
  deleteWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Delete one wfRefBlogTag from _all_ existing stages. Returns deleted document. */
  deleteWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one cosmosFeedBlogCard */
  publishCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Publish one cosmosPageAgreement */
  publishCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Publish one cosmosPageBlogDetail */
  publishCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Publish one cosmosPageDirectory */
  publishCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Publish one cosmosPageEulaKey */
  publishCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Publish one cosmosPageFeed */
  publishCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Publish one cosmosPageHeroAndSection */
  publishCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Publish one cosmosPageLegalContent */
  publishCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Publish one cosmosPageLicense */
  publishCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Publish one cosmosPagePluginDetail */
  publishCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Publish one cosmosPageRedirect */
  publishCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Publish one cosmosPageResearch */
  publishCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Publish one cosmosPageSearch */
  publishCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Publish one cosmosRefIndustryList */
  publishCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Publish one cosmosReferenceFAQItem */
  publishCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Publish one cosmosReferenceSection */
  publishCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Publish one cosmosRemoteLearn */
  publishCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many CosmosFeedBlogCard documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosFeedBlogCardsConnection)
   */
  publishManyCosmosFeedBlogCards: BatchPayload;
  /** Publish many CosmosFeedBlogCard documents */
  publishManyCosmosFeedBlogCardsConnection: CosmosFeedBlogCardConnection;
  /**
   * Publish many CosmosPageAgreement documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageAgreementsConnection)
   */
  publishManyCosmosPageAgreements: BatchPayload;
  /** Publish many CosmosPageAgreement documents */
  publishManyCosmosPageAgreementsConnection: CosmosPageAgreementConnection;
  /**
   * Publish many CosmosPageBlogDetail documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageBlogDetailsConnection)
   */
  publishManyCosmosPageBlogDetails: BatchPayload;
  /** Publish many CosmosPageBlogDetail documents */
  publishManyCosmosPageBlogDetailsConnection: CosmosPageBlogDetailConnection;
  /**
   * Publish many CosmosPageDirectory documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageDirectoriesConnection)
   */
  publishManyCosmosPageDirectories: BatchPayload;
  /** Publish many CosmosPageDirectory documents */
  publishManyCosmosPageDirectoriesConnection: CosmosPageDirectoryConnection;
  /**
   * Publish many CosmosPageEulaKey documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageEulaKeysConnection)
   */
  publishManyCosmosPageEulaKeys: BatchPayload;
  /** Publish many CosmosPageEulaKey documents */
  publishManyCosmosPageEulaKeysConnection: CosmosPageEulaKeyConnection;
  /**
   * Publish many CosmosPageFeed documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageFeedsConnection)
   */
  publishManyCosmosPageFeeds: BatchPayload;
  /** Publish many CosmosPageFeed documents */
  publishManyCosmosPageFeedsConnection: CosmosPageFeedConnection;
  /**
   * Publish many CosmosPageHeroAndSection documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageHeroAndSectionsConnection)
   */
  publishManyCosmosPageHeroAndSections: BatchPayload;
  /** Publish many CosmosPageHeroAndSection documents */
  publishManyCosmosPageHeroAndSectionsConnection: CosmosPageHeroAndSectionConnection;
  /**
   * Publish many CosmosPageLegalContent documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageLegalContentsConnection)
   */
  publishManyCosmosPageLegalContents: BatchPayload;
  /** Publish many CosmosPageLegalContent documents */
  publishManyCosmosPageLegalContentsConnection: CosmosPageLegalContentConnection;
  /**
   * Publish many CosmosPageLicense documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageLicensesConnection)
   */
  publishManyCosmosPageLicenses: BatchPayload;
  /** Publish many CosmosPageLicense documents */
  publishManyCosmosPageLicensesConnection: CosmosPageLicenseConnection;
  /**
   * Publish many CosmosPagePluginDetail documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPagePluginDetailsConnection)
   */
  publishManyCosmosPagePluginDetails: BatchPayload;
  /** Publish many CosmosPagePluginDetail documents */
  publishManyCosmosPagePluginDetailsConnection: CosmosPagePluginDetailConnection;
  /**
   * Publish many CosmosPageRedirect documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageRedirectsConnection)
   */
  publishManyCosmosPageRedirects: BatchPayload;
  /** Publish many CosmosPageRedirect documents */
  publishManyCosmosPageRedirectsConnection: CosmosPageRedirectConnection;
  /**
   * Publish many CosmosPageResearch documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageResearchesConnection)
   */
  publishManyCosmosPageResearches: BatchPayload;
  /** Publish many CosmosPageResearch documents */
  publishManyCosmosPageResearchesConnection: CosmosPageResearchConnection;
  /**
   * Publish many CosmosPageSearch documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosPageSearchesConnection)
   */
  publishManyCosmosPageSearches: BatchPayload;
  /** Publish many CosmosPageSearch documents */
  publishManyCosmosPageSearchesConnection: CosmosPageSearchConnection;
  /**
   * Publish many CosmosRefIndustryList documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosRefIndustryListsConnection)
   */
  publishManyCosmosRefIndustryLists: BatchPayload;
  /** Publish many CosmosRefIndustryList documents */
  publishManyCosmosRefIndustryListsConnection: CosmosRefIndustryListConnection;
  /**
   * Publish many CosmosReferenceFAQItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosReferenceFAQItemsConnection)
   */
  publishManyCosmosReferenceFAQItems: BatchPayload;
  /** Publish many CosmosReferenceFAQItem documents */
  publishManyCosmosReferenceFAQItemsConnection: CosmosReferenceFaqItemConnection;
  /**
   * Publish many CosmosReferenceSection documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosReferenceSectionsConnection)
   */
  publishManyCosmosReferenceSections: BatchPayload;
  /** Publish many CosmosReferenceSection documents */
  publishManyCosmosReferenceSectionsConnection: CosmosReferenceSectionConnection;
  /**
   * Publish many CosmosRemoteLearn documents
   * @deprecated Please use the new paginated many mutation (publishManyCosmosRemoteLearnsConnection)
   */
  publishManyCosmosRemoteLearns: BatchPayload;
  /** Publish many CosmosRemoteLearn documents */
  publishManyCosmosRemoteLearnsConnection: CosmosRemoteLearnConnection;
  /**
   * Publish many RemoteLearn documents
   * @deprecated Please use the new paginated many mutation (publishManyRemoteLearnsConnection)
   */
  publishManyRemoteLearns: BatchPayload;
  /** Publish many RemoteLearn documents */
  publishManyRemoteLearnsConnection: RemoteLearnConnection;
  /**
   * Publish many WfRefApplicationOwner documents
   * @deprecated Please use the new paginated many mutation (publishManyWfRefApplicationOwnersConnection)
   */
  publishManyWfRefApplicationOwners: BatchPayload;
  /** Publish many WfRefApplicationOwner documents */
  publishManyWfRefApplicationOwnersConnection: WfRefApplicationOwnerConnection;
  /**
   * Publish many WfRefBlogCategory documents
   * @deprecated Please use the new paginated many mutation (publishManyWfRefBlogCategoriesConnection)
   */
  publishManyWfRefBlogCategories: BatchPayload;
  /** Publish many WfRefBlogCategory documents */
  publishManyWfRefBlogCategoriesConnection: WfRefBlogCategoryConnection;
  /**
   * Publish many WfRefBlogTag documents
   * @deprecated Please use the new paginated many mutation (publishManyWfRefBlogTagsConnection)
   */
  publishManyWfRefBlogTags: BatchPayload;
  /** Publish many WfRefBlogTag documents */
  publishManyWfRefBlogTagsConnection: WfRefBlogTagConnection;
  /** Publish one remoteLearn */
  publishRemoteLearn?: Maybe<RemoteLearn>;
  /** Publish one wfRefApplicationOwner */
  publishWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Publish one wfRefBlogCategory */
  publishWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Publish one wfRefBlogTag */
  publishWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one cosmosFeedBlogCard */
  schedulePublishCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Schedule to publish one cosmosPageAgreement */
  schedulePublishCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Schedule to publish one cosmosPageBlogDetail */
  schedulePublishCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Schedule to publish one cosmosPageDirectory */
  schedulePublishCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Schedule to publish one cosmosPageEulaKey */
  schedulePublishCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Schedule to publish one cosmosPageFeed */
  schedulePublishCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Schedule to publish one cosmosPageHeroAndSection */
  schedulePublishCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Schedule to publish one cosmosPageLegalContent */
  schedulePublishCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Schedule to publish one cosmosPageLicense */
  schedulePublishCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Schedule to publish one cosmosPagePluginDetail */
  schedulePublishCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Schedule to publish one cosmosPageRedirect */
  schedulePublishCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Schedule to publish one cosmosPageResearch */
  schedulePublishCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Schedule to publish one cosmosPageSearch */
  schedulePublishCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Schedule to publish one cosmosRefIndustryList */
  schedulePublishCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Schedule to publish one cosmosReferenceFAQItem */
  schedulePublishCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Schedule to publish one cosmosReferenceSection */
  schedulePublishCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Schedule to publish one cosmosRemoteLearn */
  schedulePublishCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /** Schedule to publish one remoteLearn */
  schedulePublishRemoteLearn?: Maybe<RemoteLearn>;
  /** Schedule to publish one wfRefApplicationOwner */
  schedulePublishWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Schedule to publish one wfRefBlogCategory */
  schedulePublishWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Schedule to publish one wfRefBlogTag */
  schedulePublishWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one cosmosFeedBlogCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Unpublish one cosmosPageAgreement from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Unpublish one cosmosPageBlogDetail from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Unpublish one cosmosPageDirectory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Unpublish one cosmosPageEulaKey from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Unpublish one cosmosPageFeed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Unpublish one cosmosPageHeroAndSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Unpublish one cosmosPageLegalContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Unpublish one cosmosPageLicense from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Unpublish one cosmosPagePluginDetail from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Unpublish one cosmosPageRedirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Unpublish one cosmosPageResearch from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Unpublish one cosmosPageSearch from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Unpublish one cosmosRefIndustryList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Unpublish one cosmosReferenceFAQItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Unpublish one cosmosReferenceSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Unpublish one cosmosRemoteLearn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /** Unpublish one remoteLearn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRemoteLearn?: Maybe<RemoteLearn>;
  /** Unpublish one wfRefApplicationOwner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Unpublish one wfRefBlogCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Unpublish one wfRefBlogTag from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one cosmosFeedBlogCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Unpublish one cosmosPageAgreement from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Unpublish one cosmosPageBlogDetail from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Unpublish one cosmosPageDirectory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Unpublish one cosmosPageEulaKey from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Unpublish one cosmosPageFeed from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Unpublish one cosmosPageHeroAndSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Unpublish one cosmosPageLegalContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Unpublish one cosmosPageLicense from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Unpublish one cosmosPagePluginDetail from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Unpublish one cosmosPageRedirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Unpublish one cosmosPageResearch from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Unpublish one cosmosPageSearch from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Unpublish one cosmosRefIndustryList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Unpublish one cosmosReferenceFAQItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Unpublish one cosmosReferenceSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Unpublish one cosmosRemoteLearn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many CosmosFeedBlogCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosFeedBlogCardsConnection)
   */
  unpublishManyCosmosFeedBlogCards: BatchPayload;
  /** Find many CosmosFeedBlogCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosFeedBlogCardsConnection: CosmosFeedBlogCardConnection;
  /**
   * Unpublish many CosmosPageAgreement documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageAgreementsConnection)
   */
  unpublishManyCosmosPageAgreements: BatchPayload;
  /** Find many CosmosPageAgreement documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageAgreementsConnection: CosmosPageAgreementConnection;
  /**
   * Unpublish many CosmosPageBlogDetail documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageBlogDetailsConnection)
   */
  unpublishManyCosmosPageBlogDetails: BatchPayload;
  /** Find many CosmosPageBlogDetail documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageBlogDetailsConnection: CosmosPageBlogDetailConnection;
  /**
   * Unpublish many CosmosPageDirectory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageDirectoriesConnection)
   */
  unpublishManyCosmosPageDirectories: BatchPayload;
  /** Find many CosmosPageDirectory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageDirectoriesConnection: CosmosPageDirectoryConnection;
  /**
   * Unpublish many CosmosPageEulaKey documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageEulaKeysConnection)
   */
  unpublishManyCosmosPageEulaKeys: BatchPayload;
  /** Find many CosmosPageEulaKey documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageEulaKeysConnection: CosmosPageEulaKeyConnection;
  /**
   * Unpublish many CosmosPageFeed documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageFeedsConnection)
   */
  unpublishManyCosmosPageFeeds: BatchPayload;
  /** Find many CosmosPageFeed documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageFeedsConnection: CosmosPageFeedConnection;
  /**
   * Unpublish many CosmosPageHeroAndSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageHeroAndSectionsConnection)
   */
  unpublishManyCosmosPageHeroAndSections: BatchPayload;
  /** Find many CosmosPageHeroAndSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageHeroAndSectionsConnection: CosmosPageHeroAndSectionConnection;
  /**
   * Unpublish many CosmosPageLegalContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageLegalContentsConnection)
   */
  unpublishManyCosmosPageLegalContents: BatchPayload;
  /** Find many CosmosPageLegalContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageLegalContentsConnection: CosmosPageLegalContentConnection;
  /**
   * Unpublish many CosmosPageLicense documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageLicensesConnection)
   */
  unpublishManyCosmosPageLicenses: BatchPayload;
  /** Find many CosmosPageLicense documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageLicensesConnection: CosmosPageLicenseConnection;
  /**
   * Unpublish many CosmosPagePluginDetail documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPagePluginDetailsConnection)
   */
  unpublishManyCosmosPagePluginDetails: BatchPayload;
  /** Find many CosmosPagePluginDetail documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPagePluginDetailsConnection: CosmosPagePluginDetailConnection;
  /**
   * Unpublish many CosmosPageRedirect documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageRedirectsConnection)
   */
  unpublishManyCosmosPageRedirects: BatchPayload;
  /** Find many CosmosPageRedirect documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageRedirectsConnection: CosmosPageRedirectConnection;
  /**
   * Unpublish many CosmosPageResearch documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageResearchesConnection)
   */
  unpublishManyCosmosPageResearches: BatchPayload;
  /** Find many CosmosPageResearch documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageResearchesConnection: CosmosPageResearchConnection;
  /**
   * Unpublish many CosmosPageSearch documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosPageSearchesConnection)
   */
  unpublishManyCosmosPageSearches: BatchPayload;
  /** Find many CosmosPageSearch documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosPageSearchesConnection: CosmosPageSearchConnection;
  /**
   * Unpublish many CosmosRefIndustryList documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosRefIndustryListsConnection)
   */
  unpublishManyCosmosRefIndustryLists: BatchPayload;
  /** Find many CosmosRefIndustryList documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosRefIndustryListsConnection: CosmosRefIndustryListConnection;
  /**
   * Unpublish many CosmosReferenceFAQItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosReferenceFAQItemsConnection)
   */
  unpublishManyCosmosReferenceFAQItems: BatchPayload;
  /** Find many CosmosReferenceFAQItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosReferenceFAQItemsConnection: CosmosReferenceFaqItemConnection;
  /**
   * Unpublish many CosmosReferenceSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosReferenceSectionsConnection)
   */
  unpublishManyCosmosReferenceSections: BatchPayload;
  /** Find many CosmosReferenceSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosReferenceSectionsConnection: CosmosReferenceSectionConnection;
  /**
   * Unpublish many CosmosRemoteLearn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCosmosRemoteLearnsConnection)
   */
  unpublishManyCosmosRemoteLearns: BatchPayload;
  /** Find many CosmosRemoteLearn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCosmosRemoteLearnsConnection: CosmosRemoteLearnConnection;
  /**
   * Unpublish many RemoteLearn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRemoteLearnsConnection)
   */
  unpublishManyRemoteLearns: BatchPayload;
  /** Find many RemoteLearn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRemoteLearnsConnection: RemoteLearnConnection;
  /**
   * Unpublish many WfRefApplicationOwner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyWfRefApplicationOwnersConnection)
   */
  unpublishManyWfRefApplicationOwners: BatchPayload;
  /** Find many WfRefApplicationOwner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyWfRefApplicationOwnersConnection: WfRefApplicationOwnerConnection;
  /**
   * Unpublish many WfRefBlogCategory documents
   * @deprecated Please use the new paginated many mutation (unpublishManyWfRefBlogCategoriesConnection)
   */
  unpublishManyWfRefBlogCategories: BatchPayload;
  /** Find many WfRefBlogCategory documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyWfRefBlogCategoriesConnection: WfRefBlogCategoryConnection;
  /**
   * Unpublish many WfRefBlogTag documents
   * @deprecated Please use the new paginated many mutation (unpublishManyWfRefBlogTagsConnection)
   */
  unpublishManyWfRefBlogTags: BatchPayload;
  /** Find many WfRefBlogTag documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyWfRefBlogTagsConnection: WfRefBlogTagConnection;
  /** Unpublish one remoteLearn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRemoteLearn?: Maybe<RemoteLearn>;
  /** Unpublish one wfRefApplicationOwner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Unpublish one wfRefBlogCategory from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Unpublish one wfRefBlogTag from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one cosmosFeedBlogCard */
  updateCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Update one cosmosPageAgreement */
  updateCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Update one cosmosPageBlogDetail */
  updateCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Update one cosmosPageDirectory */
  updateCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Update one cosmosPageEulaKey */
  updateCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Update one cosmosPageFeed */
  updateCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Update one cosmosPageHeroAndSection */
  updateCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Update one cosmosPageLegalContent */
  updateCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Update one cosmosPageLicense */
  updateCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Update one cosmosPagePluginDetail */
  updateCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Update one cosmosPageRedirect */
  updateCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Update one cosmosPageResearch */
  updateCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Update one cosmosPageSearch */
  updateCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Update one cosmosRefIndustryList */
  updateCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Update one cosmosReferenceFAQItem */
  updateCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Update one cosmosReferenceSection */
  updateCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Update one cosmosRemoteLearn */
  updateCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many cosmosFeedBlogCards
   * @deprecated Please use the new paginated many mutation (updateManyCosmosFeedBlogCardsConnection)
   */
  updateManyCosmosFeedBlogCards: BatchPayload;
  /** Update many CosmosFeedBlogCard documents */
  updateManyCosmosFeedBlogCardsConnection: CosmosFeedBlogCardConnection;
  /**
   * Update many cosmosPageAgreements
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageAgreementsConnection)
   */
  updateManyCosmosPageAgreements: BatchPayload;
  /** Update many CosmosPageAgreement documents */
  updateManyCosmosPageAgreementsConnection: CosmosPageAgreementConnection;
  /**
   * Update many cosmosPageBlogDetails
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageBlogDetailsConnection)
   */
  updateManyCosmosPageBlogDetails: BatchPayload;
  /** Update many CosmosPageBlogDetail documents */
  updateManyCosmosPageBlogDetailsConnection: CosmosPageBlogDetailConnection;
  /**
   * Update many cosmosPageDirectories
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageDirectoriesConnection)
   */
  updateManyCosmosPageDirectories: BatchPayload;
  /** Update many CosmosPageDirectory documents */
  updateManyCosmosPageDirectoriesConnection: CosmosPageDirectoryConnection;
  /**
   * Update many cosmosPageEulaKeys
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageEulaKeysConnection)
   */
  updateManyCosmosPageEulaKeys: BatchPayload;
  /** Update many CosmosPageEulaKey documents */
  updateManyCosmosPageEulaKeysConnection: CosmosPageEulaKeyConnection;
  /**
   * Update many cosmosPageFeeds
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageFeedsConnection)
   */
  updateManyCosmosPageFeeds: BatchPayload;
  /** Update many CosmosPageFeed documents */
  updateManyCosmosPageFeedsConnection: CosmosPageFeedConnection;
  /**
   * Update many cosmosPageHeroAndSections
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageHeroAndSectionsConnection)
   */
  updateManyCosmosPageHeroAndSections: BatchPayload;
  /** Update many CosmosPageHeroAndSection documents */
  updateManyCosmosPageHeroAndSectionsConnection: CosmosPageHeroAndSectionConnection;
  /**
   * Update many cosmosPageLegalContents
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageLegalContentsConnection)
   */
  updateManyCosmosPageLegalContents: BatchPayload;
  /** Update many CosmosPageLegalContent documents */
  updateManyCosmosPageLegalContentsConnection: CosmosPageLegalContentConnection;
  /**
   * Update many cosmosPageLicenses
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageLicensesConnection)
   */
  updateManyCosmosPageLicenses: BatchPayload;
  /** Update many CosmosPageLicense documents */
  updateManyCosmosPageLicensesConnection: CosmosPageLicenseConnection;
  /**
   * Update many cosmosPagePluginDetails
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPagePluginDetailsConnection)
   */
  updateManyCosmosPagePluginDetails: BatchPayload;
  /** Update many CosmosPagePluginDetail documents */
  updateManyCosmosPagePluginDetailsConnection: CosmosPagePluginDetailConnection;
  /**
   * Update many cosmosPageRedirects
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageRedirectsConnection)
   */
  updateManyCosmosPageRedirects: BatchPayload;
  /** Update many CosmosPageRedirect documents */
  updateManyCosmosPageRedirectsConnection: CosmosPageRedirectConnection;
  /**
   * Update many cosmosPageResearches
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageResearchesConnection)
   */
  updateManyCosmosPageResearches: BatchPayload;
  /** Update many CosmosPageResearch documents */
  updateManyCosmosPageResearchesConnection: CosmosPageResearchConnection;
  /**
   * Update many cosmosPageSearches
   * @deprecated Please use the new paginated many mutation (updateManyCosmosPageSearchesConnection)
   */
  updateManyCosmosPageSearches: BatchPayload;
  /** Update many CosmosPageSearch documents */
  updateManyCosmosPageSearchesConnection: CosmosPageSearchConnection;
  /**
   * Update many cosmosRefIndustryLists
   * @deprecated Please use the new paginated many mutation (updateManyCosmosRefIndustryListsConnection)
   */
  updateManyCosmosRefIndustryLists: BatchPayload;
  /** Update many CosmosRefIndustryList documents */
  updateManyCosmosRefIndustryListsConnection: CosmosRefIndustryListConnection;
  /**
   * Update many cosmosReferenceFAQItems
   * @deprecated Please use the new paginated many mutation (updateManyCosmosReferenceFAQItemsConnection)
   */
  updateManyCosmosReferenceFAQItems: BatchPayload;
  /** Update many CosmosReferenceFAQItem documents */
  updateManyCosmosReferenceFAQItemsConnection: CosmosReferenceFaqItemConnection;
  /**
   * Update many cosmosReferenceSections
   * @deprecated Please use the new paginated many mutation (updateManyCosmosReferenceSectionsConnection)
   */
  updateManyCosmosReferenceSections: BatchPayload;
  /** Update many CosmosReferenceSection documents */
  updateManyCosmosReferenceSectionsConnection: CosmosReferenceSectionConnection;
  /**
   * Update many cosmosRemoteLearns
   * @deprecated Please use the new paginated many mutation (updateManyCosmosRemoteLearnsConnection)
   */
  updateManyCosmosRemoteLearns: BatchPayload;
  /** Update many CosmosRemoteLearn documents */
  updateManyCosmosRemoteLearnsConnection: CosmosRemoteLearnConnection;
  /**
   * Update many remoteLearns
   * @deprecated Please use the new paginated many mutation (updateManyRemoteLearnsConnection)
   */
  updateManyRemoteLearns: BatchPayload;
  /** Update many RemoteLearn documents */
  updateManyRemoteLearnsConnection: RemoteLearnConnection;
  /**
   * Update many wfRefApplicationOwners
   * @deprecated Please use the new paginated many mutation (updateManyWfRefApplicationOwnersConnection)
   */
  updateManyWfRefApplicationOwners: BatchPayload;
  /** Update many WfRefApplicationOwner documents */
  updateManyWfRefApplicationOwnersConnection: WfRefApplicationOwnerConnection;
  /**
   * Update many wfRefBlogCategories
   * @deprecated Please use the new paginated many mutation (updateManyWfRefBlogCategoriesConnection)
   */
  updateManyWfRefBlogCategories: BatchPayload;
  /** Update many WfRefBlogCategory documents */
  updateManyWfRefBlogCategoriesConnection: WfRefBlogCategoryConnection;
  /**
   * Update many wfRefBlogTags
   * @deprecated Please use the new paginated many mutation (updateManyWfRefBlogTagsConnection)
   */
  updateManyWfRefBlogTags: BatchPayload;
  /** Update many WfRefBlogTag documents */
  updateManyWfRefBlogTagsConnection: WfRefBlogTagConnection;
  /** Update one remoteLearn */
  updateRemoteLearn?: Maybe<RemoteLearn>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one wfRefApplicationOwner */
  updateWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Update one wfRefBlogCategory */
  updateWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Update one wfRefBlogTag */
  updateWfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one cosmosFeedBlogCard */
  upsertCosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Upsert one cosmosPageAgreement */
  upsertCosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Upsert one cosmosPageBlogDetail */
  upsertCosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Upsert one cosmosPageDirectory */
  upsertCosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Upsert one cosmosPageEulaKey */
  upsertCosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Upsert one cosmosPageFeed */
  upsertCosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Upsert one cosmosPageHeroAndSection */
  upsertCosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Upsert one cosmosPageLegalContent */
  upsertCosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Upsert one cosmosPageLicense */
  upsertCosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Upsert one cosmosPagePluginDetail */
  upsertCosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Upsert one cosmosPageRedirect */
  upsertCosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Upsert one cosmosPageResearch */
  upsertCosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Upsert one cosmosPageSearch */
  upsertCosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Upsert one cosmosRefIndustryList */
  upsertCosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Upsert one cosmosReferenceFAQItem */
  upsertCosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Upsert one cosmosReferenceSection */
  upsertCosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Upsert one cosmosRemoteLearn */
  upsertCosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /** Upsert one remoteLearn */
  upsertRemoteLearn?: Maybe<RemoteLearn>;
  /** Upsert one wfRefApplicationOwner */
  upsertWfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Upsert one wfRefBlogCategory */
  upsertWfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Upsert one wfRefBlogTag */
  upsertWfRefBlogTag?: Maybe<WfRefBlogTag>;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateCosmosFeedBlogCardArgs = {
  data: CosmosFeedBlogCardCreateInput;
};


export type MutationCreateCosmosPageAgreementArgs = {
  data: CosmosPageAgreementCreateInput;
};


export type MutationCreateCosmosPageBlogDetailArgs = {
  data: CosmosPageBlogDetailCreateInput;
};


export type MutationCreateCosmosPageDirectoryArgs = {
  data: CosmosPageDirectoryCreateInput;
};


export type MutationCreateCosmosPageEulaKeyArgs = {
  data: CosmosPageEulaKeyCreateInput;
};


export type MutationCreateCosmosPageFeedArgs = {
  data: CosmosPageFeedCreateInput;
};


export type MutationCreateCosmosPageHeroAndSectionArgs = {
  data: CosmosPageHeroAndSectionCreateInput;
};


export type MutationCreateCosmosPageLegalContentArgs = {
  data: CosmosPageLegalContentCreateInput;
};


export type MutationCreateCosmosPageLicenseArgs = {
  data: CosmosPageLicenseCreateInput;
};


export type MutationCreateCosmosPagePluginDetailArgs = {
  data: CosmosPagePluginDetailCreateInput;
};


export type MutationCreateCosmosPageRedirectArgs = {
  data: CosmosPageRedirectCreateInput;
};


export type MutationCreateCosmosPageResearchArgs = {
  data: CosmosPageResearchCreateInput;
};


export type MutationCreateCosmosPageSearchArgs = {
  data: CosmosPageSearchCreateInput;
};


export type MutationCreateCosmosRefIndustryListArgs = {
  data: CosmosRefIndustryListCreateInput;
};


export type MutationCreateCosmosReferenceFaqItemArgs = {
  data: CosmosReferenceFaqItemCreateInput;
};


export type MutationCreateCosmosReferenceSectionArgs = {
  data: CosmosReferenceSectionCreateInput;
};


export type MutationCreateCosmosRemoteLearnArgs = {
  data: CosmosRemoteLearnCreateInput;
};


export type MutationCreateRemoteLearnArgs = {
  data: RemoteLearnCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateWfRefApplicationOwnerArgs = {
  data: WfRefApplicationOwnerCreateInput;
};


export type MutationCreateWfRefBlogCategoryArgs = {
  data: WfRefBlogCategoryCreateInput;
};


export type MutationCreateWfRefBlogTagArgs = {
  data: WfRefBlogTagCreateInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteCosmosFeedBlogCardArgs = {
  where: CosmosFeedBlogCardWhereUniqueInput;
};


export type MutationDeleteCosmosPageAgreementArgs = {
  where: CosmosPageAgreementWhereUniqueInput;
};


export type MutationDeleteCosmosPageBlogDetailArgs = {
  where: CosmosPageBlogDetailWhereUniqueInput;
};


export type MutationDeleteCosmosPageDirectoryArgs = {
  where: CosmosPageDirectoryWhereUniqueInput;
};


export type MutationDeleteCosmosPageEulaKeyArgs = {
  where: CosmosPageEulaKeyWhereUniqueInput;
};


export type MutationDeleteCosmosPageFeedArgs = {
  where: CosmosPageFeedWhereUniqueInput;
};


export type MutationDeleteCosmosPageHeroAndSectionArgs = {
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};


export type MutationDeleteCosmosPageLegalContentArgs = {
  where: CosmosPageLegalContentWhereUniqueInput;
};


export type MutationDeleteCosmosPageLicenseArgs = {
  where: CosmosPageLicenseWhereUniqueInput;
};


export type MutationDeleteCosmosPagePluginDetailArgs = {
  where: CosmosPagePluginDetailWhereUniqueInput;
};


export type MutationDeleteCosmosPageRedirectArgs = {
  where: CosmosPageRedirectWhereUniqueInput;
};


export type MutationDeleteCosmosPageResearchArgs = {
  where: CosmosPageResearchWhereUniqueInput;
};


export type MutationDeleteCosmosPageSearchArgs = {
  where: CosmosPageSearchWhereUniqueInput;
};


export type MutationDeleteCosmosRefIndustryListArgs = {
  where: CosmosRefIndustryListWhereUniqueInput;
};


export type MutationDeleteCosmosReferenceFaqItemArgs = {
  where: CosmosReferenceFaqItemWhereUniqueInput;
};


export type MutationDeleteCosmosReferenceSectionArgs = {
  where: CosmosReferenceSectionWhereUniqueInput;
};


export type MutationDeleteCosmosRemoteLearnArgs = {
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyCosmosFeedBlogCardsArgs = {
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
};


export type MutationDeleteManyCosmosFeedBlogCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
};


export type MutationDeleteManyCosmosPageAgreementsArgs = {
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
};


export type MutationDeleteManyCosmosPageAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
};


export type MutationDeleteManyCosmosPageBlogDetailsArgs = {
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
};


export type MutationDeleteManyCosmosPageBlogDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
};


export type MutationDeleteManyCosmosPageDirectoriesArgs = {
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
};


export type MutationDeleteManyCosmosPageDirectoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
};


export type MutationDeleteManyCosmosPageEulaKeysArgs = {
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
};


export type MutationDeleteManyCosmosPageEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
};


export type MutationDeleteManyCosmosPageFeedsArgs = {
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
};


export type MutationDeleteManyCosmosPageFeedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
};


export type MutationDeleteManyCosmosPageHeroAndSectionsArgs = {
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
};


export type MutationDeleteManyCosmosPageHeroAndSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
};


export type MutationDeleteManyCosmosPageLegalContentsArgs = {
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
};


export type MutationDeleteManyCosmosPageLegalContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
};


export type MutationDeleteManyCosmosPageLicensesArgs = {
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
};


export type MutationDeleteManyCosmosPageLicensesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
};


export type MutationDeleteManyCosmosPagePluginDetailsArgs = {
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
};


export type MutationDeleteManyCosmosPagePluginDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
};


export type MutationDeleteManyCosmosPageRedirectsArgs = {
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
};


export type MutationDeleteManyCosmosPageRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
};


export type MutationDeleteManyCosmosPageResearchesArgs = {
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
};


export type MutationDeleteManyCosmosPageResearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
};


export type MutationDeleteManyCosmosPageSearchesArgs = {
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
};


export type MutationDeleteManyCosmosPageSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
};


export type MutationDeleteManyCosmosRefIndustryListsArgs = {
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
};


export type MutationDeleteManyCosmosRefIndustryListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
};


export type MutationDeleteManyCosmosReferenceFaqItemsArgs = {
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
};


export type MutationDeleteManyCosmosReferenceFaqItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
};


export type MutationDeleteManyCosmosReferenceSectionsArgs = {
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
};


export type MutationDeleteManyCosmosReferenceSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
};


export type MutationDeleteManyCosmosRemoteLearnsArgs = {
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationDeleteManyCosmosRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationDeleteManyRemoteLearnsArgs = {
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationDeleteManyRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationDeleteManyWfRefApplicationOwnersArgs = {
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationDeleteManyWfRefApplicationOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationDeleteManyWfRefBlogCategoriesArgs = {
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
};


export type MutationDeleteManyWfRefBlogCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
};


export type MutationDeleteManyWfRefBlogTagsArgs = {
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
};


export type MutationDeleteManyWfRefBlogTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
};


export type MutationDeleteRemoteLearnArgs = {
  where: RemoteLearnWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteWfRefApplicationOwnerArgs = {
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationDeleteWfRefBlogCategoryArgs = {
  where: WfRefBlogCategoryWhereUniqueInput;
};


export type MutationDeleteWfRefBlogTagArgs = {
  where: WfRefBlogTagWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosFeedBlogCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosFeedBlogCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageAgreementArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageAgreementWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageBlogDetailArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageBlogDetailWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageDirectoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageDirectoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageEulaKeyArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageEulaKeyWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageFeedArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageFeedWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageHeroAndSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageLegalContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageLegalContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageLicenseArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageLicenseWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPagePluginDetailArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPagePluginDetailWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageRedirectArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageRedirectWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageResearchArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageResearchWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosPageSearchArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosPageSearchWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosRefIndustryListArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosRefIndustryListWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosReferenceFaqItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosReferenceFaqItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosReferenceSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CosmosReferenceSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCosmosRemoteLearnArgs = {
  to?: Array<Stage>;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosFeedBlogCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosFeedBlogCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageAgreementsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageBlogDetailsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageBlogDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageDirectoriesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageDirectoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageEulaKeysArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageFeedsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageFeedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageHeroAndSectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageHeroAndSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageLegalContentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageLegalContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageLicensesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageLicensesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPagePluginDetailsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPagePluginDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageRedirectsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageResearchesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageResearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageSearchesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosPageSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosRefIndustryListsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosRefIndustryListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosReferenceFaqItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosReferenceFaqItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosReferenceSectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosReferenceSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCosmosRemoteLearnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationPublishManyCosmosRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationPublishManyRemoteLearnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationPublishManyRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationPublishManyWfRefApplicationOwnersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationPublishManyWfRefApplicationOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationPublishManyWfRefBlogCategoriesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyWfRefBlogCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyWfRefBlogTagsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyWfRefBlogTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishRemoteLearnArgs = {
  to?: Array<Stage>;
  where: RemoteLearnWhereUniqueInput;
};


export type MutationPublishWfRefApplicationOwnerArgs = {
  to?: Array<Stage>;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationPublishWfRefBlogCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: WfRefBlogCategoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishWfRefBlogTagArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: WfRefBlogTagWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosFeedBlogCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosFeedBlogCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageAgreementArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageAgreementWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageBlogDetailArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageBlogDetailWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageDirectoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageDirectoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageEulaKeyArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageEulaKeyWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageFeedArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageFeedWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageHeroAndSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageLegalContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageLegalContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageLicenseArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageLicenseWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPagePluginDetailArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPagePluginDetailWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageRedirectArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageRedirectWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageResearchArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageResearchWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosPageSearchArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosPageSearchWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosRefIndustryListArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosRefIndustryListWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosReferenceFaqItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosReferenceFaqItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosReferenceSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosReferenceSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCosmosRemoteLearnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationSchedulePublishRemoteLearnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RemoteLearnWhereUniqueInput;
};


export type MutationSchedulePublishWfRefApplicationOwnerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationSchedulePublishWfRefBlogCategoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: WfRefBlogCategoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishWfRefBlogTagArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: WfRefBlogTagWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosFeedBlogCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosFeedBlogCardWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageAgreementArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageAgreementWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageBlogDetailArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageBlogDetailWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageDirectoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageDirectoryWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageEulaKeyArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageEulaKeyWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageFeedArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageFeedWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageHeroAndSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageLegalContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageLegalContentWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageLicenseArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageLicenseWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPagePluginDetailArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPagePluginDetailWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageRedirectArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageRedirectWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageResearchArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageResearchWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosPageSearchArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageSearchWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosRefIndustryListArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosRefIndustryListWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosReferenceFaqItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosReferenceFaqItemWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosReferenceSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosReferenceSectionWhereUniqueInput;
};


export type MutationScheduleUnpublishCosmosRemoteLearnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationScheduleUnpublishRemoteLearnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RemoteLearnWhereUniqueInput;
};


export type MutationScheduleUnpublishWfRefApplicationOwnerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationScheduleUnpublishWfRefBlogCategoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: WfRefBlogCategoryWhereUniqueInput;
};


export type MutationScheduleUnpublishWfRefBlogTagArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: WfRefBlogTagWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishCosmosFeedBlogCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosFeedBlogCardWhereUniqueInput;
};


export type MutationUnpublishCosmosPageAgreementArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageAgreementWhereUniqueInput;
};


export type MutationUnpublishCosmosPageBlogDetailArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageBlogDetailWhereUniqueInput;
};


export type MutationUnpublishCosmosPageDirectoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageDirectoryWhereUniqueInput;
};


export type MutationUnpublishCosmosPageEulaKeyArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageEulaKeyWhereUniqueInput;
};


export type MutationUnpublishCosmosPageFeedArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageFeedWhereUniqueInput;
};


export type MutationUnpublishCosmosPageHeroAndSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};


export type MutationUnpublishCosmosPageLegalContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageLegalContentWhereUniqueInput;
};


export type MutationUnpublishCosmosPageLicenseArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageLicenseWhereUniqueInput;
};


export type MutationUnpublishCosmosPagePluginDetailArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPagePluginDetailWhereUniqueInput;
};


export type MutationUnpublishCosmosPageRedirectArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageRedirectWhereUniqueInput;
};


export type MutationUnpublishCosmosPageResearchArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageResearchWhereUniqueInput;
};


export type MutationUnpublishCosmosPageSearchArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosPageSearchWhereUniqueInput;
};


export type MutationUnpublishCosmosRefIndustryListArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosRefIndustryListWhereUniqueInput;
};


export type MutationUnpublishCosmosReferenceFaqItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosReferenceFaqItemWhereUniqueInput;
};


export type MutationUnpublishCosmosReferenceSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CosmosReferenceSectionWhereUniqueInput;
};


export type MutationUnpublishCosmosRemoteLearnArgs = {
  from?: Array<Stage>;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyCosmosFeedBlogCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
};


export type MutationUnpublishManyCosmosFeedBlogCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageAgreementsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageBlogDetailsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageBlogDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageDirectoriesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageDirectoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageEulaKeysArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageFeedsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageFeedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageHeroAndSectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageHeroAndSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageLegalContentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageLegalContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageLicensesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageLicensesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
};


export type MutationUnpublishManyCosmosPagePluginDetailsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
};


export type MutationUnpublishManyCosmosPagePluginDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageRedirectsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageResearchesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageResearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageSearchesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
};


export type MutationUnpublishManyCosmosPageSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
};


export type MutationUnpublishManyCosmosRefIndustryListsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
};


export type MutationUnpublishManyCosmosRefIndustryListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
};


export type MutationUnpublishManyCosmosReferenceFaqItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
};


export type MutationUnpublishManyCosmosReferenceFaqItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
};


export type MutationUnpublishManyCosmosReferenceSectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
};


export type MutationUnpublishManyCosmosReferenceSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
};


export type MutationUnpublishManyCosmosRemoteLearnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationUnpublishManyCosmosRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationUnpublishManyRemoteLearnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationUnpublishManyRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationUnpublishManyWfRefApplicationOwnersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationUnpublishManyWfRefApplicationOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationUnpublishManyWfRefBlogCategoriesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
};


export type MutationUnpublishManyWfRefBlogCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
};


export type MutationUnpublishManyWfRefBlogTagsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
};


export type MutationUnpublishManyWfRefBlogTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
};


export type MutationUnpublishRemoteLearnArgs = {
  from?: Array<Stage>;
  where: RemoteLearnWhereUniqueInput;
};


export type MutationUnpublishWfRefApplicationOwnerArgs = {
  from?: Array<Stage>;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationUnpublishWfRefBlogCategoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: WfRefBlogCategoryWhereUniqueInput;
};


export type MutationUnpublishWfRefBlogTagArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: WfRefBlogTagWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateCosmosFeedBlogCardArgs = {
  data: CosmosFeedBlogCardUpdateInput;
  where: CosmosFeedBlogCardWhereUniqueInput;
};


export type MutationUpdateCosmosPageAgreementArgs = {
  data: CosmosPageAgreementUpdateInput;
  where: CosmosPageAgreementWhereUniqueInput;
};


export type MutationUpdateCosmosPageBlogDetailArgs = {
  data: CosmosPageBlogDetailUpdateInput;
  where: CosmosPageBlogDetailWhereUniqueInput;
};


export type MutationUpdateCosmosPageDirectoryArgs = {
  data: CosmosPageDirectoryUpdateInput;
  where: CosmosPageDirectoryWhereUniqueInput;
};


export type MutationUpdateCosmosPageEulaKeyArgs = {
  data: CosmosPageEulaKeyUpdateInput;
  where: CosmosPageEulaKeyWhereUniqueInput;
};


export type MutationUpdateCosmosPageFeedArgs = {
  data: CosmosPageFeedUpdateInput;
  where: CosmosPageFeedWhereUniqueInput;
};


export type MutationUpdateCosmosPageHeroAndSectionArgs = {
  data: CosmosPageHeroAndSectionUpdateInput;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};


export type MutationUpdateCosmosPageLegalContentArgs = {
  data: CosmosPageLegalContentUpdateInput;
  where: CosmosPageLegalContentWhereUniqueInput;
};


export type MutationUpdateCosmosPageLicenseArgs = {
  data: CosmosPageLicenseUpdateInput;
  where: CosmosPageLicenseWhereUniqueInput;
};


export type MutationUpdateCosmosPagePluginDetailArgs = {
  data: CosmosPagePluginDetailUpdateInput;
  where: CosmosPagePluginDetailWhereUniqueInput;
};


export type MutationUpdateCosmosPageRedirectArgs = {
  data: CosmosPageRedirectUpdateInput;
  where: CosmosPageRedirectWhereUniqueInput;
};


export type MutationUpdateCosmosPageResearchArgs = {
  data: CosmosPageResearchUpdateInput;
  where: CosmosPageResearchWhereUniqueInput;
};


export type MutationUpdateCosmosPageSearchArgs = {
  data: CosmosPageSearchUpdateInput;
  where: CosmosPageSearchWhereUniqueInput;
};


export type MutationUpdateCosmosRefIndustryListArgs = {
  data: CosmosRefIndustryListUpdateInput;
  where: CosmosRefIndustryListWhereUniqueInput;
};


export type MutationUpdateCosmosReferenceFaqItemArgs = {
  data: CosmosReferenceFaqItemUpdateInput;
  where: CosmosReferenceFaqItemWhereUniqueInput;
};


export type MutationUpdateCosmosReferenceSectionArgs = {
  data: CosmosReferenceSectionUpdateInput;
  where: CosmosReferenceSectionWhereUniqueInput;
};


export type MutationUpdateCosmosRemoteLearnArgs = {
  data: CosmosRemoteLearnUpdateInput;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyCosmosFeedBlogCardsArgs = {
  data: CosmosFeedBlogCardUpdateManyInput;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
};


export type MutationUpdateManyCosmosFeedBlogCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosFeedBlogCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosFeedBlogCardManyWhereInput>;
};


export type MutationUpdateManyCosmosPageAgreementsArgs = {
  data: CosmosPageAgreementUpdateManyInput;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
};


export type MutationUpdateManyCosmosPageAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageAgreementUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageAgreementManyWhereInput>;
};


export type MutationUpdateManyCosmosPageBlogDetailsArgs = {
  data: CosmosPageBlogDetailUpdateManyInput;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
};


export type MutationUpdateManyCosmosPageBlogDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageBlogDetailUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageBlogDetailManyWhereInput>;
};


export type MutationUpdateManyCosmosPageDirectoriesArgs = {
  data: CosmosPageDirectoryUpdateManyInput;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
};


export type MutationUpdateManyCosmosPageDirectoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageDirectoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageDirectoryManyWhereInput>;
};


export type MutationUpdateManyCosmosPageEulaKeysArgs = {
  data: CosmosPageEulaKeyUpdateManyInput;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
};


export type MutationUpdateManyCosmosPageEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageEulaKeyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageEulaKeyManyWhereInput>;
};


export type MutationUpdateManyCosmosPageFeedsArgs = {
  data: CosmosPageFeedUpdateManyInput;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
};


export type MutationUpdateManyCosmosPageFeedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageFeedUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageFeedManyWhereInput>;
};


export type MutationUpdateManyCosmosPageHeroAndSectionsArgs = {
  data: CosmosPageHeroAndSectionUpdateManyInput;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
};


export type MutationUpdateManyCosmosPageHeroAndSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageHeroAndSectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageHeroAndSectionManyWhereInput>;
};


export type MutationUpdateManyCosmosPageLegalContentsArgs = {
  data: CosmosPageLegalContentUpdateManyInput;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
};


export type MutationUpdateManyCosmosPageLegalContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageLegalContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageLegalContentManyWhereInput>;
};


export type MutationUpdateManyCosmosPageLicensesArgs = {
  data: CosmosPageLicenseUpdateManyInput;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
};


export type MutationUpdateManyCosmosPageLicensesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageLicenseUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageLicenseManyWhereInput>;
};


export type MutationUpdateManyCosmosPagePluginDetailsArgs = {
  data: CosmosPagePluginDetailUpdateManyInput;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
};


export type MutationUpdateManyCosmosPagePluginDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPagePluginDetailUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPagePluginDetailManyWhereInput>;
};


export type MutationUpdateManyCosmosPageRedirectsArgs = {
  data: CosmosPageRedirectUpdateManyInput;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
};


export type MutationUpdateManyCosmosPageRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageRedirectUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageRedirectManyWhereInput>;
};


export type MutationUpdateManyCosmosPageResearchesArgs = {
  data: CosmosPageResearchUpdateManyInput;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
};


export type MutationUpdateManyCosmosPageResearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageResearchUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageResearchManyWhereInput>;
};


export type MutationUpdateManyCosmosPageSearchesArgs = {
  data: CosmosPageSearchUpdateManyInput;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
};


export type MutationUpdateManyCosmosPageSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosPageSearchUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosPageSearchManyWhereInput>;
};


export type MutationUpdateManyCosmosRefIndustryListsArgs = {
  data: CosmosRefIndustryListUpdateManyInput;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
};


export type MutationUpdateManyCosmosRefIndustryListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosRefIndustryListUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosRefIndustryListManyWhereInput>;
};


export type MutationUpdateManyCosmosReferenceFaqItemsArgs = {
  data: CosmosReferenceFaqItemUpdateManyInput;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
};


export type MutationUpdateManyCosmosReferenceFaqItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosReferenceFaqItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceFaqItemManyWhereInput>;
};


export type MutationUpdateManyCosmosReferenceSectionsArgs = {
  data: CosmosReferenceSectionUpdateManyInput;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
};


export type MutationUpdateManyCosmosReferenceSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosReferenceSectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosReferenceSectionManyWhereInput>;
};


export type MutationUpdateManyCosmosRemoteLearnsArgs = {
  data: CosmosRemoteLearnUpdateManyInput;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationUpdateManyCosmosRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CosmosRemoteLearnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CosmosRemoteLearnManyWhereInput>;
};


export type MutationUpdateManyRemoteLearnsArgs = {
  data: RemoteLearnUpdateManyInput;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationUpdateManyRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RemoteLearnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RemoteLearnManyWhereInput>;
};


export type MutationUpdateManyWfRefApplicationOwnersArgs = {
  data: WfRefApplicationOwnerUpdateManyInput;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationUpdateManyWfRefApplicationOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: WfRefApplicationOwnerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefApplicationOwnerManyWhereInput>;
};


export type MutationUpdateManyWfRefBlogCategoriesArgs = {
  data: WfRefBlogCategoryUpdateManyInput;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
};


export type MutationUpdateManyWfRefBlogCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: WfRefBlogCategoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogCategoryManyWhereInput>;
};


export type MutationUpdateManyWfRefBlogTagsArgs = {
  data: WfRefBlogTagUpdateManyInput;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
};


export type MutationUpdateManyWfRefBlogTagsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: WfRefBlogTagUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WfRefBlogTagManyWhereInput>;
};


export type MutationUpdateRemoteLearnArgs = {
  data: RemoteLearnUpdateInput;
  where: RemoteLearnWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateWfRefApplicationOwnerArgs = {
  data: WfRefApplicationOwnerUpdateInput;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationUpdateWfRefBlogCategoryArgs = {
  data: WfRefBlogCategoryUpdateInput;
  where: WfRefBlogCategoryWhereUniqueInput;
};


export type MutationUpdateWfRefBlogTagArgs = {
  data: WfRefBlogTagUpdateInput;
  where: WfRefBlogTagWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertCosmosFeedBlogCardArgs = {
  upsert: CosmosFeedBlogCardUpsertInput;
  where: CosmosFeedBlogCardWhereUniqueInput;
};


export type MutationUpsertCosmosPageAgreementArgs = {
  upsert: CosmosPageAgreementUpsertInput;
  where: CosmosPageAgreementWhereUniqueInput;
};


export type MutationUpsertCosmosPageBlogDetailArgs = {
  upsert: CosmosPageBlogDetailUpsertInput;
  where: CosmosPageBlogDetailWhereUniqueInput;
};


export type MutationUpsertCosmosPageDirectoryArgs = {
  upsert: CosmosPageDirectoryUpsertInput;
  where: CosmosPageDirectoryWhereUniqueInput;
};


export type MutationUpsertCosmosPageEulaKeyArgs = {
  upsert: CosmosPageEulaKeyUpsertInput;
  where: CosmosPageEulaKeyWhereUniqueInput;
};


export type MutationUpsertCosmosPageFeedArgs = {
  upsert: CosmosPageFeedUpsertInput;
  where: CosmosPageFeedWhereUniqueInput;
};


export type MutationUpsertCosmosPageHeroAndSectionArgs = {
  upsert: CosmosPageHeroAndSectionUpsertInput;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};


export type MutationUpsertCosmosPageLegalContentArgs = {
  upsert: CosmosPageLegalContentUpsertInput;
  where: CosmosPageLegalContentWhereUniqueInput;
};


export type MutationUpsertCosmosPageLicenseArgs = {
  upsert: CosmosPageLicenseUpsertInput;
  where: CosmosPageLicenseWhereUniqueInput;
};


export type MutationUpsertCosmosPagePluginDetailArgs = {
  upsert: CosmosPagePluginDetailUpsertInput;
  where: CosmosPagePluginDetailWhereUniqueInput;
};


export type MutationUpsertCosmosPageRedirectArgs = {
  upsert: CosmosPageRedirectUpsertInput;
  where: CosmosPageRedirectWhereUniqueInput;
};


export type MutationUpsertCosmosPageResearchArgs = {
  upsert: CosmosPageResearchUpsertInput;
  where: CosmosPageResearchWhereUniqueInput;
};


export type MutationUpsertCosmosPageSearchArgs = {
  upsert: CosmosPageSearchUpsertInput;
  where: CosmosPageSearchWhereUniqueInput;
};


export type MutationUpsertCosmosRefIndustryListArgs = {
  upsert: CosmosRefIndustryListUpsertInput;
  where: CosmosRefIndustryListWhereUniqueInput;
};


export type MutationUpsertCosmosReferenceFaqItemArgs = {
  upsert: CosmosReferenceFaqItemUpsertInput;
  where: CosmosReferenceFaqItemWhereUniqueInput;
};


export type MutationUpsertCosmosReferenceSectionArgs = {
  upsert: CosmosReferenceSectionUpsertInput;
  where: CosmosReferenceSectionWhereUniqueInput;
};


export type MutationUpsertCosmosRemoteLearnArgs = {
  upsert: CosmosRemoteLearnUpsertInput;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type MutationUpsertRemoteLearnArgs = {
  upsert: RemoteLearnUpsertInput;
  where: RemoteLearnWhereUniqueInput;
};


export type MutationUpsertWfRefApplicationOwnerArgs = {
  upsert: WfRefApplicationOwnerUpsertInput;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type MutationUpsertWfRefBlogCategoryArgs = {
  upsert: WfRefBlogCategoryUpsertInput;
  where: WfRefBlogCategoryWhereUniqueInput;
};


export type MutationUpsertWfRefBlogTagArgs = {
  upsert: WfRefBlogTagUpsertInput;
  where: WfRefBlogTagWhereUniqueInput;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single cosmosFeedBlogCard */
  cosmosFeedBlogCard?: Maybe<CosmosFeedBlogCard>;
  /** Retrieve document version */
  cosmosFeedBlogCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosFeedBlogCards */
  cosmosFeedBlogCards: Array<CosmosFeedBlogCard>;
  /** Retrieve multiple cosmosFeedBlogCards using the Relay connection interface */
  cosmosFeedBlogCardsConnection: CosmosFeedBlogCardConnection;
  /** Retrieve a single cosmosPageAgreement */
  cosmosPageAgreement?: Maybe<CosmosPageAgreement>;
  /** Retrieve document version */
  cosmosPageAgreementVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageAgreements */
  cosmosPageAgreements: Array<CosmosPageAgreement>;
  /** Retrieve multiple cosmosPageAgreements using the Relay connection interface */
  cosmosPageAgreementsConnection: CosmosPageAgreementConnection;
  /** Retrieve a single cosmosPageBlogDetail */
  cosmosPageBlogDetail?: Maybe<CosmosPageBlogDetail>;
  /** Retrieve document version */
  cosmosPageBlogDetailVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageBlogDetails */
  cosmosPageBlogDetails: Array<CosmosPageBlogDetail>;
  /** Retrieve multiple cosmosPageBlogDetails using the Relay connection interface */
  cosmosPageBlogDetailsConnection: CosmosPageBlogDetailConnection;
  /** Retrieve multiple cosmosPageDirectories */
  cosmosPageDirectories: Array<CosmosPageDirectory>;
  /** Retrieve multiple cosmosPageDirectories using the Relay connection interface */
  cosmosPageDirectoriesConnection: CosmosPageDirectoryConnection;
  /** Retrieve a single cosmosPageDirectory */
  cosmosPageDirectory?: Maybe<CosmosPageDirectory>;
  /** Retrieve document version */
  cosmosPageDirectoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single cosmosPageEulaKey */
  cosmosPageEulaKey?: Maybe<CosmosPageEulaKey>;
  /** Retrieve document version */
  cosmosPageEulaKeyVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageEulaKeys */
  cosmosPageEulaKeys: Array<CosmosPageEulaKey>;
  /** Retrieve multiple cosmosPageEulaKeys using the Relay connection interface */
  cosmosPageEulaKeysConnection: CosmosPageEulaKeyConnection;
  /** Retrieve a single cosmosPageFeed */
  cosmosPageFeed?: Maybe<CosmosPageFeed>;
  /** Retrieve document version */
  cosmosPageFeedVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageFeeds */
  cosmosPageFeeds: Array<CosmosPageFeed>;
  /** Retrieve multiple cosmosPageFeeds using the Relay connection interface */
  cosmosPageFeedsConnection: CosmosPageFeedConnection;
  /** Retrieve a single cosmosPageHeroAndSection */
  cosmosPageHeroAndSection?: Maybe<CosmosPageHeroAndSection>;
  /** Retrieve document version */
  cosmosPageHeroAndSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageHeroAndSections */
  cosmosPageHeroAndSections: Array<CosmosPageHeroAndSection>;
  /** Retrieve multiple cosmosPageHeroAndSections using the Relay connection interface */
  cosmosPageHeroAndSectionsConnection: CosmosPageHeroAndSectionConnection;
  /** Retrieve a single cosmosPageLegalContent */
  cosmosPageLegalContent?: Maybe<CosmosPageLegalContent>;
  /** Retrieve document version */
  cosmosPageLegalContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageLegalContents */
  cosmosPageLegalContents: Array<CosmosPageLegalContent>;
  /** Retrieve multiple cosmosPageLegalContents using the Relay connection interface */
  cosmosPageLegalContentsConnection: CosmosPageLegalContentConnection;
  /** Retrieve a single cosmosPageLicense */
  cosmosPageLicense?: Maybe<CosmosPageLicense>;
  /** Retrieve document version */
  cosmosPageLicenseVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageLicenses */
  cosmosPageLicenses: Array<CosmosPageLicense>;
  /** Retrieve multiple cosmosPageLicenses using the Relay connection interface */
  cosmosPageLicensesConnection: CosmosPageLicenseConnection;
  /** Retrieve a single cosmosPagePluginDetail */
  cosmosPagePluginDetail?: Maybe<CosmosPagePluginDetail>;
  /** Retrieve document version */
  cosmosPagePluginDetailVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPagePluginDetails */
  cosmosPagePluginDetails: Array<CosmosPagePluginDetail>;
  /** Retrieve multiple cosmosPagePluginDetails using the Relay connection interface */
  cosmosPagePluginDetailsConnection: CosmosPagePluginDetailConnection;
  /** Retrieve a single cosmosPageRedirect */
  cosmosPageRedirect?: Maybe<CosmosPageRedirect>;
  /** Retrieve document version */
  cosmosPageRedirectVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageRedirects */
  cosmosPageRedirects: Array<CosmosPageRedirect>;
  /** Retrieve multiple cosmosPageRedirects using the Relay connection interface */
  cosmosPageRedirectsConnection: CosmosPageRedirectConnection;
  /** Retrieve a single cosmosPageResearch */
  cosmosPageResearch?: Maybe<CosmosPageResearch>;
  /** Retrieve document version */
  cosmosPageResearchVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageResearches */
  cosmosPageResearches: Array<CosmosPageResearch>;
  /** Retrieve multiple cosmosPageResearches using the Relay connection interface */
  cosmosPageResearchesConnection: CosmosPageResearchConnection;
  /** Retrieve a single cosmosPageSearch */
  cosmosPageSearch?: Maybe<CosmosPageSearch>;
  /** Retrieve document version */
  cosmosPageSearchVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosPageSearches */
  cosmosPageSearches: Array<CosmosPageSearch>;
  /** Retrieve multiple cosmosPageSearches using the Relay connection interface */
  cosmosPageSearchesConnection: CosmosPageSearchConnection;
  /** Retrieve a single cosmosRefIndustryList */
  cosmosRefIndustryList?: Maybe<CosmosRefIndustryList>;
  /** Retrieve document version */
  cosmosRefIndustryListVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosRefIndustryLists */
  cosmosRefIndustryLists: Array<CosmosRefIndustryList>;
  /** Retrieve multiple cosmosRefIndustryLists using the Relay connection interface */
  cosmosRefIndustryListsConnection: CosmosRefIndustryListConnection;
  /** Retrieve a single cosmosReferenceFAQItem */
  cosmosReferenceFAQItem?: Maybe<CosmosReferenceFaqItem>;
  /** Retrieve document version */
  cosmosReferenceFAQItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosReferenceFAQItems */
  cosmosReferenceFAQItems: Array<CosmosReferenceFaqItem>;
  /** Retrieve multiple cosmosReferenceFAQItems using the Relay connection interface */
  cosmosReferenceFAQItemsConnection: CosmosReferenceFaqItemConnection;
  /** Retrieve a single cosmosReferenceSection */
  cosmosReferenceSection?: Maybe<CosmosReferenceSection>;
  /** Retrieve document version */
  cosmosReferenceSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosReferenceSections */
  cosmosReferenceSections: Array<CosmosReferenceSection>;
  /** Retrieve multiple cosmosReferenceSections using the Relay connection interface */
  cosmosReferenceSectionsConnection: CosmosReferenceSectionConnection;
  /** Retrieve a single cosmosRemoteLearn */
  cosmosRemoteLearn?: Maybe<CosmosRemoteLearn>;
  /** Retrieve document version */
  cosmosRemoteLearnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cosmosRemoteLearns */
  cosmosRemoteLearns: Array<CosmosRemoteLearn>;
  /** Retrieve multiple cosmosRemoteLearns using the Relay connection interface */
  cosmosRemoteLearnsConnection: CosmosRemoteLearnConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single remoteLearn */
  remoteLearn?: Maybe<RemoteLearn>;
  /** Retrieve document version */
  remoteLearnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple remoteLearns */
  remoteLearns: Array<RemoteLearn>;
  /** Retrieve multiple remoteLearns using the Relay connection interface */
  remoteLearnsConnection: RemoteLearnConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
  /** Retrieve a single wfRefApplicationOwner */
  wfRefApplicationOwner?: Maybe<WfRefApplicationOwner>;
  /** Retrieve document version */
  wfRefApplicationOwnerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple wfRefApplicationOwners */
  wfRefApplicationOwners: Array<WfRefApplicationOwner>;
  /** Retrieve multiple wfRefApplicationOwners using the Relay connection interface */
  wfRefApplicationOwnersConnection: WfRefApplicationOwnerConnection;
  /** Retrieve multiple wfRefBlogCategories */
  wfRefBlogCategories: Array<WfRefBlogCategory>;
  /** Retrieve multiple wfRefBlogCategories using the Relay connection interface */
  wfRefBlogCategoriesConnection: WfRefBlogCategoryConnection;
  /** Retrieve a single wfRefBlogCategory */
  wfRefBlogCategory?: Maybe<WfRefBlogCategory>;
  /** Retrieve document version */
  wfRefBlogCategoryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single wfRefBlogTag */
  wfRefBlogTag?: Maybe<WfRefBlogTag>;
  /** Retrieve document version */
  wfRefBlogTagVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple wfRefBlogTags */
  wfRefBlogTags: Array<WfRefBlogTag>;
  /** Retrieve multiple wfRefBlogTags using the Relay connection interface */
  wfRefBlogTagsConnection: WfRefBlogTagConnection;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryCosmosFeedBlogCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosFeedBlogCardWhereUniqueInput;
};


export type QueryCosmosFeedBlogCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosFeedBlogCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosFeedBlogCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosFeedBlogCardWhereInput>;
};


export type QueryCosmosFeedBlogCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosFeedBlogCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosFeedBlogCardWhereInput>;
};


export type QueryCosmosPageAgreementArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageAgreementWhereUniqueInput;
};


export type QueryCosmosPageAgreementVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageAgreementOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageAgreementWhereInput>;
};


export type QueryCosmosPageAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageAgreementOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageAgreementWhereInput>;
};


export type QueryCosmosPageBlogDetailArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageBlogDetailWhereUniqueInput;
};


export type QueryCosmosPageBlogDetailVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageBlogDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageBlogDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageBlogDetailWhereInput>;
};


export type QueryCosmosPageBlogDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageBlogDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageBlogDetailWhereInput>;
};


export type QueryCosmosPageDirectoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageDirectoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageDirectoryWhereInput>;
};


export type QueryCosmosPageDirectoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageDirectoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageDirectoryWhereInput>;
};


export type QueryCosmosPageDirectoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageDirectoryWhereUniqueInput;
};


export type QueryCosmosPageDirectoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageEulaKeyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageEulaKeyWhereUniqueInput;
};


export type QueryCosmosPageEulaKeyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageEulaKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageEulaKeyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageEulaKeyWhereInput>;
};


export type QueryCosmosPageEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageEulaKeyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageEulaKeyWhereInput>;
};


export type QueryCosmosPageFeedArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageFeedWhereUniqueInput;
};


export type QueryCosmosPageFeedVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageFeedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageFeedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageFeedWhereInput>;
};


export type QueryCosmosPageFeedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageFeedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageFeedWhereInput>;
};


export type QueryCosmosPageHeroAndSectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageHeroAndSectionWhereUniqueInput;
};


export type QueryCosmosPageHeroAndSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageHeroAndSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageHeroAndSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
};


export type QueryCosmosPageHeroAndSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageHeroAndSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageHeroAndSectionWhereInput>;
};


export type QueryCosmosPageLegalContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageLegalContentWhereUniqueInput;
};


export type QueryCosmosPageLegalContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageLegalContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageLegalContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageLegalContentWhereInput>;
};


export type QueryCosmosPageLegalContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageLegalContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageLegalContentWhereInput>;
};


export type QueryCosmosPageLicenseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageLicenseWhereUniqueInput;
};


export type QueryCosmosPageLicenseVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageLicensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageLicenseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageLicenseWhereInput>;
};


export type QueryCosmosPageLicensesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageLicenseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageLicenseWhereInput>;
};


export type QueryCosmosPagePluginDetailArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPagePluginDetailWhereUniqueInput;
};


export type QueryCosmosPagePluginDetailVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPagePluginDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPagePluginDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};


export type QueryCosmosPagePluginDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPagePluginDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPagePluginDetailWhereInput>;
};


export type QueryCosmosPageRedirectArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageRedirectWhereUniqueInput;
};


export type QueryCosmosPageRedirectVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageRedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageRedirectWhereInput>;
};


export type QueryCosmosPageRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageRedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageRedirectWhereInput>;
};


export type QueryCosmosPageResearchArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageResearchWhereUniqueInput;
};


export type QueryCosmosPageResearchVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageResearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageResearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageResearchWhereInput>;
};


export type QueryCosmosPageResearchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageResearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageResearchWhereInput>;
};


export type QueryCosmosPageSearchArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosPageSearchWhereUniqueInput;
};


export type QueryCosmosPageSearchVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosPageSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageSearchWhereInput>;
};


export type QueryCosmosPageSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosPageSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosPageSearchWhereInput>;
};


export type QueryCosmosRefIndustryListArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosRefIndustryListWhereUniqueInput;
};


export type QueryCosmosRefIndustryListVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosRefIndustryListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosRefIndustryListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosRefIndustryListWhereInput>;
};


export type QueryCosmosRefIndustryListsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosRefIndustryListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosRefIndustryListWhereInput>;
};


export type QueryCosmosReferenceFaqItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosReferenceFaqItemWhereUniqueInput;
};


export type QueryCosmosReferenceFaqItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosReferenceFaqItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosReferenceFaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
};


export type QueryCosmosReferenceFaqItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosReferenceFaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosReferenceFaqItemWhereInput>;
};


export type QueryCosmosReferenceSectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosReferenceSectionWhereUniqueInput;
};


export type QueryCosmosReferenceSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosReferenceSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type QueryCosmosReferenceSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosReferenceSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosReferenceSectionWhereInput>;
};


export type QueryCosmosRemoteLearnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CosmosRemoteLearnWhereUniqueInput;
};


export type QueryCosmosRemoteLearnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCosmosRemoteLearnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosRemoteLearnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosRemoteLearnWhereInput>;
};


export type QueryCosmosRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CosmosRemoteLearnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CosmosRemoteLearnWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryRemoteLearnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RemoteLearnWhereUniqueInput;
};


export type QueryRemoteLearnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRemoteLearnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RemoteLearnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RemoteLearnWhereInput>;
};


export type QueryRemoteLearnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RemoteLearnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RemoteLearnWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryWfRefApplicationOwnerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: WfRefApplicationOwnerWhereUniqueInput;
};


export type QueryWfRefApplicationOwnerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryWfRefApplicationOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WfRefApplicationOwnerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WfRefApplicationOwnerWhereInput>;
};


export type QueryWfRefApplicationOwnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WfRefApplicationOwnerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WfRefApplicationOwnerWhereInput>;
};


export type QueryWfRefBlogCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WfRefBlogCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WfRefBlogCategoryWhereInput>;
};


export type QueryWfRefBlogCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WfRefBlogCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WfRefBlogCategoryWhereInput>;
};


export type QueryWfRefBlogCategoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: WfRefBlogCategoryWhereUniqueInput;
};


export type QueryWfRefBlogCategoryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryWfRefBlogTagArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: WfRefBlogTagWhereUniqueInput;
};


export type QueryWfRefBlogTagVersionArgs = {
  where: VersionWhereInput;
};


export type QueryWfRefBlogTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WfRefBlogTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WfRefBlogTagWhereInput>;
};


export type QueryWfRefBlogTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WfRefBlogTagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WfRefBlogTagWhereInput>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

export type RemoteLearn = Entity & Node & {
  __typename?: 'RemoteLearn';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<RemoteLearn>;
  /** List of RemoteLearn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  learnSearch?: Maybe<Scalars['Json']['output']>;
  /** Added because remote source content can't be created with only remote */
  placeHolder?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RemoteLearnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RemoteLearnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RemoteLearnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RemoteLearnLearnSearchArgs = {
  applicationFamily?: InputMaybe<Scalars['String']['input']>;
  industries: Scalars['String']['input'];
  types: Scalars['String']['input'];
};


export type RemoteLearnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RemoteLearnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RemoteLearnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RemoteLearnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RemoteLearnWhereUniqueInput;
};

/** A connection to a list of items. */
export type RemoteLearnConnection = {
  __typename?: 'RemoteLearnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RemoteLearnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RemoteLearnCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  placeHolder?: InputMaybe<Scalars['String']['input']>;
  remoteLearn1723125044707ElementLearnCategory?: InputMaybe<ElementLearnCategoryCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RemoteLearnCreateManyInlineInput = {
  /** Connect multiple existing RemoteLearn documents */
  connect?: InputMaybe<Array<RemoteLearnWhereUniqueInput>>;
  /** Create and connect multiple existing RemoteLearn documents */
  create?: InputMaybe<Array<RemoteLearnCreateInput>>;
};

export type RemoteLearnCreateOneInlineInput = {
  /** Connect one existing RemoteLearn document */
  connect?: InputMaybe<RemoteLearnWhereUniqueInput>;
  /** Create and connect one RemoteLearn document */
  create?: InputMaybe<RemoteLearnCreateInput>;
};

/** An edge in a connection. */
export type RemoteLearnEdge = {
  __typename?: 'RemoteLearnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RemoteLearn;
};

/** Identifies documents */
export type RemoteLearnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RemoteLearnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RemoteLearnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RemoteLearnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RemoteLearnWhereStageInput>;
  documentInStages_none?: InputMaybe<RemoteLearnWhereStageInput>;
  documentInStages_some?: InputMaybe<RemoteLearnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  placeHolder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeHolder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeHolder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeHolder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeHolder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeHolder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeHolder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeHolder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeHolder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeHolder_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RemoteLearnOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PlaceHolderAsc = 'placeHolder_ASC',
  PlaceHolderDesc = 'placeHolder_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type RemoteLearnUpdateInput = {
  placeHolder?: InputMaybe<Scalars['String']['input']>;
  remoteLearn1723125044707ElementLearnCategory?: InputMaybe<ElementLearnCategoryUpdateOneInlineInput>;
};

export type RemoteLearnUpdateManyInlineInput = {
  /** Connect multiple existing RemoteLearn documents */
  connect?: InputMaybe<Array<RemoteLearnConnectInput>>;
  /** Create and connect multiple RemoteLearn documents */
  create?: InputMaybe<Array<RemoteLearnCreateInput>>;
  /** Delete multiple RemoteLearn documents */
  delete?: InputMaybe<Array<RemoteLearnWhereUniqueInput>>;
  /** Disconnect multiple RemoteLearn documents */
  disconnect?: InputMaybe<Array<RemoteLearnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RemoteLearn documents */
  set?: InputMaybe<Array<RemoteLearnWhereUniqueInput>>;
  /** Update multiple RemoteLearn documents */
  update?: InputMaybe<Array<RemoteLearnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RemoteLearn documents */
  upsert?: InputMaybe<Array<RemoteLearnUpsertWithNestedWhereUniqueInput>>;
};

export type RemoteLearnUpdateManyInput = {
  placeHolder?: InputMaybe<Scalars['String']['input']>;
};

export type RemoteLearnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RemoteLearnUpdateManyInput;
  /** Document search */
  where: RemoteLearnWhereInput;
};

export type RemoteLearnUpdateOneInlineInput = {
  /** Connect existing RemoteLearn document */
  connect?: InputMaybe<RemoteLearnWhereUniqueInput>;
  /** Create and connect one RemoteLearn document */
  create?: InputMaybe<RemoteLearnCreateInput>;
  /** Delete currently connected RemoteLearn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RemoteLearn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RemoteLearn document */
  update?: InputMaybe<RemoteLearnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RemoteLearn document */
  upsert?: InputMaybe<RemoteLearnUpsertWithNestedWhereUniqueInput>;
};

export type RemoteLearnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RemoteLearnUpdateInput;
  /** Unique document search */
  where: RemoteLearnWhereUniqueInput;
};

export type RemoteLearnUpsertInput = {
  /** Create document if it didn't exist */
  create: RemoteLearnCreateInput;
  /** Update document if it exists */
  update: RemoteLearnUpdateInput;
};

export type RemoteLearnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RemoteLearnUpsertInput;
  /** Unique document search */
  where: RemoteLearnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RemoteLearnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RemoteLearnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RemoteLearnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RemoteLearnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RemoteLearnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RemoteLearnWhereStageInput>;
  documentInStages_none?: InputMaybe<RemoteLearnWhereStageInput>;
  documentInStages_some?: InputMaybe<RemoteLearnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  placeHolder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeHolder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeHolder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeHolder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeHolder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeHolder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeHolder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeHolder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeHolder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeHolder_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RemoteLearnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RemoteLearnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RemoteLearnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RemoteLearnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RemoteLearnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RemoteLearn record uniquely */
export type RemoteLearnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Asset | CosmosFeedBlogCard | CosmosPageAgreement | CosmosPageBlogDetail | CosmosPageDirectory | CosmosPageEulaKey | CosmosPageFeed | CosmosPageHeroAndSection | CosmosPageLegalContent | CosmosPageLicense | CosmosPagePluginDetail | CosmosPageRedirect | CosmosPageResearch | CosmosPageSearch | CosmosRefIndustryList | CosmosReferenceFaqItem | CosmosReferenceSection | CosmosRemoteLearn | RemoteLearn | WfRefApplicationOwner | WfRefBlogCategory | WfRefBlogTag;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** Integration and Development */
  Gamedev = 'GAMEDEV',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED'
}

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION'
}

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  AppToken = 'APP_TOKEN',
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

/** Opt-in flag to prevent accidental production publishes */
export enum WfEnumInDevelopmentStatus {
  AllowProdPublish = 'AllowProdPublish',
  DisableProdPublish = 'DisableProdPublish'
}

export type WfRefApplicationOwner = Entity & Node & {
  __typename?: 'WfRefApplicationOwner';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<WfRefApplicationOwner>;
  gamedevUrl: Scalars['String']['output'];
  /** List of WfRefApplicationOwner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Is this application the default one in the project. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Friendly name of the application */
  label: Scalars['String']['output'];
  /** Unique identifier for this application */
  ownerId: Scalars['String']['output'];
  /** The unique prefix used on Hygraph pages for this app. */
  pageSlugPrefix?: Maybe<Scalars['String']['output']>;
  prodUrl: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type WfRefApplicationOwnerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefApplicationOwnerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type WfRefApplicationOwnerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type WfRefApplicationOwnerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefApplicationOwnerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type WfRefApplicationOwnerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type WfRefApplicationOwnerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: WfRefApplicationOwnerWhereUniqueInput;
};

/** A connection to a list of items. */
export type WfRefApplicationOwnerConnection = {
  __typename?: 'WfRefApplicationOwnerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<WfRefApplicationOwnerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type WfRefApplicationOwnerCreateInput = {
  cmk769ab60qqa07n146yh0p3u?: InputMaybe<CosmosPageHeroAndSectionCreateManyInlineInput>;
  cmmf9k6yc066f07mw1pb342rx?: InputMaybe<CosmosPageLegalContentCreateManyInlineInput>;
  cmmf9mlb0068c07mw5ybve8cn?: InputMaybe<CosmosPageEulaKeyCreateManyInlineInput>;
  cmmf9n1s606ag07mw7gs6aixt?: InputMaybe<CosmosPageBlogDetailCreateManyInlineInput>;
  cmmf9o6z406cy07mwfcfcdlqn?: InputMaybe<CosmosPageRedirectCreateManyInlineInput>;
  cmp30vnfx00ud07oi52090yaf?: InputMaybe<CosmosPageDirectoryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  gamedevUrl: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  pageSlugPrefix?: InputMaybe<Scalars['String']['input']>;
  prodUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WfRefApplicationOwnerCreateManyInlineInput = {
  /** Connect multiple existing WfRefApplicationOwner documents */
  connect?: InputMaybe<Array<WfRefApplicationOwnerWhereUniqueInput>>;
  /** Create and connect multiple existing WfRefApplicationOwner documents */
  create?: InputMaybe<Array<WfRefApplicationOwnerCreateInput>>;
};

export type WfRefApplicationOwnerCreateOneInlineInput = {
  /** Connect one existing WfRefApplicationOwner document */
  connect?: InputMaybe<WfRefApplicationOwnerWhereUniqueInput>;
  /** Create and connect one WfRefApplicationOwner document */
  create?: InputMaybe<WfRefApplicationOwnerCreateInput>;
};

/** An edge in a connection. */
export type WfRefApplicationOwnerEdge = {
  __typename?: 'WfRefApplicationOwnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WfRefApplicationOwner;
};

/** Identifies documents */
export type WfRefApplicationOwnerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefApplicationOwnerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefApplicationOwnerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefApplicationOwnerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WfRefApplicationOwnerWhereStageInput>;
  documentInStages_none?: InputMaybe<WfRefApplicationOwnerWhereStageInput>;
  documentInStages_some?: InputMaybe<WfRefApplicationOwnerWhereStageInput>;
  gamedevUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  gamedevUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  gamedevUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  gamedevUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  gamedevUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  gamedevUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  gamedevUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  gamedevUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  gamedevUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  gamedevUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isDefault_not?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ownerId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ownerId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ownerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ownerId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ownerId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ownerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ownerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ownerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ownerId_starts_with?: InputMaybe<Scalars['String']['input']>;
  pageSlugPrefix?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pageSlugPrefix_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pageSlugPrefix_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pageSlugPrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pageSlugPrefix_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pageSlugPrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pageSlugPrefix_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pageSlugPrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pageSlugPrefix_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pageSlugPrefix_starts_with?: InputMaybe<Scalars['String']['input']>;
  prodUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  prodUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  prodUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  prodUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  prodUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  prodUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  prodUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  prodUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  prodUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  prodUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum WfRefApplicationOwnerOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  GamedevUrlAsc = 'gamedevUrl_ASC',
  GamedevUrlDesc = 'gamedevUrl_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsDefaultAsc = 'isDefault_ASC',
  IsDefaultDesc = 'isDefault_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  OwnerIdAsc = 'ownerId_ASC',
  OwnerIdDesc = 'ownerId_DESC',
  PageSlugPrefixAsc = 'pageSlugPrefix_ASC',
  PageSlugPrefixDesc = 'pageSlugPrefix_DESC',
  ProdUrlAsc = 'prodUrl_ASC',
  ProdUrlDesc = 'prodUrl_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type WfRefApplicationOwnerUpdateInput = {
  cmk769ab60qqa07n146yh0p3u?: InputMaybe<CosmosPageHeroAndSectionUpdateManyInlineInput>;
  cmmf9k6yc066f07mw1pb342rx?: InputMaybe<CosmosPageLegalContentUpdateManyInlineInput>;
  cmmf9mlb0068c07mw5ybve8cn?: InputMaybe<CosmosPageEulaKeyUpdateManyInlineInput>;
  cmmf9n1s606ag07mw7gs6aixt?: InputMaybe<CosmosPageBlogDetailUpdateManyInlineInput>;
  cmmf9o6z406cy07mwfcfcdlqn?: InputMaybe<CosmosPageRedirectUpdateManyInlineInput>;
  cmp30vnfx00ud07oi52090yaf?: InputMaybe<CosmosPageDirectoryUpdateManyInlineInput>;
  gamedevUrl?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  pageSlugPrefix?: InputMaybe<Scalars['String']['input']>;
  prodUrl?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefApplicationOwnerUpdateManyInlineInput = {
  /** Connect multiple existing WfRefApplicationOwner documents */
  connect?: InputMaybe<Array<WfRefApplicationOwnerConnectInput>>;
  /** Create and connect multiple WfRefApplicationOwner documents */
  create?: InputMaybe<Array<WfRefApplicationOwnerCreateInput>>;
  /** Delete multiple WfRefApplicationOwner documents */
  delete?: InputMaybe<Array<WfRefApplicationOwnerWhereUniqueInput>>;
  /** Disconnect multiple WfRefApplicationOwner documents */
  disconnect?: InputMaybe<Array<WfRefApplicationOwnerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing WfRefApplicationOwner documents */
  set?: InputMaybe<Array<WfRefApplicationOwnerWhereUniqueInput>>;
  /** Update multiple WfRefApplicationOwner documents */
  update?: InputMaybe<Array<WfRefApplicationOwnerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple WfRefApplicationOwner documents */
  upsert?: InputMaybe<Array<WfRefApplicationOwnerUpsertWithNestedWhereUniqueInput>>;
};

export type WfRefApplicationOwnerUpdateManyInput = {
  gamedevUrl?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pageSlugPrefix?: InputMaybe<Scalars['String']['input']>;
  prodUrl?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefApplicationOwnerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: WfRefApplicationOwnerUpdateManyInput;
  /** Document search */
  where: WfRefApplicationOwnerWhereInput;
};

export type WfRefApplicationOwnerUpdateOneInlineInput = {
  /** Connect existing WfRefApplicationOwner document */
  connect?: InputMaybe<WfRefApplicationOwnerWhereUniqueInput>;
  /** Create and connect one WfRefApplicationOwner document */
  create?: InputMaybe<WfRefApplicationOwnerCreateInput>;
  /** Delete currently connected WfRefApplicationOwner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected WfRefApplicationOwner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single WfRefApplicationOwner document */
  update?: InputMaybe<WfRefApplicationOwnerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single WfRefApplicationOwner document */
  upsert?: InputMaybe<WfRefApplicationOwnerUpsertWithNestedWhereUniqueInput>;
};

export type WfRefApplicationOwnerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: WfRefApplicationOwnerUpdateInput;
  /** Unique document search */
  where: WfRefApplicationOwnerWhereUniqueInput;
};

export type WfRefApplicationOwnerUpsertInput = {
  /** Create document if it didn't exist */
  create: WfRefApplicationOwnerCreateInput;
  /** Update document if it exists */
  update: WfRefApplicationOwnerUpdateInput;
};

export type WfRefApplicationOwnerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: WfRefApplicationOwnerUpsertInput;
  /** Unique document search */
  where: WfRefApplicationOwnerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type WfRefApplicationOwnerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type WfRefApplicationOwnerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefApplicationOwnerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefApplicationOwnerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefApplicationOwnerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WfRefApplicationOwnerWhereStageInput>;
  documentInStages_none?: InputMaybe<WfRefApplicationOwnerWhereStageInput>;
  documentInStages_some?: InputMaybe<WfRefApplicationOwnerWhereStageInput>;
  gamedevUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  gamedevUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  gamedevUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  gamedevUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  gamedevUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  gamedevUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  gamedevUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  gamedevUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  gamedevUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  gamedevUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isDefault_not?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ownerId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ownerId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ownerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ownerId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ownerId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ownerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ownerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ownerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ownerId_starts_with?: InputMaybe<Scalars['String']['input']>;
  pageSlugPrefix?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pageSlugPrefix_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pageSlugPrefix_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pageSlugPrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pageSlugPrefix_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pageSlugPrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pageSlugPrefix_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pageSlugPrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pageSlugPrefix_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pageSlugPrefix_starts_with?: InputMaybe<Scalars['String']['input']>;
  prodUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  prodUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  prodUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  prodUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  prodUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  prodUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  prodUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  prodUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  prodUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  prodUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type WfRefApplicationOwnerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefApplicationOwnerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefApplicationOwnerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefApplicationOwnerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<WfRefApplicationOwnerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References WfRefApplicationOwner record uniquely */
export type WfRefApplicationOwnerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogCategory = Entity & Node & {
  __typename?: 'WfRefBlogCategory';
  /** Hex string color value */
  badgeColor?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the category */
  categoryId: Scalars['String']['output'];
  /** The slug to use for filtering. */
  categorySlug?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<WfRefBlogCategory>;
  /** List of WfRefBlogCategory versions */
  history: Array<Version>;
  /** Absolute or relative URL.  {locale} and {categorySlug} can be string replaced. */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Default label used for singular use cases */
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<WfRefBlogCategory>;
  /** Label used for plural use cases */
  pluralLabel?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tag?: Maybe<WfRefBlogTag>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type WfRefBlogCategoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WfRefBlogCategoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefBlogCategoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type WfRefBlogCategoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type WfRefBlogCategoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type WfRefBlogCategoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WfRefBlogCategoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefBlogCategoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type WfRefBlogCategoryTagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefBlogCategoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WfRefBlogCategoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type WfRefBlogCategoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: WfRefBlogCategoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type WfRefBlogCategoryConnection = {
  __typename?: 'WfRefBlogCategoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<WfRefBlogCategoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type WfRefBlogCategoryCreateInput = {
  badgeColor?: InputMaybe<Scalars['String']['input']>;
  category1723125044706CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardCreateOneInlineInput>;
  categoryId: Scalars['String']['input'];
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  cm03yvlpm01mt06oj77n5ghz9?: InputMaybe<CosmosPageFeedCreateManyInlineInput>;
  cm042dgce034o06oj8l475nwp?: InputMaybe<CosmosConfigBlogCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<WfRefBlogCategoryCreateLocalizationsInput>;
  /** pluralLabel input for default locale (en) */
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<WfRefBlogTagCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WfRefBlogCategoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WfRefBlogCategoryCreateLocalizationInput = {
  /** Localization input */
  data: WfRefBlogCategoryCreateLocalizationDataInput;
  locale: Locale;
};

export type WfRefBlogCategoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<WfRefBlogCategoryCreateLocalizationInput>>;
};

export type WfRefBlogCategoryCreateManyInlineInput = {
  /** Connect multiple existing WfRefBlogCategory documents */
  connect?: InputMaybe<Array<WfRefBlogCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing WfRefBlogCategory documents */
  create?: InputMaybe<Array<WfRefBlogCategoryCreateInput>>;
};

export type WfRefBlogCategoryCreateOneInlineInput = {
  /** Connect one existing WfRefBlogCategory document */
  connect?: InputMaybe<WfRefBlogCategoryWhereUniqueInput>;
  /** Create and connect one WfRefBlogCategory document */
  create?: InputMaybe<WfRefBlogCategoryCreateInput>;
};

/** An edge in a connection. */
export type WfRefBlogCategoryEdge = {
  __typename?: 'WfRefBlogCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WfRefBlogCategory;
};

/** Identifies documents */
export type WfRefBlogCategoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefBlogCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefBlogCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefBlogCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  badgeColor?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  badgeColor_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  badgeColor_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  badgeColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  badgeColor_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  badgeColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  badgeColor_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  badgeColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  badgeColor_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  badgeColor_starts_with?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categorySlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categorySlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categorySlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categorySlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categorySlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categorySlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categorySlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categorySlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categorySlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WfRefBlogCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<WfRefBlogCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<WfRefBlogCategoryWhereStageInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tag?: InputMaybe<WfRefBlogTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum WfRefBlogCategoryOrderByInput {
  BadgeColorAsc = 'badgeColor_ASC',
  BadgeColorDesc = 'badgeColor_DESC',
  CategoryIdAsc = 'categoryId_ASC',
  CategoryIdDesc = 'categoryId_DESC',
  CategorySlugAsc = 'categorySlug_ASC',
  CategorySlugDesc = 'categorySlug_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PluralLabelAsc = 'pluralLabel_ASC',
  PluralLabelDesc = 'pluralLabel_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type WfRefBlogCategoryUpdateInput = {
  badgeColor?: InputMaybe<Scalars['String']['input']>;
  category1723125044706CosmosElementBlogCard?: InputMaybe<CosmosElementBlogCardUpdateOneInlineInput>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  cm03yvlpm01mt06oj77n5ghz9?: InputMaybe<CosmosPageFeedUpdateManyInlineInput>;
  cm042dgce034o06oj8l475nwp?: InputMaybe<CosmosConfigBlogUpdateManyInlineInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<WfRefBlogCategoryUpdateLocalizationsInput>;
  /** pluralLabel input for default locale (en) */
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<WfRefBlogTagUpdateOneInlineInput>;
};

export type WfRefBlogCategoryUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogCategoryUpdateLocalizationInput = {
  data: WfRefBlogCategoryUpdateLocalizationDataInput;
  locale: Locale;
};

export type WfRefBlogCategoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<WfRefBlogCategoryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<WfRefBlogCategoryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<WfRefBlogCategoryUpsertLocalizationInput>>;
};

export type WfRefBlogCategoryUpdateManyInlineInput = {
  /** Connect multiple existing WfRefBlogCategory documents */
  connect?: InputMaybe<Array<WfRefBlogCategoryConnectInput>>;
  /** Create and connect multiple WfRefBlogCategory documents */
  create?: InputMaybe<Array<WfRefBlogCategoryCreateInput>>;
  /** Delete multiple WfRefBlogCategory documents */
  delete?: InputMaybe<Array<WfRefBlogCategoryWhereUniqueInput>>;
  /** Disconnect multiple WfRefBlogCategory documents */
  disconnect?: InputMaybe<Array<WfRefBlogCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing WfRefBlogCategory documents */
  set?: InputMaybe<Array<WfRefBlogCategoryWhereUniqueInput>>;
  /** Update multiple WfRefBlogCategory documents */
  update?: InputMaybe<Array<WfRefBlogCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple WfRefBlogCategory documents */
  upsert?: InputMaybe<Array<WfRefBlogCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type WfRefBlogCategoryUpdateManyInput = {
  badgeColor?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<WfRefBlogCategoryUpdateManyLocalizationsInput>;
  /** pluralLabel input for default locale (en) */
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogCategoryUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogCategoryUpdateManyLocalizationInput = {
  data: WfRefBlogCategoryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type WfRefBlogCategoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<WfRefBlogCategoryUpdateManyLocalizationInput>>;
};

export type WfRefBlogCategoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: WfRefBlogCategoryUpdateManyInput;
  /** Document search */
  where: WfRefBlogCategoryWhereInput;
};

export type WfRefBlogCategoryUpdateOneInlineInput = {
  /** Connect existing WfRefBlogCategory document */
  connect?: InputMaybe<WfRefBlogCategoryWhereUniqueInput>;
  /** Create and connect one WfRefBlogCategory document */
  create?: InputMaybe<WfRefBlogCategoryCreateInput>;
  /** Delete currently connected WfRefBlogCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected WfRefBlogCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single WfRefBlogCategory document */
  update?: InputMaybe<WfRefBlogCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single WfRefBlogCategory document */
  upsert?: InputMaybe<WfRefBlogCategoryUpsertWithNestedWhereUniqueInput>;
};

export type WfRefBlogCategoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: WfRefBlogCategoryUpdateInput;
  /** Unique document search */
  where: WfRefBlogCategoryWhereUniqueInput;
};

export type WfRefBlogCategoryUpsertInput = {
  /** Create document if it didn't exist */
  create: WfRefBlogCategoryCreateInput;
  /** Update document if it exists */
  update: WfRefBlogCategoryUpdateInput;
};

export type WfRefBlogCategoryUpsertLocalizationInput = {
  create: WfRefBlogCategoryCreateLocalizationDataInput;
  locale: Locale;
  update: WfRefBlogCategoryUpdateLocalizationDataInput;
};

export type WfRefBlogCategoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: WfRefBlogCategoryUpsertInput;
  /** Unique document search */
  where: WfRefBlogCategoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type WfRefBlogCategoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type WfRefBlogCategoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefBlogCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefBlogCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefBlogCategoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  badgeColor?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  badgeColor_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  badgeColor_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  badgeColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  badgeColor_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  badgeColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  badgeColor_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  badgeColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  badgeColor_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  badgeColor_starts_with?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categorySlug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categorySlug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categorySlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categorySlug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categorySlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categorySlug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categorySlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categorySlug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categorySlug_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WfRefBlogCategoryWhereStageInput>;
  documentInStages_none?: InputMaybe<WfRefBlogCategoryWhereStageInput>;
  documentInStages_some?: InputMaybe<WfRefBlogCategoryWhereStageInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  pluralLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pluralLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pluralLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pluralLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pluralLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pluralLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pluralLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pluralLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pluralLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pluralLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tag?: InputMaybe<WfRefBlogTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type WfRefBlogCategoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefBlogCategoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefBlogCategoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefBlogCategoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<WfRefBlogCategoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References WfRefBlogCategory record uniquely */
export type WfRefBlogCategoryWhereUniqueInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WfRefBlogTag = Entity & Node & {
  __typename?: 'WfRefBlogTag';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<WfRefBlogTag>;
  /** List of WfRefBlogTag versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<WfRefBlogTag>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tagId: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type WfRefBlogTagCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WfRefBlogTagCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefBlogTagDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type WfRefBlogTagHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type WfRefBlogTagLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type WfRefBlogTagPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WfRefBlogTagPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WfRefBlogTagScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type WfRefBlogTagUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WfRefBlogTagUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type WfRefBlogTagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: WfRefBlogTagWhereUniqueInput;
};

/** A connection to a list of items. */
export type WfRefBlogTagConnection = {
  __typename?: 'WfRefBlogTagConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<WfRefBlogTagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type WfRefBlogTagCreateInput = {
  cm03ysxpe01f306oj6m1j4jrk?: InputMaybe<WfRefBlogCategoryCreateManyInlineInput>;
  cm03yv5h401l406ojf6vu7mm8?: InputMaybe<CosmosPageFeedCreateManyInlineInput>;
  cm042e4s1035p06oj3yksbtfn?: InputMaybe<CosmosConfigBlogCreateManyInlineInput>;
  cm4jb8x2e0eg307mv7cim96as?: InputMaybe<CosmosSectionLatestNewsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** label input for default locale (en) */
  label: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<WfRefBlogTagCreateLocalizationsInput>;
  tagId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WfRefBlogTagCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WfRefBlogTagCreateLocalizationInput = {
  /** Localization input */
  data: WfRefBlogTagCreateLocalizationDataInput;
  locale: Locale;
};

export type WfRefBlogTagCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<WfRefBlogTagCreateLocalizationInput>>;
};

export type WfRefBlogTagCreateManyInlineInput = {
  /** Connect multiple existing WfRefBlogTag documents */
  connect?: InputMaybe<Array<WfRefBlogTagWhereUniqueInput>>;
  /** Create and connect multiple existing WfRefBlogTag documents */
  create?: InputMaybe<Array<WfRefBlogTagCreateInput>>;
};

export type WfRefBlogTagCreateOneInlineInput = {
  /** Connect one existing WfRefBlogTag document */
  connect?: InputMaybe<WfRefBlogTagWhereUniqueInput>;
  /** Create and connect one WfRefBlogTag document */
  create?: InputMaybe<WfRefBlogTagCreateInput>;
};

/** An edge in a connection. */
export type WfRefBlogTagEdge = {
  __typename?: 'WfRefBlogTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WfRefBlogTag;
};

/** Identifies documents */
export type WfRefBlogTagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefBlogTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefBlogTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefBlogTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WfRefBlogTagWhereStageInput>;
  documentInStages_none?: InputMaybe<WfRefBlogTagWhereStageInput>;
  documentInStages_some?: InputMaybe<WfRefBlogTagWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tagId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tagId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tagId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tagId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tagId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tagId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tagId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tagId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tagId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum WfRefBlogTagOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TagIdAsc = 'tagId_ASC',
  TagIdDesc = 'tagId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type WfRefBlogTagUpdateInput = {
  cm03ysxpe01f306oj6m1j4jrk?: InputMaybe<WfRefBlogCategoryUpdateManyInlineInput>;
  cm03yv5h401l406ojf6vu7mm8?: InputMaybe<CosmosPageFeedUpdateManyInlineInput>;
  cm042e4s1035p06oj3yksbtfn?: InputMaybe<CosmosConfigBlogUpdateManyInlineInput>;
  cm4jb8x2e0eg307mv7cim96as?: InputMaybe<CosmosSectionLatestNewsUpdateManyInlineInput>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<WfRefBlogTagUpdateLocalizationsInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogTagUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogTagUpdateLocalizationInput = {
  data: WfRefBlogTagUpdateLocalizationDataInput;
  locale: Locale;
};

export type WfRefBlogTagUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<WfRefBlogTagCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<WfRefBlogTagUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<WfRefBlogTagUpsertLocalizationInput>>;
};

export type WfRefBlogTagUpdateManyInlineInput = {
  /** Connect multiple existing WfRefBlogTag documents */
  connect?: InputMaybe<Array<WfRefBlogTagConnectInput>>;
  /** Create and connect multiple WfRefBlogTag documents */
  create?: InputMaybe<Array<WfRefBlogTagCreateInput>>;
  /** Delete multiple WfRefBlogTag documents */
  delete?: InputMaybe<Array<WfRefBlogTagWhereUniqueInput>>;
  /** Disconnect multiple WfRefBlogTag documents */
  disconnect?: InputMaybe<Array<WfRefBlogTagWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing WfRefBlogTag documents */
  set?: InputMaybe<Array<WfRefBlogTagWhereUniqueInput>>;
  /** Update multiple WfRefBlogTag documents */
  update?: InputMaybe<Array<WfRefBlogTagUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple WfRefBlogTag documents */
  upsert?: InputMaybe<Array<WfRefBlogTagUpsertWithNestedWhereUniqueInput>>;
};

export type WfRefBlogTagUpdateManyInput = {
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<WfRefBlogTagUpdateManyLocalizationsInput>;
};

export type WfRefBlogTagUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type WfRefBlogTagUpdateManyLocalizationInput = {
  data: WfRefBlogTagUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type WfRefBlogTagUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<WfRefBlogTagUpdateManyLocalizationInput>>;
};

export type WfRefBlogTagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: WfRefBlogTagUpdateManyInput;
  /** Document search */
  where: WfRefBlogTagWhereInput;
};

export type WfRefBlogTagUpdateOneInlineInput = {
  /** Connect existing WfRefBlogTag document */
  connect?: InputMaybe<WfRefBlogTagWhereUniqueInput>;
  /** Create and connect one WfRefBlogTag document */
  create?: InputMaybe<WfRefBlogTagCreateInput>;
  /** Delete currently connected WfRefBlogTag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected WfRefBlogTag document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single WfRefBlogTag document */
  update?: InputMaybe<WfRefBlogTagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single WfRefBlogTag document */
  upsert?: InputMaybe<WfRefBlogTagUpsertWithNestedWhereUniqueInput>;
};

export type WfRefBlogTagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: WfRefBlogTagUpdateInput;
  /** Unique document search */
  where: WfRefBlogTagWhereUniqueInput;
};

export type WfRefBlogTagUpsertInput = {
  /** Create document if it didn't exist */
  create: WfRefBlogTagCreateInput;
  /** Update document if it exists */
  update: WfRefBlogTagUpdateInput;
};

export type WfRefBlogTagUpsertLocalizationInput = {
  create: WfRefBlogTagCreateLocalizationDataInput;
  locale: Locale;
  update: WfRefBlogTagUpdateLocalizationDataInput;
};

export type WfRefBlogTagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: WfRefBlogTagUpsertInput;
  /** Unique document search */
  where: WfRefBlogTagWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type WfRefBlogTagWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type WfRefBlogTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefBlogTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefBlogTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefBlogTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WfRefBlogTagWhereStageInput>;
  documentInStages_none?: InputMaybe<WfRefBlogTagWhereStageInput>;
  documentInStages_some?: InputMaybe<WfRefBlogTagWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tagId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tagId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tagId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tagId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tagId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tagId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tagId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tagId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tagId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type WfRefBlogTagWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WfRefBlogTagWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WfRefBlogTagWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WfRefBlogTagWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<WfRefBlogTagWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References WfRefBlogTag record uniquely */
export type WfRefBlogTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  DescendantsOf = 'descendants_of',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some'
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual'
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert'
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one'
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update'
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization'
}

export type AccordionTierFeatureCardFragment = { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type AccordionTierCtaCardFragment = { __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type AccordionTierCardFragment = { __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

export type AccordionTierCardsSectionFragment = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> };

export type AriesCardFragment = { __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type AriesCardsSectionFragment = { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type AssetCarouselSectionFragment = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

export type AssetGallerySectionFragment = { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

export type CosmosAssetFragment = { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null };

export type CosmosImageFragment = { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null };

export type AssetSectionFragment = { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } };

export type CosmosButtonFragment = { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

export type CosmosIconButtonFragment = { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null };

type CosmosModButton_CosmosElementButton_Fragment = { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

type CosmosModButton_CosmosElementIconButton_Fragment = { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null };

export type CosmosModButtonFragment = CosmosModButton_CosmosElementButton_Fragment | CosmosModButton_CosmosElementIconButton_Fragment;

export type CosmosDownloadButtonFragment = { __typename?: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null };

export type CosmosRichTextFragment = { __typename?: 'RichText', html: string, text: string };

export type CosmosLinkFragment = { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null };

export type CosmosTagFragment = { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null };

export type CosmosAvatarFragment = { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type CosmosVideoEmbedFragment = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type CosmosGitHubGistFragment = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

export type CosmosCompareFragment = { __typename?: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type CosmosEdsIconLinkFragment = { __typename?: 'CosmosElementEdsIconLink', ariaLabel?: string | null, href?: string | null, icon?: EdsIconsEnum | null };

export type CosmosIconLinkGroupFragment = { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<{ __typename?: 'CosmosElementEdsIconLink', ariaLabel?: string | null, href?: string | null, icon?: EdsIconsEnum | null }> };

export type CosmosInterviewFragment = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> };

export type CosmosQuoteFragment = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null };

export type CosmosCalloutCardFragment = { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type CosmosTitleAndDescFragment = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null };

export type CosmosPluginDownloadDetailFragment = { __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null };

export type CosmosPluginDownloadFragment = { __typename?: 'CosmosElementPluginDownload', title?: string | null, desc?: string | null, details: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }> };

export type WfRefApplicationOwnerFragment = { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null };

export type BlobTableSectionFragment = { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null };

export type BlogCardFragment = { __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type BlogCardsSectionFragment = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

export type CommunitySectionFragment = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null };

export type CommunityResourceFragmentFragment = { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> };

export type CommunityCardFragmentFragment = { __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null };

export type ComplexCtaCardFragment = { __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null };

export type ComplexCtaCardsSectionFragment = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null };

export type ContentLargeImageFragment = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null };

export type ContentSliderAssetFragment = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

export type CruxLinkFragment = { __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null };

export type CruxSectionFragment = { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> };

export type DelphinusCardFragment = { __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null };

export type DelphinusCardsGridSectionFragment = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> };

export type DevelopersListSectionFragment = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null };

export type PageDirectoryMetadataFragment = { __typename?: 'CosmosPageDirectory', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PageDirectoryEntitiesFragment = { __typename?: 'CosmosPageDirectory', id: string, createdAt: any, updatedAt: any, slug: string, variant: CosmosEnumDirectoryVariant, directoryEyebrow?: string | null, directoryTitle?: string | null, directoryDesc?: string | null, searchPlaceholder?: string | null, industryFilterLabel?: string | null, serviceFilterLabel?: string | null, serviceFilterPlaceholder?: string | null, noResultsLabel?: string | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, topRefSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }>, bottomRefSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> };

export type DividerSectionFragment = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null };

export type DocumentListItemFragment = { __typename?: 'CosmosElementDocumentListItem', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, href?: string | null };

export type DocumentListFragment = { __typename?: 'CosmosElementDocumentList', listId?: string | null, heading?: string | null, items: Array<{ __typename?: 'CosmosElementDocumentListItem', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, href?: string | null }> };

export type CosmosCtaRichTextFragment = { __typename?: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } };

export type DownloadCardCtaLinkFragment = { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null };

type DownloadCardCta_CosmosElementButton_Fragment = { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null };

type DownloadCardCta_CosmosElementDownloadButton_Fragment = { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null };

type DownloadCardCta_CosmosElementIconButton_Fragment = { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null };

type DownloadCardCta_CosmosElementLink_Fragment = { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null };

type DownloadCardCta_CosmosElementRichText_Fragment = { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } };

export type DownloadCardCtaFragment = DownloadCardCta_CosmosElementButton_Fragment | DownloadCardCta_CosmosElementDownloadButton_Fragment | DownloadCardCta_CosmosElementIconButton_Fragment | DownloadCardCta_CosmosElementLink_Fragment | DownloadCardCta_CosmosElementRichText_Fragment;

export type DownloadCardFragment = { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null };

export type DownloadStepFragment = { __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> };

export type DownloadCardsSectionFragment = { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null };

export type DownloadableSectionFragment = { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null };

export type EmbedSectionFragment = { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null };

export type EventsTableRowFragment = { __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null };

export type EventsTableSectionFragment = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> };

export type FaqTabElementFragment = { __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> };

export type FaqSearchSectionFragment = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type FaqItemElementFragment = { __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null };

export type RefFaqItemElementFragment = { __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null };

export type FaqSectionFragment = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type FeatureCardFragment = { __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } };

export type FeatureCardsSectionFragment = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> };

export type AccordionFeatureCardFragment = { __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type AccordionFeatureCardsSectionFragment = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> };

export type LinkListItemFragment = { __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null };

export type FeaturePanelFragment = { __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type FeaturePanelsSectionFragment = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

export type GeminiLinkFragment = { __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null };

export type GeminiCardFragment = { __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type GeminiCardsSectionFragment = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type HeroAlphaMainStackFragment = { __typename?: 'CosmosHeroAlpha', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type HeroAlphaFragment = { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type HeroGlowFragment = { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null };

export type HeroArticleImageFragment = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type HeroBravoFragment = { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type PageHeroes_CosmosHeroAlpha_Fragment = { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type PageHeroes_CosmosHeroArticleImage_Fragment = { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type PageHeroes_CosmosHeroBravo_Fragment = { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type PageHeroes_CosmosHeroGlow_Fragment = { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null };

export type PageHeroesFragment = PageHeroes_CosmosHeroAlpha_Fragment | PageHeroes_CosmosHeroArticleImage_Fragment | PageHeroes_CosmosHeroBravo_Fragment | PageHeroes_CosmosHeroGlow_Fragment;

export type HydrusLinkFragment = { __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null };

export type HydrusColumnFragment = { __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> };

export type HydrusColumnListSectionFragment = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> };

export type LatestNewsSectionFragment = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> };

export type LearnSectionFragment = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> };

export type ElementLearnCategoryFragment = { __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> };

export type CosmosElementLearnDocumentationCardFragment = { __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null };

export type CosmosElementLearnImageCardSourceFragment = { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null };

export type CosmosElementLearnImageCardFragment = { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null };

export type CheckListItemFragment = { __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null };

export type LicenseTopCardFragment = { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

export type LicenseCollapsedCardFragment = { __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null };

export type LicensesCollapsedSectionFragment = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null };

export type LicenseCardTopFragment = { __typename?: 'CosmosElementLicenseCardTop', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null };

export type LicenseCardCoreFragment = { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }> } | null };

export type LicenseSeatFragment = { __typename?: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseSeat', buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null };

export type LicenseMainCardFragment = { __typename?: 'CosmosElementLicenseMainCard', cardTop?: { __typename?: 'CosmosElementLicenseCardTop', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null } | null, cardSections: Array<{ __typename?: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }> } | null }>, seats?: { __typename?: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseSeat', buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null } | null };

export type LogoFragment = { __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } };

export type LogoListSectionFragment = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> };

export type LogoMultiCardFragment = { __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null };

export type LogoMultiCardsSectionFragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> };

export type NewsAuthorTagFragment = { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null };

export type NewsCardFragment = { __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null };

export type NewsCardsSectionFragment = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> };

export type NewsMediaCardFragment = { __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null };

export type NewsMediaCardsSectionFragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> };

export type IndustryFragment = { __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null };

export type IndustryListFragment = { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> };

export type NewsletterSignupFragment = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null };

export type NumberCalloutFragment = { __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null };

export type NumberCalloutSectionFragment = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type CosmosPageAgreementCoreFragment = { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, blocked: Array<CosmosEnumCountryCodes> };

export type CosmosPageAgreementEntitiesFragment = { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, blocked: Array<CosmosEnumCountryCodes>, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }>, agreementDetails?: { __typename?: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null } | null };

export type PageAgreementMetadataFragment = { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type AgreementDetailsFragment = { __typename?: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null };

export type CosmosPageAgreementFragment = { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, blocked: Array<CosmosEnumCountryCodes>, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null }>, agreementDetails?: { __typename?: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null } | null };

export type BlogAuthorTagFragment = { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null };

export type BlogConfigFragment = { __typename?: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any | null, blogLandingCard?: { __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null, tags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, categories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> };

type ArticleComponents_CosmosElementAsset_Fragment = { __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } };

type ArticleComponents_CosmosElementButtonList_Fragment = { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

type ArticleComponents_CosmosElementCalloutCard_Fragment = { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type ArticleComponents_CosmosElementCkEditorText_Fragment = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

type ArticleComponents_CosmosElementCompare_Fragment = { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type ArticleComponents_CosmosElementGithubGist_Fragment = { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null };

type ArticleComponents_CosmosElementIconLinkGroup_Fragment = { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<{ __typename?: 'CosmosElementEdsIconLink', ariaLabel?: string | null, href?: string | null, icon?: EdsIconsEnum | null }> };

type ArticleComponents_CosmosElementInterview_Fragment = { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> };

type ArticleComponents_CosmosElementLicenseContactCard_Fragment = { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type ArticleComponents_CosmosElementQuote_Fragment = { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null };

type ArticleComponents_CosmosElementRichText_Fragment = { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } };

type ArticleComponents_CosmosElementSectionHeading_Fragment = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type ArticleComponents_CosmosElementTitleAndDesc_Fragment = { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null };

type ArticleComponents_CosmosElementUserProfile_Fragment = { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null };

type ArticleComponents_CosmosElementVideoEmbed_Fragment = { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type ArticleComponents_CosmosSectionAssetCarousel_Fragment = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

type ArticleComponents_CosmosSectionAssetGallery_Fragment = { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

type ArticleComponents_CosmosSectionContentLargeImage_Fragment = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null };

type ArticleComponents_CosmosSectionDivider_Fragment = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null };

type ArticleComponents_CosmosSectionLogoList_Fragment = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> };

type ArticleComponents_CosmosSectionLogoMultiCard_Fragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> };

type ArticleComponents_CosmosSectionNewsMediaCard_Fragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> };

type ArticleComponents_CosmosSectionSimpleCta_Fragment = { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type ArticleComponentsFragment = ArticleComponents_CosmosElementAsset_Fragment | ArticleComponents_CosmosElementButtonList_Fragment | ArticleComponents_CosmosElementCalloutCard_Fragment | ArticleComponents_CosmosElementCkEditorText_Fragment | ArticleComponents_CosmosElementCompare_Fragment | ArticleComponents_CosmosElementGithubGist_Fragment | ArticleComponents_CosmosElementIconLinkGroup_Fragment | ArticleComponents_CosmosElementInterview_Fragment | ArticleComponents_CosmosElementLicenseContactCard_Fragment | ArticleComponents_CosmosElementQuote_Fragment | ArticleComponents_CosmosElementRichText_Fragment | ArticleComponents_CosmosElementSectionHeading_Fragment | ArticleComponents_CosmosElementTitleAndDesc_Fragment | ArticleComponents_CosmosElementUserProfile_Fragment | ArticleComponents_CosmosElementVideoEmbed_Fragment | ArticleComponents_CosmosSectionAssetCarousel_Fragment | ArticleComponents_CosmosSectionAssetGallery_Fragment | ArticleComponents_CosmosSectionContentLargeImage_Fragment | ArticleComponents_CosmosSectionDivider_Fragment | ArticleComponents_CosmosSectionLogoList_Fragment | ArticleComponents_CosmosSectionLogoMultiCard_Fragment | ArticleComponents_CosmosSectionNewsMediaCard_Fragment | ArticleComponents_CosmosSectionSimpleCta_Fragment;

export type PageBlogDetailEntitiesFragment = { __typename?: 'CosmosPageBlogDetail', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, blogConfig?: { __typename?: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any | null, blogLandingCard?: { __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null, tags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, categories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, articleComponents: Array<{ __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null } | { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<{ __typename?: 'CosmosElementEdsIconLink', ariaLabel?: string | null, href?: string | null, icon?: EdsIconsEnum | null }> } | { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> } | { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> };

export type PageBlogDetailFragment = { __typename?: 'CosmosPageBlogDetail', createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, blogConfig?: { __typename?: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any | null, blogLandingCard?: { __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null, tags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, categories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, articleComponents: Array<{ __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null } | { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<{ __typename?: 'CosmosElementEdsIconLink', ariaLabel?: string | null, href?: string | null, icon?: EdsIconsEnum | null }> } | { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> } | { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null }> };

export type PageBlogDetailMetadataFragment = { __typename?: 'CosmosPageBlogDetail', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PageEulaKeyFragment = { __typename?: 'CosmosPageEulaKey', id: string, createdAt: any, updatedAt: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, disclaimer?: string | null, title?: string | null, subtitle?: string | null, eulaKey: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null };

export type PageEulaKeyMetadataFragment = { __typename?: 'CosmosPageEulaKey', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PageFeedFragment = { __typename?: 'CosmosPageFeed', id: string, createdAt: any, updatedAt: any, slug: string, searchPlaceholder?: string | null, clearFiltersButtonLabel?: string | null, featuredLabel?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, noResultsDescription?: string | null, tags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, categories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> };

export type PageFeedMetadataFragment = { __typename?: 'CosmosPageFeed', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

type CosmosEntity_Asset_Fragment = { __typename: 'Asset', id: string, stage: Stage };

type CosmosEntity_CommunityCard_Fragment = { __typename: 'CommunityCard', id: string, stage: Stage };

type CosmosEntity_CommunityResource_Fragment = { __typename: 'CommunityResource', id: string, stage: Stage };

type CosmosEntity_CosmosConfigBlog_Fragment = { __typename: 'CosmosConfigBlog', id: string, stage: Stage };

type CosmosEntity_CosmosConfigSection_Fragment = { __typename: 'CosmosConfigSection', id: string, stage: Stage };

type CosmosEntity_CosmosElementAccordionFeatureCard_Fragment = { __typename: 'CosmosElementAccordionFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementAccordionTierCard_Fragment = { __typename: 'CosmosElementAccordionTierCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementAccordionTierCtaCard_Fragment = { __typename: 'CosmosElementAccordionTierCtaCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementAccordionTierFeatureCard_Fragment = { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementAgreementDetail_Fragment = { __typename: 'CosmosElementAgreementDetail', id: string, stage: Stage };

type CosmosEntity_CosmosElementAriesCard_Fragment = { __typename: 'CosmosElementAriesCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementAsset_Fragment = { __typename: 'CosmosElementAsset', id: string, stage: Stage };

type CosmosEntity_CosmosElementAvatar_Fragment = { __typename: 'CosmosElementAvatar', id: string, stage: Stage };

type CosmosEntity_CosmosElementBlogCard_Fragment = { __typename: 'CosmosElementBlogCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementButton_Fragment = { __typename: 'CosmosElementButton', id: string, stage: Stage };

type CosmosEntity_CosmosElementButtonList_Fragment = { __typename: 'CosmosElementButtonList', id: string, stage: Stage };

type CosmosEntity_CosmosElementCalloutCard_Fragment = { __typename: 'CosmosElementCalloutCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementCheckListItem_Fragment = { __typename: 'CosmosElementCheckListItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementCkEditorText_Fragment = { __typename: 'CosmosElementCkEditorText', id: string, stage: Stage };

type CosmosEntity_CosmosElementCkEditorTextCollapsible_Fragment = { __typename: 'CosmosElementCkEditorTextCollapsible', id: string, stage: Stage };

type CosmosEntity_CosmosElementCompare_Fragment = { __typename: 'CosmosElementCompare', id: string, stage: Stage };

type CosmosEntity_CosmosElementComplexCtaCard_Fragment = { __typename: 'CosmosElementComplexCtaCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementCruxLink_Fragment = { __typename: 'CosmosElementCruxLink', id: string, stage: Stage };

type CosmosEntity_CosmosElementDelphinusCard_Fragment = { __typename: 'CosmosElementDelphinusCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementDocumentList_Fragment = { __typename: 'CosmosElementDocumentList', id: string, stage: Stage };

type CosmosEntity_CosmosElementDocumentListItem_Fragment = { __typename: 'CosmosElementDocumentListItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementDownloadButton_Fragment = { __typename: 'CosmosElementDownloadButton', id: string, stage: Stage };

type CosmosEntity_CosmosElementDownloadCard_Fragment = { __typename: 'CosmosElementDownloadCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementDownloadStep_Fragment = { __typename: 'CosmosElementDownloadStep', id: string, stage: Stage };

type CosmosEntity_CosmosElementEdsIconLink_Fragment = { __typename: 'CosmosElementEdsIconLink', id: string, stage: Stage };

type CosmosEntity_CosmosElementEventsTableRow_Fragment = { __typename: 'CosmosElementEventsTableRow', id: string, stage: Stage };

type CosmosEntity_CosmosElementFaqItem_Fragment = { __typename: 'CosmosElementFAQItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementFaqTab_Fragment = { __typename: 'CosmosElementFaqTab', id: string, stage: Stage };

type CosmosEntity_CosmosElementFeatureCard_Fragment = { __typename: 'CosmosElementFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementGameDevFeatureCard_Fragment = { __typename: 'CosmosElementGameDevFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementGeminiCard_Fragment = { __typename: 'CosmosElementGeminiCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementGeminiLink_Fragment = { __typename: 'CosmosElementGeminiLink', id: string, stage: Stage };

type CosmosEntity_CosmosElementGithubGist_Fragment = { __typename: 'CosmosElementGithubGist', id: string, stage: Stage };

type CosmosEntity_CosmosElementHydrusColumn_Fragment = { __typename: 'CosmosElementHydrusColumn', id: string, stage: Stage };

type CosmosEntity_CosmosElementHydrusLink_Fragment = { __typename: 'CosmosElementHydrusLink', id: string, stage: Stage };

type CosmosEntity_CosmosElementIconButton_Fragment = { __typename: 'CosmosElementIconButton', id: string, stage: Stage };

type CosmosEntity_CosmosElementIconLinkGroup_Fragment = { __typename: 'CosmosElementIconLinkGroup', id: string, stage: Stage };

type CosmosEntity_CosmosElementIconSectionHeading_Fragment = { __typename: 'CosmosElementIconSectionHeading', id: string, stage: Stage };

type CosmosEntity_CosmosElementImageTag_Fragment = { __typename: 'CosmosElementImageTag', id: string, stage: Stage };

type CosmosEntity_CosmosElementIndustry_Fragment = { __typename: 'CosmosElementIndustry', id: string, stage: Stage };

type CosmosEntity_CosmosElementInterview_Fragment = { __typename: 'CosmosElementInterview', id: string, stage: Stage };

type CosmosEntity_CosmosElementInterviewQuestion_Fragment = { __typename: 'CosmosElementInterviewQuestion', id: string, stage: Stage };

type CosmosEntity_CosmosElementLearnDocumentationCard_Fragment = { __typename: 'CosmosElementLearnDocumentationCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementLearnImageCard_Fragment = { __typename: 'CosmosElementLearnImageCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementLearnImageCardSource_Fragment = { __typename: 'CosmosElementLearnImageCardSource', id: string, stage: Stage };

type CosmosEntity_CosmosElementLearnTab_Fragment = { __typename: 'CosmosElementLearnTab', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseCardCore_Fragment = { __typename: 'CosmosElementLicenseCardCore', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseCardTop_Fragment = { __typename: 'CosmosElementLicenseCardTop', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseCollapsedCard_Fragment = { __typename: 'CosmosElementLicenseCollapsedCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseContactCard_Fragment = { __typename: 'CosmosElementLicenseContactCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseMainCard_Fragment = { __typename: 'CosmosElementLicenseMainCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseSeat_Fragment = { __typename: 'CosmosElementLicenseSeat', id: string, stage: Stage };

type CosmosEntity_CosmosElementLicenseTopCard_Fragment = { __typename: 'CosmosElementLicenseTopCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementLink_Fragment = { __typename: 'CosmosElementLink', id: string, stage: Stage };

type CosmosEntity_CosmosElementLogo_Fragment = { __typename: 'CosmosElementLogo', id: string, stage: Stage };

type CosmosEntity_CosmosElementLogoMultiCard_Fragment = { __typename: 'CosmosElementLogoMultiCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementNewsCard_Fragment = { __typename: 'CosmosElementNewsCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementNewsMediaCard_Fragment = { __typename: 'CosmosElementNewsMediaCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementNumberCallout_Fragment = { __typename: 'CosmosElementNumberCallout', id: string, stage: Stage };

type CosmosEntity_CosmosElementPluginDownload_Fragment = { __typename: 'CosmosElementPluginDownload', id: string, stage: Stage };

type CosmosEntity_CosmosElementPluginDownloadDetail_Fragment = { __typename: 'CosmosElementPluginDownloadDetail', id: string, stage: Stage };

type CosmosEntity_CosmosElementPluginListItem_Fragment = { __typename: 'CosmosElementPluginListItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementQuote_Fragment = { __typename: 'CosmosElementQuote', id: string, stage: Stage };

type CosmosEntity_CosmosElementResearchCard_Fragment = { __typename: 'CosmosElementResearchCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementResellerCard_Fragment = { __typename: 'CosmosElementResellerCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementRichText_Fragment = { __typename: 'CosmosElementRichText', id: string, stage: Stage };

type CosmosEntity_CosmosElementSearchFilter_Fragment = { __typename: 'CosmosElementSearchFilter', id: string, stage: Stage };

type CosmosEntity_CosmosElementSectionHeading_Fragment = { __typename: 'CosmosElementSectionHeading', id: string, stage: Stage };

type CosmosEntity_CosmosElementSpeakerCard_Fragment = { __typename: 'CosmosElementSpeakerCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementTabbedBlogCardsItem_Fragment = { __typename: 'CosmosElementTabbedBlogCardsItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementTabbedContentImageItem_Fragment = { __typename: 'CosmosElementTabbedContentImageItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementTabbedFullWidthAssetItem_Fragment = { __typename: 'CosmosElementTabbedFullWidthAssetItem', id: string, stage: Stage };

type CosmosEntity_CosmosElementTag_Fragment = { __typename: 'CosmosElementTag', id: string, stage: Stage };

type CosmosEntity_CosmosElementTitleAndDesc_Fragment = { __typename: 'CosmosElementTitleAndDesc', id: string, stage: Stage };

type CosmosEntity_CosmosElementUserProfile_Fragment = { __typename: 'CosmosElementUserProfile', id: string, stage: Stage };

type CosmosEntity_CosmosElementUtCard_Fragment = { __typename: 'CosmosElementUtCard', id: string, stage: Stage };

type CosmosEntity_CosmosElementVideoEmbed_Fragment = { __typename: 'CosmosElementVideoEmbed', id: string, stage: Stage };

type CosmosEntity_CosmosFeedBlogCard_Fragment = { __typename: 'CosmosFeedBlogCard', id: string, stage: Stage };

type CosmosEntity_CosmosHeroAlpha_Fragment = { __typename: 'CosmosHeroAlpha', id: string, stage: Stage };

type CosmosEntity_CosmosHeroArticleImage_Fragment = { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage };

type CosmosEntity_CosmosHeroBravo_Fragment = { __typename: 'CosmosHeroBravo', id: string, stage: Stage };

type CosmosEntity_CosmosHeroGlow_Fragment = { __typename: 'CosmosHeroGlow', id: string, stage: Stage };

type CosmosEntity_CosmosPageAgreement_Fragment = { __typename: 'CosmosPageAgreement', id: string, stage: Stage };

type CosmosEntity_CosmosPageBlogDetail_Fragment = { __typename: 'CosmosPageBlogDetail', id: string, stage: Stage };

type CosmosEntity_CosmosPageDirectory_Fragment = { __typename: 'CosmosPageDirectory', id: string, stage: Stage };

type CosmosEntity_CosmosPageEulaKey_Fragment = { __typename: 'CosmosPageEulaKey', id: string, stage: Stage };

type CosmosEntity_CosmosPageFeed_Fragment = { __typename: 'CosmosPageFeed', id: string, stage: Stage };

type CosmosEntity_CosmosPageHeroAndSection_Fragment = { __typename: 'CosmosPageHeroAndSection', id: string, stage: Stage };

type CosmosEntity_CosmosPageLegalContent_Fragment = { __typename: 'CosmosPageLegalContent', id: string, stage: Stage };

type CosmosEntity_CosmosPageLicense_Fragment = { __typename: 'CosmosPageLicense', id: string, stage: Stage };

type CosmosEntity_CosmosPagePluginDetail_Fragment = { __typename: 'CosmosPagePluginDetail', id: string, stage: Stage };

type CosmosEntity_CosmosPageRedirect_Fragment = { __typename: 'CosmosPageRedirect', id: string, stage: Stage };

type CosmosEntity_CosmosPageResearch_Fragment = { __typename: 'CosmosPageResearch', id: string, stage: Stage };

type CosmosEntity_CosmosPageSearch_Fragment = { __typename: 'CosmosPageSearch', id: string, stage: Stage };

type CosmosEntity_CosmosRefIndustryList_Fragment = { __typename: 'CosmosRefIndustryList', id: string, stage: Stage };

type CosmosEntity_CosmosReferenceFaqItem_Fragment = { __typename: 'CosmosReferenceFAQItem', id: string, stage: Stage };

type CosmosEntity_CosmosReferenceSection_Fragment = { __typename: 'CosmosReferenceSection', id: string, stage: Stage };

type CosmosEntity_CosmosRemoteLearn_Fragment = { __typename: 'CosmosRemoteLearn', id: string, stage: Stage };

type CosmosEntity_CosmosSectionAccordionFeatureCard_Fragment = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionAccordionTierCards_Fragment = { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage };

type CosmosEntity_CosmosSectionAriesCards_Fragment = { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage };

type CosmosEntity_CosmosSectionAsset_Fragment = { __typename: 'CosmosSectionAsset', id: string, stage: Stage };

type CosmosEntity_CosmosSectionAssetCarousel_Fragment = { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage };

type CosmosEntity_CosmosSectionAssetGallery_Fragment = { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage };

type CosmosEntity_CosmosSectionBlobTable_Fragment = { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage };

type CosmosEntity_CosmosSectionBlogCard_Fragment = { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionCkRichText_Fragment = { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage };

type CosmosEntity_CosmosSectionCommunity_Fragment = { __typename: 'CosmosSectionCommunity', id: string, stage: Stage };

type CosmosEntity_CosmosSectionComplexCtaCard_Fragment = { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionContentLargeImage_Fragment = { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage };

type CosmosEntity_CosmosSectionContentSliderAsset_Fragment = { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage };

type CosmosEntity_CosmosSectionCrux_Fragment = { __typename: 'CosmosSectionCrux', id: string, stage: Stage };

type CosmosEntity_CosmosSectionDelphinusCardsGrid_Fragment = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage };

type CosmosEntity_CosmosSectionDevelopersList_Fragment = { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage };

type CosmosEntity_CosmosSectionDivider_Fragment = { __typename: 'CosmosSectionDivider', id: string, stage: Stage };

type CosmosEntity_CosmosSectionDownloadCard_Fragment = { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionDownloadable_Fragment = { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage };

type CosmosEntity_CosmosSectionEmbed_Fragment = { __typename: 'CosmosSectionEmbed', id: string, stage: Stage };

type CosmosEntity_CosmosSectionEventsTable_Fragment = { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage };

type CosmosEntity_CosmosSectionFaq_Fragment = { __typename: 'CosmosSectionFaq', id: string, stage: Stage };

type CosmosEntity_CosmosSectionFaqSearch_Fragment = { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage };

type CosmosEntity_CosmosSectionFeatureCard_Fragment = { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionGameDevFeatureCard_Fragment = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionGeminiCard_Fragment = { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionHydrusColumnList_Fragment = { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage };

type CosmosEntity_CosmosSectionLatestNews_Fragment = { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage };

type CosmosEntity_CosmosSectionLearn_Fragment = { __typename: 'CosmosSectionLearn', id: string, stage: Stage };

type CosmosEntity_CosmosSectionLicensesCollapsed_Fragment = { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage };

type CosmosEntity_CosmosSectionLogoList_Fragment = { __typename: 'CosmosSectionLogoList', id: string, stage: Stage };

type CosmosEntity_CosmosSectionLogoMultiCard_Fragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionNewsCard_Fragment = { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionNewsMediaCard_Fragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionNewsletterSignup_Fragment = { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage };

type CosmosEntity_CosmosSectionNumberCallout_Fragment = { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage };

type CosmosEntity_CosmosSectionPluginListTable_Fragment = { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage };

type CosmosEntity_CosmosSectionQuote_Fragment = { __typename: 'CosmosSectionQuote', id: string, stage: Stage };

type CosmosEntity_CosmosSectionResellersSearch_Fragment = { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage };

type CosmosEntity_CosmosSectionRichText_Fragment = { __typename: 'CosmosSectionRichText', id: string, stage: Stage };

type CosmosEntity_CosmosSectionSimpleCta_Fragment = { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage };

type CosmosEntity_CosmosSectionSlimContactCard_Fragment = { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionSpeakerCard_Fragment = { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionTabbedBlogCard_Fragment = { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage };

type CosmosEntity_CosmosSectionTabbedContentImage_Fragment = { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage };

type CosmosEntity_CosmosSectionTabbedFullWidthAsset_Fragment = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage };

type CosmosEntity_CosmosSectionUtCard_Fragment = { __typename: 'CosmosSectionUtCard', id: string, stage: Stage };

type CosmosEntity_CosmosSeo_Fragment = { __typename: 'CosmosSeo', id: string, stage: Stage };

type CosmosEntity_ElementLearnCategory_Fragment = { __typename: 'ElementLearnCategory', id: string, stage: Stage };

type CosmosEntity_RemoteLearn_Fragment = { __typename: 'RemoteLearn', id: string, stage: Stage };

type CosmosEntity_ScheduledOperation_Fragment = { __typename: 'ScheduledOperation', id: string, stage: Stage };

type CosmosEntity_ScheduledRelease_Fragment = { __typename: 'ScheduledRelease', id: string, stage: Stage };

type CosmosEntity_User_Fragment = { __typename: 'User', id: string, stage: Stage };

type CosmosEntity_WfRefApplicationOwner_Fragment = { __typename: 'WfRefApplicationOwner', id: string, stage: Stage };

type CosmosEntity_WfRefBlogCategory_Fragment = { __typename: 'WfRefBlogCategory', id: string, stage: Stage };

type CosmosEntity_WfRefBlogTag_Fragment = { __typename: 'WfRefBlogTag', id: string, stage: Stage };

export type CosmosEntityFragment = CosmosEntity_Asset_Fragment | CosmosEntity_CommunityCard_Fragment | CosmosEntity_CommunityResource_Fragment | CosmosEntity_CosmosConfigBlog_Fragment | CosmosEntity_CosmosConfigSection_Fragment | CosmosEntity_CosmosElementAccordionFeatureCard_Fragment | CosmosEntity_CosmosElementAccordionTierCard_Fragment | CosmosEntity_CosmosElementAccordionTierCtaCard_Fragment | CosmosEntity_CosmosElementAccordionTierFeatureCard_Fragment | CosmosEntity_CosmosElementAgreementDetail_Fragment | CosmosEntity_CosmosElementAriesCard_Fragment | CosmosEntity_CosmosElementAsset_Fragment | CosmosEntity_CosmosElementAvatar_Fragment | CosmosEntity_CosmosElementBlogCard_Fragment | CosmosEntity_CosmosElementButton_Fragment | CosmosEntity_CosmosElementButtonList_Fragment | CosmosEntity_CosmosElementCalloutCard_Fragment | CosmosEntity_CosmosElementCheckListItem_Fragment | CosmosEntity_CosmosElementCkEditorText_Fragment | CosmosEntity_CosmosElementCkEditorTextCollapsible_Fragment | CosmosEntity_CosmosElementCompare_Fragment | CosmosEntity_CosmosElementComplexCtaCard_Fragment | CosmosEntity_CosmosElementCruxLink_Fragment | CosmosEntity_CosmosElementDelphinusCard_Fragment | CosmosEntity_CosmosElementDocumentList_Fragment | CosmosEntity_CosmosElementDocumentListItem_Fragment | CosmosEntity_CosmosElementDownloadButton_Fragment | CosmosEntity_CosmosElementDownloadCard_Fragment | CosmosEntity_CosmosElementDownloadStep_Fragment | CosmosEntity_CosmosElementEdsIconLink_Fragment | CosmosEntity_CosmosElementEventsTableRow_Fragment | CosmosEntity_CosmosElementFaqItem_Fragment | CosmosEntity_CosmosElementFaqTab_Fragment | CosmosEntity_CosmosElementFeatureCard_Fragment | CosmosEntity_CosmosElementGameDevFeatureCard_Fragment | CosmosEntity_CosmosElementGeminiCard_Fragment | CosmosEntity_CosmosElementGeminiLink_Fragment | CosmosEntity_CosmosElementGithubGist_Fragment | CosmosEntity_CosmosElementHydrusColumn_Fragment | CosmosEntity_CosmosElementHydrusLink_Fragment | CosmosEntity_CosmosElementIconButton_Fragment | CosmosEntity_CosmosElementIconLinkGroup_Fragment | CosmosEntity_CosmosElementIconSectionHeading_Fragment | CosmosEntity_CosmosElementImageTag_Fragment | CosmosEntity_CosmosElementIndustry_Fragment | CosmosEntity_CosmosElementInterview_Fragment | CosmosEntity_CosmosElementInterviewQuestion_Fragment | CosmosEntity_CosmosElementLearnDocumentationCard_Fragment | CosmosEntity_CosmosElementLearnImageCard_Fragment | CosmosEntity_CosmosElementLearnImageCardSource_Fragment | CosmosEntity_CosmosElementLearnTab_Fragment | CosmosEntity_CosmosElementLicenseCardCore_Fragment | CosmosEntity_CosmosElementLicenseCardTop_Fragment | CosmosEntity_CosmosElementLicenseCollapsedCard_Fragment | CosmosEntity_CosmosElementLicenseContactCard_Fragment | CosmosEntity_CosmosElementLicenseMainCard_Fragment | CosmosEntity_CosmosElementLicenseSeat_Fragment | CosmosEntity_CosmosElementLicenseTopCard_Fragment | CosmosEntity_CosmosElementLink_Fragment | CosmosEntity_CosmosElementLogo_Fragment | CosmosEntity_CosmosElementLogoMultiCard_Fragment | CosmosEntity_CosmosElementNewsCard_Fragment | CosmosEntity_CosmosElementNewsMediaCard_Fragment | CosmosEntity_CosmosElementNumberCallout_Fragment | CosmosEntity_CosmosElementPluginDownload_Fragment | CosmosEntity_CosmosElementPluginDownloadDetail_Fragment | CosmosEntity_CosmosElementPluginListItem_Fragment | CosmosEntity_CosmosElementQuote_Fragment | CosmosEntity_CosmosElementResearchCard_Fragment | CosmosEntity_CosmosElementResellerCard_Fragment | CosmosEntity_CosmosElementRichText_Fragment | CosmosEntity_CosmosElementSearchFilter_Fragment | CosmosEntity_CosmosElementSectionHeading_Fragment | CosmosEntity_CosmosElementSpeakerCard_Fragment | CosmosEntity_CosmosElementTabbedBlogCardsItem_Fragment | CosmosEntity_CosmosElementTabbedContentImageItem_Fragment | CosmosEntity_CosmosElementTabbedFullWidthAssetItem_Fragment | CosmosEntity_CosmosElementTag_Fragment | CosmosEntity_CosmosElementTitleAndDesc_Fragment | CosmosEntity_CosmosElementUserProfile_Fragment | CosmosEntity_CosmosElementUtCard_Fragment | CosmosEntity_CosmosElementVideoEmbed_Fragment | CosmosEntity_CosmosFeedBlogCard_Fragment | CosmosEntity_CosmosHeroAlpha_Fragment | CosmosEntity_CosmosHeroArticleImage_Fragment | CosmosEntity_CosmosHeroBravo_Fragment | CosmosEntity_CosmosHeroGlow_Fragment | CosmosEntity_CosmosPageAgreement_Fragment | CosmosEntity_CosmosPageBlogDetail_Fragment | CosmosEntity_CosmosPageDirectory_Fragment | CosmosEntity_CosmosPageEulaKey_Fragment | CosmosEntity_CosmosPageFeed_Fragment | CosmosEntity_CosmosPageHeroAndSection_Fragment | CosmosEntity_CosmosPageLegalContent_Fragment | CosmosEntity_CosmosPageLicense_Fragment | CosmosEntity_CosmosPagePluginDetail_Fragment | CosmosEntity_CosmosPageRedirect_Fragment | CosmosEntity_CosmosPageResearch_Fragment | CosmosEntity_CosmosPageSearch_Fragment | CosmosEntity_CosmosRefIndustryList_Fragment | CosmosEntity_CosmosReferenceFaqItem_Fragment | CosmosEntity_CosmosReferenceSection_Fragment | CosmosEntity_CosmosRemoteLearn_Fragment | CosmosEntity_CosmosSectionAccordionFeatureCard_Fragment | CosmosEntity_CosmosSectionAccordionTierCards_Fragment | CosmosEntity_CosmosSectionAriesCards_Fragment | CosmosEntity_CosmosSectionAsset_Fragment | CosmosEntity_CosmosSectionAssetCarousel_Fragment | CosmosEntity_CosmosSectionAssetGallery_Fragment | CosmosEntity_CosmosSectionBlobTable_Fragment | CosmosEntity_CosmosSectionBlogCard_Fragment | CosmosEntity_CosmosSectionCkRichText_Fragment | CosmosEntity_CosmosSectionCommunity_Fragment | CosmosEntity_CosmosSectionComplexCtaCard_Fragment | CosmosEntity_CosmosSectionContentLargeImage_Fragment | CosmosEntity_CosmosSectionContentSliderAsset_Fragment | CosmosEntity_CosmosSectionCrux_Fragment | CosmosEntity_CosmosSectionDelphinusCardsGrid_Fragment | CosmosEntity_CosmosSectionDevelopersList_Fragment | CosmosEntity_CosmosSectionDivider_Fragment | CosmosEntity_CosmosSectionDownloadCard_Fragment | CosmosEntity_CosmosSectionDownloadable_Fragment | CosmosEntity_CosmosSectionEmbed_Fragment | CosmosEntity_CosmosSectionEventsTable_Fragment | CosmosEntity_CosmosSectionFaq_Fragment | CosmosEntity_CosmosSectionFaqSearch_Fragment | CosmosEntity_CosmosSectionFeatureCard_Fragment | CosmosEntity_CosmosSectionGameDevFeatureCard_Fragment | CosmosEntity_CosmosSectionGeminiCard_Fragment | CosmosEntity_CosmosSectionHydrusColumnList_Fragment | CosmosEntity_CosmosSectionLatestNews_Fragment | CosmosEntity_CosmosSectionLearn_Fragment | CosmosEntity_CosmosSectionLicensesCollapsed_Fragment | CosmosEntity_CosmosSectionLogoList_Fragment | CosmosEntity_CosmosSectionLogoMultiCard_Fragment | CosmosEntity_CosmosSectionNewsCard_Fragment | CosmosEntity_CosmosSectionNewsMediaCard_Fragment | CosmosEntity_CosmosSectionNewsletterSignup_Fragment | CosmosEntity_CosmosSectionNumberCallout_Fragment | CosmosEntity_CosmosSectionPluginListTable_Fragment | CosmosEntity_CosmosSectionQuote_Fragment | CosmosEntity_CosmosSectionResellersSearch_Fragment | CosmosEntity_CosmosSectionRichText_Fragment | CosmosEntity_CosmosSectionSimpleCta_Fragment | CosmosEntity_CosmosSectionSlimContactCard_Fragment | CosmosEntity_CosmosSectionSpeakerCard_Fragment | CosmosEntity_CosmosSectionTabbedBlogCard_Fragment | CosmosEntity_CosmosSectionTabbedContentImage_Fragment | CosmosEntity_CosmosSectionTabbedFullWidthAsset_Fragment | CosmosEntity_CosmosSectionUtCard_Fragment | CosmosEntity_CosmosSeo_Fragment | CosmosEntity_ElementLearnCategory_Fragment | CosmosEntity_RemoteLearn_Fragment | CosmosEntity_ScheduledOperation_Fragment | CosmosEntity_ScheduledRelease_Fragment | CosmosEntity_User_Fragment | CosmosEntity_WfRefApplicationOwner_Fragment | CosmosEntity_WfRefBlogCategory_Fragment | CosmosEntity_WfRefBlogTag_Fragment;

export type RefSectionsEntitiesFragment = { __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null };

export type RefSectionsFragment = { __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null };

export type PageHeroAndSectionsEntitiesFragment = { __typename?: 'CosmosPageHeroAndSection', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> };

export type PageHeroAndSectionsFragment = { __typename?: 'CosmosPageHeroAndSection', createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null }> };

export type PageHeroAndSectionsMetadataFragment = { __typename?: 'CosmosPageHeroAndSection', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type CosmosElementCkEditorTextFragment = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

export type CosmosElementCkEditorTextCollapsibleFragment = { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null };

type PageLegalContentSections_CosmosElementCkEditorText_Fragment = { __typename: 'CosmosElementCkEditorText', ckText?: string | null };

type PageLegalContentSections_CosmosElementCkEditorTextCollapsible_Fragment = { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null };

export type PageLegalContentSectionsFragment = PageLegalContentSections_CosmosElementCkEditorText_Fragment | PageLegalContentSections_CosmosElementCkEditorTextCollapsible_Fragment;

export type PageLegalContentEntitiesFragment = { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, sections: Array<{ __typename: 'CosmosElementCkEditorText', id: string, stage: Stage } | { __typename: 'CosmosElementCkEditorTextCollapsible', id: string, stage: Stage }> };

export type PageLegalContentFragment = { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, sections: Array<{ __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null }> };

export type PageLegalContentMetadataFragment = { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PageLegalContentSlugDataFragment = { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, locale: Locale, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null };

export type CosmosPageLicenseCoreFragment = { __typename?: 'CosmosPageLicense', id: string, createdAt: any, updatedAt: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, hero?: { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, contentLargeImages: Array<{ __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, freeCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, mainCards: Array<{ __typename?: 'CosmosElementLicenseMainCard', cardTop?: { __typename?: 'CosmosElementLicenseCardTop', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null } | null, cardSections: Array<{ __typename?: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }> } | null }>, seats?: { __typename?: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseSeat', buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null } | null }>, contactCard?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, contactCard2?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null };

export type CosmosPageLicenseEntitiesFragment = { __typename?: 'CosmosPageLicense', id: string, createdAt: any, updatedAt: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }>, hero?: { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, contentLargeImages: Array<{ __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, freeCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, mainCards: Array<{ __typename?: 'CosmosElementLicenseMainCard', cardTop?: { __typename?: 'CosmosElementLicenseCardTop', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null } | null, cardSections: Array<{ __typename?: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }> } | null }>, seats?: { __typename?: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseSeat', buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null } | null }>, contactCard?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, contactCard2?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null };

export type CosmosPageLicenseFragment = { __typename?: 'CosmosPageLicense', id: string, createdAt: any, updatedAt: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null }>, hero?: { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, contentLargeImages: Array<{ __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, freeCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, mainCards: Array<{ __typename?: 'CosmosElementLicenseMainCard', cardTop?: { __typename?: 'CosmosElementLicenseCardTop', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null } | null, cardSections: Array<{ __typename?: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }> } | null }>, seats?: { __typename?: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseSeat', buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null } | null }>, contactCard?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, contactCard2?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null };

export type CosmosPageLicenseMetadataFragment = { __typename?: 'CosmosPageLicense', createdAt: any, updatedAt: any, slug?: string | null, id: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PagePluginDetailEntitiesFragment = { __typename?: 'CosmosPagePluginDetail', id: string, createdAt: any, updatedAt: any, slug: string, archivedVersionsTitle?: string | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, downloads: Array<{ __typename?: 'CosmosElementPluginDownload', title?: string | null, desc?: string | null, details: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }> }>, latestCardSections: Array<{ __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }>, articleComponents: Array<{ __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null } | { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> } | { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> }>, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> };

export type PagePluginDetailFragment = { __typename?: 'CosmosPagePluginDetail', createdAt: any, updatedAt: any, slug: string, archivedVersionsTitle?: string | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, downloads: Array<{ __typename?: 'CosmosElementPluginDownload', title?: string | null, desc?: string | null, details: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }> }>, latestCardSections: Array<{ __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }>, articleComponents: Array<{ __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null } | { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> } | { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> }>, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null }> };

export type PagePluginDetailMetadataFragment = { __typename?: 'CosmosPagePluginDetail', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type CosmosRedirectPageFragment = { __typename: 'CosmosPageRedirect', id: string, slug: string, prefixWithLocaleMatcher?: boolean | null, destination: string, permanent?: boolean | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null };

export type ResearchCardFragment = { __typename?: 'CosmosElementResearchCard', href?: string | null, publicationDate?: any | null, desc?: string | null, footer?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type PageResearchFragment = { __typename?: 'CosmosPageResearch', createdAt: any, updatedAt: any, slug: string, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, researchCards: Array<{ __typename?: 'CosmosElementResearchCard', href?: string | null, publicationDate?: any | null, desc?: string | null, footer?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, researchCardsSectionConfig?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null };

export type PageResearchMetadataFragment = { __typename?: 'CosmosPageResearch', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type SearchFilterFragment = { __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null };

export type PageSearchFragment = { __typename?: 'CosmosPageSearch', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, desc?: string | null, searchPlaceholder?: string | null, clearSearchLabel?: string | null, defaultSearchFilter?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, suggestedLinksLabel?: string | null, searchFilters: Array<{ __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null }>, suggestedLinks: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type PageSearchMetadataFragment = { __typename?: 'CosmosPageSearch', id: string, createdAt: any, updatedAt: any, slug: string, defaultSearchFilter?: string | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null, searchFilters: Array<{ __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null }> };

export type PageSearchFiltersFragment = { __typename?: 'CosmosPageSearch', id: string, slug: string, defaultSearchFilter?: string | null, searchFilters: Array<{ __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null }> };

export type PluginListItemFragment = { __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type PluginListTableSectionFragment = { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

export type QuoteSectionFragment = { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> };

export type ResellerCardFragment = { __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null };

export type ResellersSearchSectionFragment = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type RichTextSectionFragment = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

export type CkRichTextSectionFragment = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

export type SectionHeadingFragment = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type IconSectionHeadingFragment = { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type SectionConfigHeadingUnion_CosmosElementIconSectionHeading_Fragment = { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type SectionConfigHeadingUnion_CosmosElementSectionHeading_Fragment = { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type SectionConfigHeadingUnionFragment = SectionConfigHeadingUnion_CosmosElementIconSectionHeading_Fragment | SectionConfigHeadingUnion_CosmosElementSectionHeading_Fragment;

export type SectionConfigFragment = { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type PageSections_CosmosSectionAccordionFeatureCard_Fragment = { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> };

type PageSections_CosmosSectionAccordionTierCards_Fragment = { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> };

type PageSections_CosmosSectionAriesCards_Fragment = { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

type PageSections_CosmosSectionAsset_Fragment = { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } };

type PageSections_CosmosSectionAssetCarousel_Fragment = { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

type PageSections_CosmosSectionAssetGallery_Fragment = { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

type PageSections_CosmosSectionBlobTable_Fragment = { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null };

type PageSections_CosmosSectionBlogCard_Fragment = { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

type PageSections_CosmosSectionCkRichText_Fragment = { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

type PageSections_CosmosSectionCommunity_Fragment = { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null };

type PageSections_CosmosSectionComplexCtaCard_Fragment = { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null };

type PageSections_CosmosSectionContentLargeImage_Fragment = { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null };

type PageSections_CosmosSectionContentSliderAsset_Fragment = { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> };

type PageSections_CosmosSectionCrux_Fragment = { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> };

type PageSections_CosmosSectionDelphinusCardsGrid_Fragment = { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> };

type PageSections_CosmosSectionDevelopersList_Fragment = { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null };

type PageSections_CosmosSectionDivider_Fragment = { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null };

type PageSections_CosmosSectionDownloadCard_Fragment = { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null };

type PageSections_CosmosSectionDownloadable_Fragment = { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null };

type PageSections_CosmosSectionEmbed_Fragment = { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null };

type PageSections_CosmosSectionEventsTable_Fragment = { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> };

type PageSections_CosmosSectionFaq_Fragment = { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type PageSections_CosmosSectionFaqSearch_Fragment = { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type PageSections_CosmosSectionFeatureCard_Fragment = { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> };

type PageSections_CosmosSectionGameDevFeatureCard_Fragment = { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

type PageSections_CosmosSectionGeminiCard_Fragment = { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

type PageSections_CosmosSectionHydrusColumnList_Fragment = { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> };

type PageSections_CosmosSectionLatestNews_Fragment = { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> };

type PageSections_CosmosSectionLearn_Fragment = { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> };

type PageSections_CosmosSectionLicensesCollapsed_Fragment = { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null };

type PageSections_CosmosSectionLogoList_Fragment = { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> };

type PageSections_CosmosSectionLogoMultiCard_Fragment = { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> };

type PageSections_CosmosSectionNewsCard_Fragment = { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> };

type PageSections_CosmosSectionNewsMediaCard_Fragment = { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> };

type PageSections_CosmosSectionNewsletterSignup_Fragment = { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null };

type PageSections_CosmosSectionNumberCallout_Fragment = { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type PageSections_CosmosSectionPluginListTable_Fragment = { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

type PageSections_CosmosSectionQuote_Fragment = { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> };

type PageSections_CosmosSectionResellersSearch_Fragment = { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

type PageSections_CosmosSectionRichText_Fragment = { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> };

type PageSections_CosmosSectionSimpleCta_Fragment = { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

type PageSections_CosmosSectionSlimContactCard_Fragment = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

type PageSections_CosmosSectionSpeakerCard_Fragment = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

type PageSections_CosmosSectionTabbedBlogCard_Fragment = { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> };

type PageSections_CosmosSectionTabbedContentImage_Fragment = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> };

type PageSections_CosmosSectionTabbedFullWidthAsset_Fragment = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

type PageSections_CosmosSectionUtCard_Fragment = { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type PageSectionsFragment = PageSections_CosmosSectionAccordionFeatureCard_Fragment | PageSections_CosmosSectionAccordionTierCards_Fragment | PageSections_CosmosSectionAriesCards_Fragment | PageSections_CosmosSectionAsset_Fragment | PageSections_CosmosSectionAssetCarousel_Fragment | PageSections_CosmosSectionAssetGallery_Fragment | PageSections_CosmosSectionBlobTable_Fragment | PageSections_CosmosSectionBlogCard_Fragment | PageSections_CosmosSectionCkRichText_Fragment | PageSections_CosmosSectionCommunity_Fragment | PageSections_CosmosSectionComplexCtaCard_Fragment | PageSections_CosmosSectionContentLargeImage_Fragment | PageSections_CosmosSectionContentSliderAsset_Fragment | PageSections_CosmosSectionCrux_Fragment | PageSections_CosmosSectionDelphinusCardsGrid_Fragment | PageSections_CosmosSectionDevelopersList_Fragment | PageSections_CosmosSectionDivider_Fragment | PageSections_CosmosSectionDownloadCard_Fragment | PageSections_CosmosSectionDownloadable_Fragment | PageSections_CosmosSectionEmbed_Fragment | PageSections_CosmosSectionEventsTable_Fragment | PageSections_CosmosSectionFaq_Fragment | PageSections_CosmosSectionFaqSearch_Fragment | PageSections_CosmosSectionFeatureCard_Fragment | PageSections_CosmosSectionGameDevFeatureCard_Fragment | PageSections_CosmosSectionGeminiCard_Fragment | PageSections_CosmosSectionHydrusColumnList_Fragment | PageSections_CosmosSectionLatestNews_Fragment | PageSections_CosmosSectionLearn_Fragment | PageSections_CosmosSectionLicensesCollapsed_Fragment | PageSections_CosmosSectionLogoList_Fragment | PageSections_CosmosSectionLogoMultiCard_Fragment | PageSections_CosmosSectionNewsCard_Fragment | PageSections_CosmosSectionNewsMediaCard_Fragment | PageSections_CosmosSectionNewsletterSignup_Fragment | PageSections_CosmosSectionNumberCallout_Fragment | PageSections_CosmosSectionPluginListTable_Fragment | PageSections_CosmosSectionQuote_Fragment | PageSections_CosmosSectionResellersSearch_Fragment | PageSections_CosmosSectionRichText_Fragment | PageSections_CosmosSectionSimpleCta_Fragment | PageSections_CosmosSectionSlimContactCard_Fragment | PageSections_CosmosSectionSpeakerCard_Fragment | PageSections_CosmosSectionTabbedBlogCard_Fragment | PageSections_CosmosSectionTabbedContentImage_Fragment | PageSections_CosmosSectionTabbedFullWidthAsset_Fragment | PageSections_CosmosSectionUtCard_Fragment;

export type CosmosSeoFragment = { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null };

export type SimpleCtaSectionFragment = { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type SlimContactCardFragment = { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> };

export type SlimContactCardsSectionFragment = { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

export type SpeakerCardFragment = { __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type SpeakerCardsSectionFragment = { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type TabbedBlogCardsItemFragment = { __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> };

export type TabbedBlogCardsSectionFragment = { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> };

export type TabbedContentImageItemFragment = { __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null };

export type TabbedContentImageSectionFragment = { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> };

export type TabbedFullWidthAssetItemFragment = { __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type TabbedFullWidthAssetSectionFragment = { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type CosmosUserProfileFragment = { __typename?: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null };

export type UtCardFragment = { __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null };

export type UtCardSectionFragment = { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> };

export type BlogTagFragment = { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string };

export type BlogCategoryFragment = { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null };

export type CreateWfRefBlogTagMutationVariables = Exact<{
  tagId: Scalars['String']['input'];
  label: Scalars['String']['input'];
}>;


export type CreateWfRefBlogTagMutation = { __typename?: 'Mutation', createWfRefBlogTag?: { __typename?: 'WfRefBlogTag', id: string } | null };

export type UpdateLocalizationWfRefBlogTagMutationVariables = Exact<{
  locale: Locale;
  tagId: Scalars['String']['input'];
  label: Scalars['String']['input'];
}>;


export type UpdateLocalizationWfRefBlogTagMutation = { __typename?: 'Mutation', updateWfRefBlogTag?: { __typename?: 'WfRefBlogTag', id: string } | null };

export type UpdateWfRefBlogTagIdMutationVariables = Exact<{
  newTagId: Scalars['String']['input'];
  existingTagId: Scalars['String']['input'];
}>;


export type UpdateWfRefBlogTagIdMutation = { __typename?: 'Mutation', updateWfRefBlogTag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string } | null };

export type QueryLearnSearchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  categoryType: Scalars['String']['input'];
  industry: Scalars['String']['input'];
  applicationFamily: Scalars['String']['input'];
}>;


export type QueryLearnSearchQuery = { __typename?: 'Query', values?: { __typename?: 'RemoteLearn', learnSearch?: any | null } | null };

export type CosmosPageAgreementEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageAgreementEntitiesQuery = { __typename?: 'Query', cosmosPageAgreement?: { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, blocked: Array<CosmosEnumCountryCodes>, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }>, agreementDetails?: { __typename?: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null } | null } | null };

export type CosmosPageAgreementQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageAgreementQuery = { __typename?: 'Query', cosmosPageAgreement?: { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, blocked: Array<CosmosEnumCountryCodes>, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null }>, agreementDetails?: { __typename?: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null } | null } | null };

export type CosmosPageAgreementDetailsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageAgreementDetailsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail', agreementKeyEula: string, acceptedRedirect?: string | null, acceptedTimeout?: number | null, acceptButtonLabel?: string | null, acceptOptionLabel?: string | null, acceptedContent?: string | null, mustAcceptWarning?: string | null } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageAgreementMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageAgreementMetadataQuery = { __typename?: 'Query', cosmosPageAgreement?: { __typename?: 'CosmosPageAgreement', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageBlogDetailEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageBlogDetailEntitiesQuery = { __typename?: 'Query', cosmosPageBlogDetail?: { __typename?: 'CosmosPageBlogDetail', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, blogConfig?: { __typename?: 'CosmosConfigBlog', sticky?: boolean | null, publicationDate?: any | null, blogLandingCard?: { __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null, tags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, categories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, articleComponents: Array<{ __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null } | { __typename: 'CosmosElementIconLinkGroup', id: string, description?: string | null, edsIconLinks: Array<{ __typename?: 'CosmosElementEdsIconLink', ariaLabel?: string | null, href?: string | null, icon?: EdsIconsEnum | null }> } | { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> } | { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> } | null };

export type CosmosPageBlogDetailSectionsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageBlogDetailSectionsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageBlogDetailHeroQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageBlogDetailHeroQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageBlogDetailMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageBlogDetailMetadataQuery = { __typename?: 'Query', cosmosPageBlogDetail?: { __typename?: 'CosmosPageBlogDetail', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageLegalContentMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageLegalContentMetadataQuery = { __typename?: 'Query', cosmosPageLegalContent?: { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageLegalContentQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageLegalContentQuery = { __typename?: 'Query', cosmosPageLegalContent?: { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, sections: Array<{ __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCkEditorTextCollapsible', ckText?: string | null, collapseButtonLabel?: string | null, defaultOpen?: boolean | null }> } | null };

export type CosmosPageLegalContentSlugSingleQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageLegalContentSlugSingleQuery = { __typename?: 'Query', cosmosPageLegalContent?: { __typename?: 'CosmosPageLegalContent', id: string, createdAt: any, updatedAt: any, slug: string, locale: Locale, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null } | null };

export type CosmosPageDirectoryMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageDirectoryMetadataQuery = { __typename?: 'Query', cosmosPageDirectory?: { __typename?: 'CosmosPageDirectory', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageDirectoryEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageDirectoryEntitiesQuery = { __typename?: 'Query', cosmosPageDirectory?: { __typename?: 'CosmosPageDirectory', id: string, createdAt: any, updatedAt: any, slug: string, variant: CosmosEnumDirectoryVariant, directoryEyebrow?: string | null, directoryTitle?: string | null, directoryDesc?: string | null, searchPlaceholder?: string | null, industryFilterLabel?: string | null, serviceFilterLabel?: string | null, serviceFilterPlaceholder?: string | null, noResultsLabel?: string | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, topRefSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }>, bottomRefSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> } | null };

export type CosmosPageEulaKeyQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageEulaKeyQuery = { __typename?: 'Query', cosmosPageEulaKey?: { __typename?: 'CosmosPageEulaKey', id: string, createdAt: any, updatedAt: any, slug: string, banner?: string | null, bannerCountryCodes?: string | null, disclaimer?: string | null, title?: string | null, subtitle?: string | null, eulaKey: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null } | null };

export type CosmosPageEulaKeyMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageEulaKeyMetadataQuery = { __typename?: 'Query', cosmosPageEulaKey?: { __typename?: 'CosmosPageEulaKey', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageFeedEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageFeedEntitiesQuery = { __typename?: 'Query', cosmosPageFeed?: { __typename?: 'CosmosPageFeed', id: string, createdAt: any, updatedAt: any, slug: string, searchPlaceholder?: string | null, clearFiltersButtonLabel?: string | null, featuredLabel?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, noResultsDescription?: string | null, tags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, categories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> } | null, wfRefBlogCategories: Array<{ __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null }> };

export type CosmosPageFeedMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageFeedMetadataQuery = { __typename?: 'Query', cosmosPageFeed?: { __typename?: 'CosmosPageFeed', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageHeroAndSectionMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageHeroAndSectionMetadataQuery = { __typename?: 'Query', cosmosPageHeroAndSection?: { __typename?: 'CosmosPageHeroAndSection', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageHeroAndSectionEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageHeroAndSectionEntitiesQuery = { __typename?: 'Query', cosmosPageHeroAndSection?: { __typename?: 'CosmosPageHeroAndSection', id: string, createdAt: any, updatedAt: any, slug: string, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> } | null };

export type CosmosPageHeroQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageHeroQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageHeroAlphaQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageHeroAlphaQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageHeroGlowQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageHeroGlowQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageHeroArticleImageQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageHeroArticleImageQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageHeroBravoQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageHeroBravoQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageLicenseEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageLicenseEntitiesQuery = { __typename?: 'Query', cosmosPageLicense?: { __typename?: 'CosmosPageLicense', id: string, createdAt: any, updatedAt: any, slug?: string | null, title?: string | null, desc?: string | null, freeCardHeading?: string | null, cardHeading?: string | null, showExampleLabel?: string | null, hideExampleLabel?: string | null, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }>, hero?: { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, contentLargeImages: Array<{ __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, freeCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, mainCards: Array<{ __typename?: 'CosmosElementLicenseMainCard', cardTop?: { __typename?: 'CosmosElementLicenseCardTop', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null } | null, cardSections: Array<{ __typename?: 'CosmosElementLicenseCardCore', title?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseCardCore', title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null, example?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null, label?: string | null }> } | null }>, seats?: { __typename?: 'CosmosElementLicenseSeat', title?: string | null, perSeatPerYear?: string | null, perYear?: string | null, taxes?: string | null, minusButtonLabel?: string | null, addButtonLabel?: string | null, countriesToOverride: Array<CosmosEnumCountryCodes>, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, countryOverride?: { __typename?: 'CosmosElementLicenseSeat', buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null } | null }>, contactCard?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, contactCard2?: { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null } | null };

export type CosmosPageLicenseMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageLicenseMetadataQuery = { __typename?: 'Query', cosmosPageLicense?: { __typename?: 'CosmosPageLicense', createdAt: any, updatedAt: any, slug?: string | null, id: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPagePluginDetailEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPagePluginDetailEntitiesQuery = { __typename?: 'Query', cosmosPagePluginDetail?: { __typename?: 'CosmosPagePluginDetail', id: string, createdAt: any, updatedAt: any, slug: string, archivedVersionsTitle?: string | null, hero?: { __typename: 'CosmosHeroAlpha', id: string, stage: Stage } | { __typename: 'CosmosHeroArticleImage', id: string, stage: Stage } | { __typename: 'CosmosHeroBravo', id: string, stage: Stage } | { __typename: 'CosmosHeroGlow', id: string, stage: Stage } | null, downloads: Array<{ __typename?: 'CosmosElementPluginDownload', title?: string | null, desc?: string | null, details: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }> }>, latestCardSections: Array<{ __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }>, articleComponents: Array<{ __typename: 'CosmosElementAsset', caption?: string | null, articleComponentAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosElementButtonList', buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosElementCalloutCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementCkEditorText', ckText?: string | null } | { __typename: 'CosmosElementCompare', caption?: string | null, attribution?: string | null, leftImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, rightImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosElementGithubGist', username?: string | null, gistId?: string | null, file?: string | null } | { __typename: 'CosmosElementInterview', interviewee?: string | null, questions: Array<{ __typename?: 'CosmosElementInterviewQuestion', question?: string | null, answer?: string | null }> } | { __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementTitleAndDesc', desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementUserProfile', variant?: CosmosEnumUserProfileVariant | null, desc?: string | null, titleText?: string | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrlMd: string, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, button?: { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> }>, refSections: Array<{ __typename?: 'CosmosReferenceSection', section?: { __typename: 'CosmosSectionAccordionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionAccordionTierCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAriesCards', id: string, stage: Stage } | { __typename: 'CosmosSectionAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetCarousel', id: string, stage: Stage } | { __typename: 'CosmosSectionAssetGallery', id: string, stage: Stage } | { __typename: 'CosmosSectionBlobTable', id: string, stage: Stage } | { __typename: 'CosmosSectionBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionCkRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionCommunity', id: string, stage: Stage } | { __typename: 'CosmosSectionComplexCtaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionContentLargeImage', id: string, stage: Stage } | { __typename: 'CosmosSectionContentSliderAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionCrux', id: string, stage: Stage } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, stage: Stage } | { __typename: 'CosmosSectionDevelopersList', id: string, stage: Stage } | { __typename: 'CosmosSectionDivider', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadCard', id: string, stage: Stage } | { __typename: 'CosmosSectionDownloadable', id: string, stage: Stage } | { __typename: 'CosmosSectionEmbed', id: string, stage: Stage } | { __typename: 'CosmosSectionEventsTable', id: string, stage: Stage } | { __typename: 'CosmosSectionFaq', id: string, stage: Stage } | { __typename: 'CosmosSectionFaqSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, stage: Stage } | { __typename: 'CosmosSectionGeminiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionHydrusColumnList', id: string, stage: Stage } | { __typename: 'CosmosSectionLatestNews', id: string, stage: Stage } | { __typename: 'CosmosSectionLearn', id: string, stage: Stage } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoList', id: string, stage: Stage } | { __typename: 'CosmosSectionLogoMultiCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsMediaCard', id: string, stage: Stage } | { __typename: 'CosmosSectionNewsletterSignup', id: string, stage: Stage } | { __typename: 'CosmosSectionNumberCallout', id: string, stage: Stage } | { __typename: 'CosmosSectionPluginListTable', id: string, stage: Stage } | { __typename: 'CosmosSectionQuote', id: string, stage: Stage } | { __typename: 'CosmosSectionResellersSearch', id: string, stage: Stage } | { __typename: 'CosmosSectionRichText', id: string, stage: Stage } | { __typename: 'CosmosSectionSimpleCta', id: string, stage: Stage } | { __typename: 'CosmosSectionSlimContactCard', id: string, stage: Stage } | { __typename: 'CosmosSectionSpeakerCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedContentImage', id: string, stage: Stage } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, stage: Stage } | { __typename: 'CosmosSectionUtCard', id: string, stage: Stage } | null }> } | null };

export type CosmosPagePluginDetailSectionsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPagePluginDetailSectionsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPagePluginDetailHeroQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPagePluginDetailHeroQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPagePluginDetailMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPagePluginDetailMetadataQuery = { __typename?: 'Query', cosmosPagePluginDetail?: { __typename?: 'CosmosPagePluginDetail', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageRedirectQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CosmosPageRedirectQuery = { __typename?: 'Query', cosmosPageRedirect?: { __typename: 'CosmosPageRedirect', id: string, slug: string, prefixWithLocaleMatcher?: boolean | null, destination: string, permanent?: boolean | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null } | null };

export type CosmosPageRedirectsQueryVariables = Exact<{ [key: string]: never; }>;


export type CosmosPageRedirectsQuery = { __typename?: 'Query', cosmosPageRedirects: Array<{ __typename: 'CosmosPageRedirect', id: string, slug: string, prefixWithLocaleMatcher?: boolean | null, destination: string, permanent?: boolean | null, owner?: { __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null } | null }> };

export type CosmosPageResearchMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageResearchMetadataQuery = { __typename?: 'Query', cosmosPageResearch?: { __typename?: 'CosmosPageResearch', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CosmosPageResearchQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageResearchQuery = { __typename?: 'Query', cosmosPageResearch?: { __typename?: 'CosmosPageResearch', createdAt: any, updatedAt: any, slug: string, hero?: { __typename: 'CosmosHeroAlpha', id: string, variant?: CosmosEnumHeroAlphaVariants | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null, altText?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosHeroArticleImage', id: string, gradient?: CosmosEnumEdsGradients | null, caption?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroBravo', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosHeroGlow', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, narrow?: boolean | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null } | null, researchCards: Array<{ __typename?: 'CosmosElementResearchCard', href?: string | null, publicationDate?: any | null, desc?: string | null, footer?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, researchCardsSectionConfig?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | null };

export type CosmosPageSearchFiltersQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageSearchFiltersQuery = { __typename?: 'Query', cosmosPageSearch?: { __typename?: 'CosmosPageSearch', id: string, slug: string, defaultSearchFilter?: string | null, searchFilters: Array<{ __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null }> } | null };

export type CosmosPageSearchMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageSearchMetadataQuery = { __typename?: 'Query', cosmosPageSearch?: { __typename?: 'CosmosPageSearch', id: string, createdAt: any, updatedAt: any, slug: string, defaultSearchFilter?: string | null, metaTags?: { __typename?: 'CosmosSeo', title?: string | null, socialTitle?: string | null, description?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null, searchFilters: Array<{ __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null }> } | null };

export type CosmosPageSearchQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageSearchQuery = { __typename?: 'Query', cosmosPageSearch?: { __typename?: 'CosmosPageSearch', id: string, createdAt: any, updatedAt: any, slug: string, title?: string | null, desc?: string | null, searchPlaceholder?: string | null, clearSearchLabel?: string | null, defaultSearchFilter?: string | null, loadingLabel?: string | null, noResultsLabel?: string | null, suggestedLinksLabel?: string | null, searchFilters: Array<{ __typename?: 'CosmosElementSearchFilter', id: string, label?: string | null, value?: string | null }>, suggestedLinks: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | null };

export type CosmosPageSectionsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionAssetQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionAssetQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename: 'CosmosSectionAsset', id: string, size?: CosmosEnumSectionSizes | null, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, sectionAsset: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionAssetCarouselQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionAssetCarouselQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename: 'CosmosSectionAssetCarousel', id: string, caption?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionAssetGalleryQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionAssetGalleryQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename: 'CosmosSectionAssetGallery', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionBlogCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionBlogCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename: 'CosmosSectionBlogCard', id: string, maxSize?: CosmosEnumBlogCardsMaxSize | null, cardGridFitToWidth?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionBlobTableQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionBlobTableQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename: 'CosmosSectionBlobTable', environmentVariable: string, limit?: number | null, variant?: CosmosEnumBlobTableVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionCommunityQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionCommunityQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename: 'CosmosSectionCommunity', id: string, forumTitle?: string | null, application?: CosmosEnumApplicationFamily | null, skipCommunityTable?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, forumButton?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, resources?: { __typename?: 'CommunityResource', title?: string | null, showMoreStr?: string | null, hideStr?: string | null, cards: Array<{ __typename?: 'CommunityCard', title?: string | null, description?: string | null, iconType?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, link?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null }> } | null } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionComplexCtaCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionComplexCtaCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename: 'CosmosSectionComplexCtaCard', id: string, complexCtaVariant?: CosmosEnumComplexCtaVariant | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementComplexCtaCard', icon?: EdsIconsEnum | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, button?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null }>, bottomDescription?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionContentLargeImageQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionContentLargeImageQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename: 'CosmosSectionContentLargeImage', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, caption?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionCruxQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionCruxQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename: 'CosmosSectionCrux', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cruxLinks: Array<{ __typename?: 'CosmosElementCruxLink', label?: string | null, href?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionDividerQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionDividerQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename: 'CosmosSectionDivider', id: string, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, size?: CosmosEnumSectionSizes | null } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionDownloadableQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionDownloadableQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename: 'CosmosSectionDownloadable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, instructions?: { __typename?: 'CosmosReferenceSection', section?: { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | null } | null, executables: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionDownloadCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionDownloadCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename: 'CosmosSectionDownloadCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, steps: Array<{ __typename?: 'CosmosElementDownloadStep', gradient?: CosmosEnumEdsGradients | null, label?: string | null, content: Array<{ __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null }> }>, footer?: { __typename?: 'CosmosElementDownloadCard', titleIcon?: EdsIconsEnum | null, title: { __typename?: 'RichText', html: string, text: string }, description: { __typename?: 'RichText', html: string, text: string }, cta?: { __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementDownloadButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, windowsUrl?: string | null, macUrl?: string | null, mobileDisclaimer?: { __typename?: 'RichText', html: string, text: string } | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null } | { __typename: 'CosmosElementLink', label?: string | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null, linkIcon?: CosmosEnumLinkIcons | null } | { __typename: 'CosmosElementRichText', text: { __typename?: 'RichText', html: string, text: string } } | null } | null } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionEmbedQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionEmbedQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename: 'CosmosSectionEmbed', id: string, size?: CosmosEnumSectionSizes | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, embed?: { __typename: 'CosmosElementVideoEmbed', iframeSrc?: string | null, disableOverlay?: boolean | null, playButtonAriaLabel?: string | null, attribution?: string | null, overlayImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionEventsTableQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionEventsTableQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename: 'CosmosSectionEventsTable', id: string, upcomingTabLabel?: string | null, pastTabLabel?: string | null, titleColumnLabel?: string | null, locationColumnLabel?: string | null, detailsColumnLabel?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null, events: Array<{ __typename?: 'CosmosElementEventsTableRow', id: string, title?: string | null, badgeLabel?: string | null, timeAndDate?: any | null, endTimeAndDate?: any | null, timeZone?: CosmosEnumTimeZone | null, timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null, location?: string | null, href?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionFeatureCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionFeatureCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename: 'CosmosSectionFeatureCard', id: string, tagListTitle?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tags: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, cards: Array<{ __typename?: 'CosmosElementFeatureCard', imageLabel?: string | null, label?: string | null, href?: string | null, img: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } }> } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionFaqQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionFaqQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename: 'CosmosSectionFaq', id: string, firstItemDefaultOpen?: boolean | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, faqButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionGameDevFeatureCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionGameDevFeatureCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename: 'CosmosSectionGameDevFeatureCard', id: string, disableCardBg?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionAccordionFeatureCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionAccordionFeatureCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename: 'CosmosSectionAccordionFeatureCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename?: 'CosmosElementAccordionFeatureCard', defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGameDevFeatureCard', eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, linksAsTags?: boolean | null, flip?: boolean | null, eyebrowBadges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', id: string, href?: string | null, label?: string | null, iconPosition?: CosmosEnumIconPosition | null, icon?: CosmosEnumLinkIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> }> } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionAccordionTierCardsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionAccordionTierCardsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename: 'CosmosSectionAccordionTierCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCard', id: string, tag?: string | null, gradient?: CosmosEnumEdsGradients | null, defaultOpen?: boolean | null, anchorLinkId?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, items: Array<{ __typename: 'CosmosElementAccordionTierCtaCard', id: string, desc?: string | null, gradient?: CosmosEnumEdsGradients | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementAccordionTierFeatureCard', id: string, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, buttons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionLearnQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionLearnQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename: 'CosmosSectionLearn', id: string, applicationFamily?: CosmosEnumApplicationFamily | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename?: 'CosmosElementLearnTab', label: string, value: CosmosEnumLearnTabs }>, categories: Array<{ __typename?: 'ElementLearnCategory', categoryType?: EnumLearnCategories | null, titleHref?: string | null, cardCount?: number | null, squareImage?: boolean | null, description?: { __typename?: 'RichText', html: string, text: string } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, remoteLearn?: { __typename?: 'RemoteLearn', id: string, learnSearch?: any | null } | null, cards: Array<{ __typename: 'CosmosElementLearnDocumentationCard', description?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null } | { __typename?: 'CosmosElementLearnImageCard', desc?: string | null, imageLabel?: string | null, url?: string | null, industries: Array<CosmosEnumLearnTabs>, title?: { __typename?: 'RichText', html: string, text: string } | null, source?: { __typename?: 'CosmosElementLearnImageCardSource', author?: string | null, timestamp?: any | null, ago?: string | null } | null, img?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }>, cta?: { __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | null, remoteCards: Array<{ __typename?: 'CosmosRemoteLearn', id: string, industries: Array<CosmosEnumLearnTabs>, type: CosmosEnumLearnPostType, data?: any | null }> }> } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionLogoListQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionLogoListQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename: 'CosmosSectionLogoList', id: string, disableMarquee?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, logos: Array<{ __typename?: 'CosmosElementLogo', href?: string | null, title: string, landscape: boolean, image: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null } }> } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionLogoMultiCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionLogoMultiCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename: 'CosmosSectionLogoMultiCard', id: string, desc?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, links: Array<{ __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null }>, cards: Array<{ __typename?: 'CosmosElementLogoMultiCard', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, desc?: string | null, href?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionNewsCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionNewsCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename: 'CosmosSectionNewsCard', id: string, maxCount?: EnumSmallNewsCardMax | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsCard', href?: string | null, image: { __typename?: 'Asset', url: string, altText?: string | null }, title?: { __typename?: 'RichText', html: string, text: string } | null, description?: { __typename?: 'RichText', html: string, text: string } | null, tag?: { __typename?: 'CosmosElementTag', href?: string | null, label?: string | null } | null, authorTag?: { __typename?: 'CosmosElementImageTag', href?: string | null, label: string, image?: { __typename?: 'Asset', url: string, altText?: string | null } | null } | null }> } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionNewsMediaCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionNewsMediaCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename: 'CosmosSectionNewsMediaCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementNewsMediaCard', href?: string | null, desc?: string | null, author?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null }> } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionLicensesCollapsedQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionLicensesCollapsedQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename: 'CosmosSectionLicensesCollapsed', id: string, freeHeading?: string | null, collapsedCardsHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, topCard?: { __typename?: 'CosmosElementLicenseTopCard', title?: string | null, bullets: Array<{ __typename?: 'RichText', html: string, text: string }>, checkList: Array<{ __typename?: 'CosmosElementCheckListItem', label?: string | null, icon?: CosmosEnumCheckListIcons | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | null, collapsedCards: Array<{ __typename?: 'CosmosElementLicenseCollapsedCard', icon?: EdsIconsEnum | null, title?: string | null, description?: { __typename?: 'RichText', html: string, text: string } | null }>, collapsedCta?: { __typename?: 'CosmosElementLink', label?: string | null, href?: string | null, icon?: CosmosEnumLinkIcons | null, iconPosition?: CosmosEnumIconPosition | null } | null } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionRichTextQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionRichTextQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename: 'CosmosSectionRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, content?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionGeminiCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionGeminiCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename: 'CosmosSectionGeminiCard', id: string, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, cardsVariant?: CosmosEnumGeminiVariants | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, cards: Array<{ __typename?: 'CosmosElementGeminiCard', id: string, eyebrow?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, cardHref?: string | null, desc?: string | null, background?: CosmosEnumMaterialCardBackground | null, anchorLinkId?: string | null, heading?: { __typename?: 'RichText', html: string, text: string } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, links: Array<{ __typename?: 'CosmosElementGeminiLink', id: string, label?: string | null, href?: string | null, endIcon?: CosmosEnumLinkIcons | null, edsIcon?: EdsIconsEnum | null }>, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionHydrusColumnListQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionHydrusColumnListQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename: 'CosmosSectionHydrusColumnList', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, columns: Array<{ __typename?: 'CosmosElementHydrusColumn', id: string, title?: string | null, titleHref?: string | null, links: Array<{ __typename?: 'CosmosElementHydrusLink', id: string, icon?: EdsIconsEnum | null, label?: string | null, href?: string | null, badgeLabel?: string | null }> }> } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionDelphinusCardsGridQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionDelphinusCardsGridQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename: 'CosmosSectionDelphinusCardsGrid', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, grid: Array<{ __typename?: 'CosmosElementDelphinusCard', id: string, preHeading?: string | null, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, title?: string | null, titleHref?: string | null, desc?: string | null, assetPosition?: CosmosEnumIconPosition | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, badge?: { __typename?: 'CosmosElementTag', label?: string | null, href?: string | null } | null, avatar?: { __typename?: 'CosmosElementAvatar', href?: string | null, label?: string | null, imageSrc?: string | null, color?: CosmosEnumAvatarColors | null, imageAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null }> } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionNewsletterSignupQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionNewsletterSignupQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename: 'CosmosSectionNewsletterSignup', id: string, signUpLabel?: string | null, successTitle?: string | null, successDescription?: string | null, industryPlaceholder?: string | null, industriesRef?: { __typename?: 'CosmosRefIndustryList', industries: Array<{ __typename?: 'CosmosElementIndustry', salesForceId: string, dataRouterId?: string | null, label?: string | null }> } | null } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionSimpleCtaQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionSimpleCtaQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename: 'CosmosSectionSimpleCta', id: string, style?: CosmosEnumSimpleCtaStyle | null, gradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, desc?: string | null, simpleCtaVariant?: CosmosEnumSimpleCtaVariant | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionSlimContactCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionSlimContactCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename: 'CosmosSectionSlimContactCard', id: string, forceShowPaddingTop?: boolean | null, forceShowPaddingBottom?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementLicenseContactCard', slimContactCardDesc?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionSpeakerCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionSpeakerCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename: 'CosmosSectionSpeakerCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, speakers: Array<{ __typename?: 'CosmosElementSpeakerCard', id: string, icon?: EdsIconsEnum | null, title?: string | null, company?: string | null, desc?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionLatestNewsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionLatestNewsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename: 'CosmosSectionLatestNews', id: string, preserveStickySort?: boolean | null, featuredLabel?: string | null, feedBrand?: string | null, disableCategoryPills?: boolean | null, latestNewsVariant?: CosmosEnumLatestNewsVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string }>, cosmosPageBlogDetails: Array<{ __typename?: 'CosmosPageBlogDetail', slug: string }> } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionNumberCalloutQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionNumberCalloutQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename: 'CosmosSectionNumberCallout', id: string, icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, eyebrow?: string | null, titleGradient?: CosmosEnumEdsGradients | null, desc?: string | null, timeAndDate?: any | null, flip?: boolean | null, verticallyCenter?: boolean | null, numberCalloutVariant?: CosmosEnumNumberCalloutVariants | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, callouts: Array<{ __typename?: 'CosmosElementNumberCallout', number?: number | null, numberDisplay?: string | null, label?: string | null }>, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionTabbedFullWidthAssetQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionTabbedFullWidthAssetQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename: 'CosmosSectionTabbedFullWidthAsset', id: string, tabs: Array<{ __typename?: 'CosmosElementTabbedFullWidthAssetItem', tabLabel?: string | null, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }>, heroAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionTabbedBlogCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionTabbedBlogCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename: 'CosmosSectionTabbedBlogCard', id: string, tabs: Array<{ __typename: 'CosmosElementTabbedBlogCardsItem', id: string, tabLabel?: string | null, description?: string | null, cardGridFitToWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, backgroundAsset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, cards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }>, featuredCards: Array<{ __typename?: 'CosmosElementBlogCard', href?: string | null, desc?: string | null, eyebrow?: string | null, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, category?: { __typename?: 'WfRefBlogCategory', id: string, categoryId: string, categorySlug?: string | null, label?: string | null, pluralLabel?: string | null, badgeColor?: string | null, tag?: { __typename?: 'WfRefBlogTag', id: string, tagId: string, label: string } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> }> } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionTabbedContentImageQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionTabbedContentImageQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename: 'CosmosSectionTabbedContentImage', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tabs: Array<{ __typename: 'CosmosElementTabbedContentImageItem', id: string, tabLabel?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, blurredImage?: { __typename?: 'Asset', id: string, url: string, width?: number | null, height?: number | null, mimeType?: string | null, altText?: string | null, optUrl: string } | null }> } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionFaqSearchQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionFaqSearchQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename: 'CosmosSectionFaqSearch', id: string, desc?: string | null, faqButtonsPosition?: CosmosEnumFaqButtonsPosition | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, title?: { __typename?: 'RichText', html: string, text: string } | null, faqTabs: Array<{ __typename?: 'CosmosElementFaqTab', id: string, title?: string | null, firstItemDefaultOpen?: boolean | null, anchorLinkId?: string | null, items: Array<{ __typename?: 'CosmosElementFAQItem', id: string, defaultOpen?: boolean | null, anchorLinkId?: string | null, question?: { __typename?: 'RichText', html: string, text: string } | null, answer?: { __typename?: 'RichText', html: string, text: string } | null }>, refFaqItems: Array<{ __typename?: 'CosmosReferenceFAQItem', id: string, question?: string | null, answer?: string | null, anchorLinkId?: string | null }> }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionCkRichTextQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionCkRichTextQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename: 'CosmosSectionCkRichText', id: string, wide?: boolean | null, centered?: boolean | null, centeredButton?: boolean | null, ckContent?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }> } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionAriesCardsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionAriesCardsQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename: 'CosmosSectionAriesCards', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementAriesCard', id: string, icon?: EdsIconsEnum | null, desc?: string | null, fullWidth?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, asset?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionContentSliderAssetQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionContentSliderAssetQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename: 'CosmosSectionContentSliderAsset', id: string, eyebrow?: string | null, gradient?: CosmosEnumEdsGradients | null, desc?: string | null, flip?: boolean | null, verticallyCenter?: boolean | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, badges: Array<{ __typename?: 'CosmosElementTag', href?: string | null, label?: string | null }>, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, assets: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null }> } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionQuoteQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionQuoteQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename: 'CosmosSectionQuote', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, quotes: Array<{ __typename: 'CosmosElementQuote', quote?: string | null, source?: string | null, description?: string | null, iconGradient?: CosmosEnumEdsGradients | null }> } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionUtCardQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionUtCardQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename: 'CosmosSectionUtCard', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename?: 'CosmosElementUtCard', href?: string | null, label?: string | null, cardImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null, logoImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null }> } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionResellersSearchQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionResellersSearchQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename: 'CosmosSectionResellersSearch', id: string, viewLocationLabel?: string | null, searchLabel?: string | null, noResultsLabel?: string | null, locationLinkTemplate?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, cards: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards2: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards3: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, cards4: Array<{ __typename: 'CosmosElementResellerCard', id: string, name?: string | null, website?: string | null, email?: string | null, street?: string | null, postalCode?: string | null, city?: string | null, region?: string | null, phone?: string | null, continents: Array<CosmosEnumResellerContinents>, location?: { __typename?: 'Location', latitude: number, longitude: number } | null }>, blurredBackgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionPluginListTableQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionPluginListTableQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename?: 'CosmosSectionDevelopersList' } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename: 'CosmosSectionPluginListTable', id: string, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, tableItems: Array<{ __typename?: 'CosmosElementPluginListItem', id: string, title?: string | null, desc?: string | null, learnMoreUrl?: string | null, compatibilityTags: Array<string>, downloads: Array<{ __typename?: 'CosmosElementPluginDownloadDetail', operatingSystem?: CosmosEnumOperatingSystems | null, downloadUrl?: string | null, dateLastUpdated?: any | null, infoContent?: string | null, releaseNotesUrl?: string | null, tpsNoticesUrl?: string | null, sizeInBytes?: number | null }>, extraButtons: Array<{ __typename?: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> }> } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageSectionDevelopersListQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type CosmosPageSectionDevelopersListQuery = { __typename?: 'Query', entities?: Array<{ __typename?: 'Asset' } | { __typename?: 'CommunityCard' } | { __typename?: 'CommunityResource' } | { __typename?: 'CosmosConfigBlog' } | { __typename?: 'CosmosConfigSection' } | { __typename?: 'CosmosElementAccordionFeatureCard' } | { __typename?: 'CosmosElementAccordionTierCard' } | { __typename?: 'CosmosElementAccordionTierCtaCard' } | { __typename?: 'CosmosElementAccordionTierFeatureCard' } | { __typename?: 'CosmosElementAgreementDetail' } | { __typename?: 'CosmosElementAriesCard' } | { __typename?: 'CosmosElementAsset' } | { __typename?: 'CosmosElementAvatar' } | { __typename?: 'CosmosElementBlogCard' } | { __typename?: 'CosmosElementButton' } | { __typename?: 'CosmosElementButtonList' } | { __typename?: 'CosmosElementCalloutCard' } | { __typename?: 'CosmosElementCheckListItem' } | { __typename?: 'CosmosElementCkEditorText' } | { __typename?: 'CosmosElementCkEditorTextCollapsible' } | { __typename?: 'CosmosElementCompare' } | { __typename?: 'CosmosElementComplexCtaCard' } | { __typename?: 'CosmosElementCruxLink' } | { __typename?: 'CosmosElementDelphinusCard' } | { __typename?: 'CosmosElementDocumentList' } | { __typename?: 'CosmosElementDocumentListItem' } | { __typename?: 'CosmosElementDownloadButton' } | { __typename?: 'CosmosElementDownloadCard' } | { __typename?: 'CosmosElementDownloadStep' } | { __typename?: 'CosmosElementEdsIconLink' } | { __typename?: 'CosmosElementEventsTableRow' } | { __typename?: 'CosmosElementFAQItem' } | { __typename?: 'CosmosElementFaqTab' } | { __typename?: 'CosmosElementFeatureCard' } | { __typename?: 'CosmosElementGameDevFeatureCard' } | { __typename?: 'CosmosElementGeminiCard' } | { __typename?: 'CosmosElementGeminiLink' } | { __typename?: 'CosmosElementGithubGist' } | { __typename?: 'CosmosElementHydrusColumn' } | { __typename?: 'CosmosElementHydrusLink' } | { __typename?: 'CosmosElementIconButton' } | { __typename?: 'CosmosElementIconLinkGroup' } | { __typename?: 'CosmosElementIconSectionHeading' } | { __typename?: 'CosmosElementImageTag' } | { __typename?: 'CosmosElementIndustry' } | { __typename?: 'CosmosElementInterview' } | { __typename?: 'CosmosElementInterviewQuestion' } | { __typename?: 'CosmosElementLearnDocumentationCard' } | { __typename?: 'CosmosElementLearnImageCard' } | { __typename?: 'CosmosElementLearnImageCardSource' } | { __typename?: 'CosmosElementLearnTab' } | { __typename?: 'CosmosElementLicenseCardCore' } | { __typename?: 'CosmosElementLicenseCardTop' } | { __typename?: 'CosmosElementLicenseCollapsedCard' } | { __typename?: 'CosmosElementLicenseContactCard' } | { __typename?: 'CosmosElementLicenseMainCard' } | { __typename?: 'CosmosElementLicenseSeat' } | { __typename?: 'CosmosElementLicenseTopCard' } | { __typename?: 'CosmosElementLink' } | { __typename?: 'CosmosElementLogo' } | { __typename?: 'CosmosElementLogoMultiCard' } | { __typename?: 'CosmosElementNewsCard' } | { __typename?: 'CosmosElementNewsMediaCard' } | { __typename?: 'CosmosElementNumberCallout' } | { __typename?: 'CosmosElementPluginDownload' } | { __typename?: 'CosmosElementPluginDownloadDetail' } | { __typename?: 'CosmosElementPluginListItem' } | { __typename?: 'CosmosElementQuote' } | { __typename?: 'CosmosElementResearchCard' } | { __typename?: 'CosmosElementResellerCard' } | { __typename?: 'CosmosElementRichText' } | { __typename?: 'CosmosElementSearchFilter' } | { __typename?: 'CosmosElementSectionHeading' } | { __typename?: 'CosmosElementSpeakerCard' } | { __typename?: 'CosmosElementTabbedBlogCardsItem' } | { __typename?: 'CosmosElementTabbedContentImageItem' } | { __typename?: 'CosmosElementTabbedFullWidthAssetItem' } | { __typename?: 'CosmosElementTag' } | { __typename?: 'CosmosElementTitleAndDesc' } | { __typename?: 'CosmosElementUserProfile' } | { __typename?: 'CosmosElementUtCard' } | { __typename?: 'CosmosElementVideoEmbed' } | { __typename?: 'CosmosFeedBlogCard' } | { __typename?: 'CosmosHeroAlpha' } | { __typename?: 'CosmosHeroArticleImage' } | { __typename?: 'CosmosHeroBravo' } | { __typename?: 'CosmosHeroGlow' } | { __typename?: 'CosmosPageAgreement' } | { __typename?: 'CosmosPageBlogDetail' } | { __typename?: 'CosmosPageDirectory' } | { __typename?: 'CosmosPageEulaKey' } | { __typename?: 'CosmosPageFeed' } | { __typename?: 'CosmosPageHeroAndSection' } | { __typename?: 'CosmosPageLegalContent' } | { __typename?: 'CosmosPageLicense' } | { __typename?: 'CosmosPagePluginDetail' } | { __typename?: 'CosmosPageRedirect' } | { __typename?: 'CosmosPageResearch' } | { __typename?: 'CosmosPageSearch' } | { __typename?: 'CosmosRefIndustryList' } | { __typename?: 'CosmosReferenceFAQItem' } | { __typename?: 'CosmosReferenceSection' } | { __typename?: 'CosmosRemoteLearn' } | { __typename?: 'CosmosSectionAccordionFeatureCard' } | { __typename?: 'CosmosSectionAccordionTierCards' } | { __typename?: 'CosmosSectionAriesCards' } | { __typename?: 'CosmosSectionAsset' } | { __typename?: 'CosmosSectionAssetCarousel' } | { __typename?: 'CosmosSectionAssetGallery' } | { __typename?: 'CosmosSectionBlobTable' } | { __typename?: 'CosmosSectionBlogCard' } | { __typename?: 'CosmosSectionCkRichText' } | { __typename?: 'CosmosSectionCommunity' } | { __typename?: 'CosmosSectionComplexCtaCard' } | { __typename?: 'CosmosSectionContentLargeImage' } | { __typename?: 'CosmosSectionContentSliderAsset' } | { __typename?: 'CosmosSectionCrux' } | { __typename?: 'CosmosSectionDelphinusCardsGrid' } | { __typename: 'CosmosSectionDevelopersList', id: string, itemsPerPage?: number | null, tableHeading?: string | null, config?: { __typename?: 'CosmosConfigSection', anchorId?: string | null, edsBackgroundColor?: CosmosEnumEdsBackgroundColors | null, backgroundFullHeight?: boolean | null, collapsed?: boolean | null, backgroundAnimation?: CosmosEnumLottieAnimation | null, disablePaddingBottom?: boolean | null, heading?: { __typename: 'CosmosElementIconSectionHeading', icon?: EdsIconsEnum | null, iconGradient?: CosmosEnumEdsGradients | null, titleGradient?: CosmosEnumEdsGradients | null, compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | { __typename: 'CosmosElementSectionHeading', compressedTitle?: boolean | null, desc?: string | null, centeredVerticalStack?: boolean | null, titleGradient?: CosmosEnumEdsGradients | null, buttonAlignLeft?: boolean | null, title?: { __typename?: 'RichText', html: string, text: string } | null, buttons: Array<{ __typename?: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null }>, modButtons: Array<{ __typename: 'CosmosElementButton', label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, name?: string | null } | { __typename: 'CosmosElementIconButton', icon?: CosmosEnumButtonIcons | null, name?: string | null, label?: string | null, variant?: CosmosEnumButtonVariants | null, href?: string | null, iconPosition?: CosmosEnumIconPosition | null }> } | null, backgroundImage?: { __typename?: 'Asset', id: string, url: string, altText?: string | null, attribution?: string | null, mimeType?: string | null, enableVideoControls?: boolean | null, width?: number | null, height?: number | null, overrideEmbedUrl?: string | null, overrideEmbedDisableOverlay?: boolean | null, optUrl: string, fallbackImage?: { __typename?: 'Asset', url: string, altText?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, optUrl: string } | null } | null } | null, developersTsv?: { __typename?: 'Asset', url: string, mimeType?: string | null } | null } | { __typename?: 'CosmosSectionDivider' } | { __typename?: 'CosmosSectionDownloadCard' } | { __typename?: 'CosmosSectionDownloadable' } | { __typename?: 'CosmosSectionEmbed' } | { __typename?: 'CosmosSectionEventsTable' } | { __typename?: 'CosmosSectionFaq' } | { __typename?: 'CosmosSectionFaqSearch' } | { __typename?: 'CosmosSectionFeatureCard' } | { __typename?: 'CosmosSectionGameDevFeatureCard' } | { __typename?: 'CosmosSectionGeminiCard' } | { __typename?: 'CosmosSectionHydrusColumnList' } | { __typename?: 'CosmosSectionLatestNews' } | { __typename?: 'CosmosSectionLearn' } | { __typename?: 'CosmosSectionLicensesCollapsed' } | { __typename?: 'CosmosSectionLogoList' } | { __typename?: 'CosmosSectionLogoMultiCard' } | { __typename?: 'CosmosSectionNewsCard' } | { __typename?: 'CosmosSectionNewsMediaCard' } | { __typename?: 'CosmosSectionNewsletterSignup' } | { __typename?: 'CosmosSectionNumberCallout' } | { __typename?: 'CosmosSectionPluginListTable' } | { __typename?: 'CosmosSectionQuote' } | { __typename?: 'CosmosSectionResellersSearch' } | { __typename?: 'CosmosSectionRichText' } | { __typename?: 'CosmosSectionSimpleCta' } | { __typename?: 'CosmosSectionSlimContactCard' } | { __typename?: 'CosmosSectionSpeakerCard' } | { __typename?: 'CosmosSectionTabbedBlogCard' } | { __typename?: 'CosmosSectionTabbedContentImage' } | { __typename?: 'CosmosSectionTabbedFullWidthAsset' } | { __typename?: 'CosmosSectionUtCard' } | { __typename?: 'CosmosSeo' } | { __typename?: 'ElementLearnCategory' } | { __typename?: 'RemoteLearn' } | { __typename?: 'ScheduledOperation' } | { __typename?: 'ScheduledRelease' } | { __typename?: 'User' } | { __typename?: 'WfRefApplicationOwner' } | { __typename?: 'WfRefBlogCategory' } | { __typename?: 'WfRefBlogTag' }> | null };

export type CosmosPageTemplatesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CosmosPageTemplatesQuery = { __typename?: 'Query', cosmosPageHeroAndSection?: { __typename: 'CosmosPageHeroAndSection', id: string, slug: string } | null, cosmosPageDirectory?: { __typename: 'CosmosPageDirectory', id: string, slug: string } | null, cosmosPageBlogDetail?: { __typename: 'CosmosPageBlogDetail', id: string, slug: string } | null, cosmosPageEulaKey?: { __typename: 'CosmosPageEulaKey', id: string, slug: string } | null, cosmosPageRedirect?: { __typename: 'CosmosPageRedirect', id: string, slug: string } | null, cosmosPageLegalContent?: { __typename: 'CosmosPageLegalContent', id: string, slug: string } | null, cosmosPageSearch?: { __typename: 'CosmosPageSearch', id: string, slug: string } | null, cosmosPageResearch?: { __typename: 'CosmosPageResearch', id: string, slug: string } | null };

export type WfRefApplicationOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type WfRefApplicationOwnersQuery = { __typename?: 'Query', wfRefApplicationOwners: Array<{ __typename?: 'WfRefApplicationOwner', id: string, isDefault?: boolean | null, label: string, ownerId: string, prodUrl: string, gamedevUrl: string, pageSlugPrefix?: string | null }> };

export type WfRefTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WfRefTagsQuery = { __typename?: 'Query', wfRefBlogTags: Array<{ __typename?: 'WfRefBlogTag', tagId: string }> };

export const WfRefApplicationOwnerFragmentDoc = gql`
    fragment WfRefApplicationOwner on WfRefApplicationOwner {
  id
  isDefault
  label
  ownerId
  prodUrl
  gamedevUrl
  pageSlugPrefix
}
    `;
export const CosmosSeoFragmentDoc = gql`
    fragment CosmosSeo on CosmosSeo {
  title
  socialTitle
  description
  socialDescription
  openGraphImage {
    url(transformation: {image: {resize: {width: 1200}}})
    width
    height
  }
  noIndex
  noFollow
}
    `;
export const PageDirectoryMetadataFragmentDoc = gql`
    fragment PageDirectoryMetadata on CosmosPageDirectory {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const RefSectionsEntitiesFragmentDoc = gql`
    fragment RefSectionsEntities on CosmosReferenceSection {
  section {
    ... on Entity {
      id
      stage
      __typename
    }
  }
}
    `;
export const PageDirectoryEntitiesFragmentDoc = gql`
    fragment PageDirectoryEntities on CosmosPageDirectory {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  topRefSections(first: 30) {
    ...RefSectionsEntities
  }
  bottomRefSections(first: 30) {
    ...RefSectionsEntities
  }
  variant
  directoryEyebrow
  directoryTitle
  directoryDesc
  searchPlaceholder
  industryFilterLabel
  serviceFilterLabel
  serviceFilterPlaceholder
  noResultsLabel
}
    `;
export const DocumentListItemFragmentDoc = gql`
    fragment DocumentListItem on CosmosElementDocumentListItem {
  icon
  iconGradient
  title
  href
}
    `;
export const DocumentListFragmentDoc = gql`
    fragment DocumentList on CosmosElementDocumentList {
  listId
  heading
  items {
    ...DocumentListItem
  }
}
    `;
export const CosmosPageAgreementCoreFragmentDoc = gql`
    fragment CosmosPageAgreementCore on CosmosPageAgreement {
  id
  createdAt
  updatedAt
  slug
  title
  blocked
}
    `;
export const AgreementDetailsFragmentDoc = gql`
    fragment AgreementDetails on CosmosElementAgreementDetail {
  agreementKeyEula
  acceptedRedirect
  acceptedTimeout
  acceptButtonLabel
  acceptOptionLabel
  acceptedContent
  mustAcceptWarning
}
    `;
export const CosmosPageAgreementEntitiesFragmentDoc = gql`
    fragment CosmosPageAgreementEntities on CosmosPageAgreement {
  ...CosmosPageAgreementCore
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
  agreementDetails {
    ...AgreementDetails
  }
}
    `;
export const PageAgreementMetadataFragmentDoc = gql`
    fragment PageAgreementMetadata on CosmosPageAgreement {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const CosmosAssetFragmentDoc = gql`
    fragment CosmosAsset on Asset {
  id
  url
  altText
  attribution
  mimeType
  enableVideoControls
  width
  height
  fallbackImage {
    url
    altText
    width
    height
    mimeType
    optUrl: url(
      transformation: {image: {resize: {width: 1200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  overrideEmbedUrl
  overrideEmbedDisableOverlay
}
    `;
export const CosmosButtonFragmentDoc = gql`
    fragment CosmosButton on CosmosElementButton {
  label
  variant
  href
  name
}
    `;
export const CosmosIconButtonFragmentDoc = gql`
    fragment CosmosIconButton on CosmosElementIconButton {
  icon
  name
  label
  variant
  href
  iconPosition
}
    `;
export const CosmosModButtonFragmentDoc = gql`
    fragment CosmosModButton on CosmosElementSectionHeadingmodButtonsUnion {
  ... on CosmosElementButton {
    __typename
    ...CosmosButton
  }
  ... on CosmosElementIconButton {
    __typename
    ...CosmosIconButton
  }
}
    `;
export const HeroAlphaMainStackFragmentDoc = gql`
    fragment HeroAlphaMainStack on CosmosHeroAlpha {
  logoImage {
    url
    width
    height
    altText
  }
  eyebrow
  title {
    html
    text
  }
  gradient
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
}
    `;
export const HeroAlphaFragmentDoc = gql`
    fragment HeroAlpha on CosmosHeroAlpha {
  __typename
  id
  variant
  blurredImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  heroAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  ...HeroAlphaMainStack
}
    `;
export const CosmosRichTextFragmentDoc = gql`
    fragment CosmosRichText on RichText {
  html
  text
}
    `;
export const HeroGlowFragmentDoc = gql`
    fragment HeroGlow on CosmosHeroGlow {
  __typename
  id
  blurredImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  title {
    ...CosmosRichText
  }
  gradient
  desc
  narrow
}
    `;
export const HeroArticleImageFragmentDoc = gql`
    fragment HeroArticleImage on CosmosHeroArticleImage {
  __typename
  id
  title {
    ...CosmosRichText
  }
  gradient
  description {
    ...CosmosRichText
  }
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1000}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
  backgroundAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    `;
export const HeroBravoFragmentDoc = gql`
    fragment HeroBravo on CosmosHeroBravo {
  __typename
  id
  title {
    ...CosmosRichText
  }
  gradient
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  backgroundAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    `;
export const PageHeroesFragmentDoc = gql`
    fragment PageHeroes on CosmosPageHeroAndSectionheroUnion {
  ... on CosmosHeroAlpha {
    ...HeroAlpha
  }
  ... on CosmosHeroGlow {
    ...HeroGlow
  }
  ... on CosmosHeroArticleImage {
    ...HeroArticleImage
  }
  ... on CosmosHeroBravo {
    ...HeroBravo
  }
}
    `;
export const SectionHeadingFragmentDoc = gql`
    fragment SectionHeading on CosmosElementSectionHeading {
  __typename
  title {
    ...CosmosRichText
  }
  compressedTitle
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  centeredVerticalStack
  titleGradient
  buttonAlignLeft
}
    `;
export const IconSectionHeadingFragmentDoc = gql`
    fragment IconSectionHeading on CosmosElementIconSectionHeading {
  __typename
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  titleGradient
  compressedTitle
  desc
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  centeredVerticalStack
}
    `;
export const SectionConfigHeadingUnionFragmentDoc = gql`
    fragment SectionConfigHeadingUnion on CosmosConfigSectionheadingUnion {
  ... on CosmosElementSectionHeading {
    ...SectionHeading
  }
  ... on CosmosElementIconSectionHeading {
    ...IconSectionHeading
  }
}
    `;
export const SectionConfigFragmentDoc = gql`
    fragment SectionConfig on CosmosConfigSection {
  anchorId
  heading {
    ...SectionConfigHeadingUnion
  }
  edsBackgroundColor
  backgroundImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  backgroundFullHeight
  collapsed
  backgroundAnimation
  disablePaddingBottom
}
    `;
export const AssetSectionFragmentDoc = gql`
    fragment AssetSection on CosmosSectionAsset {
  __typename
  id
  config {
    ...SectionConfig
  }
  size
  sectionAsset: asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
}
    `;
export const AssetCarouselSectionFragmentDoc = gql`
    fragment AssetCarouselSection on CosmosSectionAssetCarousel {
  __typename
  id
  config {
    ...SectionConfig
  }
  assets {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
}
    `;
export const AssetGallerySectionFragmentDoc = gql`
    fragment AssetGallerySection on CosmosSectionAssetGallery {
  __typename
  id
  config {
    ...SectionConfig
  }
  assets {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    `;
export const BlogTagFragmentDoc = gql`
    fragment BlogTag on WfRefBlogTag {
  id
  tagId
  label
}
    `;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategory on WfRefBlogCategory {
  id
  categoryId
  categorySlug
  label
  pluralLabel
  badgeColor
  tag {
    ...BlogTag
  }
}
    `;
export const BlogCardFragmentDoc = gql`
    fragment BlogCard on CosmosElementBlogCard {
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  href
  category {
    ...BlogCategory
  }
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosIconButton
  }
  eyebrow
}
    `;
export const BlogCardsSectionFragmentDoc = gql`
    fragment BlogCardsSection on CosmosSectionBlogCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...BlogCard
  }
  maxSize
  cardGridFitToWidth
}
    `;
export const BlobTableSectionFragmentDoc = gql`
    fragment BlobTableSection on CosmosSectionBlobTable {
  __typename
  config {
    ...SectionConfig
  }
  environmentVariable
  limit
  variant
}
    `;
export const CosmosLinkFragmentDoc = gql`
    fragment CosmosLink on CosmosElementLink {
  label
  href
  icon
  iconPosition
}
    `;
export const CommunityCardFragmentFragmentDoc = gql`
    fragment CommunityCardFragment on CommunityCard {
  title
  description
  iconType
  iconGradient
  link {
    ...CosmosLink
  }
}
    `;
export const CommunityResourceFragmentFragmentDoc = gql`
    fragment CommunityResourceFragment on CommunityResource {
  cards(first: 10) {
    ...CommunityCardFragment
  }
  title
  showMoreStr
  hideStr
}
    `;
export const CommunitySectionFragmentDoc = gql`
    fragment CommunitySection on CosmosSectionCommunity {
  __typename
  id
  config {
    ...SectionConfig
  }
  forumTitle
  forumButton {
    ...CosmosButton
  }
  resources {
    ...CommunityResourceFragment
  }
  application
  skipCommunityTable
}
    `;
export const ComplexCtaCardFragmentDoc = gql`
    fragment ComplexCtaCard on CosmosElementComplexCtaCard {
  icon
  title {
    ...CosmosRichText
  }
  desc
  button {
    ...CosmosButton
  }
}
    `;
export const ComplexCtaCardsSectionFragmentDoc = gql`
    fragment ComplexCtaCardsSection on CosmosSectionComplexCtaCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards(first: 20) {
    ...ComplexCtaCard
  }
  bottomDescription {
    ...CosmosRichText
  }
  complexCtaVariant
}
    `;
export const CosmosTagFragmentDoc = gql`
    fragment CosmosTag on CosmosElementTag {
  href
  label
}
    `;
export const CosmosImageFragmentDoc = gql`
    fragment CosmosImage on Asset {
  id
  url
  width
  height
  mimeType
  altText
}
    `;
export const ContentLargeImageFragmentDoc = gql`
    fragment ContentLargeImage on CosmosSectionContentLargeImage {
  __typename
  id
  config {
    ...SectionConfig
  }
  eyebrow
  badges {
    ...CosmosTag
  }
  gradient
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
  blurredImage {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  flip
  verticallyCenter
}
    `;
export const CruxLinkFragmentDoc = gql`
    fragment CruxLink on CosmosElementCruxLink {
  label
  href
  icon
  iconGradient
}
    `;
export const CruxSectionFragmentDoc = gql`
    fragment CruxSection on CosmosSectionCrux {
  __typename
  id
  config {
    ...SectionConfig
  }
  cruxLinks {
    ...CruxLink
  }
}
    `;
export const DividerSectionFragmentDoc = gql`
    fragment DividerSection on CosmosSectionDivider {
  __typename
  id
  edsBackgroundColor
  size
}
    `;
export const CosmosDownloadButtonFragmentDoc = gql`
    fragment CosmosDownloadButton on CosmosElementDownloadButton {
  label
  variant
  windowsUrl
  macUrl
  mobileDisclaimer {
    ...CosmosRichText
  }
}
    `;
export const CosmosCtaRichTextFragmentDoc = gql`
    fragment CosmosCtaRichText on CosmosElementRichText {
  text {
    ...CosmosRichText
  }
}
    `;
export const DownloadCardCtaLinkFragmentDoc = gql`
    fragment DownloadCardCtaLink on CosmosElementLink {
  label
  href
  linkIcon: icon
  iconPosition
}
    `;
export const DownloadCardCtaFragmentDoc = gql`
    fragment DownloadCardCta on CosmosElementDownloadCardctaUnion {
  ... on CosmosElementButton {
    __typename
    ...CosmosButton
  }
  ... on CosmosElementDownloadButton {
    __typename
    ...CosmosDownloadButton
  }
  ... on CosmosElementIconButton {
    __typename
    ...CosmosIconButton
  }
  ... on CosmosElementRichText {
    __typename
    ...CosmosCtaRichText
  }
  ... on CosmosElementLink {
    __typename
    ...DownloadCardCtaLink
  }
}
    `;
export const DownloadCardFragmentDoc = gql`
    fragment DownloadCard on CosmosElementDownloadCard {
  titleIcon
  title {
    ...CosmosRichText
  }
  description {
    ...CosmosRichText
  }
  cta {
    ...DownloadCardCta
  }
}
    `;
export const DownloadStepFragmentDoc = gql`
    fragment DownloadStep on CosmosElementDownloadStep {
  gradient
  label
  content {
    ...DownloadCard
  }
}
    `;
export const DownloadCardsSectionFragmentDoc = gql`
    fragment DownloadCardsSection on CosmosSectionDownloadCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  steps {
    ...DownloadStep
  }
  footer {
    ...DownloadCard
  }
}
    `;
export const DownloadableSectionFragmentDoc = gql`
    fragment DownloadableSection on CosmosSectionDownloadable {
  __typename
  id
  config {
    ...SectionConfig
  }
  instructions {
    section {
      ... on CosmosSectionDownloadCard {
        ...DownloadCardsSection
      }
    }
  }
  executables {
    ...DownloadCard
  }
  footer {
    ...DownloadCard
  }
}
    `;
export const CosmosVideoEmbedFragmentDoc = gql`
    fragment CosmosVideoEmbed on CosmosElementVideoEmbed {
  __typename
  iframeSrc
  overlayImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  disableOverlay
  playButtonAriaLabel
  attribution
}
    `;
export const EmbedSectionFragmentDoc = gql`
    fragment EmbedSection on CosmosSectionEmbed {
  __typename
  id
  config {
    ...SectionConfig
  }
  size
  embed {
    ...CosmosVideoEmbed
  }
}
    `;
export const EventsTableRowFragmentDoc = gql`
    fragment EventsTableRow on CosmosElementEventsTableRow {
  id
  title
  badgeLabel
  timeAndDate
  endTimeAndDate
  timeZone
  timeAndDateFormat
  location
  description {
    ...CosmosRichText
  }
  href
}
    `;
export const EventsTableSectionFragmentDoc = gql`
    fragment EventsTableSection on CosmosSectionEventsTable {
  __typename
  id
  config {
    ...SectionConfig
  }
  blurredImage {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 400}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  upcomingTabLabel
  pastTabLabel
  titleColumnLabel
  locationColumnLabel
  detailsColumnLabel
  events {
    ...EventsTableRow
  }
}
    `;
export const FaqItemElementFragmentDoc = gql`
    fragment FAQItemElement on CosmosElementFAQItem {
  id
  question {
    ...CosmosRichText
  }
  answer {
    ...CosmosRichText
  }
  defaultOpen
  anchorLinkId
}
    `;
export const RefFaqItemElementFragmentDoc = gql`
    fragment RefFAQItemElement on CosmosReferenceFAQItem {
  id
  question
  answer
  anchorLinkId
}
    `;
export const FaqSectionFragmentDoc = gql`
    fragment FAQSection on CosmosSectionFaq {
  __typename
  id
  config {
    ...SectionConfig
  }
  title {
    ...CosmosRichText
  }
  items(first: 25) {
    ...FAQItemElement
  }
  refFaqItems(first: 25) {
    ...RefFAQItemElement
  }
  firstItemDefaultOpen
  modButtons {
    ...CosmosModButton
  }
  faqButtonsPosition
  faqButtons {
    ...CosmosIconButton
  }
}
    `;
export const FeatureCardFragmentDoc = gql`
    fragment FeatureCard on CosmosElementFeatureCard {
  img {
    url(
      transformation: {image: {resize: {width: 540}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
    width
    height
  }
  imageLabel
  label
  href
}
    `;
export const FeatureCardsSectionFragmentDoc = gql`
    fragment FeatureCardsSection on CosmosSectionFeatureCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  tagListTitle
  tags {
    ...CosmosTag
  }
  cards(first: 20) {
    ...FeatureCard
  }
}
    `;
export const LinkListItemFragmentDoc = gql`
    fragment LinkListItem on CosmosElementLink {
  id
  href
  label
  iconPosition
  icon
}
    `;
export const FeaturePanelFragmentDoc = gql`
    fragment FeaturePanel on CosmosElementGameDevFeatureCard {
  eyebrowBadges {
    ...CosmosTag
  }
  eyebrow
  title {
    ...CosmosRichText
  }
  gradient
  desc
  links {
    ...LinkListItem
  }
  linksAsTags
  buttons {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  flip
}
    `;
export const FeaturePanelsSectionFragmentDoc = gql`
    fragment FeaturePanelsSection on CosmosSectionGameDevFeatureCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...FeaturePanel
  }
  disableCardBg
  verticallyCenter
  buttons {
    ...CosmosButton
  }
}
    `;
export const AccordionFeatureCardFragmentDoc = gql`
    fragment AccordionFeatureCard on CosmosElementAccordionFeatureCard {
  title {
    ...CosmosRichText
  }
  cards(first: 20) {
    ...FeaturePanel
  }
  defaultOpen
  anchorLinkId
}
    `;
export const AccordionFeatureCardsSectionFragmentDoc = gql`
    fragment AccordionFeatureCardsSection on CosmosSectionAccordionFeatureCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  items(first: 20) {
    ...AccordionFeatureCard
  }
}
    `;
export const AccordionTierFeatureCardFragmentDoc = gql`
    fragment AccordionTierFeatureCard on CosmosElementAccordionTierFeatureCard {
  __typename
  id
  title {
    ...CosmosRichText
  }
  desc
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 600}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  buttons {
    ...CosmosModButton
  }
}
    `;
export const AccordionTierCtaCardFragmentDoc = gql`
    fragment AccordionTierCtaCard on CosmosElementAccordionTierCtaCard {
  __typename
  id
  title {
    ...CosmosRichText
  }
  desc
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  buttons {
    ...CosmosModButton
  }
  gradient
}
    `;
export const AccordionTierCardFragmentDoc = gql`
    fragment AccordionTierCard on CosmosElementAccordionTierCard {
  __typename
  id
  title {
    ...CosmosRichText
  }
  tag
  gradient
  defaultOpen
  anchorLinkId
  items(first: 20) {
    ... on CosmosElementAccordionTierFeatureCard {
      ...AccordionTierFeatureCard
    }
    ... on CosmosElementAccordionTierCtaCard {
      ...AccordionTierCtaCard
    }
  }
}
    `;
export const AccordionTierCardsSectionFragmentDoc = gql`
    fragment AccordionTierCardsSection on CosmosSectionAccordionTierCards {
  __typename
  id
  config {
    ...SectionConfig
  }
  items(first: 10) {
    ...AccordionTierCard
  }
}
    `;
export const CosmosElementLearnDocumentationCardFragmentDoc = gql`
    fragment CosmosElementLearnDocumentationCard on CosmosElementLearnDocumentationCard {
  __typename
  description {
    ...CosmosRichText
  }
  links(first: 10) {
    ...CosmosLink
  }
  cta {
    ...CosmosButton
  }
}
    `;
export const CosmosElementLearnImageCardSourceFragmentDoc = gql`
    fragment CosmosElementLearnImageCardSource on CosmosElementLearnImageCardSource {
  author
  timestamp
  ago
}
    `;
export const CosmosElementLearnImageCardFragmentDoc = gql`
    fragment CosmosElementLearnImageCard on CosmosElementLearnImageCard {
  title {
    ...CosmosRichText
  }
  desc
  imageLabel
  url
  source {
    ...CosmosElementLearnImageCardSource
  }
  img {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  industries
}
    `;
export const ElementLearnCategoryFragmentDoc = gql`
    fragment ElementLearnCategory on ElementLearnCategory {
  categoryType
  description {
    ...CosmosRichText
  }
  title {
    ...CosmosRichText
  }
  titleHref
  remoteLearn {
    id
    learnSearch(
      industries: "games"
      types: "tutorial"
      applicationFamily: "unreal_engine"
    )
  }
  cards(first: 20) {
    ...CosmosElementLearnDocumentationCard
    ...CosmosElementLearnImageCard
  }
  cardCount
  cta {
    ...CosmosButton
  }
  remoteCards(first: 20) {
    id
    industries
    type
    data
  }
  squareImage
}
    `;
export const LearnSectionFragmentDoc = gql`
    fragment LearnSection on CosmosSectionLearn {
  __typename
  id
  config {
    ...SectionConfig
  }
  tabs {
    label
    value
  }
  categories(first: 10) {
    ...ElementLearnCategory
  }
  applicationFamily
}
    `;
export const LogoFragmentDoc = gql`
    fragment Logo on CosmosElementLogo {
  image {
    ...CosmosImage
  }
  href
  title
  landscape
}
    `;
export const LogoListSectionFragmentDoc = gql`
    fragment LogoListSection on CosmosSectionLogoList {
  __typename
  id
  config {
    ...SectionConfig
  }
  logos(first: 30) {
    ...Logo
  }
  disableMarquee
}
    `;
export const LogoMultiCardFragmentDoc = gql`
    fragment LogoMultiCard on CosmosElementLogoMultiCard {
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  desc
  href
}
    `;
export const LogoMultiCardsSectionFragmentDoc = gql`
    fragment LogoMultiCardsSection on CosmosSectionLogoMultiCard {
  __typename
  config {
    ...SectionConfig
  }
  id
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ... on CosmosElementButton {
      ...CosmosButton
    }
    ... on CosmosElementIconButton {
      ...CosmosIconButton
    }
  }
  links {
    ...CosmosLink
  }
  cards {
    ...LogoMultiCard
  }
}
    `;
export const NewsAuthorTagFragmentDoc = gql`
    fragment NewsAuthorTag on CosmosElementImageTag {
  image {
    url(transformation: {image: {resize: {width: 20}, quality: {value: 90}}})
    altText
  }
  href
  label
}
    `;
export const NewsCardFragmentDoc = gql`
    fragment NewsCard on CosmosElementNewsCard {
  image {
    url(
      transformation: {image: {resize: {width: 256}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
    altText
  }
  href
  title {
    ...CosmosRichText
  }
  description {
    ...CosmosRichText
  }
  tag {
    ...CosmosTag
  }
  authorTag {
    ...NewsAuthorTag
  }
}
    `;
export const NewsCardsSectionFragmentDoc = gql`
    fragment NewsCardsSection on CosmosSectionNewsCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...NewsCard
  }
  maxCount
}
    `;
export const NewsMediaCardFragmentDoc = gql`
    fragment NewsMediaCard on CosmosElementNewsMediaCard {
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 740}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  href
  title {
    ...CosmosRichText
  }
  desc
  author
}
    `;
export const NewsMediaCardsSectionFragmentDoc = gql`
    fragment NewsMediaCardsSection on CosmosSectionNewsMediaCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...NewsMediaCard
  }
}
    `;
export const CheckListItemFragmentDoc = gql`
    fragment CheckListItem on CosmosElementCheckListItem {
  label
  icon
}
    `;
export const LicenseTopCardFragmentDoc = gql`
    fragment LicenseTopCard on CosmosElementLicenseTopCard {
  title
  bullets {
    ...CosmosRichText
  }
  checkList {
    ...CheckListItem
  }
  buttons {
    ...CosmosButton
  }
}
    `;
export const LicenseCollapsedCardFragmentDoc = gql`
    fragment LicenseCollapsedCard on CosmosElementLicenseCollapsedCard {
  icon
  title
  description {
    ...CosmosRichText
  }
}
    `;
export const LicensesCollapsedSectionFragmentDoc = gql`
    fragment LicensesCollapsedSection on CosmosSectionLicensesCollapsed {
  __typename
  id
  config {
    ...SectionConfig
  }
  freeHeading
  topCard {
    ...LicenseTopCard
  }
  collapsedCardsHeading
  collapsedCards {
    ...LicenseCollapsedCard
  }
  collapsedCta {
    ...CosmosLink
  }
}
    `;
export const RichTextSectionFragmentDoc = gql`
    fragment RichTextSection on CosmosSectionRichText {
  __typename
  id
  config {
    ...SectionConfig
  }
  content {
    ...CosmosRichText
  }
  wide
  centered
  centeredButton
  buttons {
    ...CosmosButton
  }
}
    `;
export const GeminiLinkFragmentDoc = gql`
    fragment GeminiLink on CosmosElementGeminiLink {
  id
  edsIcon: icon
  label
  href
  endIcon
}
    `;
export const GeminiCardFragmentDoc = gql`
    fragment GeminiCard on CosmosElementGeminiCard {
  id
  eyebrow
  heading {
    ...CosmosRichText
  }
  badge {
    label
    href
  }
  icon
  iconGradient
  title {
    ...CosmosRichText
  }
  cardHref
  desc
  links(first: 10) {
    ...GeminiLink
  }
  buttons(first: 10) {
    ...CosmosButton
  }
  modButtons {
    ...CosmosModButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  background
  anchorLinkId
}
    `;
export const GeminiCardsSectionFragmentDoc = gql`
    fragment GeminiCardsSection on CosmosSectionGeminiCard {
  __typename
  id
  logoImage {
    ...CosmosAsset
  }
  config {
    ...SectionConfig
  }
  title {
    ...CosmosRichText
  }
  gradient
  desc
  cards(first: 25) {
    ...GeminiCard
  }
  cardsVariant
}
    `;
export const HydrusLinkFragmentDoc = gql`
    fragment HydrusLink on CosmosElementHydrusLink {
  id
  icon
  label
  href
  badgeLabel
}
    `;
export const HydrusColumnFragmentDoc = gql`
    fragment HydrusColumn on CosmosElementHydrusColumn {
  id
  title
  titleHref
  links(first: 10) {
    ...HydrusLink
  }
}
    `;
export const HydrusColumnListSectionFragmentDoc = gql`
    fragment HydrusColumnListSection on CosmosSectionHydrusColumnList {
  __typename
  id
  config {
    ...SectionConfig
  }
  columns(first: 4) {
    ...HydrusColumn
  }
}
    `;
export const CosmosAvatarFragmentDoc = gql`
    fragment CosmosAvatar on CosmosElementAvatar {
  href
  label
  imageSrc
  imageAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 100}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  color
}
    `;
export const DelphinusCardFragmentDoc = gql`
    fragment DelphinusCard on CosmosElementDelphinusCard {
  id
  preHeading
  icon
  iconGradient
  title
  titleHref
  desc
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  assetPosition
  badge {
    label
    href
  }
  avatar {
    ...CosmosAvatar
  }
}
    `;
export const DelphinusCardsGridSectionFragmentDoc = gql`
    fragment DelphinusCardsGridSection on CosmosSectionDelphinusCardsGrid {
  __typename
  id
  config {
    ...SectionConfig
  }
  grid(first: 9) {
    ...DelphinusCard
  }
}
    `;
export const IndustryFragmentDoc = gql`
    fragment Industry on CosmosElementIndustry {
  salesForceId
  dataRouterId
  label
}
    `;
export const IndustryListFragmentDoc = gql`
    fragment IndustryList on CosmosRefIndustryList {
  industries {
    ...Industry
  }
}
    `;
export const NewsletterSignupFragmentDoc = gql`
    fragment NewsletterSignup on CosmosSectionNewsletterSignup {
  id
  __typename
  signUpLabel
  successTitle
  successDescription
  industryPlaceholder
  industriesRef {
    ...IndustryList
  }
}
    `;
export const SimpleCtaSectionFragmentDoc = gql`
    fragment SimpleCtaSection on CosmosSectionSimpleCta {
  __typename
  id
  style
  simpleCtaVariant: variant
  gradient
  title {
    ...CosmosRichText
  }
  eyebrow
  desc
  buttons {
    ...CosmosIconButton
  }
}
    `;
export const SlimContactCardFragmentDoc = gql`
    fragment SlimContactCard on CosmosElementLicenseContactCard {
  slimContactCardDesc: description {
    ...CosmosRichText
  }
  buttons {
    ...CosmosIconButton
  }
}
    `;
export const SlimContactCardsSectionFragmentDoc = gql`
    fragment SlimContactCardsSection on CosmosSectionSlimContactCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards(first: 20) {
    ...SlimContactCard
  }
  forceShowPaddingTop
  forceShowPaddingBottom
}
    `;
export const SpeakerCardFragmentDoc = gql`
    fragment SpeakerCard on CosmosElementSpeakerCard {
  id
  icon
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  title
  company
  desc
}
    `;
export const SpeakerCardsSectionFragmentDoc = gql`
    fragment SpeakerCardsSection on CosmosSectionSpeakerCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  speakers(first: 20) {
    ...SpeakerCard
  }
}
    `;
export const LatestNewsSectionFragmentDoc = gql`
    fragment LatestNewsSection on CosmosSectionLatestNews {
  __typename
  id
  config {
    ...SectionConfig
  }
  wfRefBlogTags {
    ...BlogTag
  }
  preserveStickySort
  cosmosPageBlogDetails {
    slug
  }
  latestNewsVariant: variant
  featuredLabel
  feedBrand
  disableCategoryPills
}
    `;
export const NumberCalloutFragmentDoc = gql`
    fragment NumberCallout on CosmosElementNumberCallout {
  number
  numberDisplay
  label
}
    `;
export const NumberCalloutSectionFragmentDoc = gql`
    fragment NumberCalloutSection on CosmosSectionNumberCallout {
  __typename
  id
  config {
    ...SectionConfig
  }
  icon
  iconGradient
  eyebrow
  title {
    ...CosmosRichText
  }
  titleGradient
  desc
  numberCalloutVariant: variant
  callouts {
    ...NumberCallout
  }
  timeAndDate
  buttons {
    ...CosmosIconButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  flip
  verticallyCenter
}
    `;
export const TabbedFullWidthAssetItemFragmentDoc = gql`
    fragment TabbedFullWidthAssetItem on CosmosElementTabbedFullWidthAssetItem {
  tabLabel
  eyebrow
  title {
    html
    text
  }
  gradient
  desc
  buttons {
    ...CosmosIconButton
  }
  heroAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1920}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    `;
export const TabbedFullWidthAssetSectionFragmentDoc = gql`
    fragment TabbedFullWidthAssetSection on CosmosSectionTabbedFullWidthAsset {
  __typename
  id
  tabs {
    ...TabbedFullWidthAssetItem
  }
}
    `;
export const TabbedBlogCardsItemFragmentDoc = gql`
    fragment TabbedBlogCardsItem on CosmosElementTabbedBlogCardsItem {
  __typename
  id
  tabLabel
  title {
    ...CosmosRichText
  }
  description
  buttons {
    ...CosmosButton
  }
  backgroundAsset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  cards {
    ...BlogCard
  }
  featuredCards {
    ...BlogCard
  }
  cardGridFitToWidth
}
    `;
export const TabbedBlogCardsSectionFragmentDoc = gql`
    fragment TabbedBlogCardsSection on CosmosSectionTabbedBlogCard {
  __typename
  id
  tabs {
    ...TabbedBlogCardsItem
  }
}
    `;
export const TabbedContentImageItemFragmentDoc = gql`
    fragment TabbedContentImageItem on CosmosElementTabbedContentImageItem {
  __typename
  id
  tabLabel
  gradient
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  blurredImage {
    ...CosmosImage
    optUrl: url(
      transformation: {image: {resize: {width: 256}, quality: {value: 50}}, document: {output: {format: autoImage}}}
    )
  }
  flip
}
    `;
export const TabbedContentImageSectionFragmentDoc = gql`
    fragment TabbedContentImageSection on CosmosSectionTabbedContentImage {
  __typename
  id
  config {
    ...SectionConfig
  }
  tabs {
    ...TabbedContentImageItem
  }
}
    `;
export const FaqTabElementFragmentDoc = gql`
    fragment FAQTabElement on CosmosElementFaqTab {
  id
  title
  items(first: 25) {
    ...FAQItemElement
  }
  refFaqItems(first: 25) {
    ...RefFAQItemElement
  }
  firstItemDefaultOpen
  anchorLinkId
}
    `;
export const FaqSearchSectionFragmentDoc = gql`
    fragment FAQSearchSection on CosmosSectionFaqSearch {
  __typename
  id
  config {
    ...SectionConfig
  }
  title {
    ...CosmosRichText
  }
  desc
  faqTabs(first: 25) {
    ...FAQTabElement
  }
  modButtons {
    ...CosmosModButton
  }
  faqButtonsPosition
}
    `;
export const CkRichTextSectionFragmentDoc = gql`
    fragment CkRichTextSection on CosmosSectionCkRichText {
  __typename
  id
  config {
    ...SectionConfig
  }
  ckContent: content
  wide
  centered
  centeredButton
  buttons {
    ...CosmosButton
  }
}
    `;
export const AriesCardFragmentDoc = gql`
    fragment AriesCard on CosmosElementAriesCard {
  id
  icon
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1680}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  icon
  fullWidth
}
    `;
export const AriesCardsSectionFragmentDoc = gql`
    fragment AriesCardsSection on CosmosSectionAriesCards {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...AriesCard
  }
}
    `;
export const ContentSliderAssetFragmentDoc = gql`
    fragment ContentSliderAsset on CosmosSectionContentSliderAsset {
  __typename
  id
  config {
    ...SectionConfig
  }
  eyebrow
  badges {
    ...CosmosTag
  }
  gradient
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosButton
  }
  assets(first: 10) {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 900}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  flip
  verticallyCenter
}
    `;
export const CosmosQuoteFragmentDoc = gql`
    fragment CosmosQuote on CosmosElementQuote {
  __typename
  quote
  source
  description
  iconGradient
}
    `;
export const QuoteSectionFragmentDoc = gql`
    fragment QuoteSection on CosmosSectionQuote {
  __typename
  id
  config {
    ...SectionConfig
  }
  quotes(first: 20) {
    ...CosmosQuote
  }
}
    `;
export const UtCardFragmentDoc = gql`
    fragment UtCard on CosmosElementUtCard {
  cardImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {height: 600}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  logoImage {
    ...CosmosAsset
  }
  href
  label
}
    `;
export const UtCardSectionFragmentDoc = gql`
    fragment UtCardSection on CosmosSectionUtCard {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards {
    ...UtCard
  }
}
    `;
export const ResellerCardFragmentDoc = gql`
    fragment ResellerCard on CosmosElementResellerCard {
  __typename
  id
  name
  website
  email
  street
  postalCode
  city
  region
  phone
  continents
  location {
    latitude
    longitude
  }
}
    `;
export const ResellersSearchSectionFragmentDoc = gql`
    fragment ResellersSearchSection on CosmosSectionResellersSearch {
  __typename
  id
  config {
    ...SectionConfig
  }
  cards(first: 100) {
    ...ResellerCard
  }
  cards2(first: 50) {
    ...ResellerCard
  }
  cards3(first: 50) {
    ...ResellerCard
  }
  cards4(first: 50) {
    ...ResellerCard
  }
  viewLocationLabel
  searchLabel
  noResultsLabel
  locationLinkTemplate
  blurredBackgroundImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1680}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    `;
export const CosmosPluginDownloadDetailFragmentDoc = gql`
    fragment CosmosPluginDownloadDetail on CosmosElementPluginDownloadDetail {
  operatingSystem
  downloadUrl
  dateLastUpdated
  infoContent
  releaseNotesUrl
  tpsNoticesUrl
  sizeInBytes
}
    `;
export const PluginListItemFragmentDoc = gql`
    fragment PluginListItem on CosmosElementPluginListItem {
  id
  title
  desc
  learnMoreUrl
  compatibilityTags
  downloads {
    ...CosmosPluginDownloadDetail
  }
  extraButtons {
    ...CosmosIconButton
  }
}
    `;
export const PluginListTableSectionFragmentDoc = gql`
    fragment PluginListTableSection on CosmosSectionPluginListTable {
  id
  __typename
  config {
    ...SectionConfig
  }
  tableItems: items {
    ...PluginListItem
  }
}
    `;
export const DevelopersListSectionFragmentDoc = gql`
    fragment DevelopersListSection on CosmosSectionDevelopersList {
  __typename
  id
  config {
    ...SectionConfig
  }
  developersTsv {
    url
    mimeType
  }
  itemsPerPage
  tableHeading
}
    `;
export const PageSectionsFragmentDoc = gql`
    fragment PageSections on CosmosReferenceSectionsectionUnion {
  ... on CosmosSectionAsset {
    ...AssetSection
  }
  ... on CosmosSectionAssetCarousel {
    ...AssetCarouselSection
  }
  ... on CosmosSectionAssetGallery {
    ...AssetGallerySection
  }
  ... on CosmosSectionBlogCard {
    ...BlogCardsSection
  }
  ... on CosmosSectionBlobTable {
    ...BlobTableSection
  }
  ... on CosmosSectionCommunity {
    ...CommunitySection
  }
  ... on CosmosSectionComplexCtaCard {
    ...ComplexCtaCardsSection
  }
  ... on CosmosSectionContentLargeImage {
    ...ContentLargeImage
  }
  ... on CosmosSectionCrux {
    ...CruxSection
  }
  ... on CosmosSectionDivider {
    ...DividerSection
  }
  ... on CosmosSectionDownloadable {
    ...DownloadableSection
  }
  ... on CosmosSectionDownloadCard {
    ...DownloadCardsSection
  }
  ... on CosmosSectionEmbed {
    ...EmbedSection
  }
  ... on CosmosSectionEventsTable {
    ...EventsTableSection
  }
  ... on CosmosSectionFaq {
    ...FAQSection
  }
  ... on CosmosSectionFeatureCard {
    ...FeatureCardsSection
  }
  ... on CosmosSectionGameDevFeatureCard {
    ...FeaturePanelsSection
  }
  ... on CosmosSectionAccordionFeatureCard {
    ...AccordionFeatureCardsSection
  }
  ... on CosmosSectionAccordionTierCards {
    ...AccordionTierCardsSection
  }
  ... on CosmosSectionLearn {
    ...LearnSection
  }
  ... on CosmosSectionLogoList {
    ...LogoListSection
  }
  ... on CosmosSectionLogoMultiCard {
    ...LogoMultiCardsSection
  }
  ... on CosmosSectionNewsCard {
    ...NewsCardsSection
  }
  ... on CosmosSectionNewsMediaCard {
    ...NewsMediaCardsSection
  }
  ... on CosmosSectionLicensesCollapsed {
    ...LicensesCollapsedSection
  }
  ... on CosmosSectionRichText {
    ...RichTextSection
  }
  ... on CosmosSectionGeminiCard {
    ...GeminiCardsSection
  }
  ... on CosmosSectionHydrusColumnList {
    ...HydrusColumnListSection
  }
  ... on CosmosSectionDelphinusCardsGrid {
    ...DelphinusCardsGridSection
  }
  ... on CosmosSectionNewsletterSignup {
    ...NewsletterSignup
  }
  ... on CosmosSectionSimpleCta {
    ...SimpleCtaSection
  }
  ... on CosmosSectionSlimContactCard {
    ...SlimContactCardsSection
  }
  ... on CosmosSectionSpeakerCard {
    ...SpeakerCardsSection
  }
  ... on CosmosSectionLatestNews {
    ...LatestNewsSection
  }
  ... on CosmosSectionNumberCallout {
    ...NumberCalloutSection
  }
  ... on CosmosSectionTabbedFullWidthAsset {
    ...TabbedFullWidthAssetSection
  }
  ... on CosmosSectionTabbedBlogCard {
    ...TabbedBlogCardsSection
  }
  ... on CosmosSectionTabbedContentImage {
    ...TabbedContentImageSection
  }
  ... on CosmosSectionFaqSearch {
    ...FAQSearchSection
  }
  ... on CosmosSectionCkRichText {
    ...CkRichTextSection
  }
  ... on CosmosSectionAriesCards {
    ...AriesCardsSection
  }
  ... on CosmosSectionContentSliderAsset {
    ...ContentSliderAsset
  }
  ... on CosmosSectionQuote {
    ...QuoteSection
  }
  ... on CosmosSectionUtCard {
    ...UtCardSection
  }
  ... on CosmosSectionResellersSearch {
    ...ResellersSearchSection
  }
  ... on CosmosSectionPluginListTable {
    ...PluginListTableSection
  }
  ... on CosmosSectionDevelopersList {
    ...DevelopersListSection
  }
}
    `;
export const RefSectionsFragmentDoc = gql`
    fragment RefSections on CosmosReferenceSection {
  section {
    ...PageSections
  }
}
    `;
export const CosmosPageAgreementFragmentDoc = gql`
    fragment CosmosPageAgreement on CosmosPageAgreement {
  ...CosmosPageAgreementCore
  hero {
    ...PageHeroes
  }
  refSections(first: 30) {
    ...RefSections
  }
  agreementDetails {
    ...AgreementDetails
  }
}
    `;
export const BlogAuthorTagFragmentDoc = gql`
    fragment BlogAuthorTag on CosmosElementImageTag {
  image {
    url(transformation: {image: {resize: {width: 20}, quality: {value: 90}}})
    altText
  }
  href
  label
}
    `;
export const BlogConfigFragmentDoc = gql`
    fragment BlogConfig on CosmosConfigBlog {
  sticky
  blogLandingCard {
    ...BlogCard
  }
  publicationDate
  authorTag {
    ...BlogAuthorTag
  }
  tags(first: 30) {
    ...BlogTag
  }
  categories(first: 30) {
    ...BlogCategory
  }
}
    `;
export const CosmosGitHubGistFragmentDoc = gql`
    fragment CosmosGitHubGist on CosmosElementGithubGist {
  __typename
  username
  gistId
  file
}
    `;
export const CosmosEdsIconLinkFragmentDoc = gql`
    fragment CosmosEdsIconLink on CosmosElementEdsIconLink {
  ariaLabel
  href
  icon
}
    `;
export const CosmosIconLinkGroupFragmentDoc = gql`
    fragment CosmosIconLinkGroup on CosmosElementIconLinkGroup {
  __typename
  id
  description
  edsIconLinks {
    ...CosmosEdsIconLink
  }
}
    `;
export const CosmosInterviewFragmentDoc = gql`
    fragment CosmosInterview on CosmosElementInterview {
  __typename
  interviewee
  questions(first: 25) {
    question
    answer
  }
}
    `;
export const CosmosCompareFragmentDoc = gql`
    fragment CosmosCompare on CosmosElementCompare {
  leftImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  rightImage {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 1400}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
  caption
  attribution
}
    `;
export const CosmosUserProfileFragmentDoc = gql`
    fragment CosmosUserProfile on CosmosElementUserProfile {
  avatar {
    ...CosmosAvatar
    imageAsset {
      ...CosmosAsset
      optUrlMd: url(
        transformation: {image: {resize: {width: 350}, quality: {value: 90}}, document: {output: {format: autoImage}}}
      )
    }
  }
  variant
  logoImage {
    ...CosmosAsset
  }
  titleText: title
  desc
  button {
    ...CosmosIconButton
  }
}
    `;
export const CosmosCalloutCardFragmentDoc = gql`
    fragment CosmosCalloutCard on CosmosElementCalloutCard {
  __typename
  icon
  title {
    ...CosmosRichText
  }
  desc
  buttons {
    ...CosmosIconButton
  }
}
    `;
export const CosmosTitleAndDescFragmentDoc = gql`
    fragment CosmosTitleAndDesc on CosmosElementTitleAndDesc {
  __typename
  title {
    ...CosmosRichText
  }
  desc
}
    `;
export const ArticleComponentsFragmentDoc = gql`
    fragment ArticleComponents on CosmosPageBlogDetailarticleComponentsUnion {
  ... on CosmosElementAsset {
    __typename
    articleComponentAsset: asset {
      ...CosmosAsset
      optUrl: url(
        transformation: {image: {resize: {width: 1200}, quality: {value: 90}}, document: {output: {format: autoImage}}}
      )
    }
    caption
  }
  ... on CosmosElementButtonList {
    __typename
    buttons {
      ...CosmosButton
    }
  }
  ... on CosmosElementCkEditorText {
    __typename
    ckText
  }
  ... on CosmosElementGithubGist {
    ...CosmosGitHubGist
  }
  ... on CosmosElementIconLinkGroup {
    ...CosmosIconLinkGroup
  }
  ... on CosmosElementInterview {
    ...CosmosInterview
  }
  ... on CosmosElementRichText {
    __typename
    text {
      ...CosmosRichText
    }
  }
  ... on CosmosElementLicenseContactCard {
    ...SlimContactCard
  }
  ... on CosmosElementSectionHeading {
    ...SectionHeading
  }
  ... on CosmosElementVideoEmbed {
    ...CosmosVideoEmbed
  }
  ... on CosmosSectionAssetCarousel {
    ...AssetCarouselSection
  }
  ... on CosmosSectionAssetGallery {
    ...AssetGallerySection
  }
  ... on CosmosSectionContentLargeImage {
    ...ContentLargeImage
  }
  ... on CosmosSectionLogoList {
    ...LogoListSection
  }
  ... on CosmosSectionLogoMultiCard {
    ...LogoMultiCardsSection
  }
  ... on CosmosSectionNewsMediaCard {
    ...NewsMediaCardsSection
  }
  ... on CosmosElementCompare {
    __typename
    ...CosmosCompare
  }
  ... on CosmosElementUserProfile {
    __typename
    ...CosmosUserProfile
  }
  ... on CosmosSectionDivider {
    ...DividerSection
  }
  ... on CosmosElementQuote {
    ...CosmosQuote
  }
  ... on CosmosElementCalloutCard {
    ...CosmosCalloutCard
  }
  ... on CosmosElementTitleAndDesc {
    ...CosmosTitleAndDesc
  }
  ... on CosmosSectionSimpleCta {
    ...SimpleCtaSection
  }
}
    `;
export const PageBlogDetailEntitiesFragmentDoc = gql`
    fragment PageBlogDetailEntities on CosmosPageBlogDetail {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  blogConfig {
    ...BlogConfig
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
}
    `;
export const PageBlogDetailFragmentDoc = gql`
    fragment PageBlogDetail on CosmosPageBlogDetail {
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  blogConfig {
    ...BlogConfig
  }
  hero {
    ...PageHeroes
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSections
  }
}
    `;
export const PageBlogDetailMetadataFragmentDoc = gql`
    fragment PageBlogDetailMetadata on CosmosPageBlogDetail {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const PageEulaKeyFragmentDoc = gql`
    fragment PageEulaKey on CosmosPageEulaKey {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  banner
  bannerCountryCodes
  disclaimer
  title
  subtitle
  eulaKey
}
    `;
export const PageEulaKeyMetadataFragmentDoc = gql`
    fragment PageEulaKeyMetadata on CosmosPageEulaKey {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const PageFeedFragmentDoc = gql`
    fragment PageFeed on CosmosPageFeed {
  id
  createdAt
  updatedAt
  slug
  tags {
    ...BlogTag
  }
  categories {
    ...BlogCategory
  }
  searchPlaceholder
  clearFiltersButtonLabel
  featuredLabel
  loadingLabel
  noResultsLabel
  noResultsDescription
}
    `;
export const PageFeedMetadataFragmentDoc = gql`
    fragment PageFeedMetadata on CosmosPageFeed {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const CosmosEntityFragmentDoc = gql`
    fragment CosmosEntity on Entity {
  id
  stage
  __typename
}
    `;
export const PageHeroAndSectionsEntitiesFragmentDoc = gql`
    fragment PageHeroAndSectionsEntities on CosmosPageHeroAndSection {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
}
    `;
export const PageHeroAndSectionsFragmentDoc = gql`
    fragment PageHeroAndSections on CosmosPageHeroAndSection {
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ...PageHeroes
  }
  refSections(first: 30) {
    ...RefSections
  }
}
    `;
export const PageHeroAndSectionsMetadataFragmentDoc = gql`
    fragment PageHeroAndSectionsMetadata on CosmosPageHeroAndSection {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const PageLegalContentEntitiesFragmentDoc = gql`
    fragment PageLegalContentEntities on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  sections(first: 50) {
    ... on Entity {
      id
      stage
      __typename
    }
  }
}
    `;
export const CosmosElementCkEditorTextFragmentDoc = gql`
    fragment CosmosElementCkEditorText on CosmosElementCkEditorText {
  __typename
  ckText
}
    `;
export const CosmosElementCkEditorTextCollapsibleFragmentDoc = gql`
    fragment CosmosElementCkEditorTextCollapsible on CosmosElementCkEditorTextCollapsible {
  __typename
  ckText
  collapseButtonLabel
  defaultOpen
}
    `;
export const PageLegalContentSectionsFragmentDoc = gql`
    fragment PageLegalContentSections on CosmosPageLegalContentsectionsUnion {
  ... on CosmosElementCkEditorText {
    ...CosmosElementCkEditorText
  }
  ... on CosmosElementCkEditorTextCollapsible {
    ...CosmosElementCkEditorTextCollapsible
  }
}
    `;
export const PageLegalContentFragmentDoc = gql`
    fragment PageLegalContent on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  hero {
    ...PageHeroes
  }
  sections(first: 50) {
    ...PageLegalContentSections
  }
  banner
  bannerCountryCodes
}
    `;
export const PageLegalContentMetadataFragmentDoc = gql`
    fragment PageLegalContentMetadata on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const PageLegalContentSlugDataFragmentDoc = gql`
    fragment PageLegalContentSlugData on CosmosPageLegalContent {
  id
  createdAt
  updatedAt
  slug
  owner {
    ...WfRefApplicationOwner
  }
  locale
}
    `;
export const LicenseCardTopFragmentDoc = gql`
    fragment LicenseCardTop on CosmosElementLicenseCardTop {
  icon
  title
  description {
    ...CosmosRichText
  }
  example {
    ...CosmosRichText
  }
}
    `;
export const LicenseCardCoreFragmentDoc = gql`
    fragment LicenseCardCore on CosmosElementLicenseCardCore {
  title
  description {
    ...CosmosRichText
  }
  example {
    ...CosmosRichText
  }
  buttons(first: 2) {
    variant
    href
    name
    label
  }
  countryOverride {
    title
    description {
      ...CosmosRichText
    }
    example {
      ...CosmosRichText
    }
    buttons(first: 2) {
      variant
      href
      name
      label
    }
  }
  countriesToOverride
}
    `;
export const LicenseSeatFragmentDoc = gql`
    fragment LicenseSeat on CosmosElementLicenseSeat {
  title
  description {
    ...CosmosRichText
  }
  perSeatPerYear
  perYear
  taxes
  minusButtonLabel
  addButtonLabel
  buttons(first: 2) {
    ...CosmosIconButton
  }
  countryOverride {
    buttons(first: 2) {
      ...CosmosIconButton
    }
  }
  countriesToOverride
}
    `;
export const LicenseMainCardFragmentDoc = gql`
    fragment LicenseMainCard on CosmosElementLicenseMainCard {
  cardTop {
    ...LicenseCardTop
  }
  cardSections(first: 2) {
    ...LicenseCardCore
  }
  seats {
    ...LicenseSeat
  }
}
    `;
export const CosmosPageLicenseCoreFragmentDoc = gql`
    fragment CosmosPageLicenseCore on CosmosPageLicense {
  id
  createdAt
  updatedAt
  slug
  hero {
    ...HeroGlow
  }
  contentLargeImages {
    ...ContentLargeImage
  }
  title
  desc
  freeCardHeading
  freeCard {
    ...LicenseTopCard
  }
  cardHeading
  showExampleLabel
  hideExampleLabel
  mainCards(first: 2) {
    ...LicenseMainCard
  }
  contactCard {
    ...SlimContactCard
  }
  contactCard2 {
    ...SlimContactCard
  }
}
    `;
export const CosmosPageLicenseEntitiesFragmentDoc = gql`
    fragment CosmosPageLicenseEntities on CosmosPageLicense {
  ...CosmosPageLicenseCore
  refSections(first: 12) {
    ...RefSectionsEntities
  }
}
    `;
export const CosmosPageLicenseFragmentDoc = gql`
    fragment CosmosPageLicense on CosmosPageLicense {
  ...CosmosPageLicenseCore
  refSections(first: 12) {
    ...RefSections
  }
}
    `;
export const CosmosPageLicenseMetadataFragmentDoc = gql`
    fragment CosmosPageLicenseMetadata on CosmosPageLicense {
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
  id
}
    `;
export const CosmosPluginDownloadFragmentDoc = gql`
    fragment CosmosPluginDownload on CosmosElementPluginDownload {
  title
  desc
  details {
    ...CosmosPluginDownloadDetail
  }
}
    `;
export const PagePluginDetailEntitiesFragmentDoc = gql`
    fragment PagePluginDetailEntities on CosmosPagePluginDetail {
  id
  createdAt
  updatedAt
  slug
  hero {
    ... on Entity {
      id
      stage
      __typename
    }
  }
  downloads {
    ...CosmosPluginDownload
  }
  archivedVersionsTitle
  latestCardSections {
    ...CosmosTitleAndDesc
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSectionsEntities
  }
}
    `;
export const PagePluginDetailFragmentDoc = gql`
    fragment PagePluginDetail on CosmosPagePluginDetail {
  createdAt
  updatedAt
  slug
  hero {
    ...PageHeroes
  }
  downloads {
    ...CosmosPluginDownload
  }
  archivedVersionsTitle
  latestCardSections {
    ...CosmosTitleAndDesc
  }
  articleComponents(first: 100) {
    ...ArticleComponents
  }
  refSections(first: 30) {
    ...RefSections
  }
}
    `;
export const PagePluginDetailMetadataFragmentDoc = gql`
    fragment PagePluginDetailMetadata on CosmosPagePluginDetail {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const CosmosRedirectPageFragmentDoc = gql`
    fragment CosmosRedirectPage on CosmosPageRedirect {
  __typename
  id
  slug
  owner {
    ...WfRefApplicationOwner
  }
  prefixWithLocaleMatcher
  destination
  permanent
}
    `;
export const ResearchCardFragmentDoc = gql`
    fragment ResearchCard on CosmosElementResearchCard {
  href
  publicationDate
  title {
    ...CosmosRichText
  }
  desc
  footer
  asset {
    ...CosmosAsset
    optUrl: url(
      transformation: {image: {resize: {width: 660}, quality: {value: 90}}, document: {output: {format: autoImage}}}
    )
  }
}
    `;
export const PageResearchFragmentDoc = gql`
    fragment PageResearch on CosmosPageResearch {
  createdAt
  updatedAt
  slug
  hero {
    ...PageHeroes
  }
  researchCards {
    ...ResearchCard
  }
  researchCardsSectionConfig {
    ...SectionConfig
  }
}
    `;
export const PageResearchMetadataFragmentDoc = gql`
    fragment PageResearchMetadata on CosmosPageResearch {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
}
    `;
export const SearchFilterFragmentDoc = gql`
    fragment SearchFilter on CosmosElementSearchFilter {
  id
  label
  value
}
    `;
export const PageSearchFragmentDoc = gql`
    fragment PageSearch on CosmosPageSearch {
  id
  createdAt
  updatedAt
  slug
  title
  desc
  searchPlaceholder
  clearSearchLabel
  defaultSearchFilter
  searchFilters(first: 10) {
    ...SearchFilter
  }
  loadingLabel
  noResultsLabel
  suggestedLinksLabel
  suggestedLinks(first: 4) {
    ...GeminiCard
  }
}
    `;
export const PageSearchMetadataFragmentDoc = gql`
    fragment PageSearchMetadata on CosmosPageSearch {
  id
  createdAt
  updatedAt
  slug
  metaTags {
    ...CosmosSeo
  }
  defaultSearchFilter
  searchFilters(first: 10) {
    ...SearchFilter
  }
}
    `;
export const PageSearchFiltersFragmentDoc = gql`
    fragment PageSearchFilters on CosmosPageSearch {
  id
  slug
  defaultSearchFilter
  searchFilters(first: 10) {
    ...SearchFilter
  }
}
    `;
export const CreateWfRefBlogTagDocument = gql`
    mutation CreateWfRefBlogTag($tagId: String!, $label: String!) {
  createWfRefBlogTag(data: {tagId: $tagId, label: $label}) {
    id
  }
}
    `;
export const UpdateLocalizationWfRefBlogTagDocument = gql`
    mutation UpdateLocalizationWfRefBlogTag($locale: Locale!, $tagId: String!, $label: String!) {
  updateWfRefBlogTag(
    data: {localizations: {create: {data: {label: $label}, locale: $locale}}}
    where: {tagId: $tagId}
  ) {
    id
  }
}
    `;
export const UpdateWfRefBlogTagIdDocument = gql`
    mutation UpdateWfRefBlogTagId($newTagId: String!, $existingTagId: String!) {
  updateWfRefBlogTag(data: {tagId: $newTagId}, where: {tagId: $existingTagId}) {
    id
    tagId
  }
}
    `;
export const QueryLearnSearchDocument = gql`
    query QueryLearnSearch($id: ID!, $categoryType: String!, $industry: String!, $applicationFamily: String!) {
  values: remoteLearn(where: {id: $id}) {
    learnSearch(
      industries: $industry
      types: $categoryType
      applicationFamily: $applicationFamily
    )
  }
}
    `;
export const CosmosPageAgreementEntitiesDocument = gql`
    query CosmosPageAgreementEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageAgreement(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageAgreementEntities
  }
}
    ${CosmosPageAgreementEntitiesFragmentDoc}
${CosmosPageAgreementCoreFragmentDoc}
${RefSectionsEntitiesFragmentDoc}
${AgreementDetailsFragmentDoc}`;
export const CosmosPageAgreementDocument = gql`
    query CosmosPageAgreement($locale: [Locale!]!, $slug: String!) {
  cosmosPageAgreement(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageAgreement
  }
}
    ${CosmosPageAgreementFragmentDoc}
${CosmosPageAgreementCoreFragmentDoc}
${PageHeroesFragmentDoc}
${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosRichTextFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}
${RefSectionsFragmentDoc}
${PageSectionsFragmentDoc}
${AssetSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${IconSectionHeadingFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${AssetGallerySectionFragmentDoc}
${BlogCardsSectionFragmentDoc}
${BlogCardFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}
${BlobTableSectionFragmentDoc}
${CommunitySectionFragmentDoc}
${CommunityResourceFragmentFragmentDoc}
${CommunityCardFragmentFragmentDoc}
${CosmosLinkFragmentDoc}
${ComplexCtaCardsSectionFragmentDoc}
${ComplexCtaCardFragmentDoc}
${ContentLargeImageFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${CruxSectionFragmentDoc}
${CruxLinkFragmentDoc}
${DividerSectionFragmentDoc}
${DownloadableSectionFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}
${DownloadCardCtaFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}
${EmbedSectionFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${EventsTableSectionFragmentDoc}
${EventsTableRowFragmentDoc}
${FaqSectionFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}
${FeatureCardsSectionFragmentDoc}
${FeatureCardFragmentDoc}
${FeaturePanelsSectionFragmentDoc}
${FeaturePanelFragmentDoc}
${LinkListItemFragmentDoc}
${AccordionFeatureCardsSectionFragmentDoc}
${AccordionFeatureCardFragmentDoc}
${AccordionTierCardsSectionFragmentDoc}
${AccordionTierCardFragmentDoc}
${AccordionTierFeatureCardFragmentDoc}
${AccordionTierCtaCardFragmentDoc}
${LearnSectionFragmentDoc}
${ElementLearnCategoryFragmentDoc}
${CosmosElementLearnDocumentationCardFragmentDoc}
${CosmosElementLearnImageCardFragmentDoc}
${CosmosElementLearnImageCardSourceFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${LogoMultiCardFragmentDoc}
${NewsCardsSectionFragmentDoc}
${NewsCardFragmentDoc}
${NewsAuthorTagFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${NewsMediaCardFragmentDoc}
${LicensesCollapsedSectionFragmentDoc}
${LicenseTopCardFragmentDoc}
${CheckListItemFragmentDoc}
${LicenseCollapsedCardFragmentDoc}
${RichTextSectionFragmentDoc}
${GeminiCardsSectionFragmentDoc}
${GeminiCardFragmentDoc}
${GeminiLinkFragmentDoc}
${HydrusColumnListSectionFragmentDoc}
${HydrusColumnFragmentDoc}
${HydrusLinkFragmentDoc}
${DelphinusCardsGridSectionFragmentDoc}
${DelphinusCardFragmentDoc}
${CosmosAvatarFragmentDoc}
${NewsletterSignupFragmentDoc}
${IndustryListFragmentDoc}
${IndustryFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${SlimContactCardsSectionFragmentDoc}
${SlimContactCardFragmentDoc}
${SpeakerCardsSectionFragmentDoc}
${SpeakerCardFragmentDoc}
${LatestNewsSectionFragmentDoc}
${NumberCalloutSectionFragmentDoc}
${NumberCalloutFragmentDoc}
${TabbedFullWidthAssetSectionFragmentDoc}
${TabbedFullWidthAssetItemFragmentDoc}
${TabbedBlogCardsSectionFragmentDoc}
${TabbedBlogCardsItemFragmentDoc}
${TabbedContentImageSectionFragmentDoc}
${TabbedContentImageItemFragmentDoc}
${FaqSearchSectionFragmentDoc}
${FaqTabElementFragmentDoc}
${CkRichTextSectionFragmentDoc}
${AriesCardsSectionFragmentDoc}
${AriesCardFragmentDoc}
${ContentSliderAssetFragmentDoc}
${QuoteSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${UtCardSectionFragmentDoc}
${UtCardFragmentDoc}
${ResellersSearchSectionFragmentDoc}
${ResellerCardFragmentDoc}
${PluginListTableSectionFragmentDoc}
${PluginListItemFragmentDoc}
${CosmosPluginDownloadDetailFragmentDoc}
${DevelopersListSectionFragmentDoc}
${AgreementDetailsFragmentDoc}`;
export const CosmosPageAgreementDetailsDocument = gql`
    query CosmosPageAgreementDetails($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosElementAgreementDetail {
      ...AgreementDetails
    }
  }
}
    ${AgreementDetailsFragmentDoc}`;
export const CosmosPageAgreementMetadataDocument = gql`
    query CosmosPageAgreementMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageAgreement(locales: $locale, where: {slug: $slug}) {
    ...PageAgreementMetadata
  }
}
    ${PageAgreementMetadataFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageBlogDetailEntitiesDocument = gql`
    query CosmosPageBlogDetailEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageBlogDetail(locales: $locale, where: {slug: $slug}) {
    ...PageBlogDetailEntities
  }
}
    ${PageBlogDetailEntitiesFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${BlogConfigFragmentDoc}
${BlogCardFragmentDoc}
${CosmosAssetFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}
${BlogAuthorTagFragmentDoc}
${ArticleComponentsFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosGitHubGistFragmentDoc}
${CosmosIconLinkGroupFragmentDoc}
${CosmosEdsIconLinkFragmentDoc}
${CosmosInterviewFragmentDoc}
${SlimContactCardFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${IconSectionHeadingFragmentDoc}
${AssetGallerySectionFragmentDoc}
${ContentLargeImageFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${CosmosLinkFragmentDoc}
${LogoMultiCardFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${NewsMediaCardFragmentDoc}
${CosmosCompareFragmentDoc}
${CosmosUserProfileFragmentDoc}
${CosmosAvatarFragmentDoc}
${DividerSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${CosmosCalloutCardFragmentDoc}
${CosmosTitleAndDescFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const CosmosPageBlogDetailSectionsDocument = gql`
    query CosmosPageBlogDetailSections($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageSections
  }
}
    ${PageSectionsFragmentDoc}
${AssetSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${AssetGallerySectionFragmentDoc}
${BlogCardsSectionFragmentDoc}
${BlogCardFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}
${BlobTableSectionFragmentDoc}
${CommunitySectionFragmentDoc}
${CommunityResourceFragmentFragmentDoc}
${CommunityCardFragmentFragmentDoc}
${CosmosLinkFragmentDoc}
${ComplexCtaCardsSectionFragmentDoc}
${ComplexCtaCardFragmentDoc}
${ContentLargeImageFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${CruxSectionFragmentDoc}
${CruxLinkFragmentDoc}
${DividerSectionFragmentDoc}
${DownloadableSectionFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}
${DownloadCardCtaFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}
${EmbedSectionFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${EventsTableSectionFragmentDoc}
${EventsTableRowFragmentDoc}
${FaqSectionFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}
${FeatureCardsSectionFragmentDoc}
${FeatureCardFragmentDoc}
${FeaturePanelsSectionFragmentDoc}
${FeaturePanelFragmentDoc}
${LinkListItemFragmentDoc}
${AccordionFeatureCardsSectionFragmentDoc}
${AccordionFeatureCardFragmentDoc}
${AccordionTierCardsSectionFragmentDoc}
${AccordionTierCardFragmentDoc}
${AccordionTierFeatureCardFragmentDoc}
${AccordionTierCtaCardFragmentDoc}
${LearnSectionFragmentDoc}
${ElementLearnCategoryFragmentDoc}
${CosmosElementLearnDocumentationCardFragmentDoc}
${CosmosElementLearnImageCardFragmentDoc}
${CosmosElementLearnImageCardSourceFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${LogoMultiCardFragmentDoc}
${NewsCardsSectionFragmentDoc}
${NewsCardFragmentDoc}
${NewsAuthorTagFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${NewsMediaCardFragmentDoc}
${LicensesCollapsedSectionFragmentDoc}
${LicenseTopCardFragmentDoc}
${CheckListItemFragmentDoc}
${LicenseCollapsedCardFragmentDoc}
${RichTextSectionFragmentDoc}
${GeminiCardsSectionFragmentDoc}
${GeminiCardFragmentDoc}
${GeminiLinkFragmentDoc}
${HydrusColumnListSectionFragmentDoc}
${HydrusColumnFragmentDoc}
${HydrusLinkFragmentDoc}
${DelphinusCardsGridSectionFragmentDoc}
${DelphinusCardFragmentDoc}
${CosmosAvatarFragmentDoc}
${NewsletterSignupFragmentDoc}
${IndustryListFragmentDoc}
${IndustryFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${SlimContactCardsSectionFragmentDoc}
${SlimContactCardFragmentDoc}
${SpeakerCardsSectionFragmentDoc}
${SpeakerCardFragmentDoc}
${LatestNewsSectionFragmentDoc}
${NumberCalloutSectionFragmentDoc}
${NumberCalloutFragmentDoc}
${TabbedFullWidthAssetSectionFragmentDoc}
${TabbedFullWidthAssetItemFragmentDoc}
${TabbedBlogCardsSectionFragmentDoc}
${TabbedBlogCardsItemFragmentDoc}
${TabbedContentImageSectionFragmentDoc}
${TabbedContentImageItemFragmentDoc}
${FaqSearchSectionFragmentDoc}
${FaqTabElementFragmentDoc}
${CkRichTextSectionFragmentDoc}
${AriesCardsSectionFragmentDoc}
${AriesCardFragmentDoc}
${ContentSliderAssetFragmentDoc}
${QuoteSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${UtCardSectionFragmentDoc}
${UtCardFragmentDoc}
${ResellersSearchSectionFragmentDoc}
${ResellerCardFragmentDoc}
${PluginListTableSectionFragmentDoc}
${PluginListItemFragmentDoc}
${CosmosPluginDownloadDetailFragmentDoc}
${DevelopersListSectionFragmentDoc}`;
export const CosmosPageBlogDetailHeroDocument = gql`
    query CosmosPageBlogDetailHero($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageHeroes
  }
}
    ${PageHeroesFragmentDoc}
${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosRichTextFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}`;
export const CosmosPageBlogDetailMetadataDocument = gql`
    query CosmosPageBlogDetailMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageBlogDetail(locales: $locale, where: {slug: $slug}) {
    ...PageBlogDetailMetadata
  }
}
    ${PageBlogDetailMetadataFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageLegalContentMetadataDocument = gql`
    query CosmosPageLegalContentMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    ...PageLegalContentMetadata
  }
}
    ${PageLegalContentMetadataFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageLegalContentDocument = gql`
    query CosmosPageLegalContent($locale: [Locale!]!, $slug: String!) {
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    ...PageLegalContent
  }
}
    ${PageLegalContentFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${PageHeroesFragmentDoc}
${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosRichTextFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}
${PageLegalContentSectionsFragmentDoc}
${CosmosElementCkEditorTextFragmentDoc}
${CosmosElementCkEditorTextCollapsibleFragmentDoc}`;
export const CosmosPageLegalContentSlugSingleDocument = gql`
    query CosmosPageLegalContentSlugSingle($locale: [Locale!]!, $slug: String!) {
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    ...PageLegalContentSlugData
  }
}
    ${PageLegalContentSlugDataFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}`;
export const CosmosPageDirectoryMetadataDocument = gql`
    query CosmosPageDirectoryMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageDirectory(locales: $locale, where: {slug: $slug}) {
    ...PageDirectoryMetadata
  }
}
    ${PageDirectoryMetadataFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageDirectoryEntitiesDocument = gql`
    query CosmosPageDirectoryEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageDirectory(locales: $locale, where: {slug: $slug}) {
    ...PageDirectoryEntities
  }
}
    ${PageDirectoryEntitiesFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const CosmosPageEulaKeyDocument = gql`
    query CosmosPageEulaKey($locale: [Locale!]!, $slug: String!) {
  cosmosPageEulaKey(locales: $locale, where: {slug: $slug}) {
    ...PageEulaKey
  }
}
    ${PageEulaKeyFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}`;
export const CosmosPageEulaKeyMetadataDocument = gql`
    query CosmosPageEulaKeyMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageEulaKey(locales: $locale, where: {slug: $slug}) {
    ...PageEulaKeyMetadata
  }
}
    ${PageEulaKeyMetadataFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageFeedEntitiesDocument = gql`
    query CosmosPageFeedEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageFeed(locales: $locale, where: {slug: $slug}) {
    ...PageFeed
  }
  wfRefBlogCategories(locales: $locale) {
    ...BlogCategory
  }
}
    ${PageFeedFragmentDoc}
${BlogTagFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const CosmosPageFeedMetadataDocument = gql`
    query CosmosPageFeedMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageFeed(locales: $locale, where: {slug: $slug}) {
    ...PageFeedMetadata
  }
}
    ${PageFeedMetadataFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageHeroAndSectionMetadataDocument = gql`
    query CosmosPageHeroAndSectionMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageHeroAndSection(locales: $locale, where: {slug: $slug}) {
    ...PageHeroAndSectionsMetadata
  }
}
    ${PageHeroAndSectionsMetadataFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageHeroAndSectionEntitiesDocument = gql`
    query CosmosPageHeroAndSectionEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageHeroAndSection(locales: $locale, where: {slug: $slug}) {
    ...PageHeroAndSectionsEntities
  }
}
    ${PageHeroAndSectionsEntitiesFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const CosmosPageHeroDocument = gql`
    query CosmosPageHero($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageHeroes
  }
}
    ${PageHeroesFragmentDoc}
${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosRichTextFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}`;
export const CosmosPageHeroAlphaDocument = gql`
    query CosmosPageHeroAlpha($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroAlpha {
      ...HeroAlpha
    }
  }
}
    ${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const CosmosPageHeroGlowDocument = gql`
    query CosmosPageHeroGlow($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroGlow {
      ...HeroGlow
    }
  }
}
    ${HeroGlowFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosRichTextFragmentDoc}`;
export const CosmosPageHeroArticleImageDocument = gql`
    query CosmosPageHeroArticleImage($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroArticleImage {
      ...HeroArticleImage
    }
  }
}
    ${HeroArticleImageFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageHeroBravoDocument = gql`
    query CosmosPageHeroBravo($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosHeroBravo {
      ...HeroBravo
    }
  }
}
    ${HeroBravoFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageLicenseEntitiesDocument = gql`
    query CosmosPageLicenseEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPageLicense(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageLicenseEntities
  }
}
    ${CosmosPageLicenseEntitiesFragmentDoc}
${CosmosPageLicenseCoreFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosRichTextFragmentDoc}
${ContentLargeImageFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${LicenseTopCardFragmentDoc}
${CheckListItemFragmentDoc}
${LicenseMainCardFragmentDoc}
${LicenseCardTopFragmentDoc}
${LicenseCardCoreFragmentDoc}
${LicenseSeatFragmentDoc}
${SlimContactCardFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const CosmosPageLicenseMetadataDocument = gql`
    query CosmosPageLicenseMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageLicense(locales: $locale, where: {slug: $slug}) {
    ...CosmosPageLicenseMetadata
  }
}
    ${CosmosPageLicenseMetadataFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPagePluginDetailEntitiesDocument = gql`
    query CosmosPagePluginDetailEntities($locale: [Locale!]!, $slug: String!) {
  cosmosPagePluginDetail(locales: $locale, where: {slug: $slug}) {
    ...PagePluginDetailEntities
  }
}
    ${PagePluginDetailEntitiesFragmentDoc}
${CosmosPluginDownloadFragmentDoc}
${CosmosPluginDownloadDetailFragmentDoc}
${CosmosTitleAndDescFragmentDoc}
${CosmosRichTextFragmentDoc}
${ArticleComponentsFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosGitHubGistFragmentDoc}
${CosmosIconLinkGroupFragmentDoc}
${CosmosEdsIconLinkFragmentDoc}
${CosmosInterviewFragmentDoc}
${SlimContactCardFragmentDoc}
${CosmosIconButtonFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${IconSectionHeadingFragmentDoc}
${AssetGallerySectionFragmentDoc}
${ContentLargeImageFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${CosmosLinkFragmentDoc}
${LogoMultiCardFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${NewsMediaCardFragmentDoc}
${CosmosCompareFragmentDoc}
${CosmosUserProfileFragmentDoc}
${CosmosAvatarFragmentDoc}
${DividerSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${CosmosCalloutCardFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${RefSectionsEntitiesFragmentDoc}`;
export const CosmosPagePluginDetailSectionsDocument = gql`
    query CosmosPagePluginDetailSections($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageSections
  }
}
    ${PageSectionsFragmentDoc}
${AssetSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${AssetGallerySectionFragmentDoc}
${BlogCardsSectionFragmentDoc}
${BlogCardFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}
${BlobTableSectionFragmentDoc}
${CommunitySectionFragmentDoc}
${CommunityResourceFragmentFragmentDoc}
${CommunityCardFragmentFragmentDoc}
${CosmosLinkFragmentDoc}
${ComplexCtaCardsSectionFragmentDoc}
${ComplexCtaCardFragmentDoc}
${ContentLargeImageFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${CruxSectionFragmentDoc}
${CruxLinkFragmentDoc}
${DividerSectionFragmentDoc}
${DownloadableSectionFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}
${DownloadCardCtaFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}
${EmbedSectionFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${EventsTableSectionFragmentDoc}
${EventsTableRowFragmentDoc}
${FaqSectionFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}
${FeatureCardsSectionFragmentDoc}
${FeatureCardFragmentDoc}
${FeaturePanelsSectionFragmentDoc}
${FeaturePanelFragmentDoc}
${LinkListItemFragmentDoc}
${AccordionFeatureCardsSectionFragmentDoc}
${AccordionFeatureCardFragmentDoc}
${AccordionTierCardsSectionFragmentDoc}
${AccordionTierCardFragmentDoc}
${AccordionTierFeatureCardFragmentDoc}
${AccordionTierCtaCardFragmentDoc}
${LearnSectionFragmentDoc}
${ElementLearnCategoryFragmentDoc}
${CosmosElementLearnDocumentationCardFragmentDoc}
${CosmosElementLearnImageCardFragmentDoc}
${CosmosElementLearnImageCardSourceFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${LogoMultiCardFragmentDoc}
${NewsCardsSectionFragmentDoc}
${NewsCardFragmentDoc}
${NewsAuthorTagFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${NewsMediaCardFragmentDoc}
${LicensesCollapsedSectionFragmentDoc}
${LicenseTopCardFragmentDoc}
${CheckListItemFragmentDoc}
${LicenseCollapsedCardFragmentDoc}
${RichTextSectionFragmentDoc}
${GeminiCardsSectionFragmentDoc}
${GeminiCardFragmentDoc}
${GeminiLinkFragmentDoc}
${HydrusColumnListSectionFragmentDoc}
${HydrusColumnFragmentDoc}
${HydrusLinkFragmentDoc}
${DelphinusCardsGridSectionFragmentDoc}
${DelphinusCardFragmentDoc}
${CosmosAvatarFragmentDoc}
${NewsletterSignupFragmentDoc}
${IndustryListFragmentDoc}
${IndustryFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${SlimContactCardsSectionFragmentDoc}
${SlimContactCardFragmentDoc}
${SpeakerCardsSectionFragmentDoc}
${SpeakerCardFragmentDoc}
${LatestNewsSectionFragmentDoc}
${NumberCalloutSectionFragmentDoc}
${NumberCalloutFragmentDoc}
${TabbedFullWidthAssetSectionFragmentDoc}
${TabbedFullWidthAssetItemFragmentDoc}
${TabbedBlogCardsSectionFragmentDoc}
${TabbedBlogCardsItemFragmentDoc}
${TabbedContentImageSectionFragmentDoc}
${TabbedContentImageItemFragmentDoc}
${FaqSearchSectionFragmentDoc}
${FaqTabElementFragmentDoc}
${CkRichTextSectionFragmentDoc}
${AriesCardsSectionFragmentDoc}
${AriesCardFragmentDoc}
${ContentSliderAssetFragmentDoc}
${QuoteSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${UtCardSectionFragmentDoc}
${UtCardFragmentDoc}
${ResellersSearchSectionFragmentDoc}
${ResellerCardFragmentDoc}
${PluginListTableSectionFragmentDoc}
${PluginListItemFragmentDoc}
${CosmosPluginDownloadDetailFragmentDoc}
${DevelopersListSectionFragmentDoc}`;
export const CosmosPagePluginDetailHeroDocument = gql`
    query CosmosPagePluginDetailHero($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageHeroes
  }
}
    ${PageHeroesFragmentDoc}
${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosRichTextFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}`;
export const CosmosPagePluginDetailMetadataDocument = gql`
    query CosmosPagePluginDetailMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPagePluginDetail(locales: $locale, where: {slug: $slug}) {
    ...PagePluginDetailMetadata
  }
}
    ${PagePluginDetailMetadataFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageRedirectDocument = gql`
    query CosmosPageRedirect($slug: String!) {
  cosmosPageRedirect(where: {slug: $slug}) {
    ...CosmosRedirectPage
  }
}
    ${CosmosRedirectPageFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}`;
export const CosmosPageRedirectsDocument = gql`
    query CosmosPageRedirects {
  cosmosPageRedirects(first: 1000) {
    ...CosmosRedirectPage
  }
}
    ${CosmosRedirectPageFragmentDoc}
${WfRefApplicationOwnerFragmentDoc}`;
export const CosmosPageResearchMetadataDocument = gql`
    query CosmosPageResearchMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageResearch(locales: $locale, where: {slug: $slug}) {
    ...PageResearchMetadata
  }
}
    ${PageResearchMetadataFragmentDoc}
${CosmosSeoFragmentDoc}`;
export const CosmosPageResearchDocument = gql`
    query CosmosPageResearch($locale: [Locale!]!, $slug: String!) {
  cosmosPageResearch(locales: $locale, where: {slug: $slug}) {
    ...PageResearch
  }
}
    ${PageResearchFragmentDoc}
${PageHeroesFragmentDoc}
${HeroAlphaFragmentDoc}
${CosmosAssetFragmentDoc}
${HeroAlphaMainStackFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${HeroGlowFragmentDoc}
${CosmosRichTextFragmentDoc}
${HeroArticleImageFragmentDoc}
${HeroBravoFragmentDoc}
${ResearchCardFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${IconSectionHeadingFragmentDoc}`;
export const CosmosPageSearchFiltersDocument = gql`
    query CosmosPageSearchFilters($locale: [Locale!]!, $slug: String!) {
  cosmosPageSearch(locales: $locale, where: {slug: $slug}) {
    ...PageSearchFilters
  }
}
    ${PageSearchFiltersFragmentDoc}
${SearchFilterFragmentDoc}`;
export const CosmosPageSearchMetadataDocument = gql`
    query CosmosPageSearchMetadata($locale: [Locale!]!, $slug: String!) {
  cosmosPageSearch(locales: $locale, where: {slug: $slug}) {
    ...PageSearchMetadata
  }
}
    ${PageSearchMetadataFragmentDoc}
${CosmosSeoFragmentDoc}
${SearchFilterFragmentDoc}`;
export const CosmosPageSearchDocument = gql`
    query CosmosPageSearch($locale: [Locale!]!, $slug: String!) {
  cosmosPageSearch(locales: $locale, where: {slug: $slug}) {
    ...PageSearch
  }
}
    ${PageSearchFragmentDoc}
${SearchFilterFragmentDoc}
${GeminiCardFragmentDoc}
${CosmosRichTextFragmentDoc}
${GeminiLinkFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionsDocument = gql`
    query CosmosPageSections($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ...PageSections
  }
}
    ${PageSectionsFragmentDoc}
${AssetSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${AssetCarouselSectionFragmentDoc}
${AssetGallerySectionFragmentDoc}
${BlogCardsSectionFragmentDoc}
${BlogCardFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}
${BlobTableSectionFragmentDoc}
${CommunitySectionFragmentDoc}
${CommunityResourceFragmentFragmentDoc}
${CommunityCardFragmentFragmentDoc}
${CosmosLinkFragmentDoc}
${ComplexCtaCardsSectionFragmentDoc}
${ComplexCtaCardFragmentDoc}
${ContentLargeImageFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}
${CruxSectionFragmentDoc}
${CruxLinkFragmentDoc}
${DividerSectionFragmentDoc}
${DownloadableSectionFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}
${DownloadCardCtaFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}
${EmbedSectionFragmentDoc}
${CosmosVideoEmbedFragmentDoc}
${EventsTableSectionFragmentDoc}
${EventsTableRowFragmentDoc}
${FaqSectionFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}
${FeatureCardsSectionFragmentDoc}
${FeatureCardFragmentDoc}
${FeaturePanelsSectionFragmentDoc}
${FeaturePanelFragmentDoc}
${LinkListItemFragmentDoc}
${AccordionFeatureCardsSectionFragmentDoc}
${AccordionFeatureCardFragmentDoc}
${AccordionTierCardsSectionFragmentDoc}
${AccordionTierCardFragmentDoc}
${AccordionTierFeatureCardFragmentDoc}
${AccordionTierCtaCardFragmentDoc}
${LearnSectionFragmentDoc}
${ElementLearnCategoryFragmentDoc}
${CosmosElementLearnDocumentationCardFragmentDoc}
${CosmosElementLearnImageCardFragmentDoc}
${CosmosElementLearnImageCardSourceFragmentDoc}
${LogoListSectionFragmentDoc}
${LogoFragmentDoc}
${LogoMultiCardsSectionFragmentDoc}
${LogoMultiCardFragmentDoc}
${NewsCardsSectionFragmentDoc}
${NewsCardFragmentDoc}
${NewsAuthorTagFragmentDoc}
${NewsMediaCardsSectionFragmentDoc}
${NewsMediaCardFragmentDoc}
${LicensesCollapsedSectionFragmentDoc}
${LicenseTopCardFragmentDoc}
${CheckListItemFragmentDoc}
${LicenseCollapsedCardFragmentDoc}
${RichTextSectionFragmentDoc}
${GeminiCardsSectionFragmentDoc}
${GeminiCardFragmentDoc}
${GeminiLinkFragmentDoc}
${HydrusColumnListSectionFragmentDoc}
${HydrusColumnFragmentDoc}
${HydrusLinkFragmentDoc}
${DelphinusCardsGridSectionFragmentDoc}
${DelphinusCardFragmentDoc}
${CosmosAvatarFragmentDoc}
${NewsletterSignupFragmentDoc}
${IndustryListFragmentDoc}
${IndustryFragmentDoc}
${SimpleCtaSectionFragmentDoc}
${SlimContactCardsSectionFragmentDoc}
${SlimContactCardFragmentDoc}
${SpeakerCardsSectionFragmentDoc}
${SpeakerCardFragmentDoc}
${LatestNewsSectionFragmentDoc}
${NumberCalloutSectionFragmentDoc}
${NumberCalloutFragmentDoc}
${TabbedFullWidthAssetSectionFragmentDoc}
${TabbedFullWidthAssetItemFragmentDoc}
${TabbedBlogCardsSectionFragmentDoc}
${TabbedBlogCardsItemFragmentDoc}
${TabbedContentImageSectionFragmentDoc}
${TabbedContentImageItemFragmentDoc}
${FaqSearchSectionFragmentDoc}
${FaqTabElementFragmentDoc}
${CkRichTextSectionFragmentDoc}
${AriesCardsSectionFragmentDoc}
${AriesCardFragmentDoc}
${ContentSliderAssetFragmentDoc}
${QuoteSectionFragmentDoc}
${CosmosQuoteFragmentDoc}
${UtCardSectionFragmentDoc}
${UtCardFragmentDoc}
${ResellersSearchSectionFragmentDoc}
${ResellerCardFragmentDoc}
${PluginListTableSectionFragmentDoc}
${PluginListItemFragmentDoc}
${CosmosPluginDownloadDetailFragmentDoc}
${DevelopersListSectionFragmentDoc}`;
export const CosmosPageSectionAssetDocument = gql`
    query CosmosPageSectionAsset($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionAsset {
      ...AssetSection
    }
  }
}
    ${AssetSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionAssetCarouselDocument = gql`
    query CosmosPageSectionAssetCarousel($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionAssetCarousel {
      ...AssetCarouselSection
    }
  }
}
    ${AssetCarouselSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionAssetGalleryDocument = gql`
    query CosmosPageSectionAssetGallery($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionAssetGallery {
      ...AssetGallerySection
    }
  }
}
    ${AssetGallerySectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionBlogCardDocument = gql`
    query CosmosPageSectionBlogCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionBlogCard {
      ...BlogCardsSection
    }
  }
}
    ${BlogCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${BlogCardFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}`;
export const CosmosPageSectionBlobTableDocument = gql`
    query CosmosPageSectionBlobTable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionBlobTable {
      ...BlobTableSection
    }
  }
}
    ${BlobTableSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionCommunityDocument = gql`
    query CosmosPageSectionCommunity($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionCommunity {
      ...CommunitySection
    }
  }
}
    ${CommunitySectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CommunityResourceFragmentFragmentDoc}
${CommunityCardFragmentFragmentDoc}
${CosmosLinkFragmentDoc}`;
export const CosmosPageSectionComplexCtaCardDocument = gql`
    query CosmosPageSectionComplexCtaCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionComplexCtaCard {
      ...ComplexCtaCardsSection
    }
  }
}
    ${ComplexCtaCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${ComplexCtaCardFragmentDoc}`;
export const CosmosPageSectionContentLargeImageDocument = gql`
    query CosmosPageSectionContentLargeImage($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionContentLargeImage {
      ...ContentLargeImage
    }
  }
}
    ${ContentLargeImageFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosTagFragmentDoc}
${CosmosImageFragmentDoc}`;
export const CosmosPageSectionCruxDocument = gql`
    query CosmosPageSectionCrux($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionCrux {
      ...CruxSection
    }
  }
}
    ${CruxSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CruxLinkFragmentDoc}`;
export const CosmosPageSectionDividerDocument = gql`
    query CosmosPageSectionDivider($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionDivider {
      ...DividerSection
    }
  }
}
    ${DividerSectionFragmentDoc}`;
export const CosmosPageSectionDownloadableDocument = gql`
    query CosmosPageSectionDownloadable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionDownloadable {
      ...DownloadableSection
    }
  }
}
    ${DownloadableSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${DownloadCardsSectionFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}
${DownloadCardCtaFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}`;
export const CosmosPageSectionDownloadCardDocument = gql`
    query CosmosPageSectionDownloadCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionDownloadCard {
      ...DownloadCardsSection
    }
  }
}
    ${DownloadCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${DownloadStepFragmentDoc}
${DownloadCardFragmentDoc}
${DownloadCardCtaFragmentDoc}
${CosmosDownloadButtonFragmentDoc}
${CosmosCtaRichTextFragmentDoc}
${DownloadCardCtaLinkFragmentDoc}`;
export const CosmosPageSectionEmbedDocument = gql`
    query CosmosPageSectionEmbed($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionEmbed {
      ...EmbedSection
    }
  }
}
    ${EmbedSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosVideoEmbedFragmentDoc}`;
export const CosmosPageSectionEventsTableDocument = gql`
    query CosmosPageSectionEventsTable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionEventsTable {
      ...EventsTableSection
    }
  }
}
    ${EventsTableSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosImageFragmentDoc}
${EventsTableRowFragmentDoc}`;
export const CosmosPageSectionFeatureCardDocument = gql`
    query CosmosPageSectionFeatureCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionFeatureCard {
      ...FeatureCardsSection
    }
  }
}
    ${FeatureCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosTagFragmentDoc}
${FeatureCardFragmentDoc}`;
export const CosmosPageSectionFaqDocument = gql`
    query CosmosPageSectionFaq($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionFaq {
      ...FAQSection
    }
  }
}
    ${FaqSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}`;
export const CosmosPageSectionGameDevFeatureCardDocument = gql`
    query CosmosPageSectionGameDevFeatureCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionGameDevFeatureCard {
      ...FeaturePanelsSection
    }
  }
}
    ${FeaturePanelsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${FeaturePanelFragmentDoc}
${CosmosTagFragmentDoc}
${LinkListItemFragmentDoc}`;
export const CosmosPageSectionAccordionFeatureCardDocument = gql`
    query CosmosPageSectionAccordionFeatureCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionAccordionFeatureCard {
      ...AccordionFeatureCardsSection
    }
  }
}
    ${AccordionFeatureCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${AccordionFeatureCardFragmentDoc}
${FeaturePanelFragmentDoc}
${CosmosTagFragmentDoc}
${LinkListItemFragmentDoc}`;
export const CosmosPageSectionAccordionTierCardsDocument = gql`
    query CosmosPageSectionAccordionTierCards($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionAccordionTierCards {
      ...AccordionTierCardsSection
    }
  }
}
    ${AccordionTierCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${AccordionTierCardFragmentDoc}
${AccordionTierFeatureCardFragmentDoc}
${AccordionTierCtaCardFragmentDoc}`;
export const CosmosPageSectionLearnDocument = gql`
    query CosmosPageSectionLearn($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionLearn {
      ...LearnSection
    }
  }
}
    ${LearnSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${ElementLearnCategoryFragmentDoc}
${CosmosElementLearnDocumentationCardFragmentDoc}
${CosmosLinkFragmentDoc}
${CosmosElementLearnImageCardFragmentDoc}
${CosmosElementLearnImageCardSourceFragmentDoc}
${CosmosImageFragmentDoc}`;
export const CosmosPageSectionLogoListDocument = gql`
    query CosmosPageSectionLogoList($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionLogoList {
      ...LogoListSection
    }
  }
}
    ${LogoListSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${LogoFragmentDoc}
${CosmosImageFragmentDoc}`;
export const CosmosPageSectionLogoMultiCardDocument = gql`
    query CosmosPageSectionLogoMultiCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionLogoMultiCard {
      ...LogoMultiCardsSection
    }
  }
}
    ${LogoMultiCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosLinkFragmentDoc}
${LogoMultiCardFragmentDoc}`;
export const CosmosPageSectionNewsCardDocument = gql`
    query CosmosPageSectionNewsCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionNewsCard {
      ...NewsCardsSection
    }
  }
}
    ${NewsCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${NewsCardFragmentDoc}
${CosmosTagFragmentDoc}
${NewsAuthorTagFragmentDoc}`;
export const CosmosPageSectionNewsMediaCardDocument = gql`
    query CosmosPageSectionNewsMediaCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionNewsMediaCard {
      ...NewsMediaCardsSection
    }
  }
}
    ${NewsMediaCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${NewsMediaCardFragmentDoc}`;
export const CosmosPageSectionLicensesCollapsedDocument = gql`
    query CosmosPageSectionLicensesCollapsed($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionLicensesCollapsed {
      ...LicensesCollapsedSection
    }
  }
}
    ${LicensesCollapsedSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${LicenseTopCardFragmentDoc}
${CheckListItemFragmentDoc}
${LicenseCollapsedCardFragmentDoc}
${CosmosLinkFragmentDoc}`;
export const CosmosPageSectionRichTextDocument = gql`
    query CosmosPageSectionRichText($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionRichText {
      ...RichTextSection
    }
  }
}
    ${RichTextSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionGeminiCardDocument = gql`
    query CosmosPageSectionGeminiCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionGeminiCard {
      ...GeminiCardsSection
    }
  }
}
    ${GeminiCardsSectionFragmentDoc}
${CosmosAssetFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${GeminiCardFragmentDoc}
${GeminiLinkFragmentDoc}`;
export const CosmosPageSectionHydrusColumnListDocument = gql`
    query CosmosPageSectionHydrusColumnList($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionHydrusColumnList {
      ...HydrusColumnListSection
    }
  }
}
    ${HydrusColumnListSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${HydrusColumnFragmentDoc}
${HydrusLinkFragmentDoc}`;
export const CosmosPageSectionDelphinusCardsGridDocument = gql`
    query CosmosPageSectionDelphinusCardsGrid($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionDelphinusCardsGrid {
      ...DelphinusCardsGridSection
    }
  }
}
    ${DelphinusCardsGridSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${DelphinusCardFragmentDoc}
${CosmosAvatarFragmentDoc}`;
export const CosmosPageSectionNewsletterSignupDocument = gql`
    query CosmosPageSectionNewsletterSignup($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionNewsletterSignup {
      ...NewsletterSignup
    }
  }
}
    ${NewsletterSignupFragmentDoc}
${IndustryListFragmentDoc}
${IndustryFragmentDoc}`;
export const CosmosPageSectionSimpleCtaDocument = gql`
    query CosmosPageSectionSimpleCta($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionSimpleCta {
      ...SimpleCtaSection
    }
  }
}
    ${SimpleCtaSectionFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const CosmosPageSectionSlimContactCardDocument = gql`
    query CosmosPageSectionSlimContactCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionSlimContactCard {
      ...SlimContactCardsSection
    }
  }
}
    ${SlimContactCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${SlimContactCardFragmentDoc}`;
export const CosmosPageSectionSpeakerCardDocument = gql`
    query CosmosPageSectionSpeakerCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionSpeakerCard {
      ...SpeakerCardsSection
    }
  }
}
    ${SpeakerCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${SpeakerCardFragmentDoc}`;
export const CosmosPageSectionLatestNewsDocument = gql`
    query CosmosPageSectionLatestNews($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionLatestNews {
      ...LatestNewsSection
    }
  }
}
    ${LatestNewsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${BlogTagFragmentDoc}`;
export const CosmosPageSectionNumberCalloutDocument = gql`
    query CosmosPageSectionNumberCallout($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionNumberCallout {
      ...NumberCalloutSection
    }
  }
}
    ${NumberCalloutSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${NumberCalloutFragmentDoc}`;
export const CosmosPageSectionTabbedFullWidthAssetDocument = gql`
    query CosmosPageSectionTabbedFullWidthAsset($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionTabbedFullWidthAsset {
      ...TabbedFullWidthAssetSection
    }
  }
}
    ${TabbedFullWidthAssetSectionFragmentDoc}
${TabbedFullWidthAssetItemFragmentDoc}
${CosmosIconButtonFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionTabbedBlogCardDocument = gql`
    query CosmosPageSectionTabbedBlogCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionTabbedBlogCard {
      ...TabbedBlogCardsSection
    }
  }
}
    ${TabbedBlogCardsSectionFragmentDoc}
${TabbedBlogCardsItemFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosAssetFragmentDoc}
${BlogCardFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogTagFragmentDoc}
${CosmosIconButtonFragmentDoc}`;
export const CosmosPageSectionTabbedContentImageDocument = gql`
    query CosmosPageSectionTabbedContentImage($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionTabbedContentImage {
      ...TabbedContentImageSection
    }
  }
}
    ${TabbedContentImageSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${TabbedContentImageItemFragmentDoc}
${CosmosImageFragmentDoc}`;
export const CosmosPageSectionFaqSearchDocument = gql`
    query CosmosPageSectionFaqSearch($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionFaqSearch {
      ...FAQSearchSection
    }
  }
}
    ${FaqSearchSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${FaqTabElementFragmentDoc}
${FaqItemElementFragmentDoc}
${RefFaqItemElementFragmentDoc}`;
export const CosmosPageSectionCkRichTextDocument = gql`
    query CosmosPageSectionCkRichText($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionCkRichText {
      ...CkRichTextSection
    }
  }
}
    ${CkRichTextSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageSectionAriesCardsDocument = gql`
    query CosmosPageSectionAriesCards($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionAriesCards {
      ...AriesCardsSection
    }
  }
}
    ${AriesCardsSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${AriesCardFragmentDoc}`;
export const CosmosPageSectionContentSliderAssetDocument = gql`
    query CosmosPageSectionContentSliderAsset($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionContentSliderAsset {
      ...ContentSliderAsset
    }
  }
}
    ${ContentSliderAssetFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosTagFragmentDoc}`;
export const CosmosPageSectionQuoteDocument = gql`
    query CosmosPageSectionQuote($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionQuote {
      ...QuoteSection
    }
  }
}
    ${QuoteSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${CosmosQuoteFragmentDoc}`;
export const CosmosPageSectionUtCardDocument = gql`
    query CosmosPageSectionUtCard($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionUtCard {
      ...UtCardSection
    }
  }
}
    ${UtCardSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${UtCardFragmentDoc}`;
export const CosmosPageSectionResellersSearchDocument = gql`
    query CosmosPageSectionResellersSearch($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionResellersSearch {
      ...ResellersSearchSection
    }
  }
}
    ${ResellersSearchSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${ResellerCardFragmentDoc}`;
export const CosmosPageSectionPluginListTableDocument = gql`
    query CosmosPageSectionPluginListTable($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionPluginListTable {
      ...PluginListTableSection
    }
  }
}
    ${PluginListTableSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}
${PluginListItemFragmentDoc}
${CosmosPluginDownloadDetailFragmentDoc}`;
export const CosmosPageSectionDevelopersListDocument = gql`
    query CosmosPageSectionDevelopersList($entities: [EntityWhereInput!]!, $locale: [Locale!]) {
  entities(locales: $locale, where: $entities) {
    ... on CosmosSectionDevelopersList {
      ...DevelopersListSection
    }
  }
}
    ${DevelopersListSectionFragmentDoc}
${SectionConfigFragmentDoc}
${SectionConfigHeadingUnionFragmentDoc}
${SectionHeadingFragmentDoc}
${CosmosRichTextFragmentDoc}
${CosmosButtonFragmentDoc}
${CosmosModButtonFragmentDoc}
${CosmosIconButtonFragmentDoc}
${IconSectionHeadingFragmentDoc}
${CosmosAssetFragmentDoc}`;
export const CosmosPageTemplatesDocument = gql`
    query CosmosPageTemplates($locale: [Locale!]!, $slug: String!) {
  cosmosPageHeroAndSection(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageDirectory(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageBlogDetail(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageEulaKey(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageRedirect(where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageLegalContent(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageSearch(where: {slug: $slug}) {
    __typename
    id
    slug
  }
  cosmosPageResearch(locales: $locale, where: {slug: $slug}) {
    __typename
    id
    slug
  }
}
    `;
export const WfRefApplicationOwnersDocument = gql`
    query WfRefApplicationOwners {
  wfRefApplicationOwners {
    ...WfRefApplicationOwner
  }
}
    ${WfRefApplicationOwnerFragmentDoc}`;
export const WfRefTagsDocument = gql`
    query WfRefTags($first: Int, $skip: Int) {
  wfRefBlogTags(stage: DRAFT, first: $first, skip: $skip) {
    tagId
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CreateWfRefBlogTag(variables: CreateWfRefBlogTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateWfRefBlogTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWfRefBlogTagMutation>({ document: CreateWfRefBlogTagDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateWfRefBlogTag', 'mutation', variables);
    },
    UpdateLocalizationWfRefBlogTag(variables: UpdateLocalizationWfRefBlogTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateLocalizationWfRefBlogTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLocalizationWfRefBlogTagMutation>({ document: UpdateLocalizationWfRefBlogTagDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateLocalizationWfRefBlogTag', 'mutation', variables);
    },
    UpdateWfRefBlogTagId(variables: UpdateWfRefBlogTagIdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateWfRefBlogTagIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWfRefBlogTagIdMutation>({ document: UpdateWfRefBlogTagIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateWfRefBlogTagId', 'mutation', variables);
    },
    QueryLearnSearch(variables: QueryLearnSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryLearnSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryLearnSearchQuery>({ document: QueryLearnSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'QueryLearnSearch', 'query', variables);
    },
    CosmosPageAgreementEntities(variables: CosmosPageAgreementEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementEntitiesQuery>({ document: CosmosPageAgreementEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreementEntities', 'query', variables);
    },
    CosmosPageAgreement(variables: CosmosPageAgreementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementQuery>({ document: CosmosPageAgreementDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreement', 'query', variables);
    },
    CosmosPageAgreementDetails(variables: CosmosPageAgreementDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementDetailsQuery>({ document: CosmosPageAgreementDetailsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreementDetails', 'query', variables);
    },
    CosmosPageAgreementMetadata(variables: CosmosPageAgreementMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageAgreementMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageAgreementMetadataQuery>({ document: CosmosPageAgreementMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageAgreementMetadata', 'query', variables);
    },
    CosmosPageBlogDetailEntities(variables: CosmosPageBlogDetailEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailEntitiesQuery>({ document: CosmosPageBlogDetailEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailEntities', 'query', variables);
    },
    CosmosPageBlogDetailSections(variables: CosmosPageBlogDetailSectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailSectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailSectionsQuery>({ document: CosmosPageBlogDetailSectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailSections', 'query', variables);
    },
    CosmosPageBlogDetailHero(variables: CosmosPageBlogDetailHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailHeroQuery>({ document: CosmosPageBlogDetailHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailHero', 'query', variables);
    },
    CosmosPageBlogDetailMetadata(variables: CosmosPageBlogDetailMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageBlogDetailMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageBlogDetailMetadataQuery>({ document: CosmosPageBlogDetailMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageBlogDetailMetadata', 'query', variables);
    },
    CosmosPageLegalContentMetadata(variables: CosmosPageLegalContentMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLegalContentMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLegalContentMetadataQuery>({ document: CosmosPageLegalContentMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLegalContentMetadata', 'query', variables);
    },
    CosmosPageLegalContent(variables: CosmosPageLegalContentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLegalContentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLegalContentQuery>({ document: CosmosPageLegalContentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLegalContent', 'query', variables);
    },
    CosmosPageLegalContentSlugSingle(variables: CosmosPageLegalContentSlugSingleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLegalContentSlugSingleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLegalContentSlugSingleQuery>({ document: CosmosPageLegalContentSlugSingleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLegalContentSlugSingle', 'query', variables);
    },
    CosmosPageDirectoryMetadata(variables: CosmosPageDirectoryMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageDirectoryMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageDirectoryMetadataQuery>({ document: CosmosPageDirectoryMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageDirectoryMetadata', 'query', variables);
    },
    CosmosPageDirectoryEntities(variables: CosmosPageDirectoryEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageDirectoryEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageDirectoryEntitiesQuery>({ document: CosmosPageDirectoryEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageDirectoryEntities', 'query', variables);
    },
    CosmosPageEulaKey(variables: CosmosPageEulaKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageEulaKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageEulaKeyQuery>({ document: CosmosPageEulaKeyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageEulaKey', 'query', variables);
    },
    CosmosPageEulaKeyMetadata(variables: CosmosPageEulaKeyMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageEulaKeyMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageEulaKeyMetadataQuery>({ document: CosmosPageEulaKeyMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageEulaKeyMetadata', 'query', variables);
    },
    CosmosPageFeedEntities(variables: CosmosPageFeedEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageFeedEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageFeedEntitiesQuery>({ document: CosmosPageFeedEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageFeedEntities', 'query', variables);
    },
    CosmosPageFeedMetadata(variables: CosmosPageFeedMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageFeedMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageFeedMetadataQuery>({ document: CosmosPageFeedMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageFeedMetadata', 'query', variables);
    },
    CosmosPageHeroAndSectionMetadata(variables: CosmosPageHeroAndSectionMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroAndSectionMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroAndSectionMetadataQuery>({ document: CosmosPageHeroAndSectionMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroAndSectionMetadata', 'query', variables);
    },
    CosmosPageHeroAndSectionEntities(variables: CosmosPageHeroAndSectionEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroAndSectionEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroAndSectionEntitiesQuery>({ document: CosmosPageHeroAndSectionEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroAndSectionEntities', 'query', variables);
    },
    CosmosPageHero(variables: CosmosPageHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroQuery>({ document: CosmosPageHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHero', 'query', variables);
    },
    CosmosPageHeroAlpha(variables: CosmosPageHeroAlphaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroAlphaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroAlphaQuery>({ document: CosmosPageHeroAlphaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroAlpha', 'query', variables);
    },
    CosmosPageHeroGlow(variables: CosmosPageHeroGlowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroGlowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroGlowQuery>({ document: CosmosPageHeroGlowDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroGlow', 'query', variables);
    },
    CosmosPageHeroArticleImage(variables: CosmosPageHeroArticleImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroArticleImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroArticleImageQuery>({ document: CosmosPageHeroArticleImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroArticleImage', 'query', variables);
    },
    CosmosPageHeroBravo(variables: CosmosPageHeroBravoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageHeroBravoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageHeroBravoQuery>({ document: CosmosPageHeroBravoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageHeroBravo', 'query', variables);
    },
    CosmosPageLicenseEntities(variables: CosmosPageLicenseEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLicenseEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLicenseEntitiesQuery>({ document: CosmosPageLicenseEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLicenseEntities', 'query', variables);
    },
    CosmosPageLicenseMetadata(variables: CosmosPageLicenseMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageLicenseMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageLicenseMetadataQuery>({ document: CosmosPageLicenseMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageLicenseMetadata', 'query', variables);
    },
    CosmosPagePluginDetailEntities(variables: CosmosPagePluginDetailEntitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailEntitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailEntitiesQuery>({ document: CosmosPagePluginDetailEntitiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailEntities', 'query', variables);
    },
    CosmosPagePluginDetailSections(variables: CosmosPagePluginDetailSectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailSectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailSectionsQuery>({ document: CosmosPagePluginDetailSectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailSections', 'query', variables);
    },
    CosmosPagePluginDetailHero(variables: CosmosPagePluginDetailHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailHeroQuery>({ document: CosmosPagePluginDetailHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailHero', 'query', variables);
    },
    CosmosPagePluginDetailMetadata(variables: CosmosPagePluginDetailMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPagePluginDetailMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPagePluginDetailMetadataQuery>({ document: CosmosPagePluginDetailMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPagePluginDetailMetadata', 'query', variables);
    },
    CosmosPageRedirect(variables: CosmosPageRedirectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRedirectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRedirectQuery>({ document: CosmosPageRedirectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRedirect', 'query', variables);
    },
    CosmosPageRedirects(variables?: CosmosPageRedirectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageRedirectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageRedirectsQuery>({ document: CosmosPageRedirectsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageRedirects', 'query', variables);
    },
    CosmosPageResearchMetadata(variables: CosmosPageResearchMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageResearchMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageResearchMetadataQuery>({ document: CosmosPageResearchMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageResearchMetadata', 'query', variables);
    },
    CosmosPageResearch(variables: CosmosPageResearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageResearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageResearchQuery>({ document: CosmosPageResearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageResearch', 'query', variables);
    },
    CosmosPageSearchFilters(variables: CosmosPageSearchFiltersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSearchFiltersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSearchFiltersQuery>({ document: CosmosPageSearchFiltersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSearchFilters', 'query', variables);
    },
    CosmosPageSearchMetadata(variables: CosmosPageSearchMetadataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSearchMetadataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSearchMetadataQuery>({ document: CosmosPageSearchMetadataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSearchMetadata', 'query', variables);
    },
    CosmosPageSearch(variables: CosmosPageSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSearchQuery>({ document: CosmosPageSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSearch', 'query', variables);
    },
    CosmosPageSections(variables: CosmosPageSectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionsQuery>({ document: CosmosPageSectionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSections', 'query', variables);
    },
    CosmosPageSectionAsset(variables: CosmosPageSectionAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionAssetQuery>({ document: CosmosPageSectionAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionAsset', 'query', variables);
    },
    CosmosPageSectionAssetCarousel(variables: CosmosPageSectionAssetCarouselQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionAssetCarouselQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionAssetCarouselQuery>({ document: CosmosPageSectionAssetCarouselDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionAssetCarousel', 'query', variables);
    },
    CosmosPageSectionAssetGallery(variables: CosmosPageSectionAssetGalleryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionAssetGalleryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionAssetGalleryQuery>({ document: CosmosPageSectionAssetGalleryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionAssetGallery', 'query', variables);
    },
    CosmosPageSectionBlogCard(variables: CosmosPageSectionBlogCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionBlogCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionBlogCardQuery>({ document: CosmosPageSectionBlogCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionBlogCard', 'query', variables);
    },
    CosmosPageSectionBlobTable(variables: CosmosPageSectionBlobTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionBlobTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionBlobTableQuery>({ document: CosmosPageSectionBlobTableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionBlobTable', 'query', variables);
    },
    CosmosPageSectionCommunity(variables: CosmosPageSectionCommunityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionCommunityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionCommunityQuery>({ document: CosmosPageSectionCommunityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionCommunity', 'query', variables);
    },
    CosmosPageSectionComplexCtaCard(variables: CosmosPageSectionComplexCtaCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionComplexCtaCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionComplexCtaCardQuery>({ document: CosmosPageSectionComplexCtaCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionComplexCtaCard', 'query', variables);
    },
    CosmosPageSectionContentLargeImage(variables: CosmosPageSectionContentLargeImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionContentLargeImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionContentLargeImageQuery>({ document: CosmosPageSectionContentLargeImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionContentLargeImage', 'query', variables);
    },
    CosmosPageSectionCrux(variables: CosmosPageSectionCruxQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionCruxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionCruxQuery>({ document: CosmosPageSectionCruxDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionCrux', 'query', variables);
    },
    CosmosPageSectionDivider(variables: CosmosPageSectionDividerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionDividerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionDividerQuery>({ document: CosmosPageSectionDividerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionDivider', 'query', variables);
    },
    CosmosPageSectionDownloadable(variables: CosmosPageSectionDownloadableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionDownloadableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionDownloadableQuery>({ document: CosmosPageSectionDownloadableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionDownloadable', 'query', variables);
    },
    CosmosPageSectionDownloadCard(variables: CosmosPageSectionDownloadCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionDownloadCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionDownloadCardQuery>({ document: CosmosPageSectionDownloadCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionDownloadCard', 'query', variables);
    },
    CosmosPageSectionEmbed(variables: CosmosPageSectionEmbedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionEmbedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionEmbedQuery>({ document: CosmosPageSectionEmbedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionEmbed', 'query', variables);
    },
    CosmosPageSectionEventsTable(variables: CosmosPageSectionEventsTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionEventsTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionEventsTableQuery>({ document: CosmosPageSectionEventsTableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionEventsTable', 'query', variables);
    },
    CosmosPageSectionFeatureCard(variables: CosmosPageSectionFeatureCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionFeatureCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionFeatureCardQuery>({ document: CosmosPageSectionFeatureCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionFeatureCard', 'query', variables);
    },
    CosmosPageSectionFaq(variables: CosmosPageSectionFaqQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionFaqQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionFaqQuery>({ document: CosmosPageSectionFaqDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionFaq', 'query', variables);
    },
    CosmosPageSectionGameDevFeatureCard(variables: CosmosPageSectionGameDevFeatureCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionGameDevFeatureCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionGameDevFeatureCardQuery>({ document: CosmosPageSectionGameDevFeatureCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionGameDevFeatureCard', 'query', variables);
    },
    CosmosPageSectionAccordionFeatureCard(variables: CosmosPageSectionAccordionFeatureCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionAccordionFeatureCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionAccordionFeatureCardQuery>({ document: CosmosPageSectionAccordionFeatureCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionAccordionFeatureCard', 'query', variables);
    },
    CosmosPageSectionAccordionTierCards(variables: CosmosPageSectionAccordionTierCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionAccordionTierCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionAccordionTierCardsQuery>({ document: CosmosPageSectionAccordionTierCardsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionAccordionTierCards', 'query', variables);
    },
    CosmosPageSectionLearn(variables: CosmosPageSectionLearnQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionLearnQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionLearnQuery>({ document: CosmosPageSectionLearnDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionLearn', 'query', variables);
    },
    CosmosPageSectionLogoList(variables: CosmosPageSectionLogoListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionLogoListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionLogoListQuery>({ document: CosmosPageSectionLogoListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionLogoList', 'query', variables);
    },
    CosmosPageSectionLogoMultiCard(variables: CosmosPageSectionLogoMultiCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionLogoMultiCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionLogoMultiCardQuery>({ document: CosmosPageSectionLogoMultiCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionLogoMultiCard', 'query', variables);
    },
    CosmosPageSectionNewsCard(variables: CosmosPageSectionNewsCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionNewsCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionNewsCardQuery>({ document: CosmosPageSectionNewsCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionNewsCard', 'query', variables);
    },
    CosmosPageSectionNewsMediaCard(variables: CosmosPageSectionNewsMediaCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionNewsMediaCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionNewsMediaCardQuery>({ document: CosmosPageSectionNewsMediaCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionNewsMediaCard', 'query', variables);
    },
    CosmosPageSectionLicensesCollapsed(variables: CosmosPageSectionLicensesCollapsedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionLicensesCollapsedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionLicensesCollapsedQuery>({ document: CosmosPageSectionLicensesCollapsedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionLicensesCollapsed', 'query', variables);
    },
    CosmosPageSectionRichText(variables: CosmosPageSectionRichTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionRichTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionRichTextQuery>({ document: CosmosPageSectionRichTextDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionRichText', 'query', variables);
    },
    CosmosPageSectionGeminiCard(variables: CosmosPageSectionGeminiCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionGeminiCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionGeminiCardQuery>({ document: CosmosPageSectionGeminiCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionGeminiCard', 'query', variables);
    },
    CosmosPageSectionHydrusColumnList(variables: CosmosPageSectionHydrusColumnListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionHydrusColumnListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionHydrusColumnListQuery>({ document: CosmosPageSectionHydrusColumnListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionHydrusColumnList', 'query', variables);
    },
    CosmosPageSectionDelphinusCardsGrid(variables: CosmosPageSectionDelphinusCardsGridQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionDelphinusCardsGridQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionDelphinusCardsGridQuery>({ document: CosmosPageSectionDelphinusCardsGridDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionDelphinusCardsGrid', 'query', variables);
    },
    CosmosPageSectionNewsletterSignup(variables: CosmosPageSectionNewsletterSignupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionNewsletterSignupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionNewsletterSignupQuery>({ document: CosmosPageSectionNewsletterSignupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionNewsletterSignup', 'query', variables);
    },
    CosmosPageSectionSimpleCta(variables: CosmosPageSectionSimpleCtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionSimpleCtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionSimpleCtaQuery>({ document: CosmosPageSectionSimpleCtaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionSimpleCta', 'query', variables);
    },
    CosmosPageSectionSlimContactCard(variables: CosmosPageSectionSlimContactCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionSlimContactCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionSlimContactCardQuery>({ document: CosmosPageSectionSlimContactCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionSlimContactCard', 'query', variables);
    },
    CosmosPageSectionSpeakerCard(variables: CosmosPageSectionSpeakerCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionSpeakerCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionSpeakerCardQuery>({ document: CosmosPageSectionSpeakerCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionSpeakerCard', 'query', variables);
    },
    CosmosPageSectionLatestNews(variables: CosmosPageSectionLatestNewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionLatestNewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionLatestNewsQuery>({ document: CosmosPageSectionLatestNewsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionLatestNews', 'query', variables);
    },
    CosmosPageSectionNumberCallout(variables: CosmosPageSectionNumberCalloutQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionNumberCalloutQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionNumberCalloutQuery>({ document: CosmosPageSectionNumberCalloutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionNumberCallout', 'query', variables);
    },
    CosmosPageSectionTabbedFullWidthAsset(variables: CosmosPageSectionTabbedFullWidthAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionTabbedFullWidthAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionTabbedFullWidthAssetQuery>({ document: CosmosPageSectionTabbedFullWidthAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionTabbedFullWidthAsset', 'query', variables);
    },
    CosmosPageSectionTabbedBlogCard(variables: CosmosPageSectionTabbedBlogCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionTabbedBlogCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionTabbedBlogCardQuery>({ document: CosmosPageSectionTabbedBlogCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionTabbedBlogCard', 'query', variables);
    },
    CosmosPageSectionTabbedContentImage(variables: CosmosPageSectionTabbedContentImageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionTabbedContentImageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionTabbedContentImageQuery>({ document: CosmosPageSectionTabbedContentImageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionTabbedContentImage', 'query', variables);
    },
    CosmosPageSectionFaqSearch(variables: CosmosPageSectionFaqSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionFaqSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionFaqSearchQuery>({ document: CosmosPageSectionFaqSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionFaqSearch', 'query', variables);
    },
    CosmosPageSectionCkRichText(variables: CosmosPageSectionCkRichTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionCkRichTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionCkRichTextQuery>({ document: CosmosPageSectionCkRichTextDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionCkRichText', 'query', variables);
    },
    CosmosPageSectionAriesCards(variables: CosmosPageSectionAriesCardsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionAriesCardsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionAriesCardsQuery>({ document: CosmosPageSectionAriesCardsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionAriesCards', 'query', variables);
    },
    CosmosPageSectionContentSliderAsset(variables: CosmosPageSectionContentSliderAssetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionContentSliderAssetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionContentSliderAssetQuery>({ document: CosmosPageSectionContentSliderAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionContentSliderAsset', 'query', variables);
    },
    CosmosPageSectionQuote(variables: CosmosPageSectionQuoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionQuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionQuoteQuery>({ document: CosmosPageSectionQuoteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionQuote', 'query', variables);
    },
    CosmosPageSectionUtCard(variables: CosmosPageSectionUtCardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionUtCardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionUtCardQuery>({ document: CosmosPageSectionUtCardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionUtCard', 'query', variables);
    },
    CosmosPageSectionResellersSearch(variables: CosmosPageSectionResellersSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionResellersSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionResellersSearchQuery>({ document: CosmosPageSectionResellersSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionResellersSearch', 'query', variables);
    },
    CosmosPageSectionPluginListTable(variables: CosmosPageSectionPluginListTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionPluginListTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionPluginListTableQuery>({ document: CosmosPageSectionPluginListTableDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionPluginListTable', 'query', variables);
    },
    CosmosPageSectionDevelopersList(variables: CosmosPageSectionDevelopersListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageSectionDevelopersListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageSectionDevelopersListQuery>({ document: CosmosPageSectionDevelopersListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageSectionDevelopersList', 'query', variables);
    },
    CosmosPageTemplates(variables: CosmosPageTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CosmosPageTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CosmosPageTemplatesQuery>({ document: CosmosPageTemplatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CosmosPageTemplates', 'query', variables);
    },
    WfRefApplicationOwners(variables?: WfRefApplicationOwnersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WfRefApplicationOwnersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WfRefApplicationOwnersQuery>({ document: WfRefApplicationOwnersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'WfRefApplicationOwners', 'query', variables);
    },
    WfRefTags(variables?: WfRefTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WfRefTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WfRefTagsQuery>({ document: WfRefTagsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'WfRefTags', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CommunityCardParent": [
      "CommunityResource"
    ],
    "CommunityResourceParent": [
      "CosmosSectionCommunity"
    ],
    "CosmosConfigBlogParent": [
      "CosmosFeedBlogCard",
      "CosmosPageBlogDetail"
    ],
    "CosmosConfigSectionParent": [
      "CosmosPageResearch",
      "CosmosSectionAccordionFeatureCard",
      "CosmosSectionAccordionTierCards",
      "CosmosSectionAriesCards",
      "CosmosSectionAsset",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionBlobTable",
      "CosmosSectionBlogCard",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionComplexCtaCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionCrux",
      "CosmosSectionDelphinusCardsGrid",
      "CosmosSectionDevelopersList",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable",
      "CosmosSectionEmbed",
      "CosmosSectionEventsTable",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionFeatureCard",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionGeminiCard",
      "CosmosSectionHydrusColumnList",
      "CosmosSectionLatestNews",
      "CosmosSectionLearn",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionNumberCallout",
      "CosmosSectionPluginListTable",
      "CosmosSectionQuote",
      "CosmosSectionResellersSearch",
      "CosmosSectionRichText",
      "CosmosSectionSlimContactCard",
      "CosmosSectionSpeakerCard",
      "CosmosSectionTabbedContentImage",
      "CosmosSectionUtCard"
    ],
    "CosmosConfigSectionheadingUnion": [
      "CosmosElementIconSectionHeading",
      "CosmosElementSectionHeading"
    ],
    "CosmosElementAccordionFeatureCardParent": [
      "CosmosSectionAccordionFeatureCard"
    ],
    "CosmosElementAccordionTierCardParent": [
      "CosmosSectionAccordionTierCards"
    ],
    "CosmosElementAccordionTierCarditemsUnion": [
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard"
    ],
    "CosmosElementAccordionTierCtaCardParent": [
      "CosmosElementAccordionTierCard"
    ],
    "CosmosElementAccordionTierCtaCardbuttonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementAccordionTierFeatureCardParent": [
      "CosmosElementAccordionTierCard"
    ],
    "CosmosElementAccordionTierFeatureCardbuttonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementAgreementDetailParent": [
      "CosmosPageAgreement"
    ],
    "CosmosElementAriesCardParent": [
      "CosmosSectionAriesCards"
    ],
    "CosmosElementAssetParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementAvatarParent": [
      "CosmosElementDelphinusCard",
      "CosmosElementUserProfile"
    ],
    "CosmosElementBlogCardParent": [
      "CosmosConfigBlog",
      "CosmosElementTabbedBlogCardsItem",
      "CosmosSectionBlogCard"
    ],
    "CosmosElementButtonListParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementButtonParent": [
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard",
      "CosmosElementAriesCard",
      "CosmosElementButtonList",
      "CosmosElementComplexCtaCard",
      "CosmosElementDownloadCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementIconSectionHeading",
      "CosmosElementLearnDocumentationCard",
      "CosmosElementLicenseCardCore",
      "CosmosElementLicenseTopCard",
      "CosmosElementSectionHeading",
      "CosmosElementTabbedBlogCardsItem",
      "CosmosElementTabbedContentImageItem",
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionRichText",
      "ElementLearnCategory"
    ],
    "CosmosElementCalloutCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementCheckListItemParent": [
      "CosmosElementLicenseTopCard"
    ],
    "CosmosElementCkEditorTextCollapsibleParent": [
      "CosmosPageLegalContent"
    ],
    "CosmosElementCkEditorTextParent": [
      "CosmosPageBlogDetail",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementCompareParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementComplexCtaCardParent": [
      "CosmosSectionComplexCtaCard"
    ],
    "CosmosElementCruxLinkParent": [
      "CosmosSectionCrux"
    ],
    "CosmosElementDelphinusCardParent": [
      "CosmosSectionDelphinusCardsGrid"
    ],
    "CosmosElementDocumentListItemParent": [
      "CosmosElementDocumentList"
    ],
    "CosmosElementDownloadButtonParent": [
      "CosmosElementDownloadCard"
    ],
    "CosmosElementDownloadCardParent": [
      "CosmosElementDownloadStep",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable"
    ],
    "CosmosElementDownloadCardctaUnion": [
      "CosmosElementButton",
      "CosmosElementDownloadButton",
      "CosmosElementIconButton",
      "CosmosElementLink",
      "CosmosElementRichText"
    ],
    "CosmosElementDownloadStepParent": [
      "CosmosSectionDownloadCard"
    ],
    "CosmosElementEdsIconLinkParent": [
      "CosmosElementIconLinkGroup"
    ],
    "CosmosElementEventsTableRowParent": [
      "CosmosSectionEventsTable"
    ],
    "CosmosElementFAQItemParent": [
      "CosmosElementFaqTab",
      "CosmosSectionFaq"
    ],
    "CosmosElementFaqTabParent": [
      "CosmosSectionFaqSearch"
    ],
    "CosmosElementFeatureCardParent": [
      "CosmosSectionFeatureCard"
    ],
    "CosmosElementGameDevFeatureCardParent": [
      "CosmosElementAccordionFeatureCard",
      "CosmosSectionGameDevFeatureCard"
    ],
    "CosmosElementGameDevFeatureCardmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementGeminiCardParent": [
      "CosmosPageSearch",
      "CosmosSectionGeminiCard"
    ],
    "CosmosElementGeminiCardmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementGeminiLinkParent": [
      "CosmosElementGeminiCard"
    ],
    "CosmosElementGithubGistParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementHydrusColumnParent": [
      "CosmosSectionHydrusColumnList"
    ],
    "CosmosElementHydrusLinkParent": [
      "CosmosElementHydrusColumn"
    ],
    "CosmosElementIconButtonParent": [
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard",
      "CosmosElementBlogCard",
      "CosmosElementCalloutCard",
      "CosmosElementDownloadCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementIconSectionHeading",
      "CosmosElementLicenseContactCard",
      "CosmosElementLicenseSeat",
      "CosmosElementPluginListItem",
      "CosmosElementSectionHeading",
      "CosmosElementTabbedFullWidthAssetItem",
      "CosmosElementUserProfile",
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNumberCallout",
      "CosmosSectionSimpleCta"
    ],
    "CosmosElementIconLinkGroupParent": [
      "CosmosPageBlogDetail"
    ],
    "CosmosElementIconSectionHeadingParent": [
      "CosmosConfigSection"
    ],
    "CosmosElementIconSectionHeadingmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementImageTagParent": [
      "CosmosConfigBlog",
      "CosmosElementNewsCard"
    ],
    "CosmosElementIndustryParent": [
      "CosmosRefIndustryList"
    ],
    "CosmosElementInterviewParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementInterviewQuestionParent": [
      "CosmosElementInterview"
    ],
    "CosmosElementLearnDocumentationCardParent": [
      "ElementLearnCategory"
    ],
    "CosmosElementLearnImageCardParent": [
      "ElementLearnCategory"
    ],
    "CosmosElementLearnImageCardSourceParent": [
      "CosmosElementLearnImageCard"
    ],
    "CosmosElementLearnTabParent": [
      "CosmosSectionLearn"
    ],
    "CosmosElementLicenseCardCoreParent": [
      "CosmosElementLicenseCardCore",
      "CosmosElementLicenseMainCard"
    ],
    "CosmosElementLicenseCardTopParent": [
      "CosmosElementLicenseMainCard"
    ],
    "CosmosElementLicenseCollapsedCardParent": [
      "CosmosSectionLicensesCollapsed"
    ],
    "CosmosElementLicenseContactCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosSectionSlimContactCard"
    ],
    "CosmosElementLicenseMainCardParent": [
      "CosmosPageLicense"
    ],
    "CosmosElementLicenseSeatParent": [
      "CosmosElementLicenseMainCard",
      "CosmosElementLicenseSeat"
    ],
    "CosmosElementLicenseTopCardParent": [
      "CosmosPageLicense",
      "CosmosSectionLicensesCollapsed"
    ],
    "CosmosElementLinkParent": [
      "CommunityCard",
      "CosmosElementDownloadCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementLearnDocumentationCard",
      "CosmosSectionCrux",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoMultiCard"
    ],
    "CosmosElementLogoMultiCardParent": [
      "CosmosSectionLogoMultiCard"
    ],
    "CosmosElementLogoParent": [
      "CosmosSectionLogoList"
    ],
    "CosmosElementNewsCardParent": [
      "CosmosSectionNewsCard"
    ],
    "CosmosElementNewsMediaCardParent": [
      "CosmosSectionNewsMediaCard"
    ],
    "CosmosElementNumberCalloutParent": [
      "CosmosSectionNumberCallout"
    ],
    "CosmosElementPluginDownloadDetailParent": [
      "CosmosElementPluginDownload",
      "CosmosElementPluginListItem"
    ],
    "CosmosElementPluginDownloadParent": [
      "CosmosPagePluginDetail"
    ],
    "CosmosElementPluginListItemParent": [
      "CosmosSectionPluginListTable"
    ],
    "CosmosElementQuoteParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosSectionQuote"
    ],
    "CosmosElementResearchCardParent": [
      "CosmosPageResearch"
    ],
    "CosmosElementResellerCardParent": [
      "CosmosSectionResellersSearch"
    ],
    "CosmosElementRichTextParent": [
      "CosmosElementDownloadCard",
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementSearchFilterParent": [
      "CosmosPageSearch"
    ],
    "CosmosElementSectionHeadingParent": [
      "CosmosConfigSection",
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementSectionHeadingmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosElementSpeakerCardParent": [
      "CosmosSectionSpeakerCard"
    ],
    "CosmosElementTabbedBlogCardsItemParent": [
      "CosmosSectionTabbedBlogCard"
    ],
    "CosmosElementTabbedContentImageItemParent": [
      "CosmosSectionTabbedContentImage"
    ],
    "CosmosElementTabbedFullWidthAssetItemParent": [
      "CosmosSectionTabbedFullWidthAsset"
    ],
    "CosmosElementTagParent": [
      "CosmosElementDelphinusCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementNewsCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionFeatureCard"
    ],
    "CosmosElementTitleAndDescParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementUserProfileParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail"
    ],
    "CosmosElementUtCardParent": [
      "CosmosSectionUtCard"
    ],
    "CosmosElementVideoEmbedParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosSectionEmbed"
    ],
    "CosmosHeroAlphaParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroAlphamodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosHeroArticleImageParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroArticleImagemodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosHeroBravoParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosHeroBravomodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosHeroGlowParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageResearch"
    ],
    "CosmosPageAgreementheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageBlogDetailarticleComponentsUnion": [
      "CosmosElementAsset",
      "CosmosElementButtonList",
      "CosmosElementCalloutCard",
      "CosmosElementCkEditorText",
      "CosmosElementCompare",
      "CosmosElementGithubGist",
      "CosmosElementIconLinkGroup",
      "CosmosElementInterview",
      "CosmosElementLicenseContactCard",
      "CosmosElementQuote",
      "CosmosElementRichText",
      "CosmosElementSectionHeading",
      "CosmosElementTitleAndDesc",
      "CosmosElementUserProfile",
      "CosmosElementVideoEmbed",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionContentLargeImage",
      "CosmosSectionDivider",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionSimpleCta"
    ],
    "CosmosPageBlogDetailheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageDirectoryheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageHeroAndSectionheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageLegalContentheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageLegalContentsectionsUnion": [
      "CosmosElementCkEditorText",
      "CosmosElementCkEditorTextCollapsible"
    ],
    "CosmosPagePluginDetailarticleComponentsUnion": [
      "CosmosElementAsset",
      "CosmosElementButtonList",
      "CosmosElementCalloutCard",
      "CosmosElementCkEditorText",
      "CosmosElementCompare",
      "CosmosElementGithubGist",
      "CosmosElementInterview",
      "CosmosElementLicenseContactCard",
      "CosmosElementQuote",
      "CosmosElementRichText",
      "CosmosElementSectionHeading",
      "CosmosElementTitleAndDesc",
      "CosmosElementUserProfile",
      "CosmosElementVideoEmbed",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionContentLargeImage",
      "CosmosSectionDivider",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsMediaCard"
    ],
    "CosmosPagePluginDetailheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosPageResearchheroUnion": [
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow"
    ],
    "CosmosReferenceSectionsectionUnion": [
      "CosmosSectionAccordionFeatureCard",
      "CosmosSectionAccordionTierCards",
      "CosmosSectionAriesCards",
      "CosmosSectionAsset",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionBlobTable",
      "CosmosSectionBlogCard",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionComplexCtaCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionCrux",
      "CosmosSectionDelphinusCardsGrid",
      "CosmosSectionDevelopersList",
      "CosmosSectionDivider",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable",
      "CosmosSectionEmbed",
      "CosmosSectionEventsTable",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionFeatureCard",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionGeminiCard",
      "CosmosSectionHydrusColumnList",
      "CosmosSectionLatestNews",
      "CosmosSectionLearn",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionNewsletterSignup",
      "CosmosSectionNumberCallout",
      "CosmosSectionPluginListTable",
      "CosmosSectionQuote",
      "CosmosSectionResellersSearch",
      "CosmosSectionRichText",
      "CosmosSectionSimpleCta",
      "CosmosSectionSlimContactCard",
      "CosmosSectionSpeakerCard",
      "CosmosSectionTabbedBlogCard",
      "CosmosSectionTabbedContentImage",
      "CosmosSectionTabbedFullWidthAsset",
      "CosmosSectionUtCard"
    ],
    "CosmosSectionAccordionFeatureCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionAccordionTierCardsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionAriesCardsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionAssetCarouselParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionAssetGalleryParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionAssetParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionBlobTableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionBlogCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionCkRichTextParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionCommunityParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionComplexCtaCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionContentLargeImageParent": [
      "CosmosPageBlogDetail",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionContentSliderAssetParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionCruxParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDelphinusCardsGridParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDevelopersListParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDividerParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionDownloadCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionDownloadableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionEmbedParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionEventsTableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionFaqParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionFaqSearchParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionFaqSearchmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionFaqmodButtonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionFeatureCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionGameDevFeatureCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionGeminiCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionHydrusColumnListParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLatestNewsParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLearnParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLicensesCollapsedParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionLogoListParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionLogoMultiCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionLogoMultiCardbuttonsUnion": [
      "CosmosElementButton",
      "CosmosElementIconButton"
    ],
    "CosmosSectionNewsCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionNewsMediaCardParent": [
      "CosmosPageBlogDetail",
      "CosmosPagePluginDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionNewsletterSignupParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionNumberCalloutParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionPluginListTableParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionQuoteParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionResellersSearchParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionRichTextParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionSimpleCtaParent": [
      "CosmosPageBlogDetail",
      "CosmosReferenceSection"
    ],
    "CosmosSectionSlimContactCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionSpeakerCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionTabbedBlogCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionTabbedContentImageParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionTabbedFullWidthAssetParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSectionUtCardParent": [
      "CosmosReferenceSection"
    ],
    "CosmosSeoParent": [
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageResearch",
      "CosmosPageSearch"
    ],
    "ElementLearnCategoryParent": [
      "CosmosSectionLearn"
    ],
    "ElementLearnCategorycardsUnion": [
      "CosmosElementLearnDocumentationCard",
      "CosmosElementLearnImageCard"
    ],
    "Entity": [
      "Asset",
      "CommunityCard",
      "CommunityResource",
      "CosmosConfigBlog",
      "CosmosConfigSection",
      "CosmosElementAccordionFeatureCard",
      "CosmosElementAccordionTierCard",
      "CosmosElementAccordionTierCtaCard",
      "CosmosElementAccordionTierFeatureCard",
      "CosmosElementAgreementDetail",
      "CosmosElementAriesCard",
      "CosmosElementAsset",
      "CosmosElementAvatar",
      "CosmosElementBlogCard",
      "CosmosElementButton",
      "CosmosElementButtonList",
      "CosmosElementCalloutCard",
      "CosmosElementCheckListItem",
      "CosmosElementCkEditorText",
      "CosmosElementCkEditorTextCollapsible",
      "CosmosElementCompare",
      "CosmosElementComplexCtaCard",
      "CosmosElementCruxLink",
      "CosmosElementDelphinusCard",
      "CosmosElementDocumentList",
      "CosmosElementDocumentListItem",
      "CosmosElementDownloadButton",
      "CosmosElementDownloadCard",
      "CosmosElementDownloadStep",
      "CosmosElementEdsIconLink",
      "CosmosElementEventsTableRow",
      "CosmosElementFAQItem",
      "CosmosElementFaqTab",
      "CosmosElementFeatureCard",
      "CosmosElementGameDevFeatureCard",
      "CosmosElementGeminiCard",
      "CosmosElementGeminiLink",
      "CosmosElementGithubGist",
      "CosmosElementHydrusColumn",
      "CosmosElementHydrusLink",
      "CosmosElementIconButton",
      "CosmosElementIconLinkGroup",
      "CosmosElementIconSectionHeading",
      "CosmosElementImageTag",
      "CosmosElementIndustry",
      "CosmosElementInterview",
      "CosmosElementInterviewQuestion",
      "CosmosElementLearnDocumentationCard",
      "CosmosElementLearnImageCard",
      "CosmosElementLearnImageCardSource",
      "CosmosElementLearnTab",
      "CosmosElementLicenseCardCore",
      "CosmosElementLicenseCardTop",
      "CosmosElementLicenseCollapsedCard",
      "CosmosElementLicenseContactCard",
      "CosmosElementLicenseMainCard",
      "CosmosElementLicenseSeat",
      "CosmosElementLicenseTopCard",
      "CosmosElementLink",
      "CosmosElementLogo",
      "CosmosElementLogoMultiCard",
      "CosmosElementNewsCard",
      "CosmosElementNewsMediaCard",
      "CosmosElementNumberCallout",
      "CosmosElementPluginDownload",
      "CosmosElementPluginDownloadDetail",
      "CosmosElementPluginListItem",
      "CosmosElementQuote",
      "CosmosElementResearchCard",
      "CosmosElementResellerCard",
      "CosmosElementRichText",
      "CosmosElementSearchFilter",
      "CosmosElementSectionHeading",
      "CosmosElementSpeakerCard",
      "CosmosElementTabbedBlogCardsItem",
      "CosmosElementTabbedContentImageItem",
      "CosmosElementTabbedFullWidthAssetItem",
      "CosmosElementTag",
      "CosmosElementTitleAndDesc",
      "CosmosElementUserProfile",
      "CosmosElementUtCard",
      "CosmosElementVideoEmbed",
      "CosmosFeedBlogCard",
      "CosmosHeroAlpha",
      "CosmosHeroArticleImage",
      "CosmosHeroBravo",
      "CosmosHeroGlow",
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageRedirect",
      "CosmosPageResearch",
      "CosmosPageSearch",
      "CosmosRefIndustryList",
      "CosmosReferenceFAQItem",
      "CosmosReferenceSection",
      "CosmosRemoteLearn",
      "CosmosSectionAccordionFeatureCard",
      "CosmosSectionAccordionTierCards",
      "CosmosSectionAriesCards",
      "CosmosSectionAsset",
      "CosmosSectionAssetCarousel",
      "CosmosSectionAssetGallery",
      "CosmosSectionBlobTable",
      "CosmosSectionBlogCard",
      "CosmosSectionCkRichText",
      "CosmosSectionCommunity",
      "CosmosSectionComplexCtaCard",
      "CosmosSectionContentLargeImage",
      "CosmosSectionContentSliderAsset",
      "CosmosSectionCrux",
      "CosmosSectionDelphinusCardsGrid",
      "CosmosSectionDevelopersList",
      "CosmosSectionDivider",
      "CosmosSectionDownloadCard",
      "CosmosSectionDownloadable",
      "CosmosSectionEmbed",
      "CosmosSectionEventsTable",
      "CosmosSectionFaq",
      "CosmosSectionFaqSearch",
      "CosmosSectionFeatureCard",
      "CosmosSectionGameDevFeatureCard",
      "CosmosSectionGeminiCard",
      "CosmosSectionHydrusColumnList",
      "CosmosSectionLatestNews",
      "CosmosSectionLearn",
      "CosmosSectionLicensesCollapsed",
      "CosmosSectionLogoList",
      "CosmosSectionLogoMultiCard",
      "CosmosSectionNewsCard",
      "CosmosSectionNewsMediaCard",
      "CosmosSectionNewsletterSignup",
      "CosmosSectionNumberCallout",
      "CosmosSectionPluginListTable",
      "CosmosSectionQuote",
      "CosmosSectionResellersSearch",
      "CosmosSectionRichText",
      "CosmosSectionSimpleCta",
      "CosmosSectionSlimContactCard",
      "CosmosSectionSpeakerCard",
      "CosmosSectionTabbedBlogCard",
      "CosmosSectionTabbedContentImage",
      "CosmosSectionTabbedFullWidthAsset",
      "CosmosSectionUtCard",
      "CosmosSeo",
      "ElementLearnCategory",
      "RemoteLearn",
      "ScheduledOperation",
      "ScheduledRelease",
      "User",
      "WfRefApplicationOwner",
      "WfRefBlogCategory",
      "WfRefBlogTag"
    ],
    "Node": [
      "Asset",
      "CosmosFeedBlogCard",
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageRedirect",
      "CosmosPageResearch",
      "CosmosPageSearch",
      "CosmosRefIndustryList",
      "CosmosReferenceFAQItem",
      "CosmosReferenceSection",
      "CosmosRemoteLearn",
      "RemoteLearn",
      "ScheduledOperation",
      "ScheduledRelease",
      "User",
      "WfRefApplicationOwner",
      "WfRefBlogCategory",
      "WfRefBlogTag"
    ],
    "ScheduledOperationAffectedDocument": [
      "Asset",
      "CosmosFeedBlogCard",
      "CosmosPageAgreement",
      "CosmosPageBlogDetail",
      "CosmosPageDirectory",
      "CosmosPageEulaKey",
      "CosmosPageFeed",
      "CosmosPageHeroAndSection",
      "CosmosPageLegalContent",
      "CosmosPageLicense",
      "CosmosPagePluginDetail",
      "CosmosPageRedirect",
      "CosmosPageResearch",
      "CosmosPageSearch",
      "CosmosRefIndustryList",
      "CosmosReferenceFAQItem",
      "CosmosReferenceSection",
      "CosmosRemoteLearn",
      "RemoteLearn",
      "WfRefApplicationOwner",
      "WfRefBlogCategory",
      "WfRefBlogTag"
    ]
  }
};
      export default result;
    